import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: any; output: any };
  Coordinates: { input: any; output: any };
  Date: { input: any; output: any };
  DateOnly: { input: any; output: any };
  DateTime: { input: any; output: any };
  IntOrArrayInt: { input: any; output: any };
  Interval: { input: any; output: any };
  JSON: { input: any; output: any };
  Object: { input: any; output: any };
  Scalar: { input: any; output: any };
  kpiItemValue: { input: any; output: any };
};

export type A2pSubscriptionOverview = {
  __typename?: 'A2pSubscriptionOverview';
  nextBillingDate?: Maybe<Scalars['Date']['output']>;
  periodicity?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
};

export type AIAdvanceCallReport = {
  __typename?: 'AIAdvanceCallReport';
  agentPhoneNumber?: Maybe<Scalars['String']['output']>;
  callCount?: Maybe<Scalars['Int']['output']>;
  callDirection?: Maybe<Scalars['String']['output']>;
  callRecordingId?: Maybe<Scalars['Int']['output']>;
  callRecordingUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  transcriptionId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type AIAdvanceCallReportResponse = {
  __typename?: 'AIAdvanceCallReportResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<AIAdvanceCallReport>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AIDashboardCount = {
  __typename?: 'AIDashboardCount';
  percentage?: Maybe<Scalars['Float']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AIDashboardCountResponse = {
  __typename?: 'AIDashboardCountResponse';
  data?: Maybe<Array<Maybe<AIDashboardCount>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AIDashboardDayWiseSentiment = {
  __typename?: 'AIDashboardDayWiseSentiment';
  createdAt?: Maybe<Scalars['Date']['output']>;
  negativeSentimentCount?: Maybe<Scalars['Int']['output']>;
  neutralSentimentCount?: Maybe<Scalars['Int']['output']>;
  positiveSentimentCount?: Maybe<Scalars['Int']['output']>;
};

export type AIDashboardDayWiseSentimentResponse = {
  __typename?: 'AIDashboardDayWiseSentimentResponse';
  data?: Maybe<Array<Maybe<AIDashboardDayWiseSentiment>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AIDashboardIntent = {
  __typename?: 'AIDashboardIntent';
  callVolume?: Maybe<Scalars['Float']['output']>;
  currentCount?: Maybe<Scalars['Int']['output']>;
  currentSentiment?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  previousCount?: Maybe<Scalars['Int']['output']>;
  previousSentiment?: Maybe<Scalars['String']['output']>;
};

export type AIDashboardIntentResponse = {
  __typename?: 'AIDashboardIntentResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<AIDashboardIntent>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AIDashboardMemberPerformance = {
  __typename?: 'AIDashboardMemberPerformance';
  averageDuration?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  totalCallCount?: Maybe<Scalars['Int']['output']>;
  transcribeCallCount?: Maybe<Scalars['Int']['output']>;
  transcribeSpecificSentimentCount?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userWorkspaceId?: Maybe<Scalars['Int']['output']>;
};

export type AIDashboardMemberPerformanceResponse = {
  __typename?: 'AIDashboardMemberPerformanceResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<AIDashboardMemberPerformance>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AIDashboardMemberPerformanceV2 = {
  __typename?: 'AIDashboardMemberPerformanceV2';
  averageDuration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  totalCallCount?: Maybe<Scalars['Int']['output']>;
  transcribeCallCount?: Maybe<Scalars['Int']['output']>;
  transcribeSpecificSentimentCount?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type AIDashboardSummaryData = {
  __typename?: 'AIDashboardSummaryData';
  agentName?: Maybe<Scalars['String']['output']>;
  callRecordingId?: Maybe<Scalars['Int']['output']>;
  callRecordingUrl?: Maybe<Scalars['String']['output']>;
  conclusion?: Maybe<Scalars['String']['output']>;
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  proposedSolution?: Maybe<Scalars['String']['output']>;
  reasonForCall?: Maybe<Scalars['String']['output']>;
  transcriptionId?: Maybe<Scalars['Int']['output']>;
};

export type AIDashboardSummaryResponse = {
  __typename?: 'AIDashboardSummaryResponse';
  data?: Maybe<Array<Maybe<AIDashboardSummaryData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AccessToken = {
  __typename?: 'AccessToken';
  access?: Maybe<Scalars['String']['output']>;
};

export type ActiveStrategyGroupResult = {
  __typename?: 'ActiveStrategyGroupResult';
  data?: Maybe<SingleActiveStrategyGroup>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AddWorkspaceMemberIntentInput = {
  estimatedAmount: Scalars['Int']['input'];
  referenceId: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type AddressEdge = {
  __typename?: 'AddressEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Address>;
};

export type AdminAddSalesDealInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  isPayingCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  subscriptionAmount?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAssignSubscriptions = {
  __typename?: 'AdminAssignSubscriptions';
  assignedNumberSubscription?: Maybe<Scalars['JSON']['output']>;
  assignedWorkspaceSubscription?: Maybe<Scalars['JSON']['output']>;
  numberSubscripitonMessage?: Maybe<Scalars['String']['output']>;
  workspaceSubscripitonMessage?: Maybe<Scalars['String']['output']>;
};

export type AdminAssignSubscriptionsResponse = {
  __typename?: 'AdminAssignSubscriptionsResponse';
  data?: Maybe<AdminAssignSubscriptions>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminAutoRecoverNumberPurchaseInput = {
  cartNumber?: InputMaybe<CartNumberInput>;
  passcode: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type AdminBillingDiscountOffsetResponse = {
  __typename?: 'AdminBillingDiscountOffsetResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<BillingDiscount>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminBillingDiscountResponse = {
  __typename?: 'AdminBillingDiscountResponse';
  data?: Maybe<BillingDiscount>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminBillingSubscriptionResponse = {
  __typename?: 'AdminBillingSubscriptionResponse';
  data?: Maybe<BillingSubscriptionWithDiscounts>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminCollectPaymentInput = {
  paymentSourceId: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type AdminCreateCustomPlanResponse = {
  __typename?: 'AdminCreateCustomPlanResponse';
  data?: Maybe<CustomPlan>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminEmailOtpData = {
  __typename?: 'AdminEmailOtpData';
  email?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type AdminEmailOtpRes = {
  __typename?: 'AdminEmailOtpRes';
  data?: Maybe<AdminEmailOtpData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetChannelByWorkspaceResponse = {
  __typename?: 'AdminGetChannelByWorkspaceResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetConversationCountResponse = {
  __typename?: 'AdminGetConversationCountResponse';
  data?: Maybe<Array<Maybe<ConversationCount>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetCustomPlanResponse = {
  __typename?: 'AdminGetCustomPlanResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<CustomPlan>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetDueAmount = {
  __typename?: 'AdminGetDueAmount';
  totalDueAmount?: Maybe<Scalars['Int']['output']>;
};

export type AdminGetDueAmountResponse = {
  __typename?: 'AdminGetDueAmountResponse';
  data?: Maybe<AdminGetDueAmount>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetInProcessPhoneNumbersByWorkspaceResponse = {
  __typename?: 'AdminGetInProcessPhoneNumbersByWorkspaceResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetInProcessPhoneNumbersResponse = {
  __typename?: 'AdminGetInProcessPhoneNumbersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<PhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetIncomingPhoneNumbersByWorkspaceResponse = {
  __typename?: 'AdminGetIncomingPhoneNumbersByWorkspaceResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetIncomingPhoneNumbersResponse = {
  __typename?: 'AdminGetIncomingPhoneNumbersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<IncomingPhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetUserWorkspacesResponse = {
  __typename?: 'AdminGetUserWorkspacesResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<User>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetWorkspaceByEmailResponse = {
  __typename?: 'AdminGetWorkspaceByEmailResponse';
  data?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminGetWorkspaceChannelsResponse = {
  __typename?: 'AdminGetWorkspaceChannelsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<SingleWorkspaceChannelResponse>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetWorkspaceMembersResponse = {
  __typename?: 'AdminGetWorkspaceMembersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<UserWorkspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetWorkspaceUserDetailResponse = {
  __typename?: 'AdminGetWorkspaceUserDetailResponse';
  data?: Maybe<WorkspaceUserDetail>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetWorkspaceUsersResponse = {
  __typename?: 'AdminGetWorkspaceUsersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<WorkspaceUser>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminGetWorkspacesProvider = {
  __typename?: 'AdminGetWorkspacesProvider';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Workspace>;
};

export type AdminGetWorkspacesResponse = {
  __typename?: 'AdminGetWorkspacesResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminLoadWalletInput = {
  amount: Scalars['Float']['input'];
  enteredPasscode: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type AdminNumberSubscriptionInput = {
  cartNumbers: Array<InputMaybe<CartNumberInput>>;
  enteredPasscode?: InputMaybe<Scalars['String']['input']>;
  gatewayAccountId: Scalars['String']['input'];
  gatewayToken?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: PaymentGatewayEnum;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type AdminPaymentIntentInput = {
  gatewayAccountId: Scalars['String']['input'];
  paymentGateway: PaymentGatewayEnum;
  paymentIntentPurpose: AdminPaymentIntentPurposeEnum;
  purchaseNumbers?: InputMaybe<PurchaseNumbersIntentInput>;
  subscribeWorkspacePlan?: InputMaybe<SubscribeWorkspacePlanIntentInput>;
};

export enum AdminPaymentIntentPurposeEnum {
  purchase_numbers = 'purchase_numbers',
  subscribe_workspace_plan = 'subscribe_workspace_plan',
}

export type AdminReconcileStatementReportResponse = {
  __typename?: 'AdminReconcileStatementReportResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<ReconcileStatementReportEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminRefundPaymentInput = {
  passcode: Scalars['String']['input'];
  processingFees: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
  refundedAmount: Scalars['Float']['input'];
};

export type AdminRegenerateCodeResponse = {
  __typename?: 'AdminRegenerateCodeResponse';
  data?: Maybe<CustomPlan>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AdminRoleEnum {
  administrator = 'administrator',
  support = 'support',
}

export type AdminWorkspaceInvoicesResponse = {
  __typename?: 'AdminWorkspaceInvoicesResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Invoice>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminWorkspacesResponse = {
  __typename?: 'AdminWorkspacesResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdministratorLogin = {
  __typename?: 'AdministratorLogin';
  data?: Maybe<AdministratorResponse>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdministratorResponse = {
  __typename?: 'AdministratorResponse';
  pinExists?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<AdministratorRole>;
  token?: Maybe<LoginToken>;
  twoFactorAuthenticationRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type AdministratorRole = {
  __typename?: 'AdministratorRole';
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export enum AfterHourRouteEnum {
  call_forward = 'call_forward',
  voicemail = 'voicemail',
}

export type AgentInProgressConversation = {
  __typename?: 'AgentInProgressConversation';
  callEntity?: Maybe<AgentInProgressConversationCallEntity>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AgentInProgressConversationCallEntity = {
  __typename?: 'AgentInProgressConversationCallEntity';
  callPlatform?: Maybe<Scalars['String']['output']>;
  clientIdentity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
};

export type AgentInProgressConversationResponse = {
  __typename?: 'AgentInProgressConversationResponse';
  data?: Maybe<AgentInProgressConversation>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AiAdvanceCallReportCursorPaginationV2 = {
  __typename?: 'AiAdvanceCallReportCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<AiAdvanceCallReportV2>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AiAdvanceCallReportV2 = {
  __typename?: 'AiAdvanceCallReportV2';
  agentPhoneNumber?: Maybe<Scalars['String']['output']>;
  callDirection?: Maybe<Scalars['String']['output']>;
  callRecordingId?: Maybe<Scalars['Int']['output']>;
  callRecordingUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  transcriptionId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type AiDashboardIntentCursorPaginationV2 = {
  __typename?: 'AiDashboardIntentCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<AIDashboardIntent>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AiDashboardMemberPerformanceCursorPaginationV2 = {
  __typename?: 'AiDashboardMemberPerformanceCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<AIDashboardMemberPerformanceV2>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AiDashboardMemberPerformanceGraphReport = {
  __typename?: 'AiDashboardMemberPerformanceGraphReport';
  percentage?: Maybe<Scalars['Float']['output']>;
  totalCallCount?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type AiDashboardMemberPerformanceGraphReportResponse = {
  __typename?: 'AiDashboardMemberPerformanceGraphReportResponse';
  data?: Maybe<Array<Maybe<AiDashboardMemberPerformanceGraphReport>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AiDashboardReportAnalytics = {
  __typename?: 'AiDashboardReportAnalytics';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<AiDashboardReportAnalyticsValue>;
};

export type AiDashboardReportAnalyticsResponse = {
  __typename?: 'AiDashboardReportAnalyticsResponse';
  data?: Maybe<Array<Maybe<AiDashboardReportAnalytics>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AiDashboardReportAnalyticsValue = {
  __typename?: 'AiDashboardReportAnalyticsValue';
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type AllStrategiesByGroup = {
  __typename?: 'AllStrategiesByGroup';
  strategies?: Maybe<Array<Maybe<ChannelStrategyByGroup>>>;
  strategyGroupId?: Maybe<Scalars['Int']['output']>;
  strategyGroupName?: Maybe<Scalars['String']['output']>;
  strategyGroupSlug?: Maybe<Scalars['String']['output']>;
};

export type ApprovedRegulatoryCompliance = {
  __typename?: 'ApprovedRegulatoryCompliance';
  address?: Maybe<Scalars['Boolean']['output']>;
  endUserTypes?: Maybe<Array<Maybe<RegulatoryComplianceUseCaseEnum>>>;
  identity?: Maybe<Scalars['Boolean']['output']>;
};

export type AreaCode = {
  __typename?: 'AreaCode';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stateId?: Maybe<Scalars['Int']['output']>;
};

export type AssignTagsToContactResponse = {
  __typename?: 'AssignTagsToContactResponse';
  data?: Maybe<Array<Maybe<ContactTagsv2>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AssignUnassignContactTag = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssignedChannelCounter = {
  __typename?: 'AssignedChannelCounter';
  channelId?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  counter?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type Attribute = {
  __typename?: 'Attribute';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AttributeEdge = {
  __typename?: 'AttributeEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Attribute>;
};

export type AttributeValue = {
  __typename?: 'AttributeValue';
  attributeId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AttributeValueEdge = {
  __typename?: 'AttributeValueEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<AttributeValue>;
};

export type AudioPrompt = {
  __typename?: 'AudioPrompt';
  audio?: Maybe<Media>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  gender?: Maybe<GenderEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<AudioPromptLanguageEnum>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AudioPromptTypeEnum>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export enum AudioPromptLanguageEnum {
  de = 'de',
  en = 'en',
  es = 'es',
  fr = 'fr',
  pt = 'pt',
}

export enum AudioPromptTypeEnum {
  audio = 'audio',
  recording = 'recording',
  text = 'text',
}

export type AuthMeData = {
  __typename?: 'AuthMeData';
  lastSession?: Maybe<LastUserSession>;
  user?: Maybe<User>;
  userWorkspaceRole?: Maybe<Array<Maybe<UserWorkspaceRole>>>;
};

export type AuthMeResponse = {
  __typename?: 'AuthMeResponse';
  data?: Maybe<AuthMeData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthorizationUrlResponse = {
  __typename?: 'AuthorizationUrlResponse';
  authorizationUrl?: Maybe<Scalars['String']['output']>;
};

export type AuthorizeOAuthIntegrationInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  thirdPartyName: OAuth2ThirdPartyEnum;
};

export type AuthorizeOAuthIntegrationWithTokenInput = {
  thirdPartyName: OAuth2ThirdPartyEnum;
  transientToken?: InputMaybe<Scalars['String']['input']>;
};

export type AutoRechargeConfig = {
  __typename?: 'AutoRechargeConfig';
  credit?: Maybe<Scalars['Int']['output']>;
  creditThreshold?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  isDisableAllowed?: Maybe<Scalars['Boolean']['output']>;
  targetBalance?: Maybe<Scalars['Int']['output']>;
};

export type AutoRechargeConfigResponse = {
  __typename?: 'AutoRechargeConfigResponse';
  data?: Maybe<AutoRechargeConfig>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AvailableNumberInput = {
  isoCountry: Scalars['String']['input'];
  numberType: NumberTypeEnum;
};

export type AverageRating = {
  __typename?: 'AverageRating';
  averageRating?: Maybe<Scalars['Int']['output']>;
};

export type AverageRatingData = {
  __typename?: 'AverageRatingData';
  data?: Maybe<AverageRating>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type BillingDiscount = {
  __typename?: 'BillingDiscount';
  billingNumberSubscriptionPlanId?: Maybe<Scalars['Int']['output']>;
  billingSubscription?: Maybe<BillingSubscription>;
  costPrice?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  markedPrice?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workspace?: Maybe<Workspace>;
};

export type BillingInfo = {
  __typename?: 'BillingInfo';
  billingAddress?: Maybe<BillingAddress>;
  email?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export enum BillingJournalEntriesChargeType {
  AMAZON_POLLY = 'AMAZON_POLLY',
  CARRIER = 'CARRIER',
  CLIENT = 'CLIENT',
  CONFERENCE = 'CONFERENCE',
  MESSAGE = 'MESSAGE',
  RECORDING = 'RECORDING',
  SMS_MESSAGE_CARRIER_FEES = 'SMS_MESSAGE_CARRIER_FEES',
}

export enum BillingJournalEntriesCurrencyCode {
  EUR = 'EUR',
  USD = 'USD',
}

export enum BillingJournalEntriesSourceTypeEnum {
  ADMIN = 'ADMIN',
  AUTO = 'AUTO',
  LOAD = 'LOAD',
  MANUAL = 'MANUAL',
  SIGN_UP = 'SIGN_UP',
}

export type BillingOverviewSummary = {
  __typename?: 'BillingOverviewSummary';
  nextBillingDate?: Maybe<Scalars['Date']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalAnnualCost?: Maybe<Scalars['Float']['output']>;
  totalMonthlyCost?: Maybe<Scalars['Float']['output']>;
};

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  discounts?: Maybe<BillingDiscount>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemsQuantity?: Maybe<Scalars['Int']['output']>;
  memberPlanId?: Maybe<Scalars['Int']['output']>;
  nextBillingAt?: Maybe<Scalars['Date']['output']>;
  numberSubscriptionPlan?: Maybe<NumberSubscriptionPlan>;
  paymentCustomerId?: Maybe<Scalars['String']['output']>;
  paymentSubscriptionId?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  periodUnit?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
  workspaceSubscriptionPlan?: Maybe<WorkspaceSubscriptionPlan>;
};

export type BillingSubscriptionDiscount = {
  __typename?: 'BillingSubscriptionDiscount';
  discountPercent?: Maybe<Scalars['Float']['output']>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
};

export type BillingSubscriptionOverview = {
  __typename?: 'BillingSubscriptionOverview';
  a2pSubscription?: Maybe<A2pSubscriptionOverview>;
  numberSubscription?: Maybe<NumberSubscriptionOverview>;
  summary?: Maybe<BillingOverviewSummary>;
  workspaceSubscription?: Maybe<WorkspaceSubscriptionOverview>;
};

export type BillingSubscriptionOverviewResponse = {
  __typename?: 'BillingSubscriptionOverviewResponse';
  data?: Maybe<BillingSubscriptionOverview>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BillingSubscriptionPlan = {
  __typename?: 'BillingSubscriptionPlan';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BillingSubscriptionWithDiscounts = {
  __typename?: 'BillingSubscriptionWithDiscounts';
  memberSubscription?: Maybe<Array<Maybe<MemberSubscription>>>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export type BillingUser = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: RoleEnum;
};

export type BlockedDomain = {
  __typename?: 'BlockedDomain';
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  domainName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type BlockedForwardedPhoneNumber = {
  __typename?: 'BlockedForwardedPhoneNumber';
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type BlockedIpAddress = {
  __typename?: 'BlockedIpAddress';
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type BlockedPhoneNumber = {
  __typename?: 'BlockedPhoneNumber';
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type BlockedSignUpEmail = {
  __typename?: 'BlockedSignUpEmail';
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type Brand = {
  __typename?: 'Brand';
  connectedProfile?: Maybe<ComplianceSoleProprietorProfile>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BrandChargeInput = {
  referenceId: Scalars['String']['input'];
};

export type BulkMessageCampaignRunRecipient = {
  __typename?: 'BulkMessageCampaignRunRecipient';
  contact?: Maybe<Contact>;
  conversationStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messageConversationErrorLog?: Maybe<MessageConversationErrorLog>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BulkMessagingAttachment = {
  __typename?: 'BulkMessagingAttachment';
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Media>;
  mimetype?: Maybe<Scalars['String']['output']>;
};

export type BulkMessagingCampaign = {
  __typename?: 'BulkMessagingCampaign';
  a2pCampaignId?: Maybe<Scalars['Int']['output']>;
  a2pCampaignType?: Maybe<BulkMessagingCampaignA2pCampaignTypeEnum>;
  a2pSampleId?: Maybe<Scalars['Int']['output']>;
  attachments?: Maybe<Array<Maybe<BulkMessagingAttachment>>>;
  campaignName?: Maybe<Scalars['String']['output']>;
  campaignType?: Maybe<BulkMessagingCampaignTypeEnum>;
  channel?: Maybe<Channel>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<BulkMessagingCampaignCreator>;
  deliverySummary?: Maybe<BulkMessagingDeliverySummary>;
  effectiveEndAt?: Maybe<Scalars['Date']['output']>;
  endAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initiatedAt?: Maybe<Scalars['Date']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  maxOccurrence?: Maybe<Scalars['Int']['output']>;
  mediaCount?: Maybe<Scalars['Int']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  messagingType?: Maybe<BulkMessagingCampaignMessagingTypeEnum>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  nextOccurrence?: Maybe<Scalars['Date']['output']>;
  recipients?: Maybe<Array<Maybe<BulkMessagingRecipient>>>;
  scheduleType?: Maybe<BulkMessagingCampaignScheduleTypeEnum>;
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<BulkMessagingCampaignStatusEnum>;
};

export enum BulkMessagingCampaignA2pCampaignTypeEnum {
  low_volume_campaign = 'low_volume_campaign',
  sole_prop_campaign = 'sole_prop_campaign',
}

export type BulkMessagingCampaignCreator = {
  __typename?: 'BulkMessagingCampaignCreator';
  channel?: Maybe<Channel>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Media>;
  roles?: Maybe<Role>;
};

export type BulkMessagingCampaignCursorPagination = {
  __typename?: 'BulkMessagingCampaignCursorPagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BulkMessagingCampaign>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum BulkMessagingCampaignMessagingTypeEnum {
  a2p = 'a2p',
  regular = 'regular',
}

export type BulkMessagingCampaignRecipient = {
  __typename?: 'BulkMessagingCampaignRecipient';
  contact?: Maybe<Contact>;
  conversationStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messageConversationErrorLog?: Maybe<MessageConversationErrorLog>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum BulkMessagingCampaignRecipientStatusEnum {
  delivered = 'delivered',
  failed = 'failed',
  pending = 'pending',
  processing = 'processing',
  sent = 'sent',
  undelivered = 'undelivered',
}

export type BulkMessagingCampaignRecipientsCursorPagination = {
  __typename?: 'BulkMessagingCampaignRecipientsCursorPagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BulkMessagingCampaignRecipient>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BulkMessagingCampaignRun = {
  __typename?: 'BulkMessagingCampaignRun';
  campaign?: Maybe<BulkMessagingRunCampaign>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<BulkMessagingCampaignCreator>;
  deliverySummary?: Maybe<BulkMessagingRunDeliverySummary>;
  id?: Maybe<Scalars['Int']['output']>;
  initiatedAt?: Maybe<Scalars['Date']['output']>;
  runNumber?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<BulkMessagingRunStatusEnum>;
  totalRecipients?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BulkMessagingCampaignRunsCursorPagination = {
  __typename?: 'BulkMessagingCampaignRunsCursorPagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BulkMessagingCampaignRun>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum BulkMessagingCampaignScheduleTypeEnum {
  daily = 'daily',
  monthly = 'monthly',
  weekly = 'weekly',
  yearly = 'yearly',
}

export enum BulkMessagingCampaignStatusEnum {
  active = 'active',
  cancelled = 'cancelled',
  completed = 'completed',
  draft = 'draft',
  failed = 'failed',
  partial_failed = 'partial_failed',
  paused = 'paused',
  pending = 'pending',
  scheduled = 'scheduled',
}

export enum BulkMessagingCampaignTypeEnum {
  one_time = 'one_time',
  recurring = 'recurring',
}

export type BulkMessagingDeliverySummary = {
  __typename?: 'BulkMessagingDeliverySummary';
  runStatus?: Maybe<Scalars['String']['output']>;
  totalDelivered?: Maybe<Scalars['Int']['output']>;
  totalRecipients?: Maybe<Scalars['Int']['output']>;
  totalSent?: Maybe<Scalars['Int']['output']>;
};

export type BulkMessagingRecipient = {
  __typename?: 'BulkMessagingRecipient';
  client?: Maybe<Contact>;
  country?: Maybe<Country>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Media>;
};

export type BulkMessagingRunCampaign = {
  __typename?: 'BulkMessagingRunCampaign';
  campaignType?: Maybe<BulkMessagingCampaignTypeEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type BulkMessagingRunDeliverySummary = {
  __typename?: 'BulkMessagingRunDeliverySummary';
  totalDelivered?: Maybe<Scalars['Int']['output']>;
  totalFailed?: Maybe<Scalars['Int']['output']>;
  totalProcessed?: Maybe<Scalars['Int']['output']>;
  totalSent?: Maybe<Scalars['Int']['output']>;
};

export enum BulkMessagingRunStatusEnum {
  cancelled = 'cancelled',
  completed = 'completed',
  failed = 'failed',
  force_stopped = 'force_stopped',
  partial_failed = 'partial_failed',
  pending = 'pending',
  running = 'running',
}

export enum BundleEndUserTypeEnum {
  BUSINESS = 'BUSINESS',
  INDIVIDUAL = 'INDIVIDUAL',
}

export type BundleList = {
  __typename?: 'BundleList';
  email?: Maybe<Scalars['String']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  hasVlidUntilDate?: Maybe<Scalars['Boolean']['output']>;
  isoCountry?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  numberType?: Maybe<Scalars['String']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  regulationSid?: Maybe<Scalars['String']['output']>;
  sortBy?: Maybe<BundleSortByEnum>;
  sortDirection?: Maybe<BundleSortDirectionEnum>;
  status?: Maybe<BundleStatusEnum>;
  validUntilDate?: Maybe<Scalars['Date']['output']>;
  validUntilDateAfter?: Maybe<Scalars['Date']['output']>;
  validUntilDateBefore?: Maybe<Scalars['Date']['output']>;
};

export enum BundleSortByEnum {
  DATE_UPDATED = 'DATE_UPDATED',
  VALID_UNTIL = 'VALID_UNTIL',
}

export enum BundleSortDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum BundleStatusEnum {
  DRAFT = 'DRAFT',
  IN_REVIEW = 'IN_REVIEW',
  PENDING_REVIEW = 'PENDING_REVIEW',
  PROVISIONALLY_APPROVED = 'PROVISIONALLY_APPROVED',
  TWILIO_APPROVED = 'TWILIO_APPROVED',
  TWILIO_REJECTED = 'TWILIO_REJECTED',
}

export type BusinessAddress = {
  __typename?: 'BusinessAddress';
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type BusinessAfterHourResponse = {
  __typename?: 'BusinessAfterHourResponse';
  data?: Maybe<BusinessHour>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BusinessHour = {
  __typename?: 'BusinessHour';
  channelId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  entries?: Maybe<Array<Maybe<BusinessHourEntry>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAlwaysOpen?: Maybe<Scalars['Boolean']['output']>;
  route?: Maybe<AfterHourRouteEnum>;
  supportAfterHours?: Maybe<Scalars['Boolean']['output']>;
  targetPhoneNumber?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Timezone>;
  timezoneId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  voicemail?: Maybe<Scalars['Boolean']['output']>;
  voicemailAudioPrompt?: Maybe<AudioPrompt>;
  voicemailPrompt?: Maybe<Scalars['String']['output']>;
  voicemailPromptSource?: Maybe<Scalars['String']['output']>;
};

export type BusinessHourEntry = {
  __typename?: 'BusinessHourEntry';
  businessHourId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  localDayOfWeek?: Maybe<Scalars['Int']['output']>;
  localEndTime?: Maybe<Scalars['String']['output']>;
  localStartTime?: Maybe<Scalars['String']['output']>;
};

export type BusinessHourResponse = {
  __typename?: 'BusinessHourResponse';
  data?: Maybe<BusinessHour>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CacheIntegrationOAuthCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  thirdPartyName: OAuth2ThirdPartyEnum;
};

export type CacheInytegrateOAuthCode = {
  __typename?: 'CacheInytegrateOAuthCode';
  data?: Maybe<OAuth2CodeHash>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CallFeatureEnum {
  carrier_leg_connected = 'carrier_leg_connected',
  recording_started = 'recording_started',
  transfer_completed = 'transfer_completed',
}

export type CallForward = {
  __typename?: 'CallForward';
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isUnconditional?: Maybe<Scalars['Boolean']['output']>;
  targetPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CallForwardResponse = {
  __typename?: 'CallForwardResponse';
  data?: Maybe<CallForward>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallIvrCondition = {
  __typename?: 'CallIvrCondition';
  action?: Maybe<ConditionActionEnum>;
  callIvrConditionTarget?: Maybe<CallIvrConditionTarget>;
  id?: Maybe<Scalars['String']['output']>;
  ifUnansweredRedirectTo?: Maybe<ConditionUnanswerRedirectEnum>;
  input?: Maybe<Scalars['String']['output']>;
};

export type CallIvrConditionTarget = {
  __typename?: 'CallIvrConditionTarget';
  id?: Maybe<Scalars['Int']['output']>;
  target?: Maybe<CallIvrConditionTargetUser>;
};

export type CallIvrConditionTargetUser = {
  __typename?: 'CallIvrConditionTargetUser';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CallIvrResponse = {
  __typename?: 'CallIvrResponse';
  data?: Maybe<IvrResponseType>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CallOutcomeTypeEnum {
  completeCall = 'completeCall',
  liveCall = 'liveCall',
  missedCall = 'missedCall',
  totalCall = 'totalCall',
}

export type CallReview = {
  __typename?: 'CallReview';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messageConversationId?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  userWorkspaceId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type CallSetting = {
  __typename?: 'CallSetting';
  afterHour?: Maybe<Scalars['Boolean']['output']>;
  callForward?: Maybe<Scalars['Boolean']['output']>;
  callTransfer?: Maybe<Scalars['Boolean']['output']>;
  callerId?: Maybe<Scalars['Int']['output']>;
  callerTune?: Maybe<Scalars['Boolean']['output']>;
  enableMissedCallEmail?: Maybe<Scalars['Boolean']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isBusinessAlwaysOpen?: Maybe<Scalars['Boolean']['output']>;
  ivr?: Maybe<Scalars['Boolean']['output']>;
  recording?: Maybe<Scalars['Boolean']['output']>;
  smsMmsEmailAlertEnabled?: Maybe<Scalars['Boolean']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  transcriptionEmailAlertEnabled?: Maybe<Scalars['Boolean']['output']>;
  voicemail?: Maybe<Scalars['Boolean']['output']>;
  welcomeMessage?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingAutoRecordingResponse = {
  __typename?: 'CallSettingAutoRecordingResponse';
  data?: Maybe<CallSettingAutoRecordingType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingAutoRecordingType = {
  __typename?: 'CallSettingAutoRecordingType';
  autoRecording?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CallSettingAutoTranscribeResponse = {
  __typename?: 'CallSettingAutoTranscribeResponse';
  data?: Maybe<CallSettingAutoTranscribeType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingAutoTranscribeType = {
  __typename?: 'CallSettingAutoTranscribeType';
  autoTranscribe?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CallSettingCallerId = {
  __typename?: 'CallSettingCallerId';
  callerIdInfo?: Maybe<CallerId>;
  id: Scalars['Int']['output'];
};

export type CallSettingCallerIdResponse = {
  __typename?: 'CallSettingCallerIdResponse';
  data?: Maybe<CallSettingCallerId>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingCallerTune = {
  __typename?: 'CallSettingCallerTune';
  audioPrompt?: Maybe<AudioPrompt>;
  callerTuneLoop?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingCallerTuneResponse = {
  __typename?: 'CallSettingCallerTuneResponse';
  data?: Maybe<CallSettingCallerTune>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingChannelGroupResponse = {
  __typename?: 'CallSettingChannelGroupResponse';
  data?: Maybe<Array<Maybe<ChannelGroup>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingChannelGroupType = {
  __typename?: 'CallSettingChannelGroupType';
  callSettingId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CallSettingChannelGroupsWithCursor = {
  __typename?: 'CallSettingChannelGroupsWithCursor';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<CallSettingChannelGroupType>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingCountResponse = {
  __typename?: 'CallSettingCountResponse';
  data?: Maybe<CountCallSettingType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingEmailAlertsResponse = {
  __typename?: 'CallSettingEmailAlertsResponse';
  data?: Maybe<CallSettingEmailAlertsType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingEmailAlertsType = {
  __typename?: 'CallSettingEmailAlertsType';
  enableMissedCallEmail?: Maybe<Scalars['Boolean']['output']>;
  smsMmsEmailAlertEnabled?: Maybe<Scalars['Boolean']['output']>;
  transcriptionEmailAlertEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingForChannel = {
  __typename?: 'CallSettingForChannel';
  callTransfer?: Maybe<Scalars['Boolean']['output']>;
  recording?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingForChannelData = {
  __typename?: 'CallSettingForChannelData';
  callSetting?: Maybe<CallSettingForChannel>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CallSettingForChannelResponse = {
  __typename?: 'CallSettingForChannelResponse';
  data?: Maybe<CallSettingForChannelData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingFriendlyName = {
  __typename?: 'CallSettingFriendlyName';
  friendlyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type CallSettingFriendlyNameResponse = {
  __typename?: 'CallSettingFriendlyNameResponse';
  data?: Maybe<CallSettingFriendlyName>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingMissedCallEmailResponse = {
  __typename?: 'CallSettingMissedCallEmailResponse';
  data?: Maybe<CallSettingMissedCallEmailType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingMissedCallEmailType = {
  __typename?: 'CallSettingMissedCallEmailType';
  enableMissedCallEmail?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingRecordingAnnouncementResponse = {
  __typename?: 'CallSettingRecordingAnnouncementResponse';
  data?: Maybe<CallSettingRecordingAnnouncementType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingRecordingAnnouncementType = {
  __typename?: 'CallSettingRecordingAnnouncementType';
  audioPrompt?: Maybe<AudioPrompt>;
  id?: Maybe<Scalars['Int']['output']>;
  recordingAnnouncementAfterBeep?: Maybe<Scalars['Boolean']['output']>;
  recordingAnnouncementMessage?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingResponse = {
  __typename?: 'CallSettingResponse';
  data?: Maybe<CallSetting>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingResponseWithCursor = {
  __typename?: 'CallSettingResponseWithCursor';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<CallSettingsType>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingSummary = {
  __typename?: 'CallSettingSummary';
  entries?: Maybe<Array<Maybe<BusinessHourEntry>>>;
  id: Scalars['Int']['output'];
  isBusinessHourSet?: Maybe<Scalars['Boolean']['output']>;
  recording?: Maybe<Scalars['Boolean']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  timezoneId?: Maybe<Scalars['Int']['output']>;
};

export type CallSettingSummaryResponse = {
  __typename?: 'CallSettingSummaryResponse';
  data?: Maybe<CallSettingSummary>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingVoicemail = {
  __typename?: 'CallSettingVoicemail';
  audioPrompt?: Maybe<AudioPrompt>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  sendVoicemailToEmail?: Maybe<Scalars['Boolean']['output']>;
  voicemailAfterBeep?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingVoicemailResponse = {
  __typename?: 'CallSettingVoicemailResponse';
  data?: Maybe<CallSettingVoicemail>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingWelcomeMessage = {
  __typename?: 'CallSettingWelcomeMessage';
  audioPrompt?: Maybe<AudioPrompt>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isPreRing?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingWelcomeMessageResponse = {
  __typename?: 'CallSettingWelcomeMessageResponse';
  data?: Maybe<CallSettingWelcomeMessage>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingWithAudioPrompt = {
  __typename?: 'CallSettingWithAudioPrompt';
  audioPrompt: AudioPrompt;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSettingWithAudioPromptResponse = {
  __typename?: 'CallSettingWithAudioPromptResponse';
  data?: Maybe<CallSettingWithAudioPrompt>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallSettingsType = {
  __typename?: 'CallSettingsType';
  businessHourType?: Maybe<Scalars['String']['output']>;
  callerId?: Maybe<CallerId>;
  channelGroups?: Maybe<Array<Maybe<ChannelGroup>>>;
  channels?: Maybe<Array<Maybe<Channel>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incomingTimeout?: Maybe<Scalars['Int']['output']>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  recording?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CallSetttingTimeout = {
  __typename?: 'CallSetttingTimeout';
  id?: Maybe<Scalars['Int']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type CallSetttingTimeoutResponse = {
  __typename?: 'CallSetttingTimeoutResponse';
  data?: Maybe<CallSetttingTimeout>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallThread = {
  __typename?: 'CallThread';
  conversationStatus?: Maybe<Scalars['String']['output']>;
  effectiveEndedAt?: Maybe<Scalars['Date']['output']>;
  effectiveStartedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CallTransferAudioPrompt = {
  __typename?: 'CallTransferAudioPrompt';
  audio?: Maybe<Media>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  defaultUrl?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<AudioPromptLanguageEnum>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AudioPromptTypeEnum>;
  useDefault?: Maybe<Scalars['Boolean']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type CallTransferResponse = {
  __typename?: 'CallTransferResponse';
  data?: Maybe<CallTransferResponseType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallTransferResponseType = {
  __typename?: 'CallTransferResponseType';
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  noAnswerPrompt?: Maybe<CallTransferAudioPrompt>;
  terminatedPrompt?: Maybe<CallTransferAudioPrompt>;
  transferPrompt?: Maybe<CallTransferAudioPrompt>;
};

export enum CallTransferRouteEnum {
  ExternalNumber = 'ExternalNumber',
  Member = 'Member',
}

export type CallerId = {
  __typename?: 'CallerId';
  createdAt?: Maybe<Scalars['Date']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CallerIdCursorPaginationV2 = {
  __typename?: 'CallerIdCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<CallerId>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CallerIdEdge = {
  __typename?: 'CallerIdEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CallerId>;
};

export type CampaignRecipientsByCampaignId = {
  __typename?: 'CampaignRecipientsByCampaignId';
  contact?: Maybe<Contact>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum CampaignStatusEnum {
  created = 'created',
  created_with_error = 'created_with_error',
  failed = 'failed',
  paused = 'paused',
  pending = 'pending',
}

export type CampaignUseCase = {
  __typename?: 'CampaignUseCase';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CanStartMessageConversationData = {
  __typename?: 'CanStartMessageConversationData';
  canConference?: Maybe<Scalars['Boolean']['output']>;
  canMessage?: Maybe<Scalars['Boolean']['output']>;
  lowBalance?: Maybe<Scalars['Boolean']['output']>;
};

export type CanStartMessageConversationResponse = {
  __typename?: 'CanStartMessageConversationResponse';
  data?: Maybe<CanStartMessageConversationData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CancelSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type CancelSubscriptionInputV2 = {
  callReliabilityScore?: InputMaybe<Scalars['Int']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  productSatisfactionScore?: InputMaybe<Scalars['Int']['input']>;
  remarks: Scalars['String']['input'];
};

export type Card = {
  __typename?: 'Card';
  brand?: Maybe<Scalars['String']['output']>;
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  expiryYear?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CartNumberInput = {
  addressRequirements: Scalars['String']['input'];
  basePrice?: InputMaybe<Scalars['String']['input']>;
  capabilities?: InputMaybe<InputTwilioCapability>;
  currentPrice?: InputMaybe<Scalars['String']['input']>;
  friendlyName: Scalars['String']['input'];
  isoCountry: Scalars['String']['input'];
  numberType: NumberTypeEnum;
  phoneNumber: Scalars['String']['input'];
  rateCenter?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export enum ChallengeNameEnum {
  EMAIL_OTP = 'EMAIL_OTP',
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
}

export type Channel = {
  __typename?: 'Channel';
  a2pVerified?: Maybe<Scalars['Boolean']['output']>;
  assignedUsers?: Maybe<Array<Maybe<User>>>;
  beta?: Maybe<Scalars['Boolean']['output']>;
  callSetting?: Maybe<CallSettingsType>;
  capability?: Maybe<ChannelCapability>;
  channelGroup?: Maybe<ChannelGroup>;
  channelUserWorkspaces?: Maybe<Array<Maybe<ChannelUserWorkspace>>>;
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  emergencyStatus?: Maybe<EmergencyStatusEnum>;
  enableMissedCallEmail?: Maybe<Scalars['Boolean']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  integrationChannels?: Maybe<IntegrationChannel>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  muted?: Maybe<Scalars['Boolean']['output']>;
  numberState?: Maybe<NumberStateEnum>;
  numberType?: Maybe<NumberTypeEnum>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  purchaseAt?: Maybe<Scalars['Date']['output']>;
  purchaseBy?: Maybe<UserWorkspace>;
  recording?: Maybe<Scalars['Boolean']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
  removalSchedule?: Maybe<ChannelRemovalSchedule>;
  setting?: Maybe<ChannelSetting>;
  sid?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<BillingSubscription>;
  unreadCountChannel?: Maybe<Scalars['Int']['output']>;
  unreadCounter?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  v2MigratedAt?: Maybe<Scalars['Date']['output']>;
  voicemail?: Maybe<Scalars['Boolean']['output']>;
  workspace?: Maybe<Workspace>;
};

export type ChannelCapability = {
  __typename?: 'ChannelCapability';
  fax?: Maybe<Scalars['Boolean']['output']>;
  mms?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['Boolean']['output']>;
  voice?: Maybe<Scalars['Boolean']['output']>;
};

export type ChannelConversation = {
  __typename?: 'ChannelConversation';
  channel?: Maybe<Channel>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  messageConversation?: Maybe<MessageConversation>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChannelConversationCursorPagination = {
  __typename?: 'ChannelConversationCursorPagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<ChannelConversation>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelCountResponse = {
  __typename?: 'ChannelCountResponse';
  count: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelCursorPaginationV2 = {
  __typename?: 'ChannelCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Channel>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelEdge = {
  __typename?: 'ChannelEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Channel>;
};

export enum ChannelFilterEnum {
  MOST_ACTIVE = 'MOST_ACTIVE',
  RECENTLY_ADDED = 'RECENTLY_ADDED',
  UNREAD_ACTIVITY = 'UNREAD_ACTIVITY',
}

export type ChannelGroup = {
  __typename?: 'ChannelGroup';
  callSetting?: Maybe<CallSettingsType>;
  channel?: Maybe<Array<Maybe<Channel>>>;
  id?: Maybe<Scalars['Int']['output']>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type ChannelGroupCountResponse = {
  __typename?: 'ChannelGroupCountResponse';
  data?: Maybe<CountChannelGroupType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelGroupCursorPagination = {
  __typename?: 'ChannelGroupCursorPagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<ChannelGroup>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelGroupData = {
  __typename?: 'ChannelGroupData';
  data?: Maybe<ChannelGroup>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelMember = {
  __typename?: 'ChannelMember';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
};

export type ChannelOverviewResponse = {
  __typename?: 'ChannelOverviewResponse';
  data?: Maybe<Channel>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelRemovalSchedule = {
  __typename?: 'ChannelRemovalSchedule';
  batchId?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  detailType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  scheduleArn?: Maybe<Scalars['String']['output']>;
  scheduleAt?: Maybe<Scalars['Date']['output']>;
  scheduleExpression?: Maybe<Scalars['String']['output']>;
  scheduleName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChannelRemovalScheduleStatus>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type ChannelRemovalScheduleResponse = {
  __typename?: 'ChannelRemovalScheduleResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export enum ChannelRemovalScheduleStatus {
  created = 'created',
  executed = 'executed',
  failed = 'failed',
  pending = 'pending',
}

export type ChannelSetting = {
  __typename?: 'ChannelSetting';
  autoTranscribe?: Maybe<Scalars['Boolean']['output']>;
  caller?: Maybe<CallerId>;
  enableVoiceMailEmail?: Maybe<Scalars['Boolean']['output']>;
  externalNumber?: Maybe<ForwardToExternalNumber>;
  forwardToExternalNumber?: Maybe<Scalars['Boolean']['output']>;
  forwardToExternalNumberLoop?: Maybe<Scalars['Int']['output']>;
  forwardToExternalNumberPlay?: Maybe<Media>;
  forwardToExternalNumberSay?: Maybe<TwimlSay>;
  id?: Maybe<Scalars['Int']['output']>;
  recording?: Maybe<Scalars['Boolean']['output']>;
  voicemail?: Maybe<Scalars['Boolean']['output']>;
  voicemailLoop?: Maybe<Scalars['Int']['output']>;
  voicemailPlay?: Maybe<Media>;
  voicemailSay?: Maybe<TwimlSay>;
  welcomeMessage?: Maybe<Scalars['Boolean']['output']>;
  welcomeMessageLoop?: Maybe<Scalars['Int']['output']>;
  welcomeMessagePlay?: Maybe<Media>;
  welcomeMessageSay?: Maybe<TwimlSay>;
};

export type ChannelStrategy = {
  __typename?: 'ChannelStrategy';
  channel?: Maybe<Channel>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  strategy?: Maybe<Strategy>;
  strategyGroup?: Maybe<StrategyGroup>;
  strategySlug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workspace?: Maybe<Workspace>;
};

export type ChannelStrategyByGroup = {
  __typename?: 'ChannelStrategyByGroup';
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  strategyId?: Maybe<Scalars['Int']['output']>;
  strategySlug?: Maybe<Scalars['String']['output']>;
};

export type ChannelUserWorkspace = {
  __typename?: 'ChannelUserWorkspace';
  channel?: Maybe<Channel>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userWorkspace?: Maybe<UserWorkspace>;
};

export type ChannelUserWorkspaceCursorPaginationV2 = {
  __typename?: 'ChannelUserWorkspaceCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<ChannelUserWorkspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelUserWorkspaceEdge = {
  __typename?: 'ChannelUserWorkspaceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ChannelUserWorkspace>;
};

export type ChannelUserWorkspaceMembersResponse = {
  __typename?: 'ChannelUserWorkspaceMembersResponse';
  data?: Maybe<Array<Maybe<MembersAssignedToChannel>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelsByWorkspaceCursorPaginationResponse = {
  __typename?: 'ChannelsByWorkspaceCursorPaginationResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Channel>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelsResponse = {
  __typename?: 'ChannelsResponse';
  data?: Maybe<Array<Maybe<Channel>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ChargeBeeCurrencyCodeEnum {
  USD = 'USD',
}

export type ChargeBeePaymentIntentResponse = {
  __typename?: 'ChargeBeePaymentIntentResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ChargeTypeEnum {
  CALL = 'CALL',
  MESSAGE = 'MESSAGE',
}

export type Charges = {
  __typename?: 'Charges';
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationUnit?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceUnit?: Maybe<Scalars['String']['output']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  messageConversation?: Maybe<CallThread>;
  room?: Maybe<Room>;
  sender?: Maybe<UserWorkspace>;
  type?: Maybe<MessageTypeEnum>;
};

export type ChatMessageEdge = {
  __typename?: 'ChatMessageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  node?: Maybe<ChatMessage>;
};

export type CheckConfigurationAndRewardOfChannelData = {
  __typename?: 'CheckConfigurationAndRewardOfChannelData';
  availableRewardCount: Scalars['Int']['output'];
  requiresDisposition: Scalars['Boolean']['output'];
};

export type CheckConfigurationAndRewardOfChannelResponse = {
  __typename?: 'CheckConfigurationAndRewardOfChannelResponse';
  data?: Maybe<CheckConfigurationAndRewardOfChannelData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CheckMemberEmailExistResponse = {
  __typename?: 'CheckMemberEmailExistResponse';
  data?: Maybe<CheckMemberExist>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CheckMemberExist = {
  __typename?: 'CheckMemberExist';
  exists?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckRegulatoryCompliance = {
  __typename?: 'CheckRegulatoryCompliance';
  approvedRegulatoryCompliance?: Maybe<ApprovedRegulatoryCompliance>;
  regulatoryCompliance?: Maybe<Scalars['Boolean']['output']>;
  requiredRegulatoryCompliance?: Maybe<ApprovedRegulatoryCompliance>;
};

export type ClaimedFreeNumber = {
  __typename?: 'ClaimedFreeNumber';
  currentPrice?: Maybe<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type Client = {
  __typename?: 'Client';
  country?: Maybe<Country>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ClientUsageHistory = {
  __typename?: 'ClientUsageHistory';
  clientUsageHistoryData?: Maybe<ClientUsageHistoryData>;
  userData?: Maybe<UserData>;
};

export type ClientUsageHistoryData = {
  __typename?: 'ClientUsageHistoryData';
  _id?: Maybe<Scalars['String']['output']>;
  accessDate?: Maybe<Scalars['DateTime']['output']>;
  activity?: Maybe<Scalars['String']['output']>;
  ipAddressLogId?: Maybe<IPAddressLog>;
};

export type ClientUsageHistoryResponse = {
  __typename?: 'ClientUsageHistoryResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<ClientUsageHistory>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CollectPaymentRequestInput = {
  gatewayAccountId: Scalars['String']['input'];
  gatewayToken?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: PaymentGatewayEnum;
  paymentSourceId?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  urlToken: Scalars['String']['input'];
};

export type CommandResponse = {
  __typename?: 'CommandResponse';
  command?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CommandResponseEdge = {
  __typename?: 'CommandResponseEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CommandResponse>;
};

export type CommandResponseInput = {
  command: Scalars['String']['input'];
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CommandResponseMessage = {
  __typename?: 'CommandResponseMessage';
  data?: Maybe<CommandResponse>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CommonResponse = {
  __typename?: 'CommonResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  edges?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ComplianceCampaign = {
  __typename?: 'ComplianceCampaign';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ContactComplianceConsentCampaignTypeEnum>;
};

export type ComplianceCampaignCursorPaginationResponse = {
  __typename?: 'ComplianceCampaignCursorPaginationResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<ComplianceCampaign>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ComplianceCampaignFilter = {
  id: Scalars['Int']['input'];
  type: ContactComplianceConsentCampaignTypeEnum;
};

export type ComplianceCampaignSampleMessage = {
  __typename?: 'ComplianceCampaignSampleMessage';
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ComplianceCampaignSampleMessagesResponse = {
  __typename?: 'ComplianceCampaignSampleMessagesResponse';
  data?: Maybe<Array<Maybe<ComplianceCampaignSampleMessage>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ComplianceDropdownEdge = {
  __typename?: 'ComplianceDropdownEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ComplianceDropdownResponse>;
};

export type ComplianceDropdownResponse = {
  __typename?: 'ComplianceDropdownResponse';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type CompliancePhoneNumber = {
  __typename?: 'CompliancePhoneNumber';
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messagingServiceSid?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CompliancePhoneNumberEdge = {
  __typename?: 'CompliancePhoneNumberEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CompliancePhoneNumber>;
};

export type ComplianceProprietorBrandEdge = {
  __typename?: 'ComplianceProprietorBrandEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ComplianceSoleProprietorBrand>;
};

export type ComplianceSoleProprietorBrand = {
  __typename?: 'ComplianceSoleProprietorBrand';
  connectedProfile?: Maybe<ConnectedProfile>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  reasonForFailure?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<ComplianceSoleProprietorBrandStatusEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vertical?: Maybe<ComplianceDropdownResponse>;
};

export type ComplianceSoleProprietorBrandCreationSuccessData = {
  __typename?: 'ComplianceSoleProprietorBrandCreationSuccessData';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ComplianceSoleProprietorBrandCreationSuccessResponse = {
  __typename?: 'ComplianceSoleProprietorBrandCreationSuccessResponse';
  data?: Maybe<ComplianceSoleProprietorBrandCreationSuccessData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ComplianceSoleProprietorBrandResponse = {
  __typename?: 'ComplianceSoleProprietorBrandResponse';
  data?: Maybe<ComplianceSoleProprietorBrand>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ComplianceSoleProprietorBrandStatusEnum {
  draft = 'draft',
  failed = 'failed',
  pending = 'pending',
  registered = 'registered',
  rejected = 'rejected',
}

export type ComplianceSoleProprietorBusinessData = {
  __typename?: 'ComplianceSoleProprietorBusinessData';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ComplianceSoleProprietorBusinessResponse = {
  __typename?: 'ComplianceSoleProprietorBusinessResponse';
  data?: Maybe<ComplianceSoleProprietorBusinessData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ComplianceSoleProprietorCampaign = {
  __typename?: 'ComplianceSoleProprietorCampaign';
  brand?: Maybe<Brand>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reasonForFailure?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<ComplianceSoleProprietorCampaignStatusEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  useCase?: Maybe<CampaignUseCase>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type ComplianceSoleProprietorCampaignCreationSuccessData = {
  __typename?: 'ComplianceSoleProprietorCampaignCreationSuccessData';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ComplianceSoleProprietorCampaignCreationSuccessResponse = {
  __typename?: 'ComplianceSoleProprietorCampaignCreationSuccessResponse';
  data?: Maybe<ComplianceSoleProprietorCampaignCreationSuccessData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ComplianceSoleProprietorCampaignEdge = {
  __typename?: 'ComplianceSoleProprietorCampaignEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ComplianceSoleProprietorCampaign>;
};

export type ComplianceSoleProprietorCampaignResponse = {
  __typename?: 'ComplianceSoleProprietorCampaignResponse';
  data?: Maybe<ComplianceSoleProprietorCampaign>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ComplianceSoleProprietorCampaignStatusEnum {
  a2p_campaign_create_billing_transaction_failed = 'a2p_campaign_create_billing_transaction_failed',
  a2p_campaign_create_event_failed = 'a2p_campaign_create_event_failed',
  a2p_campaign_draft = 'a2p_campaign_draft',
  a2p_campaign_draft_failed = 'a2p_campaign_draft_failed',
  a2p_campaign_messaging_service_create_failed = 'a2p_campaign_messaging_service_create_failed',
  a2p_campaign_messaging_service_deletion_failed = 'a2p_campaign_messaging_service_deletion_failed',
  a2p_campaign_payment_failed = 'a2p_campaign_payment_failed',
  a2p_campaign_payment_invoice_failed = 'a2p_campaign_payment_invoice_failed',
  a2p_campaign_pending = 'a2p_campaign_pending',
  a2p_campaign_registration_failed = 'a2p_campaign_registration_failed',
  a2p_campaign_subscription_create_failed = 'a2p_campaign_subscription_create_failed',
  a2p_campaign_subscription_deletion_failed = 'a2p_campaign_subscription_deletion_failed',
  a2p_campaign_subscription_invoice_failed = 'a2p_campaign_subscription_invoice_failed',
  a2p_campaign_twilio_registered = 'a2p_campaign_twilio_registered',
  a2p_campaign_twilio_rejected = 'a2p_campaign_twilio_rejected',
  a2p_campaign_twilio_submitted = 'a2p_campaign_twilio_submitted',
  a2p_campaign_update_failed = 'a2p_campaign_update_failed',
  a2p_campaign_us_app_to_person_deletion_failed = 'a2p_campaign_us_app_to_person_deletion_failed',
}

export type ComplianceSoleProprietorProfile = {
  __typename?: 'ComplianceSoleProprietorProfile';
  address?: Maybe<BusinessAddress>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  reasonForFailure?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<complianceSoleProprietorProfileStatus>;
};

export type ComplianceSoleProprietorProfileEdge = {
  __typename?: 'ComplianceSoleProprietorProfileEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ComplianceSoleProprietorProfile>;
};

export type ComplianceSoleProprietorProfileResponse = {
  __typename?: 'ComplianceSoleProprietorProfileResponse';
  data?: Maybe<ComplianceSoleProprietorProfile>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ConditionActionEnum {
  call_forward = 'call_forward',
  member = 'member',
  voicemail = 'voicemail',
}

export enum ConditionUnanswerRedirectEnum {
  call_forward = 'call_forward',
  revalidate = 'revalidate',
  terminate = 'terminate',
  voicemail = 'voicemail',
}

export type Conference = {
  __typename?: 'Conference';
  accountSid?: Maybe<Scalars['String']['output']>;
  apiVersion?: Maybe<Scalars['Date']['output']>;
  callSidEndingConference?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  dateUpdated?: Maybe<Scalars['Date']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  reasonConferenceEnded?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ConferenceAnalytic = {
  __typename?: 'ConferenceAnalytic';
  missed?: Maybe<ConferenceCount>;
  queued?: Maybe<ConferenceCount>;
  total?: Maybe<ConferenceCount>;
};

export type ConferenceAnalyticResponse = {
  __typename?: 'ConferenceAnalyticResponse';
  data?: Maybe<ConferenceAnalytic>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConferenceCount = {
  __typename?: 'ConferenceCount';
  current?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  previous?: Maybe<Scalars['Int']['output']>;
};

export type ConferenceHistory = {
  __typename?: 'ConferenceHistory';
  agent?: Maybe<UserWorkspace>;
  channel?: Maybe<Channel>;
  client?: Maybe<Contact>;
  conversationStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  durationConference?: Maybe<Duration>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ConferenceHistoryEdge = {
  __typename?: 'ConferenceHistoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ConferenceHistory>;
};

export type ConferenceInteractionAnalytic = {
  __typename?: 'ConferenceInteractionAnalytic';
  averageAnswerTime?: Maybe<ConferenceInteractionAnalyticItem>;
  averageCloseTime?: Maybe<ConferenceInteractionAnalyticItem>;
  totalCallDuration?: Maybe<ConferenceInteractionAnalyticItem>;
};

export type ConferenceInteractionAnalyticItem = {
  __typename?: 'ConferenceInteractionAnalyticItem';
  current?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  previous?: Maybe<Scalars['Float']['output']>;
};

export type ConferenceInteractionAnalyticResponse = {
  __typename?: 'ConferenceInteractionAnalyticResponse';
  data?: Maybe<ConferenceInteractionAnalytic>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConferenceParticipant = {
  __typename?: 'ConferenceParticipant';
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Media>;
};

export enum ConferenceStatusEnum {
  completed = 'completed',
  in_progress = 'in_progress',
  init = 'init',
}

export type Conferences = {
  __typename?: 'Conferences';
  edges?: Maybe<Array<Maybe<Conference>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type ConfigurationResponse = {
  __typename?: 'ConfigurationResponse';
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConnectOrDisconnectThirdPartyResponse = {
  __typename?: 'ConnectOrDisconnectThirdPartyResponse';
  data?: Maybe<Integration>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConnectResponse = {
  __typename?: 'ConnectResponse';
  data?: Maybe<AuthorizationUrlResponse>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConnectedProfile = {
  __typename?: 'ConnectedProfile';
  businessName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Scalars['String']['output']>;
  blockReason?: Maybe<Scalars['String']['output']>;
  blockedBy?: Maybe<User>;
  blockedOn?: Maybe<Scalars['Date']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactComplianceConsents?: Maybe<Array<Maybe<ContactComplianceConsent>>>;
  country?: Maybe<Country>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  isNumberValid?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Media>;
  sourceType?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
};

export type ContactComplianceConsent = {
  __typename?: 'ContactComplianceConsent';
  Contact?: Maybe<Contact>;
  campaign?: Maybe<ContactComplianceConsentCampaign>;
  consentDetails?: Maybe<Scalars['String']['output']>;
  consentSource?: Maybe<ContactComplianceConsentSourceEnum>;
  consentedAt?: Maybe<Scalars['Date']['output']>;
  flowDetails?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isConsented?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactComplianceConsentCampaign = {
  __typename?: 'ContactComplianceConsentCampaign';
  id?: Maybe<Scalars['Int']['output']>;
  messageServiceName?: Maybe<Scalars['String']['output']>;
};

export enum ContactComplianceConsentCampaignTypeEnum {
  low_volume_campaign = 'low_volume_campaign',
  sole_prop_campaign = 'sole_prop_campaign',
}

export type ContactComplianceConsentResponse = {
  __typename?: 'ContactComplianceConsentResponse';
  data?: Maybe<ContactComplianceConsent>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ContactComplianceConsentSourceEnum {
  ivr = 'ivr',
  online = 'online',
  other = 'other',
  paper = 'paper',
  person = 'person',
  phone = 'phone',
  pos = 'pos',
  text = 'text',
  verbal = 'verbal',
  web = 'web',
}

export type ContactConsentStatus = {
  __typename?: 'ContactConsentStatus';
  hasConsented?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactConsentStatusResponse = {
  __typename?: 'ContactConsentStatusResponse';
  data?: Maybe<ContactConsentStatus>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Contact>;
};

export enum ContactMessagingTypeEnum {
  sms = 'sms',
  telegram = 'telegram',
  viber = 'viber',
  whatsapp = 'whatsapp',
}

export type ContactNote = {
  __typename?: 'ContactNote';
  contact?: Maybe<Contact>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdById?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<UserWorkspace>;
};

export type ContactNoteEdge = {
  __typename?: 'ContactNoteEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ContactNote>;
};

export type ContactNoteV2 = {
  __typename?: 'ContactNoteV2';
  contact?: Maybe<Contact>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdById?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<UserWorkspace>;
};

export type ContactOffSetResponse = {
  __typename?: 'ContactOffSetResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Contact>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ContactProfileForDialerScreen = {
  __typename?: 'ContactProfileForDialerScreen';
  country?: Maybe<Country>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Media>;
};

export enum ContactSourceTypeEnum {
  imported = 'imported',
  manual = 'manual',
  system = 'system',
}

export type ContactSourceTypeResponse = {
  __typename?: 'ContactSourceTypeResponse';
  data?: Maybe<Array<Maybe<SourceType>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ContactTag = {
  __typename?: 'ContactTag';
  contactId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Tag>;
};

export type ContactTagEdge = {
  __typename?: 'ContactTagEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ContactTag>;
};

export type ContactTagsData = {
  __typename?: 'ContactTagsData';
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type ContactTagsv2 = {
  __typename?: 'ContactTagsv2';
  contact?: Maybe<Contact>;
  id?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Tag>;
};

export type ConversationAnalyticItem = {
  __typename?: 'ConversationAnalyticItem';
  label?: Maybe<Scalars['String']['output']>;
  received?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type ConversationAnalyticResponse = {
  __typename?: 'ConversationAnalyticResponse';
  edges?: Maybe<Array<Maybe<ConversationAnalyticItem>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConversationCount = {
  __typename?: 'ConversationCount';
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  incomingCounts?: Maybe<Scalars['Int']['output']>;
  outgoingCounts?: Maybe<Scalars['Int']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  totalCounts?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export type ConversationDetailResponse = {
  __typename?: 'ConversationDetailResponse';
  data?: Maybe<RecentMessageConversation>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ConversationTypeEnum {
  conference = 'conference',
  message = 'message',
}

export type CountCallSettingType = {
  __typename?: 'CountCallSettingType';
  count?: Maybe<Scalars['Int']['output']>;
};

export type CountChannelGroupType = {
  __typename?: 'CountChannelGroupType';
  count?: Maybe<Scalars['Int']['output']>;
};

export type CountPinnedChatMessagesResponse = {
  __typename?: 'CountPinnedChatMessagesResponse';
  count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CountResponse = {
  __typename?: 'CountResponse';
  count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename?: 'Country';
  alphaThreeCode?: Maybe<Scalars['String']['output']>;
  alphaTwoCode?: Maybe<Scalars['String']['output']>;
  dialingCode?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type CouponCode = {
  __typename?: 'CouponCode';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maxRedemption?: Maybe<Scalars['Int']['output']>;
  noOfCodeUsed?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PromotionStatusEnum>;
};

export enum CouponDiscountTypeEnum {
  fixed_amount = 'fixed_amount',
  percentage = 'percentage',
}

export type CouponGroup = {
  __typename?: 'CouponGroup';
  codeLength?: Maybe<Scalars['Int']['output']>;
  delimiter?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export enum CouponOriginEnum {
  affiliate_partner = 'affiliate_partner',
  calilio_campaign = 'calilio_campaign',
}

export enum CouponPeriodicityEnum {
  annually = 'annually',
  monthly = 'monthly',
}

export enum CouponTermLimitEnum {
  lifetime = 'lifetime',
  term_limited = 'term_limited',
}

export enum CouponTypeEnum {
  batch = 'batch',
  single = 'single',
}

export type CreateBulkMessagingCampaignResponse = {
  __typename?: 'CreateBulkMessagingCampaignResponse';
  data?: Maybe<BulkMessagingCampaign>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateIntegrationRequestInput = {
  appName: Scalars['String']['input'];
  appWebsite: Scalars['String']['input'];
  remarks: Scalars['String']['input'];
};

export type CreateNotificationTemplateResponse = {
  __typename?: 'CreateNotificationTemplateResponse';
  data?: Maybe<Array<Maybe<TemplateNotification>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreatePaymentRequest = {
  __typename?: 'CreatePaymentRequest';
  data?: Maybe<PaymentRequest>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateSubscriptionInput = {
  gatewayAccountId: Scalars['String']['input'];
  gatewayToken?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: PaymentGatewayEnum;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  user: BillingUser;
};

export type CriticalEvent = {
  __typename?: 'CriticalEvent';
  event?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CriticalEventRes = {
  __typename?: 'CriticalEventRes';
  data?: Maybe<Array<Maybe<CriticalEvent>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Cursor = {
  __typename?: 'Cursor';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type CursorBasedViewByWorkspaces = {
  __typename?: 'CursorBasedViewByWorkspaces';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<ViewByWorkspaces>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorBasedWorkspaceMembers = {
  __typename?: 'CursorBasedWorkspaceMembers';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<WorkspaceMembers>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CursorDirectionEnum {
  next = 'next',
  previous = 'previous',
}

export type CursorPaginationActiveWorkspaces = {
  __typename?: 'CursorPaginationActiveWorkspaces';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAdminGetScreens = {
  __typename?: 'CursorPaginationAdminGetScreens';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Screen>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAdminGetWorkspace = {
  __typename?: 'CursorPaginationAdminGetWorkspace';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAdminGetWorkspaceMembers = {
  __typename?: 'CursorPaginationAdminGetWorkspaceMembers';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<UserWorkspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAdminListUnpaidUsersResponse = {
  __typename?: 'CursorPaginationAdminListUnpaidUsersResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<UnpaidUser>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAdminPaymentRequestsV2 = {
  __typename?: 'CursorPaginationAdminPaymentRequestsV2';
  cursor?: Maybe<Cursor>;
  data: Array<PaymentRequestV2>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAreaCodes = {
  __typename?: 'CursorPaginationAreaCodes';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<AreaCode>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAttributeValuesV2 = {
  __typename?: 'CursorPaginationAttributeValuesV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<AttributeValue>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAttributesV2 = {
  __typename?: 'CursorPaginationAttributesV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Attribute>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationAvailablePhoneNumber = {
  __typename?: 'CursorPaginationAvailablePhoneNumber';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<TwilioPhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationBillingResponseV2 = {
  __typename?: 'CursorPaginationBillingResponseV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Invoice>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationBlockedContactsV2 = {
  __typename?: 'CursorPaginationBlockedContactsV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Contact>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationBlockedDomain = {
  __typename?: 'CursorPaginationBlockedDomain';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BlockedDomain>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationBlockedForwardedPhoneNumber = {
  __typename?: 'CursorPaginationBlockedForwardedPhoneNumber';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BlockedForwardedPhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationBlockedIpAddress = {
  __typename?: 'CursorPaginationBlockedIpAddress';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BlockedIpAddress>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationBlockedPhoneNumber = {
  __typename?: 'CursorPaginationBlockedPhoneNumber';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BlockedPhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationBlockedSignUpEmail = {
  __typename?: 'CursorPaginationBlockedSignUpEmail';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BlockedSignUpEmail>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationCommandResponseV2 = {
  __typename?: 'CursorPaginationCommandResponseV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<CommandResponse>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationComplianceProprietorBrand = {
  __typename?: 'CursorPaginationComplianceProprietorBrand';
  edges?: Maybe<Array<Maybe<ComplianceProprietorBrandEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CursorPaginationComplianceSoleProprietorCampaign = {
  __typename?: 'CursorPaginationComplianceSoleProprietorCampaign';
  edges?: Maybe<Array<Maybe<ComplianceSoleProprietorCampaignEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CursorPaginationContactMessagingConsentResponse = {
  __typename?: 'CursorPaginationContactMessagingConsentResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Contact>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationContactNoteV2 = {
  __typename?: 'CursorPaginationContactNoteV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<ContactNoteV2>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationContactTagV2 = {
  __typename?: 'CursorPaginationContactTagV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<ContactTagsv2>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationContactV2 = {
  __typename?: 'CursorPaginationContactV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Contact>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationCountries = {
  __typename?: 'CursorPaginationCountries';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Country>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationGetChatMessagesV2 = {
  __typename?: 'CursorPaginationGetChatMessagesV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<ChatMessage>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationIntegrationChannelsV2 = {
  __typename?: 'CursorPaginationIntegrationChannelsV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<IntegrationChannelV2>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationIntegrationsV2 = {
  __typename?: 'CursorPaginationIntegrationsV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Integration>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationInvoices = {
  __typename?: 'CursorPaginationInvoices';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Invoice>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationMessageConversationErrorLogs = {
  __typename?: 'CursorPaginationMessageConversationErrorLogs';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<MessageConversationErrorLog>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationNotificationV2 = {
  __typename?: 'CursorPaginationNotificationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<NotificationV2>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationPaymentOrders = {
  __typename?: 'CursorPaginationPaymentOrders';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<PaymentOrder>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationRecentMessageConversationV2 = {
  __typename?: 'CursorPaginationRecentMessageConversationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<RecentMessageConversation>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationTagV2 = {
  __typename?: 'CursorPaginationTagV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Tag>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationTeamsV2 = {
  __typename?: 'CursorPaginationTeamsV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<TeamsInterface>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginationUnlimitedConfig = {
  __typename?: 'CursorPaginationUnlimitedConfig';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<UnlimitedConfig>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CustomPlan = {
  __typename?: 'CustomPlan';
  billingPlanPrices?: Maybe<PlanPrice>;
  billingPlanPricesId?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  usedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<User>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type CustomPlanConnection = {
  __typename?: 'CustomPlanConnection';
  edges?: Maybe<Array<Maybe<CustomPlanEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CustomPlanEdge = {
  __typename?: 'CustomPlanEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CustomPlan>;
};

export type CustomPlanInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  passcode: Scalars['String']['input'];
  period?: InputMaybe<PeriodicityEnum>;
  referencedPlanId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type Customer = {
  __typename?: 'Customer';
  billingAddress?: Maybe<BillingAddress>;
  email?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type CustomerBillingAddressResponse = {
  __typename?: 'CustomerBillingAddressResponse';
  data?: Maybe<BillingInfo>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardActivityAfterBusinessHourData = {
  __typename?: 'DashboardActivityAfterBusinessHourData';
  call?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardActivityAfterBusinessHourRes = {
  __typename?: 'DashboardActivityAfterBusinessHourRes';
  data?: Maybe<Array<Maybe<DashboardActivityAfterBusinessHourData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardCallDistributionItem = {
  __typename?: 'DashboardCallDistributionItem';
  callPercentage?: Maybe<Scalars['String']['output']>;
  channelFriendlyName?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelMediaUrl?: Maybe<Scalars['String']['output']>;
  channelPhoneNumber?: Maybe<Scalars['String']['output']>;
  totalCalls?: Maybe<Scalars['Int']['output']>;
};

export type DashboardCallDistributionRes = {
  __typename?: 'DashboardCallDistributionRes';
  data?: Maybe<Array<Maybe<DashboardCallDistributionItem>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardCallVolumeItem = {
  __typename?: 'DashboardCallVolumeItem';
  inboundCount?: Maybe<Scalars['Int']['output']>;
  outboundCount?: Maybe<Scalars['Int']['output']>;
  timeBucket?: Maybe<Scalars['String']['output']>;
};

export type DashboardCallVolumeRes = {
  __typename?: 'DashboardCallVolumeRes';
  data?: Maybe<Array<Maybe<DashboardCallVolumeItem>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardNumberAnalytic = {
  __typename?: 'DashboardNumberAnalytic';
  capability?: Maybe<ChannelCapability>;
  channelName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  duration?: Maybe<Scalars['String']['output']>;
  emergencyStatus?: Maybe<EmergencyStatusEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  members?: Maybe<Array<Maybe<ChannelMember>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  strategies?: Maybe<Array<Maybe<ChannelStrategy>>>;
  teams?: Maybe<Array<Maybe<Team>>>;
  totalCalls?: Maybe<Scalars['Int']['output']>;
};

export type DashboardNumberAnalyticsCursorResponse = {
  __typename?: 'DashboardNumberAnalyticsCursorResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<DashboardNumberAnalyticsData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardNumberAnalyticsData = {
  __typename?: 'DashboardNumberAnalyticsData';
  capability?: Maybe<ChannelCapability>;
  channelName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  duration?: Maybe<Scalars['String']['output']>;
  emergencyStatus?: Maybe<EmergencyStatusEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  members?: Maybe<Array<Maybe<ChannelMember>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  strategies?: Maybe<Array<Maybe<ChannelStrategy>>>;
  teams?: Maybe<Array<Maybe<Team>>>;
  totalCalls?: Maybe<Scalars['Int']['output']>;
};

export type DashboardNumberAnalyticsResponse = {
  __typename?: 'DashboardNumberAnalyticsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<DashboardNumberAnalytic>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardReportAnalyticData = {
  __typename?: 'DashboardReportAnalyticData';
  callType?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type DashboardReportAnalyticResponse = {
  __typename?: 'DashboardReportAnalyticResponse';
  data?: Maybe<Array<Maybe<DashboardReportAnalyticData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardUniquerVsRepeatedCallerItem = {
  __typename?: 'DashboardUniquerVsRepeatedCallerItem';
  repeatedCount?: Maybe<Scalars['Int']['output']>;
  timeBucket?: Maybe<Scalars['String']['output']>;
  uniqueCount?: Maybe<Scalars['Int']['output']>;
};

export type DashboardUniquerVsRepeatedCallerRes = {
  __typename?: 'DashboardUniquerVsRepeatedCallerRes';
  data?: Maybe<Array<Maybe<DashboardUniquerVsRepeatedCallerItem>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DashboardUnlimitedUsages = {
  __typename?: 'DashboardUnlimitedUsages';
  endingAt?: Maybe<Scalars['Date']['output']>;
  freeCreditWorth?: Maybe<Scalars['Float']['output']>;
  hasUnlimitedConfig?: Maybe<Scalars['Boolean']['output']>;
  incoming?: Maybe<DashboardUnlimitedUsagesData>;
  outgoing?: Maybe<DashboardUnlimitedUsagesData>;
};

export type DashboardUnlimitedUsagesData = {
  __typename?: 'DashboardUnlimitedUsagesData';
  call?: Maybe<Scalars['Float']['output']>;
  callCount?: Maybe<Scalars['String']['output']>;
  callThreshold?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['Float']['output']>;
  messageCount?: Maybe<Scalars['String']['output']>;
  messageThreshold?: Maybe<Scalars['String']['output']>;
};

export type DashboardUnlimitedUsagesRes = {
  __typename?: 'DashboardUnlimitedUsagesRes';
  data?: Maybe<DashboardUnlimitedUsages>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DefaultChannelResponse = {
  __typename?: 'DefaultChannelResponse';
  data?: Maybe<ChannelUserWorkspace>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeletePlanItemsInput = {
  planItemType: Scalars['String']['input'];
  subcriptionType: Scalars['String']['input'];
};

export type DeleteWorkspaceUserResponse = {
  __typename?: 'DeleteWorkspaceUserResponse';
  data?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeviceLog = {
  __typename?: 'DeviceLog';
  _id?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  sessionLength?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userWorkspaceId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export enum DevicePlatformEnum {
  mobile = 'mobile',
  web = 'web',
}

export type DialerCallPulse = {
  __typename?: 'DialerCallPulse';
  data?: Maybe<Scalars['Object']['output']>;
  feature?: Maybe<CallFeatureEnum>;
};

export enum DirectionFilterEnum {
  incoming = 'incoming',
  outgoing = 'outgoing',
}

export enum DirectionTypeEnum {
  incoming = 'incoming',
  outgoing = 'outgoing',
}

export type DiscountResponse = {
  __typename?: 'DiscountResponse';
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
};

export enum DiscountTypeEnum {
  fixedAmount = 'fixedAmount',
  percentage = 'percentage',
}

export type DowngradeWorkspaceSubscriptionInput = {
  targetedPlanPriceId: Scalars['Int']['input'];
};

export type DraftMessageConversation = {
  __typename?: 'DraftMessageConversation';
  agentId?: Maybe<Scalars['Int']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mediaCount?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  messageContent?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type DraftMessageConversationMedia = {
  __typename?: 'DraftMessageConversationMedia';
  draftMessageConversationId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Media>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type Duration = {
  __typename?: 'Duration';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type DurationConference = {
  __typename?: 'DurationConference';
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type Email = {
  __typename?: 'Email';
  email: Scalars['String']['output'];
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  isPhoneNumberVerified?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailTemplateSegment = {
  __typename?: 'EmailTemplateSegment';
  content?: Maybe<Scalars['String']['output']>;
  contentJson?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type EmailUpdateResponse = {
  __typename?: 'EmailUpdateResponse';
  data?: Maybe<UpdatedEmail>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum EmergencyStatusEnum {
  active = 'active',
  inactive = 'inactive',
}

export type EnumerateCountriesForAvailableNumbersResponse = {
  __typename?: 'EnumerateCountriesForAvailableNumbersResponse';
  data?: Maybe<Array<Maybe<Country>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type EnumerateNumberTypesAvailableForCountryResponse = {
  __typename?: 'EnumerateNumberTypesAvailableForCountryResponse';
  data?: Maybe<Array<Maybe<NumberType>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorDetails = {
  __typename?: 'ErrorDetails';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type EstimateAmountResponse = {
  __typename?: 'EstimateAmountResponse';
  data?: Maybe<EstimatedData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type EstimatedData = {
  __typename?: 'EstimatedData';
  estimatedAmount?: Maybe<Scalars['Int']['output']>;
};

export type ExchangeOAuthAuthorizationCodeForTokensResponse = {
  __typename?: 'ExchangeOAuthAuthorizationCodeForTokensResponse';
  data?: Maybe<Integration>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ExportContactStatusResponse = {
  __typename?: 'ExportContactStatusResponse';
  data?: Maybe<Media>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExportInvoiceStatusResponse = {
  __typename?: 'ExportInvoiceStatusResponse';
  data?: Maybe<Media>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExtensionConfiguration = {
  __typename?: 'ExtensionConfiguration';
  applySearchExtend?: Maybe<Scalars['Boolean']['output']>;
  autoSearchNumbers?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  showLogo?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type ExtensionConfigurationResponse = {
  __typename?: 'ExtensionConfigurationResponse';
  data?: Maybe<ExtensionConfiguration>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FederatedAuthResponse = {
  __typename?: 'FederatedAuthResponse';
  data?: Maybe<FederatedAuthToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FederatedAuthToken = {
  __typename?: 'FederatedAuthToken';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token?: Maybe<LoginToken>;
};

export type FetchUrlTokenForPayment = {
  __typename?: 'FetchUrlTokenForPayment';
  data?: Maybe<PaymentRequest>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FetchUserStatementResponse = {
  __typename?: 'FetchUserStatementResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<UserWalletUsageDetails>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ForgotPassword = {
  __typename?: 'ForgotPassword';
  data?: Maybe<Email>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ForwardChatToEmailReceiver = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ForwardToExternalNumber = {
  __typename?: 'ForwardToExternalNumber';
  externalNumber?: Maybe<Scalars['String']['output']>;
};

export enum GenderEnum {
  female = 'female',
  male = 'male',
}

export type GeographicAddress = {
  __typename?: 'GeographicAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  geographic?: Maybe<GeographicCoordinates>;
  region?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GeographicCoordinates = {
  __typename?: 'GeographicCoordinates';
  coordinates?: Maybe<Scalars['Coordinates']['output']>;
};

export type GetBulkMessagingCampaignResponse = {
  __typename?: 'GetBulkMessagingCampaignResponse';
  data?: Maybe<BulkMessagingCampaign>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetBulkMessagingCampaignRunResponse = {
  __typename?: 'GetBulkMessagingCampaignRunResponse';
  data?: Maybe<BulkMessagingCampaignRun>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetComplianceSoleProprietorStatus = {
  __typename?: 'GetComplianceSoleProprietorStatus';
  brand?: Maybe<ComplianceSoleProprietorBrand>;
  campaign?: Maybe<ComplianceSoleProprietorCampaign>;
  profile?: Maybe<ComplianceSoleProprietorProfile>;
};

export type GetComplianceSoleProprietorStatusResponse = {
  __typename?: 'GetComplianceSoleProprietorStatusResponse';
  data?: Maybe<GetComplianceSoleProprietorStatus>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetContactProfileForDialerScreenResponse = {
  __typename?: 'GetContactProfileForDialerScreenResponse';
  data?: Maybe<ContactProfileForDialerScreen>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetNotificationTemplateResponse = {
  __typename?: 'GetNotificationTemplateResponse';
  edges?: Maybe<Array<Maybe<TemplateNotificationEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type GetTranscriptionInformationData = {
  __typename?: 'GetTranscriptionInformationData';
  availableSentiments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  callRecordingUrl?: Maybe<Scalars['String']['output']>;
  callSummary?: Maybe<Scalars['String']['output']>;
  conclusion?: Maybe<Scalars['String']['output']>;
  customerTalkTime?: Maybe<Scalars['String']['output']>;
  memberTalkTime?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resolutions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sentiment?: Maybe<Scalars['String']['output']>;
  silenceTime?: Maybe<Scalars['String']['output']>;
  totalTalkTime?: Maybe<Scalars['String']['output']>;
  transcriptionText?: Maybe<Array<Maybe<TranscriptionText>>>;
};

export type GetTranscriptionInformationResponse = {
  __typename?: 'GetTranscriptionInformationResponse';
  data?: Maybe<GetTranscriptionInformationData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetWorkspaceChannelMembersCursorPagination = {
  __typename?: 'GetWorkspaceChannelMembersCursorPagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<WorkspaceChannelMember>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IPAddressLog = {
  __typename?: 'IPAddressLog';
  _id?: Maybe<Scalars['String']['output']>;
  address?: Maybe<GeographicAddress>;
  clientIp?: Maybe<Scalars['String']['output']>;
  deviceLogId?: Maybe<DeviceLog>;
};

export enum IdentityProviderEnum {
  Google = 'Google',
  SignInWithApple = 'SignInWithApple',
}

export enum IdentityProviderUserListEnum {
  Email = 'Email',
  Google = 'Google',
  SignInWithApple = 'SignInWithApple',
}

export type Image = {
  __typename?: 'Image';
  url?: Maybe<Scalars['String']['output']>;
};

export type ImportBulkContactProgressResponse = {
  __typename?: 'ImportBulkContactProgressResponse';
  progress?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type InProcessPhoneNumber = {
  __typename?: 'InProcessPhoneNumber';
  capabilities?: Maybe<TwilioCapability>;
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  numberType?: Maybe<NumberTypeEnum>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type InProcessPhoneNumberCursorPagination = {
  __typename?: 'InProcessPhoneNumberCursorPagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<InProcessPhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type InProcessPhoneNumberCursorPaginationResponse = {
  __typename?: 'InProcessPhoneNumberCursorPaginationResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<PhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IncomingPhoneNumber = {
  __typename?: 'IncomingPhoneNumber';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  providerNumber?: Maybe<TwilioPhoneNumber>;
  purchaseBy?: Maybe<UserWorkspace>;
  status?: Maybe<IncomingPhoneNumberStatusEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workspace?: Maybe<Workspace>;
};

export type IncomingPhoneNumberEdge = {
  __typename?: 'IncomingPhoneNumberEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<IncomingPhoneNumber>;
};

export enum IncomingPhoneNumberStatusEnum {
  DOCUMENT_REQUIRED = 'DOCUMENT_REQUIRED',
  FAILED = 'FAILED',
  INADEQUATE_DOCUMENT = 'INADEQUATE_DOCUMENT',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  VERIFICATION_IN_PROGRESS = 'VERIFICATION_IN_PROGRESS',
}

export type IndividualMemberDashboardReportAnalytics = {
  __typename?: 'IndividualMemberDashboardReportAnalytics';
  callDate?: Maybe<Scalars['String']['output']>;
  callDuration?: Maybe<Scalars['String']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type IndividualMemberDashboardReportAnalyticsResponse = {
  __typename?: 'IndividualMemberDashboardReportAnalyticsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<IndividualMemberDashboardReportAnalytics>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IndividualNumberReportAnalyticsEdge = {
  __typename?: 'IndividualNumberReportAnalyticsEdge';
  callDate?: Maybe<Scalars['String']['output']>;
  callDuration?: Maybe<Scalars['String']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type IndividualNumberReportAnalyticsResponse = {
  __typename?: 'IndividualNumberReportAnalyticsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<IndividualNumberReportAnalyticsEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type InputAIDashboard = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InputAcceptInvitedWorkspaceMemberInterface = {
  accept: Scalars['Boolean']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type InputAddress = {
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type InputAdminBlockOrUnblockWorkspace = {
  active: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  passcode: Scalars['String']['input'];
};

export type InputAdminCancelPaymentOrder = {
  paymentOrderId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type InputAdminChangePassword = {
  passcode: Scalars['String']['input'];
  previousPassword: Scalars['String']['input'];
  proposedPassword: Scalars['String']['input'];
};

export type InputAdminChangeProviderSubaccountStatus = {
  passcode: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputAdminCloseWorkspace = {
  passcode: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputAdminConfigureA2pCompliance = {
  a2pVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputAdminConfigureExclusiveNumbers = {
  exclusiveNumbers: Array<InputMaybe<InputExclusiveNumbers>>;
  paymentOrderId: Scalars['Int']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type InputAdminCreateAndResetConfigurationChannel = {
  phoneNumber: Scalars['String']['input'];
};

export type InputAdminCreateConfiguration = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Object']['input']>;
};

export type InputAdminCreatePaymentOrder = {
  amount: Scalars['Int']['input'];
  items?: InputMaybe<Array<InputMaybe<PaymentOrderItem>>>;
  quantity: Scalars['Int']['input'];
  remarks: Scalars['String']['input'];
  type: PaymentOrderTypeEnum;
  workspaceId: Scalars['Int']['input'];
};

export type InputAdminDeleteWorkspaceMember = {
  enteredPasscode?: InputMaybe<Scalars['String']['input']>;
  userWorkspaceId: Scalars['Int']['input'];
};

export type InputAdminEmailOTP = {
  email: Scalars['String']['input'];
  passcode: Scalars['String']['input'];
};

export type InputAdminEmailTemplateSegment = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentJson?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type InputAdminEnableOrDisableUser = {
  blocked: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
};

export type InputAdminGetConversationCount = {
  email?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ConversationTypeEnum>;
};

export type InputAdminPortAwayNumber = {
  enteredPasscode: Scalars['String']['input'];
};

export type InputAdminSetFederatedUserPassword = {
  email?: InputMaybe<Scalars['String']['input']>;
  passcode: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type InputAdminSetKycVerification = {
  kycVerified: Scalars['Boolean']['input'];
  passcode: Scalars['String']['input'];
};

export type InputAdminUpdateUserEmail = {
  newEmail?: InputMaybe<Scalars['String']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputAssignMembersToChannel = {
  assignIds: Array<InputMaybe<Scalars['Int']['input']>>;
  channelId: Scalars['Int']['input'];
  unassignIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type InputAssignOrUnassignChannelToMember = {
  checkedChannel: Array<InputMaybe<Scalars['Int']['input']>>;
  uncheckedChannel: Array<InputMaybe<Scalars['Int']['input']>>;
  userWorkspaceId: Scalars['Int']['input'];
};

export type InputAssignSubaccount = {
  subaccount: InputSubaccount;
  workspaceId: Scalars['Int']['input'];
};

export type InputAttribute = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type InputAttributeValue = {
  attributeId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type InputAudioPrompt = {
  audioId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  language?: InputMaybe<AudioPromptLanguageEnum>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AudioPromptTypeEnum>;
};

export type InputAuthConfirmSignUp = {
  confirmationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type InputAuthLogin = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export type InputAuthResendConfirmationCode = {
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export type InputAuthSignUp = {
  clickId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  partnerKey?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type InputAuthSignUpV2 = {
  clickId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  partnerKey?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  uiVersion?: InputMaybe<UiVersionEnum>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type InputAuthUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputAutoRechargeConfig = {
  creditThreshold: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  targetBalance: Scalars['Int']['input'];
};

export type InputAutoRecording = {
  autoRecording?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputAutoTranscribe = {
  autoTranscribe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputBillingAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type InputBillingDiscount = {
  billingSubscriptionId?: InputMaybe<Scalars['Int']['input']>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  discountPrice?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountTypeEnum>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type InputBillingInfo = {
  billingAddress?: InputMaybe<InputBillingAddress>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputBlockOrUnblockContact = {
  blockReason?: InputMaybe<Scalars['String']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputBulkMessagingCampaign = {
  a2pCampaignId?: InputMaybe<Scalars['Int']['input']>;
  a2pCampaignType?: InputMaybe<BulkMessagingCampaignA2pCampaignTypeEnum>;
  a2pSampleId?: InputMaybe<Scalars['Int']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  campaignType?: InputMaybe<BulkMessagingCampaignTypeEnum>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endAt?: InputMaybe<Scalars['Date']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  maxOccurrence?: InputMaybe<Scalars['Int']['input']>;
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  messagingType?: InputMaybe<BulkMessagingCampaignMessagingTypeEnum>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduleType?: InputMaybe<BulkMessagingCampaignScheduleTypeEnum>;
  scheduledAt?: InputMaybe<Scalars['Date']['input']>;
};

export type InputBundle = {
  email?: InputMaybe<Scalars['String']['input']>;
  endUserType?: InputMaybe<BundleEndUserTypeEnum>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  isoCountry?: InputMaybe<Scalars['String']['input']>;
  numberType?: InputMaybe<Scalars['String']['input']>;
  regulationsSid?: InputMaybe<Scalars['String']['input']>;
};

export type InputBusinessAddress = {
  address?: InputMaybe<InputAddress>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  isExistingAddress: Scalars['Boolean']['input'];
};

export type InputBusinessHour = {
  callSettingId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  entries?: InputMaybe<Array<InputMaybe<InputBusinessHourEntry>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  route?: InputMaybe<AfterHourRouteEnum>;
  targetPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezoneId?: InputMaybe<Scalars['Int']['input']>;
  voicemail?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailAudioPrompt?: InputMaybe<InputAudioPrompt>;
  voicemailPrompt?: InputMaybe<Scalars['String']['input']>;
  voicemailPromptSource?: InputMaybe<Scalars['String']['input']>;
};

export type InputBusinessHourEntry = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  localDayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  localEndTime?: InputMaybe<Scalars['String']['input']>;
  localStartTime?: InputMaybe<Scalars['String']['input']>;
};

export type InputCallForward = {
  callSettingId: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isUnconditional: Scalars['Boolean']['input'];
  targetPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputCallForwardChannel = {
  isActive: Scalars['Boolean']['input'];
  isUnconditional: Scalars['Boolean']['input'];
  targetPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputCallSetting = {
  friendlyName: Scalars['String']['input'];
};

export type InputCallSettingBusinessAfterHours = {
  callSettingId: Scalars['Int']['input'];
  route?: InputMaybe<AfterHourRouteEnum>;
  supportAfterHours?: InputMaybe<Scalars['Boolean']['input']>;
  targetPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  voicemailAudioPrompt?: InputMaybe<InputAudioPrompt>;
};

export type InputCallSettingBusinessHour = {
  callSettingId: Scalars['Int']['input'];
  entries?: InputMaybe<Array<InputMaybe<InputBusinessHourEntry>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  timezoneId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCallSettingId = {
  callSettingId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCallSettingTransfer = {
  isActive: Scalars['Boolean']['input'];
  noAnswerPrompt?: InputMaybe<InputCallTransferAudioPrompt>;
  terminatedPrompt?: InputMaybe<InputCallTransferAudioPrompt>;
  transferPrompt?: InputMaybe<InputCallTransferAudioPrompt>;
};

export type InputCallSettingVoiceMail = {
  audioPrompt?: InputMaybe<InputAudioPrompt>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sendVoicemailToEmail?: InputMaybe<Scalars['Boolean']['input']>;
  voiceMailAfterBeep?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCallSettingWelcomeMessage = {
  audioPrompt?: InputMaybe<InputAudioPrompt>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPreRing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCallSettingWithPrompt = {
  audioPrompt?: InputMaybe<InputAudioPrompt>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCallTransfer = {
  destination: Scalars['String']['input'];
  route: CallTransferRouteEnum;
};

export type InputCallTransferAudioPrompt = {
  audioId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  language?: InputMaybe<AudioPromptLanguageEnum>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AudioPromptTypeEnum>;
  useDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCallerId = {
  callerId: Scalars['Int']['input'];
};

export type InputCallerTune = {
  audioPrompt?: InputMaybe<InputAudioPrompt>;
  callerTuneLoop?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCart = {
  addressRequirements: Scalars['String']['input'];
  basePrice?: InputMaybe<Scalars['String']['input']>;
  capabilities?: InputMaybe<InputTwilioCapability>;
  currentPrice?: InputMaybe<Scalars['String']['input']>;
  friendlyName: Scalars['String']['input'];
  isoCountry: Scalars['String']['input'];
  numberType: NumberTypeEnum;
  phoneNumber: Scalars['String']['input'];
  rateCenter?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type InputChangePassword = {
  previousPassword?: InputMaybe<Scalars['String']['input']>;
  proposedPassword?: InputMaybe<Scalars['String']['input']>;
};

export type InputChannel = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
};

export type InputChannelGroup = {
  name: Scalars['String']['input'];
};

export type InputChannelSetting = {
  autoTranscribe?: InputMaybe<Scalars['Boolean']['input']>;
  callerId?: InputMaybe<Scalars['Int']['input']>;
  channelId: Scalars['Int']['input'];
  enableVoiceMailEmail?: InputMaybe<Scalars['Boolean']['input']>;
  externalNumber?: InputMaybe<Scalars['String']['input']>;
  forwardToExternalNumber?: InputMaybe<Scalars['Boolean']['input']>;
  forwardToExternalNumberLoop?: InputMaybe<Scalars['Int']['input']>;
  forwardToExternalNumberPlayId?: InputMaybe<Scalars['Int']['input']>;
  forwardToExternalNumberSay?: InputMaybe<TwimlSayInput>;
  recording?: InputMaybe<Scalars['Boolean']['input']>;
  voicemail?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailLoop?: InputMaybe<Scalars['Int']['input']>;
  voicemailPlayId?: InputMaybe<Scalars['Int']['input']>;
  voicemailSay?: InputMaybe<TwimlSayInput>;
  welcomeMessage?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeMessageLoop?: InputMaybe<Scalars['Int']['input']>;
  welcomeMessagePlayId?: InputMaybe<Scalars['Int']['input']>;
  welcomeMessageSay?: InputMaybe<TwimlSayInput>;
};

export type InputChannelSettingAudioPrompt = {
  audioId?: InputMaybe<Scalars['Int']['input']>;
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  language?: InputMaybe<AudioPromptLanguageEnum>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AudioPromptTypeEnum>;
};

export type InputChannelSettingBusinessAfterHours = {
  route?: InputMaybe<AfterHourRouteEnum>;
  supportAfterHours?: InputMaybe<Scalars['Boolean']['input']>;
  targetPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  voicemailAudioPrompt?: InputMaybe<InputChannelSettingAudioPrompt>;
};

export type InputChannelSettingBusinessHour = {
  entries?: InputMaybe<Array<InputMaybe<InputBusinessHourEntry>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  timezoneId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputChannelSettingCallTransfer = {
  isActive: Scalars['Boolean']['input'];
  noAnswerPrompt?: InputMaybe<InputChannelSettingCallTransferAudioPrompt>;
  terminatedPrompt?: InputMaybe<InputChannelSettingCallTransferAudioPrompt>;
  transferPrompt?: InputMaybe<InputChannelSettingCallTransferAudioPrompt>;
};

export type InputChannelSettingCallTransferAudioPrompt = {
  audioId?: InputMaybe<Scalars['Int']['input']>;
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  language?: InputMaybe<AudioPromptLanguageEnum>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AudioPromptTypeEnum>;
  useDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputChannelSettingIvr = {
  greetingMessagePrompt: InputChannelSettingAudioPrompt;
  ifUnansweredPrompt: InputChannelSettingAudioPrompt;
  invalidPrompt: InputChannelSettingAudioPrompt;
  isActive: Scalars['Boolean']['input'];
  menuOptions: Array<InputMaybe<InputMenuOption>>;
};

export type InputChannelUserWorkspace = {
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputChatMessage = {
  body?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCollectClientInformation = {
  sessionId: Scalars['String']['input'];
};

export type InputCompletedConference = {
  sid: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type InputConfirmForgotPassword = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type InputConfirmSignupAndLogin = {
  confirmationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type InputContact = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type InputContactComplianceConsent = {
  campaignId: Scalars['Int']['input'];
  campaignType: ContactComplianceConsentCampaignTypeEnum;
  consentDetails?: InputMaybe<Scalars['String']['input']>;
  consentSource: ContactComplianceConsentSourceEnum;
  consentedAt?: InputMaybe<Scalars['Date']['input']>;
  contactIds: Array<Scalars['Int']['input']>;
  flowDetails: Scalars['String']['input'];
  isConsented: Scalars['Boolean']['input'];
};

export type InputContactNote = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type InputContactNoteInterface = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateBlockEmail = {
  email: Scalars['String']['input'];
  passcode: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type InputCreateBlockForwardedPhoneNumber = {
  passcode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  requestedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateBlockIpAddress = {
  ipAddress: Scalars['String']['input'];
  passcode: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type InputCreateBlockPhoneNumber = {
  passcode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type InputCreateBrand = {
  mock: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  verticalId: Scalars['Int']['input'];
};

export type InputCreateCampaign = {
  brandId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  hasEmbeddedLinks: Scalars['Boolean']['input'];
  hasEmbeddedPhone: Scalars['Boolean']['input'];
  helpKeywords: Array<InputMaybe<Scalars['String']['input']>>;
  helpMessage: Scalars['String']['input'];
  optInKeywords: Array<InputMaybe<Scalars['String']['input']>>;
  optInMessage: Scalars['String']['input'];
  optOutKeywords: Array<InputMaybe<Scalars['String']['input']>>;
  optOutMessage: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sampleMessage1: Scalars['String']['input'];
  sampleMessage2: Scalars['String']['input'];
  useCaseId: Scalars['Int']['input'];
  userConsent: Scalars['String']['input'];
};

export type InputCreateCustomerV2 = {
  accountType?: InputMaybe<WorkspaceDetailAccountTypeEnum>;
  address?: InputMaybe<InputAddress>;
  billingAddress?: InputMaybe<InputBillingAddress>;
  code?: InputMaybe<Scalars['String']['input']>;
  crmId?: InputMaybe<Scalars['Int']['input']>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  noOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  planId: Scalars['Int']['input'];
  socialUrl?: InputMaybe<Scalars['String']['input']>;
  useCaseIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type InputCreateDomain = {
  domainName: Scalars['String']['input'];
  passcode: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type InputCreatePayment = {
  amount: Scalars['Float']['input'];
  items?: InputMaybe<Array<PaymentRequestItem>>;
  purpose: PaymentRequestPurposeEnum;
  remarks?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type InputCreateSubscription = {
  code?: InputMaybe<Scalars['String']['input']>;
  gatewayAccountId: Scalars['String']['input'];
  gatewayToken?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: PaymentGatewayEnum;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['Int']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type InputCreateUser = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  passcode: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type InputDeletePromotion = {
  passcode: Scalars['String']['input'];
};

export type InputDeleteRequestRegulatoryCompliance = {
  passcode: Scalars['String']['input'];
  remarks: Scalars['String']['input'];
};

export type InputDraftMessageConversation = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  messageContent?: InputMaybe<Scalars['String']['input']>;
};

export type InputEmailAlerts = {
  enableMissedCallEmail?: InputMaybe<Scalars['Boolean']['input']>;
  smsMmsEmailAlertEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  transcriptionEmailAlertEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputEmailMfa = {
  enabled: Scalars['Boolean']['input'];
};

export type InputEnableOrDisableChannel = {
  key?: InputMaybe<KeyChannelEnum>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputEnabledTOTPMfa = {
  otpCode: Scalars['String']['input'];
};

export type InputEstimateUpgradeWorkspaceSubscription = {
  targetedPlanPriceId: Scalars['Int']['input'];
};

export type InputExclusiveNumbers = {
  countryId: Scalars['Int']['input'];
  numberType: NumberTypeEnum;
  sid: Scalars['String']['input'];
};

export type InputExtensionConfiguration = {
  applySearchExtend?: InputMaybe<Scalars['Boolean']['input']>;
  autoSearchNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  showLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputFederatedAuth = {
  clickId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  partnerKey?: InputMaybe<Scalars['String']['input']>;
  providerType: IdentityProviderEnum;
  requestId?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type InputForgotPassword = {
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export type InputForwardChatToEmail = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  receivers: Array<ForwardChatToEmailReceiver>;
  subject: Scalars['String']['input'];
};

export type InputFromDateToDate = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InputFromDateToDateUserId = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGetContactProfileForDialerScreen = {
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type InputHangUpConference = {
  terminateReason: Scalars['String']['input'];
};

export type InputIncomingPhoneDocumentNumber = {
  documents?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type InputIncomingPhoneStatusNumber = {
  status?: InputMaybe<IncomingPhoneNumberStatusEnum>;
};

export type InputIntegrationChannel = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  integrationUserId?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputIntegrationConfiguration = {
  integrationUserId?: InputMaybe<Scalars['Int']['input']>;
  syncCallDetails?: InputMaybe<Scalars['Boolean']['input']>;
  syncContacts?: InputMaybe<Scalars['Boolean']['input']>;
  syncMessage?: InputMaybe<Scalars['Boolean']['input']>;
  syncRecordings?: InputMaybe<Scalars['Boolean']['input']>;
  syncVoicemails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputIntegrationWebhook = {
  password?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type InputIvr = {
  greetingMessagePrompt: InputAudioPrompt;
  ifUnansweredPrompt: InputAudioPrompt;
  invalidPrompt: InputAudioPrompt;
  isActive: Scalars['Boolean']['input'];
  menuOptions: Array<InputMaybe<InputMenuOption>>;
};

export type InputKycDocumentMedia = {
  label?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputLowBalanceAlert = {
  balanceThreshold?: InputMaybe<Scalars['Int']['input']>;
  isEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputMarkAsActiveOrAway = {
  activeStatus?: InputMaybe<UserActiveStatusEnum>;
  awayTill?: InputMaybe<Scalars['Date']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type InputMarkAsCloseOrOpen = {
  markAsClosed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputMenuOption = {
  action?: InputMaybe<ConditionActionEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  ifUnansweredRedirectTo?: InputMaybe<ConditionUnanswerRedirectEnum>;
  input?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['IntOrArrayInt']['input']>;
};

export type InputMessageConversation = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  messageContent?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type InputMessageSchedule = {
  body?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  scheduleAt: Scalars['Date']['input'];
  to: Scalars['String']['input'];
};

export type InputMfaAuth = {
  challengeName: ChallengeNameEnum;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  remember: Scalars['Boolean']['input'];
  verificationCode: Scalars['String']['input'];
};

export type InputMissedCallEmail = {
  enableMissedCallEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputModule = {
  name: Scalars['String']['input'];
  screenId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputNotification = {
  body?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type InputNumberPurchaseStatus = {
  id: Scalars['Int']['input'];
  purchased?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputPaymentIntentV3 = {
  amount: Scalars['Int']['input'];
  currencyCode?: InputMaybe<PaymentIntentCurrencyCodeEnum>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  planPriceId?: InputMaybe<Scalars['Int']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type InputPin = {
  passCode?: InputMaybe<Scalars['String']['input']>;
};

export type InputPinOrUnpinChatMessage = {
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputPinUnpinMessageConversation = {
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputPinUnpinRecentMessageConversation = {
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputPlan = {
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

export type InputPlanPrice = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  periodicity?: InputMaybe<PeriodicityEnum>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type InputPowerCampaignCall = {
  powerCampaignQueueId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputPowerCampaignDispositionContact = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  powerCampaignDispositionId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputPowerCampaignInterface = {
  assignedType: PowerCampaignAssignedTypeEnum;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channelId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dispositionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxAttempts: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  postCallDuration: Scalars['Int']['input'];
  postCallDurationUnit: PowerCampaignCallDurationUnitEnum;
  previewDuration: Scalars['Int']['input'];
  previewDurationUnit: PowerCampaignCallDurationUnitEnum;
  receivers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  retryPeriod: Scalars['Int']['input'];
  retryPeriodUnit: PowerCampaignCallDurationUnitEnum;
};

export type InputPowerDispositionInterface = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputPrivilege = {
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type InputPromoCode = {
  affiliatorEmail: Scalars['String']['input'];
  affiliatorName: Scalars['String']['input'];
  billingCycle?: InputMaybe<CouponPeriodicityEnum>;
  codeLength?: InputMaybe<Scalars['Int']['input']>;
  couponType: CouponTypeEnum;
  customCodes?: InputMaybe<Scalars['String']['input']>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  discountType: CouponDiscountTypeEnum;
  expiryDate: Scalars['Date']['input'];
  introducerEmail?: InputMaybe<Scalars['String']['input']>;
  introducerName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberOfPromoCodes?: InputMaybe<Scalars['Int']['input']>;
  numberOfRedemptions?: InputMaybe<Scalars['Int']['input']>;
  origin: CouponOriginEnum;
  planPriceId?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  remarks: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  suffix?: InputMaybe<Scalars['String']['input']>;
  termDuration?: InputMaybe<Scalars['Int']['input']>;
  termLimit: CouponTermLimitEnum;
};

export type InputProviderErrorLog = {
  code?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  stackTrace?: InputMaybe<Scalars['String']['input']>;
};

export type InputProviderErrorLogData = {
  category?: InputMaybe<ProviderCategoryEnum>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<InputProviderErrorLog>;
};

export type InputPurchaseNumberCartItem = {
  basePrice?: InputMaybe<Scalars['String']['input']>;
  capabilities?: InputMaybe<InputTwilioCapability>;
  currentPrice?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  isoCountry?: InputMaybe<Scalars['String']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputPurchaseNumbers = {
  cartItems?: InputMaybe<Array<InputMaybe<InputPurchaseNumberCartItem>>>;
  replaceUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputPushCredentialToken = {
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PushCredentialTypeEnum>;
};

export type InputPushCredentialTokenStatus = {
  status?: InputMaybe<PushCredentialTokenStatusEnum>;
};

export type InputReassignPowerCampaignContacts = {
  currentAssignee?: InputMaybe<Scalars['Int']['input']>;
  newAssignee?: InputMaybe<Scalars['Int']['input']>;
};

export type InputRecordingAnnouncement = {
  audioPrompt?: InputMaybe<InputAudioPrompt>;
  recordingAnnouncementAfterBeep?: InputMaybe<Scalars['Boolean']['input']>;
  recordingAnnouncementMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputRefreshToken = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type InputRejectPaymentOrder = {
  paymentOrderId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputReleaseChannels = {
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  releaseInstantly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputReleasePaymentOrderLien = {
  failureReason?: InputMaybe<Scalars['String']['input']>;
  paymentOrderId: Scalars['Int']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type InputRenewFailedSubscriptionInterface = {
  subscriptionId: Scalars['String']['input'];
};

export type InputRequestRegulatoryCompliance = {
  address?: InputMaybe<InputAddress>;
  addressDocumentId?: InputMaybe<Scalars['Int']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  channelRequested?: InputMaybe<InputCart>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identityDocumentBackId?: InputMaybe<Scalars['Int']['input']>;
  identityDocumentId?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  personalLink?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  supportingDocumentTypeId?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<RegulatoryComplianceUseCaseEnum>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type InputResendInviteWorkspaceMember = {
  email: Scalars['String']['input'];
};

export type InputReview = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  sid: Scalars['String']['input'];
};

export type InputRole = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type InputRoom = {
  receiverId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputScreen = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type InputSendMessage = {
  body?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type InputSetChannelsInGroup = {
  assignedChannelIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  unAssignedChannelIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type InputSetDefaultCountry = {
  countryId: Scalars['Int']['input'];
};

export type InputSetUsageReportNotification = {
  enabled: Scalars['Boolean']['input'];
  frequency: UsageReportNotificationFrequencyEnum;
  localDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  localDayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  localMonthOfYear?: InputMaybe<Scalars['Int']['input']>;
  localSendAt: Scalars['String']['input'];
  localWeekOfMonth?: InputMaybe<Scalars['Int']['input']>;
  localWeekdayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  monthlyScheduleType?: InputMaybe<MonthlyScheduleTypeEnum>;
  timezoneValue: Scalars['String']['input'];
};

export type InputStatusRegulatoryCompliance = {
  action: RegulatoryComplianceStatusEnum;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputStrategy = {
  channelId: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  strategyId: Scalars['Int']['input'];
  strategySlug?: InputMaybe<Scalars['String']['input']>;
};

export type InputStrategyGroup = {
  channelId: Scalars['Int']['input'];
  strategies: Array<InputMaybe<InputStrategy>>;
  strategyGroupId: Scalars['Int']['input'];
};

export type InputSubaccount = {
  authToken: Scalars['String']['input'];
  sid: Scalars['String']['input'];
};

export type InputSuperviseConference = {
  mode?: InputMaybe<SupervisionModeEnum>;
};

export type InputSwitchCall = {
  destinationDevicePlatform: DevicePlatformEnum;
};

export type InputSwitchEmailMfa = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type InputTag = {
  color?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TagEnum>;
};

export type InputTeamMembers = {
  status: StatusEnum;
  userId: Scalars['Int']['input'];
};

export type InputTeamMembersInterface = {
  status: StatusEnum;
  teamId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type InputTemplateNotification = {
  body: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isExternal: Scalars['Boolean']['input'];
  locale?: InputMaybe<LocaleEnum>;
  redirectUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: NotificationTypeEnum;
};

export type InputTimeout = {
  timeout: Scalars['Int']['input'];
};

export type InputToggleChannelNotification = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputToggleMissedCallEmailNotification = {
  enableMissedCallEmail: Scalars['Boolean']['input'];
};

export type InputTranscriptionInformation = {
  providerCallRecordingsId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputTransferPhoneNumber = {
  addressSid?: InputMaybe<Scalars['String']['input']>;
  bundleSid?: InputMaybe<Scalars['String']['input']>;
  destinationAccountSid: Scalars['String']['input'];
  enteredPasscode: Scalars['String']['input'];
  originationAccountSid: Scalars['String']['input'];
};

export type InputTwilioCapability = {
  MMS?: InputMaybe<Scalars['Boolean']['input']>;
  SMS?: InputMaybe<Scalars['Boolean']['input']>;
  voice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUnAssignChannelMember = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUnSuperviseConference = {
  callSid?: InputMaybe<Scalars['String']['input']>;
  superviseId: Scalars['String']['input'];
};

export type InputUpdateAdminUser = {
  role: Scalars['String']['input'];
};

export type InputUpdateBillingDiscount = {
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  discountPrice?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountTypeEnum>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateBlockEmail = {
  email?: InputMaybe<Scalars['String']['input']>;
  passcode: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateBlockForwardedPhoneNumber = {
  passcode: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateBlockIpAddress = {
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  passcode: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateBlockPhoneNumber = {
  passcode: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateDomain = {
  domainName?: InputMaybe<Scalars['String']['input']>;
  passcode: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateIntegrationWebhook = {
  id?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdatePromoCode = {
  status: PromotionStatusEnum;
};

export type InputUpdatePromotion = {
  affiliatorEmail?: InputMaybe<Scalars['String']['input']>;
  affiliatorName?: InputMaybe<Scalars['String']['input']>;
  disabledReason?: InputMaybe<Scalars['String']['input']>;
  introducerEmail?: InputMaybe<Scalars['String']['input']>;
  introducerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PromotionStatusEnum>;
};

export type InputUpdateTemplateNotification = {
  body: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: NotificationTypeEnum;
};

export type InputUpdateVerifyCallerId = {
  friendlyName: Scalars['String']['input'];
};

export type InputUpdateWorkspace = {
  coverProfileId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['Int']['input']>;
  timezoneId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUser = {
  coverProfilePictureId?: InputMaybe<Scalars['Int']['input']>;
  currentWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<InputMaybe<RoleEnum>>>;
};

export type InputUserId = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUserWorkspaceFCMToken = {
  platform: NotificationPlatformEnum;
  token: Scalars['String']['input'];
};

export type InputVerifyCallerId = {
  extension?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  sendVerificationCodeVia?: InputMaybe<SendVerificationCodeViaEnum>;
};

export type InputVerifyInvitationToken = {
  token: Scalars['String']['input'];
};

export type InputVerifyPromoCode = {
  code: Scalars['String']['input'];
  planPriceId: Scalars['Int']['input'];
};

export type InputVerifyTwoFactorAuthentication = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  remember?: InputMaybe<Scalars['Boolean']['input']>;
  verificationCode: Scalars['String']['input'];
};

export type InputWorkspaceDetail = {
  accountType?: InputMaybe<WorkspaceDetailAccountTypeEnum>;
  address?: InputMaybe<InputAddress>;
  crmId?: InputMaybe<Scalars['Int']['input']>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  noOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  planPriceId?: InputMaybe<Scalars['Int']['input']>;
  socialUrl?: InputMaybe<Scalars['String']['input']>;
  useCaseIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type InputWorkspaceDetailDocuments = {
  documentIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type InputWorkspaceLogin = {
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputWorkspacePreferredContactMethod = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messagingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messagingNumber?: InputMaybe<Scalars['String']['input']>;
  messagingType?: InputMaybe<ContactMessagingTypeEnum>;
  phoneCallEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phoneCallNumber?: InputMaybe<Scalars['String']['input']>;
  prefEndTime: Scalars['String']['input'];
  prefStartTime: Scalars['String']['input'];
};

export type InputWorkspaceStatus = {
  status?: InputMaybe<WorkspaceStatusEnum>;
};

export type Inputkyc = {
  address?: InputMaybe<InputAddress>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  kycDocument?: InputMaybe<InputkycDocument>;
  kycDocumentMedia?: InputMaybe<Array<InputMaybe<InputKycDocumentMedia>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  pictureId?: InputMaybe<Scalars['Int']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type InputkycDocument = {
  documentTypeId?: InputMaybe<Scalars['Int']['input']>;
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  issuedDate?: InputMaybe<Scalars['Date']['input']>;
  issuedFrom?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type Integration = {
  __typename?: 'Integration';
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  integrationUser?: Maybe<IntegrationUser>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IntegrationChannel = {
  __typename?: 'IntegrationChannel';
  id?: Maybe<Scalars['Int']['output']>;
  integrationUserId?: Maybe<Scalars['Int']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type IntegrationChannelEdge = {
  __typename?: 'IntegrationChannelEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Channel>;
};

export type IntegrationChannelResponse = {
  __typename?: 'IntegrationChannelResponse';
  data?: Maybe<IntegrationChannel>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IntegrationChannelV2 = {
  __typename?: 'IntegrationChannelV2';
  country?: Maybe<Country>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  integrationChannels?: Maybe<IntegrationChannel>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type IntegrationConfiguration = {
  __typename?: 'IntegrationConfiguration';
  createdBy?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  integrationUserId?: Maybe<Scalars['Int']['output']>;
  syncCallDetails?: Maybe<Scalars['Boolean']['output']>;
  syncContacts?: Maybe<Scalars['Boolean']['output']>;
  syncMessage?: Maybe<Scalars['Boolean']['output']>;
  syncRecordings?: Maybe<Scalars['Boolean']['output']>;
  syncVoicemails?: Maybe<Scalars['Boolean']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type IntegrationConfigurationResponse = {
  __typename?: 'IntegrationConfigurationResponse';
  data?: Maybe<IntegrationConfiguration>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IntegrationCountResponse = {
  __typename?: 'IntegrationCountResponse';
  data?: Maybe<Array<Maybe<Metrics>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IntegrationEdge = {
  __typename?: 'IntegrationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Integration>;
};

export type IntegrationRequest = {
  __typename?: 'IntegrationRequest';
  appName: Scalars['String']['output'];
  appWebsite: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  remarks: Scalars['String']['output'];
  requestedAt: Scalars['Date']['output'];
  requestedBy?: Maybe<User>;
  workspace?: Maybe<Workspace>;
};

export type IntegrationRequestResponse = {
  __typename?: 'IntegrationRequestResponse';
  data?: Maybe<IntegrationRequest>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IntegrationResponse = {
  __typename?: 'IntegrationResponse';
  data?: Maybe<Integration>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationStatusEnum {
  active = 'active',
  inactive = 'inactive',
}

export type IntegrationUser = {
  __typename?: 'IntegrationUser';
  id?: Maybe<Scalars['Int']['output']>;
  integration?: Maybe<Integration>;
  status?: Maybe<IntegrationUserStatusEnum>;
};

export type IntegrationUserEdge = {
  __typename?: 'IntegrationUserEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<IntegrationUser>;
};

export enum IntegrationUserStatusEnum {
  active = 'active',
  in_progress = 'in_progress',
  inactive = 'inactive',
}

export type IntegrationWebhook = {
  __typename?: 'IntegrationWebhook';
  id?: Maybe<Scalars['Int']['output']>;
  integrationUserId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<IntegrationWebhookLabelEnum>;
  password?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationWebhookLabelEnum {
  call_details = 'call_details',
}

export type IntegrationWebhookResponse = {
  __typename?: 'IntegrationWebhookResponse';
  data?: Maybe<Array<Maybe<IntegrationWebhook>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  billingCycleDate?: Maybe<Scalars['Date']['output']>;
  creditsApplied?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceItems?: Maybe<Array<Maybe<InvoiceItem>>>;
  invoiceNo?: Maybe<Scalars['String']['output']>;
  paymentMode?: Maybe<Card>;
  refund?: Maybe<Array<Maybe<Refund>>>;
  status?: Maybe<InvoiceStatusEnum>;
  subTotalAmount?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
  totalRefundedAmount?: Maybe<Scalars['Int']['output']>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Invoice>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Country>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceId?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  numberType?: Maybe<NumberTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type InvoiceResponse = {
  __typename?: 'InvoiceResponse';
  data?: Maybe<Invoice>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceStatusEnum {
  not_paid = 'not_paid',
  paid = 'paid',
  payment_due = 'payment_due',
  pending = 'pending',
  posted = 'posted',
  voided = 'voided',
}

export type InvoicesResponse = {
  __typename?: 'InvoicesResponse';
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type IpAddressInfo = {
  __typename?: 'IpAddressInfo';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type IpAddressInfoResponse = {
  __typename?: 'IpAddressInfoResponse';
  data?: Maybe<IpAddressInfo>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IvrCursorPagination = {
  __typename?: 'IvrCursorPagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<CallIvrCondition>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IvrResponse = {
  __typename?: 'IvrResponse';
  data?: Maybe<IvrType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IvrResponseType = {
  __typename?: 'IvrResponseType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type IvrType = {
  __typename?: 'IvrType';
  id?: Maybe<Scalars['Int']['output']>;
  ifUnansweredPrompt?: Maybe<AudioPrompt>;
  invalidPrompt?: Maybe<AudioPrompt>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  startPrompt?: Maybe<AudioPrompt>;
};

export enum JobStatusEnum {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  QUEUED = 'QUEUED',
}

export enum KeyChannelEnum {
  recording = 'recording',
  voicemail = 'voicemail',
}

export type KpiAnswerRate = {
  __typename?: 'KpiAnswerRate';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<KpiAnswerRateValue>;
};

export type KpiAnswerRateValue = {
  __typename?: 'KpiAnswerRateValue';
  answerRate?: Maybe<Scalars['Float']['output']>;
  changePercent?: Maybe<Scalars['Float']['output']>;
  currentAnsweredCall?: Maybe<Scalars['Int']['output']>;
  currentTotalInbound?: Maybe<Scalars['Int']['output']>;
  previousAnsweredCall?: Maybe<Scalars['Int']['output']>;
  previousTotalInbound?: Maybe<Scalars['Int']['output']>;
};

export type KpiAverageAnswerTime = {
  __typename?: 'KpiAverageAnswerTime';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<KpiAverageAnswerTimeValue>;
};

export type KpiAverageAnswerTimeValue = {
  __typename?: 'KpiAverageAnswerTimeValue';
  changePercent?: Maybe<Scalars['Float']['output']>;
  currentAverageAns?: Maybe<Scalars['String']['output']>;
  previousAverageAns?: Maybe<Scalars['String']['output']>;
};

export type KpiCall = {
  __typename?: 'KpiCall';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<KpiCallValue>;
};

export type KpiCallValue = {
  __typename?: 'KpiCallValue';
  currentInboundCall?: Maybe<Scalars['Int']['output']>;
  currentOutboundCall?: Maybe<Scalars['Int']['output']>;
  inboundCallChangePercent?: Maybe<Scalars['Float']['output']>;
  outboundCallChangePercent?: Maybe<Scalars['Float']['output']>;
  previousInboundCall?: Maybe<Scalars['Int']['output']>;
  previousOutboundCall?: Maybe<Scalars['Int']['output']>;
};

export type KpiClosedConversation = {
  __typename?: 'KpiClosedConversation';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<KpiClosedConversationValue>;
};

export type KpiClosedConversationValue = {
  __typename?: 'KpiClosedConversationValue';
  changePercent?: Maybe<Scalars['Float']['output']>;
  currentClosedConversation?: Maybe<Scalars['Int']['output']>;
  previousClosedConversation?: Maybe<Scalars['Int']['output']>;
};

export type KpiItem = {
  __typename?: 'KpiItem';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<Scalars['kpiItemValue']['output']>;
  widgetId?: Maybe<Scalars['Int']['output']>;
};

export type KpiKeyItem = {
  __typename?: 'KpiKeyItem';
  answerRate?: Maybe<Scalars['String']['output']>;
  averageAnswerTime?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  missedCalls?: Maybe<Scalars['String']['output']>;
  recordingCoverage?: Maybe<Scalars['String']['output']>;
  totalCalls?: Maybe<Scalars['String']['output']>;
  transcriptionCoverage?: Maybe<Scalars['String']['output']>;
};

export type KpiKeysRes = {
  __typename?: 'KpiKeysRes';
  data?: Maybe<KpiKeyItem>;
  message?: Maybe<Scalars['String']['output']>;
};

export type KpiLiveCall = {
  __typename?: 'KpiLiveCall';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<KpiLiveCallValue>;
};

export type KpiLiveCallValue = {
  __typename?: 'KpiLiveCallValue';
  liveCallCount?: Maybe<Scalars['Int']['output']>;
  peakCount?: Maybe<Scalars['Int']['output']>;
};

export type KpiMessage = {
  __typename?: 'KpiMessage';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<KpiMessageValue>;
};

export type KpiMessageValue = {
  __typename?: 'KpiMessageValue';
  currentInboundMess?: Maybe<Scalars['Int']['output']>;
  currentOutboundMess?: Maybe<Scalars['Int']['output']>;
  inboundMessChangePercent?: Maybe<Scalars['Float']['output']>;
  outboundMessChangePercent?: Maybe<Scalars['Float']['output']>;
  previousInboundMess?: Maybe<Scalars['Int']['output']>;
  previousOutboundMess?: Maybe<Scalars['Int']['output']>;
};

export type KpiMissedCall = {
  __typename?: 'KpiMissedCall';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<KpiMissedCallValue>;
};

export type KpiMissedCallValue = {
  __typename?: 'KpiMissedCallValue';
  changePercent?: Maybe<Scalars['Float']['output']>;
  currentMissedCallValue?: Maybe<Scalars['Int']['output']>;
  percentOfInbound?: Maybe<Scalars['Float']['output']>;
  previousMissedCallValue?: Maybe<Scalars['Int']['output']>;
};

export type KpiOpenConversation = {
  __typename?: 'KpiOpenConversation';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<KpiWidgetSlugEnum>;
  value?: Maybe<KpiOpenConversationValue>;
};

export type KpiOpenConversationValue = {
  __typename?: 'KpiOpenConversationValue';
  changePercent?: Maybe<Scalars['Float']['output']>;
  currentOpenConversation?: Maybe<Scalars['Int']['output']>;
  previousOpenConversation?: Maybe<Scalars['Int']['output']>;
};

export enum KpiWidgetSlugEnum {
  AnswerRate = 'AnswerRate',
  AverageAnswerTime = 'AverageAnswerTime',
  ClosedConversation = 'ClosedConversation',
  LiveCall = 'LiveCall',
  MissedCall = 'MissedCall',
  OpenedConversation = 'OpenedConversation',
  TotalCall = 'TotalCall',
  TotalMessage = 'TotalMessage',
}

export type KpisCombined = {
  __typename?: 'KpisCombined';
  answerRate?: Maybe<KpiAnswerRate>;
  averageAnswerTime?: Maybe<KpiAverageAnswerTime>;
  closedConversation?: Maybe<KpiClosedConversation>;
  liveCall?: Maybe<KpiLiveCall>;
  missedCall?: Maybe<KpiMissedCall>;
  openedConversation?: Maybe<KpiOpenConversation>;
  totalCall?: Maybe<KpiCall>;
  totalMessage?: Maybe<KpiMessage>;
};

export type KpisCombinedRes = {
  __typename?: 'KpisCombinedRes';
  data?: Maybe<KpisCombined>;
  message?: Maybe<Scalars['String']['output']>;
};

export type KycResponse = {
  __typename?: 'KycResponse';
  data?: Maybe<kyc>;
  message?: Maybe<Scalars['String']['output']>;
};

export type KycVerificationSession = {
  __typename?: 'KycVerificationSession';
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sessionExpiry?: Maybe<Scalars['Date']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  sessionUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<KycVerificationSessionsStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vendorData?: Maybe<Scalars['String']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type KycVerificationSessionResponse = {
  __typename?: 'KycVerificationSessionResponse';
  data?: Maybe<KycVerificationSession>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum KycVerificationSessionsStatus {
  abandoned = 'abandoned',
  approved = 'approved',
  declined = 'declined',
  expired = 'expired',
  in_progress = 'in_progress',
  in_review = 'in_review',
  kyc_expired = 'kyc_expired',
  not_started = 'not_started',
  resubmitted = 'resubmitted',
}

export type LastMonthInstance = {
  __typename?: 'LastMonthInstance';
  category?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['String']['output']>;
  countUnit?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceUnit?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  usageUnit?: Maybe<Scalars['String']['output']>;
};

export type LastUserSession = {
  __typename?: 'LastUserSession';
  authType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type ListActiveChannelStrategies = {
  __typename?: 'ListActiveChannelStrategies';
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ListAllStrategiesByGroup = {
  __typename?: 'ListAllStrategiesByGroup';
  data?: Maybe<Array<Maybe<AllStrategiesByGroup>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ListPinnedChatMessages = {
  __typename?: 'ListPinnedChatMessages';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cursor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<UserWorkspace>;
};

export type ListPinnedChatMessagesResponse = {
  __typename?: 'ListPinnedChatMessagesResponse';
  data?: Maybe<Array<Maybe<ListPinnedChatMessages>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ListPinnedMessageConversations = {
  __typename?: 'ListPinnedMessageConversations';
  agent?: Maybe<UserWorkspace>;
  callRecording?: Maybe<Recording>;
  channel?: Maybe<Channel>;
  client?: Maybe<Contact>;
  conversationStatus?: Maybe<Scalars['String']['output']>;
  conversationType?: Maybe<MessageConversationTypeEnum>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cursor?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<DirectionTypeEnum>;
  effectiveEndedAt?: Maybe<Scalars['Date']['output']>;
  effectiveStartedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  markAsClosed?: Maybe<Scalars['Boolean']['output']>;
  messageContent?: Maybe<Scalars['String']['output']>;
  numMedia?: Maybe<Scalars['Int']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  recording?: Maybe<Array<Maybe<Recording>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  voicemailRecording?: Maybe<Recording>;
};

export type ListPinnedMessageConversationsResponse = {
  __typename?: 'ListPinnedMessageConversationsResponse';
  data?: Maybe<Array<Maybe<ListPinnedMessageConversations>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ListPlanItemPriceInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFamilyType?: InputMaybe<Scalars['String']['input']>;
};

export type ListStrategyResult = {
  __typename?: 'ListStrategyResult';
  data?: Maybe<Array<Maybe<ChannelStrategy>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type LiveConference = {
  __typename?: 'LiveConference';
  agent?: Maybe<UserWorkspace>;
  channel?: Maybe<Channel>;
  client?: Maybe<Contact>;
  conversationStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  durationConference?: Maybe<Duration>;
  forwardedAt?: Maybe<Scalars['Date']['output']>;
  forwardedToId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  supervisionId?: Maybe<Scalars['String']['output']>;
  supervisionMode?: Maybe<SupervisionModeEnum>;
};

export type LiveConferenceCount = {
  __typename?: 'LiveConferenceCount';
  count?: Maybe<Scalars['Int']['output']>;
};

export type LiveConferenceDuration = {
  __typename?: 'LiveConferenceDuration';
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type LiveConferenceEdge = {
  __typename?: 'LiveConferenceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<LiveConference>;
};

export type LiveConferenceV2Data = {
  __typename?: 'LiveConferenceV2Data';
  agent?: Maybe<UserWorkspace>;
  channel?: Maybe<Channel>;
  client?: Maybe<Contact>;
  conversationStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  durationConference?: Maybe<LiveConferenceDuration>;
  id?: Maybe<Scalars['Int']['output']>;
  supervisionId?: Maybe<Scalars['String']['output']>;
  supervisionMode?: Maybe<SupervisionModeEnum>;
};

export type LiveConferencesV2CursorResponse = {
  __typename?: 'LiveConferencesV2CursorResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<LiveConferenceV2Data>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type LoadWalletInput = {
  amount: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  gatewayAccountId: Scalars['String']['input'];
  gatewayToken?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: PaymentGatewayEnum;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type LoadWalletIntentInput = {
  amount: Scalars['Int']['input'];
  referenceId: Scalars['String']['input'];
};

export enum LocaleEnum {
  de = 'de',
  en = 'en',
  es = 'es',
  fr = 'fr',
  pt = 'pt',
  sl = 'sl',
}

export type LogOAuthAuthorizationErrorInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  errorDescription?: InputMaybe<Scalars['String']['input']>;
  errorURI?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  thirdPartyName: Scalars['String']['input'];
};

export type Login = {
  __typename?: 'Login';
  data?: Maybe<UserToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type LoginToken = {
  __typename?: 'LoginToken';
  access?: Maybe<Scalars['String']['output']>;
  accessTokenExpiresAt?: Maybe<Scalars['Date']['output']>;
  accessTokenIssuedAt?: Maybe<Scalars['Date']['output']>;
  refresh?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Date']['output']>;
  refreshTokenIssuedAt?: Maybe<Scalars['Date']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type LowBalanceAlert = {
  __typename?: 'LowBalanceAlert';
  balanceThreshold?: Maybe<Scalars['Int']['output']>;
  isEmail?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkAsCloseOrOpenCount = {
  __typename?: 'MarkAsCloseOrOpenCount';
  closeCount?: Maybe<Scalars['Int']['output']>;
  openCount?: Maybe<Scalars['Int']['output']>;
};

export type MarkAsCloseOrOpenCountData = {
  __typename?: 'MarkAsCloseOrOpenCountData';
  data?: Maybe<MarkAsCloseOrOpenCount>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Media = {
  __typename?: 'Media';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  originalname?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Member = {
  __typename?: 'Member';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
};

export type MemberAnalytic = {
  __typename?: 'MemberAnalytic';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Media>;
};

export type MemberAnalyticsReportCursorPaginationResponse = {
  __typename?: 'MemberAnalyticsReportCursorPaginationResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<MemberAnalyticsReportData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MemberAnalyticsReportData = {
  __typename?: 'MemberAnalyticsReportData';
  averageCallDuration?: Maybe<Scalars['String']['output']>;
  channels?: Maybe<Array<Maybe<Channel>>>;
  id?: Maybe<Scalars['Int']['output']>;
  inbound?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  missed?: Maybe<Scalars['Int']['output']>;
  outbound?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
  totalCallDuration?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type MemberDashboardReportAnalytics = {
  __typename?: 'MemberDashboardReportAnalytics';
  averageCallDuration?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Array<Maybe<Channel>>>;
  id?: Maybe<Scalars['Int']['output']>;
  inbound?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  missed?: Maybe<Scalars['Int']['output']>;
  outbound?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
  totalCallDuration?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Member>;
};

export type MemberDashboardReportAnalyticsResponse = {
  __typename?: 'MemberDashboardReportAnalyticsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<MemberDashboardReportAnalytics>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MemberLeaderBoardItem = {
  __typename?: 'MemberLeaderBoardItem';
  callFlowId?: Maybe<Scalars['Int']['output']>;
  callFlowName?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalCalls?: Maybe<Scalars['Int']['output']>;
  totalMessages?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userMediaUrl?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type MemberSubscription = {
  __typename?: 'MemberSubscription';
  discounts?: Maybe<Array<Maybe<BillingSubscriptionDiscount>>>;
  id?: Maybe<Scalars['Int']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<BillingSubscriptionPlan>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type MemberSubscriptionDiscountData = {
  __typename?: 'MemberSubscriptionDiscountData';
  percent?: Maybe<Scalars['Float']['output']>;
};

export type MemberSubscriptionOverview = {
  __typename?: 'MemberSubscriptionOverview';
  discount?: Maybe<MemberSubscriptionDiscountData>;
  id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<MemberSubscriptionPlanData>;
  promo?: Maybe<MemberSubscriptionPromoData>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type MemberSubscriptionOverviewResponse = {
  __typename?: 'MemberSubscriptionOverviewResponse';
  data?: Maybe<MemberSubscriptionOverview>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MemberSubscriptionPlanData = {
  __typename?: 'MemberSubscriptionPlanData';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  periodicity?: Maybe<Scalars['String']['output']>;
};

export type MemberSubscriptionPromoData = {
  __typename?: 'MemberSubscriptionPromoData';
  label?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type MemberSubscriptionResponse = {
  __typename?: 'MemberSubscriptionResponse';
  data?: Maybe<BillingSubscription>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MembersAssignedToChannel = {
  __typename?: 'MembersAssignedToChannel';
  identity?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userOnlineManagement?: Maybe<UserOnlineManagement>;
};

export type MembersNotAuthorized = {
  __typename?: 'MembersNotAuthorized';
  id?: Maybe<Scalars['Int']['output']>;
  memberName?: Maybe<Scalars['String']['output']>;
};

export type Message = {
  __typename?: 'Message';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageConversation?: Maybe<CallThread>;
  room?: Maybe<Room>;
  sender?: Maybe<UserWorkspace>;
  type?: Maybe<MessageTypeEnum>;
};

export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MessageConversation = {
  __typename?: 'MessageConversation';
  agent?: Maybe<UserWorkspace>;
  callRecording?: Maybe<Recording>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['Int']['output']>;
  client?: Maybe<Contact>;
  conversationStatus?: Maybe<Scalars['String']['output']>;
  conversationType?: Maybe<MessageConversationTypeEnum>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  direction?: Maybe<DirectionTypeEnum>;
  durationConference?: Maybe<DurationConference>;
  effectiveEndedAt?: Maybe<Scalars['Date']['output']>;
  effectiveStartedAt?: Maybe<Scalars['Date']['output']>;
  forwardedAt?: Maybe<Scalars['Date']['output']>;
  forwardedTo?: Maybe<ForwardToExternalNumber>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  markAsBlocked?: Maybe<Scalars['Boolean']['output']>;
  markAsClosed?: Maybe<Scalars['Boolean']['output']>;
  messageContent?: Maybe<Scalars['String']['output']>;
  messageConversationErrorLog?: Maybe<MessageConversationErrorLog>;
  numMedia?: Maybe<Scalars['Int']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  recording?: Maybe<Array<Maybe<Recording>>>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  voicemailRecording?: Maybe<Recording>;
  voicemailRecordingUrl?: Maybe<Scalars['String']['output']>;
};

export type MessageConversationCount = {
  __typename?: 'MessageConversationCount';
  count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MessageConversationCursorPaginationV2 = {
  __typename?: 'MessageConversationCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<MessageConversation>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MessageConversationEdge = {
  __typename?: 'MessageConversationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  node?: Maybe<MessageConversation>;
};

export type MessageConversationErrorLog = {
  __typename?: 'MessageConversationErrorLog';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageConversation?: Maybe<MessageConversation>;
  statusCode?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type MessageConversationMedia = {
  __typename?: 'MessageConversationMedia';
  id?: Maybe<Scalars['Int']['output']>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Media>;
  messageConversationId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type MessageConversationSearch = {
  __typename?: 'MessageConversationSearch';
  cursor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export enum MessageConversationTypeEnum {
  conference = 'conference',
  internal_message = 'internal_message',
  message = 'message',
}

export type MessageConversationUnreadData = {
  __typename?: 'MessageConversationUnreadData';
  oldestUnreadMessageCursor?: Maybe<Scalars['String']['output']>;
};

export type MessageCount = {
  __typename?: 'MessageCount';
  received?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Message>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type MessageSchedule = {
  __typename?: 'MessageSchedule';
  attachments?: Maybe<Array<Maybe<Media>>>;
  channel: Channel;
  client: Contact;
  createdAt: Scalars['Date']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  messageContent?: Maybe<Scalars['String']['output']>;
  recentMessageConversation?: Maybe<RecentMessageConversation>;
  scheduleAt: Scalars['Date']['output'];
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<MessageScheduleStatusEnum>;
};

export type MessageScheduleCount = {
  __typename?: 'MessageScheduleCount';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  scheduleAt?: Maybe<Scalars['Date']['output']>;
};

export type MessageScheduleCountData = {
  __typename?: 'MessageScheduleCountData';
  data?: Maybe<MessageScheduleCount>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MessageSchedulePagination = {
  __typename?: 'MessageSchedulePagination';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<MessageSchedule>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum MessageScheduleStatusEnum {
  canceled = 'canceled',
  completed = 'completed',
  failed = 'failed',
  scheduled = 'scheduled',
}

export enum MessageTypeEnum {
  conference = 'conference',
  message = 'message',
}

export enum MetricEnum {
  load_wallet = 'load_wallet',
}

export type Metrics = {
  __typename?: 'Metrics';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type MfaStatusToken = {
  __typename?: 'MfaStatusToken';
  status?: Maybe<Scalars['String']['output']>;
};

export type MfaSwitchEmail = {
  __typename?: 'MfaSwitchEmail';
  challengeName?: Maybe<Scalars['String']['output']>;
};

export type MfaToken = {
  __typename?: 'MfaToken';
  otpAuthUri?: Maybe<Scalars['String']['output']>;
};

export type Module = {
  __typename?: 'Module';
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  privileges?: Maybe<Array<Maybe<Privilege>>>;
  screen?: Maybe<Screen>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type ModuleEdge = {
  __typename?: 'ModuleEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Module>;
};

export enum MonthlyScheduleTypeEnum {
  day_of_month = 'day_of_month',
  weekday_of_month = 'weekday_of_month',
}

export type MultipleAdminProviderLastMonthUsage = {
  __typename?: 'MultipleAdminProviderLastMonthUsage';
  data?: Maybe<Array<Maybe<LastMonthInstance>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleAttribute = {
  __typename?: 'MultipleAttribute';
  data?: Maybe<Array<Maybe<Attribute>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleAttributeValue = {
  __typename?: 'MultipleAttributeValue';
  data?: Maybe<Array<Maybe<AttributeValue>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleCart = {
  __typename?: 'MultipleCart';
  data?: Maybe<Array<Maybe<TwilioPhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleContactTags = {
  __typename?: 'MultipleContactTags';
  data?: Maybe<ContactTagsData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleMessageAttachment = {
  __typename?: 'MultipleMessageAttachment';
  data?: Maybe<Array<Maybe<MessageAttachment>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleProviderPhoneNumberPricing = {
  __typename?: 'MultipleProviderPhoneNumberPricing';
  edges?: Maybe<Array<Maybe<ProviderPhoneNumberPricing>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleRecentMessageConversation = {
  __typename?: 'MultipleRecentMessageConversation';
  edges?: Maybe<Array<Maybe<PinnedRecentMessageConversationNode>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type MultipleScreenPlanMappings = {
  __typename?: 'MultipleScreenPlanMappings';
  edges?: Maybe<Array<Maybe<ScreenPlanMapping>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleScreenRoleMappings = {
  __typename?: 'MultipleScreenRoleMappings';
  edges?: Maybe<Array<Maybe<ScreenRoleMapping>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleScreens = {
  __typename?: 'MultipleScreens';
  edges?: Maybe<Array<Maybe<Screen>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleTags = {
  __typename?: 'MultipleTags';
  data?: Maybe<Array<Maybe<Tag>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleWorkspace = {
  __typename?: 'MultipleWorkspace';
  edges?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleWorkspaceDetail = {
  __typename?: 'MultipleWorkspaceDetail';
  data?: Maybe<Array<Maybe<WorkspaceDetail>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleWorkspaceRateLimit = {
  __typename?: 'MultipleWorkspaceRateLimit';
  data?: Maybe<Array<Maybe<WorkspaceRateLimit>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MultipleWorkspaceRateLimitExhaust = {
  __typename?: 'MultipleWorkspaceRateLimitExhaust';
  data?: Maybe<Array<Maybe<WorkspaceRateLimitExhaust>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitedWorkspaceMember?: Maybe<Message>;
  addTeamMember?: Maybe<addTeamsMembersResponse>;
  addToCart?: Maybe<Message>;
  adminAddSalesDeal?: Maybe<Message>;
  adminAddToCart?: Maybe<Message>;
  adminAuthMe?: Maybe<SingleUser>;
  adminAutoRecoverNumberPurchase?: Maybe<MessageResponse>;
  adminBlockOrUnblockWorkspace?: Maybe<Message>;
  adminCancelNumberPurchase?: Maybe<Message>;
  adminCancelPaymentOrder?: Maybe<PaymentOrderResponse>;
  adminChangePassword?: Maybe<Message>;
  adminChangeWorkspaceStatus?: Maybe<SingleWorkspace>;
  adminCloseWorkspace?: Maybe<Message>;
  adminCollectPayment?: Maybe<Message>;
  adminConfigureA2pCompliance?: Maybe<SingleChannel>;
  adminConfigureExclusiveNumbers?: Maybe<Message>;
  adminCreateBillingDiscount?: Maybe<Message>;
  adminCreateBlockDomain?: Maybe<Message>;
  adminCreateBlockForwardedPhoneNumber?: Maybe<Message>;
  adminCreateBlockIpAddress?: Maybe<Message>;
  adminCreateBlockPhoneNumber?: Maybe<Message>;
  adminCreateBlockedSignupEmail?: Maybe<Message>;
  adminCreateConfiguration?: Maybe<Message>;
  adminCreateCustomPaymentOrder?: Maybe<PaymentOrderResponse>;
  adminCreateCustomPlan?: Maybe<AdminCreateCustomPlanResponse>;
  adminCreateCustomers?: Maybe<CommonResponse>;
  adminCreateKYC?: Maybe<KycResponse>;
  adminCreateModule?: Maybe<SingleModule>;
  adminCreateNotificationTemplate?: Maybe<CreateNotificationTemplateResponse>;
  adminCreateOrUpdateEmailTemplateSegment?: Maybe<SingleEmailTemplateSegmentResponse>;
  adminCreatePaymentIntent?: Maybe<ChargeBeePaymentIntentResponse>;
  adminCreatePaymentRequest?: Maybe<CreatePaymentRequest>;
  adminCreatePlan?: Maybe<SinglePlan>;
  adminCreatePrivilege?: Maybe<SinglePrivilege>;
  adminCreatePromoCode?: Maybe<Message>;
  adminCreateRole?: Maybe<SingleRole>;
  adminCreateScreen?: Maybe<SingleScreen>;
  adminCreateUser?: Maybe<SingleUser>;
  adminDeleteBlockedDomain?: Maybe<Message>;
  adminDeleteBlockedForwardedPhoneNumber?: Maybe<Message>;
  adminDeleteBlockedIpAddress?: Maybe<Message>;
  adminDeleteBlockedPhoneNumber?: Maybe<Message>;
  adminDeleteBlockedSignUpEmail?: Maybe<Message>;
  adminDeleteCustomPlan?: Maybe<Message>;
  adminDeleteNotificationTemplate?: Maybe<Message>;
  adminDeletePromoCode?: Maybe<Message>;
  adminDeletePromotion?: Maybe<Message>;
  adminDeleteRequestRegulatoryCompliance?: Maybe<Message>;
  adminDeleteRole?: Maybe<SingleRole>;
  adminDeleteWorkspaceMember?: Maybe<Message>;
  adminEnableOrDisableUser?: Maybe<Message>;
  adminGlobalSignOut?: Maybe<Message>;
  adminLoadWallet?: Maybe<WalletResponse>;
  adminPortAwayNumber?: Maybe<MessageResponse>;
  adminRefundPayment?: Maybe<Message>;
  adminRefundPhoneNumberBilling?: Maybe<MessageResponse>;
  adminRegenerateCode?: Maybe<AdminRegenerateCodeResponse>;
  adminReleasePaymentOrderLien?: Maybe<PaymentOrderResponse>;
  adminRemoveBillingDiscount?: Maybe<Message>;
  adminRemoveFromCart?: Maybe<Message>;
  adminRemoveProviderPhoneNumber?: Maybe<SingleTwilioAvailablePhoneNumber>;
  adminResetConfigurationChannel?: Maybe<Message>;
  adminSendTemplateNotification?: Maybe<Message>;
  adminSetFederatedUserPassword?: Maybe<Message>;
  adminSetKycVerification?: Maybe<Message>;
  adminSubscribeNumberPlan?: Maybe<MessageResponse>;
  adminSuspendProviderSubaccount?: Maybe<Message>;
  adminTransferProviderPhoneNumber?: Maybe<Message>;
  adminUnsuspendProviderSubaccount?: Maybe<Message>;
  adminUpdateBillingDiscount?: Maybe<Message>;
  adminUpdateBlockedDomain?: Maybe<Message>;
  adminUpdateBlockedForwardedPhoneNumber?: Maybe<Message>;
  adminUpdateBlockedIpAddress?: Maybe<Message>;
  adminUpdateBlockedPhoneNumber?: Maybe<Message>;
  adminUpdateBlockedSignUpEmail?: Maybe<Message>;
  adminUpdateCustomPlan?: Maybe<AdminCreateCustomPlanResponse>;
  adminUpdateIncomingPhoneNumber?: Maybe<SingleIncomingPhoneNumber>;
  adminUpdateModule?: Maybe<SingleModule>;
  adminUpdateNotificationTemplate?: Maybe<UpdateNotificationTemplateResponse>;
  adminUpdateNumberPurchaseStatus?: Maybe<Message>;
  adminUpdatePlan?: Maybe<SinglePlan>;
  adminUpdatePrivilege?: Maybe<SinglePrivilege>;
  adminUpdatePromotion?: Maybe<Message>;
  adminUpdateProviderPhoneNumbers?: Maybe<SingleTwilioAvailablePhoneNumber>;
  adminUpdateRegulatoryCompliance?: Maybe<Message>;
  adminUpdateRole?: Maybe<SingleRole>;
  adminUpdateScreen?: Maybe<SingleScreen>;
  adminUpdateUser?: Maybe<Message>;
  adminUpdateUserEmail?: Maybe<EmailUpdateResponse>;
  adminUploadWorkspaceDetailDocuments?: Maybe<Message>;
  administratorLogin?: Maybe<AdministratorLogin>;
  administratorVerifyTwoFactorAuthentication?: Maybe<AdministratorLogin>;
  assignMemberToChannel?: Maybe<Message>;
  assignOrUnassignChannelToMember?: Maybe<Message>;
  assignOrUnassignMembersToChannel?: Maybe<Message>;
  assignPhoneNumberToCampaign?: Maybe<MessageResponse>;
  assignTagsToContact?: Maybe<AssignTagsToContactResponse>;
  authMe?: Maybe<SingleUser>;
  blockOrUnblockContact?: Maybe<SingleContact>;
  bundleCreate?: Maybe<SingleBundle>;
  bundleRemove?: Maybe<Message>;
  bundleUpdate?: Maybe<Message>;
  cacheOAuthAuthorizationCode?: Maybe<CacheInytegrateOAuthCode>;
  callTransfer?: Maybe<Message>;
  cancelSubscription?: Maybe<PlanSubscriptionResponse>;
  cancelSubscriptionV2?: Maybe<PlanSubscriptionResponse>;
  cancelWorkspaceDowngrade?: Maybe<Message>;
  captureClientCallEntityInfo?: Maybe<Message>;
  changePassword?: Maybe<Message>;
  claimFreeNumbers?: Maybe<MessageResponse>;
  collectPayment?: Maybe<PaymentCollectionResponse>;
  collectPaymentRequest?: Maybe<Message>;
  completeProviderConference?: Maybe<Message>;
  completeProviderConferences?: Maybe<Message>;
  completedConference?: Maybe<Message>;
  confirmForgotPassword?: Maybe<Message>;
  confirmPaymentOrder?: Maybe<PaymentOrderResponse>;
  /** @deprecated no longer consumed currently confirmSignupAndLogin is being used */
  confirmSignUp?: Maybe<Message>;
  confirmSignupAndLogin?: Maybe<Login>;
  connectThirdParty?: Maybe<ConnectOrDisconnectThirdPartyResponse>;
  createAllPlanItems: CommonResponse;
  createAttribute?: Maybe<SingleAttribute>;
  createAttributeValue?: Maybe<SingleAttributeValue>;
  createBrand?: Maybe<ComplianceSoleProprietorBrandCreationSuccessResponse>;
  createBrandRegistrationOtp?: Maybe<MessageResponse>;
  createBulkMessagingCampaign?: Maybe<CreateBulkMessagingCampaignResponse>;
  createBusinessAddress?: Maybe<ComplianceSoleProprietorBusinessResponse>;
  createBusinessProfile?: Maybe<ComplianceSoleProprietorBusinessResponse>;
  createCallSetting?: Maybe<CallSettingResponse>;
  createCampaign?: Maybe<ComplianceSoleProprietorCampaignCreationSuccessResponse>;
  createChannelGroup?: Maybe<ChannelGroupData>;
  createChannelSetting?: Maybe<SingleChannelSetting>;
  createCommandResponse?: Maybe<CommandResponseMessage>;
  createContact?: Maybe<SingleContact>;
  createContactComplianceConsent?: Maybe<ContactComplianceConsentResponse>;
  createContactNote?: Maybe<SingleContactNote>;
  createCustomerV2?: Maybe<MessageResponse>;
  createExtensionConfiguration?: Maybe<ExtensionConfigurationResponse>;
  createInputScreenPlanMapping?: Maybe<SingleScreenPlanMappingInterface>;
  createInputScreenRoleMapping?: Maybe<SingleScreenRoleMappingInterface>;
  createIntegrationConfiguration?: Maybe<IntegrationConfigurationResponse>;
  createIntegrationRequest?: Maybe<IntegrationRequestResponse>;
  createIntegrationWebhooks?: Maybe<IntegrationWebhookResponse>;
  createKycVerificationSession?: Maybe<KycVerificationSessionResponse>;
  createMultipleInputScreenPlanMapping?: Maybe<SingleScreenPlanMappingInterface>;
  createMultipleInputScreenRoleMapping?: Maybe<SingleScreenRoleMappingInterface>;
  /** @deprecated Use setBusinessHoursInCallSetting instead, as createOrUpdateBusinessHour will no longer be supported after call setting is implemented. */
  createOrUpdateBusinessHour?: Maybe<BusinessHourResponse>;
  createOrUpdateDraftMessage?: Maybe<SingleDraftMessageConversation>;
  createOrUpdateRecordingCall?: Maybe<Message>;
  createPaymentIntent?: Maybe<ChargeBeePaymentIntentResponse>;
  createPaymentIntentV2?: Maybe<ChargeBeePaymentIntentResponse>;
  createPaymentIntentV3?: Maybe<ChargeBeePaymentIntentResponse>;
  createPaymentSource?: Maybe<PaymentSourceResponse>;
  createPlanItem?: Maybe<CommonResponse>;
  createPlanItemPrice?: Maybe<CommonResponse>;
  createPlanPrice?: Maybe<SinglePlanPrice>;
  createPowerCampaign?: Maybe<PowerCampaignResponse>;
  createPowerCampaignDispositionContact?: Maybe<PowerCampaignDispositionContactResponse>;
  createPowerDisposition?: Maybe<PowerDispositionResponse>;
  createProviderErrorLog?: Maybe<ProviderErrorLogResponse>;
  createReview?: Maybe<SingleReview>;
  createRoom?: Maybe<SingleRoom>;
  createSubscription?: Maybe<MessageResponse>;
  createTag?: Maybe<SingleTag>;
  createTeams?: Maybe<TeamsResponse>;
  createTranscriptionJob?: Maybe<SingleTranscriptionInformation>;
  createUserWorkspaceFcmToken?: Maybe<SingleUserWorkspaceFCMTokens>;
  createWorkspaceDetail?: Maybe<SingleWorkspaceDetail>;
  deactivateWorkspaceMember?: Maybe<Message>;
  deleteAllPlanItems?: Maybe<CommonResponse>;
  deleteAttribute?: Maybe<SingleAttribute>;
  deleteAttributeValue?: Maybe<SingleAttributeValue>;
  deleteBrand?: Maybe<MessageResponse>;
  deleteBulkMessagingCampaign?: Maybe<Message>;
  deleteBulkMessagingCampaignRun?: Maybe<Message>;
  deleteBusinessProfile?: Maybe<MessageResponse>;
  deleteCallSetting?: Maybe<Message>;
  deleteCallerId?: Maybe<Message>;
  deleteCampaign?: Maybe<MessageResponse>;
  deleteChannelGroup?: Maybe<Message>;
  deleteCommandResponse?: Maybe<CommandResponseMessage>;
  deleteContact?: Maybe<SingleContact>;
  deleteContactNote?: Maybe<SingleContactNote>;
  deleteContactTag?: Maybe<Message>;
  deleteContacts?: Maybe<Message>;
  deleteCustomer?: Maybe<CommonResponse>;
  deletePlanItem?: Maybe<CommonResponse>;
  deletePlanItemPrice?: Maybe<CommonResponse>;
  deletePowerCampaign?: Maybe<Message>;
  deletePowerDisposition?: Maybe<Message>;
  deletePushCredentialToken?: Maybe<Message>;
  deleteScheduledMessage?: Maybe<Message>;
  deleteTags?: Maybe<MultipleTags>;
  deleteTeamMember?: Maybe<Message>;
  deleteTeams?: Maybe<Message>;
  deleteUserWorkspaceFcmToken?: Maybe<Message>;
  deleteWorkspaceUser?: Maybe<DeleteWorkspaceUserResponse>;
  disableTOTPMfa?: Maybe<SetUpMfaStatusResponse>;
  disconnectThirdParty?: Maybe<ConnectOrDisconnectThirdPartyResponse>;
  downgradeWorkspaceSubscription?: Maybe<PlanSubscriptionResponse>;
  duplicateBulkMessagingCampaign?: Maybe<GetBulkMessagingCampaignResponse>;
  enableOrDisableChannel?: Maybe<SingleChannel>;
  enrollConference?: Maybe<SingleSuperviseConference>;
  estimateMemberAddition?: Maybe<EstimateAmountResponse>;
  estimateRenewFailedSubscription?: Maybe<EstimateAmountResponse>;
  estimateUpgradeWorkspaceSubscription?: Maybe<EstimateAmountResponse>;
  exchangeOAuthAuthorizationCodeForTokens?: Maybe<ExchangeOAuthAuthorizationCodeForTokensResponse>;
  exchangeOAuthAuthorizationCodeForTokensViaTransientToken?: Maybe<Message>;
  exportContacts?: Maybe<Message>;
  exportInvoices?: Maybe<Message>;
  federatedAuth?: Maybe<FederatedAuthResponse>;
  finalizePowerCampaignCallReview?: Maybe<SinglePowerCampaignCall>;
  forgotPassword?: Maybe<ForgotPassword>;
  forwardChatToEmail?: Maybe<Message>;
  generateAdminPin?: Maybe<Message>;
  globalSignOut?: Maybe<Message>;
  hangUpConference?: Maybe<Message>;
  integrate?: Maybe<ConnectResponse>;
  loadWallet?: Maybe<WalletResponse>;
  logOAuthAuthorizationError?: Maybe<Message>;
  login?: Maybe<Login>;
  markAllAsReadNotification?: Maybe<Message>;
  markAllAsSeenNotification?: Maybe<Message>;
  markAsActiveOrAway?: Maybe<Message>;
  markAsCloseOrOpen?: Maybe<Message>;
  markAsSeenNotification?: Maybe<Message>;
  markMemberChatAsRead?: Maybe<Message>;
  migrateToV2?: Maybe<Message>;
  pauseOrResumePowerCampaignRun?: Maybe<PowerCampaignRunResponse>;
  pauseRecurringBulkMessagingCampaign?: Maybe<Message>;
  pinOrUnpinChatMessage?: Maybe<SingleChatMessage>;
  pinOrUnpinMessageConversation?: Maybe<SingleMessageConversation>;
  pinOrUnpinRecentMessageConversation?: Maybe<SingleRecentMessageConversation>;
  preCheckLogin?: Maybe<PreCheckLoginResponse>;
  previewPowerCampaignCall?: Maybe<SinglePowerCampaignCall>;
  purchaseNumbers?: Maybe<PurchaseNumbersRes>;
  readAllMessage?: Maybe<Message>;
  readMessage?: Maybe<Message>;
  reassignPowerCampaignContacts?: Maybe<Message>;
  refreshToken?: Maybe<RefreshToken>;
  rejectPaymentOrder?: Maybe<PaymentOrderResponse>;
  releaseChannels?: Maybe<MessageResponse>;
  removeChannelRemovalSchedule?: Maybe<ChannelRemovalScheduleResponse>;
  removeFromCart?: Maybe<Message>;
  removeProviderPhoneNumber?: Maybe<SingleTwilioAvailablePhoneNumber>;
  removeProviderPhoneNumbers: RemoveProviderPhoneNumbersResponse;
  removeScheduledSubscriptionCancellation?: Maybe<PlanSubscriptionResponse>;
  removeSecondaryPaymentSource?: Maybe<Message>;
  removeWorkspaceUserWithDisposition?: Maybe<RemoveWorkspaceUserWithDispositionResponse>;
  requestRegulatoryCompliance?: Maybe<Message>;
  resendConfirmationCode?: Maybe<Message>;
  resendEmailMfaOtp?: Maybe<SetUpEmailMfaResponse>;
  resendInviteWorkspaceMember?: Maybe<Message>;
  resendMessage?: Maybe<SingleMessageConversation>;
  resendTwoFactorAuthenticationCode?: Maybe<Message>;
  resetAdminPin?: Maybe<Message>;
  restoreCancelledSubscription?: Maybe<MessageResponse>;
  resumeRecurringBulkMessagingCampaign?: Maybe<Message>;
  retrySubmitBusinessProfile?: Maybe<ComplianceSoleProprietorBusinessResponse>;
  revoke?: Maybe<RevokeResponse>;
  revokeInvitationToken?: Maybe<RevokeInvitationTokenResponse>;
  scheduleMessage?: Maybe<ScheduleMessageResponse>;
  sendChatMessage?: Maybe<SingleChatMessage>;
  sendInternalMessage?: Maybe<SingleMessageConversation>;
  sendMessage?: Maybe<SingleMessageConversation>;
  sendScheduledMessageNow?: Maybe<Message>;
  sendTestNotification?: Maybe<Message>;
  /** @deprecated use setAutoRechargeConfigV2 instead */
  setAutoRechargeConfig?: Maybe<AutoRechargeConfigResponse>;
  setAutoRechargeConfigV2?: Maybe<AutoRechargeConfigResponse>;
  setAutoRecordingInCallSetting?: Maybe<CallSettingAutoRecordingResponse>;
  setAutoRecordingInChannelSetting?: Maybe<CallSettingAutoRecordingResponse>;
  setAutoTranscribeInCallSetting?: Maybe<CallSettingAutoTranscribeResponse>;
  setAutoTranscribeInChannelSetting?: Maybe<CallSettingAutoTranscribeResponse>;
  setBusinessAfterHoursInCallSetting?: Maybe<BusinessAfterHourResponse>;
  setBusinessAfterHoursInChannelSetting?: Maybe<BusinessAfterHourResponse>;
  setBusinessHoursInCallSetting?: Maybe<BusinessHourResponse>;
  setBusinessHoursInChannelSetting?: Maybe<BusinessHourResponse>;
  setCallForwardInCallSetting?: Maybe<CallForwardResponse>;
  setCallForwardInChannelSetting?: Maybe<CallForwardResponse>;
  setCallSettingEmailAlerts?: Maybe<CallSettingEmailAlertsResponse>;
  setCallSettingInChannelGroup?: Maybe<ChannelGroupData>;
  setCallTransferInCallSetting?: Maybe<CallTransferResponse>;
  setCallTransferInChannelSetting?: Maybe<CallTransferResponse>;
  setCallerIdInCallSetting?: Maybe<CallSettingCallerIdResponse>;
  setCallerIdInChannelSetting?: Maybe<CallSettingCallerIdResponse>;
  setCallerTuneInCallSetting?: Maybe<CallSettingCallerTuneResponse>;
  setCallerTuneInChannelSetting?: Maybe<CallSettingCallerTuneResponse>;
  setChannelGroupsInCallSetting?: Maybe<CallSettingChannelGroupResponse>;
  setChannelSettingEmailAlerts?: Maybe<CallSettingEmailAlertsResponse>;
  setChannelsInGroup?: Maybe<setChannelsInGroupType>;
  setDefaultChannel?: Maybe<SetDefaultChannelResponse>;
  setDefaultCountry?: Maybe<Message>;
  setIvrInCallSetting?: Maybe<CallIvrResponse>;
  setIvrInChannelSetting?: Maybe<CallIvrResponse>;
  setLowBalanceAlert?: Maybe<SingleLowBalanceAlert>;
  setMfaReminder?: Maybe<Message>;
  setMissedCallEmailInCallSetting?: Maybe<CallSettingMissedCallEmailResponse>;
  setMissedCallEmailInChannelSetting?: Maybe<CallSettingMissedCallEmailResponse>;
  setRecordingAnnouncementInCallSetting?: Maybe<CallSettingRecordingAnnouncementResponse>;
  setRecordingAnnouncementInChannelSetting?: Maybe<CallSettingRecordingAnnouncementResponse>;
  setSecondaryPaymentSource?: Maybe<Message>;
  setTimeoutInCallSetting?: Maybe<CallSetttingTimeoutResponse>;
  setTimeoutInChannelSetting?: Maybe<CallSetttingTimeoutResponse>;
  setUpEmailMfa?: Maybe<SetUpMfaStatusResponse>;
  setUpTOTPMfa?: Maybe<SetUpTOTPResponse>;
  setUsageReportNotification?: Maybe<UsageReportNotificationResponse>;
  setVoicemailInCallSetting?: Maybe<CallSettingVoicemailResponse>;
  setVoicemailInChannelSetting?: Maybe<CallSettingVoicemailResponse>;
  setWelcomeMessageInCallSetting?: Maybe<CallSettingWelcomeMessageResponse>;
  setWelcomeMessageInChannelSetting?: Maybe<CallSettingWelcomeMessageResponse>;
  setWorkspacePreferredContactMethods?: Maybe<Message>;
  setWorkspacePreferredContactMethodsLater?: Maybe<Message>;
  signOut?: Maybe<Message>;
  signUp?: Maybe<SingUp>;
  signUpV2?: Maybe<SingUp>;
  startPowerCampaigns?: Maybe<StartPowerCampaignsResponse>;
  submitBusinessProfile?: Maybe<ComplianceSoleProprietorBusinessResponse>;
  subscribeNumberPlan?: Maybe<MessageResponse>;
  subscribeWorkspacePlanAndInviteUser?: Maybe<PlanSubscriptionResponse>;
  superviseConference?: Maybe<SingleSuperviseConference>;
  switchCall?: Maybe<Message>;
  switchPrimaryPaymentSource?: Maybe<Message>;
  switchToChannelSetting?: Maybe<ChannelOverviewResponse>;
  switchToEmailMfa?: Maybe<SetUpEmailMfaResponse>;
  switchUiVersion?: Maybe<Message>;
  terminateRecurringBulkMessagingCampaign?: Maybe<Message>;
  toggleChannelNotification?: Maybe<Message>;
  toggleChannelPin?: Maybe<ToggleChannelPinResponse>;
  toggleIntegrationChannelStatus?: Maybe<ToggleIntegrationChannelStatusResponse>;
  toggleMissedCallEmailNotification?: Maybe<SingleChannel>;
  toggleReadNotification?: Maybe<Message>;
  toggleStrategyGroup?: Maybe<StrategyResult>;
  unAssignMemberFromChannel?: Maybe<Message>;
  unEnrollConference?: Maybe<Message>;
  unSuperviseConference?: Maybe<SingleSuperviseConference>;
  unassignPhoneNumberFromCampaign?: Maybe<MessageResponse>;
  unassignTagsFromContact?: Maybe<MultipleContactTags>;
  unsetSecondaryPaymentSource?: Maybe<Message>;
  updateAttribute?: Maybe<SingleAttribute>;
  updateAttributeValue?: Maybe<SingleAttributeValue>;
  updateBulkMessagingCampaign?: Maybe<UpdateBulkMessagingCampaignResponse>;
  updateBusinessAddress?: Maybe<ComplianceSoleProprietorBusinessResponse>;
  updateBusinessProfile?: Maybe<ComplianceSoleProprietorBusinessResponse>;
  updateCallSetting?: Maybe<CallSettingFriendlyNameResponse>;
  updateCallerId?: Maybe<SingleVerifyCallerId>;
  updateChannel?: Maybe<SingleChannel>;
  updateChannelGroup?: Maybe<Message>;
  updateCommandResponse?: Maybe<CommandResponseMessage>;
  updateContact?: Maybe<SingleContact>;
  updateContactNote?: Maybe<SingleContactNote>;
  updateCustomerBillingAddress?: Maybe<CustomerBillingAddressResponse>;
  updateIncomingPhoneNumber?: Maybe<SingleIncomingPhoneNumber>;
  updateIntegrationWebhooks?: Maybe<IntegrationWebhookResponse>;
  updatePlanItemPrice?: Maybe<CommonResponse>;
  updatePlanPrice?: Maybe<SinglePlanPrice>;
  updatePowerCampaign?: Maybe<PowerCampaignResponse>;
  updatePowerCampaignContactDetails?: Maybe<Message>;
  updatePowerCampaignDispositionContact?: Maybe<Message>;
  updatePowerDisposition?: Maybe<Message>;
  updatePushCredentialTokenStatus?: Maybe<SinglePushCredentialToken>;
  updateScheduledMessage?: Maybe<Message>;
  updateTag?: Maybe<SingleTag>;
  updateTeamMember?: Maybe<updateTeamMemberResponse>;
  updateTeams?: Maybe<TeamsResponse>;
  /** @deprecated Use updateWorkspaceMemberV2 */
  updateWorkspaceMember?: Maybe<Message>;
  updateWorkspaceMemberV2?: Maybe<UpdateWorkspaceMemberV2Response>;
  upgradeWorkspaceSubscription?: Maybe<PlanSubscriptionResponse>;
  uploadWorkspaceDetailDocuments?: Maybe<Message>;
  verifyAndEnableTOTPMfa?: Maybe<SetUpMfaStatusResponse>;
  verifyAndTransitionStatus?: Maybe<Message>;
  verifyCallerId?: Maybe<SingleVerifyCallerId>;
  verifyInvitationToken?: Maybe<VerifyInvitationToken>;
  verifyMfaAuthentication?: Maybe<Login>;
  verifyPaymentRequest?: Maybe<verifyPaymentRequest>;
  /** @deprecated no longer consumed */
  verifyTwoFactorAuthentication?: Maybe<Login>;
  workspaceAuthMe?: Maybe<SingleWorkspace>;
  workspaceLogin?: Maybe<WorkspaceMemberLogin>;
  wrapUpCall?: Maybe<Message>;
};

export type MutationacceptInvitedWorkspaceMemberArgs = {
  input?: InputMaybe<InputAcceptInvitedWorkspaceMemberInterface>;
};

export type MutationaddTeamMemberArgs = {
  input: Array<InputMaybe<InputTeamMembersInterface>>;
};

export type MutationaddToCartArgs = {
  input?: InputMaybe<InputCart>;
};

export type MutationadminAddSalesDealArgs = {
  input?: InputMaybe<AdminAddSalesDealInput>;
};

export type MutationadminAddToCartArgs = {
  input?: InputMaybe<InputCart>;
  workspaceId: Scalars['Int']['input'];
};

export type MutationadminAuthMeArgs = {
  input: InputUser;
};

export type MutationadminAutoRecoverNumberPurchaseArgs = {
  input?: InputMaybe<AdminAutoRecoverNumberPurchaseInput>;
  referenceId: Scalars['String']['input'];
};

export type MutationadminBlockOrUnblockWorkspaceArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputAdminBlockOrUnblockWorkspace>;
};

export type MutationadminCancelNumberPurchaseArgs = {
  id: Scalars['Int']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminCancelPaymentOrderArgs = {
  input: InputAdminCancelPaymentOrder;
};

export type MutationadminChangePasswordArgs = {
  input: InputAdminChangePassword;
};

export type MutationadminChangeWorkspaceStatusArgs = {
  id: Scalars['Int']['input'];
  input: InputWorkspaceStatus;
};

export type MutationadminCloseWorkspaceArgs = {
  id: Scalars['Int']['input'];
  input: InputAdminCloseWorkspace;
};

export type MutationadminCollectPaymentArgs = {
  input?: InputMaybe<AdminCollectPaymentInput>;
};

export type MutationadminConfigureA2pComplianceArgs = {
  id: Scalars['Int']['input'];
  input: InputAdminConfigureA2pCompliance;
};

export type MutationadminConfigureExclusiveNumbersArgs = {
  input: InputAdminConfigureExclusiveNumbers;
};

export type MutationadminCreateBillingDiscountArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputBillingDiscount>;
  passcode: Scalars['String']['input'];
};

export type MutationadminCreateBlockDomainArgs = {
  input?: InputMaybe<InputCreateDomain>;
};

export type MutationadminCreateBlockForwardedPhoneNumberArgs = {
  input?: InputMaybe<InputCreateBlockForwardedPhoneNumber>;
};

export type MutationadminCreateBlockIpAddressArgs = {
  input?: InputMaybe<InputCreateBlockIpAddress>;
};

export type MutationadminCreateBlockPhoneNumberArgs = {
  input?: InputMaybe<InputCreateBlockPhoneNumber>;
};

export type MutationadminCreateBlockedSignupEmailArgs = {
  input?: InputMaybe<InputCreateBlockEmail>;
};

export type MutationadminCreateConfigurationArgs = {
  input?: InputMaybe<InputAdminCreateConfiguration>;
};

export type MutationadminCreateCustomPaymentOrderArgs = {
  input: InputAdminCreatePaymentOrder;
};

export type MutationadminCreateCustomPlanArgs = {
  input: CustomPlanInput;
};

export type MutationadminCreateKYCArgs = {
  input: Inputkyc;
  workspaceId: Scalars['Int']['input'];
};

export type MutationadminCreateModuleArgs = {
  input: InputModule;
};

export type MutationadminCreateNotificationTemplateArgs = {
  input?: InputMaybe<Array<InputMaybe<InputTemplateNotification>>>;
};

export type MutationadminCreateOrUpdateEmailTemplateSegmentArgs = {
  input?: InputMaybe<InputAdminEmailTemplateSegment>;
};

export type MutationadminCreatePaymentIntentArgs = {
  input?: InputMaybe<AdminPaymentIntentInput>;
};

export type MutationadminCreatePaymentRequestArgs = {
  input?: InputMaybe<InputCreatePayment>;
};

export type MutationadminCreatePlanArgs = {
  input: InputPlan;
};

export type MutationadminCreatePrivilegeArgs = {
  input: InputPrivilege;
};

export type MutationadminCreatePromoCodeArgs = {
  input: InputPromoCode;
};

export type MutationadminCreateRoleArgs = {
  input: InputRole;
};

export type MutationadminCreateScreenArgs = {
  input: InputScreen;
};

export type MutationadminCreateUserArgs = {
  input?: InputMaybe<InputCreateUser>;
};

export type MutationadminDeleteBlockedDomainArgs = {
  id: Scalars['Int']['input'];
  passcode: Scalars['String']['input'];
};

export type MutationadminDeleteBlockedForwardedPhoneNumberArgs = {
  id: Scalars['Int']['input'];
  passcode: Scalars['String']['input'];
};

export type MutationadminDeleteBlockedIpAddressArgs = {
  id: Scalars['Int']['input'];
  passcode: Scalars['String']['input'];
};

export type MutationadminDeleteBlockedPhoneNumberArgs = {
  id: Scalars['Int']['input'];
  passcode: Scalars['String']['input'];
};

export type MutationadminDeleteBlockedSignUpEmailArgs = {
  id: Scalars['Int']['input'];
  passcode: Scalars['String']['input'];
};

export type MutationadminDeleteCustomPlanArgs = {
  customPlanMetaId: Scalars['Int']['input'];
};

export type MutationadminDeleteNotificationTemplateArgs = {
  id: Scalars['Int']['input'];
};

export type MutationadminDeletePromoCodeArgs = {
  id: Scalars['Int']['input'];
  input: InputDeletePromotion;
};

export type MutationadminDeletePromotionArgs = {
  id: Scalars['Int']['input'];
  input: InputDeletePromotion;
};

export type MutationadminDeleteRequestRegulatoryComplianceArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputDeleteRequestRegulatoryCompliance>;
};

export type MutationadminDeleteRoleArgs = {
  id: Scalars['Int']['input'];
};

export type MutationadminDeleteWorkspaceMemberArgs = {
  input?: InputMaybe<InputAdminDeleteWorkspaceMember>;
};

export type MutationadminEnableOrDisableUserArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputAdminEnableOrDisableUser>;
};

export type MutationadminLoadWalletArgs = {
  input: AdminLoadWalletInput;
};

export type MutationadminPortAwayNumberArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputAdminPortAwayNumber>;
};

export type MutationadminRefundPaymentArgs = {
  id: Scalars['Int']['input'];
  input: AdminRefundPaymentInput;
};

export type MutationadminRefundPhoneNumberBillingArgs = {
  input?: InputMaybe<RefundRequest>;
};

export type MutationadminRegenerateCodeArgs = {
  customPlanMetaId: Scalars['Int']['input'];
};

export type MutationadminReleasePaymentOrderLienArgs = {
  input: InputReleasePaymentOrderLien;
};

export type MutationadminRemoveBillingDiscountArgs = {
  id: Scalars['Int']['input'];
  passcode: Scalars['String']['input'];
};

export type MutationadminRemoveFromCartArgs = {
  input?: InputMaybe<InputCart>;
  workspaceId: Scalars['Int']['input'];
};

export type MutationadminRemoveProviderPhoneNumberArgs = {
  enteredPasscode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type MutationadminResetConfigurationChannelArgs = {
  id: Scalars['Int']['input'];
};

export type MutationadminSendTemplateNotificationArgs = {
  templateId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationadminSetFederatedUserPasswordArgs = {
  id: Scalars['Int']['input'];
  input: InputAdminSetFederatedUserPassword;
};

export type MutationadminSetKycVerificationArgs = {
  input?: InputMaybe<InputAdminSetKycVerification>;
  workspaceId: Scalars['Int']['input'];
};

export type MutationadminSubscribeNumberPlanArgs = {
  input?: InputMaybe<AdminNumberSubscriptionInput>;
};

export type MutationadminSuspendProviderSubaccountArgs = {
  input: InputAdminChangeProviderSubaccountStatus;
  sid: Scalars['String']['input'];
};

export type MutationadminTransferProviderPhoneNumberArgs = {
  input?: InputMaybe<InputTransferPhoneNumber>;
  phoneNumberSid: Scalars['String']['input'];
};

export type MutationadminUnsuspendProviderSubaccountArgs = {
  input: InputAdminChangeProviderSubaccountStatus;
  sid: Scalars['String']['input'];
};

export type MutationadminUpdateBillingDiscountArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputUpdateBillingDiscount>;
  passcode: Scalars['String']['input'];
};

export type MutationadminUpdateBlockedDomainArgs = {
  id: Scalars['Int']['input'];
  input: InputUpdateDomain;
};

export type MutationadminUpdateBlockedForwardedPhoneNumberArgs = {
  id: Scalars['Int']['input'];
  input: InputUpdateBlockForwardedPhoneNumber;
};

export type MutationadminUpdateBlockedIpAddressArgs = {
  id: Scalars['Int']['input'];
  input: InputUpdateBlockIpAddress;
};

export type MutationadminUpdateBlockedPhoneNumberArgs = {
  id: Scalars['Int']['input'];
  input: InputUpdateBlockPhoneNumber;
};

export type MutationadminUpdateBlockedSignUpEmailArgs = {
  id: Scalars['Int']['input'];
  input: InputUpdateBlockEmail;
};

export type MutationadminUpdateCustomPlanArgs = {
  id: Scalars['Int']['input'];
  input: CustomPlanInput;
};

export type MutationadminUpdateIncomingPhoneNumberArgs = {
  _id: Scalars['String']['input'];
  input?: InputMaybe<InputIncomingPhoneStatusNumber>;
};

export type MutationadminUpdateModuleArgs = {
  id: Scalars['Int']['input'];
  input: InputModule;
};

export type MutationadminUpdateNotificationTemplateArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputUpdateTemplateNotification>;
};

export type MutationadminUpdateNumberPurchaseStatusArgs = {
  input?: InputMaybe<InputNumberPurchaseStatus>;
};

export type MutationadminUpdatePlanArgs = {
  id: Scalars['Int']['input'];
  input: InputPlan;
};

export type MutationadminUpdatePrivilegeArgs = {
  id: Scalars['Int']['input'];
  input: InputPrivilege;
};

export type MutationadminUpdatePromotionArgs = {
  id: Scalars['Int']['input'];
  input: InputUpdatePromotion;
};

export type MutationadminUpdateProviderPhoneNumbersArgs = {
  id: Scalars['Int']['input'];
};

export type MutationadminUpdateRegulatoryComplianceArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputStatusRegulatoryCompliance>;
};

export type MutationadminUpdateRoleArgs = {
  id: Scalars['Int']['input'];
  input: InputRole;
};

export type MutationadminUpdateScreenArgs = {
  id: Scalars['Int']['input'];
  input: InputScreen;
};

export type MutationadminUpdateUserArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputUpdateAdminUser>;
};

export type MutationadminUpdateUserEmailArgs = {
  id: Scalars['Int']['input'];
  input: InputAdminUpdateUserEmail;
};

export type MutationadminUploadWorkspaceDetailDocumentsArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputWorkspaceDetailDocuments>;
};

export type MutationadministratorLoginArgs = {
  input: InputAuthLogin;
};

export type MutationadministratorVerifyTwoFactorAuthenticationArgs = {
  input?: InputMaybe<InputVerifyTwoFactorAuthentication>;
};

export type MutationassignMemberToChannelArgs = {
  input: InputChannelUserWorkspace;
};

export type MutationassignOrUnassignChannelToMemberArgs = {
  input?: InputMaybe<InputAssignOrUnassignChannelToMember>;
};

export type MutationassignOrUnassignMembersToChannelArgs = {
  input?: InputMaybe<InputAssignMembersToChannel>;
};

export type MutationassignPhoneNumberToCampaignArgs = {
  campaignId: Scalars['Int']['input'];
  channelIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type MutationassignTagsToContactArgs = {
  input?: InputMaybe<AssignUnassignContactTag>;
};

export type MutationauthMeArgs = {
  input: InputUser;
};

export type MutationblockOrUnblockContactArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<InputBlockOrUnblockContact>;
};

export type MutationbundleCreateArgs = {
  input?: InputMaybe<InputBundle>;
};

export type MutationbundleRemoveArgs = {
  sid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationbundleUpdateArgs = {
  input?: InputMaybe<InputBundle>;
  sid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationcacheOAuthAuthorizationCodeArgs = {
  input?: InputMaybe<CacheIntegrationOAuthCodeInput>;
};

export type MutationcallTransferArgs = {
  callSid: Scalars['String']['input'];
  input: InputCallTransfer;
};

export type MutationcancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};

export type MutationcancelSubscriptionV2Args = {
  input: CancelSubscriptionInputV2;
};

export type MutationcaptureClientCallEntityInfoArgs = {
  callSid: Scalars['String']['input'];
  input: InputCollectClientInformation;
};

export type MutationchangePasswordArgs = {
  input?: InputMaybe<InputChangePassword>;
};

export type MutationclaimFreeNumbersArgs = {
  input: NumbersClaimInput;
};

export type MutationcollectPaymentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  paymentSourceId: Scalars['String']['input'];
};

export type MutationcollectPaymentRequestArgs = {
  input: CollectPaymentRequestInput;
};

export type MutationcompleteProviderConferenceArgs = {
  id: Scalars['Int']['input'];
};

export type MutationcompletedConferenceArgs = {
  input?: InputMaybe<InputCompletedConference>;
};

export type MutationconfirmForgotPasswordArgs = {
  input?: InputMaybe<InputConfirmForgotPassword>;
};

export type MutationconfirmPaymentOrderArgs = {
  paymentOrderId: Scalars['Int']['input'];
};

export type MutationconfirmSignUpArgs = {
  input: InputAuthConfirmSignUp;
};

export type MutationconfirmSignupAndLoginArgs = {
  input?: InputMaybe<InputAuthConfirmSignUp>;
};

export type MutationconnectThirdPartyArgs = {
  integrationId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationcreateAttributeArgs = {
  input: InputAttribute;
};

export type MutationcreateAttributeValueArgs = {
  input: InputAttributeValue;
};

export type MutationcreateBrandArgs = {
  input?: InputMaybe<InputCreateBrand>;
};

export type MutationcreateBrandRegistrationOtpArgs = {
  brandId: Scalars['Int']['input'];
};

export type MutationcreateBulkMessagingCampaignArgs = {
  input?: InputMaybe<InputBulkMessagingCampaign>;
};

export type MutationcreateBusinessAddressArgs = {
  input?: InputMaybe<InputBusinessAddress>;
};

export type MutationcreateBusinessProfileArgs = {
  input?: InputMaybe<createBusinessProfileInput>;
};

export type MutationcreateCallSettingArgs = {
  input: InputCallSetting;
};

export type MutationcreateCampaignArgs = {
  input?: InputMaybe<InputCreateCampaign>;
};

export type MutationcreateChannelGroupArgs = {
  input: InputChannelGroup;
};

export type MutationcreateChannelSettingArgs = {
  input?: InputMaybe<InputChannelSetting>;
};

export type MutationcreateCommandResponseArgs = {
  input?: InputMaybe<CommandResponseInput>;
};

export type MutationcreateContactArgs = {
  input: InputContact;
};

export type MutationcreateContactComplianceConsentArgs = {
  input: InputContactComplianceConsent;
};

export type MutationcreateContactNoteArgs = {
  input: InputContactNote;
};

export type MutationcreateCustomerV2Args = {
  input?: InputMaybe<InputCreateCustomerV2>;
};

export type MutationcreateExtensionConfigurationArgs = {
  input?: InputMaybe<InputExtensionConfiguration>;
};

export type MutationcreateInputScreenPlanMappingArgs = {
  input: Scalars['String']['input'];
  planId: Scalars['Int']['input'];
};

export type MutationcreateInputScreenRoleMappingArgs = {
  input: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};

export type MutationcreateIntegrationConfigurationArgs = {
  input?: InputMaybe<InputIntegrationConfiguration>;
};

export type MutationcreateIntegrationRequestArgs = {
  input: CreateIntegrationRequestInput;
};

export type MutationcreateIntegrationWebhooksArgs = {
  input?: InputMaybe<Array<InputMaybe<InputIntegrationWebhook>>>;
  integrationUserId: Scalars['Int']['input'];
};

export type MutationcreateMultipleInputScreenPlanMappingArgs = {
  input: Array<Scalars['String']['input']>;
  planId: Scalars['Int']['input'];
};

export type MutationcreateMultipleInputScreenRoleMappingArgs = {
  input: Array<Scalars['String']['input']>;
  roleId: Scalars['Int']['input'];
};

export type MutationcreateOrUpdateBusinessHourArgs = {
  input: InputBusinessHour;
};

export type MutationcreateOrUpdateDraftMessageArgs = {
  input?: InputMaybe<InputDraftMessageConversation>;
};

export type MutationcreateOrUpdateRecordingCallArgs = {
  callSid: Scalars['String']['input'];
  input: UpdateRecordingInput;
};

export type MutationcreatePaymentIntentArgs = {
  input?: InputMaybe<PaymentIntentInput>;
};

export type MutationcreatePaymentIntentV2Args = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  paymentGateway?: InputMaybe<PaymentGatewayEnum>;
  planPriceId?: InputMaybe<Scalars['Int']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationcreatePaymentIntentV3Args = {
  input?: InputMaybe<InputPaymentIntentV3>;
};

export type MutationcreatePaymentSourceArgs = {
  input?: InputMaybe<PaymentSourceInput>;
};

export type MutationcreatePlanItemArgs = {
  input: PlanItemInput;
};

export type MutationcreatePlanItemPriceArgs = {
  input: PlanItemPriceInput;
};

export type MutationcreatePlanPriceArgs = {
  input: InputPlanPrice;
};

export type MutationcreatePowerCampaignArgs = {
  input: InputPowerCampaignInterface;
};

export type MutationcreatePowerCampaignDispositionContactArgs = {
  input?: InputMaybe<InputPowerCampaignDispositionContact>;
};

export type MutationcreatePowerDispositionArgs = {
  input: InputPowerDispositionInterface;
};

export type MutationcreateProviderErrorLogArgs = {
  input?: InputMaybe<InputProviderErrorLogData>;
};

export type MutationcreateReviewArgs = {
  input: InputReview;
};

export type MutationcreateRoomArgs = {
  input: InputRoom;
};

export type MutationcreateSubscriptionArgs = {
  input?: InputMaybe<InputCreateSubscription>;
};

export type MutationcreateTagArgs = {
  input: InputTag;
};

export type MutationcreateTeamsArgs = {
  input: createTeamsInput;
};

export type MutationcreateTranscriptionJobArgs = {
  input: InputTranscriptionInformation;
};

export type MutationcreateUserWorkspaceFcmTokenArgs = {
  input: InputUserWorkspaceFCMToken;
};

export type MutationcreateWorkspaceDetailArgs = {
  input: InputWorkspaceDetail;
};

export type MutationdeactivateWorkspaceMemberArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationdeleteAttributeArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteAttributeValueArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteBrandArgs = {
  brandId: Scalars['Int']['input'];
};

export type MutationdeleteBulkMessagingCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};

export type MutationdeleteBulkMessagingCampaignRunArgs = {
  campaignRunId: Scalars['Int']['input'];
};

export type MutationdeleteBusinessProfileArgs = {
  profileId: Scalars['Int']['input'];
};

export type MutationdeleteCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteCallerIdArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};

export type MutationdeleteChannelGroupArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteCommandResponseArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteContactArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteContactNoteArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteContactTagArgs = {
  contactId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
};

export type MutationdeleteContactsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationdeletePlanItemArgs = {
  planItemId: Scalars['String']['input'];
};

export type MutationdeletePlanItemPriceArgs = {
  id: Scalars['String']['input'];
};

export type MutationdeletePowerCampaignArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeletePowerDispositionArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeletePushCredentialTokenArgs = {
  token: Scalars['String']['input'];
  type: PushCredentialTypeEnum;
};

export type MutationdeleteScheduledMessageArgs = {
  id: Scalars['String']['input'];
};

export type MutationdeleteTagsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationdeleteTeamMemberArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdeleteTeamsArgs = {
  id: Scalars['String']['input'];
};

export type MutationdeleteUserWorkspaceFcmTokenArgs = {
  platform?: InputMaybe<NotificationPlatformEnum>;
};

export type MutationdeleteWorkspaceUserArgs = {
  id: Scalars['Int']['input'];
};

export type MutationdisconnectThirdPartyArgs = {
  integrationId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationdowngradeWorkspaceSubscriptionArgs = {
  input?: InputMaybe<DowngradeWorkspaceSubscriptionInput>;
};

export type MutationduplicateBulkMessagingCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};

export type MutationenableOrDisableChannelArgs = {
  id: Scalars['Int']['input'];
  input: InputEnableOrDisableChannel;
};

export type MutationenrollConferenceArgs = {
  callSid: Scalars['String']['input'];
  input: InputCallTransfer;
};

export type MutationestimateRenewFailedSubscriptionArgs = {
  input?: InputMaybe<InputRenewFailedSubscriptionInterface>;
};

export type MutationestimateUpgradeWorkspaceSubscriptionArgs = {
  input?: InputMaybe<InputEstimateUpgradeWorkspaceSubscription>;
};

export type MutationexchangeOAuthAuthorizationCodeForTokensArgs = {
  input?: InputMaybe<AuthorizeOAuthIntegrationInput>;
};

export type MutationexchangeOAuthAuthorizationCodeForTokensViaTransientTokenArgs = {
  input?: InputMaybe<AuthorizeOAuthIntegrationWithTokenInput>;
};

export type MutationexportContactsArgs = {
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Array<InputMaybe<ContactSourceTypeEnum>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type MutationexportInvoicesArgs = {
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
};

export type MutationfederatedAuthArgs = {
  input: InputFederatedAuth;
};

export type MutationfinalizePowerCampaignCallReviewArgs = {
  id: Scalars['String']['input'];
};

export type MutationforgotPasswordArgs = {
  input?: InputMaybe<InputForgotPassword>;
};

export type MutationforwardChatToEmailArgs = {
  input: InputForwardChatToEmail;
};

export type MutationgenerateAdminPinArgs = {
  input?: InputMaybe<InputPin>;
};

export type MutationhangUpConferenceArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputHangUpConference>;
};

export type MutationintegrateArgs = {
  integrationId: Scalars['Int']['input'];
};

export type MutationloadWalletArgs = {
  input: LoadWalletInput;
};

export type MutationlogOAuthAuthorizationErrorArgs = {
  input?: InputMaybe<LogOAuthAuthorizationErrorInput>;
};

export type MutationloginArgs = {
  input: InputAuthLogin;
};

export type MutationmarkAllAsSeenNotificationArgs = {
  notificationId: Scalars['Int']['input'];
};

export type MutationmarkAsActiveOrAwayArgs = {
  input?: InputMaybe<InputMarkAsActiveOrAway>;
};

export type MutationmarkAsCloseOrOpenArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputMarkAsCloseOrOpen>;
};

export type MutationmarkAsSeenNotificationArgs = {
  notificationId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationmarkMemberChatAsReadArgs = {
  roomId: Scalars['Int']['input'];
};

export type MutationpauseOrResumePowerCampaignRunArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<PowerCampaignRunStatusInput>;
};

export type MutationpauseRecurringBulkMessagingCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};

export type MutationpinOrUnpinChatMessageArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputPinOrUnpinChatMessage>;
};

export type MutationpinOrUnpinMessageConversationArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputPinUnpinMessageConversation>;
};

export type MutationpinOrUnpinRecentMessageConversationArgs = {
  channelId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputPinUnpinRecentMessageConversation>;
};

export type MutationpreCheckLoginArgs = {
  input?: InputMaybe<PreCheckLogin>;
};

export type MutationpreviewPowerCampaignCallArgs = {
  input: InputPowerCampaignCall;
};

export type MutationpurchaseNumbersArgs = {
  input?: InputMaybe<InputPurchaseNumbers>;
};

export type MutationreadAllMessageArgs = {
  recentMessageConversationId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationreadMessageArgs = {
  messageConversationId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationreassignPowerCampaignContactsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<InputReassignPowerCampaignContacts>;
};

export type MutationrefreshTokenArgs = {
  input?: InputMaybe<InputRefreshToken>;
};

export type MutationrejectPaymentOrderArgs = {
  input: InputRejectPaymentOrder;
};

export type MutationreleaseChannelsArgs = {
  input?: InputMaybe<InputReleaseChannels>;
};

export type MutationremoveChannelRemovalScheduleArgs = {
  channelId: Scalars['Int']['input'];
};

export type MutationremoveFromCartArgs = {
  input?: InputMaybe<InputCart>;
};

export type MutationremoveProviderPhoneNumberArgs = {
  id: Scalars['Int']['input'];
};

export type MutationremoveProviderPhoneNumbersArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationremoveScheduledSubscriptionCancellationArgs = {
  input: ResumeSubscriptionInput;
};

export type MutationremoveSecondaryPaymentSourceArgs = {
  input?: InputMaybe<RemoveSecondaryPaymentSourceInput>;
};

export type MutationremoveWorkspaceUserWithDispositionArgs = {
  input: RemoveMemberDispositionInput;
};

export type MutationrequestRegulatoryComplianceArgs = {
  input?: InputMaybe<InputRequestRegulatoryCompliance>;
};

export type MutationresendConfirmationCodeArgs = {
  input: InputAuthResendConfirmationCode;
};

export type MutationresendEmailMfaOtpArgs = {
  input: InputSwitchEmailMfa;
};

export type MutationresendInviteWorkspaceMemberArgs = {
  input: InputResendInviteWorkspaceMember;
};

export type MutationresendMessageArgs = {
  id: Scalars['Int']['input'];
};

export type MutationresendTwoFactorAuthenticationCodeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MutationresetAdminPinArgs = {
  input?: InputMaybe<ResetPin>;
};

export type MutationrestoreCancelledSubscriptionArgs = {
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type MutationresumeRecurringBulkMessagingCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};

export type MutationrevokeArgs = {
  integrationId: Scalars['Int']['input'];
};

export type MutationrevokeInvitationTokenArgs = {
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationscheduleMessageArgs = {
  input?: InputMaybe<InputMessageSchedule>;
};

export type MutationsendChatMessageArgs = {
  input: InputChatMessage;
};

export type MutationsendInternalMessageArgs = {
  input?: InputMaybe<InputMessageConversation>;
};

export type MutationsendMessageArgs = {
  input?: InputMaybe<InputSendMessage>;
};

export type MutationsendScheduledMessageNowArgs = {
  id: Scalars['String']['input'];
};

export type MutationsendTestNotificationArgs = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  notification?: InputMaybe<InputNotification>;
};

export type MutationsetAutoRechargeConfigArgs = {
  input?: InputMaybe<InputAutoRechargeConfig>;
};

export type MutationsetAutoRechargeConfigV2Args = {
  input?: InputMaybe<InputAutoRechargeConfig>;
};

export type MutationsetAutoRecordingInCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputAutoRecording;
};

export type MutationsetAutoRecordingInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputAutoRecording;
};

export type MutationsetAutoTranscribeInCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputAutoTranscribe;
};

export type MutationsetAutoTranscribeInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputAutoTranscribe;
};

export type MutationsetBusinessAfterHoursInCallSettingArgs = {
  input: InputCallSettingBusinessAfterHours;
};

export type MutationsetBusinessAfterHoursInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputChannelSettingBusinessAfterHours;
};

export type MutationsetBusinessHoursInCallSettingArgs = {
  input: InputCallSettingBusinessHour;
};

export type MutationsetBusinessHoursInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputChannelSettingBusinessHour;
};

export type MutationsetCallForwardInCallSettingArgs = {
  input: InputCallForward;
};

export type MutationsetCallForwardInChannelSettingArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  input: InputCallForwardChannel;
};

export type MutationsetCallSettingEmailAlertsArgs = {
  id: Scalars['Int']['input'];
  input: InputEmailAlerts;
};

export type MutationsetCallSettingInChannelGroupArgs = {
  callSettingId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type MutationsetCallTransferInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
  input: InputCallSettingTransfer;
};

export type MutationsetCallTransferInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputChannelSettingCallTransfer;
};

export type MutationsetCallerIdInCallSettingArgs = {
  callerId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type MutationsetCallerIdInChannelSettingArgs = {
  callerId?: InputMaybe<Scalars['Int']['input']>;
  channelId: Scalars['Int']['input'];
};

export type MutationsetCallerTuneInCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputCallerTune;
};

export type MutationsetCallerTuneInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputCallerTune;
};

export type MutationsetChannelGroupsInCallSettingArgs = {
  channelGroupIds: Array<InputMaybe<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
};

export type MutationsetChannelSettingEmailAlertsArgs = {
  channelId: Scalars['Int']['input'];
  input: InputEmailAlerts;
};

export type MutationsetChannelsInGroupArgs = {
  input: InputSetChannelsInGroup;
};

export type MutationsetDefaultChannelArgs = {
  channelId: Scalars['Int']['input'];
};

export type MutationsetDefaultCountryArgs = {
  input?: InputMaybe<InputSetDefaultCountry>;
};

export type MutationsetIvrInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
  input: InputIvr;
};

export type MutationsetIvrInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputChannelSettingIvr;
};

export type MutationsetLowBalanceAlertArgs = {
  balanceThreshold?: InputMaybe<Scalars['Int']['input']>;
  isEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationsetMissedCallEmailInCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputMissedCallEmail;
};

export type MutationsetMissedCallEmailInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputMissedCallEmail;
};

export type MutationsetRecordingAnnouncementInCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputRecordingAnnouncement;
};

export type MutationsetRecordingAnnouncementInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputRecordingAnnouncement;
};

export type MutationsetSecondaryPaymentSourceArgs = {
  input?: InputMaybe<SetSecondaryPaymentSourceInput>;
};

export type MutationsetTimeoutInCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputTimeout;
};

export type MutationsetTimeoutInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputTimeout;
};

export type MutationsetUpEmailMfaArgs = {
  input: InputEmailMfa;
};

export type MutationsetUsageReportNotificationArgs = {
  input: InputSetUsageReportNotification;
};

export type MutationsetVoicemailInCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputCallSettingVoiceMail;
};

export type MutationsetVoicemailInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputCallSettingVoiceMail;
};

export type MutationsetWelcomeMessageInCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputCallSettingWelcomeMessage;
};

export type MutationsetWelcomeMessageInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  input: InputCallSettingWelcomeMessage;
};

export type MutationsetWorkspacePreferredContactMethodsArgs = {
  input?: InputMaybe<InputWorkspacePreferredContactMethod>;
};

export type MutationsignOutArgs = {
  input?: InputMaybe<InputRefreshToken>;
};

export type MutationsignUpArgs = {
  input: InputAuthSignUp;
};

export type MutationsignUpV2Args = {
  input: InputAuthSignUpV2;
};

export type MutationstartPowerCampaignsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MutationsubscribeNumberPlanArgs = {
  input: NumberSubscriptionInput;
};

export type MutationsubscribeWorkspacePlanAndInviteUserArgs = {
  input?: InputMaybe<CreateSubscriptionInput>;
};

export type MutationsuperviseConferenceArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputSuperviseConference>;
};

export type MutationswitchCallArgs = {
  id: Scalars['Int']['input'];
  input: InputSwitchCall;
};

export type MutationswitchPrimaryPaymentSourceArgs = {
  input?: InputMaybe<SwitchPaymentSourceInput>;
};

export type MutationswitchToChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type MutationswitchToEmailMfaArgs = {
  input: InputSwitchEmailMfa;
};

export type MutationswitchUiVersionArgs = {
  uiVersion: UiVersionEnum;
};

export type MutationterminateRecurringBulkMessagingCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};

export type MutationtoggleChannelNotificationArgs = {
  input: InputToggleChannelNotification;
};

export type MutationtoggleChannelPinArgs = {
  channelId: Scalars['Int']['input'];
};

export type MutationtoggleIntegrationChannelStatusArgs = {
  input?: InputMaybe<InputIntegrationChannel>;
};

export type MutationtoggleMissedCallEmailNotificationArgs = {
  id: Scalars['Int']['input'];
  input: InputToggleMissedCallEmailNotification;
};

export type MutationtoggleReadNotificationArgs = {
  notificationId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationtoggleStrategyGroupArgs = {
  input: InputStrategyGroup;
};

export type MutationunAssignMemberFromChannelArgs = {
  input: InputUnAssignChannelMember;
};

export type MutationunEnrollConferenceArgs = {
  supervisionId: Scalars['String']['input'];
};

export type MutationunSuperviseConferenceArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputUnSuperviseConference>;
};

export type MutationunassignPhoneNumberFromCampaignArgs = {
  channelIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type MutationunassignTagsFromContactArgs = {
  input?: InputMaybe<AssignUnassignContactTag>;
};

export type MutationunsetSecondaryPaymentSourceArgs = {
  input: UnsetSecondaryPaymentSourceInput;
};

export type MutationupdateAttributeArgs = {
  id: Scalars['Int']['input'];
  input: InputAttribute;
};

export type MutationupdateAttributeValueArgs = {
  id: Scalars['Int']['input'];
  input: InputAttributeValue;
};

export type MutationupdateBulkMessagingCampaignArgs = {
  campaignId: Scalars['Int']['input'];
  input?: InputMaybe<InputBulkMessagingCampaign>;
};

export type MutationupdateBusinessAddressArgs = {
  input?: InputMaybe<InputBusinessAddress>;
};

export type MutationupdateBusinessProfileArgs = {
  input?: InputMaybe<createBusinessProfileInput>;
};

export type MutationupdateCallSettingArgs = {
  id: Scalars['Int']['input'];
  input: InputCallSetting;
};

export type MutationupdateCallerIdArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputUpdateVerifyCallerId>;
};

export type MutationupdateChannelArgs = {
  id: Scalars['Int']['input'];
  input: InputChannel;
};

export type MutationupdateChannelGroupArgs = {
  id: Scalars['Int']['input'];
  input: InputChannelGroup;
};

export type MutationupdateCommandResponseArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<CommandResponseInput>;
};

export type MutationupdateContactArgs = {
  id: Scalars['Int']['input'];
  input: InputContact;
};

export type MutationupdateContactNoteArgs = {
  id: Scalars['Int']['input'];
  input: InputContactNote;
};

export type MutationupdateCustomerBillingAddressArgs = {
  input?: InputMaybe<InputBillingInfo>;
};

export type MutationupdateIncomingPhoneNumberArgs = {
  _id: Scalars['String']['input'];
  input?: InputMaybe<InputIncomingPhoneDocumentNumber>;
};

export type MutationupdateIntegrationWebhooksArgs = {
  input?: InputMaybe<Array<InputMaybe<InputUpdateIntegrationWebhook>>>;
};

export type MutationupdatePlanItemPriceArgs = {
  input: PlanItemPriceInput;
};

export type MutationupdatePlanPriceArgs = {
  id: Scalars['Int']['input'];
  input: InputPlanPrice;
};

export type MutationupdatePowerCampaignArgs = {
  id: Scalars['Int']['input'];
  input: InputPowerCampaignInterface;
};

export type MutationupdatePowerCampaignContactDetailsArgs = {
  input?: InputMaybe<UpdatePowerCampaignContactDetails>;
};

export type MutationupdatePowerCampaignDispositionContactArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<InputPowerCampaignDispositionContact>;
};

export type MutationupdatePowerDispositionArgs = {
  id: Scalars['Int']['input'];
  input: InputPowerDispositionInterface;
};

export type MutationupdatePushCredentialTokenStatusArgs = {
  input: InputPushCredentialTokenStatus;
  token: Scalars['String']['input'];
  type: PushCredentialTypeEnum;
};

export type MutationupdateScheduledMessageArgs = {
  id: Scalars['String']['input'];
  input: UpdateMessageSchedule;
};

export type MutationupdateTagArgs = {
  id: Scalars['Int']['input'];
  input: InputTag;
};

export type MutationupdateTeamMemberArgs = {
  id: Scalars['Int']['input'];
  input: UpdateTeamMembersInterface;
};

export type MutationupdateTeamsArgs = {
  id: Scalars['String']['input'];
  input: updateTeamsInput;
};

export type MutationupdateWorkspaceMemberArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input: UpdateInviteWorkspaceMember;
};

export type MutationupdateWorkspaceMemberV2Args = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input: UpdateInviteWorkspaceMemberV2;
};

export type MutationupgradeWorkspaceSubscriptionArgs = {
  input?: InputMaybe<UpgradeWorkspaceSubscriptionInput>;
};

export type MutationuploadWorkspaceDetailDocumentsArgs = {
  input?: InputMaybe<InputWorkspaceDetailDocuments>;
};

export type MutationverifyAndEnableTOTPMfaArgs = {
  input: InputEnabledTOTPMfa;
};

export type MutationverifyAndTransitionStatusArgs = {
  id: Scalars['Int']['input'];
  model?: InputMaybe<VerifyAndTransitionModelEnum>;
};

export type MutationverifyCallerIdArgs = {
  input?: InputMaybe<InputVerifyCallerId>;
};

export type MutationverifyInvitationTokenArgs = {
  input?: InputMaybe<InputVerifyInvitationToken>;
};

export type MutationverifyMfaAuthenticationArgs = {
  input: InputMfaAuth;
};

export type MutationverifyPaymentRequestArgs = {
  urlToken: Scalars['String']['input'];
};

export type MutationverifyTwoFactorAuthenticationArgs = {
  input?: InputMaybe<InputVerifyTwoFactorAuthentication>;
};

export type MutationworkspaceAuthMeArgs = {
  input?: InputMaybe<InputUpdateWorkspace>;
};

export type MutationworkspaceLoginArgs = {
  input?: InputMaybe<InputWorkspaceLogin>;
};

export type MutationwrapUpCallArgs = {
  callSid: Scalars['String']['input'];
};

export type MyWidget = {
  __typename?: 'MyWidget';
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type MyWidgetGroupsRes = {
  __typename?: 'MyWidgetGroupsRes';
  data?: Maybe<Array<Maybe<UserWidgetGroup>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MyWorkspaceResponse = {
  __typename?: 'MyWorkspaceResponse';
  data?: Maybe<Workspace>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NotificationCountResponse = {
  __typename?: 'NotificationCountResponse';
  data?: Maybe<Scalars['Scalar']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NotificationDropDown = {
  __typename?: 'NotificationDropDown';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  data?: Maybe<Scalars['Scalar']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  replacementAttributes?: Maybe<Scalars['Scalar']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Scalar']['output']>;
};

export type NotificationDropdownResponse = {
  __typename?: 'NotificationDropdownResponse';
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<NotificationDropDown>;
};

export enum NotificationPlatformEnum {
  mobile = 'mobile',
  web = 'web',
}

export type NotificationSubscription = {
  __typename?: 'NotificationSubscription';
  counter?: Maybe<Scalars['Int']['output']>;
  notification?: Maybe<NotificationV2>;
  userWorkspaceId?: Maybe<Scalars['Int']['output']>;
};

export enum NotificationTypeEnum {
  featureUpdate = 'featureUpdate',
  softwareMaintenance = 'softwareMaintenance',
}

export type NotificationV2 = {
  __typename?: 'NotificationV2';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  redirection?: Maybe<RedirectionParamsData>;
  replacementAttributes?: Maybe<Array<Maybe<ReplacementAttributesData>>>;
  seenAt?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NumberAggregateReportAnalytics = {
  __typename?: 'NumberAggregateReportAnalytics';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<NumberAggregateReportAnalyticsValue>;
};

export type NumberAggregateReportAnalyticsResponse = {
  __typename?: 'NumberAggregateReportAnalyticsResponse';
  data?: Maybe<Array<Maybe<NumberAggregateReportAnalytics>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NumberAggregateReportAnalyticsValue = {
  __typename?: 'NumberAggregateReportAnalyticsValue';
  callDuration?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export enum NumberDispositionEnum {
  delete = 'delete',
  purchase = 'purchase',
}

export type NumberGraphReportAnalyticsData = {
  __typename?: 'NumberGraphReportAnalyticsData';
  inbound?: Maybe<Scalars['Int']['output']>;
  missed?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  outbound?: Maybe<Scalars['Int']['output']>;
  totalCalls?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type NumberGraphReportAnalyticsResponse = {
  __typename?: 'NumberGraphReportAnalyticsResponse';
  data?: Maybe<Array<Maybe<NumberGraphReportAnalyticsData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NumberReport = {
  __typename?: 'NumberReport';
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type NumberReportAnalyticData = {
  __typename?: 'NumberReportAnalyticData';
  callType?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type NumberReportAnalyticResponse = {
  __typename?: 'NumberReportAnalyticResponse';
  data?: Maybe<Array<Maybe<NumberReportAnalyticData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum NumberStateEnum {
  active = 'active',
  released = 'released',
}

export type NumberSubscriptionDetails = {
  __typename?: 'NumberSubscriptionDetails';
  nextBillingDate?: Maybe<Scalars['Date']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type NumberSubscriptionDetailsForDate = {
  __typename?: 'NumberSubscriptionDetailsForDate';
  amount?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Country>;
  id?: Maybe<Scalars['Int']['output']>;
  nextBillingDate?: Maybe<Scalars['Date']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
};

export type NumberSubscriptionDetailsForDateResponse = {
  __typename?: 'NumberSubscriptionDetailsForDateResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<NumberSubscriptionDetailsForDate>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NumberSubscriptionDetailsResponse = {
  __typename?: 'NumberSubscriptionDetailsResponse';
  data?: Maybe<Array<Maybe<NumberSubscriptionDetails>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NumberSubscriptionInput = {
  cartNumbers: Array<InputMaybe<CartNumberInput>>;
  gatewayAccountId: Scalars['String']['input'];
  gatewayToken?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: PaymentGatewayEnum;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type NumberSubscriptionOverview = {
  __typename?: 'NumberSubscriptionOverview';
  annuallyNumbers?: Maybe<Scalars['Int']['output']>;
  monthlyNumbers?: Maybe<Scalars['Int']['output']>;
  nextBillingDate?: Maybe<Scalars['Date']['output']>;
  nextBillingDateTotalAmount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type NumberSubscriptionPlan = {
  __typename?: 'NumberSubscriptionPlan';
  id?: Maybe<Scalars['Int']['output']>;
};

export type NumberType = {
  __typename?: 'NumberType';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export enum NumberTypeEnum {
  local = 'local',
  machine_to_machine = 'machine_to_machine',
  mobile = 'mobile',
  national = 'national',
  shared_cost = 'shared_cost',
  toll_free = 'toll_free',
  voip = 'voip',
}

export type NumbersClaimInput = {
  cartNumbers: Array<InputMaybe<CartNumberInput>>;
};

export type OAuth2CodeHash = {
  __typename?: 'OAuth2CodeHash';
  transientToken?: Maybe<Scalars['String']['output']>;
};

export enum OAuth2ThirdPartyEnum {
  PabblyConnect = 'PabblyConnect',
  Pipedrive = 'Pipedrive',
}

export type OffsetPaginationRegulatoryCompliance = {
  __typename?: 'OffsetPaginationRegulatoryCompliance';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<RegulatoryCompliance>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderByInput = {
  field: Scalars['String']['input'];
  sort: SortEnum;
};

export enum OrderEnum {
  createdAt = 'createdAt',
}

export type PageInfo = {
  __typename?: 'PageInfo';
  count?: Maybe<Scalars['Int']['output']>;
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageInfoTwilio = {
  __typename?: 'PageInfoTwilio';
  count?: Maybe<Scalars['Int']['output']>;
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationAgentSession = {
  __typename?: 'PaginationAgentSession';
  edges?: Maybe<Array<Maybe<PowerCampaignAssigneeEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationBlockedContact = {
  __typename?: 'PaginationBlockedContact';
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationCompliancePhoneNumber = {
  __typename?: 'PaginationCompliancePhoneNumber';
  edges?: Maybe<Array<Maybe<CompliancePhoneNumberEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationConferenceHistoryAnalytic = {
  __typename?: 'PaginationConferenceHistoryAnalytic';
  edges?: Maybe<Array<Maybe<ConferenceHistoryEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationIntegration = {
  __typename?: 'PaginationIntegration';
  edges?: Maybe<Array<Maybe<IntegrationEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationIntegrationChannelResponse = {
  __typename?: 'PaginationIntegrationChannelResponse';
  edges?: Maybe<Array<Maybe<IntegrationChannelEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationIntegrationUser = {
  __typename?: 'PaginationIntegrationUser';
  edges?: Maybe<Array<Maybe<IntegrationUserEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationLiveConferences = {
  __typename?: 'PaginationLiveConferences';
  edges?: Maybe<Array<Maybe<LiveConferenceEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleAddress = {
  __typename?: 'PaginationMultipleAddress';
  edges?: Maybe<Array<Maybe<AddressEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationMultipleAttribute = {
  __typename?: 'PaginationMultipleAttribute';
  edges?: Maybe<Array<Maybe<AttributeEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationMultipleAttributeValue = {
  __typename?: 'PaginationMultipleAttributeValue';
  edges?: Maybe<Array<Maybe<AttributeValueEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationMultipleCallerId = {
  __typename?: 'PaginationMultipleCallerId';
  edges?: Maybe<Array<Maybe<CallerIdEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleChannel = {
  __typename?: 'PaginationMultipleChannel';
  edges?: Maybe<Array<Maybe<ChannelEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleChannelUserWorkspace = {
  __typename?: 'PaginationMultipleChannelUserWorkspace';
  edges?: Maybe<Array<Maybe<ChannelUserWorkspaceEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleChatMessage = {
  __typename?: 'PaginationMultipleChatMessage';
  edges?: Maybe<Array<Maybe<ChatMessageEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationMultipleCommandResponse = {
  __typename?: 'PaginationMultipleCommandResponse';
  edges?: Maybe<Array<Maybe<CommandResponseEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleComplianceDropdown = {
  __typename?: 'PaginationMultipleComplianceDropdown';
  edges?: Maybe<Array<Maybe<ComplianceDropdownEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationMultipleComplianceSoleProprietorProfile = {
  __typename?: 'PaginationMultipleComplianceSoleProprietorProfile';
  edges?: Maybe<Array<Maybe<ComplianceSoleProprietorProfileEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationMultipleContact = {
  __typename?: 'PaginationMultipleContact';
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleContactNote = {
  __typename?: 'PaginationMultipleContactNote';
  edges?: Maybe<Array<Maybe<ContactNoteEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleContactTag = {
  __typename?: 'PaginationMultipleContactTag';
  edges?: Maybe<Array<Maybe<ContactTagEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleEmailTemplateSegment = {
  __typename?: 'PaginationMultipleEmailTemplateSegment';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<EmailTemplateSegment>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationMultipleIncomingPhoneNumber = {
  __typename?: 'PaginationMultipleIncomingPhoneNumber';
  edges?: Maybe<Array<Maybe<IncomingPhoneNumberEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleMessageConversation = {
  __typename?: 'PaginationMultipleMessageConversation';
  edges?: Maybe<Array<Maybe<MessageConversationEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleMessageConversationSearch = {
  __typename?: 'PaginationMultipleMessageConversationSearch';
  edges?: Maybe<Array<Maybe<MessageConversationEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleModule = {
  __typename?: 'PaginationMultipleModule';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<Module>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationMultiplePhoneNumbers = {
  __typename?: 'PaginationMultiplePhoneNumbers';
  edges?: Maybe<Array<Maybe<PhoneNumberEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultiplePlan = {
  __typename?: 'PaginationMultiplePlan';
  edges?: Maybe<Array<Maybe<PlanEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationMultiplePrivilege = {
  __typename?: 'PaginationMultiplePrivilege';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<Privilege>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationMultipleRecentMessageConversation = {
  __typename?: 'PaginationMultipleRecentMessageConversation';
  edges?: Maybe<Array<Maybe<RecentMessageConversationEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleRecording = {
  __typename?: 'PaginationMultipleRecording';
  edges?: Maybe<Array<Maybe<RecordingEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleRegulatoryCompliance = {
  __typename?: 'PaginationMultipleRegulatoryCompliance';
  edges?: Maybe<Array<Maybe<RegulatoryComplianceEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleReleasedChannels = {
  __typename?: 'PaginationMultipleReleasedChannels';
  edges?: Maybe<Array<Maybe<ChannelEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleRole = {
  __typename?: 'PaginationMultipleRole';
  edges?: Maybe<Array<Maybe<RoleEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationMultipleScreen = {
  __typename?: 'PaginationMultipleScreen';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<Screen>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationMultipleScreenPlanMapping = {
  __typename?: 'PaginationMultipleScreenPlanMapping';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<ScreenPlanMapping>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationMultipleScreenRoleMapping = {
  __typename?: 'PaginationMultipleScreenRoleMapping';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<ScreenRoleMapping>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationMultipleTag = {
  __typename?: 'PaginationMultipleTag';
  edges?: Maybe<Array<Maybe<TagEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationMultipleWorkspaceMember = {
  __typename?: 'PaginationMultipleWorkspaceMember';
  edges?: Maybe<Array<Maybe<WorkspaceAuthEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPlanPrice = {
  __typename?: 'PaginationPlanPrice';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<PlanPrice>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationPlanPrices = {
  __typename?: 'PaginationPlanPrices';
  edges?: Maybe<Array<Maybe<PlanPriceEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerCampaignCallHistory = {
  __typename?: 'PaginationPowerCampaignCallHistory';
  edges?: Maybe<Array<Maybe<PowerCampaignCallHistoryEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerCampaignCallQueue = {
  __typename?: 'PaginationPowerCampaignCallQueue';
  edges?: Maybe<Array<Maybe<PowerCampaignCallQueueEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerCampaignCallsByStatus = {
  __typename?: 'PaginationPowerCampaignCallsByStatus';
  edges?: Maybe<Array<Maybe<PowerCampaignCallsByStatusEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerCampaignDispositions = {
  __typename?: 'PaginationPowerCampaignDispositions';
  edges?: Maybe<Array<Maybe<PowerCampaignDispositionEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerCampaignError = {
  __typename?: 'PaginationPowerCampaignError';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<PowerCampaignError>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationPowerCampaigns = {
  __typename?: 'PaginationPowerCampaigns';
  edges?: Maybe<Array<Maybe<PowerCampaignEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerDialerDashboardCall = {
  __typename?: 'PaginationPowerDialerDashboardCall';
  edges?: Maybe<Array<Maybe<PowerDialerDashboardCallEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerDisposition = {
  __typename?: 'PaginationPowerDisposition';
  edges?: Maybe<Array<Maybe<PowerDispositionEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerDispositionContact = {
  __typename?: 'PaginationPowerDispositionContact';
  edges?: Maybe<Array<Maybe<PowerCampaignDispositionContactEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationPowerImport = {
  __typename?: 'PaginationPowerImport';
  edges?: Maybe<Array<Maybe<PowerImportEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationRecentCallLogs = {
  __typename?: 'PaginationRecentCallLogs';
  edges?: Maybe<Array<Maybe<RecentCallLogsEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationTeamMembers = {
  __typename?: 'PaginationTeamMembers';
  edges?: Maybe<Array<Maybe<TeamMemberEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationTeams = {
  __typename?: 'PaginationTeams';
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationUser = {
  __typename?: 'PaginationUser';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<User>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationUserRole = {
  __typename?: 'PaginationUserRole';
  edges?: Maybe<Array<Maybe<UserRoleEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationWorkspace = {
  __typename?: 'PaginationWorkspace';
  edges?: Maybe<Array<Maybe<WorkspaceEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationWorkspaceDetail = {
  __typename?: 'PaginationWorkspaceDetail';
  edges?: Maybe<Array<Maybe<WorkspaceDetailEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginationWorkspaceMemberAnalytic = {
  __typename?: 'PaginationWorkspaceMemberAnalytic';
  edges?: Maybe<Array<Maybe<WorkspaceMemberAnalyticEdge>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaginationWorkspaceSubaccountActivityLog = {
  __typename?: 'PaginationWorkspaceSubaccountActivityLog';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<WorkspaceSubaccountActivityLog>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Participant = {
  __typename?: 'Participant';
  accountSid?: Maybe<Scalars['String']['output']>;
  callSid?: Maybe<Scalars['String']['output']>;
  callSidToCoach?: Maybe<Scalars['String']['output']>;
  coaching?: Maybe<Scalars['Boolean']['output']>;
  conferenceSid?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  dateUpdated?: Maybe<Scalars['Date']['output']>;
  endConferenceOnExit?: Maybe<Scalars['Boolean']['output']>;
  hold?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  muted?: Maybe<Scalars['Boolean']['output']>;
  startConferenceOnEnter?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Participants = {
  __typename?: 'Participants';
  edges?: Maybe<Array<Maybe<Participant>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<PageInfoTwilio>;
};

export type PaymentCollectionResponse = {
  __typename?: 'PaymentCollectionResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PaymentGatewayEnum {
  chargebee = 'chargebee',
  paypal = 'paypal',
  stripe = 'stripe',
}

export enum PaymentIntentCurrencyCodeEnum {
  EUR = 'EUR',
  INR = 'INR',
  USD = 'USD',
}

export type PaymentIntentInput = {
  addWorkspaceMember?: InputMaybe<AddWorkspaceMemberIntentInput>;
  brandCharge?: InputMaybe<BrandChargeInput>;
  gatewayAccountId?: InputMaybe<Scalars['String']['input']>;
  loadWallet?: InputMaybe<LoadWalletIntentInput>;
  paymentGateway: PaymentGatewayEnum;
  paymentIntentPurpose: PaymentIntentPurposeEnum;
  paymentRequest?: InputMaybe<PaymentRequestIntentInput>;
  purchaseNumbers?: InputMaybe<PurchaseNumbersIntentInput>;
  soleProprietorCampaignCharge?: InputMaybe<SoleProprietorCampaignChargeInput>;
  subscribeWorkspacePlan?: InputMaybe<SubscribeWorkspacePlanIntentInput>;
  upgradeWorkspaceSubscription?: InputMaybe<UpgradeWorkspaceSubscriptionIntentInput>;
};

export enum PaymentIntentPurposeEnum {
  add_payment_source = 'add_payment_source',
  add_workspace_member = 'add_workspace_member',
  brand_charge = 'brand_charge',
  load_wallet = 'load_wallet',
  payment_request = 'payment_request',
  purchase_numbers = 'purchase_numbers',
  sole_proprietor_campaign_charge = 'sole_proprietor_campaign_charge',
  subscribe_workspace_plan = 'subscribe_workspace_plan',
  upgrade_workspace_subscription = 'upgrade_workspace_subscription',
}

export type PaymentOrder = {
  __typename?: 'PaymentOrder';
  batchId?: Maybe<Scalars['String']['output']>;
  cartAmount?: Maybe<Scalars['Int']['output']>;
  chargedAmount?: Maybe<Scalars['Int']['output']>;
  clientRequestId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  dunningAttempt?: Maybe<Scalars['Int']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemsQuantity?: Maybe<Scalars['Int']['output']>;
  lienStatus?: Maybe<PaymentOrderLienStatusEnum>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  remarks?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PaymentOrderTypeEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updater?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentOrderItem = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export enum PaymentOrderLienStatusEnum {
  amount_blocked = 'amount_blocked',
  amount_debited = 'amount_debited',
  amount_released = 'amount_released',
  cancelled = 'cancelled',
  confirmation_requested = 'confirmation_requested',
}

export type PaymentOrderResponse = {
  __typename?: 'PaymentOrderResponse';
  data?: Maybe<PaymentOrder>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PaymentOrderStatusEnum {
  cancelled = 'cancelled',
  completed = 'completed',
  failed = 'failed',
  insufficient_amount = 'insufficient_amount',
  not_paid = 'not_paid',
  payment_due = 'payment_due',
  pending = 'pending',
  processing = 'processing',
}

export enum PaymentOrderTypeEnum {
  a2p_sole_proprietor_brand_charge = 'a2p_sole_proprietor_brand_charge',
  a2p_sole_proprietor_campaign_charge = 'a2p_sole_proprietor_campaign_charge',
  a2p_sole_proprietor_campaign_one_time_charge = 'a2p_sole_proprietor_campaign_one_time_charge',
  a2p_sole_proprietor_campaign_subscription = 'a2p_sole_proprietor_campaign_subscription',
  exclusive_number_purchase = 'exclusive_number_purchase',
  number_migration = 'number_migration',
  number_purchase = 'number_purchase',
  number_renewal = 'number_renewal',
  port_in_number_configuration = 'port_in_number_configuration',
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  amount: Scalars['Float']['output'];
  currency: ChargeBeeCurrencyCodeEnum;
  id: Scalars['Int']['output'];
  paymentReceivedAt?: Maybe<Scalars['Date']['output']>;
  purpose: PaymentRequestPurposeEnum;
  remarks?: Maybe<Scalars['String']['output']>;
  requestedDate?: Maybe<Scalars['Date']['output']>;
  status: PaymentRequestStatusEnum;
  urlToken?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars['Int']['output'];
};

export type PaymentRequestCountResponse = {
  __typename?: 'PaymentRequestCountResponse';
  count: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentRequestInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentRequestIntentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentRequestItem = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentRequestListResponse = {
  __typename?: 'PaymentRequestListResponse';
  count: Scalars['Int']['output'];
  data: Array<PaymentRequest>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PaymentRequestPurposeEnum {
  a2p_low_volume = 'a2p_low_volume',
  exclusive_numbers = 'exclusive_numbers',
  port_in = 'port_in',
}

export enum PaymentRequestStatusEnum {
  cancelled = 'cancelled',
  created = 'created',
  failed = 'failed',
  link_expired = 'link_expired',
  paid = 'paid',
  pending = 'pending',
}

export type PaymentRequestV2 = {
  __typename?: 'PaymentRequestV2';
  amount: Scalars['Float']['output'];
  currency: ChargeBeeCurrencyCodeEnum;
  id: Scalars['Int']['output'];
  paymentReceivedAt?: Maybe<Scalars['Date']['output']>;
  purpose: PaymentRequestPurposeEnum;
  remarks?: Maybe<Scalars['String']['output']>;
  requestedDate?: Maybe<Scalars['Date']['output']>;
  status: PaymentRequestStatusEnum;
  urlToken?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
};

export type PaymentSource = {
  __typename?: 'PaymentSource';
  card?: Maybe<Card>;
  gatewayAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  isSecondary?: Maybe<Scalars['Boolean']['output']>;
  paymentGateway?: Maybe<PaymentGatewayEnum>;
  paypal?: Maybe<Paypal>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentSourceStatusEnum>;
};

export type PaymentSourceInput = {
  gatewayAccountId: Scalars['String']['input'];
  gatewayToken: Scalars['String']['input'];
};

export type PaymentSourceResponse = {
  __typename?: 'PaymentSourceResponse';
  data?: Maybe<PaymentSource>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PaymentSourceStatusEnum {
  expired = 'expired',
  expiring = 'expiring',
  invalid = 'invalid',
  pending_verification = 'pending_verification',
  valid = 'valid',
}

export type PaymentSourcesResponse = {
  __typename?: 'PaymentSourcesResponse';
  data?: Maybe<Array<Maybe<PaymentSource>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Paypal = {
  __typename?: 'Paypal';
  email?: Maybe<Scalars['String']['output']>;
};

export enum PeriodicityEnum {
  month = 'month',
  year = 'year',
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<TwilioPhoneNumber>;
  purchaseBy?: Maybe<UserWorkspace>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PhoneNumberStatusEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workspace?: Maybe<Workspace>;
};

export type PhoneNumberCursorPaginationV2 = {
  __typename?: 'PhoneNumberCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<PhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberEdge = {
  __typename?: 'PhoneNumberEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PhoneNumber>;
};

export type PhoneNumberPrice = {
  __typename?: 'PhoneNumberPrice';
  base_price?: Maybe<Scalars['String']['output']>;
  current_price?: Maybe<Scalars['String']['output']>;
  number_type?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberStatusCount = {
  __typename?: 'PhoneNumberStatusCount';
  activeCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  releasedAndScheduledChannelsCount?: Maybe<Scalars['Int']['output']>;
};

export type PhoneNumberStatusCountResponse = {
  __typename?: 'PhoneNumberStatusCountResponse';
  data?: Maybe<PhoneNumberStatusCount>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PhoneNumberStatusEnum {
  billing_complete = 'billing_complete',
  billing_complete_notify_failed = 'billing_complete_notify_failed',
  charge_created = 'charge_created',
  completed = 'completed',
  document_required = 'document_required',
  inadequate_document = 'inadequate_document',
  invoice_created = 'invoice_created',
  number_purchased = 'number_purchased',
  payment_failed = 'payment_failed',
  purchase_failed = 'purchase_failed',
  verification_in_progress = 'verification_in_progress',
}

export type PinnedMessageConversationCount = {
  __typename?: 'PinnedMessageConversationCount';
  count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PinnedRecentMessageConversationNode = {
  __typename?: 'PinnedRecentMessageConversationNode';
  node?: Maybe<RecentMessageConversation>;
};

export type Plan = {
  __typename?: 'Plan';
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  referencePlan?: Maybe<Plan>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showAmount?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PlanEdge = {
  __typename?: 'PlanEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Plan>;
};

export type PlanItemInput = {
  id: Scalars['String']['input'];
  itemFamilyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PlanItemPriceInput = {
  id: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  periodUnit?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
};

export type PlanPrice = {
  __typename?: 'PlanPrice';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  periodicity?: Maybe<PeriodicityEnum>;
  plan?: Maybe<Plan>;
  position?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
};

export type PlanPriceEdge = {
  __typename?: 'PlanPriceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PlanPrice>;
};

export type PlanSubscription = {
  __typename?: 'PlanSubscription';
  billingPeriodUnit?: Maybe<Scalars['String']['output']>;
  cancelScheduleCreatedAt?: Maybe<Scalars['Int']['output']>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currentTermEnd?: Maybe<Scalars['Date']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  discountItems?: Maybe<Array<Maybe<DiscountResponse>>>;
  hasScheduledChanges?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  itemProductFamily?: Maybe<Scalars['String']['output']>;
  mrr?: Maybe<Scalars['Int']['output']>;
  nextBillingAt?: Maybe<Scalars['Int']['output']>;
  remainingBillingCycles?: Maybe<Scalars['Int']['output']>;
  scheduledChanges?: Maybe<SubscriptionScheduledChanges>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionItems?: Maybe<Array<Maybe<PlanSubscriptionItem>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PlanSubscriptionItem = {
  __typename?: 'PlanSubscriptionItem';
  amount?: Maybe<Scalars['Int']['output']>;
  itemPriceId?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export type PlanSubscriptionResponse = {
  __typename?: 'PlanSubscriptionResponse';
  data?: Maybe<PlanSubscription>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PlanSubscriptionsResponse = {
  __typename?: 'PlanSubscriptionsResponse';
  edges?: Maybe<Array<Maybe<PlanSubscription>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PlanTypeEnum {
  basic = 'basic',
  business = 'business',
  custom = 'custom',
}

export enum PlatformEnum {
  android = 'android',
  ios = 'ios',
  web = 'web',
}

export type PowerCampaign = {
  __typename?: 'PowerCampaign';
  assignedType?: Maybe<PowerCampaignAssignedTypeEnum>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelPhoneNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maxAttempts?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postCallDuration?: Maybe<Scalars['Int']['output']>;
  postCallDurationUnit?: Maybe<PowerCampaignCallDurationUnitEnum>;
  powerCampaignAssignee?: Maybe<Array<Maybe<PowerCampaignAssignee>>>;
  powerCampaignDisposition?: Maybe<Array<Maybe<PowerCampaignDisposition>>>;
  powerCampaignReceiver?: Maybe<Array<Maybe<PowerCampaignReceiver>>>;
  powerCampaignRuns?: Maybe<Array<Maybe<PowerCampaignRuns>>>;
  previewDuration?: Maybe<Scalars['Int']['output']>;
  previewDurationUnit?: Maybe<PowerCampaignCallDurationUnitEnum>;
  retryPeriod?: Maybe<Scalars['Int']['output']>;
  retryPeriodUnit?: Maybe<PowerCampaignCallDurationUnitEnum>;
  status?: Maybe<CampaignStatusEnum>;
};

export enum PowerCampaignAssignedTypeEnum {
  member = 'member',
  team = 'team',
}

export type PowerCampaignAssignee = {
  __typename?: 'PowerCampaignAssignee';
  callQueue?: Maybe<PowerCampaignCallQueue>;
  powerCampaign?: Maybe<PowerCampaign>;
  team?: Maybe<TeamsInterface>;
  user?: Maybe<User>;
};

export type PowerCampaignAssigneeDTO = {
  __typename?: 'PowerCampaignAssigneeDTO';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PowerCampaignAssigneeEdge = {
  __typename?: 'PowerCampaignAssigneeEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerCampaignAssignee>;
};

export type PowerCampaignAssigneesResponse = {
  __typename?: 'PowerCampaignAssigneesResponse';
  data?: Maybe<Array<Maybe<PowerCampaignAssigneeDTO>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PowerCampaignCall = {
  __typename?: 'PowerCampaignCall';
  callDuration?: Maybe<Scalars['String']['output']>;
  callStartedAt?: Maybe<Scalars['Date']['output']>;
  channel?: Maybe<Channel>;
  channelPhoneNumber?: Maybe<Scalars['String']['output']>;
  client?: Maybe<PowerCampaignContact>;
  clientId?: Maybe<Scalars['Int']['output']>;
  clientPhoneNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageConversation?: Maybe<PowerCampaignMessageConversation>;
  messageConversationStatus?: Maybe<Scalars['String']['output']>;
  powerCampaign?: Maybe<PowerCampaign>;
  powerCampaignCallQueue?: Maybe<PowerCampaignCallQueue>;
  powerCampaignRun?: Maybe<PowerCampaignRuns>;
  previewStartedAt?: Maybe<Scalars['Date']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PowerCampaignCallStatusEnum>;
  user?: Maybe<User>;
};

export enum PowerCampaignCallDurationUnitEnum {
  hr = 'hr',
  min = 'min',
  sec = 'sec',
}

export type PowerCampaignCallHistoryEdge = {
  __typename?: 'PowerCampaignCallHistoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerCampaignCall>;
};

export type PowerCampaignCallQueue = {
  __typename?: 'PowerCampaignCallQueue';
  assignedTo?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  powerCampaignCalls?: Maybe<PowerCampaignCall>;
  powerCampaignId?: Maybe<Scalars['Int']['output']>;
  powerCampaignRunId?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export type PowerCampaignCallQueueEdge = {
  __typename?: 'PowerCampaignCallQueueEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerCampaignCallQueue>;
};

export type PowerCampaignCallStatusCount = {
  __typename?: 'PowerCampaignCallStatusCount';
  data?: Maybe<Array<Maybe<PowerCampaignCallStatusCountData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PowerCampaignCallStatusCountData = {
  __typename?: 'PowerCampaignCallStatusCountData';
  key?: Maybe<PowerCampaignCallStatusCountEnum>;
  value?: Maybe<Scalars['Int']['output']>;
};

export enum PowerCampaignCallStatusCountEnum {
  agentSessionCount = 'agentSessionCount',
  completedCallCount = 'completedCallCount',
  missedCallCount = 'missedCallCount',
  totalCallCount = 'totalCallCount',
}

export enum PowerCampaignCallStatusEnum {
  completed = 'completed',
  connected = 'connected',
  disconnected = 'disconnected',
  failed = 'failed',
  initiated = 'initiated',
  pending = 'pending',
  rescheduled = 'rescheduled',
}

export type PowerCampaignCallsByStatusEdge = {
  __typename?: 'PowerCampaignCallsByStatusEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerCampaignCall>;
};

export type PowerCampaignContact = {
  __typename?: 'PowerCampaignContact';
  clientDisposition?: Maybe<PowerCampaignDispositionContact>;
  clientDispositions?: Maybe<Array<Maybe<PowerCampaignDispositionContact>>>;
  contactNotes?: Maybe<Array<Maybe<ContactNote>>>;
  country?: Maybe<Country>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type PowerCampaignContactDetails = {
  __typename?: 'PowerCampaignContactDetails';
  data?: Maybe<Array<Maybe<PowerCampaignCall>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PowerCampaignDisposition = {
  __typename?: 'PowerCampaignDisposition';
  campaign?: Maybe<PowerCampaign>;
  disposition?: Maybe<PowerDisposition>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type PowerCampaignDispositionContact = {
  __typename?: 'PowerCampaignDispositionContact';
  campaignDisposition?: Maybe<PowerCampaignDisposition>;
  contact?: Maybe<PowerCampaignContact>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type PowerCampaignDispositionContactEdge = {
  __typename?: 'PowerCampaignDispositionContactEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerCampaignDispositionContact>;
};

export type PowerCampaignDispositionContactResponse = {
  __typename?: 'PowerCampaignDispositionContactResponse';
  data?: Maybe<PowerCampaignDispositionContact>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PowerCampaignDispositionEdge = {
  __typename?: 'PowerCampaignDispositionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerCampaignDisposition>;
};

export type PowerCampaignEdge = {
  __typename?: 'PowerCampaignEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerCampaign>;
};

export type PowerCampaignError = {
  __typename?: 'PowerCampaignError';
  channelId?: Maybe<Scalars['Int']['output']>;
  channelPhoneNumber?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  failureLog?: Maybe<Scalars['String']['output']>;
  failureType?: Maybe<Scalars['String']['output']>;
  membersNotAuthorized?: Maybe<Array<Maybe<MembersNotAuthorized>>>;
};

export type PowerCampaignMessageConversation = {
  __typename?: 'PowerCampaignMessageConversation';
  id?: Maybe<Scalars['Int']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
};

export type PowerCampaignReceiver = {
  __typename?: 'PowerCampaignReceiver';
  id?: Maybe<Scalars['Int']['output']>;
  powerImport?: Maybe<PowerImport>;
};

export type PowerCampaignResponse = {
  __typename?: 'PowerCampaignResponse';
  data?: Maybe<PowerCampaign>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PowerCampaignRunResponse = {
  __typename?: 'PowerCampaignRunResponse';
  data?: Maybe<PowerCampaignRuns>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PowerCampaignRunStatusEnum {
  completed = 'completed',
  created = 'created',
  failed = 'failed',
  in_progress = 'in_progress',
  paused = 'paused',
  pending = 'pending',
}

export type PowerCampaignRunStatusInput = {
  status?: InputMaybe<PowerCampaignRunStatusEnum>;
};

export type PowerCampaignRuns = {
  __typename?: 'PowerCampaignRuns';
  calledContactCount?: Maybe<Scalars['Int']['output']>;
  calledContactCountByMember?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  powerCampaignCalls?: Maybe<Array<Maybe<PowerCampaignCall>>>;
  powerCampaignId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<PowerCampaignRunStatusEnum>;
  totalContactCount?: Maybe<Scalars['Int']['output']>;
  totalContactCountAssignedToMember?: Maybe<Scalars['Int']['output']>;
};

export type PowerDialerDashboardCallCount = {
  __typename?: 'PowerDialerDashboardCallCount';
  completeCall: Scalars['Int']['output'];
  liveCall: Scalars['Int']['output'];
  missedCall: Scalars['Int']['output'];
  totalCall: Scalars['Int']['output'];
};

export type PowerDialerDashboardCallCountResponse = {
  __typename?: 'PowerDialerDashboardCallCountResponse';
  data?: Maybe<PowerDialerDashboardCallCount>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PowerDialerDashboardCallEdge = {
  __typename?: 'PowerDialerDashboardCallEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerCampaignCall>;
};

export type PowerDisposition = {
  __typename?: 'PowerDisposition';
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalContacts?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PowerDispositionContact = {
  __typename?: 'PowerDispositionContact';
  clientDispositions?: Maybe<Array<Maybe<PowerCampaignDispositionContact>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type PowerDispositionContactEdge = {
  __typename?: 'PowerDispositionContactEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerDispositionContact>;
};

export type PowerDispositionEdge = {
  __typename?: 'PowerDispositionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerDisposition>;
};

export type PowerDispositionResponse = {
  __typename?: 'PowerDispositionResponse';
  data?: Maybe<PowerDisposition>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PowerImport = {
  __typename?: 'PowerImport';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PowerImportStatusEnum>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  validCount?: Maybe<Scalars['Int']['output']>;
};

export type PowerImportEdge = {
  __typename?: 'PowerImportEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PowerImport>;
};

export enum PowerImportStatusEnum {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending',
}

export type PowerImportUploadStatusResponse = {
  __typename?: 'PowerImportUploadStatusResponse';
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  validCount?: Maybe<Scalars['Int']['output']>;
};

export type PreCheckLogin = {
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type PreCheckLoginData = {
  __typename?: 'PreCheckLoginData';
  platformExists?: Maybe<Scalars['Boolean']['output']>;
};

export type PreCheckLoginResponse = {
  __typename?: 'PreCheckLoginResponse';
  data?: Maybe<PreCheckLoginData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Privilege = {
  __typename?: 'Privilege';
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  module?: Maybe<Module>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PrivilegeEdge = {
  __typename?: 'PrivilegeEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Privilege>;
};

export type PromoCodeListResponse = {
  __typename?: 'PromoCodeListResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<CouponCode>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PromoCodeUsers = {
  __typename?: 'PromoCodeUsers';
  couponAssociatedWorkspace?: Maybe<Workspace>;
};

export type PromoCodeUsersListResponse = {
  __typename?: 'PromoCodeUsersListResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<PromoCodeUsers>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Promotion = {
  __typename?: 'Promotion';
  couponCodes?: Maybe<Array<Maybe<CouponCode>>>;
};

export type PromotionListResponse = {
  __typename?: 'PromotionListResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Promotions>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PromotionResponse = {
  __typename?: 'PromotionResponse';
  data?: Maybe<Promotions>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PromotionStatusEnum {
  active = 'active',
  archived = 'archived',
  deleted = 'deleted',
  expired = 'expired',
  inactive = 'inactive',
}

export type Promotions = {
  __typename?: 'Promotions';
  affiliatorEmail?: Maybe<Scalars['String']['output']>;
  affiliatorName?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<CouponPeriodicityEnum>;
  couponGroup?: Maybe<CouponGroup>;
  couponType?: Maybe<CouponTypeEnum>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<CouponDiscountTypeEnum>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  introducerEmail?: Maybe<Scalars['String']['output']>;
  introducerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPromoCodes?: Maybe<Scalars['Int']['output']>;
  numberOfRedemptions?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<CouponOriginEnum>;
  planPriceId?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<PromotionStatusEnum>;
  termDuration?: Maybe<Scalars['Int']['output']>;
  termLimit?: Maybe<CouponTermLimitEnum>;
};

export type ProviderAccount = {
  __typename?: 'ProviderAccount';
  sid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WorkspaceProviderSubaccountStatusEnum>;
  systemSuspend?: Maybe<WorkspaceProviderSubAccountSuspendedReasonEnum>;
};

export enum ProviderCategoryEnum {
  auth = 'auth',
  messaging = 'messaging',
  voice = 'voice',
}

export type ProviderErrorLogResponse = {
  __typename?: 'ProviderErrorLogResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type ProviderLogin = {
  __typename?: 'ProviderLogin';
  data?: Maybe<ProviderToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ProviderMessagingPricing = {
  __typename?: 'ProviderMessagingPricing';
  edges?: Maybe<Scalars['Scalar']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ProviderPhoneNumberPricing = {
  __typename?: 'ProviderPhoneNumberPricing';
  country?: Maybe<Scalars['String']['output']>;
  isoCountry?: Maybe<Scalars['String']['output']>;
  phoneNumberPrices?: Maybe<Array<Maybe<PhoneNumberPrice>>>;
  priceUnit?: Maybe<Scalars['String']['output']>;
};

export type ProviderToken = {
  __typename?: 'ProviderToken';
  token?: Maybe<AccessToken>;
};

export type ProviderVoicePricing = {
  __typename?: 'ProviderVoicePricing';
  edges?: Maybe<Scalars['Scalar']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PurchaseNumbersIntentInput = {
  availableNumbers: Array<InputMaybe<AvailableNumberInput>>;
  referenceId: Scalars['String']['input'];
};

export type PurchaseNumbersRes = {
  __typename?: 'PurchaseNumbersRes';
  data?: Maybe<PurchaseNumbersResData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PurchaseNumbersResData = {
  __typename?: 'PurchaseNumbersResData';
  code?: Maybe<Scalars['String']['output']>;
  duplicates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PushCredentialToken = {
  __typename?: 'PushCredentialToken';
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PushCredentialTokenStatusEnum>;
  token?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PushCredentialTypeEnum>;
};

export enum PushCredentialTokenStatusEnum {
  failed = 'failed',
  pending = 'pending',
  success = 'success',
}

export enum PushCredentialTypeEnum {
  apn = 'apn',
  fcm = 'fcm',
}

export type Query = {
  __typename?: 'Query';
  _service?: Maybe<Scalars['String']['output']>;
  activeStrategyGroup?: Maybe<ActiveStrategyGroupResult>;
  /** @deprecated Use activeWorkspacesV2 */
  activeWorkspaces?: Maybe<MultipleWorkspace>;
  activeWorkspacesV2?: Maybe<CursorPaginationActiveWorkspaces>;
  addresses?: Maybe<PaginationMultipleAddress>;
  adminAuthMe?: Maybe<AuthMeResponse>;
  adminCheckRegulatoryCompliance?: Maybe<SingleCheckRegulatoryCompliance>;
  adminEmailOtp?: Maybe<AdminEmailOtpRes>;
  adminFetchBlockedDomains?: Maybe<CursorPaginationBlockedDomain>;
  adminFetchBlockedForwardedPhoneNumbers?: Maybe<CursorPaginationBlockedForwardedPhoneNumber>;
  adminFetchBlockedIpAddresses?: Maybe<CursorPaginationBlockedIpAddress>;
  adminFetchBlockedPhoneNumbers?: Maybe<CursorPaginationBlockedPhoneNumber>;
  adminFetchBlockedSignUpEmails?: Maybe<CursorPaginationBlockedSignUpEmail>;
  adminFetchEmailTemplateSegment?: Maybe<SingleEmailTemplateSegmentResponse>;
  adminFetchEmailTemplateSegments?: Maybe<PaginationMultipleEmailTemplateSegment>;
  adminFetchModules?: Maybe<PaginationMultipleModule>;
  adminFetchPrivilege?: Maybe<SinglePrivilege>;
  adminFetchPrivileges?: Maybe<PaginationMultiplePrivilege>;
  /** @deprecated Use adminFetchScreensV2 */
  adminFetchScreens?: Maybe<PaginationMultipleScreen>;
  adminFetchScreensByPlan?: Maybe<MultipleScreens>;
  adminFetchScreensByRole?: Maybe<MultipleScreens>;
  adminFetchScreensV2?: Maybe<CursorPaginationAdminGetScreens>;
  /** @deprecated Use 'adminGetActiveChannelsV2' instead. */
  adminGetActiveChannels?: Maybe<ChannelsResponse>;
  /** @deprecated Use adminGetActiveChannelsByWorkspaceV2 instead. */
  adminGetActiveChannelsByWorkspace?: Maybe<AdminGetChannelByWorkspaceResponse>;
  adminGetActiveChannelsByWorkspaceV2?: Maybe<ChannelsByWorkspaceCursorPaginationResponse>;
  adminGetActiveChannelsCount?: Maybe<CountResponse>;
  adminGetActiveChannelsV2?: Maybe<ChannelCursorPaginationV2>;
  adminGetAvailablePhoneNumbers?: Maybe<TwilioAvailablePhoneNumber>;
  adminGetBillingDiscounts?: Maybe<AdminBillingDiscountOffsetResponse>;
  adminGetCarts?: Maybe<MultipleCart>;
  adminGetClosedWorkspaceUserDetail?: Maybe<AdminGetWorkspaceUserDetailResponse>;
  adminGetComplianceSoleProprietorStatus?: Maybe<GetComplianceSoleProprietorStatusResponse>;
  adminGetConfiguration?: Maybe<ConfigurationResponse>;
  adminGetConversationCount?: Maybe<AdminGetConversationCountResponse>;
  adminGetCustomPlan?: Maybe<AdminGetCustomPlanResponse>;
  adminGetCustomPlanById?: Maybe<AdminCreateCustomPlanResponse>;
  adminGetDeletedUser?: Maybe<SingleUser>;
  adminGetDueAmount?: Maybe<AdminGetDueAmountResponse>;
  adminGetInProcessNumbersCount?: Maybe<CountResponse>;
  adminGetInProcessNumbersV2?: Maybe<PhoneNumberCursorPaginationV2>;
  /** @deprecated Use adminGetInProcessNumbersV2 instead. */
  adminGetInProcessPhoneNumbers?: Maybe<AdminGetInProcessPhoneNumbersResponse>;
  /** @deprecated Use adminGetInProcessPhoneNumbersByWorkspaceV2 instead. */
  adminGetInProcessPhoneNumbersByWorkspace?: Maybe<AdminGetInProcessPhoneNumbersByWorkspaceResponse>;
  adminGetInProcessPhoneNumbersByWorkspaceV2?: Maybe<InProcessPhoneNumberCursorPaginationResponse>;
  adminGetIncomingPhoneNumbers?: Maybe<AdminGetIncomingPhoneNumbersResponse>;
  adminGetMessageConversationErrorLogs?: Maybe<CursorPaginationMessageConversationErrorLogs>;
  adminGetMessageConversationErrorLogsCount?: Maybe<CountResponse>;
  adminGetNotificationTemplates?: Maybe<GetNotificationTemplateResponse>;
  adminGetPreferredContactMethodsByWorkspaceId?: Maybe<WorkspacePreferredContactMethodResponse>;
  adminGetPromoCodeUsers?: Maybe<PromoCodeUsersListResponse>;
  adminGetPromoCodes?: Maybe<PromoCodeListResponse>;
  adminGetPromotion?: Maybe<PromotionResponse>;
  adminGetPromotions?: Maybe<PromotionListResponse>;
  adminGetRefund?: Maybe<RefundResponse>;
  adminGetRegulatoryComplianceStatusCallback?: Maybe<RegulatoryComplianceStatusCallbackResponse>;
  /** @deprecated Use 'adminGetReleasedChannelsV2' instead. */
  adminGetReleasedChannels?: Maybe<ChannelsResponse>;
  /** @deprecated Use adminGetReleasedChannelsByWorkspaceV2 instead. */
  adminGetReleasedChannelsByWorkspace?: Maybe<AdminGetChannelByWorkspaceResponse>;
  adminGetReleasedChannelsByWorkspaceV2?: Maybe<ChannelsByWorkspaceCursorPaginationResponse>;
  adminGetReleasedChannelsCount?: Maybe<CountResponse>;
  adminGetReleasedChannelsV2?: Maybe<ChannelCursorPaginationV2>;
  adminGetSubaccountActivityLogs?: Maybe<PaginationWorkspaceSubaccountActivityLog>;
  adminGetUnpaidUsers?: Maybe<Message>;
  adminGetUsageDetailsForMessageConversation?: Maybe<adminUsageDetailsMessageConversationResponse>;
  adminGetUserCompleteStatement?: Maybe<UserCompleteStatementResponse>;
  adminGetUserWorkspaces?: Maybe<AdminGetUserWorkspacesResponse>;
  adminGetUsers?: Maybe<PaginationUser>;
  adminGetWalletDetails?: Maybe<WalletResponse>;
  adminGetWalletDetailsV2?: Maybe<WalletResponse>;
  adminGetWalletLoadLogs?: Maybe<WalletLoadLogResponse>;
  adminGetWalletLoadLogsCount?: Maybe<CountResponse>;
  adminGetWorkspaceBillingDiscount?: Maybe<AdminBillingDiscountResponse>;
  adminGetWorkspaceBillingSubscription?: Maybe<AdminBillingSubscriptionResponse>;
  adminGetWorkspaceByEmail?: Maybe<AdminGetWorkspaceByEmailResponse>;
  adminGetWorkspaceByEmailAndStatus?: Maybe<AdminGetWorkspaceByEmailResponse>;
  adminGetWorkspaceByPhoneNumber?: Maybe<WorkspaceByPhoneNumberResponse>;
  adminGetWorkspaceChannels?: Maybe<AdminGetWorkspaceChannelsResponse>;
  /** @deprecated Use adminGetWorkspaceMembersV2 */
  adminGetWorkspaceMembers?: Maybe<AdminGetWorkspaceMembersResponse>;
  adminGetWorkspaceMembersV2?: Maybe<CursorPaginationAdminGetWorkspaceMembers>;
  adminGetWorkspaceUsers?: Maybe<AdminGetWorkspaceUsersResponse>;
  /** @deprecated Use adminGetWorkspacesV2 */
  adminGetWorkspaces?: Maybe<AdminGetWorkspacesResponse>;
  adminGetWorkspacesCountWithActiveChannels?: Maybe<WorkspaceWithChannelCountResponse>;
  adminGetWorkspacesCountWithInProcessPhoneNumbers?: Maybe<WorkspaceWithChannelCountResponse>;
  adminGetWorkspacesCountWithToBeReleasedChannels?: Maybe<WorkspaceWithChannelCountResponse>;
  adminGetWorkspacesV2?: Maybe<CursorPaginationAdminGetWorkspace>;
  adminGetWorkspacesWithActiveChannelMetrics?: Maybe<WorkspaceWithChannelMetricsResponse>;
  adminGetWorkspacesWithInProcessPhoneNumberMetrics?: Maybe<WorkspaceWithChannelMetricsResponse>;
  adminGetWorkspacesWithToBeReleasedChannelMetrics?: Maybe<WorkspaceWithChannelMetricsResponse>;
  adminListPaymentOrders?: Maybe<CursorPaginationPaymentOrders>;
  /** @deprecated Use adminListPaymentRequestsV2 */
  adminListPaymentRequests?: Maybe<PaymentRequestListResponse>;
  adminListPaymentRequestsV2?: Maybe<CursorPaginationAdminPaymentRequestsV2>;
  adminListPaymentSources?: Maybe<PaymentSourcesResponse>;
  adminListUnpaidUsers?: Maybe<CursorPaginationAdminListUnpaidUsersResponse>;
  adminMyRolePrivilege?: Maybe<MultipleScreenRoleMappings>;
  adminPlans?: Maybe<PaginationMultiplePlan>;
  adminProviderLastMonthUsage?: Maybe<MultipleAdminProviderLastMonthUsage>;
  adminReconcileStatementReport?: Maybe<AdminReconcileStatementReportResponse>;
  adminRegulatoryCompliances?: Maybe<OffsetPaginationRegulatoryCompliance>;
  adminRegulatoryCompliancesStatusSummaryCount?: Maybe<RegulatoryCompliancesStatusSummaryCount>;
  adminRoles?: Maybe<PaginationMultipleRole>;
  adminUserWorkspace?: Maybe<SingleUser>;
  adminViewByWorkspaces?: Maybe<CursorBasedViewByWorkspaces>;
  adminWorkspace?: Maybe<SingleWorkspace>;
  adminWorkspaceBillingHistory?: Maybe<AdminWorkspaceInvoicesResponse>;
  adminWorkspaceBillingHistoryV2?: Maybe<CursorPaginationBillingResponseV2>;
  agentInProgressConversation?: Maybe<AgentInProgressConversationResponse>;
  /** @deprecated Use aiAdvanceCallReportV2 */
  aiAdvanceCallReport?: Maybe<AIAdvanceCallReportResponse>;
  aiAdvanceCallReportV2?: Maybe<AiAdvanceCallReportCursorPaginationV2>;
  aiDashboardCount?: Maybe<AIDashboardCountResponse>;
  aiDashboardDayWiseSentiment?: Maybe<AIDashboardDayWiseSentimentResponse>;
  aiDashboardIntent?: Maybe<AIDashboardIntentResponse>;
  aiDashboardIntentV2?: Maybe<AiDashboardIntentCursorPaginationV2>;
  /** @deprecated Use aiDashboardMemberPerformanceV2 */
  aiDashboardMemberPerformance?: Maybe<AIDashboardMemberPerformanceResponse>;
  aiDashboardMemberPerformanceGraphReport?: Maybe<AiDashboardMemberPerformanceGraphReportResponse>;
  aiDashboardMemberPerformanceV2?: Maybe<AiDashboardMemberPerformanceCursorPaginationV2>;
  aiDashboardReportAnalytics?: Maybe<AiDashboardReportAnalyticsResponse>;
  aiDashboardSummary?: Maybe<AIDashboardSummaryResponse>;
  applicationVersioning?: Maybe<ConfigurationResponse>;
  approvedComplianceSoleProprietorBrands?: Maybe<CursorPaginationComplianceProprietorBrand>;
  areaCodes?: Maybe<CursorPaginationAreaCodes>;
  assignChannels?: Maybe<PaginationMultipleChannelUserWorkspace>;
  assignChannelsV2?: Maybe<ChannelUserWorkspaceCursorPaginationV2>;
  attribute?: Maybe<SingleAttribute>;
  attributeValue?: Maybe<SingleAttributeValue>;
  attributeValues?: Maybe<PaginationMultipleAttributeValue>;
  attributeValuesV2?: Maybe<CursorPaginationAttributeValuesV2>;
  attributes?: Maybe<PaginationMultipleAttribute>;
  attributesV2?: Maybe<CursorPaginationAttributesV2>;
  authMe?: Maybe<AuthMeResponse>;
  availablePhoneNumbers?: Maybe<TwilioAvailablePhoneNumber>;
  availablePhoneNumbersV2?: Maybe<CursorPaginationAvailablePhoneNumber>;
  averageRating?: Maybe<AverageRatingData>;
  bundle?: Maybe<SingleBundle>;
  bundles: Array<BundleList>;
  /** @deprecated Use callerIdsV2 instead */
  callerIds?: Maybe<PaginationMultipleCallerId>;
  callerIdsV2?: Maybe<CallerIdCursorPaginationV2>;
  canStartMessageConversation?: Maybe<CanStartMessageConversationResponse>;
  cannedResponsesV2?: Maybe<CursorPaginationCommandResponseV2>;
  carts?: Maybe<MultipleCart>;
  cbInvoice?: Maybe<CommonResponse>;
  channel?: Maybe<SingleChannel>;
  channelCapability?: Maybe<SingleChannel>;
  channelConversations?: Maybe<ChannelConversationCursorPagination>;
  channelGroups?: Maybe<ChannelGroupCursorPagination>;
  channelGroupsCount?: Maybe<ChannelGroupCountResponse>;
  channelMembers?: Maybe<ChannelUserWorkspaceMembersResponse>;
  channelSettingByChannelId?: Maybe<SingleChannelSetting>;
  channelStrategiesByStrategyGroup?: Maybe<ListStrategyResult>;
  /** @deprecated Use 'channelsV2' instead. */
  channels?: Maybe<PaginationMultipleChannel>;
  channelsForNewConversations?: Maybe<ChannelUserWorkspaceCursorPaginationV2>;
  channelsV2?: Maybe<ChannelCursorPaginationV2>;
  checkConfigurationAndRewardOfChannel?: Maybe<CheckConfigurationAndRewardOfChannelResponse>;
  checkMemberEmailExist?: Maybe<CheckMemberEmailExistResponse>;
  checkRegulatoryCompliance?: Maybe<SingleCheckRegulatoryCompliance>;
  clientIpAddressLogInfo?: Maybe<IpAddressInfoResponse>;
  clientUsageHistory?: Maybe<ClientUsageHistoryResponse>;
  commandResponses?: Maybe<PaginationMultipleCommandResponse>;
  complianceDropdowns?: Maybe<PaginationMultipleComplianceDropdown>;
  complianceSoleProprietorBrand?: Maybe<ComplianceSoleProprietorBrandResponse>;
  complianceSoleProprietorBrands?: Maybe<CursorPaginationComplianceProprietorBrand>;
  complianceSoleProprietorCampaign?: Maybe<ComplianceSoleProprietorCampaignResponse>;
  complianceSoleProprietorCampaigns?: Maybe<CursorPaginationComplianceSoleProprietorCampaign>;
  complianceSoleProprietorProfile?: Maybe<ComplianceSoleProprietorProfileResponse>;
  complianceSoleProprietorProfiles?: Maybe<PaginationMultipleComplianceSoleProprietorProfile>;
  conferenceAnalytic?: Maybe<ConferenceAnalyticResponse>;
  conferenceHistoryAnalytic?: Maybe<PaginationConferenceHistoryAnalytic>;
  conferenceInteractionAnalytic?: Maybe<ConferenceInteractionAnalyticResponse>;
  contact?: Maybe<SingleContact>;
  contactComplianceConsents?: Maybe<CursorPaginationContactMessagingConsentResponse>;
  contactConsentStatus?: Maybe<ContactConsentStatusResponse>;
  contactNotes?: Maybe<PaginationMultipleContactNote>;
  contactNotesV2?: Maybe<CursorPaginationContactNoteV2>;
  contactSourceTypes?: Maybe<ContactSourceTypeResponse>;
  contactTags?: Maybe<PaginationMultipleContactTag>;
  contactTagsV2?: Maybe<CursorPaginationContactTagV2>;
  /** @deprecated Use contactsV2 instead, as contacts is no longer supported. */
  contacts?: Maybe<PaginationMultipleContact>;
  contactsOffSet?: Maybe<ContactOffSetResponse>;
  contactsV2?: Maybe<CursorPaginationContactV2>;
  countAdminPaymentRequests?: Maybe<PaymentRequestCountResponse>;
  countChannels?: Maybe<ChannelCountResponse>;
  countJournalEntries?: Maybe<CountResponse>;
  countMembers?: Maybe<WorkspaceMemberV2CountResponse>;
  countPinnedChatMessages?: Maybe<CountPinnedChatMessagesResponse>;
  countPinnedMessageConversations?: Maybe<PinnedMessageConversationCount>;
  countSearchChatMessages?: Maybe<SearchChatMessagesCount>;
  countSearchMessageConversations?: Maybe<MessageConversationCount>;
  countTeams?: Maybe<TeamsCountResponse>;
  countrywiseTrafficAnalytic?: Maybe<ConversationAnalyticResponse>;
  customer?: Maybe<CommonResponse>;
  customerBillingAddress?: Maybe<CustomerBillingAddressResponse>;
  dashboardAfterHourActivities?: Maybe<DashboardActivityAfterBusinessHourRes>;
  dashboardCallDistributions?: Maybe<DashboardCallDistributionRes>;
  dashboardCallVolume?: Maybe<DashboardCallVolumeRes>;
  dashboardCriticalEvents?: Maybe<CriticalEventRes>;
  dashboardKeyKpis?: Maybe<KpiKeysRes>;
  dashboardKpis?: Maybe<KpisCombinedRes>;
  dashboardMemberLeaderBoard?: Maybe<dashboardMemberLeaderBoardRes>;
  dashboardMyWidgetGroups?: Maybe<MyWidgetGroupsRes>;
  /** @deprecated Use getDashboardNumberAnalyticsV2 instead. */
  dashboardNumberAnalytics?: Maybe<DashboardNumberAnalyticsResponse>;
  dashboardReportAnalytic?: Maybe<DashboardReportAnalyticResponse>;
  dashboardUniqueVsRepeatedCaller?: Maybe<DashboardUniquerVsRepeatedCallerRes>;
  dashboardUnlimitedUsages?: Maybe<DashboardUnlimitedUsagesRes>;
  dashboardWalletExpenditure?: Maybe<WalletExpenditureRes>;
  draftMessage?: Maybe<SingleDraftMessageConversation>;
  enumerateCountriesForAvailableNumbers?: Maybe<EnumerateCountriesForAvailableNumbersResponse>;
  enumerateNumberTypesAvailableForCountry?: Maybe<EnumerateNumberTypesAvailableForCountryResponse>;
  estimateRenewFailedSubscriptionV2?: Maybe<EstimateAmountResponse>;
  estimateSoleProprietorBrandCharge?: Maybe<EstimateAmountResponse>;
  estimateSoleProprietorCampaignCharge?: Maybe<EstimateAmountResponse>;
  exportJournalEntries?: Maybe<Message>;
  extensionConfiguration?: Maybe<ExtensionConfigurationResponse>;
  fetchActiveChannelStrategies?: Maybe<ListActiveChannelStrategies>;
  fetchAllCountries?: Maybe<CursorPaginationCountries>;
  fetchBulkMessagingCampaignRecipients?: Maybe<BulkMessagingCampaignRecipientsCursorPagination>;
  fetchJournalEntries?: Maybe<FetchUserStatementResponse>;
  fetchSingleRecentMessageConversation?: Maybe<ConversationDetailResponse>;
  findRecentMessageConversation?: Maybe<SingleRecentMessageConversation>;
  getAgentSessions?: Maybe<PaginationAgentSession>;
  getAllNotification?: Maybe<NotificationDropdownResponse>;
  getAllNotificationV2?: Maybe<CursorPaginationNotificationV2>;
  getAssignedChannels?: Maybe<ChannelUserWorkspaceCursorPaginationV2>;
  getAssignedChannelsCount?: Maybe<CountResponse>;
  getAutoRechargeConfigs?: Maybe<AutoRechargeConfigResponse>;
  getAutoRecordingInCallSetting?: Maybe<CallSettingAutoRecordingResponse>;
  getAutoRecordingInChannelSetting?: Maybe<CallSettingAutoRecordingResponse>;
  getAutoTranscribeInCallSetting?: Maybe<CallSettingAutoTranscribeResponse>;
  getAutoTranscribeInChannelSetting?: Maybe<CallSettingAutoTranscribeResponse>;
  getBillingSubscriptionOverview?: Maybe<BillingSubscriptionOverviewResponse>;
  /** @deprecated Use `getBlockedContactsV2` instead, as `getBlockedContacts` is no longer supported. */
  getBlockedContacts?: Maybe<PaginationBlockedContact>;
  getBlockedContactsCount?: Maybe<CountResponse>;
  getBlockedContactsV2?: Maybe<CursorPaginationBlockedContactsV2>;
  getBulkMessagingCampaign?: Maybe<GetBulkMessagingCampaignResponse>;
  getBulkMessagingCampaignListCount?: Maybe<CountResponse>;
  getBulkMessagingCampaignRun?: Maybe<GetBulkMessagingCampaignRunResponse>;
  getBusinessAfterHoursInCallSetting?: Maybe<BusinessAfterHourResponse>;
  getBusinessAfterHoursInChannelSetting?: Maybe<BusinessAfterHourResponse>;
  getBusinessHour?: Maybe<BusinessHourResponse>;
  getBusinessHoursInCallSetting?: Maybe<BusinessHourResponse>;
  getBusinessHoursInChannelSetting?: Maybe<BusinessHourResponse>;
  getCallForwardInCallSetting?: Maybe<CallForwardResponse>;
  getCallForwardInChannelSetting?: Maybe<CallForwardResponse>;
  getCallSetting?: Maybe<CallSettingResponse>;
  getCallSettingEmailAlerts?: Maybe<CallSettingEmailAlertsResponse>;
  getCallSettingForChannel?: Maybe<CallSettingForChannelResponse>;
  getCallSettings?: Maybe<CallSettingResponseWithCursor>;
  getCallSettingsCount?: Maybe<CallSettingCountResponse>;
  getCallTransferInCallSetting?: Maybe<CallTransferResponse>;
  getCallTransferInChannelSetting?: Maybe<CallTransferResponse>;
  getCallerIdInCallSetting?: Maybe<CallSettingCallerIdResponse>;
  getCallerIdInChannelSetting?: Maybe<CallSettingCallerIdResponse>;
  getCallerTuneInCallSetting?: Maybe<CallSettingCallerTuneResponse>;
  getCallerTuneInChannelSetting?: Maybe<CallSettingCallerTuneResponse>;
  getCampaignRecipientsByCampaignId?: Maybe<getCampaignRecipientsByCampaignIdResponse>;
  getChannelByGroup?: Maybe<ChannelCursorPaginationV2>;
  getChannelGroupsCountInCallSetting?: Maybe<CallSettingCountResponse>;
  getChannelGroupsInCallSetting?: Maybe<CallSettingChannelGroupsWithCursor>;
  getChannelOverview?: Maybe<ChannelOverviewResponse>;
  getChannelSetting?: Maybe<CallSettingResponse>;
  getChannelSettingEmailAlerts?: Maybe<CallSettingEmailAlertsResponse>;
  getChannelsByCampaign?: Maybe<ChannelsResponse>;
  getChatMessages?: Maybe<PaginationMultipleChatMessage>;
  getChatMessagesV2?: Maybe<CursorPaginationGetChatMessagesV2>;
  getComplianceCampaignSampleMessages?: Maybe<ComplianceCampaignSampleMessagesResponse>;
  getComplianceCampaigns?: Maybe<ComplianceCampaignCursorPaginationResponse>;
  getConfiguration?: Maybe<ConfigurationResponse>;
  getContactByPhoneNumber?: Maybe<SingleContact>;
  getContactComplianceConsent?: Maybe<ContactComplianceConsentResponse>;
  getContactProfileForDialerScreen?: Maybe<GetContactProfileForDialerScreenResponse>;
  getContactsCount?: Maybe<CountResponse>;
  getDashboardNumberAnalyticsV2?: Maybe<DashboardNumberAnalyticsCursorResponse>;
  getDefaultChannel?: Maybe<DefaultChannelResponse>;
  getIvrInCallSetting?: Maybe<IvrResponse>;
  getIvrInChannelSetting?: Maybe<IvrResponse>;
  getIvrMenuOptionsInCallSetting?: Maybe<IvrCursorPagination>;
  getIvrMenuOptionsInChannelSetting?: Maybe<IvrCursorPagination>;
  getLowBalanceAlert?: Maybe<SingleLowBalanceAlert>;
  getMemberAnalyticsReport?: Maybe<MemberAnalyticsReportCursorPaginationResponse>;
  getMemberRoom?: Maybe<SingleRoom>;
  getMemberSubscription?: Maybe<MemberSubscriptionResponse>;
  getMemberSubscriptionOverview?: Maybe<MemberSubscriptionOverviewResponse>;
  getMessageScheduleCount?: Maybe<MessageScheduleCountData>;
  getMissedCallEmailInCallSetting?: Maybe<CallSettingMissedCallEmailResponse>;
  getMissedCallEmailInChannelSetting?: Maybe<CallSettingMissedCallEmailResponse>;
  getNonPowerCampaignAssignees?: Maybe<PowerCampaignAssigneesResponse>;
  getPaymentOrderById?: Maybe<PaymentOrderResponse>;
  getPaymentRequestToken?: Maybe<FetchUrlTokenForPayment>;
  getPowerCampaignAssignees?: Maybe<PowerCampaignAssigneesResponse>;
  getPowerCampaignDispositionContact?: Maybe<PowerCampaignDispositionContactResponse>;
  getPowerCampaignDispositions?: Maybe<PaginationPowerCampaignDispositions>;
  getPowerCampaignErrors?: Maybe<PaginationPowerCampaignError>;
  getPowerDialerDashboardCallCount?: Maybe<PowerDialerDashboardCallCountResponse>;
  getPowerDialerDashboardCalls?: Maybe<PaginationPowerDialerDashboardCall>;
  getPowerDispositionContacts?: Maybe<PaginationPowerDispositionContact>;
  getPreferredContactMethods?: Maybe<WorkspacePreferredContactMethodResponse>;
  getRecipientsByCampaignRun?: Maybe<getRecipientsByCampaignRunResponse>;
  getRecordingAnnouncementInCallSetting?: Maybe<CallSettingRecordingAnnouncementResponse>;
  getRecordingAnnouncementInChannelSetting?: Maybe<CallSettingRecordingAnnouncementResponse>;
  getRefund?: Maybe<RefundResponse>;
  getReviewByMessageConversationId?: Maybe<SingleReview>;
  getTimeoutInCallSetting?: Maybe<CallSetttingTimeoutResponse>;
  getTimeoutInChannelSetting?: Maybe<CallSetttingTimeoutResponse>;
  getTranscriptionInformation?: Maybe<GetTranscriptionInformationResponse>;
  getUserOnlineStatus?: Maybe<UserOnlineManagementResponse>;
  getVoicemailInCallSetting?: Maybe<CallSettingVoicemailResponse>;
  getVoicemailInChannelSetting?: Maybe<CallSettingVoicemailResponse>;
  getWalletDetails?: Maybe<WalletResponse>;
  getWalletDetailsV2?: Maybe<WalletResponse>;
  getWalletDetailsWithLastCredited?: Maybe<WalletDetailWithLastCreditedResponse>;
  getWelcomeMessageInCallSetting?: Maybe<CallSettingWelcomeMessageResponse>;
  getWelcomeMessageInChannelSetting?: Maybe<CallSettingWelcomeMessageResponse>;
  getWorkspaceChannelMembers?: Maybe<GetWorkspaceChannelMembersCursorPagination>;
  groupStrategiesByGroup?: Maybe<ListAllStrategiesByGroup>;
  /** @deprecated Use 'purchaseFailedPhoneNumbers' instead. */
  inProcessPhoneNumbers?: Maybe<PaginationMultiplePhoneNumbers>;
  inProcessPhoneNumbersV2?: Maybe<InProcessPhoneNumberCursorPagination>;
  incomingPhoneNumbers?: Maybe<PaginationMultipleIncomingPhoneNumber>;
  individualMemberDashboardReportAnalytics?: Maybe<IndividualMemberDashboardReportAnalyticsResponse>;
  individualNumberReportAnalytics?: Maybe<IndividualNumberReportAnalyticsResponse>;
  integration?: Maybe<IntegrationResponse>;
  /** @deprecated Use 'integrationChannelsV2' instead. */
  integrationChannels?: Maybe<PaginationIntegrationChannelResponse>;
  integrationChannelsV2?: Maybe<CursorPaginationIntegrationChannelsV2>;
  integrationConfiguration?: Maybe<IntegrationConfigurationResponse>;
  integrationCount?: Maybe<IntegrationCountResponse>;
  integrationUsers?: Maybe<PaginationIntegrationUser>;
  integrationWebhooks?: Maybe<IntegrationWebhookResponse>;
  integrations?: Maybe<PaginationIntegration>;
  integrationsV2?: Maybe<CursorPaginationIntegrationsV2>;
  invoice?: Maybe<InvoiceResponse>;
  invoices?: Maybe<InvoicesResponse>;
  invoicesV2?: Maybe<CursorPaginationInvoices>;
  latestUnreadMessageCursor?: Maybe<Scalars['Scalar']['output']>;
  listBulkMessagingCampaign?: Maybe<BulkMessagingCampaignCursorPagination>;
  listBulkMessagingCampaignRuns?: Maybe<BulkMessagingCampaignRunsCursorPagination>;
  listCallRecordings?: Maybe<PaginationMultipleRecording>;
  listCampaignPhoneNumber?: Maybe<PaginationCompliancePhoneNumber>;
  listConferences?: Maybe<Conferences>;
  listNumberSubscriptionDetails?: Maybe<NumberSubscriptionDetailsResponse>;
  listNumberSubscriptionDetailsForDate?: Maybe<NumberSubscriptionDetailsForDateResponse>;
  listParticipants?: Maybe<Participants>;
  listPaymentOrders?: Maybe<CursorPaginationPaymentOrders>;
  listPaymentSource?: Maybe<PaymentSourcesResponse>;
  listPinnedChatMessages?: Maybe<ListPinnedChatMessagesResponse>;
  listPinnedMessageConversations?: Maybe<PaginationMultipleMessageConversation>;
  listPinnedMessageConversationsV2?: Maybe<ListPinnedMessageConversationsResponse>;
  listPinnedRecentMessageConversations?: Maybe<MultipleRecentMessageConversation>;
  listPlanItemPrices?: Maybe<CommonResponse>;
  listPlanItems?: Maybe<CommonResponse>;
  listSubscription?: Maybe<PlanSubscriptionsResponse>;
  liveConferenceCount?: Maybe<CountResponse>;
  liveConferences?: Maybe<PaginationLiveConferences>;
  liveConferencesV2?: Maybe<LiveConferencesV2CursorResponse>;
  markOpenCloseCount?: Maybe<MarkAsCloseOrOpenCountData>;
  memberDashboardReportAnalytics?: Maybe<MemberDashboardReportAnalyticsResponse>;
  messageAnalytic?: Maybe<ConversationAnalyticResponse>;
  messageAttachments?: Maybe<MultipleMessageAttachment>;
  messageConversationErrorLog?: Maybe<SingleMessageConversationErrorLog>;
  messageConversationSearch?: Maybe<PaginationMultipleMessageConversationSearch>;
  /** @deprecated Use 'messageConversationsV2' instead */
  messageConversations?: Maybe<PaginationMultipleMessageConversation>;
  messageConversationsV2?: Maybe<MessageConversationCursorPaginationV2>;
  messageSchedules?: Maybe<MessageSchedulePagination>;
  myPlanPrivilege?: Maybe<MultipleScreenPlanMappings>;
  myRolePrivilege?: Maybe<MultipleScreenRoleMappings>;
  myWorkspace?: Maybe<MyWorkspaceResponse>;
  numberAggregatedReportAnalytics?: Maybe<NumberAggregateReportAnalyticsResponse>;
  numberGraphReportAnalytics?: Maybe<NumberGraphReportAnalyticsResponse>;
  numberReportAnalytic?: Maybe<NumberReportAnalyticResponse>;
  obtainNotificationCount?: Maybe<NotificationCountResponse>;
  phoneNumberStatusCount: PhoneNumberStatusCountResponse;
  plan?: Maybe<SinglePlan>;
  planPrice?: Maybe<SinglePlanPrice>;
  planPrices?: Maybe<PaginationPlanPrices>;
  plans?: Maybe<PaginationMultiplePlan>;
  powerCampaign?: Maybe<PowerCampaignResponse>;
  powerCampaignAssigneeCallStatusCount?: Maybe<PowerCampaignCallStatusCount>;
  powerCampaignCallHistory?: Maybe<PaginationPowerCampaignCallHistory>;
  powerCampaignCallQueues?: Maybe<PaginationPowerCampaignCallQueue>;
  powerCampaignCallStatusCount?: Maybe<PowerCampaignCallStatusCount>;
  powerCampaignCallsByStatus?: Maybe<PaginationPowerCampaignCallsByStatus>;
  powerCampaignContactDetails?: Maybe<PowerCampaignContactDetails>;
  powerCampaigns?: Maybe<PaginationPowerCampaigns>;
  powerDispositions?: Maybe<PaginationPowerDisposition>;
  powerImports?: Maybe<PaginationPowerImport>;
  providerDeviceLogin?: Maybe<ProviderLogin>;
  providerLogin?: Maybe<ProviderLogin>;
  providerMessagingPricing?: Maybe<ProviderMessagingPricing>;
  providerPhoneNumberPricing?: Maybe<MultipleProviderPhoneNumberPricing>;
  providerVoicePricing?: Maybe<ProviderVoicePricing>;
  publicCheckPhoneNumberRegulation?: Maybe<SingleCheckRegulatoryCompliance>;
  purchaseFailedPhoneNumbers?: Maybe<PhoneNumberCursorPaginationV2>;
  recentCallLogs?: Maybe<PaginationRecentCallLogs>;
  recentContactLogs?: Maybe<PaginationMultipleMessageConversation>;
  /** @deprecated Use 'recentMessageConversationsV2' instead */
  recentMessageConversations?: Maybe<PaginationMultipleRecentMessageConversation>;
  recentMessageConversationsV2?: Maybe<CursorPaginationRecentMessageConversationV2>;
  registerForTopicNotifications?: Maybe<Message>;
  regulatoryCompliances?: Maybe<PaginationMultipleRegulatoryCompliance>;
  releasedAndScheduledChannels?: Maybe<ChannelsResponse>;
  releasedChannels?: Maybe<PaginationMultipleReleasedChannels>;
  role?: Maybe<SingleRole>;
  roles?: Maybe<PaginationMultipleRole>;
  screenPlanMappings?: Maybe<PaginationMultipleScreenPlanMapping>;
  screenRoleMappings?: Maybe<PaginationMultipleScreenRoleMapping>;
  searchChatMessages?: Maybe<SearchChatMessagesResponse>;
  searchMessageConversations?: Maybe<SearchMessageConversations>;
  /** @deprecated Use `tagsV2` instead, as `tags` is no longer supported. */
  tags?: Maybe<PaginationMultipleTag>;
  tagsV2?: Maybe<CursorPaginationTagV2>;
  teamMembers?: Maybe<PaginationTeamMembers>;
  /** @deprecated Use 'teamsV2' instead. */
  teams?: Maybe<PaginationTeams>;
  teamsV2?: Maybe<CursorPaginationTeamsV2>;
  unlimitedConfigs?: Maybe<CursorPaginationUnlimitedConfig>;
  unlimitedUsagePercentage?: Maybe<UnlimitedUsagePercentageResponse>;
  usageReportNotification?: Maybe<UsageReportNotificationResponse>;
  utmAttributeValues?: Maybe<UtmAttributeValueResponse>;
  validateActivationCode?: Maybe<validateActivationCodeResponse>;
  verifyPromoCode?: Maybe<VerifyPromoCodeResponse>;
  verifyPushCredentialToken?: Maybe<SinglePushCredentialToken>;
  voiceMailProxy?: Maybe<VoiceMailProxy>;
  wordFrequencyAnalytic?: Maybe<WordFrequencyAnalyticResponse>;
  workspaceA2PVerificationStatus?: Maybe<WorkspaceA2pVerificationStatusResponse>;
  workspaceAuthMe?: Maybe<WorkspaceAuthMe>;
  workspaceAuthMeV2?: Maybe<WorkspaceAuthMeV2>;
  workspaceClaimedFreeNumbers?: Maybe<WorkspaceClaimedFreeNumbersResponse>;
  workspaceClientUsageHistory?: Maybe<ClientUsageHistoryResponse>;
  workspaceMember?: Maybe<WorkspaceMember>;
  workspaceMemberAnalytic?: Maybe<PaginationWorkspaceMemberAnalytic>;
  /** @deprecated Use workspaceMembersV2 */
  workspaceMembers?: Maybe<PaginationMultipleWorkspaceMember>;
  workspaceMembersV2?: Maybe<CursorBasedWorkspaceMembers>;
  workspaceRateLimitExhausts?: Maybe<MultipleWorkspaceRateLimitExhaust>;
  workspaceRateLimits?: Maybe<MultipleWorkspaceRateLimit>;
};

export type QueryactiveStrategyGroupArgs = {
  channelId: Scalars['Int']['input'];
};

export type QueryactiveWorkspacesV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminCheckRegulatoryComplianceArgs = {
  addressRequirements: Scalars['String']['input'];
  isoCountry: Scalars['String']['input'];
  numberType: NumberTypeEnum;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminEmailOtpArgs = {
  input?: InputMaybe<InputAdminEmailOTP>;
};

export type QueryadminFetchBlockedDomainsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminFetchBlockedForwardedPhoneNumbersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminFetchBlockedIpAddressesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminFetchBlockedPhoneNumbersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminFetchBlockedSignUpEmailsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminFetchEmailTemplateSegmentArgs = {
  id: Scalars['Int']['input'];
};

export type QueryadminFetchEmailTemplateSegmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminFetchModulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminFetchPrivilegeArgs = {
  id: Scalars['Int']['input'];
};

export type QueryadminFetchPrivilegesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminFetchScreensArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminFetchScreensByPlanArgs = {
  planId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminFetchScreensByRoleArgs = {
  roleId: Scalars['Int']['input'];
};

export type QueryadminFetchScreensV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetActiveChannelsArgs = {
  alphaTwoCode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetActiveChannelsByWorkspaceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminGetActiveChannelsByWorkspaceV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetActiveChannelsCountArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminGetActiveChannelsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetAvailablePhoneNumbersArgs = {
  areaCode?: InputMaybe<Scalars['Int']['input']>;
  beta?: InputMaybe<Scalars['Boolean']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  excludeAllAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeForeignAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLocalAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  faxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inLocality?: InputMaybe<Scalars['String']['input']>;
  mmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  voiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetBillingDiscountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetCartsArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetClosedWorkspaceUserDetailArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetComplianceSoleProprietorStatusArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetConfigurationArgs = {
  key: Scalars['String']['input'];
};

export type QueryadminGetConversationCountArgs = {
  input?: InputMaybe<InputAdminGetConversationCount>;
};

export type QueryadminGetCustomPlanArgs = {
  codeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminGetCustomPlanByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryadminGetDeletedUserArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetDueAmountArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetInProcessNumbersCountArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminGetInProcessNumbersV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetInProcessPhoneNumbersArgs = {
  alphaTwoCode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetInProcessPhoneNumbersByWorkspaceArgs = {
  alphaTwoCode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminGetInProcessPhoneNumbersByWorkspaceV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetIncomingPhoneNumbersArgs = {
  alphaTwoCode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetMessageConversationErrorLogsArgs = {
  conversationType?: InputMaybe<MessageConversationTypeEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetMessageConversationErrorLogsCountArgs = {
  conversationType?: InputMaybe<MessageConversationTypeEnum>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type QueryadminGetNotificationTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetPreferredContactMethodsByWorkspaceIdArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetPromoCodeUsersArgs = {
  couponCodeId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminGetPromoCodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  promotionId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminGetPromotionArgs = {
  id: Scalars['Int']['input'];
};

export type QueryadminGetPromotionsArgs = {
  couponType?: InputMaybe<CouponTypeEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminGetRefundArgs = {
  id: Scalars['Int']['input'];
};

export type QueryadminGetRegulatoryComplianceStatusCallbackArgs = {
  id: Scalars['Int']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetReleasedChannelsArgs = {
  alphaTwoCode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetReleasedChannelsByWorkspaceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminGetReleasedChannelsByWorkspaceV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetReleasedChannelsCountArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminGetReleasedChannelsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetSubaccountActivityLogsArgs = {
  action?: InputMaybe<WorkspaceSubaccountActivityLogActionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetUnpaidUsersArgs = {
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};

export type QueryadminGetUsageDetailsForMessageConversationArgs = {
  messageConversationId: Scalars['Int']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetUserCompleteStatementArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetUserWorkspacesArgs = {
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  identityProvider?: InputMaybe<IdentityProviderUserListEnum>;
  isEmailDomainFree?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<PlanTypeEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<WorkspaceStatusEnum>;
  subscriptionCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  utmAttribute?: InputMaybe<Scalars['String']['input']>;
  utmAttributeValue?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminGetUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminGetWalletDetailsArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetWalletDetailsV2Args = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetWalletLoadLogsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetWalletLoadLogsCountArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetWorkspaceBillingDiscountArgs = {
  id: Scalars['Int']['input'];
};

export type QueryadminGetWorkspaceBillingSubscriptionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminGetWorkspaceByEmailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetWorkspaceByEmailAndStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status: Array<InputMaybe<WorkspaceStatusEnum>>;
};

export type QueryadminGetWorkspaceByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type QueryadminGetWorkspaceChannelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetWorkspaceMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetWorkspaceMembersV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetWorkspaceUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminGetWorkspacesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<Array<InputMaybe<WorkspaceStatusEnum>>>;
};

export type QueryadminGetWorkspacesCountWithActiveChannelsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminGetWorkspacesCountWithInProcessPhoneNumbersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminGetWorkspacesCountWithToBeReleasedChannelsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminGetWorkspacesV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<Array<InputMaybe<WorkspaceStatusEnum>>>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetWorkspacesWithActiveChannelMetricsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetWorkspacesWithInProcessPhoneNumberMetricsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminGetWorkspacesWithToBeReleasedChannelMetricsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminListPaymentOrdersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  lienStatus?: InputMaybe<PaymentOrderLienStatusEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<PaymentOrderStatusEnum>;
  type?: InputMaybe<PaymentOrderTypeEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminListPaymentRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<PaymentRequestStatusEnum>;
};

export type QueryadminListPaymentRequestsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<PaymentRequestPurposeEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<PaymentRequestStatusEnum>;
};

export type QueryadminListPaymentSourcesArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminListUnpaidUsersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fromDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['Date']['input'];
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminProviderLastMonthUsageArgs = {
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminReconcileStatementReportArgs = {
  fromDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['Date']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminRegulatoryCompliancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  purchaseCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  purchased?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<Array<InputMaybe<RegulatoryComplianceStatusEnum>>>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryadminUserWorkspaceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminViewByWorkspacesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  metric?: InputMaybe<MetricEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminWorkspaceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminWorkspaceBillingHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  transactionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  transactionDateTo?: InputMaybe<Scalars['Date']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryadminWorkspaceBillingHistoryV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryaiAdvanceCallReportArgs = {
  callResolution?: InputMaybe<Scalars['String']['input']>;
  callType?: InputMaybe<Scalars['String']['input']>;
  conclusionType?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  reasonType?: InputMaybe<Scalars['String']['input']>;
  sentimentType?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['Date']['input'];
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryaiAdvanceCallReportV2Args = {
  callResolution?: InputMaybe<Scalars['String']['input']>;
  callType?: InputMaybe<Scalars['String']['input']>;
  conclusionType?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fromDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  reasonType?: InputMaybe<Scalars['String']['input']>;
  sentimentType?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['Date']['input'];
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryaiDashboardCountArgs = {
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};

export type QueryaiDashboardDayWiseSentimentArgs = {
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};

export type QueryaiDashboardIntentArgs = {
  fromDate: Scalars['Date']['input'];
  intentType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['Date']['input'];
};

export type QueryaiDashboardIntentV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fromDate: Scalars['Date']['input'];
  intentType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['Date']['input'];
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryaiDashboardMemberPerformanceArgs = {
  fromDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sentimentType: Scalars['String']['input'];
  toDate: Scalars['Date']['input'];
};

export type QueryaiDashboardMemberPerformanceGraphReportArgs = {
  fromDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['Date']['input'];
};

export type QueryaiDashboardMemberPerformanceV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fromDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sentimentType: Scalars['String']['input'];
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['Date']['input'];
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryaiDashboardReportAnalyticsArgs = {
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};

export type QueryaiDashboardSummaryArgs = {
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};

export type QueryapplicationVersioningArgs = {
  platform: PlatformEnum;
};

export type QueryapprovedComplianceSoleProprietorBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  cursorOrder?: InputMaybe<Scalars['String']['input']>;
  cursorSort?: InputMaybe<SortEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryareaCodesArgs = {
  alphaTwoCode?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryassignChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryassignChannelsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  filter?: InputMaybe<ChannelFilterEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryattributeArgs = {
  id: Scalars['Int']['input'];
};

export type QueryattributeValueArgs = {
  id: Scalars['Int']['input'];
};

export type QueryattributeValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  attributeId?: InputMaybe<Scalars['Int']['input']>;
  attributeName?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryattributeValuesV2Args = {
  attributeId?: InputMaybe<Scalars['Int']['input']>;
  attributeName?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryattributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryattributesV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryavailablePhoneNumbersArgs = {
  areaCode?: InputMaybe<Scalars['Int']['input']>;
  beta?: InputMaybe<Scalars['Boolean']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  excludeAllAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeForeignAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLocalAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  faxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inLocality?: InputMaybe<Scalars['String']['input']>;
  mmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  voiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryavailablePhoneNumbersV2Args = {
  areaCode?: InputMaybe<Scalars['Int']['input']>;
  beta?: InputMaybe<Scalars['Boolean']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeAllAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeForeignAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLocalAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  faxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inLocality?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  voiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryaverageRatingArgs = {
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerybundleArgs = {
  sid?: InputMaybe<Scalars['String']['input']>;
};

export type QuerycallerIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycallerIdsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycanStartMessageConversationArgs = {
  canConference?: InputMaybe<Scalars['Boolean']['input']>;
  canMessage?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerycannedResponsesV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycbInvoiceArgs = {
  id: Scalars['String']['input'];
};

export type QuerychannelArgs = {
  id: Scalars['Int']['input'];
};

export type QuerychannelCapabilityArgs = {
  id: Scalars['Int']['input'];
};

export type QuerychannelConversationsArgs = {
  clientId: Scalars['String']['input'];
  countryId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerychannelGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerychannelGroupsCountArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerychannelMembersArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerychannelSettingByChannelIdArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerychannelStrategiesByStrategyGroupArgs = {
  channelId: Scalars['Int']['input'];
  strategyGroupId: Scalars['Int']['input'];
};

export type QuerychannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerychannelsForNewConversationsArgs = {
  clientId: Scalars['String']['input'];
  countryId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerychannelsV2Args = {
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numberTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycheckMemberEmailExistArgs = {
  email: Scalars['String']['input'];
};

export type QuerycheckRegulatoryComplianceArgs = {
  addressRequirements: Scalars['String']['input'];
  isoCountry: Scalars['String']['input'];
  numberType: NumberTypeEnum;
};

export type QueryclientIpAddressLogInfoArgs = {
  clientIp?: InputMaybe<Scalars['String']['input']>;
};

export type QueryclientUsageHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  workspaceId: Scalars['Int']['input'];
};

export type QuerycommandResponsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycomplianceDropdownsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  type: Scalars['String']['input'];
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycomplianceSoleProprietorBrandArgs = {
  id: Scalars['Int']['input'];
};

export type QuerycomplianceSoleProprietorBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  cursorOrder?: InputMaybe<Scalars['String']['input']>;
  cursorSort?: InputMaybe<SortEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycomplianceSoleProprietorCampaignArgs = {
  id: Scalars['Int']['input'];
};

export type QuerycomplianceSoleProprietorCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  cursorOrder?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycomplianceSoleProprietorProfileArgs = {
  id: Scalars['Int']['input'];
};

export type QuerycomplianceSoleProprietorProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryconferenceAnalyticArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryconferenceHistoryAnalyticArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  conversationStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction?: InputMaybe<DirectionFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryconferenceInteractionAnalyticArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuerycontactArgs = {
  id: Scalars['Int']['input'];
};

export type QuerycontactComplianceConsentsArgs = {
  campaigns?: InputMaybe<Array<InputMaybe<ComplianceCampaignFilter>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycontactConsentStatusArgs = {
  channelId: Scalars['Int']['input'];
  contactId: Scalars['Int']['input'];
};

export type QuerycontactNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerycontactNotesV2Args = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerycontactTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerycontactTagsV2Args = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerycontactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  complianceConsent?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameStartsWith?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type QuerycontactsOffSetArgs = {
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type QuerycontactsV2Args = {
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameStartsWith?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  sourceType?: InputMaybe<Array<InputMaybe<ContactSourceTypeEnum>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerycountAdminPaymentRequestsArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purpose?: InputMaybe<PaymentRequestPurposeEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentRequestStatusEnum>;
};

export type QuerycountChannelsArgs = {
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  numberTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerycountJournalEntriesArgs = {
  chargeType?: InputMaybe<Array<InputMaybe<ChargeTypeEnum>>>;
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  debit?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  messageConversationDirection?: InputMaybe<Array<InputMaybe<DirectionTypeEnum>>>;
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
};

export type QuerycountMembersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerycountPinnedChatMessagesArgs = {
  roomId: Scalars['Int']['input'];
};

export type QuerycountPinnedMessageConversationsArgs = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
};

export type QuerycountSearchChatMessagesArgs = {
  query: Scalars['String']['input'];
  roomId: Scalars['Int']['input'];
};

export type QuerycountSearchMessageConversationsArgs = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};

export type QuerycountTeamsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerycountrywiseTrafficAnalyticArgs = {
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type QuerydashboardAfterHourActivitiesArgs = {
  input?: InputMaybe<InputFromDateToDateUserId>;
};

export type QuerydashboardCallDistributionsArgs = {
  input?: InputMaybe<InputFromDateToDateUserId>;
};

export type QuerydashboardCallVolumeArgs = {
  input?: InputMaybe<InputFromDateToDateUserId>;
};

export type QuerydashboardKeyKpisArgs = {
  input?: InputMaybe<InputFromDateToDateUserId>;
};

export type QuerydashboardKpisArgs = {
  input?: InputMaybe<InputFromDateToDateUserId>;
};

export type QuerydashboardMemberLeaderBoardArgs = {
  input?: InputMaybe<InputFromDateToDate>;
};

export type QuerydashboardNumberAnalyticsArgs = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  numberType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['DateTime']['input'];
};

export type QuerydashboardReportAnalyticArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerydashboardUniqueVsRepeatedCallerArgs = {
  input?: InputMaybe<InputFromDateToDateUserId>;
};

export type QuerydashboardUnlimitedUsagesArgs = {
  input?: InputMaybe<InputUserId>;
};

export type QuerydashboardWalletExpenditureArgs = {
  input?: InputMaybe<InputFromDateToDateUserId>;
};

export type QuerydraftMessageArgs = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
};

export type QueryenumerateCountriesForAvailableNumbersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryenumerateNumberTypesAvailableForCountryArgs = {
  countryCode: Scalars['String']['input'];
};

export type QueryestimateSoleProprietorCampaignChargeArgs = {
  useCase: Scalars['String']['input'];
};

export type QueryexportJournalEntriesArgs = {
  chargeType?: InputMaybe<Array<InputMaybe<ChargeTypeEnum>>>;
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  debit?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  messageConversationDirection?: InputMaybe<Array<InputMaybe<DirectionTypeEnum>>>;
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
  usageType?: InputMaybe<Array<InputMaybe<UsageTypeEnum>>>;
};

export type QueryfetchActiveChannelStrategiesArgs = {
  channelId: Scalars['Int']['input'];
};

export type QueryfetchAllCountriesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryfetchBulkMessagingCampaignRecipientsArgs = {
  campaignId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<BulkMessagingCampaignRecipientStatusEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryfetchJournalEntriesArgs = {
  chargeType?: InputMaybe<Array<InputMaybe<ChargeTypeEnum>>>;
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  debit?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageConversationDirection?: InputMaybe<Array<InputMaybe<DirectionTypeEnum>>>;
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
  usageType?: InputMaybe<Array<InputMaybe<UsageTypeEnum>>>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryfetchSingleRecentMessageConversationArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryfindRecentMessageConversationArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  messageConversationId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerygetAgentSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  powerCampaignId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerygetAllNotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetAllNotificationV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetAssignedChannelsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  userWorkspaceId: Scalars['Int']['input'];
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetAutoRecordingInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetAutoRecordingInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetAutoTranscribeInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetAutoTranscribeInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetBlockedContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerygetBlockedContactsCountArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerygetBlockedContactsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetBulkMessagingCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};

export type QuerygetBulkMessagingCampaignListCountArgs = {
  campaignType?: InputMaybe<BulkMessagingCampaignTypeEnum>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  initiatedFrom?: InputMaybe<Scalars['Date']['input']>;
  initiatedTo?: InputMaybe<Scalars['Date']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<BulkMessagingCampaignStatusEnum>>>;
};

export type QuerygetBulkMessagingCampaignRunArgs = {
  campaignRunId: Scalars['Int']['input'];
};

export type QuerygetBusinessAfterHoursInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
};

export type QuerygetBusinessAfterHoursInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetBusinessHourArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetBusinessHoursInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
};

export type QuerygetBusinessHoursInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetCallForwardInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
};

export type QuerygetCallForwardInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetCallSettingEmailAlertsArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetCallSettingForChannelArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetCallSettingsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetCallSettingsCountArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerygetCallTransferInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
};

export type QuerygetCallTransferInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetCallerIdInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetCallerIdInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetCallerTuneInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetCallerTuneInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetCampaignRecipientsByCampaignIdArgs = {
  campaignId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetChannelByGroupArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  groupId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetChannelGroupsCountInCallSettingArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerygetChannelGroupsInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyAssignedGroups?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetChannelOverviewArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetChannelSettingEmailAlertsArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetChannelsByCampaignArgs = {
  campaignId: Scalars['Int']['input'];
  type: ContactComplianceConsentCampaignTypeEnum;
};

export type QuerygetChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerygetChatMessagesV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetComplianceCampaignSampleMessagesArgs = {
  campaignId: Scalars['Int']['input'];
  type: ContactComplianceConsentCampaignTypeEnum;
};

export type QuerygetComplianceCampaignsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetConfigurationArgs = {
  key: Scalars['String']['input'];
};

export type QuerygetContactByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type QuerygetContactComplianceConsentArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetContactProfileForDialerScreenArgs = {
  input: InputGetContactProfileForDialerScreen;
};

export type QuerygetContactsCountArgs = {
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Array<InputMaybe<ContactSourceTypeEnum>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type QuerygetDashboardNumberAnalyticsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetIvrInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
};

export type QuerygetIvrInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetIvrMenuOptionsInCallSettingArgs = {
  callSettingId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetIvrMenuOptionsInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetMemberAnalyticsReportArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['DateTime']['input'];
};

export type QuerygetMemberRoomArgs = {
  input: InputRoom;
};

export type QuerygetMessageScheduleCountArgs = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  status?: InputMaybe<Array<InputMaybe<MessageScheduleStatusEnum>>>;
};

export type QuerygetMissedCallEmailInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetMissedCallEmailInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetNonPowerCampaignAssigneesArgs = {
  id: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerygetPaymentOrderByIdArgs = {
  paymentOrderId: Scalars['Int']['input'];
};

export type QuerygetPaymentRequestTokenArgs = {
  invoiceId: Scalars['Int']['input'];
};

export type QuerygetPowerCampaignAssigneesArgs = {
  id: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerygetPowerCampaignDispositionContactArgs = {
  contactId: Scalars['Int']['input'];
  powerCampaignDispositionId: Scalars['Int']['input'];
};

export type QuerygetPowerCampaignDispositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  powerCampaignId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetPowerCampaignErrorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  powerCampaignId: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
};

export type QuerygetPowerDialerDashboardCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  callOutcomeType: CallOutcomeTypeEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerygetPowerDispositionContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  powerDispositionId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetRecipientsByCampaignRunArgs = {
  campaignRunId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<Scalars['String']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetRecordingAnnouncementInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetRecordingAnnouncementInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetRefundArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetReviewByMessageConversationIdArgs = {
  messageConversationId: Scalars['Int']['input'];
};

export type QuerygetTimeoutInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetTimeoutInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetTranscriptionInformationArgs = {
  callRecordingId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerygetUserOnlineStatusArgs = {
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerygetVoicemailInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetVoicemailInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetWelcomeMessageInCallSettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerygetWelcomeMessageInChannelSettingArgs = {
  channelId: Scalars['Int']['input'];
};

export type QuerygetWorkspaceChannelMembersArgs = {
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  channelId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygroupStrategiesByGroupArgs = {
  channelId: Scalars['Int']['input'];
};

export type QueryinProcessPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryinProcessPhoneNumbersV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryincomingPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryindividualMemberDashboardReportAnalyticsArgs = {
  fromDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['DateTime']['input'];
  userWorkspaceId: Scalars['Int']['input'];
};

export type QueryindividualNumberReportAnalyticsArgs = {
  channelId: Scalars['Int']['input'];
  fromDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['DateTime']['input'];
};

export type QueryintegrationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryintegrationChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integrationUserId: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryintegrationChannelsV2Args = {
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  integrationUserId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryintegrationConfigurationArgs = {
  id: Scalars['Int']['input'];
};

export type QueryintegrationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<IntegrationUserStatusEnum>;
};

export type QueryintegrationWebhooksArgs = {
  integrationUserId: Scalars['Int']['input'];
};

export type QueryintegrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryintegrationsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  includeInactive: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryinvoiceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryinvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<InvoiceStatusEnum>;
  transactionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  transactionDateTo?: InputMaybe<Scalars['Date']['input']>;
};

export type QueryinvoicesV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<InvoiceStatusEnum>;
  transactionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  transactionDateTo?: InputMaybe<Scalars['Date']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerylatestUnreadMessageCursorArgs = {
  order?: InputMaybe<OrderEnum>;
  recentMessageConversationId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerylistBulkMessagingCampaignArgs = {
  campaignType?: InputMaybe<BulkMessagingCampaignTypeEnum>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  initiatedFrom?: InputMaybe<Scalars['Date']['input']>;
  initiatedTo?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<Array<InputMaybe<BulkMessagingCampaignStatusEnum>>>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerylistBulkMessagingCampaignRunsArgs = {
  campaignId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  runControl?: InputMaybe<Array<InputMaybe<BulkMessagingRunStatusEnum>>>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<BulkMessagingRunStatusEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerylistCallRecordingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerylistCampaignPhoneNumberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerylistConferencesArgs = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ConferenceStatusEnum>;
  workspaceId: Scalars['Int']['input'];
};

export type QuerylistNumberSubscriptionDetailsForDateArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextBillingDate: Scalars['Date']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerylistParticipantsArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sid: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type QuerylistPaymentOrdersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  lienStatus?: InputMaybe<PaymentOrderLienStatusEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<PaymentOrderStatusEnum>;
  type?: InputMaybe<PaymentOrderTypeEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerylistPinnedChatMessagesArgs = {
  order?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
};

export type QuerylistPinnedMessageConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerylistPinnedMessageConversationsV2Args = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerylistPinnedRecentMessageConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  draftMessage?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  scheduledMessage?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerylistPlanItemPricesArgs = {
  input?: InputMaybe<ListPlanItemPriceInput>;
};

export type QuerylistPlanItemsArgs = {
  limit: Scalars['Int']['input'];
};

export type QueryliveConferenceCountArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryliveConferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<DirectionFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryliveConferencesV2Args = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerymarkOpenCloseCountArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  messageConversationId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerymemberDashboardReportAnalyticsArgs = {
  fromDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate: Scalars['DateTime']['input'];
};

export type QuerymessageAnalyticArgs = {
  fromDate: Scalars['DateTime']['input'];
  labelType: labelTypeEnum;
  toDate: Scalars['DateTime']['input'];
};

export type QuerymessageAttachmentsArgs = {
  friendlyName: Scalars['String']['input'];
};

export type QuerymessageConversationErrorLogArgs = {
  messageConversationId: Scalars['Int']['input'];
};

export type QuerymessageConversationSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerymessageConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  conversationType?: InputMaybe<MessageConversationTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerymessageConversationsV2Args = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerymessageSchedulesArgs = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<Array<InputMaybe<MessageScheduleStatusEnum>>>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerynumberAggregatedReportAnalyticsArgs = {
  channelId: Scalars['Int']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type QuerynumberGraphReportAnalyticsArgs = {
  channelId: Scalars['Int']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type QuerynumberReportAnalyticArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryphoneNumberStatusCountArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryplanArgs = {
  id: Scalars['Int']['input'];
};

export type QueryplanPriceArgs = {
  id: Scalars['Int']['input'];
};

export type QueryplanPricesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  periodicity?: InputMaybe<PeriodicityEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryplansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerypowerCampaignArgs = {
  id: Scalars['Int']['input'];
};

export type QuerypowerCampaignAssigneeCallStatusCountArgs = {
  assignedToId: Scalars['Int']['input'];
  powerCampaignId: Scalars['Int']['input'];
};

export type QuerypowerCampaignCallHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerypowerCampaignCallQueuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  powerCampaignId?: InputMaybe<Scalars['Int']['input']>;
  powerCampaignRunId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerypowerCampaignCallStatusCountArgs = {
  powerCampaignId: Scalars['Int']['input'];
};

export type QuerypowerCampaignCallsByStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  callStatus?: InputMaybe<PowerCampaignCallStatusEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  powerCampaignId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerypowerCampaignContactDetailsArgs = {
  clientId: Scalars['Int']['input'];
  powerCampaignId: Scalars['Int']['input'];
};

export type QuerypowerCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerypowerDispositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerypowerImportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryproviderDeviceLoginArgs = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  grant?: InputMaybe<TwilioGrantEnum>;
  platform?: InputMaybe<PlatformEnum>;
};

export type QueryproviderLoginArgs = {
  grant?: InputMaybe<TwilioGrantEnum>;
  platform?: InputMaybe<PlatformEnum>;
};

export type QueryproviderMessagingPricingArgs = {
  countryCodes: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryproviderPhoneNumberPricingArgs = {
  countryCodes: Array<InputMaybe<Scalars['String']['input']>>;
  publishQueue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryproviderVoicePricingArgs = {
  countryCodes: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QuerypublicCheckPhoneNumberRegulationArgs = {
  addressRequirements: Scalars['String']['input'];
  isoCountry: Scalars['String']['input'];
  numberType: NumberTypeEnum;
};

export type QuerypurchaseFailedPhoneNumbersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryrecentCallLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['Int']['input'];
  conversationStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction?: InputMaybe<DirectionTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryrecentContactLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryrecentMessageConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['Int']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
  conversationStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conversationType?: InputMaybe<MessageConversationTypeEnum>;
  direction?: InputMaybe<DirectionTypeEnum>;
  draftMessage?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  markAsClosed?: InputMaybe<Scalars['Boolean']['input']>;
  messageConversationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  scheduledMessage?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SortEnum>;
  voicemail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryrecentMessageConversationsV2Args = {
  channelId: Scalars['Int']['input'];
  conversationStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  markAsClosed?: InputMaybe<Scalars['Boolean']['input']>;
  messageDirection?: InputMaybe<DirectionTypeEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  scheduleMessage?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SortEnum>;
  voicemail?: InputMaybe<Scalars['Boolean']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryregisterForTopicNotificationsArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Array<InputMaybe<TopicEnum>>>;
};

export type QueryregulatoryCompliancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryreleasedAndScheduledChannelsArgs = {
  channelStatus?: InputMaybe<ReleasedChannelFilterEnum>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryreleasedChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryroleArgs = {
  id: Scalars['Int']['input'];
};

export type QueryrolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryscreenPlanMappingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryscreenRoleMappingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QuerysearchChatMessagesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  roomId: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerysearchMessageConversationsArgs = {
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerytagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerytagsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryteamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  teamId: Scalars['String']['input'];
};

export type QueryteamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
};

export type QueryteamsV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryunlimitedConfigsArgs = {
  chargeType?: InputMaybe<UnlimitedConfigChargeTypeEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryutmAttributeValuesArgs = {
  attribute: UtmAttribute;
};

export type QueryvalidateActivationCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type QueryverifyPromoCodeArgs = {
  input: InputVerifyPromoCode;
};

export type QueryverifyPushCredentialTokenArgs = {
  token: Scalars['String']['input'];
  type: PushCredentialTypeEnum;
};

export type QueryvoiceMailProxyArgs = {
  messageConversationPk?: InputMaybe<Scalars['String']['input']>;
  workspacePk?: InputMaybe<Scalars['String']['input']>;
};

export type QuerywordFrequencyAnalyticArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  wordsLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryworkspaceClientUsageHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type QueryworkspaceMemberArgs = {
  id: Scalars['Int']['input'];
};

export type QueryworkspaceMemberAnalyticArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryworkspaceMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByInput>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserWorkspaceStatusEnum>;
};

export type QueryworkspaceMembersV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleEnum>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<UserWorkspaceStatusEnum>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecentCallLogsData = {
  __typename?: 'RecentCallLogsData';
  callRecording?: Maybe<Recording>;
  channelId?: Maybe<Scalars['Int']['output']>;
  client?: Maybe<Contact>;
  conversationStatus?: Maybe<Scalars['String']['output']>;
  conversationType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  durationConference?: Maybe<DurationConference>;
  id?: Maybe<Scalars['Int']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RecentCallLogsEdge = {
  __typename?: 'RecentCallLogsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<RecentCallLogsData>;
};

export type RecentMessageConversation = {
  __typename?: 'RecentMessageConversation';
  channel?: Maybe<Channel>;
  client?: Maybe<Contact>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  draft?: Maybe<DraftMessageConversation>;
  draftMessage?: Maybe<Scalars['String']['output']>;
  draftMessageMediaCount?: Maybe<Scalars['Int']['output']>;
  hasScheduledMessages?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastReadCursor?: Maybe<Scalars['String']['output']>;
  markAsClosed?: Maybe<Scalars['Boolean']['output']>;
  messageConversation?: Maybe<MessageConversation>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  unReadCounter?: Maybe<Scalars['Int']['output']>;
  unreadCountRecentMessage?: Maybe<Scalars['Int']['output']>;
  unreadCounter?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RecentMessageConversationEdge = {
  __typename?: 'RecentMessageConversationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<RecentMessageConversation>;
};

export type ReconcileStatementReportEdge = {
  __typename?: 'ReconcileStatementReportEdge';
  calilio?: Maybe<Array<Maybe<Charges>>>;
  date?: Maybe<Scalars['Date']['output']>;
  twilio?: Maybe<Array<Maybe<Charges>>>;
};

export type Recording = {
  __typename?: 'Recording';
  createdAt?: Maybe<Scalars['Date']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messageConversation?: Maybe<MessageConversation>;
  messageConversationId?: Maybe<Scalars['Int']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  source?: Maybe<RecordingSourceEnum>;
  status?: Maybe<RecordingStatusEnum>;
  transcription?: Maybe<TranscriptionInformation>;
  url?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type RecordingEdge = {
  __typename?: 'RecordingEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Recording>;
};

export enum RecordingSourceEnum {
  Conference = 'Conference',
  DialVerb = 'DialVerb',
  OutboundAPI = 'OutboundAPI',
  RecordVerb = 'RecordVerb',
  StartCallRecordingAPI = 'StartCallRecordingAPI',
  StartConferenceRecordingAPI = 'StartConferenceRecordingAPI',
  Trunking = 'Trunking',
}

export enum RecordingStatusEnum {
  absent = 'absent',
  completed = 'completed',
  init = 'init',
  pause = 'pause',
  paused = 'paused',
  processing = 'processing',
  resume = 'resume',
  stopped = 'stopped',
}

export type RedirectionData = {
  __typename?: 'RedirectionData';
  channelId?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  markAsClosed?: Maybe<Scalars['Boolean']['output']>;
  memberId?: Maybe<Scalars['Int']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  roomId?: Maybe<Scalars['Int']['output']>;
  roomIdentity?: Maybe<Scalars['String']['output']>;
};

export type RedirectionParamsData = {
  __typename?: 'RedirectionParamsData';
  key?: Maybe<Scalars['String']['output']>;
  params?: Maybe<RedirectionData>;
};

export type RefreshToken = {
  __typename?: 'RefreshToken';
  data?: Maybe<LoginToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Refund = {
  __typename?: 'Refund';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approvedBy?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creditNoteId?: Maybe<Scalars['String']['output']>;
  creditNoteIssuedAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<BillingInfo>;
  failedReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initiatedBy?: Maybe<Scalars['Int']['output']>;
  invoice?: Maybe<Invoice>;
  paymentGateway?: Maybe<PaymentGatewayEnum>;
  paymentGatewayDetails?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['Date']['output']>;
  processingFees?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  refundedAmount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalRefundedAmount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RefundRequest = {
  id: Scalars['Int']['input'];
  passcode: Scalars['String']['input'];
  refundDate?: InputMaybe<Scalars['Date']['input']>;
  remarks: Scalars['String']['input'];
};

export type RefundResponse = {
  __typename?: 'RefundResponse';
  data?: Maybe<Refund>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RegulatoryCompliance = {
  __typename?: 'RegulatoryCompliance';
  address?: Maybe<Address>;
  addressDocument?: Maybe<Media>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessPhoneNumber?: Maybe<Scalars['String']['output']>;
  channelRequested?: Maybe<TwilioPhoneNumber>;
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  identityDocument?: Maybe<Media>;
  identityDocumentBack?: Maybe<Media>;
  lastName?: Maybe<Scalars['String']['output']>;
  numberType?: Maybe<NumberTypeEnum>;
  personalLink?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  purchased?: Maybe<Scalars['Boolean']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<UserWorkspace>;
  status?: Maybe<RegulatoryComplianceStatusEnum>;
  supportingDocumentTypeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  useCase?: Maybe<RegulatoryComplianceUseCaseEnum>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
};

export type RegulatoryComplianceCursorPaginationV2 = {
  __typename?: 'RegulatoryComplianceCursorPaginationV2';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<RegulatoryCompliance>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RegulatoryComplianceEdge = {
  __typename?: 'RegulatoryComplianceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<RegulatoryCompliance>;
};

export type RegulatoryComplianceStatusCallback = {
  __typename?: 'RegulatoryComplianceStatusCallback';
  statusCallback?: Maybe<Scalars['String']['output']>;
};

export type RegulatoryComplianceStatusCallbackResponse = {
  __typename?: 'RegulatoryComplianceStatusCallbackResponse';
  data?: Maybe<RegulatoryComplianceStatusCallback>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum RegulatoryComplianceStatusEnum {
  approved = 'approved',
  draft = 'draft',
  in_review = 'in_review',
  inadequate_document = 'inadequate_document',
  marked_as_purchase_cancelled = 'marked_as_purchase_cancelled',
  marked_as_purchased_complete = 'marked_as_purchased_complete',
  pending_review = 'pending_review',
  provisionally_approved = 'provisionally_approved',
  rejected = 'rejected',
}

export enum RegulatoryComplianceUseCaseEnum {
  business = 'business',
  individual = 'individual',
}

export type RegulatoryCompliancesStatusSummaryCount = {
  __typename?: 'RegulatoryCompliancesStatusSummaryCount';
  data?: Maybe<Array<Maybe<RegulatoryCompliancesStatusSummaryCountData>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RegulatoryCompliancesStatusSummaryCountData = {
  __typename?: 'RegulatoryCompliancesStatusSummaryCountData';
  key?: Maybe<RegulatoryComplianceStatusEnum>;
  value?: Maybe<Scalars['Int']['output']>;
};

export enum ReleasedChannelFilterEnum {
  released = 'released',
  scheduled = 'scheduled',
}

export type RemoveMemberDispositionInput = {
  channelId: Scalars['Int']['input'];
  disposition: NumberDispositionEnum;
  gatewayAccountId?: InputMaybe<Scalars['String']['input']>;
  userWorkspaceId: Scalars['Int']['input'];
};

export type RemovePhoneNumberFailure = {
  __typename?: 'RemovePhoneNumberFailure';
  id: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type RemoveProviderPhoneNumbersResponse = {
  __typename?: 'RemoveProviderPhoneNumbersResponse';
  deletedIds: Array<Scalars['Int']['output']>;
  failed?: Maybe<Array<RemovePhoneNumberFailure>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveSecondaryPaymentSourceInput = {
  paymentSourceId: Scalars['String']['input'];
};

export type RemoveWorkspaceUserWithDispositionResponse = {
  __typename?: 'RemoveWorkspaceUserWithDispositionResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type ReplacementAttributesData = {
  __typename?: 'ReplacementAttributesData';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ResetPin = {
  passCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type ResumeSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type RevokeInvitationTokenResponse = {
  __typename?: 'RevokeInvitationTokenResponse';
  data?: Maybe<UserWorkspace>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RevokeResponse = {
  __typename?: 'RevokeResponse';
  data?: Maybe<Integration>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RiskScore = {
  __typename?: 'RiskScore';
  countryLocationScore?: Maybe<Scalars['Float']['output']>;
  documentVerificationScore?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incorporationDateScore?: Maybe<Scalars['Float']['output']>;
  referralScore?: Maybe<Scalars['Float']['output']>;
  signupCardLocationScore?: Maybe<Scalars['Float']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  userNumberRatioScore?: Maybe<Scalars['Float']['output']>;
  usernameCardNameScore?: Maybe<Scalars['Float']['output']>;
};

export type Role = {
  __typename?: 'Role';
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  roleMaps?: Maybe<Array<Maybe<ScreenRoleMapping>>>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type RoleEdge = {
  __typename?: 'RoleEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Role>;
};

export enum RoleEnum {
  admin = 'admin',
  member = 'member',
  owner = 'owner',
}

export type Room = {
  __typename?: 'Room';
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RoomTypeEnum>;
};

export enum RoomTypeEnum {
  channels = 'channels',
  couple = 'couple',
  group = 'group',
}

export type SayAttributes = {
  __typename?: 'SayAttributes';
  language?: Maybe<Scalars['String']['output']>;
  voice?: Maybe<Scalars['String']['output']>;
};

export type SayAttributesInput = {
  language?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleMessageResponse = {
  __typename?: 'ScheduleMessageResponse';
  data?: Maybe<MessageSchedule>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Screen = {
  __typename?: 'Screen';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  modules?: Maybe<Array<Maybe<Module>>>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type ScreenEdge = {
  __typename?: 'ScreenEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Screen>;
};

export type ScreenPlanMapping = {
  __typename?: 'ScreenPlanMapping';
  id?: Maybe<Scalars['Int']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  module?: Maybe<Module>;
  plan?: Maybe<Plan>;
  planId?: Maybe<Scalars['Int']['output']>;
  privilege?: Maybe<Privilege>;
  screen?: Maybe<Screen>;
};

export type ScreenPlanMappingEdge = {
  __typename?: 'ScreenPlanMappingEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ScreenPlanMapping>;
};

export type ScreenRoleMapping = {
  __typename?: 'ScreenRoleMapping';
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  module?: Maybe<Module>;
  privilege?: Maybe<Privilege>;
  role?: Maybe<Role>;
  screen?: Maybe<Screen>;
};

export type ScreenRoleMappingEdge = {
  __typename?: 'ScreenRoleMappingEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ScreenRoleMapping>;
};

export type SearchChatMessages = {
  __typename?: 'SearchChatMessages';
  cursor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type SearchChatMessagesCount = {
  __typename?: 'SearchChatMessagesCount';
  count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SearchChatMessagesResponse = {
  __typename?: 'SearchChatMessagesResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<SearchChatMessages>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SearchMessageConversations = {
  __typename?: 'SearchMessageConversations';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<MessageConversationSearch>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum SendVerificationCodeViaEnum {
  call = 'call',
  sms = 'sms',
}

export enum SentimentEnum {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE',
}

export type SetDefaultChannelResponse = {
  __typename?: 'SetDefaultChannelResponse';
  data?: Maybe<ChannelUserWorkspace>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SetSecondaryPaymentSourceInput = {
  paymentSourceId: Scalars['String']['input'];
};

export type SetUpEmailMfaResponse = {
  __typename?: 'SetUpEmailMfaResponse';
  data?: Maybe<MfaSwitchEmail>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SetUpMfaStatusResponse = {
  __typename?: 'SetUpMfaStatusResponse';
  data?: Maybe<MfaStatusToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SetUpTOTPResponse = {
  __typename?: 'SetUpTOTPResponse';
  data?: Maybe<MfaToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingUp = {
  __typename?: 'SingUp';
  data?: Maybe<Email>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleActiveStrategyGroup = {
  __typename?: 'SingleActiveStrategyGroup';
  isStrategyGroupActive?: Maybe<Scalars['Boolean']['output']>;
  strategyGroupId?: Maybe<Scalars['Int']['output']>;
};

export type SingleAttribute = {
  __typename?: 'SingleAttribute';
  data?: Maybe<Attribute>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleAttributeValue = {
  __typename?: 'SingleAttributeValue';
  data?: Maybe<AttributeValue>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleBundle = {
  __typename?: 'SingleBundle';
  data?: Maybe<BundleList>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleChannel = {
  __typename?: 'SingleChannel';
  data?: Maybe<Channel>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleChannelSetting = {
  __typename?: 'SingleChannelSetting';
  data?: Maybe<ChannelSetting>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleChatMessage = {
  __typename?: 'SingleChatMessage';
  data?: Maybe<ChatMessage>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleCheckRegulatoryCompliance = {
  __typename?: 'SingleCheckRegulatoryCompliance';
  data?: Maybe<CheckRegulatoryCompliance>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleContact = {
  __typename?: 'SingleContact';
  data?: Maybe<Contact>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleContactNote = {
  __typename?: 'SingleContactNote';
  data?: Maybe<ContactNoteV2>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleDraftMessageConversation = {
  __typename?: 'SingleDraftMessageConversation';
  data?: Maybe<DraftMessageConversation>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleEmailTemplateSegmentResponse = {
  __typename?: 'SingleEmailTemplateSegmentResponse';
  data?: Maybe<EmailTemplateSegment>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleIncomingPhoneNumber = {
  __typename?: 'SingleIncomingPhoneNumber';
  data?: Maybe<IncomingPhoneNumber>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleLowBalanceAlert = {
  __typename?: 'SingleLowBalanceAlert';
  data?: Maybe<LowBalanceAlert>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleMessageConversation = {
  __typename?: 'SingleMessageConversation';
  data?: Maybe<MessageConversation>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleMessageConversationErrorLog = {
  __typename?: 'SingleMessageConversationErrorLog';
  data?: Maybe<MessageConversationErrorLog>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleModule = {
  __typename?: 'SingleModule';
  data?: Maybe<Module>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SinglePlan = {
  __typename?: 'SinglePlan';
  data?: Maybe<Plan>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SinglePlanPrice = {
  __typename?: 'SinglePlanPrice';
  data?: Maybe<PlanPrice>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SinglePowerCampaignCall = {
  __typename?: 'SinglePowerCampaignCall';
  data?: Maybe<PowerCampaignCall>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SinglePrivilege = {
  __typename?: 'SinglePrivilege';
  data?: Maybe<Privilege>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SinglePushCredentialToken = {
  __typename?: 'SinglePushCredentialToken';
  data?: Maybe<PushCredentialToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleRecentMessageConversation = {
  __typename?: 'SingleRecentMessageConversation';
  data?: Maybe<RecentMessageConversation>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleReview = {
  __typename?: 'SingleReview';
  data?: Maybe<CallReview>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleRole = {
  __typename?: 'SingleRole';
  data?: Maybe<Role>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleRoom = {
  __typename?: 'SingleRoom';
  data?: Maybe<Room>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleScreen = {
  __typename?: 'SingleScreen';
  data?: Maybe<Screen>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleScreenPlanMappingInterface = {
  __typename?: 'SingleScreenPlanMappingInterface';
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleScreenRoleMappingInterface = {
  __typename?: 'SingleScreenRoleMappingInterface';
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleSuperviseConference = {
  __typename?: 'SingleSuperviseConference';
  data?: Maybe<SuperviseConference>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleTag = {
  __typename?: 'SingleTag';
  data?: Maybe<Tag>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleTranscriptionInformation = {
  __typename?: 'SingleTranscriptionInformation';
  data?: Maybe<TranscriptionInformation>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleTwilioAvailablePhoneNumber = {
  __typename?: 'SingleTwilioAvailablePhoneNumber';
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleUser = {
  __typename?: 'SingleUser';
  data?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleUserWorkspaceFCMToken = {
  __typename?: 'SingleUserWorkspaceFCMToken';
  data?: Maybe<UserWorkspaceFCMToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleUserWorkspaceFCMTokens = {
  __typename?: 'SingleUserWorkspaceFCMTokens';
  data?: Maybe<UserWorkspaceFCMToken>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleVerifyCallerId = {
  __typename?: 'SingleVerifyCallerId';
  data?: Maybe<VerifyCallerId>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleWorkspace = {
  __typename?: 'SingleWorkspace';
  data?: Maybe<Workspace>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SingleWorkspaceChannelResponse = {
  __typename?: 'SingleWorkspaceChannelResponse';
  country?: Maybe<Scalars['String']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  numberType?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  purchaseAt?: Maybe<Scalars['Date']['output']>;
  purchaseBy?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
};

export type SingleWorkspaceDetail = {
  __typename?: 'SingleWorkspaceDetail';
  data?: Maybe<WorkspaceDetail>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SoleProprietorCampaignChargeInput = {
  referenceId: Scalars['String']['input'];
  useCase: Scalars['String']['input'];
};

export enum SortEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SourceType = {
  __typename?: 'SourceType';
  sourceType?: Maybe<Scalars['String']['output']>;
};

export type StartPowerCampaignsResponse = {
  __typename?: 'StartPowerCampaignsResponse';
  data?: Maybe<SuccessAndFailedPowerCampaignIds>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum StatusEnum {
  active = 'active',
  inactive = 'inactive',
}

export type Strategy = {
  __typename?: 'Strategy';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type StrategyGroup = {
  __typename?: 'StrategyGroup';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type StrategyGroupStrategy = {
  __typename?: 'StrategyGroupStrategy';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  strategy?: Maybe<Strategy>;
  strategyGroup?: Maybe<StrategyGroup>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type StrategyResult = {
  __typename?: 'StrategyResult';
  data?: Maybe<Array<Maybe<ChannelStrategy>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SubscribeWorkspacePlanIntentInput = {
  planId: Scalars['Int']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  assignMemberToChannel?: Maybe<ChannelUserWorkspaceEdge>;
  assignedChannelCounter?: Maybe<AssignedChannelCounter>;
  callerIdVerification?: Maybe<CallerId>;
  chatMessage?: Maybe<ChatMessage>;
  dialerCallPulse?: Maybe<DialerCallPulse>;
  exportContactStatus?: Maybe<ExportContactStatusResponse>;
  exportInvoicesStatus?: Maybe<ExportInvoiceStatusResponse>;
  getPowerImportUploadStatus?: Maybe<PowerImportUploadStatusResponse>;
  importBulkContactProgress?: Maybe<ImportBulkContactProgressResponse>;
  kycVerificationSession?: Maybe<KycVerificationSession>;
  liveConference?: Maybe<LiveConference>;
  liveConferenceCount?: Maybe<LiveConferenceCount>;
  messageConversation?: Maybe<MessageConversation>;
  messageConversationErrorLog?: Maybe<MessageConversationErrorLog>;
  messageConversationV2?: Maybe<MessageConversationEdge>;
  messageSchedule?: Maybe<MessageSchedule>;
  notificationSubscription?: Maybe<NotificationSubscription>;
  paymentOrderCreated?: Maybe<PaymentOrder>;
  sendMessage?: Maybe<Message>;
  sendTranscriptionStatus?: Maybe<TranscriptionInformation>;
  unAssignMemberFromChannel?: Maybe<ChannelUserWorkspaceEdge>;
  unpaidUsersExportStatus?: Maybe<Media>;
  walletDetails?: Maybe<WalletDetailsResponse>;
  walletUsageHistoryExportMedia?: Maybe<Media>;
  workspaceCounter?: Maybe<WorkspaceCounters>;
  workspaceMemberNotificationCounter?: Maybe<WorkspaceMemberNotificationCounter>;
  workspaceMembers?: Maybe<UserWorkspace>;
  workspaceMembersOnlineManagement?: Maybe<UserOnlineManagement>;
  workspaceRateLimit?: Maybe<Array<Maybe<WorkspaceRateLimit>>>;
  workspaceRateLimitExhaust?: Maybe<Array<Maybe<WorkspaceRateLimitExhaust>>>;
};

export type SubscriptionassignedChannelCounterArgs = {
  identity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionchatMessageArgs = {
  identity?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptiondialerCallPulseArgs = {
  identity: Scalars['String']['input'];
};

export type SubscriptiongetPowerImportUploadStatusArgs = {
  id: Scalars['Int']['input'];
};

export type SubscriptionimportBulkContactProgressArgs = {
  eventReferenceId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionmessageConversationArgs = {
  identity?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptionmessageConversationV2Args = {
  identity?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptionmessageScheduleArgs = {
  identity?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptionsendMessageArgs = {
  identity: Scalars['String']['input'];
};

export type SubscriptionwalletUsageHistoryExportMediaArgs = {
  identity: Scalars['String']['input'];
};

export type SubscriptionworkspaceCounterArgs = {
  identity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionDetail = {
  __typename?: 'SubscriptionDetail';
  billingCycleDate?: Maybe<Scalars['Date']['output']>;
  cancelScheduledAt?: Maybe<Scalars['Date']['output']>;
  canceledAt?: Maybe<Scalars['Date']['output']>;
  canceledReason?: Maybe<Scalars['String']['output']>;
  dueIn?: Maybe<Scalars['Date']['output']>;
  monthlyFees?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionScheduledChanges = {
  __typename?: 'SubscriptionScheduledChanges';
  billingPeriodUnit?: Maybe<Scalars['String']['output']>;
  cancelScheduleCreatedAt?: Maybe<Scalars['Int']['output']>;
  cancelledAt?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currentTermEnd?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  itemProductFamily?: Maybe<Scalars['String']['output']>;
  mrr?: Maybe<Scalars['Int']['output']>;
  nextBillingAt?: Maybe<Scalars['Int']['output']>;
  remainingBillingCycles?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionItems?: Maybe<Array<Maybe<PlanSubscriptionItem>>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type SuccessAndFailedPowerCampaignIds = {
  __typename?: 'SuccessAndFailedPowerCampaignIds';
  startFailedIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  startSuccessIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type SuperviseConference = {
  __typename?: 'SuperviseConference';
  supervisionId?: Maybe<Scalars['String']['output']>;
  supervisionMode?: Maybe<SupervisionModeEnum>;
};

export enum SupervisionModeEnum {
  barge = 'barge',
  listen = 'listen',
  muted = 'muted',
  un_muted = 'un_muted',
  whisper = 'whisper',
}

export type SwitchPaymentSourceInput = {
  paymentSourceId: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TagEnum>;
};

export type TagEdge = {
  __typename?: 'TagEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Tag>;
};

export enum TagEnum {
  contacts = 'contacts',
}

export type Team = {
  __typename?: 'Team';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TeamEdge = {
  __typename?: 'TeamEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TeamsInterface>;
};

export type TeamMemberEdge = {
  __typename?: 'TeamMemberEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TeamMembersInterface>;
};

export type TeamMembersInterface = {
  __typename?: 'TeamMembersInterface';
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<StatusEnum>;
  teamId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspacesId?: Maybe<Scalars['Int']['output']>;
};

export type TeamsCountResponse = {
  __typename?: 'TeamsCountResponse';
  count: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type TeamsInterface = {
  __typename?: 'TeamsInterface';
  createdBy?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<Maybe<User>>>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusEnum>;
  teamMembers?: Maybe<Array<Maybe<TeamMembersInterface>>>;
  totalMembers?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  workspacesId?: Maybe<Scalars['Int']['output']>;
};

export type TeamsResponse = {
  __typename?: 'TeamsResponse';
  data?: Maybe<TeamsInterface>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TemplateNotification = {
  __typename?: 'TemplateNotification';
  body?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<LocaleEnum>;
  parentId?: Maybe<Scalars['Int']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NotificationTypeEnum>;
};

export type TemplateNotificationEdge = {
  __typename?: 'TemplateNotificationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TemplateNotification>;
};

export enum ThresholdUnitEnum {
  minutes = 'minutes',
  segments = 'segments',
}

export type Timezone = {
  __typename?: 'Timezone';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ToggleChannelPinResponse = {
  __typename?: 'ToggleChannelPinResponse';
  data?: Maybe<ChannelUserWorkspace>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ToggleIntegrationChannelStatusResponse = {
  __typename?: 'ToggleIntegrationChannelStatusResponse';
  data?: Maybe<IntegrationChannelV2>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum TopicEnum {
  CreateUser = 'CreateUser',
  LoadWallet = 'LoadWallet',
}

export type TranscriptionInformation = {
  __typename?: 'TranscriptionInformation';
  callSummary?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  jobKeyName?: Maybe<Scalars['String']['output']>;
  jobResponse?: Maybe<Scalars['JSON']['output']>;
  jobStatus?: Maybe<JobStatusEnum>;
  providerCallRecordingsId?: Maybe<Scalars['Int']['output']>;
  sentiment?: Maybe<SentimentEnum>;
  targetLanguageCode?: Maybe<Scalars['String']['output']>;
  transcribedText?: Maybe<Scalars['String']['output']>;
};

export type TranscriptionText = {
  __typename?: 'TranscriptionText';
  content?: Maybe<Scalars['String']['output']>;
  participantRole?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
};

export type TwilioAvailablePhoneNumber = {
  __typename?: 'TwilioAvailablePhoneNumber';
  edges?: Maybe<Array<Maybe<TwilioPhoneNumber>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TwilioCapability = {
  __typename?: 'TwilioCapability';
  MMS?: Maybe<Scalars['Boolean']['output']>;
  SMS?: Maybe<Scalars['Boolean']['output']>;
  voice?: Maybe<Scalars['Boolean']['output']>;
};

export enum TwilioGrantEnum {
  ChatGrant = 'ChatGrant',
  VideoGrant = 'VideoGrant',
  VoiceGrant = 'VoiceGrant',
}

export type TwilioPhoneNumber = {
  __typename?: 'TwilioPhoneNumber';
  addressRequirements?: Maybe<Scalars['String']['output']>;
  basePrice?: Maybe<Scalars['String']['output']>;
  beta?: Maybe<Scalars['Boolean']['output']>;
  capabilities?: Maybe<TwilioCapability>;
  currentPrice?: Maybe<Scalars['String']['output']>;
  endUser?: Maybe<Scalars['Boolean']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  isoCountry?: Maybe<Scalars['String']['output']>;
  numberType?: Maybe<NumberTypeEnum>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rateCenter?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  supportingDocument?: Maybe<Scalars['Boolean']['output']>;
};

export type TwimlSay = {
  __typename?: 'TwimlSay';
  attributes?: Maybe<Array<Maybe<SayAttributes>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TwimlSayInput = {
  attributes?: InputMaybe<Array<InputMaybe<SayAttributesInput>>>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export enum UiVersionEnum {
  v1 = 'v1',
  v2 = 'v2',
}

export type UnlimitedConfig = {
  __typename?: 'UnlimitedConfig';
  consumedThreshold?: Maybe<Scalars['Int']['output']>;
  direction?: Maybe<UnlimitedConfigDirectionEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<ThresholdUnitEnum>;
};

export enum UnlimitedConfigChargeTypeEnum {
  message = 'message',
  voice = 'voice',
}

export enum UnlimitedConfigDirectionEnum {
  incoming = 'incoming',
  outgoing = 'outgoing',
}

export type UnlimitedUsagePercentageResponse = {
  __typename?: 'UnlimitedUsagePercentageResponse';
  data?: Maybe<UsagePercentage>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UnpaidUser = {
  __typename?: 'UnpaidUser';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  signedUpDate?: Maybe<Scalars['Date']['output']>;
};

export type UnsetSecondaryPaymentSourceInput = {
  paymentSourceId: Scalars['String']['input'];
};

export type UpdateBulkMessagingCampaignResponse = {
  __typename?: 'UpdateBulkMessagingCampaignResponse';
  data?: Maybe<BulkMessagingCampaign>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateInviteWorkspaceMember = {
  role?: InputMaybe<RoleEnum>;
};

export type UpdateInviteWorkspaceMemberV2 = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role: RoleEnum;
};

export type UpdateMessageSchedule = {
  body?: InputMaybe<Scalars['String']['input']>;
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  scheduleAt: Scalars['Date']['input'];
};

export type UpdateNotificationTemplateResponse = {
  __typename?: 'UpdateNotificationTemplateResponse';
  data?: Maybe<TemplateNotification>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdatePowerCampaignContactDetails = {
  campaignDispositionId?: InputMaybe<Scalars['Int']['input']>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  contactId: Scalars['Int']['input'];
  contactNote?: InputMaybe<Array<InputMaybe<InputContactNoteInterface>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UpdateRecordingInput = {
  status: RecordingStatusEnum;
};

export type UpdateTeamMembersInterface = {
  status: StatusEnum;
};

export type UpdateWorkspaceMemberV2Response = {
  __typename?: 'UpdateWorkspaceMemberV2Response';
  data?: Maybe<UpdatedWorkspaceMemberResponse>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdatedEmail = {
  __typename?: 'UpdatedEmail';
  email: Scalars['String']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
};

export type UpdatedWorkspaceMemberResponse = {
  __typename?: 'UpdatedWorkspaceMemberResponse';
  role?: Maybe<Role>;
  user?: Maybe<User>;
  userWorkspace?: Maybe<UserWorkspace>;
};

export type UpgradeWorkspaceSubscriptionInput = {
  gatewayAccountId: Scalars['String']['input'];
  gatewayToken?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: PaymentGatewayEnum;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  targetedPlanPriceId: Scalars['Int']['input'];
};

export type UpgradeWorkspaceSubscriptionIntentInput = {
  estimatedAmount: Scalars['Int']['input'];
  referenceId: Scalars['String']['input'];
};

export type UsagePercentage = {
  __typename?: 'UsagePercentage';
  usagePercentage?: Maybe<Scalars['Float']['output']>;
};

export type UsageReportNotification = {
  __typename?: 'UsageReportNotification';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  frequency?: Maybe<UsageReportNotificationFrequencyEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  localDayOfMonth?: Maybe<Scalars['Int']['output']>;
  localDayOfWeek?: Maybe<Scalars['Int']['output']>;
  localMonthOfYear?: Maybe<Scalars['Int']['output']>;
  localSendAt?: Maybe<Scalars['String']['output']>;
  localWeekOfMonth?: Maybe<Scalars['Int']['output']>;
  localWeekdayOfMonth?: Maybe<Scalars['Int']['output']>;
  monthlyScheduleType?: Maybe<MonthlyScheduleTypeEnum>;
};

export enum UsageReportNotificationFrequencyEnum {
  daily = 'daily',
  monthly = 'monthly',
  weekly = 'weekly',
  yearly = 'yearly',
}

export type UsageReportNotificationResponse = {
  __typename?: 'UsageReportNotificationResponse';
  data?: Maybe<UsageReportNotification>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UsageTypeEnum {
  INCOMING_CALL = 'INCOMING_CALL',
  INCOMING_MESSAGE = 'INCOMING_MESSAGE',
  OUTGOING_CALL = 'OUTGOING_CALL',
  OUTGOING_MESSAGE = 'OUTGOING_MESSAGE',
}

export type UseCase = {
  __typename?: 'UseCase';
  value?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  accountStatus?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  averageRiskScore?: Maybe<Scalars['Float']['output']>;
  coverProfilePicture?: Maybe<Media>;
  dueIn?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerifiedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identityProvider?: Maybe<IdentityProviderEnum>;
  language?: Maybe<Scalars['String']['output']>;
  lastPasswordResetAt?: Maybe<Scalars['Date']['output']>;
  mfaEmailEnabled?: Maybe<Scalars['Boolean']['output']>;
  mfaReminderAt?: Maybe<Scalars['Date']['output']>;
  mfaTotpEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Media>;
  roles?: Maybe<Array<Maybe<Role>>>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalMonthlyFee?: Maybe<Scalars['Float']['output']>;
  uiVersion?: Maybe<UiVersionEnum>;
  workspaces?: Maybe<Array<Maybe<Workspace>>>;
};

export type UserActiveStatus = {
  __typename?: 'UserActiveStatus';
  activeStatus?: Maybe<UserActiveStatusEnum>;
  awaySet?: Maybe<Scalars['Date']['output']>;
  awayTill?: Maybe<Scalars['Date']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UserActiveStatusEnum {
  active = 'active',
  away = 'away',
}

export type UserCompleteStatementResponse = {
  __typename?: 'UserCompleteStatementResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<UserTransactionDetails>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserData = {
  __typename?: 'UserData';
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserProfile>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<User>;
};

export type UserOnlineManagement = {
  __typename?: 'UserOnlineManagement';
  activeStatus?: Maybe<UserActiveStatusEnum>;
  awaySet?: Maybe<Scalars['Date']['output']>;
  awayTill?: Maybe<Scalars['Date']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastSeenAt?: Maybe<Scalars['Date']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  userWorkspace?: Maybe<UserWorkspace>;
  userWorkspaceId?: Maybe<Scalars['Int']['output']>;
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type UserOnlineManagementResponse = {
  __typename?: 'UserOnlineManagementResponse';
  data?: Maybe<UserActiveStatus>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  countryId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  profilePicture?: Maybe<Image>;
};

export type UserRole = {
  __typename?: 'UserRole';
  id?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export type UserRoleEdge = {
  __typename?: 'UserRoleEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<UserRole>;
};

export type UserToken = {
  __typename?: 'UserToken';
  challengeName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token?: Maybe<LoginToken>;
  twoFactorAuthenticationRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type UserTransactionDetails = {
  __typename?: 'UserTransactionDetails';
  agentPhoneNumber?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  clientPhoneNumber?: Maybe<Scalars['String']['output']>;
  creditAmount?: Maybe<Scalars['Float']['output']>;
  debitAmount?: Maybe<Scalars['Float']['output']>;
  direction?: Maybe<DirectionTypeEnum>;
  duration?: Maybe<Scalars['Int']['output']>;
  messageConversationId?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
};

export type UserWalletUsageDetails = {
  __typename?: 'UserWalletUsageDetails';
  balance?: Maybe<Scalars['Float']['output']>;
  creditAmount?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  debitAmount?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
};

export type UserWidgetGroup = {
  __typename?: 'UserWidgetGroup';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  widgets?: Maybe<Array<Maybe<MyWidget>>>;
};

export type UserWorkspace = {
  __typename?: 'UserWorkspace';
  callPlatform?: Maybe<DevicePlatformEnum>;
  channels?: Maybe<Array<Maybe<Channel>>>;
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  status?: Maybe<UserWorkspaceStatusEnum>;
  user?: Maybe<User>;
  userOnlineManagement?: Maybe<UserOnlineManagement>;
  userWorkspaceRoles?: Maybe<Array<Maybe<UserWorkspaceRole>>>;
  workspace?: Maybe<Workspace>;
};

export type UserWorkspaceFCMToken = {
  __typename?: 'UserWorkspaceFCMToken';
  id?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<NotificationPlatformEnum>;
  token?: Maybe<Scalars['String']['output']>;
};

export type UserWorkspaceRole = {
  __typename?: 'UserWorkspaceRole';
  role?: Maybe<Role>;
};

export enum UserWorkspaceStatusEnum {
  accepted = 'accepted',
  deactivated = 'deactivated',
  declined = 'declined',
  expired = 'expired',
  pending = 'pending',
}

export enum UtmAttribute {
  campaign = 'campaign',
  content = 'content',
  medium = 'medium',
  source = 'source',
  term = 'term',
}

export type UtmAttributeValue = {
  __typename?: 'UtmAttributeValue';
  label?: Maybe<Scalars['String']['output']>;
};

export type UtmAttributeValueResponse = {
  __typename?: 'UtmAttributeValueResponse';
  data?: Maybe<Array<Maybe<UtmAttributeValue>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidateActivationCodeData = {
  __typename?: 'ValidateActivationCodeData';
  planId?: Maybe<Scalars['Int']['output']>;
};

export enum VerifyAndTransitionModelEnum {
  MessageConversation = 'MessageConversation',
  RecentMessageConversation = 'RecentMessageConversation',
}

export type VerifyCallerId = {
  __typename?: 'VerifyCallerId';
  friendlyName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  validationCode?: Maybe<Scalars['String']['output']>;
};

export type VerifyInvitationToken = {
  __typename?: 'VerifyInvitationToken';
  data?: Maybe<VerifyInvitationTokenResponse>;
  message?: Maybe<Scalars['String']['output']>;
};

export type VerifyInvitationTokenResponse = {
  __typename?: 'VerifyInvitationTokenResponse';
  name?: Maybe<Scalars['String']['output']>;
  passwordRequired?: Maybe<Scalars['Boolean']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type VerifyPromoCodeData = {
  __typename?: 'VerifyPromoCodeData';
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<CouponDiscountTypeEnum>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyPromoCodeResponse = {
  __typename?: 'VerifyPromoCodeResponse';
  data?: Maybe<VerifyPromoCodeData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ViewByWorkspaces = {
  __typename?: 'ViewByWorkspaces';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  owner?: Maybe<User>;
};

export type VoiceMailProxy = {
  __typename?: 'VoiceMailProxy';
  data?: Maybe<VoiceMailProxyResponse>;
  message?: Maybe<Scalars['String']['output']>;
};

export type VoiceMailProxyResponse = {
  __typename?: 'VoiceMailProxyResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  messageConversation?: Maybe<MessageConversation>;
  recentMessageConversation?: Maybe<RecentMessageConversation>;
};

export type WalletDetailWithLastCredited = {
  __typename?: 'WalletDetailWithLastCredited';
  amount?: Maybe<Scalars['Float']['output']>;
  lastCredit?: Maybe<Scalars['Float']['output']>;
  lastTransactionDate?: Maybe<Scalars['Date']['output']>;
};

export type WalletDetailWithLastCreditedResponse = {
  __typename?: 'WalletDetailWithLastCreditedResponse';
  data?: Maybe<WalletDetailWithLastCredited>;
  message: Scalars['String']['output'];
};

export type WalletDetails = {
  __typename?: 'WalletDetails';
  amount: Scalars['Float']['output'];
  isAutoRechargeEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type WalletDetailsResponse = {
  __typename?: 'WalletDetailsResponse';
  amount: Scalars['Float']['output'];
};

export type WalletExpenditureItem = {
  __typename?: 'WalletExpenditureItem';
  amountSpent?: Maybe<Scalars['String']['output']>;
  spentSection?: Maybe<Scalars['String']['output']>;
};

export type WalletExpenditureRes = {
  __typename?: 'WalletExpenditureRes';
  data?: Maybe<Array<Maybe<WalletExpenditureItem>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WalletLoadLog = {
  __typename?: 'WalletLoadLog';
  created?: Maybe<User>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<BillingJournalEntriesSourceTypeEnum>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workspace?: Maybe<Workspace>;
};

export type WalletLoadLogResponse = {
  __typename?: 'WalletLoadLogResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<WalletLoadLog>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WalletResponse = {
  __typename?: 'WalletResponse';
  data?: Maybe<WalletDetails>;
  message: Scalars['String']['output'];
};

export enum WidgetSlugEnum {
  ActivityAfterBusinessHours = 'ActivityAfterBusinessHours',
  AnswerRate = 'AnswerRate',
  AverageAnswerTime = 'AverageAnswerTime',
  CallDistribution = 'CallDistribution',
  CallVolume = 'CallVolume',
  ClosedConversation = 'ClosedConversation',
  CriticalEvent = 'CriticalEvent',
  KeyKpi = 'KeyKpi',
  Leaderboard = 'Leaderboard',
  LiveCall = 'LiveCall',
  MissedCall = 'MissedCall',
  OpenedConversation = 'OpenedConversation',
  TotalCall = 'TotalCall',
  TotalMessage = 'TotalMessage',
  UniqueVsRepeatedCaller = 'UniqueVsRepeatedCaller',
  WalletSpentBreakdown = 'WalletSpentBreakdown',
}

export type WordFrequencyAnalyticItem = {
  __typename?: 'WordFrequencyAnalyticItem';
  frequency?: Maybe<Scalars['Int']['output']>;
  word?: Maybe<Scalars['String']['output']>;
};

export type WordFrequencyAnalyticResponse = {
  __typename?: 'WordFrequencyAnalyticResponse';
  edges?: Maybe<Array<Maybe<WordFrequencyAnalyticItem>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  active?: Maybe<Scalars['Boolean']['output']>;
  availableBalance?: Maybe<Scalars['Float']['output']>;
  channels?: Maybe<Array<Maybe<Channel>>>;
  country?: Maybe<Country>;
  coverProfile?: Maybe<Media>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentUserWorkspace?: Maybe<UserWorkspace>;
  hasCompleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incomingPhoneNumbers?: Maybe<Array<Maybe<IncomingPhoneNumber>>>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  kycVerified?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Media>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  numberOfUsers?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<User>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  pkReference?: Maybe<Scalars['String']['output']>;
  preferredContactMethodReminderAt?: Maybe<Scalars['Date']['output']>;
  providerAccount?: Maybe<ProviderAccount>;
  rateLimitTier?: Maybe<Scalars['Int']['output']>;
  riskScore?: Maybe<RiskScore>;
  salesDealCreatedAt?: Maybe<Scalars['Date']['output']>;
  salesDealCreatedBy?: Maybe<User>;
  salesDealCreatedById?: Maybe<Scalars['Int']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WorkspaceStatusEnum>;
  subscription?: Maybe<SubscriptionDetail>;
  timezone?: Maybe<Scalars['String']['output']>;
  timezoneId?: Maybe<Scalars['Int']['output']>;
  timezoneLabel?: Maybe<Scalars['String']['output']>;
  timezoneValue?: Maybe<Scalars['String']['output']>;
  totalPhoneNumbers?: Maybe<Scalars['Int']['output']>;
  trusted?: Maybe<Scalars['Boolean']['output']>;
  unreadCountWorkspace?: Maybe<Scalars['Int']['output']>;
  v2MigratedAt?: Maybe<Scalars['Date']['output']>;
  workspaceDetails?: Maybe<WorkspaceDetail>;
};

export type WorkspaceA2pVerificationStatusData = {
  __typename?: 'WorkspaceA2pVerificationStatusData';
  a2pVerified?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkspaceA2pVerificationStatusResponse = {
  __typename?: 'WorkspaceA2pVerificationStatusResponse';
  data?: Maybe<WorkspaceA2pVerificationStatusData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceAuthEdge = {
  __typename?: 'WorkspaceAuthEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<UserWorkspace>;
};

export type WorkspaceAuthMe = {
  __typename?: 'WorkspaceAuthMe';
  data?: Maybe<WorkspaceLogin>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceAuthMeV2 = {
  __typename?: 'WorkspaceAuthMeV2';
  data?: Maybe<Workspace>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceByPhoneNumberResponse = {
  __typename?: 'WorkspaceByPhoneNumberResponse';
  data?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceChannelMember = {
  __typename?: 'WorkspaceChannelMember';
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  isAssignedToChannel?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<UserWorkspaceStatusEnum>;
  user?: Maybe<User>;
};

export type WorkspaceClaimedFreeNumbersResponse = {
  __typename?: 'WorkspaceClaimedFreeNumbersResponse';
  data: Array<ClaimedFreeNumber>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceCounters = {
  __typename?: 'WorkspaceCounters';
  channelId?: Maybe<Scalars['Int']['output']>;
  counter?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  userWorkspaceId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceDetail = {
  __typename?: 'WorkspaceDetail';
  accountType?: Maybe<WorkspaceDetailAccountTypeEnum>;
  address?: Maybe<Address>;
  documents?: Maybe<Array<Maybe<Media>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noOfEmployees?: Maybe<Scalars['Int']['output']>;
  planPrice?: Maybe<PlanPrice>;
  socialUrl?: Maybe<Scalars['String']['output']>;
  useCases?: Maybe<Array<Maybe<UseCase>>>;
};

export enum WorkspaceDetailAccountTypeEnum {
  company = 'company',
  personal = 'personal',
}

export type WorkspaceDetailEdge = {
  __typename?: 'WorkspaceDetailEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<WorkspaceDetail>;
};

export type WorkspaceEdge = {
  __typename?: 'WorkspaceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Workspace>;
};

export type WorkspaceLogin = {
  __typename?: 'WorkspaceLogin';
  token?: Maybe<WorkspaceToken>;
  workspaceUser?: Maybe<UserWorkspace>;
};

export type WorkspaceMember = {
  __typename?: 'WorkspaceMember';
  data?: Maybe<UserWorkspace>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceMemberAnalyticData = {
  __typename?: 'WorkspaceMemberAnalyticData';
  duration?: Maybe<Scalars['Interval']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inboundConference?: Maybe<Scalars['Int']['output']>;
  lastOnlineSince?: Maybe<Scalars['DateTime']['output']>;
  member?: Maybe<MemberAnalytic>;
  missedConference?: Maybe<Scalars['Int']['output']>;
  outboundConference?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceMemberAnalyticEdge = {
  __typename?: 'WorkspaceMemberAnalyticEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<WorkspaceMemberAnalyticData>;
};

export type WorkspaceMemberCountItem = {
  __typename?: 'WorkspaceMemberCountItem';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceMemberLogin = {
  __typename?: 'WorkspaceMemberLogin';
  data?: Maybe<WorkspaceLogin>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceMemberNotificationCounter = {
  __typename?: 'WorkspaceMemberNotificationCounter';
  counter?: Maybe<Scalars['Int']['output']>;
  memberId?: Maybe<Scalars['Int']['output']>;
  roomId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userWorkspaceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceMemberV2CountResponse = {
  __typename?: 'WorkspaceMemberV2CountResponse';
  data?: Maybe<Array<Maybe<WorkspaceMemberCountItem>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceMembers = {
  __typename?: 'WorkspaceMembers';
  channels?: Maybe<Array<Maybe<Channel>>>;
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Array<Maybe<Metrics>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  status?: Maybe<UserWorkspaceStatusEnum>;
  unreadCounter?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userOnlineManagement?: Maybe<UserOnlineManagement>;
  workspace?: Maybe<Workspace>;
};

export type WorkspacePreferredContactMethod = {
  __typename?: 'WorkspacePreferredContactMethod';
  email?: Maybe<Scalars['String']['output']>;
  emailEnabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messagingEnabled?: Maybe<Scalars['Boolean']['output']>;
  messagingNumber?: Maybe<Scalars['String']['output']>;
  messagingType?: Maybe<ContactMessagingTypeEnum>;
  phoneCallEnabled?: Maybe<Scalars['Boolean']['output']>;
  phoneCallNumber?: Maybe<Scalars['String']['output']>;
  prefEndTime?: Maybe<Scalars['String']['output']>;
  prefStartTime?: Maybe<Scalars['String']['output']>;
};

export type WorkspacePreferredContactMethodResponse = {
  __typename?: 'WorkspacePreferredContactMethodResponse';
  data?: Maybe<WorkspacePreferredContactMethod>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum WorkspaceProviderSubAccountSuspendedReasonEnum {
  dunning_failure = 'dunning_failure',
  low_wallet_balance = 'low_wallet_balance',
  manually_by_admin = 'manually_by_admin',
}

export enum WorkspaceProviderSubaccountStatusEnum {
  active = 'active',
  closed = 'closed',
  suspended = 'suspended',
}

export type WorkspaceRateLimit = {
  __typename?: 'WorkspaceRateLimit';
  category?: Maybe<WorkspaceRateLimitExhaustCategoryEnum>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  direction?: Maybe<DirectionTypeEnum>;
  exhaust?: Maybe<WorkspaceRateLimitExhaust>;
  id?: Maybe<Scalars['Int']['output']>;
  segmentLimit?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type WorkspaceRateLimitExhaust = {
  __typename?: 'WorkspaceRateLimitExhaust';
  category?: Maybe<WorkspaceRateLimitExhaustCategoryEnum>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  direction?: Maybe<DirectionTypeEnum>;
  exhaustedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  windowDate?: Maybe<Scalars['DateOnly']['output']>;
};

export enum WorkspaceRateLimitExhaustCategoryEnum {
  call = 'call',
  message = 'message',
}

export enum WorkspaceStatusEnum {
  approved = 'approved',
  blocked = 'blocked',
  closed = 'closed',
  created = 'created',
  limited = 'limited',
  member_subscription_created = 'member_subscription_created',
  number_subscription_created = 'number_subscription_created',
  payment_failed = 'payment_failed',
  pending = 'pending',
  provider_pending = 'provider_pending',
  published_workspace_detail = 'published_workspace_detail',
  reject = 'reject',
  sub_account_created = 'sub_account_created',
  subscription_completed = 'subscription_completed',
  suspended = 'suspended',
  workspace_close_billing_subscription_plan_update_failed = 'workspace_close_billing_subscription_plan_update_failed',
  workspace_close_delete_billing_discount_failed = 'workspace_close_delete_billing_discount_failed',
  workspace_close_delete_billing_subscription_failed = 'workspace_close_delete_billing_subscription_failed',
  workspace_close_delete_chargebee_coupon_failed = 'workspace_close_delete_chargebee_coupon_failed',
  workspace_close_delete_number_subscription_plan_failed = 'workspace_close_delete_number_subscription_plan_failed',
  workspace_close_delete_user_failed = 'workspace_close_delete_user_failed',
  workspace_close_disable_cognito_user_failed = 'workspace_close_disable_cognito_user_failed',
  workspace_close_provider_channel_update_failed = 'workspace_close_provider_channel_update_failed',
  workspace_close_provider_close_subaccount_failed = 'workspace_close_provider_close_subaccount_failed',
  workspace_close_provider_release_number_failed = 'workspace_close_provider_release_number_failed',
  workspace_close_remove_member_from_workspace_failed = 'workspace_close_remove_member_from_workspace_failed',
  workspace_close_subscription_cancellation_failed = 'workspace_close_subscription_cancellation_failed',
  workspace_close_unassociate_chargebee_coupon_failed = 'workspace_close_unassociate_chargebee_coupon_failed',
  workspace_close_update_provider_subaccount_failed = 'workspace_close_update_provider_subaccount_failed',
  workspace_close_workspace_update_failed = 'workspace_close_workspace_update_failed',
}

export type WorkspaceSubaccountActivityLog = {
  __typename?: 'WorkspaceSubaccountActivityLog';
  action?: Maybe<WorkspaceSubaccountActivityLogActionEnum>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  systemSuspend?: Maybe<WorkspaceProviderSubAccountSuspendedReasonEnum>;
  triggeredAt?: Maybe<Scalars['Date']['output']>;
  triggeredBy?: Maybe<User>;
  triggeredById?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
  workspaceSubaccountId?: Maybe<Scalars['Int']['output']>;
};

export enum WorkspaceSubaccountActivityLogActionEnum {
  closed = 'closed',
  suspend = 'suspend',
  unsuspend = 'unsuspend',
}

export type WorkspaceSubscriptionDiscount = {
  __typename?: 'WorkspaceSubscriptionDiscount';
  discountPercent?: Maybe<Scalars['Float']['output']>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceSubscriptionOverview = {
  __typename?: 'WorkspaceSubscriptionOverview';
  discount?: Maybe<WorkspaceSubscriptionDiscount>;
  label?: Maybe<Scalars['String']['output']>;
  nextBillingDate?: Maybe<Scalars['Date']['output']>;
  periodicity?: Maybe<Scalars['String']['output']>;
  promo?: Maybe<WorkspaceSubscriptionPromo>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceSubscriptionPlan = {
  __typename?: 'WorkspaceSubscriptionPlan';
  id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Plan>;
};

export type WorkspaceSubscriptionPromo = {
  __typename?: 'WorkspaceSubscriptionPromo';
  label?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceToken = {
  __typename?: 'WorkspaceToken';
  access?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceUser = {
  __typename?: 'WorkspaceUser';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceUserDetail = {
  __typename?: 'WorkspaceUserDetail';
  accountType?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  useCases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WorkspaceWithChannelCountResponse = {
  __typename?: 'WorkspaceWithChannelCountResponse';
  count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceWithChannelMetricsResponse = {
  __typename?: 'WorkspaceWithChannelMetricsResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<Workspace>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type addTeamsMembersResponse = {
  __typename?: 'addTeamsMembersResponse';
  data?: Maybe<Array<Maybe<TeamMembersInterface>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type adminUsageDetailMessageConversation = {
  __typename?: 'adminUsageDetailMessageConversation';
  chargeType?: Maybe<BillingJournalEntriesChargeType>;
  commission?: Maybe<Scalars['Float']['output']>;
  debit?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  participants?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  segments?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
};

export type adminUsageDetailsMessageConversationResponse = {
  __typename?: 'adminUsageDetailsMessageConversationResponse';
  data?: Maybe<Array<Maybe<adminUsageDetailMessageConversation>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum complianceSoleProprietorProfileStatus {
  a2p_end_user_create_failed = 'a2p_end_user_create_failed',
  a2p_profile_address_create_failed = 'a2p_profile_address_create_failed',
  a2p_profile_address_created = 'a2p_profile_address_created',
  a2p_profile_address_db_create_failed = 'a2p_profile_address_db_create_failed',
  a2p_profile_address_db_update_failed = 'a2p_profile_address_db_update_failed',
  a2p_profile_attach_end_user_failed = 'a2p_profile_attach_end_user_failed',
  a2p_profile_attach_profile_bundle_failed = 'a2p_profile_attach_profile_bundle_failed',
  a2p_profile_attach_supporting_document_failed = 'a2p_profile_attach_supporting_document_failed',
  a2p_profile_create_evaluation_failed = 'a2p_profile_create_evaluation_failed',
  a2p_profile_create_failed = 'a2p_profile_create_failed',
  a2p_profile_created = 'a2p_profile_created',
  a2p_profile_db_update_failed = 'a2p_profile_db_update_failed',
  a2p_profile_draft = 'a2p_profile_draft',
  a2p_profile_draft_failed = 'a2p_profile_draft_failed',
  a2p_profile_evaluation_failed = 'a2p_profile_evaluation_failed',
  a2p_profile_submit_db_update_failed = 'a2p_profile_submit_db_update_failed',
  a2p_profile_submit_failed = 'a2p_profile_submit_failed',
  a2p_profile_submitted = 'a2p_profile_submitted',
  a2p_profile_supporting_document_create_failed = 'a2p_profile_supporting_document_create_failed',
  a2p_profile_twilio_approved = 'a2p_profile_twilio_approved',
  a2p_profile_twilio_in_review = 'a2p_profile_twilio_in_review',
  a2p_profile_twilio_rejected = 'a2p_profile_twilio_rejected',
}

export type createBusinessProfileInput = {
  businessEmail: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type createTeamsInput = {
  description: Scalars['String']['input'];
  inputTeamMembersInterface?: InputMaybe<Array<InputMaybe<InputTeamMembers>>>;
  name: Scalars['String']['input'];
  status: StatusEnum;
};

export type dashboardMemberLeaderBoardRes = {
  __typename?: 'dashboardMemberLeaderBoardRes';
  data?: Maybe<Array<Maybe<MemberLeaderBoardItem>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type getCampaignRecipientsByCampaignIdResponse = {
  __typename?: 'getCampaignRecipientsByCampaignIdResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<CampaignRecipientsByCampaignId>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type getRecipientsByCampaignRunResponse = {
  __typename?: 'getRecipientsByCampaignRunResponse';
  cursor?: Maybe<Cursor>;
  data?: Maybe<Array<Maybe<BulkMessageCampaignRunRecipient>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type kyc = {
  __typename?: 'kyc';
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  status?: Maybe<kycStatus>;
  workspace?: Maybe<Workspace>;
};

export enum kycStatus {
  not_verified = 'not_verified',
  pending = 'pending',
  rejected = 'rejected',
  verified = 'verified',
}

export enum labelTypeEnum {
  daily = 'daily',
  hourly = 'hourly',
  weekDays = 'weekDays',
}

export type paymentRequestData = {
  __typename?: 'paymentRequestData';
  amount: Scalars['Float']['output'];
  purpose: PaymentRequestPurposeEnum;
};

export type setChannelsInGroup = {
  __typename?: 'setChannelsInGroup';
  assignedChannels?: Maybe<Array<Maybe<Channel>>>;
  unAssignedChannels?: Maybe<Array<Maybe<Channel>>>;
};

export type setChannelsInGroupType = {
  __typename?: 'setChannelsInGroupType';
  data?: Maybe<setChannelsInGroup>;
  message?: Maybe<Scalars['String']['output']>;
};

export type updateTeamMemberResponse = {
  __typename?: 'updateTeamMemberResponse';
  data?: Maybe<TeamMembersInterface>;
  message?: Maybe<Scalars['String']['output']>;
};

export type updateTeamsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusEnum>;
};

export type validateActivationCodeResponse = {
  __typename?: 'validateActivationCodeResponse';
  data?: Maybe<CustomPlan>;
  message?: Maybe<Scalars['String']['output']>;
};

export type verifyPaymentRequest = {
  __typename?: 'verifyPaymentRequest';
  data?: Maybe<paymentRequestData>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AssignChannelsV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type AssignChannelsV2Query = {
  __typename?: 'Query';
  assignChannelsV2?: {
    __typename?: 'ChannelUserWorkspaceCursorPaginationV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'ChannelUserWorkspace';
      id?: number | null;
      pinned?: boolean | null;
      isDefault?: boolean | null;
      updatedAt?: any | null;
      channel?: {
        __typename?: 'Channel';
        id?: number | null;
        friendlyName?: string | null;
        phoneNumber?: string | null;
        unreadCounter?: number | null;
        v2MigratedAt?: any | null;
        country?: { __typename?: 'Country'; name?: string | null; flag?: string | null } | null;
        channelGroup?: {
          __typename?: 'ChannelGroup';
          id?: number | null;
          callSetting?: { __typename?: 'CallSettingsType'; id?: number | null; friendlyName?: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type GetAllNotificationV2QueryVariables = Exact<{
  sort?: InputMaybe<SortEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
}>;

export type GetAllNotificationV2Query = {
  __typename?: 'Query';
  getAllNotificationV2?: {
    __typename?: 'CursorPaginationNotificationV2';
    data?: Array<{
      __typename?: 'NotificationV2';
      id?: number | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      imageUrl?: string | null;
      title?: string | null;
      body?: string | null;
      isExternal?: boolean | null;
      type?: string | null;
      redirectUrl?: string | null;
      seenAt?: any | null;
      redirection?: {
        __typename?: 'RedirectionParamsData';
        key?: string | null;
        params?: {
          __typename?: 'RedirectionData';
          memberId?: number | null;
          channelId?: number | null;
          clientId?: number | null;
          clientName?: string | null;
          markAsClosed?: boolean | null;
          pinned?: boolean | null;
        } | null;
      } | null;
      replacementAttributes?: Array<{
        __typename?: 'ReplacementAttributesData';
        key?: string | null;
        value?: string | null;
      } | null> | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type ChannelsV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  numberTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type ChannelsV2Query = {
  __typename?: 'Query';
  channelsV2?: {
    __typename?: 'ChannelCursorPaginationV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'Channel';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      identity?: string | null;
      emergencyStatus?: EmergencyStatusEnum | null;
      beta?: boolean | null;
      isAssigned?: boolean | null;
      numberType?: NumberTypeEnum | null;
      createdAt?: any | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      channelGroup?: {
        __typename?: 'ChannelGroup';
        id?: number | null;
        name?: string | null;
        callSetting?: {
          __typename?: 'CallSettingsType';
          id?: number | null;
          businessHourType?: string | null;
          friendlyName?: string | null;
          recording?: boolean | null;
          incomingTimeout?: number | null;
          metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
          callerId?: {
            __typename?: 'CallerId';
            id?: number | null;
            friendlyName?: string | null;
            phoneNumber?: string | null;
          } | null;
        } | null;
      } | null;
      assignedUsers?: Array<{
        __typename?: 'User';
        name?: string | null;
        id?: number | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null> | null;
      capability?: {
        __typename?: 'ChannelCapability';
        fax?: boolean | null;
        mms?: boolean | null;
        sms?: boolean | null;
        voice?: boolean | null;
      } | null;
      subscription?: { __typename?: 'BillingSubscription'; nextBillingAt?: any | null } | null;
      channelUserWorkspaces?: Array<{
        __typename?: 'ChannelUserWorkspace';
        id?: number | null;
        userWorkspace?: {
          __typename?: 'UserWorkspace';
          id?: number | null;
          status?: UserWorkspaceStatusEnum | null;
          user?: {
            __typename?: 'User';
            id?: number | null;
            name?: string | null;
            profilePicture?: {
              __typename?: 'Media';
              id?: number | null;
              url?: string | null;
              originalname?: string | null;
              size?: number | null;
              key?: string | null;
              mimetype?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type InProcessPhoneNumbersV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type InProcessPhoneNumbersV2Query = {
  __typename?: 'Query';
  inProcessPhoneNumbersV2?: {
    __typename?: 'InProcessPhoneNumberCursorPagination';
    message?: string | null;
    data?: Array<{
      __typename?: 'InProcessPhoneNumber';
      id?: number | null;
      phoneNumber?: string | null;
      friendlyName?: string | null;
      status?: string | null;
      source?: string | null;
      numberType?: NumberTypeEnum | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      capabilities?: {
        __typename?: 'TwilioCapability';
        voice?: boolean | null;
        SMS?: boolean | null;
        MMS?: boolean | null;
      } | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        name?: string | null;
        slug?: string | null;
        dialingCode?: string | null;
        alphaTwoCode?: string | null;
        alphaThreeCode?: string | null;
        numeric?: string | null;
        flag?: string | null;
      } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type PurchaseFailedPhoneNumbersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type PurchaseFailedPhoneNumbersQuery = {
  __typename?: 'Query';
  purchaseFailedPhoneNumbers?: {
    __typename?: 'PhoneNumberCursorPaginationV2';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'PhoneNumber';
      id?: number | null;
      status?: PhoneNumberStatusEnum | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      meta?: {
        __typename?: 'TwilioPhoneNumber';
        addressRequirements?: string | null;
        isoCountry?: string | null;
        phoneNumber?: string | null;
        friendlyName?: string | null;
        region?: string | null;
        rateCenter?: string | null;
        numberType?: NumberTypeEnum | null;
        basePrice?: string | null;
        currentPrice?: string | null;
        supportingDocument?: boolean | null;
        endUser?: boolean | null;
        beta?: boolean | null;
        capabilities?: {
          __typename?: 'TwilioCapability';
          voice?: boolean | null;
          SMS?: boolean | null;
          MMS?: boolean | null;
        } | null;
      } | null;
      workspace?: {
        __typename?: 'Workspace';
        id?: number | null;
        secret?: string | null;
        label?: string | null;
        isCurrent?: boolean | null;
        status?: WorkspaceStatusEnum | null;
        hasCompleted?: boolean | null;
        active?: boolean | null;
        totalPhoneNumbers?: number | null;
        numberOfUsers?: number | null;
        timezone?: string | null;
        createdAt?: any | null;
        unreadCountWorkspace?: number | null;
        salesDealCreatedAt?: any | null;
        salesDealCreatedById?: number | null;
        pkReference?: string | null;
        timezoneId?: number | null;
        kycVerified?: boolean | null;
        trusted?: boolean | null;
        providerAccount?: {
          __typename?: 'ProviderAccount';
          sid?: string | null;
          status?: WorkspaceProviderSubaccountStatusEnum | null;
          systemSuspend?: WorkspaceProviderSubAccountSuspendedReasonEnum | null;
        } | null;
        workspaceDetails?: {
          __typename?: 'WorkspaceDetail';
          id?: number | null;
          name?: string | null;
          socialUrl?: string | null;
          noOfEmployees?: number | null;
          accountType?: WorkspaceDetailAccountTypeEnum | null;
          address?: {
            __typename?: 'Address';
            id?: number | null;
            street?: string | null;
            suburb?: string | null;
            state?: string | null;
            country?: string | null;
            street2?: string | null;
            zipcode?: string | null;
          } | null;
          planPrice?: {
            __typename?: 'PlanPrice';
            id?: number | null;
            amount?: number | null;
            periodicity?: PeriodicityEnum | null;
            isPublished?: boolean | null;
            position?: number | null;
            rank?: number | null;
            plan?: {
              __typename?: 'Plan';
              id?: number | null;
              label?: string | null;
              name?: string | null;
              slug?: string | null;
              shortDescription?: string | null;
              description?: string | null;
              features?: Array<string | null> | null;
              recommendation?: string | null;
              showAmount?: boolean | null;
              referencePlan?: {
                __typename?: 'Plan';
                id?: number | null;
                label?: string | null;
                name?: string | null;
                slug?: string | null;
                shortDescription?: string | null;
                description?: string | null;
                features?: Array<string | null> | null;
                recommendation?: string | null;
                showAmount?: boolean | null;
              } | null;
            } | null;
          } | null;
          documents?: Array<{
            __typename?: 'Media';
            id?: number | null;
            url?: string | null;
            originalname?: string | null;
            size?: number | null;
            key?: string | null;
            mimetype?: string | null;
            createdAt?: any | null;
          } | null> | null;
          useCases?: Array<{ __typename?: 'UseCase'; value?: string | null } | null> | null;
        } | null;
        logo?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          address?: string | null;
          dueIn?: string | null;
          accountStatus?: boolean | null;
          timezone?: string | null;
          averageRiskScore?: number | null;
          totalMonthlyFee?: number | null;
          language?: string | null;
          emailVerifiedAt?: any | null;
          profilePicture?: {
            __typename?: 'Media';
            id?: number | null;
            url?: string | null;
            originalname?: string | null;
            size?: number | null;
            key?: string | null;
            mimetype?: string | null;
            createdAt?: any | null;
          } | null;
          roles?: Array<{
            __typename?: 'Role';
            id?: number | null;
            label?: string | null;
            slug?: string | null;
            level?: number | null;
            isActive?: boolean | null;
            isDefault?: boolean | null;
            position?: number | null;
            roleMaps?: Array<{
              __typename?: 'ScreenRoleMapping';
              id?: number | null;
              isDefault?: boolean | null;
              isPublished?: boolean | null;
              isActive?: boolean | null;
              screen?: {
                __typename?: 'Screen';
                id?: number | null;
                name?: string | null;
                slug?: string | null;
                isDefault?: boolean | null;
                isActive?: boolean | null;
                description?: string | null;
              } | null;
              privilege?: {
                __typename?: 'Privilege';
                id?: number | null;
                name?: string | null;
                slug?: string | null;
                isDefault?: boolean | null;
              } | null;
            } | null> | null;
          } | null> | null;
          workspaces?: Array<{
            __typename?: 'Workspace';
            id?: number | null;
            secret?: string | null;
            label?: string | null;
            isCurrent?: boolean | null;
            status?: WorkspaceStatusEnum | null;
            hasCompleted?: boolean | null;
            active?: boolean | null;
            totalPhoneNumbers?: number | null;
            numberOfUsers?: number | null;
            timezone?: string | null;
            createdAt?: any | null;
            unreadCountWorkspace?: number | null;
            salesDealCreatedAt?: any | null;
            salesDealCreatedById?: number | null;
            pkReference?: string | null;
            timezoneId?: number | null;
            kycVerified?: boolean | null;
            trusted?: boolean | null;
          } | null> | null;
        } | null;
        incomingPhoneNumbers?: Array<{
          __typename?: 'IncomingPhoneNumber';
          _id?: string | null;
          status?: IncomingPhoneNumberStatusEnum | null;
          createdAt?: any | null;
          updatedAt?: any | null;
          providerNumber?: {
            __typename?: 'TwilioPhoneNumber';
            addressRequirements?: string | null;
            isoCountry?: string | null;
            phoneNumber?: string | null;
            friendlyName?: string | null;
            region?: string | null;
            rateCenter?: string | null;
            numberType?: NumberTypeEnum | null;
            basePrice?: string | null;
            currentPrice?: string | null;
            supportingDocument?: boolean | null;
            endUser?: boolean | null;
            beta?: boolean | null;
          } | null;
        } | null> | null;
        phoneNumbers?: Array<{
          __typename?: 'PhoneNumber';
          id?: number | null;
          status?: PhoneNumberStatusEnum | null;
          createdAt?: any | null;
          updatedAt?: any | null;
        } | null> | null;
        riskScore?: {
          __typename?: 'RiskScore';
          id?: number | null;
          documentVerificationScore?: number | null;
          userNumberRatioScore?: number | null;
          usernameCardNameScore?: number | null;
          countryLocationScore?: number | null;
          signupCardLocationScore?: number | null;
          referralScore?: number | null;
          incorporationDateScore?: number | null;
          totalScore?: number | null;
        } | null;
        subscription?: {
          __typename?: 'SubscriptionDetail';
          name?: string | null;
          dueIn?: any | null;
          monthlyFees?: number | null;
          billingCycleDate?: any | null;
          status?: string | null;
          transactionDate?: any | null;
          canceledReason?: string | null;
          canceledAt?: any | null;
          cancelScheduledAt?: any | null;
        } | null;
        channels?: Array<{
          __typename?: 'Channel';
          id?: number | null;
          friendlyName?: string | null;
          phoneNumber?: string | null;
          identity?: string | null;
          numberType?: NumberTypeEnum | null;
          purchaseAt?: any | null;
          releasedAt?: any | null;
          createdAt?: any | null;
          updatedAt?: any | null;
          numberState?: NumberStateEnum | null;
          a2pVerified?: boolean | null;
          unreadCountChannel?: number | null;
          emergencyStatus?: EmergencyStatusEnum | null;
          beta?: boolean | null;
          isFree?: boolean | null;
          unreadCounter?: number | null;
          channelUserWorkspaces?: Array<{
            __typename?: 'ChannelUserWorkspace';
            id?: number | null;
            isDefault?: boolean | null;
            userWorkspace?: {
              __typename?: 'UserWorkspace';
              id?: number | null;
              status?: UserWorkspaceStatusEnum | null;
              identity?: string | null;
            } | null;
            channel?: {
              __typename?: 'Channel';
              id?: number | null;
              friendlyName?: string | null;
              phoneNumber?: string | null;
              identity?: string | null;
              numberType?: NumberTypeEnum | null;
              purchaseAt?: any | null;
              releasedAt?: any | null;
              createdAt?: any | null;
              updatedAt?: any | null;
              numberState?: NumberStateEnum | null;
              a2pVerified?: boolean | null;
              unreadCountChannel?: number | null;
              emergencyStatus?: EmergencyStatusEnum | null;
              beta?: boolean | null;
              isFree?: boolean | null;
              unreadCounter?: number | null;
            } | null;
          } | null> | null;
          setting?: {
            __typename?: 'ChannelSetting';
            id?: number | null;
            recording?: boolean | null;
            welcomeMessage?: boolean | null;
            welcomeMessageLoop?: number | null;
            voicemail?: boolean | null;
            voicemailLoop?: number | null;
            autoTranscribe?: boolean | null;
            forwardToExternalNumber?: boolean | null;
            forwardToExternalNumberLoop?: number | null;
            enableVoiceMailEmail?: boolean | null;
            welcomeMessageSay?: {
              __typename?: 'TwimlSay';
              message?: string | null;
              attributes?: Array<{
                __typename?: 'SayAttributes';
                language?: string | null;
                voice?: string | null;
              } | null> | null;
            } | null;
            voicemailSay?: { __typename?: 'TwimlSay'; message?: string | null } | null;
            welcomeMessagePlay?: {
              __typename?: 'Media';
              id?: number | null;
              url?: string | null;
              originalname?: string | null;
              size?: number | null;
              key?: string | null;
              mimetype?: string | null;
              createdAt?: any | null;
            } | null;
            voicemailPlay?: {
              __typename?: 'Media';
              id?: number | null;
              url?: string | null;
              originalname?: string | null;
              size?: number | null;
              key?: string | null;
              mimetype?: string | null;
              createdAt?: any | null;
            } | null;
            caller?: {
              __typename?: 'CallerId';
              id?: number | null;
              friendlyName?: string | null;
              phoneNumber?: string | null;
              sid?: string | null;
              createdAt?: any | null;
              updatedAt?: any | null;
            } | null;
            forwardToExternalNumberPlay?: {
              __typename?: 'Media';
              id?: number | null;
              url?: string | null;
              originalname?: string | null;
              size?: number | null;
              key?: string | null;
              mimetype?: string | null;
              createdAt?: any | null;
            } | null;
            forwardToExternalNumberSay?: { __typename?: 'TwimlSay'; message?: string | null } | null;
            externalNumber?: { __typename?: 'ForwardToExternalNumber'; externalNumber?: string | null } | null;
          } | null;
          capability?: {
            __typename?: 'ChannelCapability';
            fax?: boolean | null;
            mms?: boolean | null;
            sms?: boolean | null;
            voice?: boolean | null;
          } | null;
          integrationChannels?: {
            __typename?: 'IntegrationChannel';
            id?: number | null;
            memberCount?: number | null;
            integrationUserId?: number | null;
            workspaceId?: number | null;
            isEnabled?: boolean | null;
          } | null;
          assignedUsers?: Array<{
            __typename?: 'User';
            id?: number | null;
            name?: string | null;
            email?: string | null;
            phoneNumber?: string | null;
            address?: string | null;
            dueIn?: string | null;
            accountStatus?: boolean | null;
            timezone?: string | null;
            averageRiskScore?: number | null;
            totalMonthlyFee?: number | null;
            language?: string | null;
            emailVerifiedAt?: any | null;
          } | null> | null;
        } | null> | null;
        salesDealCreatedBy?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          address?: string | null;
          dueIn?: string | null;
          accountStatus?: boolean | null;
          timezone?: string | null;
          averageRiskScore?: number | null;
          totalMonthlyFee?: number | null;
          language?: string | null;
          emailVerifiedAt?: any | null;
        } | null;
        currentUserWorkspace?: {
          __typename?: 'UserWorkspace';
          id?: number | null;
          status?: UserWorkspaceStatusEnum | null;
          identity?: string | null;
        } | null;
      } | null;
      purchaseBy?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        status?: UserWorkspaceStatusEnum | null;
        identity?: string | null;
        userOnlineManagement?: {
          __typename?: 'UserOnlineManagement';
          isActive?: boolean | null;
          lastSeenAt?: any | null;
          activeStatus?: UserActiveStatusEnum | null;
          awayTill?: any | null;
          message?: string | null;
          awaySet?: any | null;
          icon?: string | null;
        } | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          address?: string | null;
          dueIn?: string | null;
          accountStatus?: boolean | null;
          timezone?: string | null;
          averageRiskScore?: number | null;
          totalMonthlyFee?: number | null;
          language?: string | null;
          emailVerifiedAt?: any | null;
        } | null;
        userWorkspaceRoles?: Array<{
          __typename?: 'UserWorkspaceRole';
          role?: {
            __typename?: 'Role';
            id?: number | null;
            label?: string | null;
            slug?: string | null;
            level?: number | null;
            isActive?: boolean | null;
            isDefault?: boolean | null;
            position?: number | null;
          } | null;
        } | null> | null;
      } | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        name?: string | null;
        slug?: string | null;
        dialingCode?: string | null;
        alphaTwoCode?: string | null;
        alphaThreeCode?: string | null;
        numeric?: string | null;
        flag?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type RecentMessageConversationsV2QueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  direction?: InputMaybe<CursorDirectionEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  markAsClosed?: InputMaybe<Scalars['Boolean']['input']>;
  conversationStatus?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  messageDirection?: InputMaybe<DirectionTypeEnum>;
  voicemail?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleMessage?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type RecentMessageConversationsV2Query = {
  __typename?: 'Query';
  recentMessageConversationsV2?: {
    __typename?: 'CursorPaginationRecentMessageConversationV2';
    cursor?: {
      __typename?: 'Cursor';
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      startCursor?: string | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'RecentMessageConversation';
      id?: number | null;
      updatedAt?: any | null;
      unreadCounter?: number | null;
      lastReadCursor?: string | null;
      pinned?: boolean | null;
      markAsClosed?: boolean | null;
      hasScheduledMessages?: boolean | null;
      channel?: { __typename?: 'Channel'; id?: number | null } | null;
      client?: {
        __typename?: 'Contact';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        isBlocked?: boolean | null;
        country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      messageConversation?: {
        __typename?: 'MessageConversation';
        numMedia?: number | null;
        conversationType?: MessageConversationTypeEnum | null;
        conversationStatus?: string | null;
        direction?: DirectionTypeEnum | null;
        messageContent?: string | null;
        pinned?: boolean | null;
        voicemailRecordingUrl?: string | null;
        forwardedTo?: { __typename?: 'ForwardToExternalNumber'; externalNumber?: string | null } | null;
      } | null;
      draft?: {
        __typename?: 'DraftMessageConversation';
        mediaCount?: number | null;
        messageContent?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type MessageConversationsV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
}>;

export type MessageConversationsV2Query = {
  __typename?: 'Query';
  messageConversationsV2?: {
    __typename?: 'MessageConversationCursorPaginationV2';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'MessageConversation';
      id?: number | null;
      messageContent?: string | null;
      markAsClosed?: boolean | null;
      direction?: DirectionTypeEnum | null;
      pinned?: boolean | null;
      conversationStatus?: string | null;
      conversationType?: MessageConversationTypeEnum | null;
      recordingUrl?: string | null;
      numMedia?: number | null;
      friendlyName?: string | null;
      voicemailRecordingUrl?: string | null;
      createdAt?: any | null;
      forwardedAt?: any | null;
      markAsBlocked?: boolean | null;
      durationConference?: { __typename?: 'DurationConference'; endDate?: any | null; startDate?: any | null } | null;
      client?: {
        __typename?: 'Contact';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      agent?: {
        __typename?: 'UserWorkspace';
        callPlatform?: DevicePlatformEnum | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
        userOnlineManagement?: { __typename?: 'UserOnlineManagement'; isActive?: boolean | null } | null;
      } | null;
      forwardedTo?: { __typename?: 'ForwardToExternalNumber'; externalNumber?: string | null } | null;
      messageConversationErrorLog?: {
        __typename?: 'MessageConversationErrorLog';
        message?: string | null;
        code?: string | null;
        statusCode?: string | null;
      } | null;
      callRecording?: {
        __typename?: 'Recording';
        id?: number | null;
        url?: string | null;
        transcription?: {
          __typename?: 'TranscriptionInformation';
          id?: number | null;
          jobStatus?: JobStatusEnum | null;
        } | null;
      } | null;
      voicemailRecording?: {
        __typename?: 'Recording';
        id?: number | null;
        url?: string | null;
        transcription?: {
          __typename?: 'TranscriptionInformation';
          id?: number | null;
          jobStatus?: JobStatusEnum | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CannedResponsesV2QueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type CannedResponsesV2Query = {
  __typename?: 'Query';
  cannedResponsesV2?: {
    __typename?: 'CursorPaginationCommandResponseV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'CommandResponse';
      id?: number | null;
      title?: string | null;
      command?: string | null;
      content?: string | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type SettingCannedResponsesV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type SettingCannedResponsesV2Query = {
  __typename?: 'Query';
  cannedResponsesV2?: {
    __typename?: 'CursorPaginationCommandResponseV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'CommandResponse';
      id?: number | null;
      title?: string | null;
      command?: string | null;
      content?: string | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type GetBlockedContactsV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetBlockedContactsV2Query = {
  __typename?: 'Query';
  getBlockedContactsV2?: {
    __typename?: 'CursorPaginationBlockedContactsV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'Contact';
      blockedOn?: any | null;
      timeZone?: string | null;
      blockReason?: string | null;
      id?: number | null;
      phoneNumber?: string | null;
      name?: string | null;
      isBlocked?: boolean | null;
      isPublished?: boolean | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      blockedBy?: { __typename?: 'User'; name?: string | null } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type ContactNotesV2QueryVariables = Exact<{
  direction?: InputMaybe<CursorDirectionEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ContactNotesV2Query = {
  __typename?: 'Query';
  contactNotesV2?: {
    __typename?: 'CursorPaginationContactNoteV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'ContactNoteV2';
      id?: number | null;
      description?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      createdById?: number | null;
      updatedBy?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          phoneNumber?: string | null;
          profilePicture?: {
            __typename?: 'Media';
            id?: number | null;
            url?: string | null;
            originalname?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      hasPreviousPage?: boolean | null;
      hasNextPage?: boolean | null;
      endCursor?: string | null;
    } | null;
  } | null;
};

export type ContactTagsV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ContactTagsV2Query = {
  __typename?: 'Query';
  contactTagsV2?: {
    __typename?: 'CursorPaginationContactTagV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'ContactTagsv2';
      id?: number | null;
      tags?: {
        __typename?: 'Tag';
        id?: number | null;
        color?: string | null;
        label?: string | null;
        slug?: string | null;
        type?: TagEnum | null;
      } | null;
      contact?: { __typename?: 'Contact'; id?: number | null } | null;
    } | null> | null;
  } | null;
};

export type TagsV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type TagsV2Query = {
  __typename?: 'Query';
  tagsV2?: {
    __typename?: 'CursorPaginationTagV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'Tag';
      id?: number | null;
      label?: string | null;
      color?: string | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type TeamsV2QueryVariables = Exact<{
  sort?: InputMaybe<SortEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type TeamsV2Query = {
  __typename?: 'Query';
  teamsV2?: {
    __typename?: 'CursorPaginationTeamsV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'TeamsInterface';
      totalMembers?: number | null;
      name?: string | null;
      status?: StatusEnum | null;
      workspacesId?: number | null;
      createdBy?: number | null;
      updatedBy?: number | null;
      description?: string | null;
      id?: string | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
      members?: Array<{
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        accountStatus?: boolean | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null> | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
    } | null;
  } | null;
};

export type WorkspaceMembersV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  status?: InputMaybe<UserWorkspaceStatusEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleEnum>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type WorkspaceMembersV2Query = {
  __typename?: 'Query';
  workspaceMembersV2?: {
    __typename?: 'CursorBasedWorkspaceMembers';
    message?: string | null;
    data?: Array<{
      __typename?: 'WorkspaceMembers';
      id?: number | null;
      status?: UserWorkspaceStatusEnum | null;
      identity?: string | null;
      unreadCounter?: number | null;
      roles?: Array<{
        __typename?: 'Role';
        label?: string | null;
        isDefault?: boolean | null;
        isActive?: boolean | null;
      } | null> | null;
      userOnlineManagement?: {
        __typename?: 'UserOnlineManagement';
        icon?: string | null;
        message?: string | null;
        awayTill?: any | null;
        isActive?: boolean | null;
        activeStatus?: UserActiveStatusEnum | null;
        lastSeenAt?: any | null;
      } | null;
      user?: {
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        accountStatus?: boolean | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      channels?: Array<{ __typename?: 'Channel'; id?: number | null; phoneNumber?: string | null } | null> | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type CallerIdsV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type CallerIdsV2Query = {
  __typename?: 'Query';
  callerIdsV2?: {
    __typename?: 'CallerIdCursorPaginationV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'CallerId';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      sid?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type FetchAllCountriesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchAllCountriesQuery = {
  __typename?: 'Query';
  fetchAllCountries?: {
    __typename?: 'CursorPaginationCountries';
    message?: string | null;
    data?: Array<{
      __typename?: 'Country';
      id?: number | null;
      name?: string | null;
      slug?: string | null;
      dialingCode?: string | null;
      alphaTwoCode?: string | null;
      alphaThreeCode?: string | null;
      numeric?: string | null;
      flag?: string | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type ContactsV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Array<InputMaybe<ContactSourceTypeEnum>> | InputMaybe<ContactSourceTypeEnum>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  nameStartsWith?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type ContactsV2Query = {
  __typename?: 'Query';
  contactsV2?: {
    __typename?: 'CursorPaginationContactV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'Contact';
      id?: number | null;
      name?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      sourceType?: string | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
      tags?: Array<{
        __typename?: 'Tag';
        id?: number | null;
        label?: string | null;
        color?: string | null;
      } | null> | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type ListPinnedMessageConversationsV2QueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPinnedMessageConversationsV2Query = {
  __typename?: 'Query';
  listPinnedMessageConversationsV2?: {
    __typename?: 'ListPinnedMessageConversationsResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'ListPinnedMessageConversations';
      id?: number | null;
      direction?: DirectionTypeEnum | null;
      numMedia?: number | null;
      pinned?: boolean | null;
      conversationStatus?: string | null;
      messageContent?: string | null;
      markAsClosed?: boolean | null;
      conversationType?: MessageConversationTypeEnum | null;
      createdAt?: any | null;
      cursor?: string | null;
      client?: {
        __typename?: 'Contact';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      agent?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          phoneNumber?: string | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
      } | null;
      recording?: Array<{ __typename?: 'Recording'; id?: number | null; url?: string | null } | null> | null;
      voicemailRecording?: { __typename?: 'Recording'; id?: number | null; url?: string | null } | null;
      callRecording?: { __typename?: 'Recording'; id?: number | null; url?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetChatMessagesV2QueryVariables = Exact<{
  roomId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type GetChatMessagesV2Query = {
  __typename?: 'Query';
  getChatMessagesV2?: {
    __typename?: 'CursorPaginationGetChatMessagesV2';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'ChatMessage';
      id?: number | null;
      body?: string | null;
      createdAt?: any | null;
      isPinned?: boolean | null;
      type?: MessageTypeEnum | null;
      messageConversation?: {
        __typename?: 'CallThread';
        id?: number | null;
        conversationStatus?: string | null;
        effectiveStartedAt?: any | null;
        effectiveEndedAt?: any | null;
      } | null;
      sender?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        status?: UserWorkspaceStatusEnum | null;
        userOnlineManagement?: {
          __typename?: 'UserOnlineManagement';
          isActive?: boolean | null;
          lastSeenAt?: any | null;
          activeStatus?: UserActiveStatusEnum | null;
          awayTill?: any | null;
          message?: string | null;
          icon?: string | null;
        } | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          address?: string | null;
          dueIn?: string | null;
          accountStatus?: boolean | null;
          timezone?: string | null;
          averageRiskScore?: number | null;
          totalMonthlyFee?: number | null;
          lastPasswordResetAt?: any | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListPinnedChatMessagesQueryVariables = Exact<{
  roomId: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type ListPinnedChatMessagesQuery = {
  __typename?: 'Query';
  listPinnedChatMessages?: {
    __typename?: 'ListPinnedChatMessagesResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'ListPinnedChatMessages';
      id?: number | null;
      isPinned?: boolean | null;
      cursor?: string | null;
      createdAt?: any | null;
      body?: string | null;
      sender?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        user?: {
          __typename?: 'User';
          name?: string | null;
          id?: number | null;
          phoneNumber?: string | null;
          profilePicture?: { __typename?: 'Media'; url?: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ChannelConversationsQueryVariables = Exact<{
  clientId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChannelConversationsQuery = {
  __typename?: 'Query';
  channelConversations?: {
    __typename?: 'ChannelConversationCursorPagination';
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'ChannelConversation';
      id?: number | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      isDefault?: boolean | null;
      channel?: {
        __typename?: 'Channel';
        id?: number | null;
        friendlyName?: string | null;
        phoneNumber?: string | null;
        unreadCounter?: number | null;
        country?: { __typename?: 'Country'; name?: string | null; flag?: string | null } | null;
      } | null;
      messageConversation?: {
        __typename?: 'MessageConversation';
        messageContent?: string | null;
        direction?: DirectionTypeEnum | null;
        id?: number | null;
        numMedia?: number | null;
        conversationStatus?: string | null;
        conversationType?: MessageConversationTypeEnum | null;
        friendlyName?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ChannelsForNewConversationsQueryVariables = Exact<{
  clientId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChannelsForNewConversationsQuery = {
  __typename?: 'Query';
  channelsForNewConversations?: {
    __typename?: 'ChannelUserWorkspaceCursorPaginationV2';
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'ChannelUserWorkspace';
      id?: number | null;
      isDefault?: boolean | null;
      channel?: {
        __typename?: 'Channel';
        id?: number | null;
        phoneNumber?: string | null;
        friendlyName?: string | null;
        country?: {
          __typename?: 'Country';
          alphaTwoCode?: string | null;
          flag?: string | null;
          id?: number | null;
          name?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type IntegrationsV2QueryVariables = Exact<{
  sort?: InputMaybe<SortEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  includeInactive: Scalars['Boolean']['input'];
}>;

export type IntegrationsV2Query = {
  __typename?: 'Query';
  integrationsV2?: {
    __typename?: 'CursorPaginationIntegrationsV2';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'Integration';
      id?: number | null;
      name?: string | null;
      logoUrl?: string | null;
      label?: string | null;
      domain?: string | null;
      description?: string | null;
      integrationUser?: {
        __typename?: 'IntegrationUser';
        id?: number | null;
        status?: IntegrationUserStatusEnum | null;
      } | null;
    } | null> | null;
  } | null;
};

export type IntegrationChannelsV2QueryVariables = Exact<{
  sort?: InputMaybe<SortEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  integrationUserId: Scalars['Int']['input'];
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type IntegrationChannelsV2Query = {
  __typename?: 'Query';
  integrationChannelsV2?: {
    __typename?: 'CursorPaginationIntegrationChannelsV2';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      hasPreviousPage?: boolean | null;
      hasNextPage?: boolean | null;
      endCursor?: string | null;
    } | null;
    data?: Array<{
      __typename?: 'IntegrationChannelV2';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      integrationChannels?: {
        __typename?: 'IntegrationChannel';
        id?: number | null;
        integrationUserId?: number | null;
        isEnabled?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type AttributeValuesV2QueryVariables = Exact<{
  sort?: InputMaybe<SortEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  attributeName?: InputMaybe<Scalars['String']['input']>;
}>;

export type AttributeValuesV2Query = {
  __typename?: 'Query';
  attributeValuesV2?: {
    __typename?: 'CursorPaginationAttributeValuesV2';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'AttributeValue';
      id?: number | null;
      value?: string | null;
      description?: string | null;
      isActive?: boolean | null;
      isDefault?: boolean | null;
      attributeId: number;
      label?: string | null;
    } | null> | null;
  } | null;
};

export type AvailablePhoneNumbersV2QueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numberType?: InputMaybe<NumberTypeEnum>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  voiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  faxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeAllAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLocalAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeForeignAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  beta?: InputMaybe<Scalars['Boolean']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  areaCode?: InputMaybe<Scalars['Int']['input']>;
  inLocality?: InputMaybe<Scalars['String']['input']>;
}>;

export type AvailablePhoneNumbersV2Query = {
  __typename?: 'Query';
  availablePhoneNumbersV2?: {
    __typename?: 'CursorPaginationAvailablePhoneNumber';
    message?: string | null;
    data?: Array<{
      __typename?: 'TwilioPhoneNumber';
      addressRequirements?: string | null;
      isoCountry?: string | null;
      phoneNumber?: string | null;
      friendlyName?: string | null;
      region?: string | null;
      rateCenter?: string | null;
      numberType?: NumberTypeEnum | null;
      basePrice?: string | null;
      currentPrice?: string | null;
      supportingDocument?: boolean | null;
      endUser?: boolean | null;
      beta?: boolean | null;
      capabilities?: {
        __typename?: 'TwilioCapability';
        voice?: boolean | null;
        SMS?: boolean | null;
        MMS?: boolean | null;
      } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type AreaCodesQueryVariables = Exact<{
  direction?: InputMaybe<CursorDirectionEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  alphaTwoCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type AreaCodesQuery = {
  __typename?: 'Query';
  areaCodes?: {
    __typename?: 'CursorPaginationAreaCodes';
    message?: string | null;
    data?: Array<{
      __typename?: 'AreaCode';
      id?: number | null;
      name?: string | null;
      slug?: string | null;
      code?: string | null;
      stateId?: number | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type GetIvrMenuOptionsInCallSettingQueryVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type GetIvrMenuOptionsInCallSettingQuery = {
  __typename?: 'Query';
  getIvrMenuOptionsInCallSetting?: {
    __typename?: 'IvrCursorPagination';
    data?: Array<{
      __typename?: 'CallIvrCondition';
      input?: string | null;
      ifUnansweredRedirectTo?: ConditionUnanswerRedirectEnum | null;
      id?: string | null;
      action?: ConditionActionEnum | null;
      callIvrConditionTarget?: {
        __typename?: 'CallIvrConditionTarget';
        id?: number | null;
        target?: { __typename?: 'CallIvrConditionTargetUser'; id?: number | null; name?: string | null } | null;
      } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type GetIvrMenuOptionsInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type GetIvrMenuOptionsInChannelSettingQuery = {
  __typename?: 'Query';
  getIvrMenuOptionsInChannelSetting?: {
    __typename?: 'IvrCursorPagination';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'CallIvrCondition';
      id?: string | null;
      input?: string | null;
      action?: ConditionActionEnum | null;
      ifUnansweredRedirectTo?: ConditionUnanswerRedirectEnum | null;
      callIvrConditionTarget?: {
        __typename?: 'CallIvrConditionTarget';
        id?: number | null;
        target?: { __typename?: 'CallIvrConditionTargetUser'; id?: number | null; name?: string | null } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type MessageSchedulesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  status?: InputMaybe<Array<InputMaybe<MessageScheduleStatusEnum>> | InputMaybe<MessageScheduleStatusEnum>>;
}>;

export type MessageSchedulesQuery = {
  __typename?: 'Query';
  messageSchedules?: {
    __typename?: 'MessageSchedulePagination';
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'MessageSchedule';
      scheduleAt: any;
      messageContent?: string | null;
      id: string;
      createdAt: any;
      failureReason?: string | null;
      status?: MessageScheduleStatusEnum | null;
      attachments?: Array<{
        __typename?: 'Media';
        id?: number | null;
        url?: string | null;
        mimetype?: string | null;
      } | null> | null;
      client: {
        __typename?: 'Contact';
        id?: number | null;
        name?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        country?: { __typename?: 'Country'; flag?: string | null; id?: number | null } | null;
      };
      channel: { __typename?: 'Channel'; id?: number | null };
    } | null> | null;
  } | null;
};

export type GetCallSettingsQueryVariables = Exact<{
  sort?: InputMaybe<SortEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCallSettingsQuery = {
  __typename?: 'Query';
  getCallSettings?: {
    __typename?: 'CallSettingResponseWithCursor';
    message?: string | null;
    data?: Array<{
      __typename?: 'CallSettingsType';
      updatedAt?: string | null;
      recording?: boolean | null;
      id?: number | null;
      friendlyName?: string | null;
      createdAt?: string | null;
      businessHourType?: string | null;
      metrics?: Array<{ __typename?: 'Metrics'; value?: number | null; key?: string | null } | null> | null;
      channelGroups?: Array<{
        __typename?: 'ChannelGroup';
        slug?: string | null;
        name?: string | null;
        id?: number | null;
      } | null> | null;
      channels?: Array<{
        __typename?: 'Channel';
        phoneNumber?: string | null;
        friendlyName?: string | null;
        assignedUsers?: Array<{
          __typename?: 'User';
          name?: string | null;
          profilePicture?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
        } | null> | null;
      } | null> | null;
      callerId?: {
        __typename?: 'CallerId';
        phoneNumber?: string | null;
        friendlyName?: string | null;
        id?: number | null;
      } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      hasPreviousPage?: boolean | null;
      hasNextPage?: boolean | null;
      endCursor?: string | null;
    } | null;
  } | null;
};

export type GetChannelGroupsInCallSettingQueryVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  onlyAssignedGroups?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetChannelGroupsInCallSettingQuery = {
  __typename?: 'Query';
  getChannelGroupsInCallSetting?: {
    __typename?: 'CallSettingChannelGroupsWithCursor';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      hasPreviousPage?: boolean | null;
      hasNextPage?: boolean | null;
      endCursor?: string | null;
    } | null;
    data?: Array<{
      __typename?: 'CallSettingChannelGroupType';
      name?: string | null;
      id?: number | null;
      callSettingId?: number | null;
      metrics?: Array<{ __typename?: 'Metrics'; value?: number | null; key?: string | null } | null> | null;
    } | null> | null;
  } | null;
};

export type GetComplianceCampaignsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type GetComplianceCampaignsQuery = {
  __typename?: 'Query';
  getComplianceCampaigns?: {
    __typename?: 'ComplianceCampaignCursorPaginationResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'ComplianceCampaign';
      id?: number | null;
      name?: string | null;
      type?: ContactComplianceConsentCampaignTypeEnum | null;
      createdAt?: any | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type ContactComplianceConsentsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<ComplianceCampaignFilter>> | InputMaybe<ComplianceCampaignFilter>>;
}>;

export type ContactComplianceConsentsQuery = {
  __typename?: 'Query';
  contactComplianceConsents?: {
    __typename?: 'CursorPaginationContactMessagingConsentResponse';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'Contact';
      id?: number | null;
      phoneNumber?: string | null;
      name?: string | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      contactComplianceConsents?: Array<{
        __typename?: 'ContactComplianceConsent';
        id?: number | null;
        isConsented?: boolean | null;
        flowDetails?: string | null;
        consentedAt?: any | null;
        consentSource?: ContactComplianceConsentSourceEnum | null;
        consentDetails?: string | null;
        campaign?: {
          __typename?: 'ContactComplianceConsentCampaign';
          id?: number | null;
          messageServiceName?: string | null;
        } | null;
      } | null> | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        name?: string | null;
        flag?: string | null;
        alphaTwoCode?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ChannelGroupsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChannelGroupsQuery = {
  __typename?: 'Query';
  channelGroups?: {
    __typename?: 'ChannelGroupCursorPagination';
    message?: string | null;
    data?: Array<{
      __typename?: 'ChannelGroup';
      name?: string | null;
      id?: number | null;
      callSetting?: { __typename?: 'CallSettingsType'; id?: number | null; friendlyName?: string | null } | null;
      channel?: Array<{
        __typename?: 'Channel';
        id?: number | null;
        friendlyName?: string | null;
        phoneNumber?: string | null;
      } | null> | null;
      metrics?: Array<{ __typename?: 'Metrics'; value?: number | null; key?: string | null } | null> | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      hasPreviousPage?: boolean | null;
      hasNextPage?: boolean | null;
      endCursor?: string | null;
    } | null;
  } | null;
};

export type GetChannelByGroupQueryVariables = Exact<{
  groupId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetChannelByGroupQuery = {
  __typename?: 'Query';
  getChannelByGroup?: {
    __typename?: 'ChannelCursorPaginationV2';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      hasPreviousPage?: boolean | null;
      hasNextPage?: boolean | null;
      endCursor?: string | null;
    } | null;
    data?: Array<{
      __typename?: 'Channel';
      id?: number | null;
      phoneNumber?: string | null;
      friendlyName?: string | null;
      channelGroup?: { __typename?: 'ChannelGroup'; id?: number | null } | null;
      country?: { __typename?: 'Country'; id?: number | null; name?: string | null; flag?: string | null } | null;
    } | null> | null;
  } | null;
};

export type LiveConferencesV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type LiveConferencesV2Query = {
  __typename?: 'Query';
  liveConferencesV2?: {
    __typename?: 'LiveConferencesV2CursorResponse';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'LiveConferenceV2Data';
      id?: number | null;
      direction?: string | null;
      conversationStatus?: string | null;
      createdAt?: any | null;
      supervisionId?: string | null;
      supervisionMode?: SupervisionModeEnum | null;
      agent?: {
        __typename?: 'UserWorkspace';
        user?: {
          __typename?: 'User';
          name?: string | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
        userOnlineManagement?: { __typename?: 'UserOnlineManagement'; isActive?: boolean | null } | null;
      } | null;
      client?: {
        __typename?: 'Contact';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        country?: { __typename?: 'Country'; flag?: string | null } | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      channel?: {
        __typename?: 'Channel';
        friendlyName?: string | null;
        phoneNumber?: string | null;
        identity?: string | null;
        country?: { __typename?: 'Country'; name?: string | null; flag?: string | null } | null;
      } | null;
      durationConference?: { __typename?: 'LiveConferenceDuration'; startDate?: any | null } | null;
    } | null> | null;
  } | null;
};

export type GetWorkspaceChannelMembersQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetWorkspaceChannelMembersQuery = {
  __typename?: 'Query';
  getWorkspaceChannelMembers?: {
    __typename?: 'GetWorkspaceChannelMembersCursorPagination';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'WorkspaceChannelMember';
      isAssignedToChannel?: boolean | null;
      id?: number | null;
      user?: {
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListBulkMessagingCampaignQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  campaignType?: InputMaybe<BulkMessagingCampaignTypeEnum>;
  status?: InputMaybe<Array<InputMaybe<BulkMessagingCampaignStatusEnum>> | InputMaybe<BulkMessagingCampaignStatusEnum>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  initiatedFrom?: InputMaybe<Scalars['Date']['input']>;
  initiatedTo?: InputMaybe<Scalars['Date']['input']>;
}>;

export type ListBulkMessagingCampaignQuery = {
  __typename?: 'Query';
  listBulkMessagingCampaign?: {
    __typename?: 'BulkMessagingCampaignCursorPagination';
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'BulkMessagingCampaign';
      id?: number | null;
      campaignName?: string | null;
      isDraft?: boolean | null;
      messageTemplate?: string | null;
      mediaCount?: number | null;
      campaignType?: BulkMessagingCampaignTypeEnum | null;
      messagingType?: BulkMessagingCampaignMessagingTypeEnum | null;
      status?: BulkMessagingCampaignStatusEnum | null;
      scheduleType?: BulkMessagingCampaignScheduleTypeEnum | null;
      isScheduled?: boolean | null;
      initiatedAt?: any | null;
      scheduledAt?: any | null;
      maxOccurrence?: number | null;
      endAt?: any | null;
      createdAt?: any | null;
      recipients?: Array<{
        __typename?: 'BulkMessagingRecipient';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        profile?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null> | null;
      attachments?: Array<{
        __typename?: 'BulkMessagingAttachment';
        id?: number | null;
        fileName?: string | null;
        mimetype?: string | null;
        fileSize?: number | null;
        fileUrl?: string | null;
      } | null> | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
      createdBy?: {
        __typename?: 'BulkMessagingCampaignCreator';
        id?: number | null;
        name?: string | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
        roles?: {
          __typename?: 'Role';
          id?: number | null;
          label?: string | null;
          slug?: string | null;
          level?: number | null;
          isActive?: boolean | null;
          isDefault?: boolean | null;
          position?: number | null;
        } | null;
      } | null;
      deliverySummary?: {
        __typename?: 'BulkMessagingDeliverySummary';
        totalSent?: number | null;
        totalRecipients?: number | null;
        runStatus?: string | null;
        totalDelivered?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListBulkMessagingCampaignRunsQueryVariables = Exact<{
  campaignId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BulkMessagingRunStatusEnum>;
  runControl?: InputMaybe<Array<InputMaybe<BulkMessagingRunStatusEnum>> | InputMaybe<BulkMessagingRunStatusEnum>>;
}>;

export type ListBulkMessagingCampaignRunsQuery = {
  __typename?: 'Query';
  listBulkMessagingCampaignRuns?: {
    __typename?: 'BulkMessagingCampaignRunsCursorPagination';
    message?: string | null;
    data?: Array<{
      __typename?: 'BulkMessagingCampaignRun';
      id?: number | null;
      runNumber?: number | null;
      status?: BulkMessagingRunStatusEnum | null;
      totalRecipients?: number | null;
      scheduledAt?: any | null;
      startedAt?: any | null;
      completedAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      initiatedAt?: any | null;
      campaign?: { __typename?: 'BulkMessagingRunCampaign'; id?: number | null; name?: string | null } | null;
      deliverySummary?: {
        __typename?: 'BulkMessagingRunDeliverySummary';
        totalProcessed?: number | null;
        totalSent?: number | null;
        totalFailed?: number | null;
        totalDelivered?: number | null;
      } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type ListPaymentOrdersQueryVariables = Exact<{
  lienStatus?: InputMaybe<PaymentOrderLienStatusEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPaymentOrdersQuery = {
  __typename?: 'Query';
  listPaymentOrders?: {
    __typename?: 'CursorPaginationPaymentOrders';
    message?: string | null;
    data?: Array<{
      __typename?: 'PaymentOrder';
      id?: number | null;
      lienStatus?: PaymentOrderLienStatusEnum | null;
      createdAt?: any | null;
    } | null> | null;
    cursor?: { __typename?: 'Cursor'; hasNextPage?: boolean | null } | null;
  } | null;
};

export type signOutMutationVariables = Exact<{
  input?: InputMaybe<InputRefreshToken>;
}>;

export type signOutMutation = {
  __typename?: 'Mutation';
  signOut?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SignUpMutationVariables = Exact<{
  input: InputAuthSignUp;
}>;

export type SignUpMutation = {
  __typename?: 'Mutation';
  signUp?: {
    __typename?: 'SingUp';
    message?: string | null;
    data?: {
      __typename?: 'Email';
      email: string;
      isEmailVerified?: boolean | null;
      isPhoneNumberVerified?: boolean | null;
    } | null;
  } | null;
};

export type SignUpV2MutationVariables = Exact<{
  input: InputAuthSignUpV2;
}>;

export type SignUpV2Mutation = {
  __typename?: 'Mutation';
  signUpV2?: {
    __typename?: 'SingUp';
    message?: string | null;
    data?: {
      __typename?: 'Email';
      email: string;
      isEmailVerified?: boolean | null;
      isPhoneNumberVerified?: boolean | null;
    } | null;
  } | null;
};

export type ConfirmSignupAndLoginMutationVariables = Exact<{
  input?: InputMaybe<InputAuthConfirmSignUp>;
}>;

export type ConfirmSignupAndLoginMutation = {
  __typename?: 'Mutation';
  confirmSignupAndLogin?: {
    __typename?: 'Login';
    message?: string | null;
    data?: {
      __typename?: 'UserToken';
      isEmailVerified?: boolean | null;
      twoFactorAuthenticationRequired?: boolean | null;
      token?: {
        __typename?: 'LoginToken';
        sessionId?: string | null;
        refreshTokenIssuedAt?: any | null;
        refreshTokenExpiresAt?: any | null;
        refresh?: string | null;
        accessTokenIssuedAt?: any | null;
        accessTokenExpiresAt?: any | null;
        access?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ForgotPasswordMutationVariables = Exact<{
  input?: InputMaybe<InputForgotPassword>;
}>;

export type ForgotPasswordMutation = {
  __typename?: 'Mutation';
  forgotPassword?: {
    __typename?: 'ForgotPassword';
    message?: string | null;
    data?: { __typename?: 'Email'; email: string } | null;
  } | null;
};

export type LoginMutationVariables = Exact<{
  input: InputAuthLogin;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login?: {
    __typename?: 'Login';
    message?: string | null;
    data?: {
      __typename?: 'UserToken';
      isEmailVerified?: boolean | null;
      twoFactorAuthenticationRequired?: boolean | null;
      challengeName?: string | null;
      name?: string | null;
      email?: string | null;
      id?: number | null;
      token?: {
        __typename?: 'LoginToken';
        sessionId?: string | null;
        access?: string | null;
        accessTokenIssuedAt?: any | null;
        accessTokenExpiresAt?: any | null;
        refresh?: string | null;
        refreshTokenIssuedAt?: any | null;
        refreshTokenExpiresAt?: any | null;
      } | null;
    } | null;
  } | null;
};

export type CreateTeamsMutationVariables = Exact<{
  input: createTeamsInput;
}>;

export type CreateTeamsMutation = {
  __typename?: 'Mutation';
  createTeams?: {
    __typename?: 'TeamsResponse';
    message?: string | null;
    data?: {
      __typename?: 'TeamsInterface';
      totalMembers?: number | null;
      name?: string | null;
      status?: StatusEnum | null;
      workspacesId?: number | null;
      createdBy?: number | null;
      updatedBy?: number | null;
      description?: string | null;
      id?: string | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
      members?: Array<{
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        accountStatus?: boolean | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UpdateTeamsMutationVariables = Exact<{
  updateTeamsId: Scalars['String']['input'];
  input: updateTeamsInput;
}>;

export type UpdateTeamsMutation = {
  __typename?: 'Mutation';
  updateTeams?: {
    __typename?: 'TeamsResponse';
    message?: string | null;
    data?: {
      __typename?: 'TeamsInterface';
      id?: string | null;
      name?: string | null;
      description?: string | null;
      status?: StatusEnum | null;
      teamMembers?: Array<{
        __typename?: 'TeamMembersInterface';
        userId?: number | null;
        workspacesId?: number | null;
        teamId?: string | null;
        status?: StatusEnum | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          address?: string | null;
          profilePicture?: {
            __typename?: 'Media';
            id?: number | null;
            url?: string | null;
            originalname?: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type DeleteTeamsMutationVariables = Exact<{
  deleteTeamsId: Scalars['String']['input'];
}>;

export type DeleteTeamsMutation = {
  __typename?: 'Mutation';
  deleteTeams?: { __typename?: 'Message'; message?: string | null } | null;
};

export type AddTeamMemberMutationVariables = Exact<{
  input: Array<InputMaybe<InputTeamMembersInterface>> | InputMaybe<InputTeamMembersInterface>;
}>;

export type AddTeamMemberMutation = {
  __typename?: 'Mutation';
  addTeamMember?: { __typename?: 'addTeamsMembersResponse'; message?: string | null } | null;
};

export type DeleteTeamMemberMutationVariables = Exact<{
  deleteTeamMemberId: Scalars['Int']['input'];
}>;

export type DeleteTeamMemberMutation = {
  __typename?: 'Mutation';
  deleteTeamMember?: { __typename?: 'Message'; message?: string | null } | null;
};

export type BlockOrUnblockContactMutationVariables = Exact<{
  blockOrUnblockContactId?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<InputBlockOrUnblockContact>;
}>;

export type BlockOrUnblockContactMutation = {
  __typename?: 'Mutation';
  blockOrUnblockContact?: {
    __typename?: 'SingleContact';
    message?: string | null;
    data?: {
      __typename?: 'Contact';
      id?: number | null;
      isBlocked?: boolean | null;
      isPublished?: boolean | null;
      phoneNumber?: string | null;
      name?: string | null;
      blockedOn?: any | null;
      timeZone?: string | null;
      blockReason?: string | null;
      blockedBy?: { __typename?: 'User'; name?: string | null } | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
    } | null;
  } | null;
};

export type ConfirmForgotPasswordMutationVariables = Exact<{
  input?: InputMaybe<InputConfirmForgotPassword>;
}>;

export type ConfirmForgotPasswordMutation = {
  __typename?: 'Mutation';
  confirmForgotPassword?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SendMessageMutationVariables = Exact<{
  input?: InputMaybe<InputSendMessage>;
}>;

export type SendMessageMutation = {
  __typename?: 'Mutation';
  sendMessage?: {
    __typename?: 'SingleMessageConversation';
    message?: string | null;
    data?: {
      __typename?: 'MessageConversation';
      id?: number | null;
      markAsClosed?: boolean | null;
      direction?: DirectionTypeEnum | null;
      pinned?: boolean | null;
      channelId?: number | null;
      conversationStatus?: string | null;
      messageContent?: string | null;
      conversationType?: MessageConversationTypeEnum | null;
      recordingUrl?: string | null;
      numMedia?: number | null;
      friendlyName?: string | null;
      voicemailRecordingUrl?: string | null;
      createdAt?: any | null;
      forwardedAt?: any | null;
      durationConference?: { __typename?: 'DurationConference'; endDate?: any | null; startDate?: any | null } | null;
      client?: {
        __typename?: 'Contact';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      } | null;
      agent?: {
        __typename?: 'UserWorkspace';
        callPlatform?: DevicePlatformEnum | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
      } | null;
      forwardedTo?: { __typename?: 'ForwardToExternalNumber'; externalNumber?: string | null } | null;
    } | null;
  } | null;
};

export type PinOrUnpinMessageConversationMutationVariables = Exact<{
  pinOrUnpinMessageConversationId: Scalars['Int']['input'];
  input?: InputMaybe<InputPinUnpinMessageConversation>;
}>;

export type PinOrUnpinMessageConversationMutation = {
  __typename?: 'Mutation';
  pinOrUnpinMessageConversation?: {
    __typename?: 'SingleMessageConversation';
    message?: string | null;
    data?: { __typename?: 'MessageConversation'; id?: number | null; pinned?: boolean | null } | null;
  } | null;
};

export type VerifyTwoFactorAuthenticationMutationVariables = Exact<{
  input?: InputMaybe<InputVerifyTwoFactorAuthentication>;
}>;

export type VerifyTwoFactorAuthenticationMutation = {
  __typename?: 'Mutation';
  verifyTwoFactorAuthentication?: {
    __typename?: 'Login';
    message?: string | null;
    data?: {
      __typename?: 'UserToken';
      isEmailVerified?: boolean | null;
      twoFactorAuthenticationRequired?: boolean | null;
      token?: {
        __typename?: 'LoginToken';
        sessionId?: string | null;
        access?: string | null;
        refresh?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ResendTwoFactorAuthenticationCodeMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;

export type ResendTwoFactorAuthenticationCodeMutation = {
  __typename?: 'Mutation';
  resendTwoFactorAuthenticationCode?: { __typename?: 'Message'; message?: string | null } | null;
};

export type WorkspaceLoginMutationVariables = Exact<{
  input?: InputMaybe<InputWorkspaceLogin>;
}>;

export type WorkspaceLoginMutation = {
  __typename?: 'Mutation';
  workspaceLogin?: {
    __typename?: 'WorkspaceMemberLogin';
    message?: string | null;
    data?: {
      __typename?: 'WorkspaceLogin';
      token?: { __typename?: 'WorkspaceToken'; access?: string | null } | null;
      workspaceUser?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        workspace?: {
          __typename?: 'Workspace';
          status?: WorkspaceStatusEnum | null;
          hasCompleted?: boolean | null;
          label?: string | null;
          logo?: { __typename?: 'Media'; url?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CreateCommandResponseMutationVariables = Exact<{
  input?: InputMaybe<CommandResponseInput>;
}>;

export type CreateCommandResponseMutation = {
  __typename?: 'Mutation';
  createCommandResponse?: {
    __typename?: 'CommandResponseMessage';
    message?: string | null;
    data?: {
      __typename?: 'CommandResponse';
      title?: string | null;
      id?: number | null;
      content?: string | null;
      command?: string | null;
    } | null;
  } | null;
};

export type UpdateCommandResponseMutationVariables = Exact<{
  updateCommandResponseId: Scalars['Int']['input'];
  input?: InputMaybe<CommandResponseInput>;
}>;

export type UpdateCommandResponseMutation = {
  __typename?: 'Mutation';
  updateCommandResponse?: {
    __typename?: 'CommandResponseMessage';
    message?: string | null;
    data?: {
      __typename?: 'CommandResponse';
      id?: number | null;
      title?: string | null;
      command?: string | null;
      content?: string | null;
    } | null;
  } | null;
};

export type DeleteCommandResponseMutationVariables = Exact<{
  deleteCommandResponseId: Scalars['Int']['input'];
}>;

export type DeleteCommandResponseMutation = {
  __typename?: 'Mutation';
  deleteCommandResponse?: {
    __typename?: 'CommandResponseMessage';
    message?: string | null;
    data?: {
      __typename?: 'CommandResponse';
      id?: number | null;
      title?: string | null;
      command?: string | null;
      content?: string | null;
    } | null;
  } | null;
};

export type PreCheckLoginMutationVariables = Exact<{
  input?: InputMaybe<PreCheckLogin>;
}>;

export type PreCheckLoginMutation = {
  __typename?: 'Mutation';
  preCheckLogin?: {
    __typename?: 'PreCheckLoginResponse';
    message?: string | null;
    data?: { __typename?: 'PreCheckLoginData'; platformExists?: boolean | null } | null;
  } | null;
};

export type CreateCustomerV2MutationVariables = Exact<{
  input?: InputMaybe<InputCreateCustomerV2>;
}>;

export type CreateCustomerV2Mutation = {
  __typename?: 'Mutation';
  createCustomerV2?: { __typename?: 'MessageResponse'; message?: string | null } | null;
};

export type CreatePaymentIntentV2MutationVariables = Exact<{
  amount?: InputMaybe<Scalars['Int']['input']>;
  paymentGateway?: InputMaybe<PaymentGatewayEnum>;
}>;

export type CreatePaymentIntentV2Mutation = {
  __typename?: 'Mutation';
  createPaymentIntentV2?: {
    __typename?: 'ChargeBeePaymentIntentResponse';
    message?: string | null;
    data?: any | null;
  } | null;
};

export type CreateSubscriptionMutationVariables = Exact<{
  input?: InputMaybe<InputCreateSubscription>;
}>;

export type CreateSubscriptionMutation = {
  __typename?: 'Mutation';
  createSubscription?: { __typename?: 'MessageResponse'; message?: string | null } | null;
};

export type ResendConfirmationCodeMutationVariables = Exact<{
  input: InputAuthResendConfirmationCode;
}>;

export type ResendConfirmationCodeMutation = {
  __typename?: 'Mutation';
  resendConfirmationCode?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CreateUserWorkspaceFcmTokenMutationVariables = Exact<{
  input: InputUserWorkspaceFCMToken;
}>;

export type CreateUserWorkspaceFcmTokenMutation = {
  __typename?: 'Mutation';
  createUserWorkspaceFcmToken?: {
    __typename?: 'SingleUserWorkspaceFCMTokens';
    message?: string | null;
    data?: {
      __typename?: 'UserWorkspaceFCMToken';
      id?: number | null;
      token?: string | null;
      platform?: NotificationPlatformEnum | null;
    } | null;
  } | null;
};

export type DeleteUserWorkspaceFcmTokenMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteUserWorkspaceFcmTokenMutation = {
  __typename?: 'Mutation';
  deleteUserWorkspaceFcmToken?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CreateProviderErrorLogMutationVariables = Exact<{
  input?: InputMaybe<InputProviderErrorLogData>;
}>;

export type CreateProviderErrorLogMutation = {
  __typename?: 'Mutation';
  createProviderErrorLog?: { __typename?: 'ProviderErrorLogResponse'; message?: string | null } | null;
};

export type CreateContactNoteMutationVariables = Exact<{
  input: InputContactNote;
}>;

export type CreateContactNoteMutation = {
  __typename?: 'Mutation';
  createContactNote?: {
    __typename?: 'SingleContactNote';
    message?: string | null;
    data?: {
      __typename?: 'ContactNoteV2';
      id?: number | null;
      description?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      updatedBy?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateContactNoteMutationVariables = Exact<{
  updateContactNoteId: Scalars['Int']['input'];
  input: InputContactNote;
}>;

export type UpdateContactNoteMutation = {
  __typename?: 'Mutation';
  updateContactNote?: {
    __typename?: 'SingleContactNote';
    message?: string | null;
    data?: {
      __typename?: 'ContactNoteV2';
      id?: number | null;
      description?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      updatedBy?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteContactNoteMutationVariables = Exact<{
  deleteContactNoteId: Scalars['Int']['input'];
}>;

export type DeleteContactNoteMutation = {
  __typename?: 'Mutation';
  deleteContactNote?: {
    __typename?: 'SingleContactNote';
    message?: string | null;
    data?: { __typename?: 'ContactNoteV2'; id?: number | null } | null;
  } | null;
};

export type CreateTagMutationVariables = Exact<{
  input: InputTag;
}>;

export type CreateTagMutation = {
  __typename?: 'Mutation';
  createTag?: {
    __typename?: 'SingleTag';
    message?: string | null;
    data?: { __typename?: 'Tag'; id?: number | null; label?: string | null; color?: string | null } | null;
  } | null;
};

export type UpdateTagMutationVariables = Exact<{
  updateTagId: Scalars['Int']['input'];
  input: InputTag;
}>;

export type UpdateTagMutation = {
  __typename?: 'Mutation';
  updateTag?: {
    __typename?: 'SingleTag';
    message?: string | null;
    data?: {
      __typename?: 'Tag';
      id?: number | null;
      label?: string | null;
      slug?: string | null;
      type?: TagEnum | null;
      color?: string | null;
    } | null;
  } | null;
};

export type DeleteTagsMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type DeleteTagsMutation = {
  __typename?: 'Mutation';
  deleteTags?: {
    __typename?: 'MultipleTags';
    message?: string | null;
    data?: Array<{ __typename?: 'Tag'; id?: number | null } | null> | null;
  } | null;
};

export type AssignTagsToContactMutationVariables = Exact<{
  input?: InputMaybe<AssignUnassignContactTag>;
}>;

export type AssignTagsToContactMutation = {
  __typename?: 'Mutation';
  assignTagsToContact?: {
    __typename?: 'AssignTagsToContactResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'ContactTagsv2';
      id?: number | null;
      contact?: { __typename?: 'Contact'; id?: number | null } | null;
      tags?: {
        __typename?: 'Tag';
        type?: TagEnum | null;
        slug?: string | null;
        label?: string | null;
        id?: number | null;
        color?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type UnassignTagsFromContactMutationVariables = Exact<{
  input?: InputMaybe<AssignUnassignContactTag>;
}>;

export type UnassignTagsFromContactMutation = {
  __typename?: 'Mutation';
  unassignTagsFromContact?: {
    __typename?: 'MultipleContactTags';
    message?: string | null;
    data?: {
      __typename?: 'ContactTagsData';
      tags?: Array<{
        __typename?: 'Tag';
        id?: number | null;
        label?: string | null;
        color?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type SetDefaultChannelMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type SetDefaultChannelMutation = {
  __typename?: 'Mutation';
  setDefaultChannel?: {
    __typename?: 'SetDefaultChannelResponse';
    message?: string | null;
    data?: { __typename?: 'ChannelUserWorkspace'; id?: number | null } | null;
  } | null;
};

export type SetDefaultCountryMutationVariables = Exact<{
  input?: InputMaybe<InputSetDefaultCountry>;
}>;

export type SetDefaultCountryMutation = {
  __typename?: 'Mutation';
  setDefaultCountry?: { __typename?: 'Message'; message?: string | null } | null;
};

export type UpdateContactMutationVariables = Exact<{
  updateContactId: Scalars['Int']['input'];
  input: InputContact;
}>;

export type UpdateContactMutation = {
  __typename?: 'Mutation';
  updateContact?: {
    __typename?: 'SingleContact';
    message?: string | null;
    data?: {
      __typename?: 'Contact';
      id?: number | null;
      email?: string | null;
      name?: string | null;
      companyName?: string | null;
      website?: string | null;
      address?: string | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
    } | null;
  } | null;
};

export type CreateOrUpdateRecordingCallMutationVariables = Exact<{
  callSid: Scalars['String']['input'];
  input: UpdateRecordingInput;
}>;

export type CreateOrUpdateRecordingCallMutation = {
  __typename?: 'Mutation';
  createOrUpdateRecordingCall?: { __typename?: 'Message'; message?: string | null } | null;
};

export type UpdateCustomerBillingAddressMutationVariables = Exact<{
  input?: InputMaybe<InputBillingInfo>;
}>;

export type UpdateCustomerBillingAddressMutation = {
  __typename?: 'Mutation';
  updateCustomerBillingAddress?: {
    __typename?: 'CustomerBillingAddressResponse';
    message?: string | null;
    data?: {
      __typename?: 'BillingInfo';
      vatNumber?: string | null;
      email?: string | null;
      billingAddress?: {
        __typename?: 'BillingAddress';
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        line1?: string | null;
        state?: string | null;
        country?: string | null;
        zip?: string | null;
      } | null;
    } | null;
  } | null;
};

export type VerifyCallerIdMutationVariables = Exact<{
  input?: InputMaybe<InputVerifyCallerId>;
}>;

export type VerifyCallerIdMutation = {
  __typename?: 'Mutation';
  verifyCallerId?: {
    __typename?: 'SingleVerifyCallerId';
    message?: string | null;
    data?: {
      __typename?: 'VerifyCallerId';
      friendlyName?: string | null;
      phoneNumber?: string | null;
      validationCode?: string | null;
    } | null;
  } | null;
};

export type UpdateCallerIdMutationVariables = Exact<{
  updateCallerIdId: Scalars['Int']['input'];
  input?: InputMaybe<InputUpdateVerifyCallerId>;
}>;

export type UpdateCallerIdMutation = {
  __typename?: 'Mutation';
  updateCallerId?: {
    __typename?: 'SingleVerifyCallerId';
    message?: string | null;
    data?: { __typename?: 'VerifyCallerId'; friendlyName?: string | null } | null;
  } | null;
};

export type DeleteCallerIdMutationVariables = Exact<{
  deleteCallerIdId: Scalars['Int']['input'];
}>;

export type DeleteCallerIdMutation = {
  __typename?: 'Mutation';
  deleteCallerId?: { __typename?: 'Message'; message?: string | null } | null;
};

export type EstimateUpgradeWorkspaceSubscriptionMutationVariables = Exact<{
  input?: InputMaybe<InputEstimateUpgradeWorkspaceSubscription>;
}>;

export type EstimateUpgradeWorkspaceSubscriptionMutation = {
  __typename?: 'Mutation';
  estimateUpgradeWorkspaceSubscription?: {
    __typename?: 'EstimateAmountResponse';
    message?: string | null;
    data?: { __typename?: 'EstimatedData'; estimatedAmount?: number | null } | null;
  } | null;
};

export type UpgradeWorkspaceSubscriptionMutationVariables = Exact<{
  input?: InputMaybe<UpgradeWorkspaceSubscriptionInput>;
}>;

export type UpgradeWorkspaceSubscriptionMutation = {
  __typename?: 'Mutation';
  upgradeWorkspaceSubscription?: {
    __typename?: 'PlanSubscriptionResponse';
    message?: string | null;
    data?: { __typename?: 'PlanSubscription'; id?: string | null } | null;
  } | null;
};

export type DowngradeWorkspaceSubscriptionMutationVariables = Exact<{
  input?: InputMaybe<DowngradeWorkspaceSubscriptionInput>;
}>;

export type DowngradeWorkspaceSubscriptionMutation = {
  __typename?: 'Mutation';
  downgradeWorkspaceSubscription?: {
    __typename?: 'PlanSubscriptionResponse';
    message?: string | null;
    data?: { __typename?: 'PlanSubscription'; id?: string | null } | null;
  } | null;
};

export type CancelSubscriptionV2MutationVariables = Exact<{
  input: CancelSubscriptionInputV2;
}>;

export type CancelSubscriptionV2Mutation = {
  __typename?: 'Mutation';
  cancelSubscriptionV2?: {
    __typename?: 'PlanSubscriptionResponse';
    message?: string | null;
    data?: {
      __typename?: 'PlanSubscription';
      id?: string | null;
      billingPeriodUnit?: string | null;
      remainingBillingCycles?: number | null;
      customerId?: string | null;
      status?: string | null;
      currentTermEnd?: any | null;
      nextBillingAt?: number | null;
      createdAt?: any | null;
      cancelledAt?: any | null;
      updatedAt?: any | null;
      cancelScheduleCreatedAt?: number | null;
      deleted?: boolean | null;
      currencyCode?: string | null;
      mrr?: number | null;
      itemProductFamily?: string | null;
      itemCount?: number | null;
      hasScheduledChanges?: boolean | null;
      subscriptionItems?: Array<{
        __typename?: 'PlanSubscriptionItem';
        itemPriceId?: string | null;
        itemType?: string | null;
        quantity?: number | null;
        unitPrice?: number | null;
        amount?: number | null;
      } | null> | null;
      scheduledChanges?: {
        __typename?: 'SubscriptionScheduledChanges';
        id?: string | null;
        billingPeriodUnit?: string | null;
        remainingBillingCycles?: number | null;
        customerId?: string | null;
        status?: string | null;
        currentTermEnd?: number | null;
        nextBillingAt?: number | null;
        createdAt?: number | null;
        cancelledAt?: number | null;
        updatedAt?: number | null;
        cancelScheduleCreatedAt?: number | null;
        deleted?: boolean | null;
        currencyCode?: string | null;
        mrr?: number | null;
        itemProductFamily?: string | null;
        itemCount?: number | null;
      } | null;
      discountItems?: Array<{
        __typename?: 'DiscountResponse';
        discountType?: string | null;
        discountAmount?: number | null;
        discountPercentage?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type RestoreCancelledSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type RestoreCancelledSubscriptionMutation = {
  __typename?: 'Mutation';
  restoreCancelledSubscription?: { __typename?: 'MessageResponse'; message?: string | null } | null;
};

export type SetAutoRechargeConfigMutationVariables = Exact<{
  input?: InputMaybe<InputAutoRechargeConfig>;
}>;

export type SetAutoRechargeConfigMutation = {
  __typename?: 'Mutation';
  setAutoRechargeConfig?: {
    __typename?: 'AutoRechargeConfigResponse';
    message?: string | null;
    data?: {
      __typename?: 'AutoRechargeConfig';
      enabled?: boolean | null;
      creditThreshold?: number | null;
      credit?: number | null;
    } | null;
  } | null;
};

export type SetLowBalanceAlertMutationVariables = Exact<{
  isEmail?: InputMaybe<Scalars['Boolean']['input']>;
  balanceThreshold?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SetLowBalanceAlertMutation = {
  __typename?: 'Mutation';
  setLowBalanceAlert?: {
    __typename?: 'SingleLowBalanceAlert';
    message?: string | null;
    data?: { __typename?: 'LowBalanceAlert'; isEmail?: boolean | null; balanceThreshold?: number | null } | null;
  } | null;
};

export type LoadWalletMutationVariables = Exact<{
  input: LoadWalletInput;
}>;

export type LoadWalletMutation = {
  __typename?: 'Mutation';
  loadWallet?: {
    __typename?: 'WalletResponse';
    message: string;
    data?: { __typename?: 'WalletDetails'; amount: number } | null;
  } | null;
};

export type createPaymentIntentMutationVariables = Exact<{
  input?: InputMaybe<PaymentIntentInput>;
}>;

export type createPaymentIntentMutation = {
  __typename?: 'Mutation';
  createPaymentIntent?: {
    __typename?: 'ChargeBeePaymentIntentResponse';
    data?: any | null;
    message?: string | null;
  } | null;
};

export type MarkAllAsReadNotificationMutationVariables = Exact<{ [key: string]: never }>;

export type MarkAllAsReadNotificationMutation = {
  __typename?: 'Mutation';
  markAllAsReadNotification?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ToggleReadNotificationMutationVariables = Exact<{
  notificationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ToggleReadNotificationMutation = {
  __typename?: 'Mutation';
  toggleReadNotification?: { __typename?: 'Message'; message?: string | null } | null;
};

export type MarkAsSeenNotificationMutationVariables = Exact<{
  notificationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MarkAsSeenNotificationMutation = {
  __typename?: 'Mutation';
  markAsSeenNotification?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SubscribeWorkspacePlanAndInviteUserMutationVariables = Exact<{
  input?: InputMaybe<CreateSubscriptionInput>;
}>;

export type SubscribeWorkspacePlanAndInviteUserMutation = {
  __typename?: 'Mutation';
  subscribeWorkspacePlanAndInviteUser?: {
    __typename?: 'PlanSubscriptionResponse';
    message?: string | null;
    data?: { __typename?: 'PlanSubscription'; id?: string | null } | null;
  } | null;
};

export type EstimateMemberAdditionMutationVariables = Exact<{ [key: string]: never }>;

export type EstimateMemberAdditionMutation = {
  __typename?: 'Mutation';
  estimateMemberAddition?: {
    __typename?: 'EstimateAmountResponse';
    message?: string | null;
    data?: { __typename?: 'EstimatedData'; estimatedAmount?: number | null } | null;
  } | null;
};

export type MarkAllAsSeenNotificationMutationVariables = Exact<{
  notificationId: Scalars['Int']['input'];
}>;

export type MarkAllAsSeenNotificationMutation = {
  __typename?: 'Mutation';
  markAllAsSeenNotification?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CreateOrUpdateDraftMessageMutationVariables = Exact<{
  input?: InputMaybe<InputDraftMessageConversation>;
}>;

export type CreateOrUpdateDraftMessageMutation = {
  __typename?: 'Mutation';
  createOrUpdateDraftMessage?: {
    __typename?: 'SingleDraftMessageConversation';
    message?: string | null;
    data?: {
      __typename?: 'DraftMessageConversation';
      id?: number | null;
      channelId?: number | null;
      clientId?: number | null;
      messageContent?: string | null;
      createdAt?: any | null;
      medias?: Array<{
        __typename?: 'Media';
        id?: number | null;
        url?: string | null;
        originalname?: string | null;
        size?: number | null;
        key?: string | null;
        mimetype?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type DeleteContactsMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type DeleteContactsMutation = {
  __typename?: 'Mutation';
  deleteContacts?: { __typename?: 'Message'; message?: string | null } | null;
};

export type DeleteContactMutationVariables = Exact<{
  deleteContactId: Scalars['Int']['input'];
}>;

export type DeleteContactMutation = {
  __typename?: 'Mutation';
  deleteContact?: {
    __typename?: 'SingleContact';
    message?: string | null;
    data?: { __typename?: 'Contact'; id?: number | null; name?: string | null } | null;
  } | null;
};

export type CreateContactMutationVariables = Exact<{
  input: InputContact;
}>;

export type CreateContactMutation = {
  __typename?: 'Mutation';
  createContact?: {
    __typename?: 'SingleContact';
    message?: string | null;
    data?: {
      __typename?: 'Contact';
      sourceType?: string | null;
      name?: string | null;
      phoneNumber?: string | null;
      id?: number | null;
      email?: string | null;
      timeZone?: string | null;
      website?: string | null;
      address?: string | null;
      companyName?: string | null;
      profilePicture?: {
        __typename?: 'Media';
        url?: string | null;
        originalname?: string | null;
        id?: number | null;
      } | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null; name?: string | null } | null;
      tags?: Array<{
        __typename?: 'Tag';
        id?: number | null;
        label?: string | null;
        color?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type authMeUpdateMutationVariables = Exact<{
  input: InputUser;
}>;

export type authMeUpdateMutation = {
  __typename?: 'Mutation';
  authMe?: {
    __typename?: 'SingleUser';
    message?: string | null;
    data?: {
      __typename?: 'User';
      id?: number | null;
      name?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      roles?: Array<{
        __typename?: 'Role';
        id?: number | null;
        label?: string | null;
        slug?: string | null;
        level?: number | null;
        isActive?: boolean | null;
        isDefault?: boolean | null;
        position?: number | null;
      } | null> | null;
      profilePicture?: {
        __typename?: 'Media';
        url?: string | null;
        id?: number | null;
        originalname?: string | null;
        size?: number | null;
        key?: string | null;
        mimetype?: string | null;
      } | null;
      coverProfilePicture?: { __typename?: 'Media'; url?: string | null } | null;
    } | null;
  } | null;
};

export type PinOrUnpinRecentMessageConversationMutationVariables = Exact<{
  pinOrUnpinRecentMessageConversationId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
  input?: InputMaybe<InputPinUnpinRecentMessageConversation>;
}>;

export type PinOrUnpinRecentMessageConversationMutation = {
  __typename?: 'Mutation';
  pinOrUnpinRecentMessageConversation?: {
    __typename?: 'SingleRecentMessageConversation';
    message?: string | null;
    data?: {
      __typename?: 'RecentMessageConversation';
      id?: number | null;
      pinned?: boolean | null;
      updatedAt?: any | null;
      client?: { __typename?: 'Contact'; id?: number | null } | null;
      channel?: { __typename?: 'Channel'; id?: number | null } | null;
    } | null;
  } | null;
};

export type ChangePasswordMutationVariables = Exact<{
  input?: InputMaybe<InputChangePassword>;
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword?: { __typename?: 'Message'; message?: string | null } | null;
};

export type GlobalSignOutMutationVariables = Exact<{ [key: string]: never }>;

export type GlobalSignOutMutation = {
  __typename?: 'Mutation';
  globalSignOut?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ToggleChannelPinMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type ToggleChannelPinMutation = {
  __typename?: 'Mutation';
  toggleChannelPin?: {
    __typename?: 'ToggleChannelPinResponse';
    message?: string | null;
    data?: {
      __typename?: 'ChannelUserWorkspace';
      id?: number | null;
      pinned?: boolean | null;
      isDefault?: boolean | null;
      updatedAt?: any | null;
    } | null;
  } | null;
};

export type CreatePaymentSourceMutationVariables = Exact<{
  input?: InputMaybe<PaymentSourceInput>;
}>;

export type CreatePaymentSourceMutation = {
  __typename?: 'Mutation';
  createPaymentSource?: {
    __typename?: 'PaymentSourceResponse';
    message?: string | null;
    data?: {
      __typename?: 'PaymentSource';
      id?: string | null;
      gatewayAccountId?: string | null;
      isPrimary?: boolean | null;
      isSecondary?: boolean | null;
      paymentGateway?: PaymentGatewayEnum | null;
      referenceId?: string | null;
      status?: PaymentSourceStatusEnum | null;
      card?: {
        __typename?: 'Card';
        brand?: string | null;
        expiryMonth?: number | null;
        expiryYear?: number | null;
        firstName?: string | null;
        last4?: string | null;
        lastName?: string | null;
      } | null;
      paypal?: { __typename?: 'Paypal'; email?: string | null } | null;
    } | null;
  } | null;
};

export type SwitchPrimaryPaymentSourceMutationVariables = Exact<{
  input?: InputMaybe<SwitchPaymentSourceInput>;
}>;

export type SwitchPrimaryPaymentSourceMutation = {
  __typename?: 'Mutation';
  switchPrimaryPaymentSource?: { __typename?: 'Message'; message?: string | null } | null;
};

export type RemoveSecondaryPaymentSourceMutationVariables = Exact<{
  input?: InputMaybe<RemoveSecondaryPaymentSourceInput>;
}>;

export type RemoveSecondaryPaymentSourceMutation = {
  __typename?: 'Mutation';
  removeSecondaryPaymentSource?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SetSecondaryPaymentSourceMutationVariables = Exact<{
  input?: InputMaybe<SetSecondaryPaymentSourceInput>;
}>;

export type SetSecondaryPaymentSourceMutation = {
  __typename?: 'Mutation';
  setSecondaryPaymentSource?: { __typename?: 'Message'; message?: string | null } | null;
};

export type UnsetSecondaryPaymentSourceMutationVariables = Exact<{
  input: UnsetSecondaryPaymentSourceInput;
}>;

export type UnsetSecondaryPaymentSourceMutation = {
  __typename?: 'Mutation';
  unsetSecondaryPaymentSource?: { __typename?: 'Message'; message?: string | null } | null;
};

export type DeleteWorkspaceUserMutationVariables = Exact<{
  deleteWorkspaceUserId: Scalars['Int']['input'];
}>;

export type DeleteWorkspaceUserMutation = {
  __typename?: 'Mutation';
  deleteWorkspaceUser?: {
    __typename?: 'DeleteWorkspaceUserResponse';
    message?: string | null;
    data?: { __typename?: 'User'; id?: number | null } | null;
  } | null;
};

export type RevokeInvitationTokenMutationVariables = Exact<{
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RevokeInvitationTokenMutation = {
  __typename?: 'Mutation';
  revokeInvitationToken?: {
    __typename?: 'RevokeInvitationTokenResponse';
    message?: string | null;
    data?: { __typename?: 'UserWorkspace'; id?: number | null } | null;
  } | null;
};

export type ResendInviteWorkspaceMemberMutationVariables = Exact<{
  input: InputResendInviteWorkspaceMember;
}>;

export type ResendInviteWorkspaceMemberMutation = {
  __typename?: 'Mutation';
  resendInviteWorkspaceMember?: { __typename?: 'Message'; message?: string | null } | null;
};

export type UpdateWorkspaceMemberMutationVariables = Exact<{
  input: UpdateInviteWorkspaceMember;
  updateWorkspaceMemberId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UpdateWorkspaceMemberMutation = {
  __typename?: 'Mutation';
  updateWorkspaceMember?: { __typename?: 'Message'; message?: string | null } | null;
};

export type UpdateWorkspaceMemberV2MutationVariables = Exact<{
  input: UpdateInviteWorkspaceMemberV2;
  updateWorkspaceMemberV2Id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UpdateWorkspaceMemberV2Mutation = {
  __typename?: 'Mutation';
  updateWorkspaceMemberV2?: {
    __typename?: 'UpdateWorkspaceMemberV2Response';
    message?: string | null;
    data?: {
      __typename?: 'UpdatedWorkspaceMemberResponse';
      user?: { __typename?: 'User'; id?: number | null; name?: string | null; email?: string | null } | null;
      userWorkspace?: { __typename?: 'UserWorkspace'; id?: number | null } | null;
      role?: { __typename?: 'Role'; id?: number | null; label?: string | null } | null;
    } | null;
  } | null;
};

export type AssignMemberToChannelMutationVariables = Exact<{
  input: InputChannelUserWorkspace;
}>;

export type AssignMemberToChannelMutation = {
  __typename?: 'Mutation';
  assignMemberToChannel?: { __typename?: 'Message'; message?: string | null } | null;
};

export type sendChatMessageMutationVariables = Exact<{
  input: InputChatMessage;
}>;

export type sendChatMessageMutation = {
  __typename?: 'Mutation';
  sendChatMessage?: {
    __typename?: 'SingleChatMessage';
    message?: string | null;
    data?: {
      __typename?: 'ChatMessage';
      id?: number | null;
      body?: string | null;
      isPinned?: boolean | null;
      createdAt?: any | null;
      sender?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        status?: UserWorkspaceStatusEnum | null;
        userOnlineManagement?: {
          __typename?: 'UserOnlineManagement';
          isActive?: boolean | null;
          lastSeenAt?: any | null;
          activeStatus?: UserActiveStatusEnum | null;
          awayTill?: any | null;
          message?: string | null;
          awaySet?: any | null;
          icon?: string | null;
        } | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          address?: string | null;
          dueIn?: string | null;
          accountStatus?: boolean | null;
          timezone?: string | null;
          averageRiskScore?: number | null;
          totalMonthlyFee?: number | null;
          lastPasswordResetAt?: any | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type PinOrUnpinChatMessageMutationVariables = Exact<{
  pinOrUnpinChatMessageId: Scalars['Int']['input'];
  input?: InputMaybe<InputPinOrUnpinChatMessage>;
}>;

export type PinOrUnpinChatMessageMutation = {
  __typename?: 'Mutation';
  pinOrUnpinChatMessage?: {
    __typename?: 'SingleChatMessage';
    message?: string | null;
    data?: { __typename?: 'ChatMessage'; id?: number | null; isPinned?: boolean | null } | null;
  } | null;
};

export type AssignOrUnassignChannelToMemberMutationVariables = Exact<{
  input?: InputMaybe<InputAssignOrUnassignChannelToMember>;
}>;

export type AssignOrUnassignChannelToMemberMutation = {
  __typename?: 'Mutation';
  assignOrUnassignChannelToMember?: { __typename?: 'Message'; message?: string | null } | null;
};

export type VerifyPaymentRequestMutationVariables = Exact<{
  urlToken: Scalars['String']['input'];
}>;

export type VerifyPaymentRequestMutation = {
  __typename?: 'Mutation';
  verifyPaymentRequest?: {
    __typename?: 'verifyPaymentRequest';
    message?: string | null;
    data?: { __typename?: 'paymentRequestData'; amount: number; purpose: PaymentRequestPurposeEnum } | null;
  } | null;
};

export type CollectPaymentRequestMutationVariables = Exact<{
  input: CollectPaymentRequestInput;
}>;

export type CollectPaymentRequestMutation = {
  __typename?: 'Mutation';
  collectPaymentRequest?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ReadMessageMutationVariables = Exact<{
  messageConversationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ReadMessageMutation = {
  __typename?: 'Mutation';
  readMessage?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ReadAllMessageMutationVariables = Exact<{
  recentMessageConversationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ReadAllMessageMutation = {
  __typename?: 'Mutation';
  readAllMessage?: { __typename?: 'Message'; message?: string | null } | null;
};

export type MarkAsActiveOrAwayMutationVariables = Exact<{
  input?: InputMaybe<InputMarkAsActiveOrAway>;
}>;

export type MarkAsActiveOrAwayMutation = {
  __typename?: 'Mutation';
  markAsActiveOrAway?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ExportInvoicesMutationVariables = Exact<{
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
}>;

export type ExportInvoicesMutation = {
  __typename?: 'Mutation';
  exportInvoices?: { __typename?: 'Message'; message?: string | null } | null;
};

export type AddToCartMutationVariables = Exact<{
  input?: InputMaybe<InputCart>;
}>;

export type AddToCartMutation = {
  __typename?: 'Mutation';
  addToCart?: { __typename?: 'Message'; message?: string | null } | null;
};

export type RemoveFromCartMutationVariables = Exact<{
  input?: InputMaybe<InputCart>;
}>;

export type RemoveFromCartMutation = {
  __typename?: 'Mutation';
  removeFromCart?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SubscribeNumberPlanMutationVariables = Exact<{
  input: NumberSubscriptionInput;
}>;

export type SubscribeNumberPlanMutation = {
  __typename?: 'Mutation';
  subscribeNumberPlan?: { __typename?: 'MessageResponse'; message?: string | null } | null;
};

export type RequestRegulatoryComplianceMutationVariables = Exact<{
  input?: InputMaybe<InputRequestRegulatoryCompliance>;
}>;

export type RequestRegulatoryComplianceMutation = {
  __typename?: 'Mutation';
  requestRegulatoryCompliance?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ClaimFreeNumbersMutationVariables = Exact<{
  input: NumbersClaimInput;
}>;

export type ClaimFreeNumbersMutation = {
  __typename?: 'Mutation';
  claimFreeNumbers?: { __typename?: 'MessageResponse'; message?: string | null } | null;
};

export type CallTransferMutationVariables = Exact<{
  callSid: Scalars['String']['input'];
  input: InputCallTransfer;
}>;

export type CallTransferMutation = {
  __typename?: 'Mutation';
  callTransfer?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ResendMessageMutationVariables = Exact<{
  resendMessageId: Scalars['Int']['input'];
}>;

export type ResendMessageMutation = {
  __typename?: 'Mutation';
  resendMessage?: {
    __typename?: 'SingleMessageConversation';
    message?: string | null;
    data?: {
      __typename?: 'MessageConversation';
      id?: number | null;
      numMedia?: number | null;
      friendlyName?: string | null;
      forwardedAt?: any | null;
      channelId?: number | null;
      conversationStatus?: string | null;
      conversationType?: MessageConversationTypeEnum | null;
      direction?: DirectionTypeEnum | null;
      markAsClosed?: boolean | null;
      messageContent?: string | null;
      pinned?: boolean | null;
      updatedAt?: any | null;
      createdAt?: any | null;
      recordingUrl?: string | null;
      voicemailRecordingUrl?: string | null;
      messageConversationErrorLog?: {
        __typename?: 'MessageConversationErrorLog';
        code?: string | null;
        message?: string | null;
        statusCode?: string | null;
      } | null;
      forwardedTo?: { __typename?: 'ForwardToExternalNumber'; externalNumber?: string | null } | null;
      agent?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        status?: UserWorkspaceStatusEnum | null;
        channels?: Array<{
          __typename?: 'Channel';
          friendlyName?: string | null;
          phoneNumber?: string | null;
          identity?: string | null;
          id?: number | null;
        } | null> | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          profilePicture?: { __typename?: 'Media'; url?: string | null } | null;
        } | null;
        userOnlineManagement?: {
          __typename?: 'UserOnlineManagement';
          activeStatus?: UserActiveStatusEnum | null;
          isActive?: boolean | null;
          lastSeenAt?: any | null;
        } | null;
      } | null;
      client?: {
        __typename?: 'Contact';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        profilePicture?: { __typename?: 'Media'; url?: string | null } | null;
      } | null;
      durationConference?: {
        __typename?: 'DurationConference';
        startDate?: any | null;
        endDate?: any | null;
        id?: number | null;
      } | null;
      voicemailRecording?: { __typename?: 'Recording'; id?: number | null; url?: string | null } | null;
      callRecording?: {
        __typename?: 'Recording';
        id?: number | null;
        transcription?: {
          __typename?: 'TranscriptionInformation';
          id?: number | null;
          providerCallRecordingsId?: number | null;
          transcribedText?: string | null;
          targetLanguageCode?: string | null;
          sentiment?: SentimentEnum | null;
          callSummary?: string | null;
          jobStatus?: JobStatusEnum | null;
          jobResponse?: any | null;
          jobKeyName?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type ConnectThirdPartyMutationVariables = Exact<{
  integrationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ConnectThirdPartyMutation = {
  __typename?: 'Mutation';
  connectThirdParty?: {
    __typename?: 'ConnectOrDisconnectThirdPartyResponse';
    message?: string | null;
    data?: {
      __typename?: 'Integration';
      id?: number | null;
      name?: string | null;
      description?: string | null;
      domain?: string | null;
      logoUrl?: string | null;
      label?: string | null;
      integrationUser?: {
        __typename?: 'IntegrationUser';
        id?: number | null;
        status?: IntegrationUserStatusEnum | null;
      } | null;
    } | null;
  } | null;
};

export type DisconnectThirdPartyMutationVariables = Exact<{
  integrationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DisconnectThirdPartyMutation = {
  __typename?: 'Mutation';
  disconnectThirdParty?: {
    __typename?: 'ConnectOrDisconnectThirdPartyResponse';
    message?: string | null;
    data?: {
      __typename?: 'Integration';
      id?: number | null;
      name?: string | null;
      description?: string | null;
      domain?: string | null;
      logoUrl?: string | null;
      label?: string | null;
      integrationUser?: {
        __typename?: 'IntegrationUser';
        id?: number | null;
        status?: IntegrationUserStatusEnum | null;
      } | null;
    } | null;
  } | null;
};

export type CreateIntegrationConfigurationMutationVariables = Exact<{
  input?: InputMaybe<InputIntegrationConfiguration>;
}>;

export type CreateIntegrationConfigurationMutation = {
  __typename?: 'Mutation';
  createIntegrationConfiguration?: {
    __typename?: 'IntegrationConfigurationResponse';
    message?: string | null;
    data?: {
      __typename?: 'IntegrationConfiguration';
      id?: number | null;
      integrationUserId?: number | null;
      workspaceId?: number | null;
      syncCallDetails?: boolean | null;
      syncContacts?: boolean | null;
      syncMessage?: boolean | null;
      syncVoicemails?: boolean | null;
      syncRecordings?: boolean | null;
      createdBy?: number | null;
      updatedBy?: number | null;
    } | null;
  } | null;
};

export type CreateIntegrationWebhooksMutationVariables = Exact<{
  integrationUserId: Scalars['Int']['input'];
  input?: InputMaybe<Array<InputMaybe<InputIntegrationWebhook>> | InputMaybe<InputIntegrationWebhook>>;
}>;

export type CreateIntegrationWebhooksMutation = {
  __typename?: 'Mutation';
  createIntegrationWebhooks?: {
    __typename?: 'IntegrationWebhookResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'IntegrationWebhook';
      id?: number | null;
      integrationUserId?: number | null;
      label?: IntegrationWebhookLabelEnum | null;
      username?: string | null;
      password?: string | null;
      url?: string | null;
    } | null> | null;
  } | null;
};

export type UpdateIntegrationWebhooksMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<InputUpdateIntegrationWebhook>> | InputMaybe<InputUpdateIntegrationWebhook>>;
}>;

export type UpdateIntegrationWebhooksMutation = {
  __typename?: 'Mutation';
  updateIntegrationWebhooks?: {
    __typename?: 'IntegrationWebhookResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'IntegrationWebhook';
      id?: number | null;
      integrationUserId?: number | null;
      label?: IntegrationWebhookLabelEnum | null;
      username?: string | null;
      password?: string | null;
      url?: string | null;
    } | null> | null;
  } | null;
};

export type ToggleIntegrationChannelStatusMutationVariables = Exact<{
  input?: InputMaybe<InputIntegrationChannel>;
}>;

export type ToggleIntegrationChannelStatusMutation = {
  __typename?: 'Mutation';
  toggleIntegrationChannelStatus?: {
    __typename?: 'ToggleIntegrationChannelStatusResponse';
    message?: string | null;
    data?: {
      __typename?: 'IntegrationChannelV2';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      integrationChannels?: {
        __typename?: 'IntegrationChannel';
        id?: number | null;
        integrationUserId?: number | null;
        isEnabled?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type RevokeMutationVariables = Exact<{
  integrationId: Scalars['Int']['input'];
}>;

export type RevokeMutation = {
  __typename?: 'Mutation';
  revoke?: {
    __typename?: 'RevokeResponse';
    message?: string | null;
    data?: {
      __typename?: 'Integration';
      id?: number | null;
      name?: string | null;
      description?: string | null;
      domain?: string | null;
      logoUrl?: string | null;
      label?: string | null;
      integrationUser?: {
        __typename?: 'IntegrationUser';
        id?: number | null;
        status?: IntegrationUserStatusEnum | null;
      } | null;
    } | null;
  } | null;
};

export type IntegrateMutationVariables = Exact<{
  integrationId: Scalars['Int']['input'];
}>;

export type IntegrateMutation = {
  __typename?: 'Mutation';
  integrate?: {
    __typename?: 'ConnectResponse';
    message?: string | null;
    data?: { __typename?: 'AuthorizationUrlResponse'; authorizationUrl?: string | null } | null;
  } | null;
};

export type ExchangeOAuthAuthorizationCodeForTokensMutationVariables = Exact<{
  input?: InputMaybe<AuthorizeOAuthIntegrationInput>;
}>;

export type ExchangeOAuthAuthorizationCodeForTokensMutation = {
  __typename?: 'Mutation';
  exchangeOAuthAuthorizationCodeForTokens?: {
    __typename?: 'ExchangeOAuthAuthorizationCodeForTokensResponse';
    message?: string | null;
    data?: {
      __typename?: 'Integration';
      id?: number | null;
      name?: string | null;
      description?: string | null;
      domain?: string | null;
      logoUrl?: string | null;
      label?: string | null;
      integrationUser?: {
        __typename?: 'IntegrationUser';
        id?: number | null;
        status?: IntegrationUserStatusEnum | null;
      } | null;
    } | null;
  } | null;
};

export type LogOAuthAuthorizationErrorMutationVariables = Exact<{
  input?: InputMaybe<LogOAuthAuthorizationErrorInput>;
}>;

export type LogOAuthAuthorizationErrorMutation = {
  __typename?: 'Mutation';
  logOAuthAuthorizationError?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CacheOAuthAuthorizationCodeMutationVariables = Exact<{
  input?: InputMaybe<CacheIntegrationOAuthCodeInput>;
}>;

export type CacheOAuthAuthorizationCodeMutation = {
  __typename?: 'Mutation';
  cacheOAuthAuthorizationCode?: {
    __typename?: 'CacheInytegrateOAuthCode';
    message?: string | null;
    data?: { __typename?: 'OAuth2CodeHash'; transientToken?: string | null } | null;
  } | null;
};

export type ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationVariables = Exact<{
  input?: InputMaybe<AuthorizeOAuthIntegrationWithTokenInput>;
}>;

export type ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation = {
  __typename?: 'Mutation';
  exchangeOAuthAuthorizationCodeForTokensViaTransientToken?: { __typename?: 'Message'; message?: string | null } | null;
};

export type WorkspaceAuthMeMutationVariables = Exact<{
  input?: InputMaybe<InputUpdateWorkspace>;
}>;

export type WorkspaceAuthMeMutation = {
  __typename?: 'Mutation';
  workspaceAuthMe?: {
    __typename?: 'SingleWorkspace';
    message?: string | null;
    data?: {
      __typename?: 'Workspace';
      id?: number | null;
      label?: string | null;
      timezoneId?: number | null;
      timezoneLabel?: string | null;
      timezoneValue?: string | null;
      timezone?: string | null;
      coverProfile?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
      logo?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
    } | null;
  } | null;
};

export type CreateIntegrationRequestMutationVariables = Exact<{
  input: CreateIntegrationRequestInput;
}>;

export type CreateIntegrationRequestMutation = {
  __typename?: 'Mutation';
  createIntegrationRequest?: {
    __typename?: 'IntegrationRequestResponse';
    message?: string | null;
    data?: { __typename?: 'IntegrationRequest'; appName: string; id: number } | null;
  } | null;
};

export type CreateBusinessAddressMutationVariables = Exact<{
  input?: InputMaybe<InputBusinessAddress>;
}>;

export type CreateBusinessAddressMutation = {
  __typename?: 'Mutation';
  createBusinessAddress?: {
    __typename?: 'ComplianceSoleProprietorBusinessResponse';
    message?: string | null;
    data?: { __typename?: 'ComplianceSoleProprietorBusinessData'; id?: number | null } | null;
  } | null;
};

export type CreateCallSettingMutationVariables = Exact<{
  input: InputCallSetting;
}>;

export type CreateCallSettingMutation = {
  __typename?: 'Mutation';
  createCallSetting?: {
    __typename?: 'CallSettingResponse';
    message?: string | null;
    data?: { __typename?: 'CallSetting'; id?: number | null; friendlyName?: string | null } | null;
  } | null;
};

export type setCallForwardInCallSettingMutationVariables = Exact<{
  input: InputCallForward;
}>;

export type setCallForwardInCallSettingMutation = {
  __typename?: 'Mutation';
  setCallForwardInCallSetting?: {
    __typename?: 'CallForwardResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallForward';
      id?: number | null;
      isUnconditional?: boolean | null;
      targetPhoneNumber?: string | null;
      isActive?: boolean | null;
    } | null;
  } | null;
};

export type SetVoicemailInCallSettingMutationVariables = Exact<{
  setCallsettingVoicemailId: Scalars['Int']['input'];
  input: InputCallSettingVoiceMail;
}>;

export type SetVoicemailInCallSettingMutation = {
  __typename?: 'Mutation';
  setVoicemailInCallSetting?: {
    __typename?: 'CallSettingVoicemailResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingVoicemail';
      id: number;
      isActive?: boolean | null;
      sendVoicemailToEmail?: boolean | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        gender?: GenderEnum | null;
        language?: AudioPromptLanguageEnum | null;
        text?: string | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type SetBusinessHoursInCallSettingMutationVariables = Exact<{
  input: InputCallSettingBusinessHour;
}>;

export type SetBusinessHoursInCallSettingMutation = {
  __typename?: 'Mutation';
  setBusinessHoursInCallSetting?: { __typename?: 'BusinessHourResponse'; message?: string | null } | null;
};

export type SetBusinessAfterHoursInCallSettingMutationVariables = Exact<{
  input: InputCallSettingBusinessAfterHours;
}>;

export type SetBusinessAfterHoursInCallSettingMutation = {
  __typename?: 'Mutation';
  setBusinessAfterHoursInCallSetting?: { __typename?: 'BusinessAfterHourResponse'; message?: string | null } | null;
};

export type ScheduleMessageMutationVariables = Exact<{
  input?: InputMaybe<InputMessageSchedule>;
}>;

export type ScheduleMessageMutation = {
  __typename?: 'Mutation';
  scheduleMessage?: {
    __typename?: 'ScheduleMessageResponse';
    message?: string | null;
    data?: {
      __typename?: 'MessageSchedule';
      id: string;
      failureReason?: string | null;
      messageContent?: string | null;
      scheduleAt: any;
      status?: MessageScheduleStatusEnum | null;
      createdAt: any;
      attachments?: Array<{
        __typename?: 'Media';
        createdAt?: any | null;
        id?: number | null;
        key?: string | null;
        mimetype?: string | null;
        originalname?: string | null;
        size?: number | null;
        url?: string | null;
      } | null> | null;
      client: { __typename?: 'Contact'; id?: number | null };
      channel: { __typename?: 'Channel'; id?: number | null };
    } | null;
  } | null;
};

export type SetIvrInCallSettingMutationVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
  input: InputIvr;
}>;

export type SetIvrInCallSettingMutation = {
  __typename?: 'Mutation';
  setIvrInCallSetting?: {
    __typename?: 'CallIvrResponse';
    message?: string | null;
    data?: { __typename?: 'IvrResponseType'; id?: number | null } | null;
  } | null;
};

export type DeleteScheduledMessageMutationVariables = Exact<{
  deleteScheduledMessageId: Scalars['String']['input'];
}>;

export type DeleteScheduledMessageMutation = {
  __typename?: 'Mutation';
  deleteScheduledMessage?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SendScheduledMessageNowMutationVariables = Exact<{
  sendScheduledMessageNowId: Scalars['String']['input'];
}>;

export type SendScheduledMessageNowMutation = {
  __typename?: 'Mutation';
  sendScheduledMessageNow?: { __typename?: 'Message'; message?: string | null } | null;
};

export type UpdateScheduledMessageMutationVariables = Exact<{
  updateScheduledMessageId: Scalars['String']['input'];
  input: UpdateMessageSchedule;
}>;

export type UpdateScheduledMessageMutation = {
  __typename?: 'Mutation';
  updateScheduledMessage?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CollectPaymentMutationVariables = Exact<{
  paymentSourceId: Scalars['String']['input'];
  collectPaymentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CollectPaymentMutation = {
  __typename?: 'Mutation';
  collectPayment?: { __typename?: 'PaymentCollectionResponse'; message?: string | null; data?: any | null } | null;
};

export type SetCallTransferInCallSettingMutationVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
  input: InputCallSettingTransfer;
}>;

export type SetCallTransferInCallSettingMutation = {
  __typename?: 'Mutation';
  setCallTransferInCallSetting?: { __typename?: 'CallTransferResponse'; message?: string | null } | null;
};

export type SetCallerIdInCallSettingMutationVariables = Exact<{
  callerId?: InputMaybe<Scalars['Int']['input']>;
  setCallerIdInCallSettingId: Scalars['Int']['input'];
}>;

export type SetCallerIdInCallSettingMutation = {
  __typename?: 'Mutation';
  setCallerIdInCallSetting?: { __typename?: 'CallSettingCallerIdResponse'; message?: string | null } | null;
};

export type SetTimeoutInCallSettingMutationVariables = Exact<{
  setTimeoutInCallSettingId: Scalars['Int']['input'];
  input: InputTimeout;
}>;

export type SetTimeoutInCallSettingMutation = {
  __typename?: 'Mutation';
  setTimeoutInCallSetting?: {
    __typename?: 'CallSetttingTimeoutResponse';
    message?: string | null;
    data?: { __typename?: 'CallSetttingTimeout'; id?: number | null; timeout?: number | null } | null;
  } | null;
};

export type SetCallerTuneInCallSettingMutationVariables = Exact<{
  setCallerTuneInCallSettingId: Scalars['Int']['input'];
  input: InputCallerTune;
}>;

export type SetCallerTuneInCallSettingMutation = {
  __typename?: 'Mutation';
  setCallerTuneInCallSetting?: {
    __typename?: 'CallSettingCallerTuneResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingCallerTune';
      id: number;
      isActive?: boolean | null;
      callerTuneLoop?: number | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SetWelcomeMessageInCallSettingMutationVariables = Exact<{
  setWelcomeMessageInCallSettingId: Scalars['Int']['input'];
  input: InputCallSettingWelcomeMessage;
}>;

export type SetWelcomeMessageInCallSettingMutation = {
  __typename?: 'Mutation';
  setWelcomeMessageInCallSetting?: {
    __typename?: 'CallSettingWelcomeMessageResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingWelcomeMessage';
      id?: number | null;
      isActive?: boolean | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SetChannelGroupsInCallSettingMutationVariables = Exact<{
  setChannelGroupsInCallSettingId: Scalars['Int']['input'];
  channelGroupIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;

export type SetChannelGroupsInCallSettingMutation = {
  __typename?: 'Mutation';
  setChannelGroupsInCallSetting?: {
    __typename?: 'CallSettingChannelGroupResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'ChannelGroup';
      slug?: string | null;
      name?: string | null;
      id?: number | null;
    } | null> | null;
  } | null;
};

export type DeleteCallSettingMutationVariables = Exact<{
  deleteCallSettingId: Scalars['Int']['input'];
}>;

export type DeleteCallSettingMutation = {
  __typename?: 'Mutation';
  deleteCallSetting?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CreateContactComplianceConsentMutationVariables = Exact<{
  input: InputContactComplianceConsent;
}>;

export type CreateContactComplianceConsentMutation = {
  __typename?: 'Mutation';
  createContactComplianceConsent?: {
    __typename?: 'ContactComplianceConsentResponse';
    message?: string | null;
    data?: { __typename?: 'ContactComplianceConsent'; id?: number | null } | null;
  } | null;
};

export type SetCallerIdInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  callerId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SetCallerIdInChannelSettingMutation = {
  __typename?: 'Mutation';
  setCallerIdInChannelSetting?: { __typename?: 'CallSettingCallerIdResponse'; message?: string | null } | null;
};

export type SetCallForwardInChannelSettingMutationVariables = Exact<{
  input: InputCallForwardChannel;
  channelId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SetCallForwardInChannelSettingMutation = {
  __typename?: 'Mutation';
  setCallForwardInChannelSetting?: {
    __typename?: 'CallForwardResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallForward';
      id?: number | null;
      isUnconditional?: boolean | null;
      targetPhoneNumber?: string | null;
      isActive?: boolean | null;
    } | null;
  } | null;
};

export type SetAutoRecordingInCallSettingMutationVariables = Exact<{
  setAutoRecordingInCallSettingId: Scalars['Int']['input'];
  input: InputAutoRecording;
}>;

export type SetAutoRecordingInCallSettingMutation = {
  __typename?: 'Mutation';
  setAutoRecordingInCallSetting?: {
    __typename?: 'CallSettingAutoRecordingResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingAutoRecordingType'; id?: number | null; autoRecording?: boolean | null } | null;
  } | null;
};

export type SetAutoTranscribeInCallSettingMutationVariables = Exact<{
  setAutoTranscribeInCallSettingId: Scalars['Int']['input'];
  input: InputAutoTranscribe;
}>;

export type SetAutoTranscribeInCallSettingMutation = {
  __typename?: 'Mutation';
  setAutoTranscribeInCallSetting?: {
    __typename?: 'CallSettingAutoTranscribeResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingAutoTranscribeType'; id?: number | null; autoTranscribe?: boolean | null } | null;
  } | null;
};

export type SetRecordingAnnouncementInCallSettingMutationVariables = Exact<{
  setRecordingAnnouncementInCallSettingId: Scalars['Int']['input'];
  input: InputRecordingAnnouncement;
}>;

export type SetRecordingAnnouncementInCallSettingMutation = {
  __typename?: 'Mutation';
  setRecordingAnnouncementInCallSetting?: {
    __typename?: 'CallSettingRecordingAnnouncementResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingRecordingAnnouncementType';
      recordingAnnouncementMessage?: boolean | null;
      recordingAnnouncementAfterBeep?: boolean | null;
      id?: number | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        text?: string | null;
        gender?: GenderEnum | null;
        audio?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
      } | null;
    } | null;
  } | null;
};

export type SetWelcomeMessageInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputCallSettingWelcomeMessage;
}>;

export type SetWelcomeMessageInChannelSettingMutation = {
  __typename?: 'Mutation';
  setWelcomeMessageInChannelSetting?: {
    __typename?: 'CallSettingWelcomeMessageResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingWelcomeMessage';
      id?: number | null;
      isActive?: boolean | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SetTimeoutInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputTimeout;
}>;

export type SetTimeoutInChannelSettingMutation = {
  __typename?: 'Mutation';
  setTimeoutInChannelSetting?: {
    __typename?: 'CallSetttingTimeoutResponse';
    message?: string | null;
    data?: { __typename?: 'CallSetttingTimeout'; id?: number | null; timeout?: number | null } | null;
  } | null;
};

export type SetCallerTuneInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputCallerTune;
}>;

export type SetCallerTuneInChannelSettingMutation = {
  __typename?: 'Mutation';
  setCallerTuneInChannelSetting?: {
    __typename?: 'CallSettingCallerTuneResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingCallerTune';
      id: number;
      isActive?: boolean | null;
      callerTuneLoop?: number | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SetVoicemailInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputCallSettingVoiceMail;
}>;

export type SetVoicemailInChannelSettingMutation = {
  __typename?: 'Mutation';
  setVoicemailInChannelSetting?: {
    __typename?: 'CallSettingVoicemailResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingVoicemail';
      id: number;
      isActive?: boolean | null;
      sendVoicemailToEmail?: boolean | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        gender?: GenderEnum | null;
        language?: AudioPromptLanguageEnum | null;
        text?: string | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type SetCallTransferInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputChannelSettingCallTransfer;
}>;

export type SetCallTransferInChannelSettingMutation = {
  __typename?: 'Mutation';
  setCallTransferInChannelSetting?: { __typename?: 'CallTransferResponse'; message?: string | null } | null;
};

export type UpdateChannelMutationVariables = Exact<{
  updateChannelId: Scalars['Int']['input'];
  input: InputChannel;
}>;

export type UpdateChannelMutation = {
  __typename?: 'Mutation';
  updateChannel?: {
    __typename?: 'SingleChannel';
    message?: string | null;
    data?: {
      __typename?: 'Channel';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
    } | null;
  } | null;
};

export type SetAutoRecordingInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputAutoRecording;
}>;

export type SetAutoRecordingInChannelSettingMutation = {
  __typename?: 'Mutation';
  setAutoRecordingInChannelSetting?: {
    __typename?: 'CallSettingAutoRecordingResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingAutoRecordingType'; id?: number | null; autoRecording?: boolean | null } | null;
  } | null;
};

export type SetAutoTranscribeInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputAutoTranscribe;
}>;

export type SetAutoTranscribeInChannelSettingMutation = {
  __typename?: 'Mutation';
  setAutoTranscribeInChannelSetting?: {
    __typename?: 'CallSettingAutoTranscribeResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingAutoTranscribeType'; id?: number | null; autoTranscribe?: boolean | null } | null;
  } | null;
};

export type SetRecordingAnnouncementInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputRecordingAnnouncement;
}>;

export type SetRecordingAnnouncementInChannelSettingMutation = {
  __typename?: 'Mutation';
  setRecordingAnnouncementInChannelSetting?: {
    __typename?: 'CallSettingRecordingAnnouncementResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingRecordingAnnouncementType';
      recordingAnnouncementMessage?: boolean | null;
      recordingAnnouncementAfterBeep?: boolean | null;
      id?: number | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        text?: string | null;
        gender?: GenderEnum | null;
        audio?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
      } | null;
    } | null;
  } | null;
};

export type SetIvrInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputChannelSettingIvr;
}>;

export type SetIvrInChannelSettingMutation = {
  __typename?: 'Mutation';
  setIvrInChannelSetting?: {
    __typename?: 'CallIvrResponse';
    message?: string | null;
    data?: { __typename?: 'IvrResponseType'; id?: number | null } | null;
  } | null;
};

export type SetBusinessHoursInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputChannelSettingBusinessHour;
}>;

export type SetBusinessHoursInChannelSettingMutation = {
  __typename?: 'Mutation';
  setBusinessHoursInChannelSetting?: { __typename?: 'BusinessHourResponse'; message?: string | null } | null;
};

export type CreateChannelGroupMutationVariables = Exact<{
  input: InputChannelGroup;
}>;

export type CreateChannelGroupMutation = {
  __typename?: 'Mutation';
  createChannelGroup?: {
    __typename?: 'ChannelGroupData';
    message?: string | null;
    data?: { __typename?: 'ChannelGroup'; slug?: string | null; name?: string | null; id?: number | null } | null;
  } | null;
};

export type DeleteChannelGroupMutationVariables = Exact<{
  deleteChannelGroupId: Scalars['Int']['input'];
}>;

export type DeleteChannelGroupMutation = {
  __typename?: 'Mutation';
  deleteChannelGroup?: { __typename?: 'Message'; message?: string | null } | null;
};

export type UpdateChannelGroupMutationVariables = Exact<{
  updateChannelGroupId: Scalars['Int']['input'];
  input: InputChannelGroup;
}>;

export type UpdateChannelGroupMutation = {
  __typename?: 'Mutation';
  updateChannelGroup?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SetChannelsInGroupMutationVariables = Exact<{
  input: InputSetChannelsInGroup;
}>;

export type SetChannelsInGroupMutation = {
  __typename?: 'Mutation';
  setChannelsInGroup?: {
    __typename?: 'setChannelsInGroupType';
    message?: string | null;
    data?: {
      __typename?: 'setChannelsInGroup';
      unAssignedChannels?: Array<{
        __typename?: 'Channel';
        phoneNumber?: string | null;
        friendlyName?: string | null;
        id?: number | null;
      } | null> | null;
      assignedChannels?: Array<{
        __typename?: 'Channel';
        phoneNumber?: string | null;
        friendlyName?: string | null;
        id?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type SetBusinessAfterHoursInChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputChannelSettingBusinessAfterHours;
}>;

export type SetBusinessAfterHoursInChannelSettingMutation = {
  __typename?: 'Mutation';
  setBusinessAfterHoursInChannelSetting?: { __typename?: 'BusinessAfterHourResponse'; message?: string | null } | null;
};

export type SwitchToChannelSettingMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type SwitchToChannelSettingMutation = {
  __typename?: 'Mutation';
  switchToChannelSetting?: {
    __typename?: 'ChannelOverviewResponse';
    message?: string | null;
    data?: {
      __typename?: 'Channel';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        flag?: string | null;
        alphaTwoCode?: string | null;
      } | null;
      callSetting?: {
        __typename?: 'CallSettingsType';
        id?: number | null;
        businessHourType?: string | null;
        friendlyName?: string | null;
        incomingTimeout?: number | null;
        recording?: boolean | null;
        metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
        callerId?: {
          __typename?: 'CallerId';
          id?: number | null;
          friendlyName?: string | null;
          phoneNumber?: string | null;
        } | null;
      } | null;
      channelGroup?: {
        __typename?: 'ChannelGroup';
        id?: number | null;
        name?: string | null;
        callSetting?: {
          __typename?: 'CallSettingsType';
          id?: number | null;
          businessHourType?: string | null;
          friendlyName?: string | null;
          recording?: boolean | null;
          incomingTimeout?: number | null;
          metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
          callerId?: {
            __typename?: 'CallerId';
            id?: number | null;
            friendlyName?: string | null;
            phoneNumber?: string | null;
          } | null;
        } | null;
      } | null;
      assignedUsers?: Array<{
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type SetCallSettingInChannelGroupMutationVariables = Exact<{
  setCallSettingInChannelGroupId: Scalars['Int']['input'];
  callSettingId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SetCallSettingInChannelGroupMutation = {
  __typename?: 'Mutation';
  setCallSettingInChannelGroup?: {
    __typename?: 'ChannelGroupData';
    message?: string | null;
    data?: {
      __typename?: 'ChannelGroup';
      slug?: string | null;
      name?: string | null;
      id?: number | null;
      metrics?: Array<{ __typename?: 'Metrics'; value?: number | null; key?: string | null } | null> | null;
      channel?: Array<{
        __typename?: 'Channel';
        phoneNumber?: string | null;
        id?: number | null;
        friendlyName?: string | null;
      } | null> | null;
      callSetting?: {
        __typename?: 'CallSettingsType';
        id?: number | null;
        friendlyName?: string | null;
        metrics?: Array<{ __typename?: 'Metrics'; value?: number | null; key?: string | null } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ToggleChannelNotificationMutationVariables = Exact<{
  input: InputToggleChannelNotification;
}>;

export type ToggleChannelNotificationMutation = {
  __typename?: 'Mutation';
  toggleChannelNotification?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ExportContactsMutationVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sourceType?: InputMaybe<Array<InputMaybe<ContactSourceTypeEnum>> | InputMaybe<ContactSourceTypeEnum>>;
}>;

export type ExportContactsMutation = {
  __typename?: 'Mutation';
  exportContacts?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ForwardChatToEmailMutationVariables = Exact<{
  input: InputForwardChatToEmail;
}>;

export type ForwardChatToEmailMutation = {
  __typename?: 'Mutation';
  forwardChatToEmail?: { __typename?: 'Message'; message?: string | null } | null;
};

export type VerifyInvitationTokenMutationVariables = Exact<{
  input?: InputMaybe<InputVerifyInvitationToken>;
}>;

export type VerifyInvitationTokenMutation = {
  __typename?: 'Mutation';
  verifyInvitationToken?: {
    __typename?: 'VerifyInvitationToken';
    message?: string | null;
    data?: {
      __typename?: 'VerifyInvitationTokenResponse';
      name?: string | null;
      passwordRequired?: boolean | null;
    } | null;
  } | null;
};

export type AcceptInvitedWorkspaceMemberMutationVariables = Exact<{
  input?: InputMaybe<InputAcceptInvitedWorkspaceMemberInterface>;
}>;

export type AcceptInvitedWorkspaceMemberMutation = {
  __typename?: 'Mutation';
  acceptInvitedWorkspaceMember?: { __typename?: 'Message'; message?: string | null } | null;
};

export type WrapUpCallMutationVariables = Exact<{
  callSid: Scalars['String']['input'];
}>;

export type WrapUpCallMutation = {
  __typename?: 'Mutation';
  wrapUpCall?: { __typename?: 'Message'; message?: string | null } | null;
};

export type VerifyAndTransitionStatusMutationVariables = Exact<{
  verifyAndTransitionStatusId: Scalars['Int']['input'];
  model?: InputMaybe<VerifyAndTransitionModelEnum>;
}>;

export type VerifyAndTransitionStatusMutation = {
  __typename?: 'Mutation';
  verifyAndTransitionStatus?: { __typename?: 'Message'; message?: string | null } | null;
};

export type RemoveProviderPhoneNumberMutationVariables = Exact<{
  removeProviderPhoneNumberId: Scalars['Int']['input'];
}>;

export type RemoveProviderPhoneNumberMutation = {
  __typename?: 'Mutation';
  removeProviderPhoneNumber?: { __typename?: 'SingleTwilioAvailablePhoneNumber'; message?: string | null } | null;
};

export type RemoveProviderPhoneNumbersMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RemoveProviderPhoneNumbersMutation = {
  __typename?: 'Mutation';
  removeProviderPhoneNumbers: {
    __typename?: 'RemoveProviderPhoneNumbersResponse';
    message?: string | null;
    deletedIds: Array<number>;
    failed?: Array<{ __typename?: 'RemovePhoneNumberFailure'; id: number; reason?: string | null }> | null;
  };
};

export type CreateTranscriptionJobMutationVariables = Exact<{
  input: InputTranscriptionInformation;
}>;

export type CreateTranscriptionJobMutation = {
  __typename?: 'Mutation';
  createTranscriptionJob?: {
    __typename?: 'SingleTranscriptionInformation';
    message?: string | null;
    data?: {
      __typename?: 'TranscriptionInformation';
      jobStatus?: JobStatusEnum | null;
      id?: number | null;
      providerCallRecordingsId?: number | null;
    } | null;
  } | null;
};

export type SwitchUiVersionMutationVariables = Exact<{
  uiVersion: UiVersionEnum;
}>;

export type SwitchUiVersionMutation = {
  __typename?: 'Mutation';
  switchUiVersion?: { __typename?: 'Message'; message?: string | null } | null;
};

export type MigrateToV2MutationVariables = Exact<{ [key: string]: never }>;

export type MigrateToV2Mutation = {
  __typename?: 'Mutation';
  migrateToV2?: { __typename?: 'Message'; message?: string | null } | null;
};

export type UpdateCallSettingMutationVariables = Exact<{
  updateCallSettingId: Scalars['Int']['input'];
  input: InputCallSetting;
}>;

export type UpdateCallSettingMutation = {
  __typename?: 'Mutation';
  updateCallSetting?: {
    __typename?: 'CallSettingFriendlyNameResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingFriendlyName'; id: number; friendlyName?: string | null } | null;
  } | null;
};

export type SuperviseConferenceMutationVariables = Exact<{
  superviseConferenceId: Scalars['Int']['input'];
  input?: InputMaybe<InputSuperviseConference>;
}>;

export type SuperviseConferenceMutation = {
  __typename?: 'Mutation';
  superviseConference?: {
    __typename?: 'SingleSuperviseConference';
    message?: string | null;
    data?: { __typename?: 'SuperviseConference'; supervisionId?: string | null } | null;
  } | null;
};

export type UnSuperviseConferenceMutationVariables = Exact<{
  unSuperviseConferenceId: Scalars['Int']['input'];
  input?: InputMaybe<InputUnSuperviseConference>;
}>;

export type UnSuperviseConferenceMutation = {
  __typename?: 'Mutation';
  unSuperviseConference?: {
    __typename?: 'SingleSuperviseConference';
    message?: string | null;
    data?: { __typename?: 'SuperviseConference'; supervisionId?: string | null } | null;
  } | null;
};

export type HangUpConferenceMutationVariables = Exact<{
  hangUpConferenceId: Scalars['Int']['input'];
  input?: InputMaybe<InputHangUpConference>;
}>;

export type HangUpConferenceMutation = {
  __typename?: 'Mutation';
  hangUpConference?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CaptureClientCallEntityInfoMutationVariables = Exact<{
  callSid: Scalars['String']['input'];
  input: InputCollectClientInformation;
}>;

export type CaptureClientCallEntityInfoMutation = {
  __typename?: 'Mutation';
  captureClientCallEntityInfo?: { __typename?: 'Message'; message?: string | null } | null;
};

export type FederatedAuthMutationVariables = Exact<{
  input: InputFederatedAuth;
}>;

export type FederatedAuthMutation = {
  __typename?: 'Mutation';
  federatedAuth?: {
    __typename?: 'FederatedAuthResponse';
    message?: string | null;
    data?: {
      __typename?: 'FederatedAuthToken';
      name?: string | null;
      id?: number | null;
      email?: string | null;
      token?: {
        __typename?: 'LoginToken';
        sessionId?: string | null;
        access?: string | null;
        accessTokenIssuedAt?: any | null;
        accessTokenExpiresAt?: any | null;
        refresh?: string | null;
        refreshTokenIssuedAt?: any | null;
        refreshTokenExpiresAt?: any | null;
      } | null;
    } | null;
  } | null;
};

export type SetUpTOTPMfaMutationVariables = Exact<{ [key: string]: never }>;

export type SetUpTOTPMfaMutation = {
  __typename?: 'Mutation';
  setUpTOTPMfa?: {
    __typename?: 'SetUpTOTPResponse';
    message?: string | null;
    data?: { __typename?: 'MfaToken'; otpAuthUri?: string | null } | null;
  } | null;
};

export type VerifyAndEnableTOTPMfaMutationVariables = Exact<{
  input: InputEnabledTOTPMfa;
}>;

export type VerifyAndEnableTOTPMfaMutation = {
  __typename?: 'Mutation';
  verifyAndEnableTOTPMfa?: {
    __typename?: 'SetUpMfaStatusResponse';
    message?: string | null;
    data?: { __typename?: 'MfaStatusToken'; status?: string | null } | null;
  } | null;
};

export type DisableTOTPMfaMutationVariables = Exact<{ [key: string]: never }>;

export type DisableTOTPMfaMutation = {
  __typename?: 'Mutation';
  disableTOTPMfa?: {
    __typename?: 'SetUpMfaStatusResponse';
    message?: string | null;
    data?: { __typename?: 'MfaStatusToken'; status?: string | null } | null;
  } | null;
};

export type SetUpEmailMfaMutationVariables = Exact<{
  input: InputEmailMfa;
}>;

export type SetUpEmailMfaMutation = {
  __typename?: 'Mutation';
  setUpEmailMfa?: {
    __typename?: 'SetUpMfaStatusResponse';
    message?: string | null;
    data?: { __typename?: 'MfaStatusToken'; status?: string | null } | null;
  } | null;
};

export type SwitchToEmailMfaMutationVariables = Exact<{
  input: InputSwitchEmailMfa;
}>;

export type SwitchToEmailMfaMutation = {
  __typename?: 'Mutation';
  switchToEmailMfa?: {
    __typename?: 'SetUpEmailMfaResponse';
    message?: string | null;
    data?: { __typename?: 'MfaSwitchEmail'; challengeName?: string | null } | null;
  } | null;
};

export type ResendEmailMfaOtpMutationVariables = Exact<{
  input: InputSwitchEmailMfa;
}>;

export type ResendEmailMfaOtpMutation = {
  __typename?: 'Mutation';
  resendEmailMfaOtp?: {
    __typename?: 'SetUpEmailMfaResponse';
    message?: string | null;
    data?: { __typename?: 'MfaSwitchEmail'; challengeName?: string | null } | null;
  } | null;
};

export type VerifyMfaAuthenticationMutationVariables = Exact<{
  input: InputMfaAuth;
}>;

export type VerifyMfaAuthenticationMutation = {
  __typename?: 'Mutation';
  verifyMfaAuthentication?: {
    __typename?: 'Login';
    message?: string | null;
    data?: {
      __typename?: 'UserToken';
      isEmailVerified?: boolean | null;
      twoFactorAuthenticationRequired?: boolean | null;
      challengeName?: string | null;
      name?: string | null;
      email?: string | null;
      id?: number | null;
      token?: {
        __typename?: 'LoginToken';
        sessionId?: string | null;
        access?: string | null;
        accessTokenIssuedAt?: any | null;
        accessTokenExpiresAt?: any | null;
        refresh?: string | null;
        refreshTokenIssuedAt?: any | null;
        refreshTokenExpiresAt?: any | null;
      } | null;
    } | null;
  } | null;
};

export type SetMfaReminderMutationVariables = Exact<{ [key: string]: never }>;

export type SetMfaReminderMutation = {
  __typename?: 'Mutation';
  setMfaReminder?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SetWorkspacePreferredContactMethodsMutationVariables = Exact<{
  input?: InputMaybe<InputWorkspacePreferredContactMethod>;
}>;

export type SetWorkspacePreferredContactMethodsMutation = {
  __typename?: 'Mutation';
  setWorkspacePreferredContactMethods?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SetWorkspacePreferredContactMethodsLaterMutationVariables = Exact<{ [key: string]: never }>;

export type SetWorkspacePreferredContactMethodsLaterMutation = {
  __typename?: 'Mutation';
  setWorkspacePreferredContactMethodsLater?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CreateKycVerificationSessionMutationVariables = Exact<{ [key: string]: never }>;

export type CreateKycVerificationSessionMutation = {
  __typename?: 'Mutation';
  createKycVerificationSession?: {
    __typename?: 'KycVerificationSessionResponse';
    message?: string | null;
    data?: {
      __typename?: 'KycVerificationSession';
      id?: number | null;
      sessionUrl?: string | null;
      sessionExpiry?: any | null;
      sessionId?: string | null;
      status?: KycVerificationSessionsStatus | null;
      vendorData?: string | null;
      workflowId?: string | null;
    } | null;
  } | null;
};

export type SetUsageReportNotificationMutationVariables = Exact<{
  input: InputSetUsageReportNotification;
}>;

export type SetUsageReportNotificationMutation = {
  __typename?: 'Mutation';
  setUsageReportNotification?: { __typename?: 'UsageReportNotificationResponse'; message?: string | null } | null;
};

export type MarkMemberChatAsReadMutationVariables = Exact<{
  roomId: Scalars['Int']['input'];
}>;

export type MarkMemberChatAsReadMutation = {
  __typename?: 'Mutation';
  markMemberChatAsRead?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SwitchCallMutationVariables = Exact<{
  switchCallId: Scalars['Int']['input'];
  input: InputSwitchCall;
}>;

export type SwitchCallMutation = {
  __typename?: 'Mutation';
  switchCall?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CancelWorkspaceDowngradeMutationVariables = Exact<{ [key: string]: never }>;

export type CancelWorkspaceDowngradeMutation = {
  __typename?: 'Mutation';
  cancelWorkspaceDowngrade?: { __typename?: 'Message'; message?: string | null } | null;
};

export type CreateBulkMessagingCampaignMutationVariables = Exact<{
  input?: InputMaybe<InputBulkMessagingCampaign>;
}>;

export type CreateBulkMessagingCampaignMutation = {
  __typename?: 'Mutation';
  createBulkMessagingCampaign?: {
    __typename?: 'CreateBulkMessagingCampaignResponse';
    message?: string | null;
    data?: {
      __typename?: 'BulkMessagingCampaign';
      id?: number | null;
      campaignName?: string | null;
      isDraft?: boolean | null;
      messageTemplate?: string | null;
      mediaCount?: number | null;
      campaignType?: BulkMessagingCampaignTypeEnum | null;
      a2pCampaignId?: number | null;
      a2pCampaignType?: BulkMessagingCampaignA2pCampaignTypeEnum | null;
      a2pSampleId?: number | null;
      messagingType?: BulkMessagingCampaignMessagingTypeEnum | null;
      status?: BulkMessagingCampaignStatusEnum | null;
      scheduleType?: BulkMessagingCampaignScheduleTypeEnum | null;
      isScheduled?: boolean | null;
      initiatedAt?: any | null;
      scheduledAt?: any | null;
      maxOccurrence?: number | null;
      endAt?: any | null;
      createdAt?: any | null;
      attachments?: Array<{
        __typename?: 'BulkMessagingAttachment';
        id?: number | null;
        fileName?: string | null;
        mimetype?: string | null;
        fileSize?: number | null;
        fileUrl?: string | null;
      } | null> | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
      createdBy?: {
        __typename?: 'BulkMessagingCampaignCreator';
        id?: number | null;
        name?: string | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
        roles?: {
          __typename?: 'Role';
          id?: number | null;
          isActive?: boolean | null;
          isDefault?: boolean | null;
          label?: string | null;
          position?: number | null;
          slug?: string | null;
          level?: number | null;
        } | null;
      } | null;
      deliverySummary?: {
        __typename?: 'BulkMessagingDeliverySummary';
        totalSent?: number | null;
        totalRecipients?: number | null;
        runStatus?: string | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateBulkMessagingCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
  input?: InputMaybe<InputBulkMessagingCampaign>;
}>;

export type UpdateBulkMessagingCampaignMutation = {
  __typename?: 'Mutation';
  updateBulkMessagingCampaign?: {
    __typename?: 'UpdateBulkMessagingCampaignResponse';
    message?: string | null;
    data?: {
      __typename?: 'BulkMessagingCampaign';
      id?: number | null;
      campaignName?: string | null;
      isDraft?: boolean | null;
      messageTemplate?: string | null;
      mediaCount?: number | null;
      campaignType?: BulkMessagingCampaignTypeEnum | null;
      messagingType?: BulkMessagingCampaignMessagingTypeEnum | null;
      a2pCampaignId?: number | null;
      a2pCampaignType?: BulkMessagingCampaignA2pCampaignTypeEnum | null;
      a2pSampleId?: number | null;
      status?: BulkMessagingCampaignStatusEnum | null;
      scheduleType?: BulkMessagingCampaignScheduleTypeEnum | null;
      isScheduled?: boolean | null;
      initiatedAt?: any | null;
      scheduledAt?: any | null;
      maxOccurrence?: number | null;
      endAt?: any | null;
      createdAt?: any | null;
      attachments?: Array<{
        __typename?: 'BulkMessagingAttachment';
        id?: number | null;
        fileName?: string | null;
        mimetype?: string | null;
        fileSize?: number | null;
        fileUrl?: string | null;
      } | null> | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
      createdBy?: {
        __typename?: 'BulkMessagingCampaignCreator';
        id?: number | null;
        name?: string | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
        roles?: {
          __typename?: 'Role';
          id?: number | null;
          label?: string | null;
          slug?: string | null;
          level?: number | null;
          isActive?: boolean | null;
          isDefault?: boolean | null;
          position?: number | null;
        } | null;
      } | null;
      deliverySummary?: {
        __typename?: 'BulkMessagingDeliverySummary';
        totalSent?: number | null;
        totalRecipients?: number | null;
        runStatus?: string | null;
      } | null;
    } | null;
  } | null;
};

export type RemoveWorkspaceUserWithDispositionMutationVariables = Exact<{
  input: RemoveMemberDispositionInput;
}>;

export type RemoveWorkspaceUserWithDispositionMutation = {
  __typename?: 'Mutation';
  removeWorkspaceUserWithDisposition?: {
    __typename?: 'RemoveWorkspaceUserWithDispositionResponse';
    message?: string | null;
  } | null;
};

export type DeleteBulkMessagingCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;

export type DeleteBulkMessagingCampaignMutation = {
  __typename?: 'Mutation';
  deleteBulkMessagingCampaign?: { __typename?: 'Message'; message?: string | null } | null;
};

export type DuplicateBulkMessagingCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;

export type DuplicateBulkMessagingCampaignMutation = {
  __typename?: 'Mutation';
  duplicateBulkMessagingCampaign?: { __typename?: 'GetBulkMessagingCampaignResponse'; message?: string | null } | null;
};

export type PauseRecurringBulkMessagingCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;

export type PauseRecurringBulkMessagingCampaignMutation = {
  __typename?: 'Mutation';
  pauseRecurringBulkMessagingCampaign?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ResumeRecurringBulkMessagingCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;

export type ResumeRecurringBulkMessagingCampaignMutation = {
  __typename?: 'Mutation';
  resumeRecurringBulkMessagingCampaign?: { __typename?: 'Message'; message?: string | null } | null;
};

export type TerminateRecurringBulkMessagingCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;

export type TerminateRecurringBulkMessagingCampaignMutation = {
  __typename?: 'Mutation';
  terminateRecurringBulkMessagingCampaign?: { __typename?: 'Message'; message?: string | null } | null;
};

export type SetCallSettingEmailAlertsMutationVariables = Exact<{
  setCallSettingEmailAlertsId: Scalars['Int']['input'];
  input: InputEmailAlerts;
}>;

export type SetCallSettingEmailAlertsMutation = {
  __typename?: 'Mutation';
  setCallSettingEmailAlerts?: {
    __typename?: 'CallSettingEmailAlertsResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingEmailAlertsType';
      enableMissedCallEmail?: boolean | null;
      smsMmsEmailAlertEnabled?: boolean | null;
      transcriptionEmailAlertEnabled?: boolean | null;
    } | null;
  } | null;
};

export type SetChannelSettingEmailAlertsMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
  input: InputEmailAlerts;
}>;

export type SetChannelSettingEmailAlertsMutation = {
  __typename?: 'Mutation';
  setChannelSettingEmailAlerts?: {
    __typename?: 'CallSettingEmailAlertsResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingEmailAlertsType';
      enableMissedCallEmail?: boolean | null;
      smsMmsEmailAlertEnabled?: boolean | null;
      transcriptionEmailAlertEnabled?: boolean | null;
    } | null;
  } | null;
};

export type SetAutoRechargeConfigV2MutationVariables = Exact<{
  input?: InputMaybe<InputAutoRechargeConfig>;
}>;

export type SetAutoRechargeConfigV2Mutation = {
  __typename?: 'Mutation';
  setAutoRechargeConfigV2?: {
    __typename?: 'AutoRechargeConfigResponse';
    message?: string | null;
    data?: {
      __typename?: 'AutoRechargeConfig';
      enabled?: boolean | null;
      creditThreshold?: number | null;
      credit?: number | null;
      targetBalance?: number | null;
      isDisableAllowed?: boolean | null;
    } | null;
  } | null;
};

export type ReleaseChannelsMutationVariables = Exact<{
  input?: InputMaybe<InputReleaseChannels>;
}>;

export type ReleaseChannelsMutation = {
  __typename?: 'Mutation';
  releaseChannels?: { __typename?: 'MessageResponse'; message?: string | null } | null;
};

export type PurchaseNumbersMutationVariables = Exact<{
  input?: InputMaybe<InputPurchaseNumbers>;
}>;

export type PurchaseNumbersMutation = {
  __typename?: 'Mutation';
  purchaseNumbers?: {
    __typename?: 'PurchaseNumbersRes';
    message?: string | null;
    data?: { __typename?: 'PurchaseNumbersResData'; duplicates?: Array<string | null> | null } | null;
  } | null;
};

export type ConfirmPaymentOrderMutationVariables = Exact<{
  paymentOrderId: Scalars['Int']['input'];
}>;

export type ConfirmPaymentOrderMutation = {
  __typename?: 'Mutation';
  confirmPaymentOrder?: {
    __typename?: 'PaymentOrderResponse';
    message?: string | null;
    data?: {
      __typename?: 'PaymentOrder';
      id?: number | null;
      status?: string | null;
      lienStatus?: PaymentOrderLienStatusEnum | null;
    } | null;
  } | null;
};

export type RejectPaymentOrderMutationVariables = Exact<{
  input: InputRejectPaymentOrder;
}>;

export type RejectPaymentOrderMutation = {
  __typename?: 'Mutation';
  rejectPaymentOrder?: {
    __typename?: 'PaymentOrderResponse';
    message?: string | null;
    data?: {
      __typename?: 'PaymentOrder';
      id?: number | null;
      status?: string | null;
      lienStatus?: PaymentOrderLienStatusEnum | null;
    } | null;
  } | null;
};

export type RemoveChannelRemovalScheduleMutationVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type RemoveChannelRemovalScheduleMutation = {
  __typename?: 'Mutation';
  removeChannelRemovalSchedule?: { __typename?: 'ChannelRemovalScheduleResponse'; message?: string | null } | null;
};

export type GetWalletDetailsV2QueryVariables = Exact<{ [key: string]: never }>;

export type GetWalletDetailsV2Query = {
  __typename?: 'Query';
  getWalletDetailsV2?: {
    __typename?: 'WalletResponse';
    message: string;
    data?: { __typename?: 'WalletDetails'; amount: number; isAutoRechargeEnabled?: boolean | null } | null;
  } | null;
};

export type authMeQueryVariables = Exact<{ [key: string]: never }>;

export type authMeQuery = {
  __typename?: 'Query';
  authMe?: {
    __typename?: 'AuthMeResponse';
    message?: string | null;
    data?: {
      __typename?: 'AuthMeData';
      lastSession?: {
        __typename?: 'LastUserSession';
        platform?: string | null;
        id?: number | null;
        authType?: string | null;
        userAgent?: string | null;
      } | null;
      user?: {
        __typename?: 'User';
        lastPasswordResetAt?: any | null;
        id?: number | null;
        name?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        language?: string | null;
        identityProvider?: IdentityProviderEnum | null;
        uiVersion?: UiVersionEnum | null;
        mfaTotpEnabled?: boolean | null;
        mfaEmailEnabled?: boolean | null;
        mfaReminderAt?: any | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
        coverProfilePicture?: {
          __typename?: 'Media';
          createdAt?: any | null;
          id?: number | null;
          key?: string | null;
          mimetype?: string | null;
          originalname?: string | null;
          size?: number | null;
          url?: string | null;
        } | null;
        roles?: Array<{
          __typename?: 'Role';
          id?: number | null;
          label?: string | null;
          slug?: string | null;
          level?: number | null;
          isActive?: boolean | null;
          isDefault?: boolean | null;
        } | null> | null;
      } | null;
      userWorkspaceRole?: Array<{
        __typename?: 'UserWorkspaceRole';
        role?: {
          __typename?: 'Role';
          id?: number | null;
          isActive?: boolean | null;
          label?: string | null;
          level?: number | null;
          position?: number | null;
          slug?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type aiDashboardIntentQueryVariables = Exact<{
  intentType: Scalars['String']['input'];
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type aiDashboardIntentQuery = {
  __typename?: 'Query';
  aiDashboardIntent?: {
    __typename?: 'AIDashboardIntentResponse';
    message?: string | null;
    count?: number | null;
    edges?: Array<{
      __typename?: 'AIDashboardIntent';
      intent?: string | null;
      currentCount?: number | null;
      currentSentiment?: string | null;
      previousCount?: number | null;
      previousSentiment?: string | null;
      callVolume?: number | null;
    } | null> | null;
  } | null;
};

export type workspaceAuthMeV2QueryVariables = Exact<{ [key: string]: never }>;

export type workspaceAuthMeV2Query = {
  __typename?: 'Query';
  workspaceAuthMeV2?: {
    __typename?: 'WorkspaceAuthMeV2';
    message?: string | null;
    data?: {
      __typename?: 'Workspace';
      v2MigratedAt?: any | null;
      timezoneValue?: string | null;
      unreadCountWorkspace?: number | null;
      id?: number | null;
      label?: string | null;
      status?: WorkspaceStatusEnum | null;
      timezone?: string | null;
      timezoneId?: number | null;
      timezoneLabel?: string | null;
      kycVerified?: boolean | null;
      hasCompleted?: boolean | null;
      preferredContactMethodReminderAt?: any | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        name?: string | null;
        dialingCode?: string | null;
        alphaTwoCode?: string | null;
      } | null;
      workspaceDetails?: {
        __typename?: 'WorkspaceDetail';
        planPrice?: { __typename?: 'PlanPrice'; amount?: number | null } | null;
        documents?: Array<{
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null> | null;
      } | null;
      logo?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      providerAccount?: {
        __typename?: 'ProviderAccount';
        systemSuspend?: WorkspaceProviderSubAccountSuspendedReasonEnum | null;
        status?: WorkspaceProviderSubaccountStatusEnum | null;
      } | null;
      owner?: {
        __typename?: 'User';
        phoneNumber?: string | null;
        name?: string | null;
        email?: string | null;
        id?: number | null;
        language?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        roles?: Array<{ __typename?: 'Role'; id?: number | null; label?: string | null } | null> | null;
        workspaces?: Array<{
          __typename?: 'Workspace';
          providerAccount?: {
            __typename?: 'ProviderAccount';
            systemSuspend?: WorkspaceProviderSubAccountSuspendedReasonEnum | null;
            status?: WorkspaceProviderSubaccountStatusEnum | null;
          } | null;
        } | null> | null;
      } | null;
      subscription?: { __typename?: 'SubscriptionDetail'; status?: string | null; transactionDate?: any | null } | null;
      currentUserWorkspace?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        status?: UserWorkspaceStatusEnum | null;
        identity?: string | null;
        workspace?: {
          __typename?: 'Workspace';
          id?: number | null;
          logo?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type NumberReportAnalyticQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type NumberReportAnalyticQuery = {
  __typename?: 'Query';
  numberReportAnalytic?: {
    __typename?: 'NumberReportAnalyticResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'NumberReportAnalyticData';
      callType?: string | null;
      count?: number | null;
      percentage?: number | null;
    } | null> | null;
  } | null;
};

export type DashboardNumberAnalyticsQueryVariables = Exact<{
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type DashboardNumberAnalyticsQuery = {
  __typename?: 'Query';
  dashboardNumberAnalytics?: {
    __typename?: 'DashboardNumberAnalyticsResponse';
    message?: string | null;
    count?: number | null;
    edges?: Array<{
      __typename?: 'DashboardNumberAnalytic';
      id?: number | null;
      phoneNumber?: string | null;
      isActive?: boolean | null;
      totalCalls?: number | null;
      duration?: string | null;
      emergencyStatus?: EmergencyStatusEnum | null;
      channelName?: string | null;
      members?: Array<{
        __typename?: 'ChannelMember';
        id?: number | null;
        name?: string | null;
        profileUrl?: string | null;
      } | null> | null;
      teams?: Array<{ __typename?: 'Team'; id?: string | null; name?: string | null } | null> | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        name?: string | null;
        slug?: string | null;
        dialingCode?: string | null;
        alphaTwoCode?: string | null;
        alphaThreeCode?: string | null;
        numeric?: string | null;
        flag?: string | null;
      } | null;
      strategies?: Array<{ __typename?: 'ChannelStrategy'; strategySlug?: string | null } | null> | null;
    } | null> | null;
  } | null;
};

export type aiDashboardMemberPerformanceQueryVariables = Exact<{
  sentimentType: Scalars['String']['input'];
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type aiDashboardMemberPerformanceQuery = {
  __typename?: 'Query';
  aiDashboardMemberPerformance?: {
    __typename?: 'AIDashboardMemberPerformanceResponse';
    message?: string | null;
    count?: number | null;
    data?: Array<{
      __typename?: 'AIDashboardMemberPerformance';
      userName?: string | null;
      totalCallCount?: number | null;
      percentage?: number | null;
      userWorkspaceId?: number | null;
      transcribeCallCount?: number | null;
      transcribeSpecificSentimentCount?: number | null;
      averageDuration?: string | null;
    } | null> | null;
  } | null;
};

export type MemberDashboardReportAnalyticsQueryVariables = Exact<{
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type MemberDashboardReportAnalyticsQuery = {
  __typename?: 'Query';
  memberDashboardReportAnalytics?: {
    __typename?: 'MemberDashboardReportAnalyticsResponse';
    message?: string | null;
    count?: number | null;
    edges?: Array<{
      __typename?: 'MemberDashboardReportAnalytics';
      id?: number | null;
      role?: string | null;
      status?: string | null;
      isActive?: boolean | null;
      outbound?: number | null;
      missed?: number | null;
      inbound?: number | null;
      averageCallDuration?: string | null;
      totalCallDuration?: string | null;
      teams?: Array<{ __typename?: 'Team'; id?: string | null; name?: string | null } | null> | null;
      user?: {
        __typename?: 'Member';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        profileUrl?: string | null;
      } | null;
      channel?: Array<{
        __typename?: 'Channel';
        id?: number | null;
        friendlyName?: string | null;
        phoneNumber?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ChannelQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type ChannelQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'SingleChannel';
    message?: string | null;
    data?: {
      __typename?: 'Channel';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      numberType?: NumberTypeEnum | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        flag?: string | null;
        alphaTwoCode?: string | null;
      } | null;
    } | null;
  } | null;
};

export type NumberGraphReportAnalyticsQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
}>;

export type NumberGraphReportAnalyticsQuery = {
  __typename?: 'Query';
  numberGraphReportAnalytics?: {
    __typename?: 'NumberGraphReportAnalyticsResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'NumberGraphReportAnalyticsData';
      year?: string | null;
      month?: string | null;
      missed?: number | null;
      outbound?: number | null;
      inbound?: number | null;
      totalCalls?: number | null;
    } | null> | null;
  } | null;
};

export type DashboardReportAnalyticQueryVariables = Exact<{
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DashboardReportAnalyticQuery = {
  __typename?: 'Query';
  dashboardReportAnalytic?: {
    __typename?: 'DashboardReportAnalyticResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'DashboardReportAnalyticData';
      callType?: string | null;
      count?: number | null;
      percentage?: number | null;
    } | null> | null;
  } | null;
};

export type IndividualMemberDashboardReportAnalyticsQueryVariables = Exact<{
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  userWorkspaceId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type IndividualMemberDashboardReportAnalyticsQuery = {
  __typename?: 'Query';
  individualMemberDashboardReportAnalytics?: {
    __typename?: 'IndividualMemberDashboardReportAnalyticsResponse';
    message?: string | null;
    count?: number | null;
    edges?: Array<{
      __typename?: 'IndividualMemberDashboardReportAnalytics';
      id?: number | null;
      name?: string | null;
      phoneNumber?: string | null;
      callType?: string | null;
      callDate?: string | null;
      callDuration?: string | null;
    } | null> | null;
  } | null;
};

export type NumberAggregatedReportAnalyticsQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
}>;

export type NumberAggregatedReportAnalyticsQuery = {
  __typename?: 'Query';
  numberAggregatedReportAnalytics?: {
    __typename?: 'NumberAggregateReportAnalyticsResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'NumberAggregateReportAnalytics';
      key?: string | null;
      value?: {
        __typename?: 'NumberAggregateReportAnalyticsValue';
        callDuration?: string | null;
        percentage?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ChannelMembersQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type ChannelMembersQuery = {
  __typename?: 'Query';
  channelMembers?: {
    __typename?: 'ChannelUserWorkspaceMembersResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'MembersAssignedToChannel';
      name?: string | null;
      userId?: number | null;
      url?: string | null;
    } | null> | null;
  } | null;
};

export type IndividualNumberReportAnalyticsQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type IndividualNumberReportAnalyticsQuery = {
  __typename?: 'Query';
  individualNumberReportAnalytics?: {
    __typename?: 'IndividualNumberReportAnalyticsResponse';
    message?: string | null;
    count?: number | null;
    edges?: Array<{
      __typename?: 'IndividualNumberReportAnalyticsEdge';
      id?: number | null;
      name?: string | null;
      phoneNumber?: string | null;
      callDate?: string | null;
      callDuration?: string | null;
      callType?: string | null;
    } | null> | null;
  } | null;
};

export type aiAdvanceCallReportQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sentimentType?: InputMaybe<Scalars['String']['input']>;
  reasonType?: InputMaybe<Scalars['String']['input']>;
  conclusionType?: InputMaybe<Scalars['String']['input']>;
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  callType?: InputMaybe<Scalars['String']['input']>;
  callResolution?: InputMaybe<Scalars['String']['input']>;
}>;

export type aiAdvanceCallReportQuery = {
  __typename?: 'Query';
  aiAdvanceCallReport?: {
    __typename?: 'AIAdvanceCallReportResponse';
    message?: string | null;
    count?: number | null;
    edges?: Array<{
      __typename?: 'AIAdvanceCallReport';
      userName?: string | null;
      callDirection?: string | null;
      createdAt?: any | null;
      agentPhoneNumber?: string | null;
      callCount?: number | null;
      callRecordingId?: number | null;
      transcriptionId?: number | null;
      callRecordingUrl?: string | null;
      customerName?: string | null;
      customerPhoneNumber?: string | null;
    } | null> | null;
  } | null;
};

export type workspaceMembersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserWorkspaceStatusEnum>;
}>;

export type workspaceMembersQuery = {
  __typename?: 'Query';
  workspaceMembers?: {
    __typename?: 'PaginationMultipleWorkspaceMember';
    message?: string | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: number | null;
      startCursor?: string | null;
      hasPreviousPage?: boolean | null;
      hasNextPage?: boolean | null;
      endCursor?: string | null;
    } | null;
    edges?: Array<{
      __typename?: 'WorkspaceAuthEdge';
      node?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        status?: UserWorkspaceStatusEnum | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          profilePicture?: {
            __typename?: 'Media';
            id?: number | null;
            url?: string | null;
            originalname?: string | null;
            size?: number | null;
            key?: string | null;
            mimetype?: string | null;
          } | null;
        } | null;
        channels?: Array<{
          __typename?: 'Channel';
          phoneNumber?: string | null;
          id?: number | null;
          friendlyName?: string | null;
        } | null> | null;
        userWorkspaceRoles?: Array<{
          __typename?: 'UserWorkspaceRole';
          role?: { __typename?: 'Role'; level?: number | null; label?: string | null; id?: number | null } | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type AiDashboardCountQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
}>;

export type AiDashboardCountQuery = {
  __typename?: 'Query';
  aiDashboardCount?: {
    __typename?: 'AIDashboardCountResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'AIDashboardCount';
      sentiment?: string | null;
      totalCount?: number | null;
      percentage?: number | null;
    } | null> | null;
  } | null;
};

export type AiDashboardReportAnalyticsQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
}>;

export type AiDashboardReportAnalyticsQuery = {
  __typename?: 'Query';
  aiDashboardReportAnalytics?: {
    __typename?: 'AiDashboardReportAnalyticsResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'AiDashboardReportAnalytics';
      key?: string | null;
      value?: {
        __typename?: 'AiDashboardReportAnalyticsValue';
        count?: number | null;
        percentage?: number | null;
        duration?: string | null;
        label?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetTranscriptionInformationQueryVariables = Exact<{
  callRecordingId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetTranscriptionInformationQuery = {
  __typename?: 'Query';
  getTranscriptionInformation?: {
    __typename?: 'GetTranscriptionInformationResponse';
    message?: string | null;
    data?: {
      __typename?: 'GetTranscriptionInformationData';
      callSummary?: string | null;
      sentiment?: string | null;
      reason?: string | null;
      conclusion?: string | null;
      resolutions?: Array<string | null> | null;
      recommendations?: Array<string | null> | null;
      callRecordingUrl?: string | null;
      memberTalkTime?: string | null;
      customerTalkTime?: string | null;
      silenceTime?: string | null;
      totalTalkTime?: string | null;
      availableSentiments?: Array<string | null> | null;
      transcriptionText?: Array<{
        __typename?: 'TranscriptionText';
        content?: string | null;
        participantRole?: string | null;
        sentiment?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type AiDashboardDayWiseSentimentQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
}>;

export type AiDashboardDayWiseSentimentQuery = {
  __typename?: 'Query';
  aiDashboardDayWiseSentiment?: {
    __typename?: 'AIDashboardDayWiseSentimentResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'AIDashboardDayWiseSentiment';
      createdAt?: any | null;
      positiveSentimentCount?: number | null;
      negativeSentimentCount?: number | null;
      neutralSentimentCount?: number | null;
    } | null> | null;
  } | null;
};

export type AiDashboardMemberPerformanceGraphReportQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
}>;

export type AiDashboardMemberPerformanceGraphReportQuery = {
  __typename?: 'Query';
  aiDashboardMemberPerformanceGraphReport?: {
    __typename?: 'AiDashboardMemberPerformanceGraphReportResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'AiDashboardMemberPerformanceGraphReport';
      userId?: number | null;
      userName?: string | null;
      percentage?: number | null;
      totalCallCount?: number | null;
    } | null> | null;
  } | null;
};

export type WorkspaceMemberQueryVariables = Exact<{
  workspaceMemberId: Scalars['Int']['input'];
}>;

export type WorkspaceMemberQuery = {
  __typename?: 'Query';
  workspaceMember?: {
    __typename?: 'WorkspaceMember';
    message?: string | null;
    data?: {
      __typename?: 'UserWorkspace';
      id?: number | null;
      user?: {
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        email?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      userOnlineManagement?: {
        __typename?: 'UserOnlineManagement';
        isActive?: boolean | null;
        lastSeenAt?: any | null;
        activeStatus?: UserActiveStatusEnum | null;
        awayTill?: any | null;
        message?: string | null;
        icon?: string | null;
      } | null;
    } | null;
  } | null;
};

export type assignChannelsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type assignChannelsQuery = {
  __typename?: 'Query';
  assignChannels?: {
    __typename?: 'PaginationMultipleChannelUserWorkspace';
    message?: string | null;
    edges?: Array<{
      __typename?: 'ChannelUserWorkspaceEdge';
      node?: {
        __typename?: 'ChannelUserWorkspace';
        id?: number | null;
        isDefault?: boolean | null;
        channel?: {
          __typename?: 'Channel';
          id?: number | null;
          unreadCountChannel?: number | null;
          friendlyName?: string | null;
          phoneNumber?: string | null;
          identity?: string | null;
          muted?: boolean | null;
          a2pVerified?: boolean | null;
          setting?: {
            __typename?: 'ChannelSetting';
            id?: number | null;
            voicemail?: boolean | null;
            recording?: boolean | null;
          } | null;
          country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
        } | null;
        userWorkspace?: {
          __typename?: 'UserWorkspace';
          id?: number | null;
          status?: UserWorkspaceStatusEnum | null;
          user?: { __typename?: 'User'; id?: number | null; name?: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type RecentMessageConversationsQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  markAsClosed?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  voicemail?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<DirectionTypeEnum>;
  conversationStatus?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type RecentMessageConversationsQuery = {
  __typename?: 'Query';
  recentMessageConversations?: {
    __typename?: 'PaginationMultipleRecentMessageConversation';
    edges?: Array<{
      __typename?: 'RecentMessageConversationEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'RecentMessageConversation';
        id?: number | null;
        updatedAt?: any | null;
        unreadCountRecentMessage?: number | null;
        draftMessage?: string | null;
        markAsClosed?: boolean | null;
        channel?: { __typename?: 'Channel'; id?: number | null } | null;
        client?: {
          __typename?: 'Contact';
          id?: number | null;
          name?: string | null;
          phoneNumber?: string | null;
          country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
          profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
        } | null;
        messageConversation?: {
          __typename?: 'MessageConversation';
          id?: number | null;
          conversationType?: MessageConversationTypeEnum | null;
          conversationStatus?: string | null;
          direction?: DirectionTypeEnum | null;
          messageContent?: string | null;
          pinned?: boolean | null;
          voicemailRecordingUrl?: string | null;
        } | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfoTwilio';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      count?: number | null;
    } | null;
  } | null;
};

export type PlanPricesQueryVariables = Exact<{
  periodicity?: InputMaybe<PeriodicityEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type PlanPricesQuery = {
  __typename?: 'Query';
  planPrices?: {
    __typename?: 'PaginationPlanPrices';
    message?: string | null;
    edges?: Array<{
      __typename?: 'PlanPriceEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'PlanPrice';
        id?: number | null;
        amount?: number | null;
        periodicity?: PeriodicityEnum | null;
        isPublished?: boolean | null;
        rank?: number | null;
        position?: number | null;
        plan?: {
          __typename?: 'Plan';
          id?: number | null;
          label?: string | null;
          name?: string | null;
          slug?: string | null;
          shortDescription?: string | null;
          description?: string | null;
          features?: Array<string | null> | null;
          recommendation?: string | null;
          showAmount?: boolean | null;
        } | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      count?: number | null;
    } | null;
  } | null;
};

export type ContactByIdQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;

export type ContactByIdQuery = {
  __typename?: 'Query';
  contact?: {
    __typename?: 'SingleContact';
    message?: string | null;
    data?: {
      __typename?: 'Contact';
      id?: number | null;
      isBlocked?: boolean | null;
      name?: string | null;
      phoneNumber?: string | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
    } | null;
  } | null;
};

export type MarkConversationAsCloseOrOpenMutationVariables = Exact<{
  markAsCloseOrOpenId: Scalars['Int']['input'];
  input?: InputMaybe<InputMarkAsCloseOrOpen>;
}>;

export type MarkConversationAsCloseOrOpenMutation = {
  __typename?: 'Mutation';
  markAsCloseOrOpen?: { __typename?: 'Message'; message?: string | null } | null;
};

export type ChannelsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChannelsQuery = {
  __typename?: 'Query';
  channels?: {
    __typename: 'PaginationMultipleChannel';
    message?: string | null;
    pageInfo?: {
      __typename: 'PageInfoTwilio';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      count?: number | null;
    } | null;
    edges?: Array<{
      __typename: 'ChannelEdge';
      cursor?: string | null;
      node?: {
        __typename: 'Channel';
        id?: number | null;
        friendlyName?: string | null;
        phoneNumber?: string | null;
        identity?: string | null;
        emergencyStatus?: EmergencyStatusEnum | null;
        beta?: boolean | null;
        country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
        capability?: { __typename: 'ChannelCapability'; voice?: boolean | null } | null;
        channelUserWorkspaces?: Array<{
          __typename: 'ChannelUserWorkspace';
          id?: number | null;
          userWorkspace?: {
            __typename: 'UserWorkspace';
            id?: number | null;
            status?: UserWorkspaceStatusEnum | null;
            user?: {
              __typename: 'User';
              id?: number | null;
              name?: string | null;
              profilePicture?: {
                __typename: 'Media';
                id?: number | null;
                url?: string | null;
                originalname?: string | null;
                size?: number | null;
                key?: string | null;
                mimetype?: string | null;
              } | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type RegulatoryCompliancesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type RegulatoryCompliancesQuery = {
  __typename?: 'Query';
  regulatoryCompliances?: {
    __typename: 'PaginationMultipleRegulatoryCompliance';
    message?: string | null;
    pageInfo?: {
      __typename: 'PageInfoTwilio';
      count?: number | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
    } | null;
    edges?: Array<{
      __typename: 'RegulatoryComplianceEdge';
      cursor?: string | null;
      node?: {
        __typename: 'RegulatoryCompliance';
        id?: number | null;
        createdAt?: any | null;
        updatedAt?: any | null;
        numberType?: NumberTypeEnum | null;
        status?: RegulatoryComplianceStatusEnum | null;
        country?: {
          __typename: 'Country';
          id?: number | null;
          name?: string | null;
          flag?: string | null;
          alphaTwoCode?: string | null;
        } | null;
        channelRequested?: {
          __typename: 'TwilioPhoneNumber';
          addressRequirements?: string | null;
          isoCountry?: string | null;
          phoneNumber?: string | null;
          friendlyName?: string | null;
          region?: string | null;
          rateCenter?: string | null;
          numberType?: NumberTypeEnum | null;
          basePrice?: string | null;
          currentPrice?: string | null;
          supportingDocument?: boolean | null;
          endUser?: boolean | null;
          capabilities?: {
            __typename: 'TwilioCapability';
            voice?: boolean | null;
            SMS?: boolean | null;
            MMS?: boolean | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type InProcessPhoneNumbersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type InProcessPhoneNumbersQuery = {
  __typename?: 'Query';
  inProcessPhoneNumbers?: {
    __typename: 'PaginationMultiplePhoneNumbers';
    message?: string | null;
    pageInfo?: {
      __typename: 'PageInfoTwilio';
      count?: number | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
    } | null;
    edges?: Array<{
      __typename: 'PhoneNumberEdge';
      cursor?: string | null;
      node?: {
        __typename: 'PhoneNumber';
        id?: number | null;
        status?: PhoneNumberStatusEnum | null;
        country?: {
          __typename?: 'Country';
          id?: number | null;
          name?: string | null;
          flag?: string | null;
          alphaTwoCode?: string | null;
        } | null;
        meta?: {
          __typename: 'TwilioPhoneNumber';
          phoneNumber?: string | null;
          isoCountry?: string | null;
          friendlyName?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type availablePhoneNumbersQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  numberType?: InputMaybe<NumberTypeEnum>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  voiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  faxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeAllAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLocalAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeForeignAddressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  beta?: InputMaybe<Scalars['Boolean']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  areaCode?: InputMaybe<Scalars['Int']['input']>;
  inLocality?: InputMaybe<Scalars['String']['input']>;
}>;

export type availablePhoneNumbersQuery = {
  __typename?: 'Query';
  availablePhoneNumbers?: {
    __typename?: 'TwilioAvailablePhoneNumber';
    message?: string | null;
    edges?: Array<{
      __typename?: 'TwilioPhoneNumber';
      addressRequirements?: string | null;
      isoCountry?: string | null;
      phoneNumber?: string | null;
      friendlyName?: string | null;
      region?: string | null;
      rateCenter?: string | null;
      numberType?: NumberTypeEnum | null;
      basePrice?: string | null;
      currentPrice?: string | null;
      supportingDocument?: boolean | null;
      endUser?: boolean | null;
      capabilities?: {
        __typename?: 'TwilioCapability';
        voice?: boolean | null;
        SMS?: boolean | null;
        MMS?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetContactByPhoneNumberQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;

export type GetContactByPhoneNumberQuery = {
  __typename?: 'Query';
  getContactByPhoneNumber?: {
    __typename?: 'SingleContact';
    message?: string | null;
    data?: {
      __typename?: 'Contact';
      address?: string | null;
      companyName?: string | null;
      email?: string | null;
      id?: number | null;
      isBlocked?: boolean | null;
      isPublished?: boolean | null;
      name?: string | null;
      phoneNumber?: string | null;
      timeZone?: string | null;
      website?: string | null;
      blockedBy?: { __typename?: 'User'; name?: string | null; phoneNumber?: string | null; id?: number | null } | null;
      country?: { __typename?: 'Country'; id?: number | null; name?: string | null; flag?: string | null } | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      tags?: Array<{
        __typename?: 'Tag';
        id?: number | null;
        label?: string | null;
        color?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type TeamsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type TeamsQuery = {
  __typename?: 'Query';
  teams?: {
    __typename?: 'PaginationTeams';
    message?: string | null;
    pageInfo?: { __typename?: 'PageInfo'; count?: number | null } | null;
    edges?: Array<{
      __typename?: 'TeamEdge';
      node?: {
        __typename?: 'TeamsInterface';
        id?: string | null;
        name?: string | null;
        status?: StatusEnum | null;
        totalMembers?: number | null;
        teamMembers?: Array<{
          __typename?: 'TeamMembersInterface';
          status?: StatusEnum | null;
          userId?: number | null;
          user?: {
            __typename?: 'User';
            name?: string | null;
            id?: number | null;
            profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type WorkspaceMembersListQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<InputMaybe<OrderByInput>> | InputMaybe<OrderByInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type WorkspaceMembersListQuery = {
  __typename?: 'Query';
  accepted?: {
    __typename?: 'PaginationMultipleWorkspaceMember';
    message?: string | null;
    edges?: Array<{
      __typename?: 'WorkspaceAuthEdge';
      node?: {
        __typename?: 'UserWorkspace';
        id?: number | null;
        identity?: string | null;
        user?: {
          __typename?: 'User';
          phoneNumber?: string | null;
          name?: string | null;
          id?: number | null;
          email?: string | null;
          profilePicture?: {
            __typename?: 'Media';
            id?: number | null;
            url?: string | null;
            originalname?: string | null;
            size?: number | null;
            key?: string | null;
            mimetype?: string | null;
          } | null;
        } | null;
        userOnlineManagement?: {
          __typename?: 'UserOnlineManagement';
          isActive?: boolean | null;
          lastSeenAt?: any | null;
          activeStatus?: UserActiveStatusEnum | null;
          awayTill?: any | null;
          message?: string | null;
          icon?: string | null;
        } | null;
        userWorkspaceRoles?: Array<{
          __typename?: 'UserWorkspaceRole';
          role?: { __typename?: 'Role'; label?: string | null } | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TeamMembersQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type TeamMembersQuery = {
  __typename?: 'Query';
  teamMembers?: {
    __typename?: 'PaginationTeamMembers';
    message?: string | null;
    edges?: Array<{
      __typename?: 'TeamMemberEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'TeamMembersInterface';
        userId?: number | null;
        workspacesId?: number | null;
        teamId?: string | null;
        status?: StatusEnum | null;
        id?: number | null;
        user?: {
          __typename?: 'User';
          id?: number | null;
          name?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          address?: string | null;
          dueIn?: string | null;
          accountStatus?: boolean | null;
          timezone?: string | null;
          averageRiskScore?: number | null;
          totalMonthlyFee?: number | null;
          language?: string | null;
          profilePicture?: {
            __typename?: 'Media';
            id?: number | null;
            url?: string | null;
            originalname?: string | null;
            size?: number | null;
            key?: string | null;
            mimetype?: string | null;
            createdAt?: any | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      count?: number | null;
    } | null;
  } | null;
};

export type GetBlockedContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type GetBlockedContactsQuery = {
  __typename?: 'Query';
  getBlockedContacts?: {
    __typename?: 'PaginationBlockedContact';
    message?: string | null;
    pageInfo?: {
      __typename?: 'PageInfoTwilio';
      count?: number | null;
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    edges?: Array<{
      __typename?: 'ContactEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'Contact';
        timeZone?: string | null;
        blockedOn?: any | null;
        blockReason?: string | null;
        id?: number | null;
        phoneNumber?: string | null;
        name?: string | null;
        isBlocked?: boolean | null;
        isPublished?: boolean | null;
        profilePicture?: { __typename?: 'Media'; url?: string | null } | null;
        blockedBy?: { __typename?: 'User'; name?: string | null } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ActiveWorkspacesQueryVariables = Exact<{ [key: string]: never }>;

export type ActiveWorkspacesQuery = {
  __typename?: 'Query';
  activeWorkspaces?: {
    __typename?: 'MultipleWorkspace';
    message?: string | null;
    edges?: Array<{
      __typename?: 'Workspace';
      kycVerified?: boolean | null;
      hasCompleted?: boolean | null;
      active?: boolean | null;
      id?: number | null;
      label?: string | null;
      isCurrent?: boolean | null;
      status?: WorkspaceStatusEnum | null;
      unreadCountWorkspace?: number | null;
      pkReference?: string | null;
      workspaceDetails?: {
        __typename?: 'WorkspaceDetail';
        planPrice?: { __typename?: 'PlanPrice'; amount?: number | null } | null;
      } | null;
      logo?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
    } | null> | null;
  } | null;
};

export type ProviderLoginQueryVariables = Exact<{ [key: string]: never }>;

export type ProviderLoginQuery = {
  __typename?: 'Query';
  providerLogin?: {
    __typename?: 'ProviderLogin';
    message?: string | null;
    data?: {
      __typename?: 'ProviderToken';
      token?: { __typename?: 'AccessToken'; access?: string | null } | null;
    } | null;
  } | null;
};

export type CommandResponsesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type CommandResponsesQuery = {
  __typename?: 'Query';
  commandResponses?: {
    __typename?: 'PaginationMultipleCommandResponse';
    message?: string | null;
    edges?: Array<{
      __typename?: 'CommandResponseEdge';
      node?: {
        __typename?: 'CommandResponse';
        command?: string | null;
        content?: string | null;
        id?: number | null;
        title?: string | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfoTwilio';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      count?: number | null;
    } | null;
  } | null;
};

export type VerifyPromoCodeQueryVariables = Exact<{
  input: InputVerifyPromoCode;
}>;

export type VerifyPromoCodeQuery = {
  __typename?: 'Query';
  verifyPromoCode?: {
    __typename?: 'VerifyPromoCodeResponse';
    message?: string | null;
    data?: {
      __typename?: 'VerifyPromoCodeData';
      isValid?: boolean | null;
      discountAmount?: number | null;
      discountPercentage?: number | null;
      discountType?: CouponDiscountTypeEnum | null;
    } | null;
  } | null;
};

export type InvoicesQueryVariables = Exact<{ [key: string]: never }>;

export type InvoicesQuery = {
  __typename?: 'Query';
  invoices?: {
    __typename?: 'InvoicesResponse';
    message?: string | null;
    edges?: Array<{
      __typename?: 'InvoiceEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'Invoice';
        id?: number | null;
        type?: string | null;
        status?: InvoiceStatusEnum | null;
        totalAmount?: number | null;
        invoiceNo?: string | null;
        transactionId?: string | null;
        transactionDate?: any | null;
        billingCycleDate?: any | null;
        currency?: string | null;
        creditsApplied?: number | null;
        subTotalAmount?: number | null;
        discountPercentage?: number | null;
        discountAmount?: number | null;
        invoiceItems?: Array<{
          __typename?: 'InvoiceItem';
          id?: number | null;
          invoiceId?: number | null;
          amount?: number | null;
          quantity?: number | null;
          remarks?: string | null;
          numberType?: NumberTypeEnum | null;
          country?: {
            __typename?: 'Country';
            id?: number | null;
            name?: string | null;
            slug?: string | null;
            dialingCode?: string | null;
            alphaTwoCode?: string | null;
            alphaThreeCode?: string | null;
            numeric?: string | null;
            flag?: string | null;
          } | null;
        } | null> | null;
        customer?: {
          __typename?: 'Customer';
          email?: string | null;
          billingAddress?: {
            __typename?: 'BillingAddress';
            first_name?: string | null;
            last_name?: string | null;
            company?: string | null;
            phone?: string | null;
            line1?: string | null;
            line2?: string | null;
            city?: string | null;
            state?: string | null;
            country?: string | null;
            zip?: string | null;
          } | null;
        } | null;
        paymentMode?: {
          __typename?: 'Card';
          firstName?: string | null;
          lastName?: string | null;
          last4?: string | null;
          expiryMonth?: number | null;
          expiryYear?: number | null;
          brand?: string | null;
        } | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      count?: number | null;
    } | null;
  } | null;
};

export type ContactNotesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type ContactNotesQuery = {
  __typename?: 'Query';
  contactNotes?: {
    __typename?: 'PaginationMultipleContactNote';
    message?: string | null;
    pageInfo?: {
      __typename?: 'PageInfoTwilio';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      count?: number | null;
    } | null;
    edges?: Array<{
      __typename?: 'ContactNoteEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'ContactNote';
        id?: number | null;
        description?: string | null;
        createdAt?: any | null;
        updatedAt?: any | null;
        updatedBy?: {
          __typename?: 'UserWorkspace';
          id?: number | null;
          user?: {
            __typename?: 'User';
            id?: number | null;
            name?: string | null;
            profilePicture?: { __typename?: 'Media'; url?: string | null } | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ValidateActivationCodeQueryVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;

export type ValidateActivationCodeQuery = {
  __typename?: 'Query';
  validateActivationCode?: {
    __typename?: 'validateActivationCodeResponse';
    message?: string | null;
    data?: {
      __typename?: 'CustomPlan';
      id?: number | null;
      email?: string | null;
      code?: string | null;
      billingPlanPricesId?: number | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      deletedAt?: any | null;
      expiresAt?: any | null;
      usedAt?: any | null;
      billingPlanPrices?: {
        __typename?: 'PlanPrice';
        id?: number | null;
        amount?: number | null;
        periodicity?: PeriodicityEnum | null;
        isPublished?: boolean | null;
        position?: number | null;
        rank?: number | null;
        plan?: {
          __typename?: 'Plan';
          id?: number | null;
          label?: string | null;
          name?: string | null;
          slug?: string | null;
          shortDescription?: string | null;
          description?: string | null;
          features?: Array<string | null> | null;
          recommendation?: string | null;
          showAmount?: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type TagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type TagsQuery = {
  __typename?: 'Query';
  tags?: {
    __typename?: 'PaginationMultipleTag';
    message?: string | null;
    pageInfo?: {
      __typename?: 'PageInfoTwilio';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      count?: number | null;
    } | null;
    edges?: Array<{
      __typename?: 'TagEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'Tag';
        id?: number | null;
        label?: string | null;
        slug?: string | null;
        type?: TagEnum | null;
        color?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ContactTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type ContactTagsQuery = {
  __typename?: 'Query';
  contactTags?: {
    __typename?: 'PaginationMultipleContactTag';
    message?: string | null;
    pageInfo?: {
      __typename?: 'PageInfoTwilio';
      count?: number | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
    } | null;
    edges?: Array<{
      __typename?: 'ContactTagEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'ContactTag';
        id?: number | null;
        contactId?: number | null;
        tags?: {
          __typename?: 'Tag';
          id?: number | null;
          label?: string | null;
          slug?: string | null;
          type?: TagEnum | null;
          color?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetAssignedChannelsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetAssignedChannelsCountQuery = {
  __typename?: 'Query';
  getAssignedChannelsCount?: { __typename?: 'CountResponse'; message?: string | null; count?: number | null } | null;
};

export type ContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  nameStartsWith?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ContactsQuery = {
  __typename?: 'Query';
  contacts?: {
    __typename?: 'PaginationMultipleContact';
    message?: string | null;
    edges?: Array<{
      __typename?: 'ContactEdge';
      cursor?: string | null;
      node?: {
        __typename?: 'Contact';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
        } | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfoTwilio';
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      startCursor?: string | null;
    } | null;
  } | null;
};

export type ContactQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;

export type ContactQuery = {
  __typename?: 'Query';
  contact?: {
    __typename?: 'SingleContact';
    message?: string | null;
    data?: {
      __typename?: 'Contact';
      id?: number | null;
      name?: string | null;
      phoneNumber?: string | null;
      email?: string | null;
      address?: string | null;
      website?: string | null;
      companyName?: string | null;
      timeZone?: string | null;
      sourceType?: string | null;
      profilePicture?: {
        __typename?: 'Media';
        id?: number | null;
        url?: string | null;
        originalname?: string | null;
      } | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null; name?: string | null } | null;
    } | null;
  } | null;
};

export type ListPaymentSourceQueryVariables = Exact<{ [key: string]: never }>;

export type ListPaymentSourceQuery = {
  __typename?: 'Query';
  listPaymentSource?: {
    __typename?: 'PaymentSourcesResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'PaymentSource';
      id?: string | null;
      referenceId?: string | null;
      isPrimary?: boolean | null;
      isSecondary?: boolean | null;
      gatewayAccountId?: string | null;
      paymentGateway?: PaymentGatewayEnum | null;
      status?: PaymentSourceStatusEnum | null;
      card?: {
        __typename?: 'Card';
        firstName?: string | null;
        lastName?: string | null;
        last4?: string | null;
        expiryMonth?: number | null;
        expiryYear?: number | null;
        brand?: string | null;
      } | null;
      paypal?: { __typename?: 'Paypal'; email?: string | null } | null;
    } | null> | null;
  } | null;
};

export type CustomerBillingAddressQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerBillingAddressQuery = {
  __typename?: 'Query';
  customerBillingAddress?: {
    __typename?: 'CustomerBillingAddressResponse';
    message?: string | null;
    data?: {
      __typename?: 'BillingInfo';
      vatNumber?: string | null;
      billingAddress?: {
        __typename?: 'BillingAddress';
        first_name?: string | null;
        last_name?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        line1?: string | null;
        line2?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        zip?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ListSubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type ListSubscriptionQuery = {
  __typename?: 'Query';
  listSubscription?: {
    __typename?: 'PlanSubscriptionsResponse';
    message?: string | null;
    edges?: Array<{
      __typename?: 'PlanSubscription';
      id?: string | null;
      customerId?: string | null;
      status?: string | null;
      currentTermEnd?: any | null;
      nextBillingAt?: number | null;
      createdAt?: any | null;
      cancelledAt?: any | null;
      updatedAt?: any | null;
      deleted?: boolean | null;
      cancelScheduleCreatedAt?: number | null;
      mrr?: number | null;
      itemCount?: number | null;
      itemProductFamily?: string | null;
      billingPeriodUnit?: string | null;
      remainingBillingCycles?: number | null;
      hasScheduledChanges?: boolean | null;
      discountItems?: Array<{
        __typename?: 'DiscountResponse';
        discountType?: string | null;
        discountAmount?: number | null;
        discountPercentage?: number | null;
      } | null> | null;
      subscriptionItems?: Array<{
        __typename?: 'PlanSubscriptionItem';
        itemPriceId?: string | null;
        itemType?: string | null;
        quantity?: number | null;
        unitPrice?: number | null;
        amount?: number | null;
      } | null> | null;
      scheduledChanges?: {
        __typename?: 'SubscriptionScheduledChanges';
        id?: string | null;
        billingPeriodUnit?: string | null;
        remainingBillingCycles?: number | null;
        customerId?: string | null;
        status?: string | null;
        currentTermEnd?: number | null;
        nextBillingAt?: number | null;
        createdAt?: number | null;
        cancelledAt?: number | null;
        updatedAt?: number | null;
        cancelScheduleCreatedAt?: number | null;
        deleted?: boolean | null;
        currencyCode?: string | null;
        mrr?: number | null;
        itemProductFamily?: string | null;
        itemCount?: number | null;
        subscriptionItems?: Array<{
          __typename?: 'PlanSubscriptionItem';
          itemPriceId?: string | null;
          itemType?: string | null;
          quantity?: number | null;
          unitPrice?: number | null;
          amount?: number | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type FetchJournalEntriesQueryVariables = Exact<{
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  debit?: InputMaybe<Scalars['Boolean']['input']>;
  chargeType?: InputMaybe<Array<InputMaybe<ChargeTypeEnum>> | InputMaybe<ChargeTypeEnum>>;
  messageConversationDirection?: InputMaybe<Array<InputMaybe<DirectionTypeEnum>> | InputMaybe<DirectionTypeEnum>>;
  usageType?: InputMaybe<Array<InputMaybe<UsageTypeEnum>> | InputMaybe<UsageTypeEnum>>;
}>;

export type FetchJournalEntriesQuery = {
  __typename?: 'Query';
  fetchJournalEntries?: {
    __typename?: 'FetchUserStatementResponse';
    data?: Array<{
      __typename?: 'UserWalletUsageDetails';
      balance?: number | null;
      creditAmount?: number | null;
      currencyCode?: string | null;
      debitAmount?: number | null;
      duration?: number | null;
      from?: string | null;
      id?: number | null;
      remarks?: string | null;
      to?: string | null;
      transactionDate?: any | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type GetAutoRechargeConfigsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAutoRechargeConfigsQuery = {
  __typename?: 'Query';
  getAutoRechargeConfigs?: {
    __typename?: 'AutoRechargeConfigResponse';
    message?: string | null;
    data?: {
      __typename?: 'AutoRechargeConfig';
      enabled?: boolean | null;
      creditThreshold?: number | null;
      credit?: number | null;
      targetBalance?: number | null;
      isDisableAllowed?: boolean | null;
    } | null;
  } | null;
};

export type GetLowBalanceAlertQueryVariables = Exact<{ [key: string]: never }>;

export type GetLowBalanceAlertQuery = {
  __typename?: 'Query';
  getLowBalanceAlert?: {
    __typename?: 'SingleLowBalanceAlert';
    message?: string | null;
    data?: { __typename?: 'LowBalanceAlert'; isEmail?: boolean | null; balanceThreshold?: number | null } | null;
  } | null;
};

export type ObtainNotificationCountQueryVariables = Exact<{ [key: string]: never }>;

export type ObtainNotificationCountQuery = {
  __typename?: 'Query';
  obtainNotificationCount?: { __typename?: 'NotificationCountResponse'; data?: any | null } | null;
};

export type SearchMessageConversationsQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEnum>;
  direction?: InputMaybe<CursorDirectionEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type SearchMessageConversationsQuery = {
  __typename?: 'Query';
  searchMessageConversations?: {
    __typename?: 'SearchMessageConversations';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'MessageConversationSearch';
      id?: number | null;
      cursor?: string | null;
    } | null> | null;
  } | null;
};

export type GetContactsCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Array<InputMaybe<ContactSourceTypeEnum>> | InputMaybe<ContactSourceTypeEnum>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;

export type GetContactsCountQuery = {
  __typename?: 'Query';
  getContactsCount?: { __typename?: 'CountResponse'; count?: number | null; message?: string | null } | null;
};

export type CountMessageConversationsQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
  query: Scalars['String']['input'];
}>;

export type CountMessageConversationsQuery = {
  __typename?: 'Query';
  countSearchMessageConversations?: { __typename?: 'MessageConversationCount'; count?: number | null } | null;
};

export type ContactSourceTypesQueryVariables = Exact<{ [key: string]: never }>;

export type ContactSourceTypesQuery = {
  __typename?: 'Query';
  contactSourceTypes?: {
    __typename?: 'ContactSourceTypeResponse';
    message?: string | null;
    data?: Array<{ __typename?: 'SourceType'; sourceType?: string | null } | null> | null;
  } | null;
};

export type CheckMemberEmailExistQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type CheckMemberEmailExistQuery = {
  __typename?: 'Query';
  checkMemberEmailExist?: {
    __typename?: 'CheckMemberEmailExistResponse';
    message?: string | null;
    data?: { __typename?: 'CheckMemberExist'; exists?: boolean | null } | null;
  } | null;
};

export type ExportJournalEntriesQueryVariables = Exact<{
  transactionDateFrom: Scalars['Date']['input'];
  transactionDateTo: Scalars['Date']['input'];
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  chargeType?: InputMaybe<Array<InputMaybe<ChargeTypeEnum>> | InputMaybe<ChargeTypeEnum>>;
  messageConversationDirection?: InputMaybe<Array<InputMaybe<DirectionTypeEnum>> | InputMaybe<DirectionTypeEnum>>;
  usageType?: InputMaybe<Array<InputMaybe<UsageTypeEnum>> | InputMaybe<UsageTypeEnum>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type ExportJournalEntriesQuery = {
  __typename?: 'Query';
  exportJournalEntries?: { __typename?: 'Message'; message?: string | null } | null;
};

export type FetchSingleRecentMessageConversationQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchSingleRecentMessageConversationQuery = {
  __typename?: 'Query';
  fetchSingleRecentMessageConversation?: {
    __typename?: 'ConversationDetailResponse';
    data?: {
      __typename?: 'RecentMessageConversation';
      id?: number | null;
      client?: { __typename?: 'Contact'; id?: number | null } | null;
    } | null;
  } | null;
};

export type CountPinnedMessageConversationsQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
}>;

export type CountPinnedMessageConversationsQuery = {
  __typename?: 'Query';
  countPinnedMessageConversations?: { __typename?: 'PinnedMessageConversationCount'; count?: number | null } | null;
};

export type GetMemberRoomQueryVariables = Exact<{
  input: InputRoom;
}>;

export type GetMemberRoomQuery = {
  __typename?: 'Query';
  getMemberRoom?: {
    __typename?: 'SingleRoom';
    message?: string | null;
    data?: {
      __typename?: 'Room';
      id?: number | null;
      label?: string | null;
      identity?: string | null;
      type?: RoomTypeEnum | null;
      isPublic?: boolean | null;
    } | null;
  } | null;
};

export type CountSearchChatMessagesQueryVariables = Exact<{
  roomId: Scalars['Int']['input'];
  query: Scalars['String']['input'];
}>;

export type CountSearchChatMessagesQuery = {
  __typename?: 'Query';
  countSearchChatMessages?: { __typename?: 'SearchChatMessagesCount'; count?: number | null } | null;
};

export type CountPinnedChatMessagesQueryVariables = Exact<{
  roomId: Scalars['Int']['input'];
}>;

export type CountPinnedChatMessagesQuery = {
  __typename?: 'Query';
  countPinnedChatMessages?: {
    __typename?: 'CountPinnedChatMessagesResponse';
    count?: number | null;
    message?: string | null;
  } | null;
};

export type SearchChatMessagesQueryVariables = Exact<{
  roomId: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchChatMessagesQuery = {
  __typename?: 'Query';
  searchChatMessages?: {
    __typename?: 'SearchChatMessagesResponse';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{ __typename?: 'SearchChatMessages'; id?: number | null; cursor?: string | null } | null> | null;
  } | null;
};

export type CountTeamsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type CountTeamsQuery = {
  __typename?: 'Query';
  countTeams?: { __typename?: 'TeamsCountResponse'; count: number; message?: string | null } | null;
};

export type ActiveWorkspacesV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
}>;

export type ActiveWorkspacesV2Query = {
  __typename?: 'Query';
  activeWorkspacesV2?: {
    __typename?: 'CursorPaginationActiveWorkspaces';
    cursor?: {
      __typename?: 'Cursor';
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
    } | null;
    data?: Array<{
      __typename?: 'Workspace';
      active?: boolean | null;
      availableBalance?: number | null;
      id?: number | null;
      isCurrent?: boolean | null;
      label?: string | null;
      numberOfUsers?: number | null;
      status?: WorkspaceStatusEnum | null;
      unreadCountWorkspace?: number | null;
      logo?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
      owner?: {
        __typename?: 'User';
        accountStatus?: boolean | null;
        id?: number | null;
        lastPasswordResetAt?: any | null;
        name?: string | null;
        coverProfilePicture?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
        roles?: Array<{
          __typename?: 'Role';
          id?: number | null;
          isActive?: boolean | null;
          label?: string | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CountMembersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type CountMembersQuery = {
  __typename?: 'Query';
  countMembers?: {
    __typename?: 'WorkspaceMemberV2CountResponse';
    message?: string | null;
    data?: Array<{ __typename?: 'WorkspaceMemberCountItem'; key?: string | null; value?: number | null } | null> | null;
  } | null;
};

export type MessageAttachmentsQueryVariables = Exact<{
  friendlyName: Scalars['String']['input'];
}>;

export type MessageAttachmentsQuery = {
  __typename?: 'Query';
  messageAttachments?: {
    __typename?: 'MultipleMessageAttachment';
    message?: string | null;
    data?: Array<{
      __typename?: 'MessageAttachment';
      id?: number | null;
      identity?: string | null;
      mimetype?: string | null;
      url?: string | null;
    } | null> | null;
  } | null;
};

export type draftMessageQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
}>;

export type draftMessageQuery = {
  __typename?: 'Query';
  draftMessage?: {
    __typename?: 'SingleDraftMessageConversation';
    message?: string | null;
    data?: {
      __typename?: 'DraftMessageConversation';
      id?: number | null;
      messageContent?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      medias?: Array<{
        __typename?: 'Media';
        id?: number | null;
        url?: string | null;
        mimetype?: string | null;
        size?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type InvoicesV2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatusEnum>;
  transactionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  transactionDateTo?: InputMaybe<Scalars['Date']['input']>;
}>;

export type InvoicesV2Query = {
  __typename?: 'Query';
  invoicesV2?: {
    __typename?: 'CursorPaginationInvoices';
    message?: string | null;
    data?: Array<{
      __typename?: 'Invoice';
      id?: number | null;
      type?: string | null;
      status?: InvoiceStatusEnum | null;
      totalAmount?: number | null;
      invoiceNo?: string | null;
      transactionId?: string | null;
      transactionDate?: any | null;
      billingCycleDate?: any | null;
      currency?: string | null;
      creditsApplied?: number | null;
      subTotalAmount?: number | null;
      discountPercentage?: number | null;
      discountAmount?: number | null;
      totalRefundedAmount?: number | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type InvoiceQueryVariables = Exact<{
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type InvoiceQuery = {
  __typename?: 'Query';
  invoice?: {
    __typename?: 'InvoiceResponse';
    message?: string | null;
    data?: {
      __typename?: 'Invoice';
      id?: number | null;
      invoiceNo?: string | null;
      status?: InvoiceStatusEnum | null;
      transactionDate?: any | null;
      transactionId?: string | null;
      type?: string | null;
      billingCycleDate?: any | null;
      currency?: string | null;
      totalAmount?: number | null;
      subTotalAmount?: number | null;
      creditsApplied?: number | null;
      discountPercentage?: number | null;
      discountAmount?: number | null;
      customer?: {
        __typename?: 'Customer';
        email?: string | null;
        vatNumber?: string | null;
        billingAddress?: {
          __typename?: 'BillingAddress';
          city?: string | null;
          company?: string | null;
          country?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          state?: string | null;
          phone?: string | null;
        } | null;
      } | null;
      invoiceItems?: Array<{
        __typename?: 'InvoiceItem';
        id?: number | null;
        amount?: number | null;
        invoiceId?: number | null;
        quantity?: number | null;
        remarks?: string | null;
        numberType?: NumberTypeEnum | null;
        phoneNumbers?: Array<string | null> | null;
        meta?: any | null;
        country?: { __typename?: 'Country'; name?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetUserOnlineStatusQueryVariables = Exact<{
  userWorkspaceId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetUserOnlineStatusQuery = {
  __typename?: 'Query';
  getUserOnlineStatus?: {
    __typename?: 'UserOnlineManagementResponse';
    data?: {
      __typename?: 'UserActiveStatus';
      activeStatus?: UserActiveStatusEnum | null;
      awaySet?: any | null;
      awayTill?: any | null;
      icon?: string | null;
      message?: string | null;
    } | null;
  } | null;
};

export type CartsQueryVariables = Exact<{ [key: string]: never }>;

export type CartsQuery = {
  __typename?: 'Query';
  carts?: {
    __typename?: 'MultipleCart';
    message?: string | null;
    data?: Array<{
      __typename?: 'TwilioPhoneNumber';
      addressRequirements?: string | null;
      isoCountry?: string | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      region?: string | null;
      rateCenter?: string | null;
      endUser?: boolean | null;
      supportingDocument?: boolean | null;
      currentPrice?: string | null;
      basePrice?: string | null;
      numberType?: NumberTypeEnum | null;
      capabilities?: {
        __typename?: 'TwilioCapability';
        voice?: boolean | null;
        SMS?: boolean | null;
        MMS?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CheckRegulatoryComplianceQueryVariables = Exact<{
  isoCountry: Scalars['String']['input'];
  numberType: NumberTypeEnum;
  addressRequirements: Scalars['String']['input'];
}>;

export type CheckRegulatoryComplianceQuery = {
  __typename?: 'Query';
  checkRegulatoryCompliance?: {
    __typename?: 'SingleCheckRegulatoryCompliance';
    message?: string | null;
    data?: {
      __typename?: 'CheckRegulatoryCompliance';
      regulatoryCompliance?: boolean | null;
      approvedRegulatoryCompliance?: {
        __typename?: 'ApprovedRegulatoryCompliance';
        identity?: boolean | null;
        address?: boolean | null;
        endUserTypes?: Array<RegulatoryComplianceUseCaseEnum | null> | null;
      } | null;
      requiredRegulatoryCompliance?: {
        __typename?: 'ApprovedRegulatoryCompliance';
        identity?: boolean | null;
        address?: boolean | null;
        endUserTypes?: Array<RegulatoryComplianceUseCaseEnum | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CheckConfigurationAndRewardOfChannelQueryVariables = Exact<{ [key: string]: never }>;

export type CheckConfigurationAndRewardOfChannelQuery = {
  __typename?: 'Query';
  checkConfigurationAndRewardOfChannel?: {
    __typename?: 'CheckConfigurationAndRewardOfChannelResponse';
    message?: string | null;
    data?: {
      __typename?: 'CheckConfigurationAndRewardOfChannelData';
      availableRewardCount: number;
      requiresDisposition: boolean;
    } | null;
  } | null;
};

export type IntegrationQueryVariables = Exact<{
  integrationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type IntegrationQuery = {
  __typename?: 'Query';
  integration?: {
    __typename?: 'IntegrationResponse';
    message?: string | null;
    data?: {
      __typename?: 'Integration';
      id?: number | null;
      name?: string | null;
      description?: string | null;
      domain?: string | null;
      logoUrl?: string | null;
      label?: string | null;
      integrationUser?: {
        __typename?: 'IntegrationUser';
        id?: number | null;
        status?: IntegrationUserStatusEnum | null;
      } | null;
    } | null;
  } | null;
};

export type GetPaymentRequestTokenQueryVariables = Exact<{
  invoiceId: Scalars['Int']['input'];
}>;

export type GetPaymentRequestTokenQuery = {
  __typename?: 'Query';
  getPaymentRequestToken?: {
    __typename?: 'FetchUrlTokenForPayment';
    message?: string | null;
    data?: { __typename?: 'PaymentRequest'; urlToken?: string | null } | null;
  } | null;
};

export type IntegrationCountQueryVariables = Exact<{ [key: string]: never }>;

export type IntegrationCountQuery = {
  __typename?: 'Query';
  integrationCount?: {
    __typename?: 'IntegrationCountResponse';
    message?: string | null;
    data?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
  } | null;
};

export type GetMemberSubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type GetMemberSubscriptionQuery = {
  __typename?: 'Query';
  getMemberSubscription?: {
    __typename?: 'MemberSubscriptionResponse';
    message?: string | null;
    data?: {
      __typename?: 'BillingSubscription';
      id?: number | null;
      memberPlanId?: number | null;
      status?: string | null;
      nextBillingAt?: any | null;
      endedAt?: any | null;
      totalAmount?: number | null;
      itemsQuantity?: number | null;
      periodUnit?: string | null;
      plan?: { __typename?: 'Plan'; id?: number | null; label?: string | null } | null;
    } | null;
  } | null;
};

export type IntegrationConfigurationQueryVariables = Exact<{
  integrationConfigurationId: Scalars['Int']['input'];
}>;

export type IntegrationConfigurationQuery = {
  __typename?: 'Query';
  integrationConfiguration?: {
    __typename?: 'IntegrationConfigurationResponse';
    message?: string | null;
    data?: {
      __typename?: 'IntegrationConfiguration';
      id?: number | null;
      integrationUserId?: number | null;
      workspaceId?: number | null;
      syncCallDetails?: boolean | null;
      syncContacts?: boolean | null;
      syncMessage?: boolean | null;
      syncVoicemails?: boolean | null;
      syncRecordings?: boolean | null;
      createdBy?: number | null;
      updatedBy?: number | null;
    } | null;
  } | null;
};

export type IntegrationWebhooksQueryVariables = Exact<{
  integrationUserId: Scalars['Int']['input'];
}>;

export type IntegrationWebhooksQuery = {
  __typename?: 'Query';
  integrationWebhooks?: {
    __typename?: 'IntegrationWebhookResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'IntegrationWebhook';
      id?: number | null;
      integrationUserId?: number | null;
      label?: IntegrationWebhookLabelEnum | null;
      username?: string | null;
      password?: string | null;
      url?: string | null;
    } | null> | null;
  } | null;
};

export type MyRolePrivilegeQueryVariables = Exact<{ [key: string]: never }>;

export type MyRolePrivilegeQuery = {
  __typename?: 'Query';
  myRolePrivilege?: {
    __typename?: 'MultipleScreenRoleMappings';
    edges?: Array<{
      __typename?: 'ScreenRoleMapping';
      module?: { __typename?: 'Module'; slug?: string | null } | null;
      privilege?: { __typename?: 'Privilege'; slug?: string | null } | null;
      role?: { __typename?: 'Role'; slug?: string | null } | null;
      screen?: { __typename?: 'Screen'; slug?: string | null } | null;
    } | null> | null;
  } | null;
};

export type CountChannelsQueryVariables = Exact<{
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type CountChannelsQuery = {
  __typename?: 'Query';
  freeNumbers?: { __typename?: 'ChannelCountResponse'; message?: string | null; count: number } | null;
  totalNumbers?: { __typename?: 'ChannelCountResponse'; message?: string | null; count: number } | null;
};

export type MyPlanPrivilegeQueryVariables = Exact<{ [key: string]: never }>;

export type MyPlanPrivilegeQuery = {
  __typename?: 'Query';
  myPlanPrivilege?: {
    __typename?: 'MultipleScreenPlanMappings';
    message?: string | null;
    edges?: Array<{
      __typename?: 'ScreenPlanMapping';
      privilege?: { __typename?: 'Privilege'; slug?: string | null } | null;
      screen?: { __typename?: 'Screen'; slug?: string | null } | null;
      module?: { __typename?: 'Module'; slug?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetAssignedChannelsQueryVariables = Exact<{
  userWorkspaceId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAssignedChannelsQuery = {
  __typename?: 'Query';
  getAssignedChannels?: {
    __typename?: 'ChannelUserWorkspaceCursorPaginationV2';
    message?: string | null;
    data?: Array<{
      __typename?: 'ChannelUserWorkspace';
      channel?: {
        __typename?: 'Channel';
        friendlyName?: string | null;
        phoneNumber?: string | null;
        id?: number | null;
        muted?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetBusinessHoursInCallSettingQueryVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
}>;

export type GetBusinessHoursInCallSettingQuery = {
  __typename?: 'Query';
  getBusinessHoursInCallSetting?: {
    __typename?: 'BusinessHourResponse';
    message?: string | null;
    data?: {
      __typename?: 'BusinessHour';
      id?: number | null;
      timezoneId?: number | null;
      isAlwaysOpen?: boolean | null;
      entries?: Array<{
        __typename?: 'BusinessHourEntry';
        localDayOfWeek?: number | null;
        localStartTime?: string | null;
        localEndTime?: string | null;
        businessHourId?: number | null;
        isActive?: boolean | null;
      } | null> | null;
      timezone?: { __typename?: 'Timezone'; value?: string | null; label?: string | null; id?: number | null } | null;
    } | null;
  } | null;
};

export type MyWorkspaceQueryVariables = Exact<{ [key: string]: never }>;

export type MyWorkspaceQuery = {
  __typename?: 'Query';
  myWorkspace?: {
    __typename?: 'MyWorkspaceResponse';
    data?: {
      __typename?: 'Workspace';
      id?: number | null;
      label?: string | null;
      totalPhoneNumbers?: number | null;
      availableBalance?: number | null;
      logo?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      coverProfile?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
    } | null;
  } | null;
};

export type GetWalletDetailsWithLastCreditedQueryVariables = Exact<{ [key: string]: never }>;

export type GetWalletDetailsWithLastCreditedQuery = {
  __typename?: 'Query';
  getWalletDetailsWithLastCredited?: {
    __typename?: 'WalletDetailWithLastCreditedResponse';
    message: string;
    data?: {
      __typename?: 'WalletDetailWithLastCredited';
      amount?: number | null;
      lastCredit?: number | null;
      lastTransactionDate?: any | null;
    } | null;
  } | null;
};

export type EnumerateCountriesForAvailableNumbersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type EnumerateCountriesForAvailableNumbersQuery = {
  __typename?: 'Query';
  enumerateCountriesForAvailableNumbers?: {
    __typename?: 'EnumerateCountriesForAvailableNumbersResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'Country';
      id?: number | null;
      name?: string | null;
      slug?: string | null;
      dialingCode?: string | null;
      alphaTwoCode?: string | null;
      alphaThreeCode?: string | null;
      numeric?: string | null;
      flag?: string | null;
    } | null> | null;
  } | null;
};

export type EnumerateNumberTypesAvailableForCountryQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
}>;

export type EnumerateNumberTypesAvailableForCountryQuery = {
  __typename?: 'Query';
  enumerateNumberTypesAvailableForCountry?: {
    __typename?: 'EnumerateNumberTypesAvailableForCountryResponse';
    message?: string | null;
    data?: Array<{ __typename?: 'NumberType'; id?: number | null; label?: string | null } | null> | null;
  } | null;
};

export type GetCallSettingQueryVariables = Exact<{
  getCallSettingId: Scalars['Int']['input'];
}>;

export type GetCallSettingQuery = {
  __typename?: 'Query';
  getCallSetting?: {
    __typename?: 'CallSettingResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSetting';
      id?: number | null;
      friendlyName?: string | null;
      isBusinessAlwaysOpen?: boolean | null;
      afterHour?: boolean | null;
      ivr?: boolean | null;
      voicemail?: boolean | null;
      welcomeMessage?: boolean | null;
      recording?: boolean | null;
      callerTune?: boolean | null;
      callForward?: boolean | null;
      callTransfer?: boolean | null;
      callerId?: number | null;
      timeout?: number | null;
      enableMissedCallEmail?: boolean | null;
      smsMmsEmailAlertEnabled?: boolean | null;
      transcriptionEmailAlertEnabled?: boolean | null;
    } | null;
  } | null;
};

export type GetBusinessAfterHoursInCallSettingQueryVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
}>;

export type GetBusinessAfterHoursInCallSettingQuery = {
  __typename?: 'Query';
  getBusinessAfterHoursInCallSetting?: {
    __typename?: 'BusinessAfterHourResponse';
    message?: string | null;
    data?: {
      __typename?: 'BusinessHour';
      id?: number | null;
      route?: AfterHourRouteEnum | null;
      supportAfterHours?: boolean | null;
      targetPhoneNumber?: string | null;
      updatedAt?: any | null;
      voicemailAudioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetMemberSubscriptionOverviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetMemberSubscriptionOverviewQuery = {
  __typename?: 'Query';
  getMemberSubscriptionOverview?: {
    __typename?: 'MemberSubscriptionOverviewResponse';
    data?: {
      __typename?: 'MemberSubscriptionOverview';
      id?: number | null;
      totalAmount?: number | null;
      userCount?: number | null;
      plan?: {
        __typename?: 'MemberSubscriptionPlanData';
        id?: number | null;
        amount?: number | null;
        periodicity?: string | null;
        label?: string | null;
      } | null;
      discount?: { __typename?: 'MemberSubscriptionDiscountData'; percent?: number | null } | null;
      promo?: { __typename?: 'MemberSubscriptionPromoData'; label?: string | null; percent?: number | null } | null;
    } | null;
  } | null;
};

export type GetIvrInCallSettingQueryVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
}>;

export type GetIvrInCallSettingQuery = {
  __typename?: 'Query';
  getIvrInCallSetting?: {
    __typename?: 'IvrResponse';
    message?: string | null;
    data?: {
      __typename?: 'IvrType';
      id?: number | null;
      isActive?: boolean | null;
      startPrompt?: {
        __typename?: 'AudioPrompt';
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      invalidPrompt?: {
        __typename?: 'AudioPrompt';
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        createdAt?: any | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      ifUnansweredPrompt?: {
        __typename?: 'AudioPrompt';
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        createdAt?: any | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetCallForwardInCallSettingQueryVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
}>;

export type GetCallForwardInCallSettingQuery = {
  __typename?: 'Query';
  getCallForwardInCallSetting?: {
    __typename?: 'CallForwardResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallForward';
      id?: number | null;
      isUnconditional?: boolean | null;
      targetPhoneNumber?: string | null;
      isActive?: boolean | null;
    } | null;
  } | null;
};

export type GetMessageScheduleCountQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  status?: InputMaybe<Array<InputMaybe<MessageScheduleStatusEnum>> | InputMaybe<MessageScheduleStatusEnum>>;
}>;

export type GetMessageScheduleCountQuery = {
  __typename?: 'Query';
  getMessageScheduleCount?: {
    __typename?: 'MessageScheduleCountData';
    message?: string | null;
    data?: {
      __typename?: 'MessageScheduleCount';
      scheduleAt?: any | null;
      id?: string | null;
      count?: number | null;
    } | null;
  } | null;
};

export type EstimateRenewFailedSubscriptionV2QueryVariables = Exact<{ [key: string]: never }>;

export type EstimateRenewFailedSubscriptionV2Query = {
  __typename?: 'Query';
  estimateRenewFailedSubscriptionV2?: {
    __typename?: 'EstimateAmountResponse';
    message?: string | null;
    data?: { __typename?: 'EstimatedData'; estimatedAmount?: number | null } | null;
  } | null;
};

export type GetCallTransferInCallSettingQueryVariables = Exact<{
  callSettingId: Scalars['Int']['input'];
}>;

export type GetCallTransferInCallSettingQuery = {
  __typename?: 'Query';
  getCallTransferInCallSetting?: {
    __typename?: 'CallTransferResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallTransferResponseType';
      id?: number | null;
      isActive?: boolean | null;
      transferPrompt?: {
        __typename?: 'CallTransferAudioPrompt';
        id?: number | null;
        defaultUrl?: string | null;
        useDefault?: boolean | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      noAnswerPrompt?: {
        __typename?: 'CallTransferAudioPrompt';
        id?: number | null;
        defaultUrl?: string | null;
        useDefault?: boolean | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        createdAt?: any | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      terminatedPrompt?: {
        __typename?: 'CallTransferAudioPrompt';
        id?: number | null;
        defaultUrl?: string | null;
        useDefault?: boolean | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        createdAt?: any | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetCallerIdInCallSettingQueryVariables = Exact<{
  callId: Scalars['Int']['input'];
}>;

export type GetCallerIdInCallSettingQuery = {
  __typename?: 'Query';
  getCallerIdInCallSetting?: {
    __typename?: 'CallSettingCallerIdResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingCallerId';
      id: number;
      callerIdInfo?: { __typename?: 'CallerId'; id?: number | null } | null;
    } | null;
  } | null;
};

export type GetTimeoutInCallSettingQueryVariables = Exact<{
  getTimeoutInCallSettingId: Scalars['Int']['input'];
}>;

export type GetTimeoutInCallSettingQuery = {
  __typename?: 'Query';
  getTimeoutInCallSetting?: {
    __typename?: 'CallSetttingTimeoutResponse';
    message?: string | null;
    data?: { __typename?: 'CallSetttingTimeout'; id?: number | null; timeout?: number | null } | null;
  } | null;
};

export type GetCallerTuneInCallSettingQueryVariables = Exact<{
  getCallerTuneInCallSettingId: Scalars['Int']['input'];
}>;

export type GetCallerTuneInCallSettingQuery = {
  __typename?: 'Query';
  getCallerTuneInCallSetting?: {
    __typename?: 'CallSettingCallerTuneResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingCallerTune';
      id: number;
      isActive?: boolean | null;
      callerTuneLoop?: number | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetWelcomeMessageInCallSettingQueryVariables = Exact<{
  getWelcomeMessageInCallSettingId: Scalars['Int']['input'];
}>;

export type GetWelcomeMessageInCallSettingQuery = {
  __typename?: 'Query';
  getWelcomeMessageInCallSetting?: {
    __typename?: 'CallSettingWelcomeMessageResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingWelcomeMessage';
      id?: number | null;
      isActive?: boolean | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type WorkspaceRateLimitsQueryVariables = Exact<{ [key: string]: never }>;

export type WorkspaceRateLimitsQuery = {
  __typename?: 'Query';
  workspaceRateLimits?: {
    __typename?: 'MultipleWorkspaceRateLimit';
    message?: string | null;
    data?: Array<{
      __typename?: 'WorkspaceRateLimit';
      id?: number | null;
      category?: WorkspaceRateLimitExhaustCategoryEnum | null;
      direction?: DirectionTypeEnum | null;
      threshold?: number | null;
      timeLimit?: number | null;
      segmentLimit?: number | null;
      exhaust?: { __typename?: 'WorkspaceRateLimitExhaust'; value?: number | null } | null;
    } | null> | null;
  } | null;
};

export type WorkspaceA2PVerificationStatusQueryVariables = Exact<{ [key: string]: never }>;

export type WorkspaceA2PVerificationStatusQuery = {
  __typename?: 'Query';
  workspaceA2PVerificationStatus?: {
    __typename?: 'WorkspaceA2pVerificationStatusResponse';
    message?: string | null;
    data?: { __typename?: 'WorkspaceA2pVerificationStatusData'; a2pVerified?: boolean | null } | null;
  } | null;
};

export type GetContactComplianceConsentQueryVariables = Exact<{
  getContactComplianceConsentId: Scalars['Int']['input'];
}>;

export type GetContactComplianceConsentQuery = {
  __typename?: 'Query';
  getContactComplianceConsent?: {
    __typename?: 'ContactComplianceConsentResponse';
    message?: string | null;
    data?: {
      __typename?: 'ContactComplianceConsent';
      id?: number | null;
      consentedAt?: any | null;
      isConsented?: boolean | null;
      consentSource?: ContactComplianceConsentSourceEnum | null;
      consentDetails?: string | null;
      flowDetails?: string | null;
      campaign?: {
        __typename?: 'ContactComplianceConsentCampaign';
        id?: number | null;
        messageServiceName?: string | null;
      } | null;
    } | null;
  } | null;
};

export type GetCallerIdInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetCallerIdInChannelSettingQuery = {
  __typename?: 'Query';
  getCallerIdInChannelSetting?: {
    __typename?: 'CallSettingCallerIdResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingCallerId';
      id: number;
      callerIdInfo?: { __typename?: 'CallerId'; id?: number | null } | null;
    } | null;
  } | null;
};

export type GetCallForwardInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetCallForwardInChannelSettingQuery = {
  __typename?: 'Query';
  getCallForwardInChannelSetting?: {
    __typename?: 'CallForwardResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallForward';
      id?: number | null;
      isUnconditional?: boolean | null;
      targetPhoneNumber?: string | null;
      isActive?: boolean | null;
    } | null;
  } | null;
};

export type GetAutoTranscribeInCallSettingQueryVariables = Exact<{
  getAutoTranscribeInCallSettingId: Scalars['Int']['input'];
}>;

export type GetAutoTranscribeInCallSettingQuery = {
  __typename?: 'Query';
  getAutoTranscribeInCallSetting?: {
    __typename?: 'CallSettingAutoTranscribeResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingAutoTranscribeType'; id?: number | null; autoTranscribe?: boolean | null } | null;
  } | null;
};

export type GetRecordingAnnouncementInCallSettingQueryVariables = Exact<{
  getRecordingAnnouncementInCallSettingId: Scalars['Int']['input'];
}>;

export type GetRecordingAnnouncementInCallSettingQuery = {
  __typename?: 'Query';
  getRecordingAnnouncementInCallSetting?: {
    __typename?: 'CallSettingRecordingAnnouncementResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingRecordingAnnouncementType';
      recordingAnnouncementMessage?: boolean | null;
      recordingAnnouncementAfterBeep?: boolean | null;
      id?: number | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        gender?: GenderEnum | null;
        language?: AudioPromptLanguageEnum | null;
        text?: string | null;
        type?: AudioPromptTypeEnum | null;
        workspaceId?: number | null;
        audio?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetAutoRecordingInCallSettingQueryVariables = Exact<{
  getAutoRecordingInCallSettingId: Scalars['Int']['input'];
}>;

export type GetAutoRecordingInCallSettingQuery = {
  __typename?: 'Query';
  getAutoRecordingInCallSetting?: {
    __typename?: 'CallSettingAutoRecordingResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingAutoRecordingType'; id?: number | null; autoRecording?: boolean | null } | null;
  } | null;
};

export type GetWelcomeMessageInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetWelcomeMessageInChannelSettingQuery = {
  __typename?: 'Query';
  getWelcomeMessageInChannelSetting?: {
    __typename?: 'CallSettingWelcomeMessageResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingWelcomeMessage';
      id?: number | null;
      isActive?: boolean | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetTimeoutInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetTimeoutInChannelSettingQuery = {
  __typename?: 'Query';
  getTimeoutInChannelSetting?: {
    __typename?: 'CallSetttingTimeoutResponse';
    message?: string | null;
    data?: { __typename?: 'CallSetttingTimeout'; id?: number | null; timeout?: number | null } | null;
  } | null;
};

export type GetCallerTuneInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetCallerTuneInChannelSettingQuery = {
  __typename?: 'Query';
  getCallerTuneInChannelSetting?: {
    __typename?: 'CallSettingCallerTuneResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingCallerTune';
      id: number;
      isActive?: boolean | null;
      callerTuneLoop?: number | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetVoicemailInCallSettingQueryVariables = Exact<{
  getVoicemailInCallSettingId: Scalars['Int']['input'];
}>;

export type GetVoicemailInCallSettingQuery = {
  __typename?: 'Query';
  getVoicemailInCallSetting?: {
    __typename?: 'CallSettingVoicemailResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingVoicemail';
      voicemailAfterBeep?: boolean | null;
      sendVoicemailToEmail?: boolean | null;
      isActive?: boolean | null;
      id: number;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        type?: AudioPromptTypeEnum | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        id?: number | null;
        gender?: GenderEnum | null;
        workspaceId?: number | null;
        audio?: { __typename?: 'Media'; url?: string | null; id?: number | null; mimetype?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetCallTransferInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetCallTransferInChannelSettingQuery = {
  __typename?: 'Query';
  getCallTransferInChannelSetting?: {
    __typename?: 'CallTransferResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallTransferResponseType';
      id?: number | null;
      isActive?: boolean | null;
      transferPrompt?: {
        __typename?: 'CallTransferAudioPrompt';
        id?: number | null;
        defaultUrl?: string | null;
        useDefault?: boolean | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      noAnswerPrompt?: {
        __typename?: 'CallTransferAudioPrompt';
        id?: number | null;
        defaultUrl?: string | null;
        useDefault?: boolean | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        createdAt?: any | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      terminatedPrompt?: {
        __typename?: 'CallTransferAudioPrompt';
        id?: number | null;
        defaultUrl?: string | null;
        useDefault?: boolean | null;
        workspaceId?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        createdAt?: any | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetVoicemailInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetVoicemailInChannelSettingQuery = {
  __typename?: 'Query';
  getVoicemailInChannelSetting?: {
    __typename?: 'CallSettingVoicemailResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingVoicemail';
      voicemailAfterBeep?: boolean | null;
      sendVoicemailToEmail?: boolean | null;
      isActive?: boolean | null;
      id: number;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        type?: AudioPromptTypeEnum | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        id?: number | null;
        gender?: GenderEnum | null;
        workspaceId?: number | null;
        audio?: { __typename?: 'Media'; url?: string | null; id?: number | null; mimetype?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetAutoRecordingInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetAutoRecordingInChannelSettingQuery = {
  __typename?: 'Query';
  getAutoRecordingInChannelSetting?: {
    __typename?: 'CallSettingAutoRecordingResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingAutoRecordingType'; id?: number | null; autoRecording?: boolean | null } | null;
  } | null;
};

export type GetAutoTranscribeInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetAutoTranscribeInChannelSettingQuery = {
  __typename?: 'Query';
  getAutoTranscribeInChannelSetting?: {
    __typename?: 'CallSettingAutoTranscribeResponse';
    message?: string | null;
    data?: { __typename?: 'CallSettingAutoTranscribeType'; id?: number | null; autoTranscribe?: boolean | null } | null;
  } | null;
};

export type GetRecordingAnnouncementInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetRecordingAnnouncementInChannelSettingQuery = {
  __typename?: 'Query';
  getRecordingAnnouncementInChannelSetting?: {
    __typename?: 'CallSettingRecordingAnnouncementResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingRecordingAnnouncementType';
      recordingAnnouncementMessage?: boolean | null;
      recordingAnnouncementAfterBeep?: boolean | null;
      id?: number | null;
      audioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        gender?: GenderEnum | null;
        language?: AudioPromptLanguageEnum | null;
        text?: string | null;
        type?: AudioPromptTypeEnum | null;
        workspaceId?: number | null;
        audio?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetIvrInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetIvrInChannelSettingQuery = {
  __typename?: 'Query';
  getIvrInChannelSetting?: {
    __typename?: 'IvrResponse';
    message?: string | null;
    data?: {
      __typename?: 'IvrType';
      id?: number | null;
      isActive?: boolean | null;
      startPrompt?: {
        __typename?: 'AudioPrompt';
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      invalidPrompt?: {
        __typename?: 'AudioPrompt';
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        createdAt?: any | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      ifUnansweredPrompt?: {
        __typename?: 'AudioPrompt';
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        createdAt?: any | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetBusinessHoursInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetBusinessHoursInChannelSettingQuery = {
  __typename?: 'Query';
  getBusinessHoursInChannelSetting?: {
    __typename?: 'BusinessHourResponse';
    message?: string | null;
    data?: {
      __typename?: 'BusinessHour';
      id?: number | null;
      isAlwaysOpen?: boolean | null;
      entries?: Array<{
        __typename?: 'BusinessHourEntry';
        localDayOfWeek?: number | null;
        localStartTime?: string | null;
        localEndTime?: string | null;
        businessHourId?: number | null;
        isActive?: boolean | null;
      } | null> | null;
      timezone?: { __typename?: 'Timezone'; value?: string | null; label?: string | null; id?: number | null } | null;
    } | null;
  } | null;
};

export type GetChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetChannelSettingQuery = {
  __typename?: 'Query';
  getChannelSetting?: {
    __typename?: 'CallSettingResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSetting';
      id?: number | null;
      friendlyName?: string | null;
      callTransfer?: boolean | null;
      isBusinessAlwaysOpen?: boolean | null;
      afterHour?: boolean | null;
      ivr?: boolean | null;
      timeout?: number | null;
      voicemail?: boolean | null;
      welcomeMessage?: boolean | null;
      recording?: boolean | null;
      callerTune?: boolean | null;
      callForward?: boolean | null;
      enableMissedCallEmail?: boolean | null;
      smsMmsEmailAlertEnabled?: boolean | null;
      transcriptionEmailAlertEnabled?: boolean | null;
      callerId?: number | null;
    } | null;
  } | null;
};

export type GetBusinessAfterHoursInChannelSettingQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetBusinessAfterHoursInChannelSettingQuery = {
  __typename?: 'Query';
  getBusinessAfterHoursInChannelSetting?: {
    __typename?: 'BusinessAfterHourResponse';
    message?: string | null;
    data?: {
      __typename?: 'BusinessHour';
      id?: number | null;
      route?: AfterHourRouteEnum | null;
      supportAfterHours?: boolean | null;
      targetPhoneNumber?: string | null;
      updatedAt?: any | null;
      voicemailAudioPrompt?: {
        __typename?: 'AudioPrompt';
        id?: number | null;
        text?: string | null;
        language?: AudioPromptLanguageEnum | null;
        gender?: GenderEnum | null;
        type?: AudioPromptTypeEnum | null;
        audio?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GetChannelOverviewQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetChannelOverviewQuery = {
  __typename?: 'Query';
  getChannelOverview?: {
    __typename?: 'ChannelOverviewResponse';
    message?: string | null;
    data?: {
      __typename?: 'Channel';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        flag?: string | null;
        alphaTwoCode?: string | null;
      } | null;
      callSetting?: {
        __typename?: 'CallSettingsType';
        id?: number | null;
        businessHourType?: string | null;
        friendlyName?: string | null;
        incomingTimeout?: number | null;
        recording?: boolean | null;
        metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
        callerId?: {
          __typename?: 'CallerId';
          id?: number | null;
          friendlyName?: string | null;
          phoneNumber?: string | null;
        } | null;
      } | null;
      subscription?: { __typename?: 'BillingSubscription'; nextBillingAt?: any | null } | null;
      channelGroup?: {
        __typename?: 'ChannelGroup';
        id?: number | null;
        name?: string | null;
        callSetting?: {
          __typename?: 'CallSettingsType';
          id?: number | null;
          businessHourType?: string | null;
          friendlyName?: string | null;
          recording?: boolean | null;
          incomingTimeout?: number | null;
          metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
          callerId?: {
            __typename?: 'CallerId';
            id?: number | null;
            friendlyName?: string | null;
            phoneNumber?: string | null;
          } | null;
        } | null;
      } | null;
      removalSchedule?: { __typename?: 'ChannelRemovalSchedule'; scheduleAt?: any | null } | null;
      assignedUsers?: Array<{
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type FetchActiveChannelStrategiesQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type FetchActiveChannelStrategiesQuery = {
  __typename?: 'Query';
  fetchActiveChannelStrategies?: {
    __typename?: 'ListActiveChannelStrategies';
    data?: Array<string | null> | null;
  } | null;
};

export type DashboardKpisQueryVariables = Exact<{
  input?: InputMaybe<InputFromDateToDateUserId>;
}>;

export type DashboardKpisQuery = {
  __typename?: 'Query';
  dashboardKpis?: {
    __typename?: 'KpisCombinedRes';
    message?: string | null;
    data?: {
      __typename?: 'KpisCombined';
      answerRate?: {
        __typename?: 'KpiAnswerRate';
        name?: string | null;
        slug?: KpiWidgetSlugEnum | null;
        value?: {
          __typename?: 'KpiAnswerRateValue';
          answerRate?: number | null;
          changePercent?: number | null;
          currentAnsweredCall?: number | null;
          currentTotalInbound?: number | null;
          previousAnsweredCall?: number | null;
          previousTotalInbound?: number | null;
        } | null;
      } | null;
      averageAnswerTime?: {
        __typename?: 'KpiAverageAnswerTime';
        name?: string | null;
        slug?: KpiWidgetSlugEnum | null;
        value?: {
          __typename?: 'KpiAverageAnswerTimeValue';
          changePercent?: number | null;
          currentAverageAns?: string | null;
          previousAverageAns?: string | null;
        } | null;
      } | null;
      totalCall?: {
        __typename?: 'KpiCall';
        name?: string | null;
        slug?: KpiWidgetSlugEnum | null;
        value?: {
          __typename?: 'KpiCallValue';
          currentInboundCall?: number | null;
          currentOutboundCall?: number | null;
          previousInboundCall?: number | null;
          previousOutboundCall?: number | null;
          inboundCallChangePercent?: number | null;
          outboundCallChangePercent?: number | null;
        } | null;
      } | null;
      closedConversation?: {
        __typename?: 'KpiClosedConversation';
        name?: string | null;
        slug?: KpiWidgetSlugEnum | null;
        value?: {
          __typename?: 'KpiClosedConversationValue';
          changePercent?: number | null;
          currentClosedConversation?: number | null;
          previousClosedConversation?: number | null;
        } | null;
      } | null;
      liveCall?: {
        __typename?: 'KpiLiveCall';
        name?: string | null;
        slug?: KpiWidgetSlugEnum | null;
        value?: { __typename?: 'KpiLiveCallValue'; liveCallCount?: number | null; peakCount?: number | null } | null;
      } | null;
      totalMessage?: {
        __typename?: 'KpiMessage';
        name?: string | null;
        slug?: KpiWidgetSlugEnum | null;
        value?: {
          __typename?: 'KpiMessageValue';
          currentInboundMess?: number | null;
          currentOutboundMess?: number | null;
          previousInboundMess?: number | null;
          previousOutboundMess?: number | null;
          inboundMessChangePercent?: number | null;
          outboundMessChangePercent?: number | null;
        } | null;
      } | null;
      missedCall?: {
        __typename?: 'KpiMissedCall';
        name?: string | null;
        slug?: KpiWidgetSlugEnum | null;
        value?: {
          __typename?: 'KpiMissedCallValue';
          changePercent?: number | null;
          percentOfInbound?: number | null;
          currentMissedCallValue?: number | null;
          previousMissedCallValue?: number | null;
        } | null;
      } | null;
      openedConversation?: {
        __typename?: 'KpiOpenConversation';
        name?: string | null;
        slug?: KpiWidgetSlugEnum | null;
        value?: {
          __typename?: 'KpiOpenConversationValue';
          changePercent?: number | null;
          currentOpenConversation?: number | null;
          previousOpenConversation?: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type DashboardCallVolumeQueryVariables = Exact<{
  input?: InputMaybe<InputFromDateToDateUserId>;
}>;

export type DashboardCallVolumeQuery = {
  __typename?: 'Query';
  dashboardCallVolume?: {
    __typename?: 'DashboardCallVolumeRes';
    message?: string | null;
    data?: Array<{
      __typename?: 'DashboardCallVolumeItem';
      timeBucket?: string | null;
      outboundCount?: number | null;
      inboundCount?: number | null;
    } | null> | null;
  } | null;
};

export type DashboardUniqueVsRepeatedCallerQueryVariables = Exact<{
  input?: InputMaybe<InputFromDateToDateUserId>;
}>;

export type DashboardUniqueVsRepeatedCallerQuery = {
  __typename?: 'Query';
  dashboardUniqueVsRepeatedCaller?: {
    __typename?: 'DashboardUniquerVsRepeatedCallerRes';
    message?: string | null;
    data?: Array<{
      __typename?: 'DashboardUniquerVsRepeatedCallerItem';
      timeBucket?: string | null;
      uniqueCount?: number | null;
      repeatedCount?: number | null;
    } | null> | null;
  } | null;
};

export type DashboardMemberLeaderBoardQueryVariables = Exact<{
  input?: InputMaybe<InputFromDateToDate>;
}>;

export type DashboardMemberLeaderBoardQuery = {
  __typename?: 'Query';
  dashboardMemberLeaderBoard?: {
    __typename?: 'dashboardMemberLeaderBoardRes';
    message?: string | null;
    data?: Array<{
      __typename?: 'MemberLeaderBoardItem';
      userId?: number | null;
      userName?: string | null;
      userMediaUrl?: string | null;
      callFlowName?: string | null;
      callFlowId?: number | null;
      totalCalls?: number | null;
      totalMessages?: number | null;
      total?: number | null;
    } | null> | null;
  } | null;
};

export type DashboardCallDistributionsQueryVariables = Exact<{
  input?: InputMaybe<InputFromDateToDateUserId>;
}>;

export type DashboardCallDistributionsQuery = {
  __typename?: 'Query';
  dashboardCallDistributions?: {
    __typename?: 'DashboardCallDistributionRes';
    message?: string | null;
    data?: Array<{
      __typename?: 'DashboardCallDistributionItem';
      channelId?: number | null;
      channelFriendlyName?: string | null;
      channelMediaUrl?: string | null;
      channelPhoneNumber?: string | null;
      totalCalls?: number | null;
      callPercentage?: string | null;
    } | null> | null;
  } | null;
};

export type DashboardKeyKpisQueryVariables = Exact<{
  input?: InputMaybe<InputFromDateToDateUserId>;
}>;

export type DashboardKeyKpisQuery = {
  __typename?: 'Query';
  dashboardKeyKpis?: {
    __typename?: 'KpiKeysRes';
    message?: string | null;
    data?: {
      __typename?: 'KpiKeyItem';
      totalCalls?: string | null;
      missedCalls?: string | null;
      answerRate?: string | null;
      averageAnswerTime?: string | null;
      message?: string | null;
      recordingCoverage?: string | null;
      transcriptionCoverage?: string | null;
    } | null;
  } | null;
};

export type DashboardWalletExpenditureQueryVariables = Exact<{
  input?: InputMaybe<InputFromDateToDateUserId>;
}>;

export type DashboardWalletExpenditureQuery = {
  __typename?: 'Query';
  dashboardWalletExpenditure?: {
    __typename?: 'WalletExpenditureRes';
    message?: string | null;
    data?: Array<{
      __typename?: 'WalletExpenditureItem';
      spentSection?: string | null;
      amountSpent?: string | null;
    } | null> | null;
  } | null;
};

export type DashboardCriticalEventsQueryVariables = Exact<{ [key: string]: never }>;

export type DashboardCriticalEventsQuery = {
  __typename?: 'Query';
  dashboardCriticalEvents?: {
    __typename?: 'CriticalEventRes';
    message?: string | null;
    data?: Array<{ __typename?: 'CriticalEvent'; message?: string | null; event?: string | null } | null> | null;
  } | null;
};

export type UnlimitedConfigsQueryVariables = Exact<{ [key: string]: never }>;

export type UnlimitedConfigsQuery = {
  __typename?: 'Query';
  unlimitedConfigs?: {
    __typename?: 'CursorPaginationUnlimitedConfig';
    message?: string | null;
    data?: Array<{
      __typename?: 'UnlimitedConfig';
      id?: number | null;
      direction?: UnlimitedConfigDirectionEnum | null;
      threshold?: number | null;
      consumedThreshold?: number | null;
      unit?: ThresholdUnitEnum | null;
    } | null> | null;
  } | null;
};

export type DashboardUnlimitedUsagesQueryVariables = Exact<{
  input?: InputMaybe<InputUserId>;
}>;

export type DashboardUnlimitedUsagesQuery = {
  __typename?: 'Query';
  dashboardUnlimitedUsages?: {
    __typename?: 'DashboardUnlimitedUsagesRes';
    message?: string | null;
    data?: {
      __typename?: 'DashboardUnlimitedUsages';
      endingAt?: any | null;
      freeCreditWorth?: number | null;
      hasUnlimitedConfig?: boolean | null;
      incoming?: {
        __typename?: 'DashboardUnlimitedUsagesData';
        call?: number | null;
        message?: number | null;
        messageCount?: string | null;
        callCount?: string | null;
        messageThreshold?: string | null;
        callThreshold?: string | null;
      } | null;
      outgoing?: {
        __typename?: 'DashboardUnlimitedUsagesData';
        call?: number | null;
        message?: number | null;
        callCount?: string | null;
        messageCount?: string | null;
        callThreshold?: string | null;
        messageThreshold?: string | null;
      } | null;
    } | null;
  } | null;
};

export type DashboardAfterHourActivitiesQueryVariables = Exact<{
  input?: InputMaybe<InputFromDateToDateUserId>;
}>;

export type DashboardAfterHourActivitiesQuery = {
  __typename?: 'Query';
  dashboardAfterHourActivities?: {
    __typename?: 'DashboardActivityAfterBusinessHourRes';
    message?: string | null;
    data?: Array<{
      __typename?: 'DashboardActivityAfterBusinessHourData';
      date?: string | null;
      call?: string | null;
      message?: string | null;
    } | null> | null;
  } | null;
};

export type GetCallSettingForChannelQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetCallSettingForChannelQuery = {
  __typename?: 'Query';
  getCallSettingForChannel?: {
    __typename?: 'CallSettingForChannelResponse';
    data?: {
      __typename?: 'CallSettingForChannelData';
      id?: number | null;
      callSetting?: {
        __typename?: 'CallSettingForChannel';
        callTransfer?: boolean | null;
        recording?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type ChannelGroupsCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChannelGroupsCountQuery = {
  __typename?: 'Query';
  channelGroupsCount?: {
    __typename?: 'ChannelGroupCountResponse';
    message?: string | null;
    data?: { __typename?: 'CountChannelGroupType'; count?: number | null } | null;
  } | null;
};

export type GetCallSettingsCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCallSettingsCountQuery = {
  __typename?: 'Query';
  getCallSettingsCount?: {
    __typename?: 'CallSettingCountResponse';
    message?: string | null;
    data?: { __typename?: 'CountCallSettingType'; count?: number | null } | null;
  } | null;
};

export type GetConfigurationQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;

export type GetConfigurationQuery = {
  __typename?: 'Query';
  getConfiguration?: { __typename?: 'ConfigurationResponse'; message?: string | null; data?: any | null } | null;
};

export type LiveConferenceCountQueryVariables = Exact<{ [key: string]: never }>;

export type LiveConferenceCountQuery = {
  __typename?: 'Query';
  liveConferenceCount?: { __typename?: 'CountResponse'; message?: string | null; count?: number | null } | null;
};

export type PhoneNumberStatusCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type PhoneNumberStatusCountQuery = {
  __typename?: 'Query';
  phoneNumberStatusCount: {
    __typename?: 'PhoneNumberStatusCountResponse';
    message?: string | null;
    data?: {
      __typename?: 'PhoneNumberStatusCount';
      activeCount?: number | null;
      pendingCount?: number | null;
      failedCount?: number | null;
      releasedAndScheduledChannelsCount?: number | null;
    } | null;
  };
};

export type PublicCheckPhoneNumberRegulationQueryVariables = Exact<{
  isoCountry: Scalars['String']['input'];
  numberType: NumberTypeEnum;
  addressRequirements: Scalars['String']['input'];
}>;

export type PublicCheckPhoneNumberRegulationQuery = {
  __typename?: 'Query';
  publicCheckPhoneNumberRegulation?: {
    __typename?: 'SingleCheckRegulatoryCompliance';
    message?: string | null;
    data?: {
      __typename?: 'CheckRegulatoryCompliance';
      regulatoryCompliance?: boolean | null;
      requiredRegulatoryCompliance?: {
        __typename?: 'ApprovedRegulatoryCompliance';
        identity?: boolean | null;
        address?: boolean | null;
        endUserTypes?: Array<RegulatoryComplianceUseCaseEnum | null> | null;
      } | null;
    } | null;
  } | null;
};

export type GetPreferredContactMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPreferredContactMethodsQuery = {
  __typename?: 'Query';
  getPreferredContactMethods?: {
    __typename?: 'WorkspacePreferredContactMethodResponse';
    message?: string | null;
    data?: {
      __typename?: 'WorkspacePreferredContactMethod';
      id?: number | null;
      messagingEnabled?: boolean | null;
      messagingType?: ContactMessagingTypeEnum | null;
      messagingNumber?: string | null;
      phoneCallEnabled?: boolean | null;
      phoneCallNumber?: string | null;
      prefStartTime?: string | null;
      prefEndTime?: string | null;
      emailEnabled?: boolean | null;
      email?: string | null;
    } | null;
  } | null;
};

export type UsageReportNotificationQueryVariables = Exact<{ [key: string]: never }>;

export type UsageReportNotificationQuery = {
  __typename?: 'Query';
  usageReportNotification?: {
    __typename?: 'UsageReportNotificationResponse';
    message?: string | null;
    data?: {
      __typename?: 'UsageReportNotification';
      frequency?: UsageReportNotificationFrequencyEnum | null;
      localSendAt?: string | null;
      localDayOfWeek?: number | null;
      localDayOfMonth?: number | null;
      localWeekOfMonth?: number | null;
      localWeekdayOfMonth?: number | null;
      localMonthOfYear?: number | null;
      monthlyScheduleType?: MonthlyScheduleTypeEnum | null;
      enabled?: boolean | null;
    } | null;
  } | null;
};

export type AgentInProgressConversationQueryVariables = Exact<{ [key: string]: never }>;

export type AgentInProgressConversationQuery = {
  __typename?: 'Query';
  agentInProgressConversation?: {
    __typename?: 'AgentInProgressConversationResponse';
    message?: string | null;
    data?: {
      __typename?: 'AgentInProgressConversation';
      id?: number | null;
      callEntity?: {
        __typename?: 'AgentInProgressConversationCallEntity';
        id?: number | null;
        sid?: string | null;
        clientIdentity?: string | null;
        callPlatform?: string | null;
      } | null;
    } | null;
  } | null;
};

export type GetBulkMessagingCampaignQueryVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;

export type GetBulkMessagingCampaignQuery = {
  __typename?: 'Query';
  getBulkMessagingCampaign?: {
    __typename?: 'GetBulkMessagingCampaignResponse';
    message?: string | null;
    data?: {
      __typename?: 'BulkMessagingCampaign';
      id?: number | null;
      campaignName?: string | null;
      isDraft?: boolean | null;
      messageTemplate?: string | null;
      mediaCount?: number | null;
      campaignType?: BulkMessagingCampaignTypeEnum | null;
      messagingType?: BulkMessagingCampaignMessagingTypeEnum | null;
      a2pCampaignId?: number | null;
      a2pCampaignType?: BulkMessagingCampaignA2pCampaignTypeEnum | null;
      a2pSampleId?: number | null;
      status?: BulkMessagingCampaignStatusEnum | null;
      scheduleType?: BulkMessagingCampaignScheduleTypeEnum | null;
      isScheduled?: boolean | null;
      initiatedAt?: any | null;
      scheduledAt?: any | null;
      maxOccurrence?: number | null;
      endAt?: any | null;
      createdAt?: any | null;
      nextOccurrence?: any | null;
      recipients?: Array<{
        __typename?: 'BulkMessagingRecipient';
        id?: number | null;
        name?: string | null;
        phoneNumber?: string | null;
        profile?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
      } | null> | null;
      attachments?: Array<{
        __typename?: 'BulkMessagingAttachment';
        id?: number | null;
        fileName?: string | null;
        mimetype?: string | null;
        fileSize?: number | null;
        fileUrl?: string | null;
        media?: { __typename?: 'Media'; id?: number | null } | null;
      } | null> | null;
      metrics?: Array<{ __typename?: 'Metrics'; key?: string | null; value?: number | null } | null> | null;
      createdBy?: {
        __typename?: 'BulkMessagingCampaignCreator';
        id?: number | null;
        name?: string | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
        roles?: {
          __typename?: 'Role';
          id?: number | null;
          label?: string | null;
          slug?: string | null;
          level?: number | null;
          isActive?: boolean | null;
          isDefault?: boolean | null;
          position?: number | null;
        } | null;
      } | null;
      deliverySummary?: {
        __typename?: 'BulkMessagingDeliverySummary';
        totalRecipients?: number | null;
        totalDelivered?: number | null;
        runStatus?: string | null;
        totalSent?: number | null;
      } | null;
      channel?: { __typename?: 'Channel'; id?: number | null; phoneNumber?: string | null } | null;
    } | null;
  } | null;
};

export type FetchBulkMessagingCampaignRecipientsQueryVariables = Exact<{
  campaignId: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BulkMessagingCampaignRecipientStatusEnum>;
}>;

export type FetchBulkMessagingCampaignRecipientsQuery = {
  __typename?: 'Query';
  fetchBulkMessagingCampaignRecipients?: {
    __typename?: 'BulkMessagingCampaignRecipientsCursorPagination';
    message?: string | null;
    data?: Array<{
      __typename?: 'BulkMessagingCampaignRecipient';
      id?: number | null;
      conversationStatus?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      contact?: {
        __typename?: 'Contact';
        id?: number | null;
        phoneNumber?: string | null;
        name?: string | null;
        country?: { __typename?: 'Country'; id?: number | null; name?: string | null; flag?: string | null } | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      messageConversationErrorLog?: {
        __typename?: 'MessageConversationErrorLog';
        id?: number | null;
        code?: string | null;
        message?: string | null;
      } | null;
    } | null> | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
  } | null;
};

export type GetBulkMessagingCampaignListCountQueryVariables = Exact<{
  campaignType?: InputMaybe<BulkMessagingCampaignTypeEnum>;
  status?: InputMaybe<Array<InputMaybe<BulkMessagingCampaignStatusEnum>> | InputMaybe<BulkMessagingCampaignStatusEnum>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  initiatedFrom?: InputMaybe<Scalars['Date']['input']>;
  initiatedTo?: InputMaybe<Scalars['Date']['input']>;
}>;

export type GetBulkMessagingCampaignListCountQuery = {
  __typename?: 'Query';
  getBulkMessagingCampaignListCount?: {
    __typename?: 'CountResponse';
    count?: number | null;
    message?: string | null;
  } | null;
};

export type WorkspaceClaimedFreeNumbersQueryVariables = Exact<{ [key: string]: never }>;

export type WorkspaceClaimedFreeNumbersQuery = {
  __typename?: 'Query';
  workspaceClaimedFreeNumbers?: {
    __typename?: 'WorkspaceClaimedFreeNumbersResponse';
    message?: string | null;
    data: Array<{
      __typename?: 'ClaimedFreeNumber';
      id: number;
      phoneNumber: string;
      friendlyName: string;
      currentPrice?: string | null;
    }>;
  } | null;
};

export type GetRecipientsByCampaignRunQueryVariables = Exact<{
  campaignRunId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetRecipientsByCampaignRunQuery = {
  __typename?: 'Query';
  getRecipientsByCampaignRun?: {
    __typename?: 'getRecipientsByCampaignRunResponse';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'BulkMessageCampaignRunRecipient';
      updatedAt?: any | null;
      id?: number | null;
      createdAt?: any | null;
      conversationStatus?: string | null;
      contact?: {
        __typename?: 'Contact';
        id?: number | null;
        email?: string | null;
        name?: string | null;
        phoneNumber?: string | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
          createdAt?: any | null;
        } | null;
        country?: {
          __typename?: 'Country';
          id?: number | null;
          name?: string | null;
          slug?: string | null;
          dialingCode?: string | null;
          alphaTwoCode?: string | null;
          alphaThreeCode?: string | null;
          numeric?: string | null;
          flag?: string | null;
        } | null;
      } | null;
      messageConversationErrorLog?: {
        __typename?: 'MessageConversationErrorLog';
        id?: number | null;
        code?: string | null;
        message?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetCampaignRecipientsByCampaignIdQueryVariables = Exact<{
  campaignId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CursorDirectionEnum>;
  withCursor?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCampaignRecipientsByCampaignIdQuery = {
  __typename?: 'Query';
  getCampaignRecipientsByCampaignId?: {
    __typename?: 'getCampaignRecipientsByCampaignIdResponse';
    message?: string | null;
    cursor?: {
      __typename?: 'Cursor';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    } | null;
    data?: Array<{
      __typename?: 'CampaignRecipientsByCampaignId';
      updatedAt?: any | null;
      id?: number | null;
      createdAt?: any | null;
      contact?: {
        __typename?: 'Contact';
        id?: number | null;
        email?: string | null;
        name?: string | null;
        phoneNumber?: string | null;
        country?: { __typename?: 'Country'; id?: number | null; name?: string | null; flag?: string | null } | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; key?: string | null; url?: string | null } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetCallSettingEmailAlertsQueryVariables = Exact<{
  getCallSettingEmailAlertsId: Scalars['Int']['input'];
}>;

export type GetCallSettingEmailAlertsQuery = {
  __typename?: 'Query';
  getCallSettingEmailAlerts?: {
    __typename?: 'CallSettingEmailAlertsResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingEmailAlertsType';
      enableMissedCallEmail?: boolean | null;
      smsMmsEmailAlertEnabled?: boolean | null;
      transcriptionEmailAlertEnabled?: boolean | null;
    } | null;
  } | null;
};

export type GetChannelSettingEmailAlertsQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;

export type GetChannelSettingEmailAlertsQuery = {
  __typename?: 'Query';
  getChannelSettingEmailAlerts?: {
    __typename?: 'CallSettingEmailAlertsResponse';
    message?: string | null;
    data?: {
      __typename?: 'CallSettingEmailAlertsType';
      enableMissedCallEmail?: boolean | null;
      smsMmsEmailAlertEnabled?: boolean | null;
      transcriptionEmailAlertEnabled?: boolean | null;
    } | null;
  } | null;
};

export type GetBulkMessagingCampaignRunQueryVariables = Exact<{
  campaignRunId: Scalars['Int']['input'];
}>;

export type GetBulkMessagingCampaignRunQuery = {
  __typename?: 'Query';
  getBulkMessagingCampaignRun?: {
    __typename?: 'GetBulkMessagingCampaignRunResponse';
    message?: string | null;
    data?: {
      __typename?: 'BulkMessagingCampaignRun';
      updatedAt?: any | null;
      totalRecipients?: number | null;
      status?: BulkMessagingRunStatusEnum | null;
      startedAt?: any | null;
      scheduledAt?: any | null;
      runNumber?: number | null;
      initiatedAt?: any | null;
      id?: number | null;
      completedAt?: any | null;
      createdAt?: any | null;
      campaign?: {
        __typename?: 'BulkMessagingRunCampaign';
        campaignType?: BulkMessagingCampaignTypeEnum | null;
        id?: number | null;
        messageTemplate?: string | null;
        name?: string | null;
        phoneNumber?: string | null;
      } | null;
      createdBy?: { __typename?: 'BulkMessagingCampaignCreator'; id?: number | null; name?: string | null } | null;
      deliverySummary?: {
        __typename?: 'BulkMessagingRunDeliverySummary';
        totalProcessed?: number | null;
        totalSent?: number | null;
        totalFailed?: number | null;
        totalDelivered?: number | null;
      } | null;
    } | null;
  } | null;
};

export type GetChannelsByCampaignQueryVariables = Exact<{
  campaignId: Scalars['Int']['input'];
  type: ContactComplianceConsentCampaignTypeEnum;
}>;

export type GetChannelsByCampaignQuery = {
  __typename?: 'Query';
  getChannelsByCampaign?: {
    __typename?: 'ChannelsResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'Channel';
      id?: number | null;
      phoneNumber?: string | null;
      friendlyName?: string | null;
    } | null> | null;
  } | null;
};

export type GetComplianceCampaignSampleMessagesQueryVariables = Exact<{
  campaignId: Scalars['Int']['input'];
  type: ContactComplianceConsentCampaignTypeEnum;
}>;

export type GetComplianceCampaignSampleMessagesQuery = {
  __typename?: 'Query';
  getComplianceCampaignSampleMessages?: {
    __typename?: 'ComplianceCampaignSampleMessagesResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'ComplianceCampaignSampleMessage';
      id?: number | null;
      message?: string | null;
    } | null> | null;
  } | null;
};

export type GetPaymentOrderByIdQueryVariables = Exact<{
  paymentOrderId: Scalars['Int']['input'];
}>;

export type GetPaymentOrderByIdQuery = {
  __typename?: 'Query';
  getPaymentOrderById?: {
    __typename?: 'PaymentOrderResponse';
    message?: string | null;
    data?: {
      __typename?: 'PaymentOrder';
      id?: number | null;
      orderNumber?: string | null;
      cartAmount?: number | null;
      chargedAmount?: number | null;
      status?: string | null;
      lienStatus?: PaymentOrderLienStatusEnum | null;
      type?: PaymentOrderTypeEnum | null;
      remarks?: string | null;
      itemsQuantity?: number | null;
      createdAt?: any | null;
    } | null;
  } | null;
};

export type ReleasedAndScheduledChannelsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  numberTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  channelStatus?: InputMaybe<ReleasedChannelFilterEnum>;
}>;

export type ReleasedAndScheduledChannelsQuery = {
  __typename?: 'Query';
  releasedAndScheduledChannels?: {
    __typename?: 'ChannelsResponse';
    message?: string | null;
    data?: Array<{
      __typename?: 'Channel';
      id?: number | null;
      friendlyName?: string | null;
      phoneNumber?: string | null;
      releasedAt?: any | null;
      numberType?: NumberTypeEnum | null;
      country?: {
        __typename?: 'Country';
        id?: number | null;
        flag?: string | null;
        alphaTwoCode?: string | null;
      } | null;
      removalSchedule?: { __typename?: 'ChannelRemovalSchedule'; scheduleAt?: any | null } | null;
      subscription?: { __typename?: 'BillingSubscription'; nextBillingAt?: any | null } | null;
    } | null> | null;
  } | null;
};

export type MessageConversationSubscriptionVariables = Exact<{
  identity?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type MessageConversationSubscription = {
  __typename?: 'Subscription';
  messageConversation?: {
    __typename?: 'MessageConversation';
    id?: number | null;
    direction?: DirectionTypeEnum | null;
    pinned?: boolean | null;
    channelId?: number | null;
    conversationStatus?: string | null;
    messageContent?: string | null;
    markAsClosed?: boolean | null;
    conversationType?: MessageConversationTypeEnum | null;
    recordingUrl?: string | null;
    friendlyName?: string | null;
    voicemailRecordingUrl?: string | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    forwardedAt?: any | null;
    numMedia?: number | null;
    client?: {
      __typename?: 'Contact';
      id?: number | null;
      name?: string | null;
      phoneNumber?: string | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
    } | null;
    agent?: {
      __typename?: 'UserWorkspace';
      id?: number | null;
      status?: UserWorkspaceStatusEnum | null;
      callPlatform?: DevicePlatformEnum | null;
      user?: {
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
        } | null;
      } | null;
      userOnlineManagement?: {
        __typename?: 'UserOnlineManagement';
        id?: number | null;
        userWorkspaceId?: number | null;
        workspaceId?: number | null;
        isActive?: boolean | null;
        lastSeenAt?: any | null;
        awayTill?: any | null;
        message?: string | null;
        icon?: string | null;
        activeStatus?: UserActiveStatusEnum | null;
      } | null;
      workspace?: {
        __typename?: 'Workspace';
        id?: number | null;
        label?: string | null;
        status?: WorkspaceStatusEnum | null;
        trusted?: boolean | null;
      } | null;
    } | null;
    voicemailRecording?: {
      __typename?: 'Recording';
      id?: number | null;
      url?: string | null;
      duration?: number | null;
    } | null;
    callRecording?: {
      __typename?: 'Recording';
      id?: number | null;
      url?: string | null;
      duration?: number | null;
    } | null;
    durationConference?: {
      __typename?: 'DurationConference';
      id?: number | null;
      startDate?: any | null;
      endDate?: any | null;
    } | null;
    forwardedTo?: { __typename?: 'ForwardToExternalNumber'; externalNumber?: string | null } | null;
    messageConversationErrorLog?: {
      __typename?: 'MessageConversationErrorLog';
      code?: string | null;
      message?: string | null;
      statusCode?: string | null;
    } | null;
  } | null;
};

export type AssignedChannelCounterSubscriptionVariables = Exact<{
  identity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type AssignedChannelCounterSubscription = {
  __typename?: 'Subscription';
  assignedChannelCounter?: {
    __typename?: 'AssignedChannelCounter';
    counter?: number | null;
    channelId?: number | null;
    clientId?: number | null;
    from?: string | null;
  } | null;
};

export type NotificationSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type NotificationSubscriptionSubscription = {
  __typename?: 'Subscription';
  notificationSubscription?: {
    __typename?: 'NotificationSubscription';
    counter?: number | null;
    userWorkspaceId?: number | null;
    notification?: {
      __typename?: 'NotificationV2';
      id?: number | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      imageUrl?: string | null;
      title?: string | null;
      body?: string | null;
      isExternal?: boolean | null;
      type?: string | null;
      redirectUrl?: string | null;
      redirection?: {
        __typename?: 'RedirectionParamsData';
        key?: string | null;
        params?: {
          __typename?: 'RedirectionData';
          channelId?: number | null;
          clientId?: number | null;
          clientName?: string | null;
          markAsClosed?: boolean | null;
          pinned?: boolean | null;
        } | null;
      } | null;
      replacementAttributes?: Array<{
        __typename?: 'ReplacementAttributesData';
        key?: string | null;
        value?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type callerIdVerificationSubscriptionVariables = Exact<{ [key: string]: never }>;

export type callerIdVerificationSubscription = {
  __typename?: 'Subscription';
  callerIdVerification?: {
    __typename?: 'CallerId';
    id?: number | null;
    friendlyName?: string | null;
    phoneNumber?: string | null;
    sid?: string | null;
    createdAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type ImportBulkContactProgressSubscriptionVariables = Exact<{
  eventReferenceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ImportBulkContactProgressSubscription = {
  __typename?: 'Subscription';
  importBulkContactProgress?: {
    __typename?: 'ImportBulkContactProgressResponse';
    progress?: number | null;
    status?: string | null;
  } | null;
};

export type WalletUsageHistoryExportMediaSubscriptionVariables = Exact<{
  identity: Scalars['String']['input'];
}>;

export type WalletUsageHistoryExportMediaSubscription = {
  __typename?: 'Subscription';
  walletUsageHistoryExportMedia?: { __typename?: 'Media'; url?: string | null; id?: number | null } | null;
};

export type ExportInvoicesStatusSubscriptionVariables = Exact<{ [key: string]: never }>;

export type ExportInvoicesStatusSubscription = {
  __typename?: 'Subscription';
  exportInvoicesStatus?: {
    __typename?: 'ExportInvoiceStatusResponse';
    status?: string | null;
    data?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
  } | null;
};

export type DialerCallPulseSubscriptionVariables = Exact<{
  identity: Scalars['String']['input'];
}>;

export type DialerCallPulseSubscription = {
  __typename?: 'Subscription';
  dialerCallPulse?: { __typename?: 'DialerCallPulse'; feature?: CallFeatureEnum | null; data?: any | null } | null;
};

export type MessageConversationErrorLogSubscriptionVariables = Exact<{ [key: string]: never }>;

export type MessageConversationErrorLogSubscription = {
  __typename?: 'Subscription';
  messageConversationErrorLog?: {
    __typename?: 'MessageConversationErrorLog';
    id?: number | null;
    message?: string | null;
    code?: string | null;
    statusCode?: string | null;
    workspaceId?: number | null;
    createdAt?: any | null;
  } | null;
};

export type ChatMessageSubscriptionVariables = Exact<{ [key: string]: never }>;

export type ChatMessageSubscription = {
  __typename?: 'Subscription';
  chatMessage?: {
    __typename?: 'ChatMessage';
    id?: number | null;
    body?: string | null;
    createdAt?: any | null;
    isPinned?: boolean | null;
    type?: MessageTypeEnum | null;
    sender?: {
      __typename?: 'UserWorkspace';
      id?: number | null;
      status?: UserWorkspaceStatusEnum | null;
      user?: {
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        emailVerifiedAt?: any | null;
        profilePicture?: {
          __typename?: 'Media';
          id?: number | null;
          url?: string | null;
          originalname?: string | null;
          size?: number | null;
          key?: string | null;
          mimetype?: string | null;
        } | null;
      } | null;
      userOnlineManagement?: {
        __typename?: 'UserOnlineManagement';
        id?: number | null;
        userWorkspaceId?: number | null;
        workspaceId?: number | null;
        isActive?: boolean | null;
        lastSeenAt?: any | null;
        awayTill?: any | null;
        message?: string | null;
        icon?: string | null;
        activeStatus?: UserActiveStatusEnum | null;
        userWorkspace?: {
          __typename?: 'UserWorkspace';
          id?: number | null;
          status?: UserWorkspaceStatusEnum | null;
        } | null;
      } | null;
      workspace?: {
        __typename?: 'Workspace';
        id?: number | null;
        label?: string | null;
        status?: WorkspaceStatusEnum | null;
        trusted?: boolean | null;
      } | null;
    } | null;
    room?: { __typename?: 'Room'; id?: number | null } | null;
    messageConversation?: {
      __typename?: 'CallThread';
      id?: number | null;
      conversationStatus?: string | null;
      effectiveStartedAt?: any | null;
      effectiveEndedAt?: any | null;
    } | null;
  } | null;
};

export type WorkspaceMembersOnlineManagementSubscriptionVariables = Exact<{ [key: string]: never }>;

export type WorkspaceMembersOnlineManagementSubscription = {
  __typename?: 'Subscription';
  workspaceMembersOnlineManagement?: {
    __typename?: 'UserOnlineManagement';
    isActive?: boolean | null;
    message?: string | null;
    lastSeenAt?: any | null;
    id?: number | null;
    icon?: string | null;
    awayTill?: any | null;
    activeStatus?: UserActiveStatusEnum | null;
    workspace?: { __typename?: 'Workspace'; id?: number | null } | null;
    userWorkspace?: { __typename?: 'UserWorkspace'; id?: number | null } | null;
  } | null;
};

export type WorkspaceRateLimitSubscriptionVariables = Exact<{ [key: string]: never }>;

export type WorkspaceRateLimitSubscription = {
  __typename?: 'Subscription';
  workspaceRateLimit?: Array<{
    __typename?: 'WorkspaceRateLimit';
    id?: number | null;
    category?: WorkspaceRateLimitExhaustCategoryEnum | null;
    direction?: DirectionTypeEnum | null;
    threshold?: number | null;
    timeLimit?: number | null;
    segmentLimit?: number | null;
    exhaust?: { __typename?: 'WorkspaceRateLimitExhaust'; value?: number | null } | null;
  } | null> | null;
};

export type walletDetailsSubscriptionVariables = Exact<{ [key: string]: never }>;

export type walletDetailsSubscription = {
  __typename?: 'Subscription';
  walletDetails?: { __typename?: 'WalletDetailsResponse'; amount: number } | null;
};

export type MessageScheduleSubscriptionVariables = Exact<{
  identity?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type MessageScheduleSubscription = {
  __typename?: 'Subscription';
  messageSchedule?: {
    __typename?: 'MessageSchedule';
    id: string;
    messageContent?: string | null;
    createdAt: any;
    client: {
      __typename?: 'Contact';
      id?: number | null;
      phoneNumber?: string | null;
      country?: { __typename?: 'Country'; id?: number | null; flag?: string | null } | null;
    };
    channel: { __typename?: 'Channel'; id?: number | null; phoneNumber?: string | null; identity?: string | null };
    attachments?: Array<{ __typename?: 'Media'; id?: number | null; url?: string | null } | null> | null;
  } | null;
};

export type ExportContactStatusSubscriptionVariables = Exact<{ [key: string]: never }>;

export type ExportContactStatusSubscription = {
  __typename?: 'Subscription';
  exportContactStatus?: {
    __typename?: 'ExportContactStatusResponse';
    status?: string | null;
    data?: {
      __typename?: 'Media';
      url?: string | null;
      size?: number | null;
      originalname?: string | null;
      mimetype?: string | null;
      key?: string | null;
      id?: number | null;
    } | null;
  } | null;
};

export type SendTranscriptionStatusSubscriptionVariables = Exact<{ [key: string]: never }>;

export type SendTranscriptionStatusSubscription = {
  __typename?: 'Subscription';
  sendTranscriptionStatus?: {
    __typename?: 'TranscriptionInformation';
    id?: number | null;
    jobStatus?: JobStatusEnum | null;
    providerCallRecordingsId?: number | null;
  } | null;
};

export type liveConferenceSubscriptionVariables = Exact<{ [key: string]: never }>;

export type liveConferenceSubscription = {
  __typename?: 'Subscription';
  liveConference?: {
    __typename?: 'LiveConference';
    id?: number | null;
    direction?: string | null;
    conversationStatus?: string | null;
    createdAt?: any | null;
    agent?: {
      __typename?: 'UserWorkspace';
      callPlatform?: DevicePlatformEnum | null;
      user?: {
        __typename?: 'User';
        id?: number | null;
        name?: string | null;
        profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
      } | null;
      userOnlineManagement?: { __typename?: 'UserOnlineManagement'; isActive?: boolean | null } | null;
    } | null;
    client?: {
      __typename?: 'Contact';
      id?: number | null;
      name?: string | null;
      phoneNumber?: string | null;
      country?: { __typename?: 'Country'; flag?: string | null } | null;
      profilePicture?: { __typename?: 'Media'; id?: number | null; url?: string | null } | null;
    } | null;
    channel?: {
      __typename?: 'Channel';
      friendlyName?: string | null;
      phoneNumber?: string | null;
      identity?: string | null;
      country?: { __typename?: 'Country'; flag?: string | null } | null;
    } | null;
    durationConference?: { __typename?: 'Duration'; startDate?: any | null } | null;
  } | null;
};

export type LiveConferenceCountSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type LiveConferenceCountSubscriptionSubscription = {
  __typename?: 'Subscription';
  liveConferenceCount?: { __typename?: 'LiveConferenceCount'; count?: number | null } | null;
};

export type WorkspaceCounterSubscriptionVariables = Exact<{ [key: string]: never }>;

export type WorkspaceCounterSubscription = {
  __typename?: 'Subscription';
  workspaceCounter?: {
    __typename?: 'WorkspaceCounters';
    workspaceId?: number | null;
    to?: string | null;
    from?: string | null;
    counter?: number | null;
    channelId?: number | null;
    userWorkspaceId?: number | null;
  } | null;
};

export type KycVerificationSessionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type KycVerificationSessionSubscription = {
  __typename?: 'Subscription';
  kycVerificationSession?: {
    __typename?: 'KycVerificationSession';
    id?: number | null;
    status?: KycVerificationSessionsStatus | null;
    workspaceId?: number | null;
  } | null;
};

export type WorkspaceMemberNotificationCounterSubscriptionVariables = Exact<{ [key: string]: never }>;

export type WorkspaceMemberNotificationCounterSubscription = {
  __typename?: 'Subscription';
  workspaceMemberNotificationCounter?: {
    __typename?: 'WorkspaceMemberNotificationCounter';
    counter?: number | null;
    memberId?: number | null;
    roomId?: number | null;
    type?: string | null;
    userWorkspaceId?: number | null;
  } | null;
};

export type PaymentOrderCreatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type PaymentOrderCreatedSubscription = {
  __typename?: 'Subscription';
  paymentOrderCreated?: {
    __typename?: 'PaymentOrder';
    id?: number | null;
    orderNumber?: string | null;
    workspaceId?: number | null;
    userId?: number | null;
    clientRequestId?: string | null;
    batchId?: string | null;
    cartAmount?: number | null;
    chargedAmount?: number | null;
    status?: string | null;
    lienStatus?: PaymentOrderLienStatusEnum | null;
    type?: PaymentOrderTypeEnum | null;
    remarks?: string | null;
    itemsQuantity?: number | null;
    dunningAttempt?: number | null;
    failureReason?: string | null;
    createdAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export const AssignChannelsV2Document = gql`
  query AssignChannelsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $order: String
    $limit: Int
    $query: String
    $sort: SortEnum
  ) {
    assignChannelsV2(cursor: $cursor, direction: $direction, limit: $limit, order: $order, query: $query, sort: $sort) {
      message
      data {
        id
        channel {
          id
          friendlyName
          country {
            name
            flag
          }
          channelGroup {
            id
            callSetting {
              id
              friendlyName
            }
          }
          phoneNumber
          unreadCounter
          v2MigratedAt
        }
        pinned
        isDefault
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useAssignChannelsV2Query__
 *
 * To run a query within a React component, call `useAssignChannelsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAssignChannelsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignChannelsV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      order: // value for 'order'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAssignChannelsV2Query(
  baseOptions?: Apollo.QueryHookOptions<AssignChannelsV2Query, AssignChannelsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssignChannelsV2Query, AssignChannelsV2QueryVariables>(AssignChannelsV2Document, options);
}
export function useAssignChannelsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AssignChannelsV2Query, AssignChannelsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AssignChannelsV2Query, AssignChannelsV2QueryVariables>(AssignChannelsV2Document, options);
}
// @ts-ignore
export function useAssignChannelsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AssignChannelsV2Query, AssignChannelsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<AssignChannelsV2Query, AssignChannelsV2QueryVariables>;
export function useAssignChannelsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AssignChannelsV2Query, AssignChannelsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<AssignChannelsV2Query | undefined, AssignChannelsV2QueryVariables>;
export function useAssignChannelsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AssignChannelsV2Query, AssignChannelsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AssignChannelsV2Query, AssignChannelsV2QueryVariables>(
    AssignChannelsV2Document,
    options
  );
}
export type AssignChannelsV2QueryHookResult = ReturnType<typeof useAssignChannelsV2Query>;
export type AssignChannelsV2LazyQueryHookResult = ReturnType<typeof useAssignChannelsV2LazyQuery>;
export type AssignChannelsV2SuspenseQueryHookResult = ReturnType<typeof useAssignChannelsV2SuspenseQuery>;
export type AssignChannelsV2QueryResult = Apollo.QueryResult<AssignChannelsV2Query, AssignChannelsV2QueryVariables>;
export const GetAllNotificationV2Document = gql`
  query GetAllNotificationV2($sort: SortEnum, $cursor: String, $direction: CursorDirectionEnum) {
    getAllNotificationV2(sort: $sort, cursor: $cursor, direction: $direction) {
      data {
        id
        createdAt
        updatedAt
        imageUrl
        title
        body
        isExternal
        type
        redirection {
          key
          params {
            memberId
            channelId
            clientId
            clientName
            markAsClosed
            pinned
          }
        }
        replacementAttributes {
          key
          value
        }
        redirectUrl
        seenAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetAllNotificationV2Query__
 *
 * To run a query within a React component, call `useGetAllNotificationV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNotificationV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNotificationV2Query({
 *   variables: {
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useGetAllNotificationV2Query(
  baseOptions?: Apollo.QueryHookOptions<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>(
    GetAllNotificationV2Document,
    options
  );
}
export function useGetAllNotificationV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>(
    GetAllNotificationV2Document,
    options
  );
}
// @ts-ignore
export function useGetAllNotificationV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>
): Apollo.UseSuspenseQueryResult<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>;
export function useGetAllNotificationV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>
): Apollo.UseSuspenseQueryResult<GetAllNotificationV2Query | undefined, GetAllNotificationV2QueryVariables>;
export function useGetAllNotificationV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>(
    GetAllNotificationV2Document,
    options
  );
}
export type GetAllNotificationV2QueryHookResult = ReturnType<typeof useGetAllNotificationV2Query>;
export type GetAllNotificationV2LazyQueryHookResult = ReturnType<typeof useGetAllNotificationV2LazyQuery>;
export type GetAllNotificationV2SuspenseQueryHookResult = ReturnType<typeof useGetAllNotificationV2SuspenseQuery>;
export type GetAllNotificationV2QueryResult = Apollo.QueryResult<
  GetAllNotificationV2Query,
  GetAllNotificationV2QueryVariables
>;
export const ChannelsV2Document = gql`
  query ChannelsV2(
    $cursor: String
    $sort: SortEnum
    $query: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $countryIds: [Int]
    $numberTypes: [String]
  ) {
    channelsV2(
      cursor: $cursor
      sort: $sort
      query: $query
      direction: $direction
      limit: $limit
      order: $order
      countryIds: $countryIds
      numberTypes: $numberTypes
    ) {
      message
      data {
        id
        friendlyName
        phoneNumber
        identity
        emergencyStatus
        beta
        isAssigned
        country {
          id
          flag
        }
        channelGroup {
          id
          name
          callSetting {
            id
            businessHourType
            metrics {
              key
              value
            }
            friendlyName
            recording
            incomingTimeout
            callerId {
              id
              friendlyName
              phoneNumber
            }
          }
        }
        assignedUsers {
          name
          id
          profilePicture {
            id
            url
          }
        }
        capability {
          fax
          mms
          sms
          voice
        }
        subscription {
          nextBillingAt
        }
        channelUserWorkspaces {
          id
          userWorkspace {
            id
            user {
              id
              name
              profilePicture {
                id
                url
                originalname
                size
                key
                mimetype
              }
            }
            status
          }
        }
        numberType
        createdAt
        metrics {
          key
          value
        }
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useChannelsV2Query__
 *
 * To run a query within a React component, call `useChannelsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useChannelsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      countryIds: // value for 'countryIds'
 *      numberTypes: // value for 'numberTypes'
 *   },
 * });
 */
export function useChannelsV2Query(baseOptions?: Apollo.QueryHookOptions<ChannelsV2Query, ChannelsV2QueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelsV2Query, ChannelsV2QueryVariables>(ChannelsV2Document, options);
}
export function useChannelsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChannelsV2Query, ChannelsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelsV2Query, ChannelsV2QueryVariables>(ChannelsV2Document, options);
}
// @ts-ignore
export function useChannelsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelsV2Query, ChannelsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelsV2Query, ChannelsV2QueryVariables>;
export function useChannelsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelsV2Query, ChannelsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelsV2Query | undefined, ChannelsV2QueryVariables>;
export function useChannelsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelsV2Query, ChannelsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelsV2Query, ChannelsV2QueryVariables>(ChannelsV2Document, options);
}
export type ChannelsV2QueryHookResult = ReturnType<typeof useChannelsV2Query>;
export type ChannelsV2LazyQueryHookResult = ReturnType<typeof useChannelsV2LazyQuery>;
export type ChannelsV2SuspenseQueryHookResult = ReturnType<typeof useChannelsV2SuspenseQuery>;
export type ChannelsV2QueryResult = Apollo.QueryResult<ChannelsV2Query, ChannelsV2QueryVariables>;
export const InProcessPhoneNumbersV2Document = gql`
  query InProcessPhoneNumbersV2(
    $cursor: String
    $query: String
    $limit: Int
    $direction: CursorDirectionEnum
    $sort: SortEnum
    $order: String
  ) {
    inProcessPhoneNumbersV2(
      cursor: $cursor
      query: $query
      limit: $limit
      direction: $direction
      sort: $sort
      order: $order
    ) {
      message
      data {
        id
        phoneNumber
        friendlyName
        status
        source
        numberType
        capabilities {
          voice
          SMS
          MMS
        }
        country {
          id
          name
          slug
          dialingCode
          alphaTwoCode
          alphaThreeCode
          numeric
          flag
        }
        createdAt
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useInProcessPhoneNumbersV2Query__
 *
 * To run a query within a React component, call `useInProcessPhoneNumbersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useInProcessPhoneNumbersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInProcessPhoneNumbersV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      direction: // value for 'direction'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInProcessPhoneNumbersV2Query(
  baseOptions?: Apollo.QueryHookOptions<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>(
    InProcessPhoneNumbersV2Document,
    options
  );
}
export function useInProcessPhoneNumbersV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>(
    InProcessPhoneNumbersV2Document,
    options
  );
}
// @ts-ignore
export function useInProcessPhoneNumbersV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>
): Apollo.UseSuspenseQueryResult<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>;
export function useInProcessPhoneNumbersV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>
): Apollo.UseSuspenseQueryResult<InProcessPhoneNumbersV2Query | undefined, InProcessPhoneNumbersV2QueryVariables>;
export function useInProcessPhoneNumbersV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InProcessPhoneNumbersV2Query, InProcessPhoneNumbersV2QueryVariables>(
    InProcessPhoneNumbersV2Document,
    options
  );
}
export type InProcessPhoneNumbersV2QueryHookResult = ReturnType<typeof useInProcessPhoneNumbersV2Query>;
export type InProcessPhoneNumbersV2LazyQueryHookResult = ReturnType<typeof useInProcessPhoneNumbersV2LazyQuery>;
export type InProcessPhoneNumbersV2SuspenseQueryHookResult = ReturnType<typeof useInProcessPhoneNumbersV2SuspenseQuery>;
export type InProcessPhoneNumbersV2QueryResult = Apollo.QueryResult<
  InProcessPhoneNumbersV2Query,
  InProcessPhoneNumbersV2QueryVariables
>;
export const PurchaseFailedPhoneNumbersDocument = gql`
  query PurchaseFailedPhoneNumbers(
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $query: String
    $order: String
    $sort: SortEnum
  ) {
    purchaseFailedPhoneNumbers(
      cursor: $cursor
      direction: $direction
      limit: $limit
      query: $query
      order: $order
      sort: $sort
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        meta {
          addressRequirements
          isoCountry
          phoneNumber
          friendlyName
          region
          rateCenter
          capabilities {
            voice
            SMS
            MMS
          }
          numberType
          basePrice
          currentPrice
          supportingDocument
          endUser
          beta
        }
        status
        workspace {
          id
          secret
          label
          isCurrent
          providerAccount {
            sid
            status
            systemSuspend
          }
          workspaceDetails {
            id
            name
            socialUrl
            noOfEmployees
            accountType
            address {
              id
              street
              suburb
              state
              country
              street2
              zipcode
            }
            planPrice {
              id
              amount
              periodicity
              isPublished
              plan {
                id
                label
                name
                slug
                shortDescription
                description
                features
                recommendation
                showAmount
                referencePlan {
                  id
                  label
                  name
                  slug
                  shortDescription
                  description
                  features
                  recommendation
                  showAmount
                }
              }
              position
              rank
            }
            documents {
              id
              url
              originalname
              size
              key
              mimetype
              createdAt
            }
            useCases {
              value
            }
          }
          status
          hasCompleted
          logo {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          active
          owner {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
              createdAt
            }
            roles {
              id
              label
              slug
              level
              isActive
              isDefault
              position
              roleMaps {
                id
                isDefault
                isPublished
                isActive
                screen {
                  id
                  name
                  slug
                  isDefault
                  isActive
                  description
                }
                privilege {
                  id
                  name
                  slug
                  isDefault
                }
              }
            }
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            workspaces {
              id
              secret
              label
              isCurrent
              status
              hasCompleted
              active
              totalPhoneNumbers
              numberOfUsers
              timezone
              createdAt
              unreadCountWorkspace
              salesDealCreatedAt
              salesDealCreatedById
              pkReference
              timezoneId
              kycVerified
              trusted
            }
            language
            emailVerifiedAt
          }
          totalPhoneNumbers
          numberOfUsers
          incomingPhoneNumbers {
            _id
            providerNumber {
              addressRequirements
              isoCountry
              phoneNumber
              friendlyName
              region
              rateCenter
              numberType
              basePrice
              currentPrice
              supportingDocument
              endUser
              beta
            }
            status
            createdAt
            updatedAt
          }
          phoneNumbers {
            id
            status
            createdAt
            updatedAt
          }
          timezone
          riskScore {
            id
            documentVerificationScore
            userNumberRatioScore
            usernameCardNameScore
            countryLocationScore
            signupCardLocationScore
            referralScore
            incorporationDateScore
            totalScore
          }
          subscription {
            name
            dueIn
            monthlyFees
            billingCycleDate
            status
            transactionDate
            canceledReason
            canceledAt
            cancelScheduledAt
          }
          channels {
            id
            friendlyName
            phoneNumber
            identity
            channelUserWorkspaces {
              id
              userWorkspace {
                id
                status
                identity
              }
              channel {
                id
                friendlyName
                phoneNumber
                identity
                numberType
                purchaseAt
                releasedAt
                createdAt
                updatedAt
                numberState
                a2pVerified
                unreadCountChannel
                emergencyStatus
                beta
                isFree
                unreadCounter
              }
              isDefault
            }
            numberType
            setting {
              id
              recording
              welcomeMessage
              welcomeMessageSay {
                message
                attributes {
                  language
                  voice
                }
              }
              welcomeMessageLoop
              voicemail
              voicemailSay {
                message
              }
              voicemailLoop
              welcomeMessagePlay {
                id
                url
                originalname
                size
                key
                mimetype
                createdAt
              }
              voicemailPlay {
                id
                url
                originalname
                size
                key
                mimetype
                createdAt
              }
              caller {
                id
                friendlyName
                phoneNumber
                sid
                createdAt
                updatedAt
              }
              autoTranscribe
              forwardToExternalNumber
              forwardToExternalNumberPlay {
                id
                url
                originalname
                size
                key
                mimetype
                createdAt
              }
              forwardToExternalNumberSay {
                message
              }
              forwardToExternalNumberLoop
              externalNumber {
                externalNumber
              }
              enableVoiceMailEmail
            }
            purchaseAt
            releasedAt
            createdAt
            updatedAt
            capability {
              fax
              mms
              sms
              voice
            }
            numberState
            a2pVerified
            unreadCountChannel
            emergencyStatus
            beta
            integrationChannels {
              id
              memberCount
              integrationUserId
              workspaceId
              isEnabled
            }
            isFree
            assignedUsers {
              id
              name
              email
              phoneNumber
              address
              dueIn
              accountStatus
              timezone
              averageRiskScore
              totalMonthlyFee
              language
              emailVerifiedAt
            }
            unreadCounter
          }
          createdAt
          unreadCountWorkspace
          salesDealCreatedAt
          salesDealCreatedById
          salesDealCreatedBy {
            id
            name
            email
            phoneNumber
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            language
            emailVerifiedAt
          }
          pkReference
          timezoneId
          kycVerified
          trusted
          currentUserWorkspace {
            id
            status
            identity
          }
        }
        purchaseBy {
          id
          status
          userOnlineManagement {
            isActive
            lastSeenAt
            activeStatus
            awayTill
            message
            awaySet
            icon
          }
          user {
            id
            name
            email
            phoneNumber
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            language
            emailVerifiedAt
          }
          userWorkspaceRoles {
            role {
              id
              label
              slug
              level
              isActive
              isDefault
              position
            }
          }
          identity
        }
        country {
          id
          name
          slug
          dialingCode
          alphaTwoCode
          alphaThreeCode
          numeric
          flag
        }
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __usePurchaseFailedPhoneNumbersQuery__
 *
 * To run a query within a React component, call `usePurchaseFailedPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseFailedPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseFailedPhoneNumbersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePurchaseFailedPhoneNumbersQuery(
  baseOptions?: Apollo.QueryHookOptions<PurchaseFailedPhoneNumbersQuery, PurchaseFailedPhoneNumbersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PurchaseFailedPhoneNumbersQuery, PurchaseFailedPhoneNumbersQueryVariables>(
    PurchaseFailedPhoneNumbersDocument,
    options
  );
}
export function usePurchaseFailedPhoneNumbersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PurchaseFailedPhoneNumbersQuery, PurchaseFailedPhoneNumbersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PurchaseFailedPhoneNumbersQuery, PurchaseFailedPhoneNumbersQueryVariables>(
    PurchaseFailedPhoneNumbersDocument,
    options
  );
}
// @ts-ignore
export function usePurchaseFailedPhoneNumbersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PurchaseFailedPhoneNumbersQuery,
    PurchaseFailedPhoneNumbersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<PurchaseFailedPhoneNumbersQuery, PurchaseFailedPhoneNumbersQueryVariables>;
export function usePurchaseFailedPhoneNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PurchaseFailedPhoneNumbersQuery, PurchaseFailedPhoneNumbersQueryVariables>
): Apollo.UseSuspenseQueryResult<PurchaseFailedPhoneNumbersQuery | undefined, PurchaseFailedPhoneNumbersQueryVariables>;
export function usePurchaseFailedPhoneNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PurchaseFailedPhoneNumbersQuery, PurchaseFailedPhoneNumbersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PurchaseFailedPhoneNumbersQuery, PurchaseFailedPhoneNumbersQueryVariables>(
    PurchaseFailedPhoneNumbersDocument,
    options
  );
}
export type PurchaseFailedPhoneNumbersQueryHookResult = ReturnType<typeof usePurchaseFailedPhoneNumbersQuery>;
export type PurchaseFailedPhoneNumbersLazyQueryHookResult = ReturnType<typeof usePurchaseFailedPhoneNumbersLazyQuery>;
export type PurchaseFailedPhoneNumbersSuspenseQueryHookResult = ReturnType<
  typeof usePurchaseFailedPhoneNumbersSuspenseQuery
>;
export type PurchaseFailedPhoneNumbersQueryResult = Apollo.QueryResult<
  PurchaseFailedPhoneNumbersQuery,
  PurchaseFailedPhoneNumbersQueryVariables
>;
export const RecentMessageConversationsV2Document = gql`
  query RecentMessageConversationsV2(
    $channelId: Int!
    $query: String
    $sort: SortEnum
    $direction: CursorDirectionEnum
    $cursor: String
    $limit: Int
    $markAsClosed: Boolean
    $conversationStatus: [String]
    $messageDirection: DirectionTypeEnum
    $voicemail: Boolean
    $scheduleMessage: Boolean
  ) {
    recentMessageConversationsV2(
      channelId: $channelId
      query: $query
      sort: $sort
      direction: $direction
      cursor: $cursor
      limit: $limit
      markAsClosed: $markAsClosed
      conversationStatus: $conversationStatus
      messageDirection: $messageDirection
      voicemail: $voicemail
      scheduleMessage: $scheduleMessage
    ) {
      cursor {
        endCursor
        hasNextPage
        startCursor
        hasPreviousPage
      }
      data {
        id
        updatedAt
        unreadCounter
        lastReadCursor
        pinned
        channel {
          id
        }
        client {
          id
          name
          phoneNumber
          isBlocked
          country {
            id
            flag
          }
          profilePicture {
            id
            url
          }
        }
        markAsClosed
        messageConversation {
          numMedia
          conversationType
          conversationStatus
          direction
          messageContent
          pinned
          voicemailRecordingUrl
          forwardedTo {
            externalNumber
          }
        }
        draft {
          mediaCount
          messageContent
        }
        hasScheduledMessages
      }
    }
  }
`;

/**
 * __useRecentMessageConversationsV2Query__
 *
 * To run a query within a React component, call `useRecentMessageConversationsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useRecentMessageConversationsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentMessageConversationsV2Query({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      direction: // value for 'direction'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      markAsClosed: // value for 'markAsClosed'
 *      conversationStatus: // value for 'conversationStatus'
 *      messageDirection: // value for 'messageDirection'
 *      voicemail: // value for 'voicemail'
 *      scheduleMessage: // value for 'scheduleMessage'
 *   },
 * });
 */
export function useRecentMessageConversationsV2Query(
  baseOptions: Apollo.QueryHookOptions<RecentMessageConversationsV2Query, RecentMessageConversationsV2QueryVariables> &
    ({ variables: RecentMessageConversationsV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecentMessageConversationsV2Query, RecentMessageConversationsV2QueryVariables>(
    RecentMessageConversationsV2Document,
    options
  );
}
export function useRecentMessageConversationsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecentMessageConversationsV2Query,
    RecentMessageConversationsV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecentMessageConversationsV2Query, RecentMessageConversationsV2QueryVariables>(
    RecentMessageConversationsV2Document,
    options
  );
}
// @ts-ignore
export function useRecentMessageConversationsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecentMessageConversationsV2Query,
    RecentMessageConversationsV2QueryVariables
  >
): Apollo.UseSuspenseQueryResult<RecentMessageConversationsV2Query, RecentMessageConversationsV2QueryVariables>;
export function useRecentMessageConversationsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecentMessageConversationsV2Query, RecentMessageConversationsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<
  RecentMessageConversationsV2Query | undefined,
  RecentMessageConversationsV2QueryVariables
>;
export function useRecentMessageConversationsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecentMessageConversationsV2Query, RecentMessageConversationsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RecentMessageConversationsV2Query, RecentMessageConversationsV2QueryVariables>(
    RecentMessageConversationsV2Document,
    options
  );
}
export type RecentMessageConversationsV2QueryHookResult = ReturnType<typeof useRecentMessageConversationsV2Query>;
export type RecentMessageConversationsV2LazyQueryHookResult = ReturnType<
  typeof useRecentMessageConversationsV2LazyQuery
>;
export type RecentMessageConversationsV2SuspenseQueryHookResult = ReturnType<
  typeof useRecentMessageConversationsV2SuspenseQuery
>;
export type RecentMessageConversationsV2QueryResult = Apollo.QueryResult<
  RecentMessageConversationsV2Query,
  RecentMessageConversationsV2QueryVariables
>;
export const MessageConversationsV2Document = gql`
  query MessageConversationsV2(
    $cursor: String
    $withCursor: Boolean
    $direction: CursorDirectionEnum
    $limit: Int
    $sort: SortEnum
    $order: String
    $clientId: Int!
    $channelId: Int!
  ) {
    messageConversationsV2(
      cursor: $cursor
      withCursor: $withCursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
      clientId: $clientId
      channelId: $channelId
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        messageContent
        markAsClosed
        direction
        durationConference {
          endDate
          startDate
        }
        client {
          id
          name
          phoneNumber
          country {
            id
            flag
          }
          profilePicture {
            id
            url
          }
        }
        agent {
          callPlatform
          user {
            id
            name
            profilePicture {
              id
              url
            }
          }
          userOnlineManagement {
            isActive
          }
        }
        pinned
        conversationStatus
        conversationType
        recordingUrl
        numMedia
        friendlyName
        voicemailRecordingUrl
        createdAt
        forwardedAt
        forwardedTo {
          externalNumber
        }
        messageConversationErrorLog {
          message
          code
          statusCode
        }
        callRecording {
          id
          url
          transcription {
            id
            jobStatus
          }
        }
        voicemailRecording {
          id
          url
          transcription {
            id
            jobStatus
          }
        }
        markAsBlocked
      }
    }
  }
`;

/**
 * __useMessageConversationsV2Query__
 *
 * To run a query within a React component, call `useMessageConversationsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useMessageConversationsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageConversationsV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      withCursor: // value for 'withCursor'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *      clientId: // value for 'clientId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useMessageConversationsV2Query(
  baseOptions: Apollo.QueryHookOptions<MessageConversationsV2Query, MessageConversationsV2QueryVariables> &
    ({ variables: MessageConversationsV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MessageConversationsV2Query, MessageConversationsV2QueryVariables>(
    MessageConversationsV2Document,
    options
  );
}
export function useMessageConversationsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MessageConversationsV2Query, MessageConversationsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MessageConversationsV2Query, MessageConversationsV2QueryVariables>(
    MessageConversationsV2Document,
    options
  );
}
// @ts-ignore
export function useMessageConversationsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MessageConversationsV2Query, MessageConversationsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<MessageConversationsV2Query, MessageConversationsV2QueryVariables>;
export function useMessageConversationsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessageConversationsV2Query, MessageConversationsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<MessageConversationsV2Query | undefined, MessageConversationsV2QueryVariables>;
export function useMessageConversationsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessageConversationsV2Query, MessageConversationsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MessageConversationsV2Query, MessageConversationsV2QueryVariables>(
    MessageConversationsV2Document,
    options
  );
}
export type MessageConversationsV2QueryHookResult = ReturnType<typeof useMessageConversationsV2Query>;
export type MessageConversationsV2LazyQueryHookResult = ReturnType<typeof useMessageConversationsV2LazyQuery>;
export type MessageConversationsV2SuspenseQueryHookResult = ReturnType<typeof useMessageConversationsV2SuspenseQuery>;
export type MessageConversationsV2QueryResult = Apollo.QueryResult<
  MessageConversationsV2Query,
  MessageConversationsV2QueryVariables
>;
export const CannedResponsesV2Document = gql`
  query CannedResponsesV2(
    $query: String
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $sort: SortEnum
  ) {
    cannedResponsesV2(
      query: $query
      cursor: $cursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
    ) {
      message
      data {
        id
        title
        command
        content
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useCannedResponsesV2Query__
 *
 * To run a query within a React component, call `useCannedResponsesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCannedResponsesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCannedResponsesV2Query({
 *   variables: {
 *      query: // value for 'query'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCannedResponsesV2Query(
  baseOptions?: Apollo.QueryHookOptions<CannedResponsesV2Query, CannedResponsesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CannedResponsesV2Query, CannedResponsesV2QueryVariables>(CannedResponsesV2Document, options);
}
export function useCannedResponsesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CannedResponsesV2Query, CannedResponsesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CannedResponsesV2Query, CannedResponsesV2QueryVariables>(
    CannedResponsesV2Document,
    options
  );
}
// @ts-ignore
export function useCannedResponsesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CannedResponsesV2Query, CannedResponsesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<CannedResponsesV2Query, CannedResponsesV2QueryVariables>;
export function useCannedResponsesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CannedResponsesV2Query, CannedResponsesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<CannedResponsesV2Query | undefined, CannedResponsesV2QueryVariables>;
export function useCannedResponsesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CannedResponsesV2Query, CannedResponsesV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CannedResponsesV2Query, CannedResponsesV2QueryVariables>(
    CannedResponsesV2Document,
    options
  );
}
export type CannedResponsesV2QueryHookResult = ReturnType<typeof useCannedResponsesV2Query>;
export type CannedResponsesV2LazyQueryHookResult = ReturnType<typeof useCannedResponsesV2LazyQuery>;
export type CannedResponsesV2SuspenseQueryHookResult = ReturnType<typeof useCannedResponsesV2SuspenseQuery>;
export type CannedResponsesV2QueryResult = Apollo.QueryResult<CannedResponsesV2Query, CannedResponsesV2QueryVariables>;
export const SettingCannedResponsesV2Document = gql`
  query SettingCannedResponsesV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    cannedResponsesV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      data {
        id
        title
        command
        content
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useSettingCannedResponsesV2Query__
 *
 * To run a query within a React component, call `useSettingCannedResponsesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSettingCannedResponsesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingCannedResponsesV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSettingCannedResponsesV2Query(
  baseOptions?: Apollo.QueryHookOptions<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>(
    SettingCannedResponsesV2Document,
    options
  );
}
export function useSettingCannedResponsesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>(
    SettingCannedResponsesV2Document,
    options
  );
}
// @ts-ignore
export function useSettingCannedResponsesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>;
export function useSettingCannedResponsesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<SettingCannedResponsesV2Query | undefined, SettingCannedResponsesV2QueryVariables>;
export function useSettingCannedResponsesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SettingCannedResponsesV2Query, SettingCannedResponsesV2QueryVariables>(
    SettingCannedResponsesV2Document,
    options
  );
}
export type SettingCannedResponsesV2QueryHookResult = ReturnType<typeof useSettingCannedResponsesV2Query>;
export type SettingCannedResponsesV2LazyQueryHookResult = ReturnType<typeof useSettingCannedResponsesV2LazyQuery>;
export type SettingCannedResponsesV2SuspenseQueryHookResult = ReturnType<
  typeof useSettingCannedResponsesV2SuspenseQuery
>;
export type SettingCannedResponsesV2QueryResult = Apollo.QueryResult<
  SettingCannedResponsesV2Query,
  SettingCannedResponsesV2QueryVariables
>;
export const GetBlockedContactsV2Document = gql`
  query GetBlockedContactsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    getBlockedContactsV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      data {
        profilePicture {
          id
          url
        }
        country {
          id
          flag
        }
        blockedBy {
          name
        }
        blockedOn
        timeZone
        blockReason
        id
        phoneNumber
        name
        isBlocked
        isPublished
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetBlockedContactsV2Query__
 *
 * To run a query within a React component, call `useGetBlockedContactsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedContactsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedContactsV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetBlockedContactsV2Query(
  baseOptions?: Apollo.QueryHookOptions<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>(
    GetBlockedContactsV2Document,
    options
  );
}
export function useGetBlockedContactsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>(
    GetBlockedContactsV2Document,
    options
  );
}
// @ts-ignore
export function useGetBlockedContactsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>;
export function useGetBlockedContactsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<GetBlockedContactsV2Query | undefined, GetBlockedContactsV2QueryVariables>;
export function useGetBlockedContactsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBlockedContactsV2Query, GetBlockedContactsV2QueryVariables>(
    GetBlockedContactsV2Document,
    options
  );
}
export type GetBlockedContactsV2QueryHookResult = ReturnType<typeof useGetBlockedContactsV2Query>;
export type GetBlockedContactsV2LazyQueryHookResult = ReturnType<typeof useGetBlockedContactsV2LazyQuery>;
export type GetBlockedContactsV2SuspenseQueryHookResult = ReturnType<typeof useGetBlockedContactsV2SuspenseQuery>;
export type GetBlockedContactsV2QueryResult = Apollo.QueryResult<
  GetBlockedContactsV2Query,
  GetBlockedContactsV2QueryVariables
>;
export const ContactNotesV2Document = gql`
  query ContactNotesV2(
    $direction: CursorDirectionEnum
    $cursor: String
    $limit: Int
    $order: String
    $sort: SortEnum
    $contactId: Int
  ) {
    contactNotesV2(
      direction: $direction
      cursor: $cursor
      limit: $limit
      order: $order
      sort: $sort
      contactId: $contactId
    ) {
      message
      data {
        updatedBy {
          id
          user {
            profilePicture {
              id
              url
              originalname
            }
            id
            name
            phoneNumber
          }
        }
        id
        description
        createdAt
        updatedAt
        createdById
      }
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useContactNotesV2Query__
 *
 * To run a query within a React component, call `useContactNotesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useContactNotesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactNotesV2Query({
 *   variables: {
 *      direction: // value for 'direction'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactNotesV2Query(
  baseOptions?: Apollo.QueryHookOptions<ContactNotesV2Query, ContactNotesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactNotesV2Query, ContactNotesV2QueryVariables>(ContactNotesV2Document, options);
}
export function useContactNotesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactNotesV2Query, ContactNotesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactNotesV2Query, ContactNotesV2QueryVariables>(ContactNotesV2Document, options);
}
// @ts-ignore
export function useContactNotesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactNotesV2Query, ContactNotesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ContactNotesV2Query, ContactNotesV2QueryVariables>;
export function useContactNotesV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactNotesV2Query, ContactNotesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ContactNotesV2Query | undefined, ContactNotesV2QueryVariables>;
export function useContactNotesV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactNotesV2Query, ContactNotesV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactNotesV2Query, ContactNotesV2QueryVariables>(ContactNotesV2Document, options);
}
export type ContactNotesV2QueryHookResult = ReturnType<typeof useContactNotesV2Query>;
export type ContactNotesV2LazyQueryHookResult = ReturnType<typeof useContactNotesV2LazyQuery>;
export type ContactNotesV2SuspenseQueryHookResult = ReturnType<typeof useContactNotesV2SuspenseQuery>;
export type ContactNotesV2QueryResult = Apollo.QueryResult<ContactNotesV2Query, ContactNotesV2QueryVariables>;
export const ContactTagsV2Document = gql`
  query ContactTagsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $sort: SortEnum
    $contactId: Int
  ) {
    contactTagsV2(
      cursor: $cursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
      contactId: $contactId
    ) {
      message
      data {
        tags {
          id
          color
          label
          slug
          type
        }
        id
        contact {
          id
        }
      }
    }
  }
`;

/**
 * __useContactTagsV2Query__
 *
 * To run a query within a React component, call `useContactTagsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useContactTagsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactTagsV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactTagsV2Query(
  baseOptions?: Apollo.QueryHookOptions<ContactTagsV2Query, ContactTagsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactTagsV2Query, ContactTagsV2QueryVariables>(ContactTagsV2Document, options);
}
export function useContactTagsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactTagsV2Query, ContactTagsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactTagsV2Query, ContactTagsV2QueryVariables>(ContactTagsV2Document, options);
}
// @ts-ignore
export function useContactTagsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactTagsV2Query, ContactTagsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ContactTagsV2Query, ContactTagsV2QueryVariables>;
export function useContactTagsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactTagsV2Query, ContactTagsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ContactTagsV2Query | undefined, ContactTagsV2QueryVariables>;
export function useContactTagsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactTagsV2Query, ContactTagsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactTagsV2Query, ContactTagsV2QueryVariables>(ContactTagsV2Document, options);
}
export type ContactTagsV2QueryHookResult = ReturnType<typeof useContactTagsV2Query>;
export type ContactTagsV2LazyQueryHookResult = ReturnType<typeof useContactTagsV2LazyQuery>;
export type ContactTagsV2SuspenseQueryHookResult = ReturnType<typeof useContactTagsV2SuspenseQuery>;
export type ContactTagsV2QueryResult = Apollo.QueryResult<ContactTagsV2Query, ContactTagsV2QueryVariables>;
export const TagsV2Document = gql`
  query TagsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $fields: [String]
    $query: String
  ) {
    tagsV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      fields: $fields
      query: $query
    ) {
      message
      data {
        id
        label
        color
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useTagsV2Query__
 *
 * To run a query within a React component, call `useTagsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useTagsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      fields: // value for 'fields'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTagsV2Query(baseOptions?: Apollo.QueryHookOptions<TagsV2Query, TagsV2QueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TagsV2Query, TagsV2QueryVariables>(TagsV2Document, options);
}
export function useTagsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsV2Query, TagsV2QueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TagsV2Query, TagsV2QueryVariables>(TagsV2Document, options);
}
// @ts-ignore
export function useTagsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TagsV2Query, TagsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<TagsV2Query, TagsV2QueryVariables>;
export function useTagsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsV2Query, TagsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<TagsV2Query | undefined, TagsV2QueryVariables>;
export function useTagsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsV2Query, TagsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TagsV2Query, TagsV2QueryVariables>(TagsV2Document, options);
}
export type TagsV2QueryHookResult = ReturnType<typeof useTagsV2Query>;
export type TagsV2LazyQueryHookResult = ReturnType<typeof useTagsV2LazyQuery>;
export type TagsV2SuspenseQueryHookResult = ReturnType<typeof useTagsV2SuspenseQuery>;
export type TagsV2QueryResult = Apollo.QueryResult<TagsV2Query, TagsV2QueryVariables>;
export const TeamsV2Document = gql`
  query TeamsV2(
    $sort: SortEnum
    $cursor: String
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
  ) {
    teamsV2(sort: $sort, cursor: $cursor, limit: $limit, query: $query, direction: $direction, order: $order) {
      message
      data {
        totalMembers
        name
        status
        workspacesId
        metrics {
          key
          value
        }
        createdBy
        updatedBy
        description
        id
        members {
          id
          name
          profilePicture {
            id
            url
          }
          accountStatus
        }
      }
      cursor {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

/**
 * __useTeamsV2Query__
 *
 * To run a query within a React component, call `useTeamsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useTeamsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsV2Query({
 *   variables: {
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      direction: // value for 'direction'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeamsV2Query(baseOptions?: Apollo.QueryHookOptions<TeamsV2Query, TeamsV2QueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamsV2Query, TeamsV2QueryVariables>(TeamsV2Document, options);
}
export function useTeamsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsV2Query, TeamsV2QueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamsV2Query, TeamsV2QueryVariables>(TeamsV2Document, options);
}
// @ts-ignore
export function useTeamsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TeamsV2Query, TeamsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<TeamsV2Query, TeamsV2QueryVariables>;
export function useTeamsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsV2Query, TeamsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<TeamsV2Query | undefined, TeamsV2QueryVariables>;
export function useTeamsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsV2Query, TeamsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TeamsV2Query, TeamsV2QueryVariables>(TeamsV2Document, options);
}
export type TeamsV2QueryHookResult = ReturnType<typeof useTeamsV2Query>;
export type TeamsV2LazyQueryHookResult = ReturnType<typeof useTeamsV2LazyQuery>;
export type TeamsV2SuspenseQueryHookResult = ReturnType<typeof useTeamsV2SuspenseQuery>;
export type TeamsV2QueryResult = Apollo.QueryResult<TeamsV2Query, TeamsV2QueryVariables>;
export const WorkspaceMembersV2Document = gql`
  query WorkspaceMembersV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $status: UserWorkspaceStatusEnum
    $query: String
    $role: RoleEnum
    $teams: [String]
  ) {
    workspaceMembersV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      status: $status
      query: $query
      role: $role
      teams: $teams
    ) {
      message
      data {
        id
        status
        roles {
          label
          isDefault
          isActive
        }
        userOnlineManagement {
          icon
          message
          awayTill
          isActive
          activeStatus
          lastSeenAt
        }
        user {
          id
          name
          email
          phoneNumber
          profilePicture {
            id
            url
          }
          accountStatus
        }
        identity
        channels {
          id
          phoneNumber
        }
        metrics {
          key
          value
        }
        metrics {
          key
          value
        }
        unreadCounter
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useWorkspaceMembersV2Query__
 *
 * To run a query within a React component, call `useWorkspaceMembersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMembersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceMembersV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      status: // value for 'status'
 *      query: // value for 'query'
 *      role: // value for 'role'
 *      teams: // value for 'teams'
 *   },
 * });
 */
export function useWorkspaceMembersV2Query(
  baseOptions?: Apollo.QueryHookOptions<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>(
    WorkspaceMembersV2Document,
    options
  );
}
export function useWorkspaceMembersV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>(
    WorkspaceMembersV2Document,
    options
  );
}
// @ts-ignore
export function useWorkspaceMembersV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>
): Apollo.UseSuspenseQueryResult<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>;
export function useWorkspaceMembersV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>
): Apollo.UseSuspenseQueryResult<WorkspaceMembersV2Query | undefined, WorkspaceMembersV2QueryVariables>;
export function useWorkspaceMembersV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>(
    WorkspaceMembersV2Document,
    options
  );
}
export type WorkspaceMembersV2QueryHookResult = ReturnType<typeof useWorkspaceMembersV2Query>;
export type WorkspaceMembersV2LazyQueryHookResult = ReturnType<typeof useWorkspaceMembersV2LazyQuery>;
export type WorkspaceMembersV2SuspenseQueryHookResult = ReturnType<typeof useWorkspaceMembersV2SuspenseQuery>;
export type WorkspaceMembersV2QueryResult = Apollo.QueryResult<
  WorkspaceMembersV2Query,
  WorkspaceMembersV2QueryVariables
>;
export const CallerIdsV2Document = gql`
  query CallerIdsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    callerIdsV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      data {
        id
        friendlyName
        phoneNumber
        sid
        createdAt
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useCallerIdsV2Query__
 *
 * To run a query within a React component, call `useCallerIdsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCallerIdsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallerIdsV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCallerIdsV2Query(
  baseOptions?: Apollo.QueryHookOptions<CallerIdsV2Query, CallerIdsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CallerIdsV2Query, CallerIdsV2QueryVariables>(CallerIdsV2Document, options);
}
export function useCallerIdsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CallerIdsV2Query, CallerIdsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CallerIdsV2Query, CallerIdsV2QueryVariables>(CallerIdsV2Document, options);
}
// @ts-ignore
export function useCallerIdsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CallerIdsV2Query, CallerIdsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<CallerIdsV2Query, CallerIdsV2QueryVariables>;
export function useCallerIdsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallerIdsV2Query, CallerIdsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<CallerIdsV2Query | undefined, CallerIdsV2QueryVariables>;
export function useCallerIdsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallerIdsV2Query, CallerIdsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CallerIdsV2Query, CallerIdsV2QueryVariables>(CallerIdsV2Document, options);
}
export type CallerIdsV2QueryHookResult = ReturnType<typeof useCallerIdsV2Query>;
export type CallerIdsV2LazyQueryHookResult = ReturnType<typeof useCallerIdsV2LazyQuery>;
export type CallerIdsV2SuspenseQueryHookResult = ReturnType<typeof useCallerIdsV2SuspenseQuery>;
export type CallerIdsV2QueryResult = Apollo.QueryResult<CallerIdsV2Query, CallerIdsV2QueryVariables>;
export const FetchAllCountriesDocument = gql`
  query FetchAllCountries(
    $query: String
    $sort: SortEnum
    $order: String
    $direction: CursorDirectionEnum
    $limit: Int
    $cursor: String
  ) {
    fetchAllCountries(
      query: $query
      sort: $sort
      order: $order
      direction: $direction
      limit: $limit
      cursor: $cursor
    ) {
      message
      data {
        id
        name
        slug
        dialingCode
        alphaTwoCode
        alphaThreeCode
        numeric
        flag
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useFetchAllCountriesQuery__
 *
 * To run a query within a React component, call `useFetchAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCountriesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useFetchAllCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>(FetchAllCountriesDocument, options);
}
export function useFetchAllCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>(
    FetchAllCountriesDocument,
    options
  );
}
// @ts-ignore
export function useFetchAllCountriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>
): Apollo.UseSuspenseQueryResult<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>;
export function useFetchAllCountriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>
): Apollo.UseSuspenseQueryResult<FetchAllCountriesQuery | undefined, FetchAllCountriesQueryVariables>;
export function useFetchAllCountriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>(
    FetchAllCountriesDocument,
    options
  );
}
export type FetchAllCountriesQueryHookResult = ReturnType<typeof useFetchAllCountriesQuery>;
export type FetchAllCountriesLazyQueryHookResult = ReturnType<typeof useFetchAllCountriesLazyQuery>;
export type FetchAllCountriesSuspenseQueryHookResult = ReturnType<typeof useFetchAllCountriesSuspenseQuery>;
export type FetchAllCountriesQueryResult = Apollo.QueryResult<FetchAllCountriesQuery, FetchAllCountriesQueryVariables>;
export const ContactsV2Document = gql`
  query ContactsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $sort: SortEnum
    $query: String
    $order: String
    $sourceType: [ContactSourceTypeEnum]
    $countryCode: [String]
    $tags: [Int]
    $nameStartsWith: String
    $fields: [String]
  ) {
    contactsV2(
      cursor: $cursor
      direction: $direction
      limit: $limit
      sort: $sort
      query: $query
      order: $order
      sourceType: $sourceType
      countryCode: $countryCode
      tags: $tags
      nameStartsWith: $nameStartsWith
      fields: $fields
    ) {
      message
      data {
        id
        name
        email
        phoneNumber
        country {
          id
          flag
        }
        metrics {
          key
          value
        }
        tags {
          id
          label
          color
        }
        profilePicture {
          id
          url
        }
        sourceType
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useContactsV2Query__
 *
 * To run a query within a React component, call `useContactsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useContactsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *      sourceType: // value for 'sourceType'
 *      countryCode: // value for 'countryCode'
 *      tags: // value for 'tags'
 *      nameStartsWith: // value for 'nameStartsWith'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useContactsV2Query(baseOptions?: Apollo.QueryHookOptions<ContactsV2Query, ContactsV2QueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactsV2Query, ContactsV2QueryVariables>(ContactsV2Document, options);
}
export function useContactsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactsV2Query, ContactsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactsV2Query, ContactsV2QueryVariables>(ContactsV2Document, options);
}
// @ts-ignore
export function useContactsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactsV2Query, ContactsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ContactsV2Query, ContactsV2QueryVariables>;
export function useContactsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsV2Query, ContactsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ContactsV2Query | undefined, ContactsV2QueryVariables>;
export function useContactsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsV2Query, ContactsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactsV2Query, ContactsV2QueryVariables>(ContactsV2Document, options);
}
export type ContactsV2QueryHookResult = ReturnType<typeof useContactsV2Query>;
export type ContactsV2LazyQueryHookResult = ReturnType<typeof useContactsV2LazyQuery>;
export type ContactsV2SuspenseQueryHookResult = ReturnType<typeof useContactsV2SuspenseQuery>;
export type ContactsV2QueryResult = Apollo.QueryResult<ContactsV2Query, ContactsV2QueryVariables>;
export const ListPinnedMessageConversationsV2Document = gql`
  query ListPinnedMessageConversationsV2($clientId: Int!, $channelId: Int!, $sort: SortEnum, $order: String) {
    listPinnedMessageConversationsV2(clientId: $clientId, channelId: $channelId, sort: $sort, order: $order) {
      message
      data {
        id
        direction
        numMedia
        client {
          id
          name
          phoneNumber
          profilePicture {
            id
            url
          }
        }
        pinned
        conversationStatus
        messageContent
        markAsClosed
        conversationType
        agent {
          id
          user {
            id
            name
            phoneNumber
            profilePicture {
              id
              url
            }
          }
        }
        createdAt
        recording {
          id
          url
        }
        cursor
        voicemailRecording {
          id
          url
        }
        callRecording {
          id
          url
        }
      }
    }
  }
`;

/**
 * __useListPinnedMessageConversationsV2Query__
 *
 * To run a query within a React component, call `useListPinnedMessageConversationsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListPinnedMessageConversationsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPinnedMessageConversationsV2Query({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      channelId: // value for 'channelId'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListPinnedMessageConversationsV2Query(
  baseOptions: Apollo.QueryHookOptions<
    ListPinnedMessageConversationsV2Query,
    ListPinnedMessageConversationsV2QueryVariables
  > &
    ({ variables: ListPinnedMessageConversationsV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPinnedMessageConversationsV2Query, ListPinnedMessageConversationsV2QueryVariables>(
    ListPinnedMessageConversationsV2Document,
    options
  );
}
export function useListPinnedMessageConversationsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPinnedMessageConversationsV2Query,
    ListPinnedMessageConversationsV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPinnedMessageConversationsV2Query, ListPinnedMessageConversationsV2QueryVariables>(
    ListPinnedMessageConversationsV2Document,
    options
  );
}
// @ts-ignore
export function useListPinnedMessageConversationsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPinnedMessageConversationsV2Query,
    ListPinnedMessageConversationsV2QueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListPinnedMessageConversationsV2Query, ListPinnedMessageConversationsV2QueryVariables>;
export function useListPinnedMessageConversationsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPinnedMessageConversationsV2Query,
        ListPinnedMessageConversationsV2QueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListPinnedMessageConversationsV2Query | undefined,
  ListPinnedMessageConversationsV2QueryVariables
>;
export function useListPinnedMessageConversationsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPinnedMessageConversationsV2Query,
        ListPinnedMessageConversationsV2QueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPinnedMessageConversationsV2Query, ListPinnedMessageConversationsV2QueryVariables>(
    ListPinnedMessageConversationsV2Document,
    options
  );
}
export type ListPinnedMessageConversationsV2QueryHookResult = ReturnType<
  typeof useListPinnedMessageConversationsV2Query
>;
export type ListPinnedMessageConversationsV2LazyQueryHookResult = ReturnType<
  typeof useListPinnedMessageConversationsV2LazyQuery
>;
export type ListPinnedMessageConversationsV2SuspenseQueryHookResult = ReturnType<
  typeof useListPinnedMessageConversationsV2SuspenseQuery
>;
export type ListPinnedMessageConversationsV2QueryResult = Apollo.QueryResult<
  ListPinnedMessageConversationsV2Query,
  ListPinnedMessageConversationsV2QueryVariables
>;
export const GetChatMessagesV2Document = gql`
  query GetChatMessagesV2(
    $roomId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
  ) {
    getChatMessagesV2(
      roomId: $roomId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        body
        createdAt
        isPinned
        type
        messageConversation {
          id
          conversationStatus
          effectiveStartedAt
          effectiveEndedAt
        }
        sender {
          id
          status
          userOnlineManagement {
            isActive
            lastSeenAt
            activeStatus
            awayTill
            message
            icon
          }
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
            }
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            lastPasswordResetAt
          }
        }
      }
    }
  }
`;

/**
 * __useGetChatMessagesV2Query__
 *
 * To run a query within a React component, call `useGetChatMessagesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesV2Query({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetChatMessagesV2Query(
  baseOptions: Apollo.QueryHookOptions<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables> &
    ({ variables: GetChatMessagesV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>(GetChatMessagesV2Document, options);
}
export function useGetChatMessagesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>(
    GetChatMessagesV2Document,
    options
  );
}
// @ts-ignore
export function useGetChatMessagesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>;
export function useGetChatMessagesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<GetChatMessagesV2Query | undefined, GetChatMessagesV2QueryVariables>;
export function useGetChatMessagesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>(
    GetChatMessagesV2Document,
    options
  );
}
export type GetChatMessagesV2QueryHookResult = ReturnType<typeof useGetChatMessagesV2Query>;
export type GetChatMessagesV2LazyQueryHookResult = ReturnType<typeof useGetChatMessagesV2LazyQuery>;
export type GetChatMessagesV2SuspenseQueryHookResult = ReturnType<typeof useGetChatMessagesV2SuspenseQuery>;
export type GetChatMessagesV2QueryResult = Apollo.QueryResult<GetChatMessagesV2Query, GetChatMessagesV2QueryVariables>;
export const ListPinnedChatMessagesDocument = gql`
  query ListPinnedChatMessages($roomId: Int!, $order: String, $sort: SortEnum) {
    listPinnedChatMessages(roomId: $roomId, order: $order, sort: $sort) {
      message
      data {
        id
        isPinned
        cursor
        createdAt
        body
        sender {
          id
          user {
            name
            profilePicture {
              url
            }
            id
            phoneNumber
          }
        }
      }
    }
  }
`;

/**
 * __useListPinnedChatMessagesQuery__
 *
 * To run a query within a React component, call `useListPinnedChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPinnedChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPinnedChatMessagesQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListPinnedChatMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables> &
    ({ variables: ListPinnedChatMessagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables>(
    ListPinnedChatMessagesDocument,
    options
  );
}
export function useListPinnedChatMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables>(
    ListPinnedChatMessagesDocument,
    options
  );
}
// @ts-ignore
export function useListPinnedChatMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables>
): Apollo.UseSuspenseQueryResult<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables>;
export function useListPinnedChatMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables>
): Apollo.UseSuspenseQueryResult<ListPinnedChatMessagesQuery | undefined, ListPinnedChatMessagesQueryVariables>;
export function useListPinnedChatMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPinnedChatMessagesQuery, ListPinnedChatMessagesQueryVariables>(
    ListPinnedChatMessagesDocument,
    options
  );
}
export type ListPinnedChatMessagesQueryHookResult = ReturnType<typeof useListPinnedChatMessagesQuery>;
export type ListPinnedChatMessagesLazyQueryHookResult = ReturnType<typeof useListPinnedChatMessagesLazyQuery>;
export type ListPinnedChatMessagesSuspenseQueryHookResult = ReturnType<typeof useListPinnedChatMessagesSuspenseQuery>;
export type ListPinnedChatMessagesQueryResult = Apollo.QueryResult<
  ListPinnedChatMessagesQuery,
  ListPinnedChatMessagesQueryVariables
>;
export const ChannelConversationsDocument = gql`
  query ChannelConversations(
    $clientId: String!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $sort: SortEnum
    $query: String
    $countryId: String
    $order: String
  ) {
    channelConversations(
      clientId: $clientId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      sort: $sort
      query: $query
      countryId: $countryId
      order: $order
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        createdAt
        updatedAt
        channel {
          id
          friendlyName
          country {
            name
            flag
          }
          phoneNumber
          unreadCounter
        }
        messageConversation {
          messageContent
          direction
          id
          numMedia
          conversationStatus
          conversationType
          friendlyName
        }
        isDefault
      }
    }
  }
`;

/**
 * __useChannelConversationsQuery__
 *
 * To run a query within a React component, call `useChannelConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelConversationsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *      countryId: // value for 'countryId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useChannelConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<ChannelConversationsQuery, ChannelConversationsQueryVariables> &
    ({ variables: ChannelConversationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelConversationsQuery, ChannelConversationsQueryVariables>(
    ChannelConversationsDocument,
    options
  );
}
export function useChannelConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChannelConversationsQuery, ChannelConversationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelConversationsQuery, ChannelConversationsQueryVariables>(
    ChannelConversationsDocument,
    options
  );
}
// @ts-ignore
export function useChannelConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelConversationsQuery, ChannelConversationsQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelConversationsQuery, ChannelConversationsQueryVariables>;
export function useChannelConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChannelConversationsQuery, ChannelConversationsQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelConversationsQuery | undefined, ChannelConversationsQueryVariables>;
export function useChannelConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChannelConversationsQuery, ChannelConversationsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelConversationsQuery, ChannelConversationsQueryVariables>(
    ChannelConversationsDocument,
    options
  );
}
export type ChannelConversationsQueryHookResult = ReturnType<typeof useChannelConversationsQuery>;
export type ChannelConversationsLazyQueryHookResult = ReturnType<typeof useChannelConversationsLazyQuery>;
export type ChannelConversationsSuspenseQueryHookResult = ReturnType<typeof useChannelConversationsSuspenseQuery>;
export type ChannelConversationsQueryResult = Apollo.QueryResult<
  ChannelConversationsQuery,
  ChannelConversationsQueryVariables
>;
export const ChannelsForNewConversationsDocument = gql`
  query ChannelsForNewConversations(
    $clientId: String!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $countryId: String
    $query: String
  ) {
    channelsForNewConversations(
      clientId: $clientId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      countryId: $countryId
      query: $query
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        isDefault
        channel {
          id
          phoneNumber
          friendlyName
          country {
            alphaTwoCode
            flag
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useChannelsForNewConversationsQuery__
 *
 * To run a query within a React component, call `useChannelsForNewConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsForNewConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsForNewConversationsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      countryId: // value for 'countryId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useChannelsForNewConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<ChannelsForNewConversationsQuery, ChannelsForNewConversationsQueryVariables> &
    ({ variables: ChannelsForNewConversationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelsForNewConversationsQuery, ChannelsForNewConversationsQueryVariables>(
    ChannelsForNewConversationsDocument,
    options
  );
}
export function useChannelsForNewConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChannelsForNewConversationsQuery, ChannelsForNewConversationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelsForNewConversationsQuery, ChannelsForNewConversationsQueryVariables>(
    ChannelsForNewConversationsDocument,
    options
  );
}
// @ts-ignore
export function useChannelsForNewConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChannelsForNewConversationsQuery,
    ChannelsForNewConversationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ChannelsForNewConversationsQuery, ChannelsForNewConversationsQueryVariables>;
export function useChannelsForNewConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChannelsForNewConversationsQuery, ChannelsForNewConversationsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ChannelsForNewConversationsQuery | undefined,
  ChannelsForNewConversationsQueryVariables
>;
export function useChannelsForNewConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChannelsForNewConversationsQuery, ChannelsForNewConversationsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelsForNewConversationsQuery, ChannelsForNewConversationsQueryVariables>(
    ChannelsForNewConversationsDocument,
    options
  );
}
export type ChannelsForNewConversationsQueryHookResult = ReturnType<typeof useChannelsForNewConversationsQuery>;
export type ChannelsForNewConversationsLazyQueryHookResult = ReturnType<typeof useChannelsForNewConversationsLazyQuery>;
export type ChannelsForNewConversationsSuspenseQueryHookResult = ReturnType<
  typeof useChannelsForNewConversationsSuspenseQuery
>;
export type ChannelsForNewConversationsQueryResult = Apollo.QueryResult<
  ChannelsForNewConversationsQuery,
  ChannelsForNewConversationsQueryVariables
>;
export const IntegrationsV2Document = gql`
  query IntegrationsV2(
    $sort: SortEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
    $includeInactive: Boolean!
  ) {
    integrationsV2(
      sort: $sort
      cursor: $cursor
      withCursor: $withCursor
      limit: $limit
      query: $query
      direction: $direction
      order: $order
      includeInactive: $includeInactive
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        name
        logoUrl
        label
        domain
        description
        integrationUser {
          id
          status
        }
      }
    }
  }
`;

/**
 * __useIntegrationsV2Query__
 *
 * To run a query within a React component, call `useIntegrationsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsV2Query({
 *   variables: {
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      direction: // value for 'direction'
 *      order: // value for 'order'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useIntegrationsV2Query(
  baseOptions: Apollo.QueryHookOptions<IntegrationsV2Query, IntegrationsV2QueryVariables> &
    ({ variables: IntegrationsV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationsV2Query, IntegrationsV2QueryVariables>(IntegrationsV2Document, options);
}
export function useIntegrationsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsV2Query, IntegrationsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationsV2Query, IntegrationsV2QueryVariables>(IntegrationsV2Document, options);
}
// @ts-ignore
export function useIntegrationsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationsV2Query, IntegrationsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationsV2Query, IntegrationsV2QueryVariables>;
export function useIntegrationsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationsV2Query, IntegrationsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationsV2Query | undefined, IntegrationsV2QueryVariables>;
export function useIntegrationsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationsV2Query, IntegrationsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IntegrationsV2Query, IntegrationsV2QueryVariables>(IntegrationsV2Document, options);
}
export type IntegrationsV2QueryHookResult = ReturnType<typeof useIntegrationsV2Query>;
export type IntegrationsV2LazyQueryHookResult = ReturnType<typeof useIntegrationsV2LazyQuery>;
export type IntegrationsV2SuspenseQueryHookResult = ReturnType<typeof useIntegrationsV2SuspenseQuery>;
export type IntegrationsV2QueryResult = Apollo.QueryResult<IntegrationsV2Query, IntegrationsV2QueryVariables>;
export const IntegrationChannelsV2Document = gql`
  query IntegrationChannelsV2(
    $sort: SortEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
    $integrationUserId: Int!
    $countryCode: [String]
  ) {
    integrationChannelsV2(
      sort: $sort
      cursor: $cursor
      withCursor: $withCursor
      limit: $limit
      query: $query
      direction: $direction
      order: $order
      integrationUserId: $integrationUserId
      countryCode: $countryCode
    ) {
      message
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      data {
        id
        friendlyName
        phoneNumber
        country {
          id
          flag
        }
        integrationChannels {
          id
          integrationUserId
          isEnabled
        }
      }
    }
  }
`;

/**
 * __useIntegrationChannelsV2Query__
 *
 * To run a query within a React component, call `useIntegrationChannelsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationChannelsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationChannelsV2Query({
 *   variables: {
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      direction: // value for 'direction'
 *      order: // value for 'order'
 *      integrationUserId: // value for 'integrationUserId'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useIntegrationChannelsV2Query(
  baseOptions: Apollo.QueryHookOptions<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables> &
    ({ variables: IntegrationChannelsV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables>(
    IntegrationChannelsV2Document,
    options
  );
}
export function useIntegrationChannelsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables>(
    IntegrationChannelsV2Document,
    options
  );
}
// @ts-ignore
export function useIntegrationChannelsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables>;
export function useIntegrationChannelsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationChannelsV2Query | undefined, IntegrationChannelsV2QueryVariables>;
export function useIntegrationChannelsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IntegrationChannelsV2Query, IntegrationChannelsV2QueryVariables>(
    IntegrationChannelsV2Document,
    options
  );
}
export type IntegrationChannelsV2QueryHookResult = ReturnType<typeof useIntegrationChannelsV2Query>;
export type IntegrationChannelsV2LazyQueryHookResult = ReturnType<typeof useIntegrationChannelsV2LazyQuery>;
export type IntegrationChannelsV2SuspenseQueryHookResult = ReturnType<typeof useIntegrationChannelsV2SuspenseQuery>;
export type IntegrationChannelsV2QueryResult = Apollo.QueryResult<
  IntegrationChannelsV2Query,
  IntegrationChannelsV2QueryVariables
>;
export const AttributeValuesV2Document = gql`
  query AttributeValuesV2(
    $sort: SortEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
    $attributeName: String
  ) {
    attributeValuesV2(
      sort: $sort
      cursor: $cursor
      withCursor: $withCursor
      limit: $limit
      query: $query
      direction: $direction
      order: $order
      attributeName: $attributeName
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        value
        description
        isActive
        isDefault
        attributeId
        label
      }
    }
  }
`;

/**
 * __useAttributeValuesV2Query__
 *
 * To run a query within a React component, call `useAttributeValuesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAttributeValuesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeValuesV2Query({
 *   variables: {
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      direction: // value for 'direction'
 *      order: // value for 'order'
 *      attributeName: // value for 'attributeName'
 *   },
 * });
 */
export function useAttributeValuesV2Query(
  baseOptions?: Apollo.QueryHookOptions<AttributeValuesV2Query, AttributeValuesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AttributeValuesV2Query, AttributeValuesV2QueryVariables>(AttributeValuesV2Document, options);
}
export function useAttributeValuesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AttributeValuesV2Query, AttributeValuesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AttributeValuesV2Query, AttributeValuesV2QueryVariables>(
    AttributeValuesV2Document,
    options
  );
}
// @ts-ignore
export function useAttributeValuesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AttributeValuesV2Query, AttributeValuesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<AttributeValuesV2Query, AttributeValuesV2QueryVariables>;
export function useAttributeValuesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttributeValuesV2Query, AttributeValuesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<AttributeValuesV2Query | undefined, AttributeValuesV2QueryVariables>;
export function useAttributeValuesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttributeValuesV2Query, AttributeValuesV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AttributeValuesV2Query, AttributeValuesV2QueryVariables>(
    AttributeValuesV2Document,
    options
  );
}
export type AttributeValuesV2QueryHookResult = ReturnType<typeof useAttributeValuesV2Query>;
export type AttributeValuesV2LazyQueryHookResult = ReturnType<typeof useAttributeValuesV2LazyQuery>;
export type AttributeValuesV2SuspenseQueryHookResult = ReturnType<typeof useAttributeValuesV2SuspenseQuery>;
export type AttributeValuesV2QueryResult = Apollo.QueryResult<AttributeValuesV2Query, AttributeValuesV2QueryVariables>;
export const AvailablePhoneNumbersV2Document = gql`
  query AvailablePhoneNumbersV2(
    $countryCode: String!
    $cursor: String
    $limit: Int
    $numberType: NumberTypeEnum
    $smsEnabled: Boolean
    $voiceEnabled: Boolean
    $mmsEnabled: Boolean
    $faxEnabled: Boolean
    $excludeAllAddressRequired: Boolean
    $excludeLocalAddressRequired: Boolean
    $excludeForeignAddressRequired: Boolean
    $beta: Boolean
    $contains: String
    $areaCode: Int
    $inLocality: String
  ) {
    availablePhoneNumbersV2(
      countryCode: $countryCode
      cursor: $cursor
      limit: $limit
      numberType: $numberType
      smsEnabled: $smsEnabled
      voiceEnabled: $voiceEnabled
      mmsEnabled: $mmsEnabled
      faxEnabled: $faxEnabled
      excludeAllAddressRequired: $excludeAllAddressRequired
      excludeLocalAddressRequired: $excludeLocalAddressRequired
      excludeForeignAddressRequired: $excludeForeignAddressRequired
      beta: $beta
      contains: $contains
      areaCode: $areaCode
      inLocality: $inLocality
    ) {
      message
      data {
        addressRequirements
        isoCountry
        phoneNumber
        friendlyName
        region
        rateCenter
        capabilities {
          voice
          SMS
          MMS
        }
        numberType
        basePrice
        currentPrice
        supportingDocument
        endUser
        beta
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useAvailablePhoneNumbersV2Query__
 *
 * To run a query within a React component, call `useAvailablePhoneNumbersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePhoneNumbersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePhoneNumbersV2Query({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      numberType: // value for 'numberType'
 *      smsEnabled: // value for 'smsEnabled'
 *      voiceEnabled: // value for 'voiceEnabled'
 *      mmsEnabled: // value for 'mmsEnabled'
 *      faxEnabled: // value for 'faxEnabled'
 *      excludeAllAddressRequired: // value for 'excludeAllAddressRequired'
 *      excludeLocalAddressRequired: // value for 'excludeLocalAddressRequired'
 *      excludeForeignAddressRequired: // value for 'excludeForeignAddressRequired'
 *      beta: // value for 'beta'
 *      contains: // value for 'contains'
 *      areaCode: // value for 'areaCode'
 *      inLocality: // value for 'inLocality'
 *   },
 * });
 */
export function useAvailablePhoneNumbersV2Query(
  baseOptions: Apollo.QueryHookOptions<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables> &
    ({ variables: AvailablePhoneNumbersV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables>(
    AvailablePhoneNumbersV2Document,
    options
  );
}
export function useAvailablePhoneNumbersV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables>(
    AvailablePhoneNumbersV2Document,
    options
  );
}
// @ts-ignore
export function useAvailablePhoneNumbersV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables>
): Apollo.UseSuspenseQueryResult<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables>;
export function useAvailablePhoneNumbersV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables>
): Apollo.UseSuspenseQueryResult<AvailablePhoneNumbersV2Query | undefined, AvailablePhoneNumbersV2QueryVariables>;
export function useAvailablePhoneNumbersV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AvailablePhoneNumbersV2Query, AvailablePhoneNumbersV2QueryVariables>(
    AvailablePhoneNumbersV2Document,
    options
  );
}
export type AvailablePhoneNumbersV2QueryHookResult = ReturnType<typeof useAvailablePhoneNumbersV2Query>;
export type AvailablePhoneNumbersV2LazyQueryHookResult = ReturnType<typeof useAvailablePhoneNumbersV2LazyQuery>;
export type AvailablePhoneNumbersV2SuspenseQueryHookResult = ReturnType<typeof useAvailablePhoneNumbersV2SuspenseQuery>;
export type AvailablePhoneNumbersV2QueryResult = Apollo.QueryResult<
  AvailablePhoneNumbersV2Query,
  AvailablePhoneNumbersV2QueryVariables
>;
export const AreaCodesDocument = gql`
  query AreaCodes(
    $direction: CursorDirectionEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $fields: [String]
    $query: String
    $alphaTwoCode: String
  ) {
    areaCodes(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      fields: $fields
      query: $query
      alphaTwoCode: $alphaTwoCode
    ) {
      message
      data {
        id
        name
        slug
        code
        stateId
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useAreaCodesQuery__
 *
 * To run a query within a React component, call `useAreaCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreaCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreaCodesQuery({
 *   variables: {
 *      direction: // value for 'direction'
 *      cursor: // value for 'cursor'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      fields: // value for 'fields'
 *      query: // value for 'query'
 *      alphaTwoCode: // value for 'alphaTwoCode'
 *   },
 * });
 */
export function useAreaCodesQuery(baseOptions?: Apollo.QueryHookOptions<AreaCodesQuery, AreaCodesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AreaCodesQuery, AreaCodesQueryVariables>(AreaCodesDocument, options);
}
export function useAreaCodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AreaCodesQuery, AreaCodesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AreaCodesQuery, AreaCodesQueryVariables>(AreaCodesDocument, options);
}
// @ts-ignore
export function useAreaCodesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AreaCodesQuery, AreaCodesQueryVariables>
): Apollo.UseSuspenseQueryResult<AreaCodesQuery, AreaCodesQueryVariables>;
export function useAreaCodesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AreaCodesQuery, AreaCodesQueryVariables>
): Apollo.UseSuspenseQueryResult<AreaCodesQuery | undefined, AreaCodesQueryVariables>;
export function useAreaCodesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AreaCodesQuery, AreaCodesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AreaCodesQuery, AreaCodesQueryVariables>(AreaCodesDocument, options);
}
export type AreaCodesQueryHookResult = ReturnType<typeof useAreaCodesQuery>;
export type AreaCodesLazyQueryHookResult = ReturnType<typeof useAreaCodesLazyQuery>;
export type AreaCodesSuspenseQueryHookResult = ReturnType<typeof useAreaCodesSuspenseQuery>;
export type AreaCodesQueryResult = Apollo.QueryResult<AreaCodesQuery, AreaCodesQueryVariables>;
export const GetIvrMenuOptionsInCallSettingDocument = gql`
  query GetIvrMenuOptionsInCallSetting(
    $callSettingId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $sort: SortEnum
  ) {
    getIvrMenuOptionsInCallSetting(
      callSettingId: $callSettingId
      cursor: $cursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
    ) {
      data {
        input
        ifUnansweredRedirectTo
        id
        callIvrConditionTarget {
          target {
            id
            name
          }
          id
        }
        action
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetIvrMenuOptionsInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetIvrMenuOptionsInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIvrMenuOptionsInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIvrMenuOptionsInCallSettingQuery({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetIvrMenuOptionsInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIvrMenuOptionsInCallSettingQuery,
    GetIvrMenuOptionsInCallSettingQueryVariables
  > &
    ({ variables: GetIvrMenuOptionsInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIvrMenuOptionsInCallSettingQuery, GetIvrMenuOptionsInCallSettingQueryVariables>(
    GetIvrMenuOptionsInCallSettingDocument,
    options
  );
}
export function useGetIvrMenuOptionsInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIvrMenuOptionsInCallSettingQuery,
    GetIvrMenuOptionsInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIvrMenuOptionsInCallSettingQuery, GetIvrMenuOptionsInCallSettingQueryVariables>(
    GetIvrMenuOptionsInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetIvrMenuOptionsInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIvrMenuOptionsInCallSettingQuery,
    GetIvrMenuOptionsInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetIvrMenuOptionsInCallSettingQuery, GetIvrMenuOptionsInCallSettingQueryVariables>;
export function useGetIvrMenuOptionsInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIvrMenuOptionsInCallSettingQuery, GetIvrMenuOptionsInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetIvrMenuOptionsInCallSettingQuery | undefined,
  GetIvrMenuOptionsInCallSettingQueryVariables
>;
export function useGetIvrMenuOptionsInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIvrMenuOptionsInCallSettingQuery, GetIvrMenuOptionsInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIvrMenuOptionsInCallSettingQuery, GetIvrMenuOptionsInCallSettingQueryVariables>(
    GetIvrMenuOptionsInCallSettingDocument,
    options
  );
}
export type GetIvrMenuOptionsInCallSettingQueryHookResult = ReturnType<typeof useGetIvrMenuOptionsInCallSettingQuery>;
export type GetIvrMenuOptionsInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetIvrMenuOptionsInCallSettingLazyQuery
>;
export type GetIvrMenuOptionsInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetIvrMenuOptionsInCallSettingSuspenseQuery
>;
export type GetIvrMenuOptionsInCallSettingQueryResult = Apollo.QueryResult<
  GetIvrMenuOptionsInCallSettingQuery,
  GetIvrMenuOptionsInCallSettingQueryVariables
>;
export const GetIvrMenuOptionsInChannelSettingDocument = gql`
  query GetIvrMenuOptionsInChannelSetting(
    $channelId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
  ) {
    getIvrMenuOptionsInChannelSetting(
      channelId: $channelId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        input
        action
        ifUnansweredRedirectTo
        callIvrConditionTarget {
          id
          target {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetIvrMenuOptionsInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetIvrMenuOptionsInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIvrMenuOptionsInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIvrMenuOptionsInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetIvrMenuOptionsInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIvrMenuOptionsInChannelSettingQuery,
    GetIvrMenuOptionsInChannelSettingQueryVariables
  > &
    ({ variables: GetIvrMenuOptionsInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIvrMenuOptionsInChannelSettingQuery, GetIvrMenuOptionsInChannelSettingQueryVariables>(
    GetIvrMenuOptionsInChannelSettingDocument,
    options
  );
}
export function useGetIvrMenuOptionsInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIvrMenuOptionsInChannelSettingQuery,
    GetIvrMenuOptionsInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIvrMenuOptionsInChannelSettingQuery, GetIvrMenuOptionsInChannelSettingQueryVariables>(
    GetIvrMenuOptionsInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetIvrMenuOptionsInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIvrMenuOptionsInChannelSettingQuery,
    GetIvrMenuOptionsInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetIvrMenuOptionsInChannelSettingQuery,
  GetIvrMenuOptionsInChannelSettingQueryVariables
>;
export function useGetIvrMenuOptionsInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIvrMenuOptionsInChannelSettingQuery,
        GetIvrMenuOptionsInChannelSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetIvrMenuOptionsInChannelSettingQuery | undefined,
  GetIvrMenuOptionsInChannelSettingQueryVariables
>;
export function useGetIvrMenuOptionsInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIvrMenuOptionsInChannelSettingQuery,
        GetIvrMenuOptionsInChannelSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIvrMenuOptionsInChannelSettingQuery,
    GetIvrMenuOptionsInChannelSettingQueryVariables
  >(GetIvrMenuOptionsInChannelSettingDocument, options);
}
export type GetIvrMenuOptionsInChannelSettingQueryHookResult = ReturnType<
  typeof useGetIvrMenuOptionsInChannelSettingQuery
>;
export type GetIvrMenuOptionsInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetIvrMenuOptionsInChannelSettingLazyQuery
>;
export type GetIvrMenuOptionsInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetIvrMenuOptionsInChannelSettingSuspenseQuery
>;
export type GetIvrMenuOptionsInChannelSettingQueryResult = Apollo.QueryResult<
  GetIvrMenuOptionsInChannelSettingQuery,
  GetIvrMenuOptionsInChannelSettingQueryVariables
>;
export const MessageSchedulesDocument = gql`
  query MessageSchedules(
    $cursor: String
    $limit: Int
    $order: String
    $sort: SortEnum
    $channelId: Int!
    $clientId: Int!
    $status: [MessageScheduleStatusEnum]
  ) {
    messageSchedules(
      cursor: $cursor
      limit: $limit
      order: $order
      sort: $sort
      channelId: $channelId
      clientId: $clientId
      status: $status
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        scheduleAt
        messageContent
        id
        createdAt
        attachments {
          id
          url
          mimetype
        }
        client {
          id
          name
          profilePicture {
            id
            url
          }
          country {
            flag
            id
          }
        }
        channel {
          id
        }
        failureReason
        status
      }
    }
  }
`;

/**
 * __useMessageSchedulesQuery__
 *
 * To run a query within a React component, call `useMessageSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageSchedulesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      channelId: // value for 'channelId'
 *      clientId: // value for 'clientId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMessageSchedulesQuery(
  baseOptions: Apollo.QueryHookOptions<MessageSchedulesQuery, MessageSchedulesQueryVariables> &
    ({ variables: MessageSchedulesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MessageSchedulesQuery, MessageSchedulesQueryVariables>(MessageSchedulesDocument, options);
}
export function useMessageSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MessageSchedulesQuery, MessageSchedulesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MessageSchedulesQuery, MessageSchedulesQueryVariables>(MessageSchedulesDocument, options);
}
// @ts-ignore
export function useMessageSchedulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MessageSchedulesQuery, MessageSchedulesQueryVariables>
): Apollo.UseSuspenseQueryResult<MessageSchedulesQuery, MessageSchedulesQueryVariables>;
export function useMessageSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessageSchedulesQuery, MessageSchedulesQueryVariables>
): Apollo.UseSuspenseQueryResult<MessageSchedulesQuery | undefined, MessageSchedulesQueryVariables>;
export function useMessageSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessageSchedulesQuery, MessageSchedulesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MessageSchedulesQuery, MessageSchedulesQueryVariables>(
    MessageSchedulesDocument,
    options
  );
}
export type MessageSchedulesQueryHookResult = ReturnType<typeof useMessageSchedulesQuery>;
export type MessageSchedulesLazyQueryHookResult = ReturnType<typeof useMessageSchedulesLazyQuery>;
export type MessageSchedulesSuspenseQueryHookResult = ReturnType<typeof useMessageSchedulesSuspenseQuery>;
export type MessageSchedulesQueryResult = Apollo.QueryResult<MessageSchedulesQuery, MessageSchedulesQueryVariables>;
export const GetCallSettingsDocument = gql`
  query GetCallSettings($sort: SortEnum, $cursor: String, $limit: Int, $query: String, $order: String) {
    getCallSettings(sort: $sort, cursor: $cursor, limit: $limit, query: $query, order: $order) {
      message
      data {
        updatedAt
        recording
        metrics {
          value
          key
        }
        id
        friendlyName
        createdAt
        channelGroups {
          slug
          name
          id
        }
        businessHourType
        channels {
          phoneNumber
          friendlyName
          assignedUsers {
            name
            profilePicture {
              url
              id
            }
          }
        }
        callerId {
          phoneNumber
          friendlyName
          id
        }
      }
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useGetCallSettingsQuery__
 *
 * To run a query within a React component, call `useGetCallSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallSettingsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetCallSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCallSettingsQuery, GetCallSettingsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallSettingsQuery, GetCallSettingsQueryVariables>(GetCallSettingsDocument, options);
}
export function useGetCallSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallSettingsQuery, GetCallSettingsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallSettingsQuery, GetCallSettingsQueryVariables>(GetCallSettingsDocument, options);
}
// @ts-ignore
export function useGetCallSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallSettingsQuery, GetCallSettingsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingsQuery, GetCallSettingsQueryVariables>;
export function useGetCallSettingsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallSettingsQuery, GetCallSettingsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingsQuery | undefined, GetCallSettingsQueryVariables>;
export function useGetCallSettingsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallSettingsQuery, GetCallSettingsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallSettingsQuery, GetCallSettingsQueryVariables>(GetCallSettingsDocument, options);
}
export type GetCallSettingsQueryHookResult = ReturnType<typeof useGetCallSettingsQuery>;
export type GetCallSettingsLazyQueryHookResult = ReturnType<typeof useGetCallSettingsLazyQuery>;
export type GetCallSettingsSuspenseQueryHookResult = ReturnType<typeof useGetCallSettingsSuspenseQuery>;
export type GetCallSettingsQueryResult = Apollo.QueryResult<GetCallSettingsQuery, GetCallSettingsQueryVariables>;
export const GetChannelGroupsInCallSettingDocument = gql`
  query GetChannelGroupsInCallSetting(
    $callSettingId: Int!
    $sort: SortEnum
    $cursor: String
    $limit: Int
    $order: String
    $query: String
    $onlyAssignedGroups: Boolean
  ) {
    getChannelGroupsInCallSetting(
      callSettingId: $callSettingId
      sort: $sort
      cursor: $cursor
      limit: $limit
      order: $order
      query: $query
      onlyAssignedGroups: $onlyAssignedGroups
    ) {
      message
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      data {
        name
        metrics {
          value
          key
        }
        id
        callSettingId
      }
    }
  }
`;

/**
 * __useGetChannelGroupsInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetChannelGroupsInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelGroupsInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelGroupsInCallSettingQuery({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      query: // value for 'query'
 *      onlyAssignedGroups: // value for 'onlyAssignedGroups'
 *   },
 * });
 */
export function useGetChannelGroupsInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChannelGroupsInCallSettingQuery,
    GetChannelGroupsInCallSettingQueryVariables
  > &
    ({ variables: GetChannelGroupsInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelGroupsInCallSettingQuery, GetChannelGroupsInCallSettingQueryVariables>(
    GetChannelGroupsInCallSettingDocument,
    options
  );
}
export function useGetChannelGroupsInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChannelGroupsInCallSettingQuery,
    GetChannelGroupsInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelGroupsInCallSettingQuery, GetChannelGroupsInCallSettingQueryVariables>(
    GetChannelGroupsInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetChannelGroupsInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChannelGroupsInCallSettingQuery,
    GetChannelGroupsInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetChannelGroupsInCallSettingQuery, GetChannelGroupsInCallSettingQueryVariables>;
export function useGetChannelGroupsInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelGroupsInCallSettingQuery, GetChannelGroupsInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetChannelGroupsInCallSettingQuery | undefined,
  GetChannelGroupsInCallSettingQueryVariables
>;
export function useGetChannelGroupsInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelGroupsInCallSettingQuery, GetChannelGroupsInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChannelGroupsInCallSettingQuery, GetChannelGroupsInCallSettingQueryVariables>(
    GetChannelGroupsInCallSettingDocument,
    options
  );
}
export type GetChannelGroupsInCallSettingQueryHookResult = ReturnType<typeof useGetChannelGroupsInCallSettingQuery>;
export type GetChannelGroupsInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetChannelGroupsInCallSettingLazyQuery
>;
export type GetChannelGroupsInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetChannelGroupsInCallSettingSuspenseQuery
>;
export type GetChannelGroupsInCallSettingQueryResult = Apollo.QueryResult<
  GetChannelGroupsInCallSettingQuery,
  GetChannelGroupsInCallSettingQueryVariables
>;
export const GetComplianceCampaignsDocument = gql`
  query GetComplianceCampaigns(
    $cursor: String
    $query: String
    $limit: Int
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $order: String
    $sort: SortEnum
  ) {
    getComplianceCampaigns(
      cursor: $cursor
      query: $query
      limit: $limit
      direction: $direction
      withCursor: $withCursor
      order: $order
      sort: $sort
    ) {
      message
      data {
        id
        name
        type
        createdAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetComplianceCampaignsQuery__
 *
 * To run a query within a React component, call `useGetComplianceCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCampaignsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetComplianceCampaignsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>(
    GetComplianceCampaignsDocument,
    options
  );
}
export function useGetComplianceCampaignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>(
    GetComplianceCampaignsDocument,
    options
  );
}
// @ts-ignore
export function useGetComplianceCampaignsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>;
export function useGetComplianceCampaignsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetComplianceCampaignsQuery | undefined, GetComplianceCampaignsQueryVariables>;
export function useGetComplianceCampaignsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetComplianceCampaignsQuery, GetComplianceCampaignsQueryVariables>(
    GetComplianceCampaignsDocument,
    options
  );
}
export type GetComplianceCampaignsQueryHookResult = ReturnType<typeof useGetComplianceCampaignsQuery>;
export type GetComplianceCampaignsLazyQueryHookResult = ReturnType<typeof useGetComplianceCampaignsLazyQuery>;
export type GetComplianceCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCampaignsSuspenseQuery>;
export type GetComplianceCampaignsQueryResult = Apollo.QueryResult<
  GetComplianceCampaignsQuery,
  GetComplianceCampaignsQueryVariables
>;
export const ContactComplianceConsentsDocument = gql`
  query ContactComplianceConsents(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $fields: [String]
    $query: String
    $campaigns: [ComplianceCampaignFilter]
  ) {
    contactComplianceConsents(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      fields: $fields
      query: $query
      campaigns: $campaigns
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        profilePicture {
          id
          url
        }
        phoneNumber
        contactComplianceConsents {
          id
          isConsented
          flowDetails
          consentedAt
          consentSource
          consentDetails
          campaign {
            id
            messageServiceName
          }
        }
        country {
          id
          name
          flag
          alphaTwoCode
        }
        name
      }
    }
  }
`;

/**
 * __useContactComplianceConsentsQuery__
 *
 * To run a query within a React component, call `useContactComplianceConsentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactComplianceConsentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactComplianceConsentsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      fields: // value for 'fields'
 *      query: // value for 'query'
 *      campaigns: // value for 'campaigns'
 *   },
 * });
 */
export function useContactComplianceConsentsQuery(
  baseOptions?: Apollo.QueryHookOptions<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>(
    ContactComplianceConsentsDocument,
    options
  );
}
export function useContactComplianceConsentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>(
    ContactComplianceConsentsDocument,
    options
  );
}
// @ts-ignore
export function useContactComplianceConsentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>;
export function useContactComplianceConsentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactComplianceConsentsQuery | undefined, ContactComplianceConsentsQueryVariables>;
export function useContactComplianceConsentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactComplianceConsentsQuery, ContactComplianceConsentsQueryVariables>(
    ContactComplianceConsentsDocument,
    options
  );
}
export type ContactComplianceConsentsQueryHookResult = ReturnType<typeof useContactComplianceConsentsQuery>;
export type ContactComplianceConsentsLazyQueryHookResult = ReturnType<typeof useContactComplianceConsentsLazyQuery>;
export type ContactComplianceConsentsSuspenseQueryHookResult = ReturnType<
  typeof useContactComplianceConsentsSuspenseQuery
>;
export type ContactComplianceConsentsQueryResult = Apollo.QueryResult<
  ContactComplianceConsentsQuery,
  ContactComplianceConsentsQueryVariables
>;
export const ChannelGroupsDocument = gql`
  query ChannelGroups($cursor: String, $order: String, $sort: SortEnum, $limit: Int, $query: String) {
    channelGroups(cursor: $cursor, order: $order, sort: $sort, limit: $limit, query: $query) {
      message
      data {
        name
        id
        callSetting {
          id
          friendlyName
        }
        channel {
          id
          friendlyName
          phoneNumber
        }
        metrics {
          value
          key
        }
      }
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useChannelGroupsQuery__
 *
 * To run a query within a React component, call `useChannelGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelGroupsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useChannelGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<ChannelGroupsQuery, ChannelGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelGroupsQuery, ChannelGroupsQueryVariables>(ChannelGroupsDocument, options);
}
export function useChannelGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChannelGroupsQuery, ChannelGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelGroupsQuery, ChannelGroupsQueryVariables>(ChannelGroupsDocument, options);
}
// @ts-ignore
export function useChannelGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelGroupsQuery, ChannelGroupsQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelGroupsQuery, ChannelGroupsQueryVariables>;
export function useChannelGroupsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelGroupsQuery, ChannelGroupsQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelGroupsQuery | undefined, ChannelGroupsQueryVariables>;
export function useChannelGroupsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelGroupsQuery, ChannelGroupsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelGroupsQuery, ChannelGroupsQueryVariables>(ChannelGroupsDocument, options);
}
export type ChannelGroupsQueryHookResult = ReturnType<typeof useChannelGroupsQuery>;
export type ChannelGroupsLazyQueryHookResult = ReturnType<typeof useChannelGroupsLazyQuery>;
export type ChannelGroupsSuspenseQueryHookResult = ReturnType<typeof useChannelGroupsSuspenseQuery>;
export type ChannelGroupsQueryResult = Apollo.QueryResult<ChannelGroupsQuery, ChannelGroupsQueryVariables>;
export const GetChannelByGroupDocument = gql`
  query GetChannelByGroup(
    $groupId: Int!
    $cursor: String
    $query: String
    $limit: Int
    $sort: SortEnum
    $withCursor: Boolean
  ) {
    getChannelByGroup(
      groupId: $groupId
      cursor: $cursor
      query: $query
      limit: $limit
      sort: $sort
      withCursor: $withCursor
    ) {
      message
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      data {
        id
        phoneNumber
        friendlyName
        channelGroup {
          id
        }
        country {
          id
          name
          flag
        }
      }
    }
  }
`;

/**
 * __useGetChannelByGroupQuery__
 *
 * To run a query within a React component, call `useGetChannelByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelByGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      withCursor: // value for 'withCursor'
 *   },
 * });
 */
export function useGetChannelByGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GetChannelByGroupQuery, GetChannelByGroupQueryVariables> &
    ({ variables: GetChannelByGroupQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>(GetChannelByGroupDocument, options);
}
export function useGetChannelByGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>(
    GetChannelByGroupDocument,
    options
  );
}
// @ts-ignore
export function useGetChannelByGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>
): Apollo.UseSuspenseQueryResult<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>;
export function useGetChannelByGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>
): Apollo.UseSuspenseQueryResult<GetChannelByGroupQuery | undefined, GetChannelByGroupQueryVariables>;
export function useGetChannelByGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>(
    GetChannelByGroupDocument,
    options
  );
}
export type GetChannelByGroupQueryHookResult = ReturnType<typeof useGetChannelByGroupQuery>;
export type GetChannelByGroupLazyQueryHookResult = ReturnType<typeof useGetChannelByGroupLazyQuery>;
export type GetChannelByGroupSuspenseQueryHookResult = ReturnType<typeof useGetChannelByGroupSuspenseQuery>;
export type GetChannelByGroupQueryResult = Apollo.QueryResult<GetChannelByGroupQuery, GetChannelByGroupQueryVariables>;
export const LiveConferencesV2Document = gql`
  query LiveConferencesV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $channelId: Int
  ) {
    liveConferencesV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      channelId: $channelId
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        agent {
          user {
            name
            profilePicture {
              id
              url
            }
          }
          userOnlineManagement {
            isActive
          }
        }
        client {
          id
          name
          phoneNumber
          country {
            flag
          }
          profilePicture {
            id
            url
          }
        }
        channel {
          friendlyName
          phoneNumber
          identity
          country {
            name
            flag
          }
        }
        direction
        conversationStatus
        createdAt
        durationConference {
          startDate
        }
        supervisionId
        supervisionMode
      }
    }
  }
`;

/**
 * __useLiveConferencesV2Query__
 *
 * To run a query within a React component, call `useLiveConferencesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLiveConferencesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveConferencesV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useLiveConferencesV2Query(
  baseOptions?: Apollo.QueryHookOptions<LiveConferencesV2Query, LiveConferencesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LiveConferencesV2Query, LiveConferencesV2QueryVariables>(LiveConferencesV2Document, options);
}
export function useLiveConferencesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LiveConferencesV2Query, LiveConferencesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LiveConferencesV2Query, LiveConferencesV2QueryVariables>(
    LiveConferencesV2Document,
    options
  );
}
// @ts-ignore
export function useLiveConferencesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<LiveConferencesV2Query, LiveConferencesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<LiveConferencesV2Query, LiveConferencesV2QueryVariables>;
export function useLiveConferencesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LiveConferencesV2Query, LiveConferencesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<LiveConferencesV2Query | undefined, LiveConferencesV2QueryVariables>;
export function useLiveConferencesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LiveConferencesV2Query, LiveConferencesV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LiveConferencesV2Query, LiveConferencesV2QueryVariables>(
    LiveConferencesV2Document,
    options
  );
}
export type LiveConferencesV2QueryHookResult = ReturnType<typeof useLiveConferencesV2Query>;
export type LiveConferencesV2LazyQueryHookResult = ReturnType<typeof useLiveConferencesV2LazyQuery>;
export type LiveConferencesV2SuspenseQueryHookResult = ReturnType<typeof useLiveConferencesV2SuspenseQuery>;
export type LiveConferencesV2QueryResult = Apollo.QueryResult<LiveConferencesV2Query, LiveConferencesV2QueryVariables>;
export const GetWorkspaceChannelMembersDocument = gql`
  query GetWorkspaceChannelMembers(
    $channelId: Int!
    $limit: Int
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $order: String
    $sort: SortEnum
    $query: String
    $assignedOnly: Boolean
  ) {
    getWorkspaceChannelMembers(
      channelId: $channelId
      limit: $limit
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      order: $order
      sort: $sort
      query: $query
      assignedOnly: $assignedOnly
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        isAssignedToChannel
        id
        user {
          id
          name
          email
          phoneNumber
          profilePicture {
            id
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkspaceChannelMembersQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceChannelMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceChannelMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceChannelMembersQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *      assignedOnly: // value for 'assignedOnly'
 *   },
 * });
 */
export function useGetWorkspaceChannelMembersQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkspaceChannelMembersQuery, GetWorkspaceChannelMembersQueryVariables> &
    ({ variables: GetWorkspaceChannelMembersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkspaceChannelMembersQuery, GetWorkspaceChannelMembersQueryVariables>(
    GetWorkspaceChannelMembersDocument,
    options
  );
}
export function useGetWorkspaceChannelMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceChannelMembersQuery, GetWorkspaceChannelMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkspaceChannelMembersQuery, GetWorkspaceChannelMembersQueryVariables>(
    GetWorkspaceChannelMembersDocument,
    options
  );
}
// @ts-ignore
export function useGetWorkspaceChannelMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspaceChannelMembersQuery,
    GetWorkspaceChannelMembersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetWorkspaceChannelMembersQuery, GetWorkspaceChannelMembersQueryVariables>;
export function useGetWorkspaceChannelMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkspaceChannelMembersQuery, GetWorkspaceChannelMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWorkspaceChannelMembersQuery | undefined, GetWorkspaceChannelMembersQueryVariables>;
export function useGetWorkspaceChannelMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkspaceChannelMembersQuery, GetWorkspaceChannelMembersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkspaceChannelMembersQuery, GetWorkspaceChannelMembersQueryVariables>(
    GetWorkspaceChannelMembersDocument,
    options
  );
}
export type GetWorkspaceChannelMembersQueryHookResult = ReturnType<typeof useGetWorkspaceChannelMembersQuery>;
export type GetWorkspaceChannelMembersLazyQueryHookResult = ReturnType<typeof useGetWorkspaceChannelMembersLazyQuery>;
export type GetWorkspaceChannelMembersSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceChannelMembersSuspenseQuery
>;
export type GetWorkspaceChannelMembersQueryResult = Apollo.QueryResult<
  GetWorkspaceChannelMembersQuery,
  GetWorkspaceChannelMembersQueryVariables
>;
export const ListBulkMessagingCampaignDocument = gql`
  query ListBulkMessagingCampaign(
    $cursor: String
    $query: String
    $limit: Int
    $withCursor: Boolean
    $direction: CursorDirectionEnum
    $order: String
    $sort: SortEnum
    $campaignType: BulkMessagingCampaignTypeEnum
    $status: [BulkMessagingCampaignStatusEnum]
    $createdBy: [Int]
    $initiatedFrom: Date
    $initiatedTo: Date
  ) {
    listBulkMessagingCampaign(
      cursor: $cursor
      query: $query
      limit: $limit
      withCursor: $withCursor
      direction: $direction
      order: $order
      sort: $sort
      campaignType: $campaignType
      status: $status
      createdBy: $createdBy
      initiatedFrom: $initiatedFrom
      initiatedTo: $initiatedTo
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        campaignName
        isDraft
        messageTemplate
        mediaCount
        campaignType
        messagingType
        status
        scheduleType
        isScheduled
        initiatedAt
        scheduledAt
        maxOccurrence
        endAt
        recipients {
          id
          name
          phoneNumber
          profile {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
        }
        attachments {
          id
          fileName
          mimetype
          fileSize
          fileUrl
        }
        metrics {
          key
          value
        }
        createdBy {
          id
          name
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          roles {
            id
            label
            slug
            level
            isActive
            isDefault
            position
          }
        }
        createdAt
        deliverySummary {
          totalSent
          totalRecipients
          runStatus
          totalDelivered
        }
      }
    }
  }
`;

/**
 * __useListBulkMessagingCampaignQuery__
 *
 * To run a query within a React component, call `useListBulkMessagingCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBulkMessagingCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBulkMessagingCampaignQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      withCursor: // value for 'withCursor'
 *      direction: // value for 'direction'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      campaignType: // value for 'campaignType'
 *      status: // value for 'status'
 *      createdBy: // value for 'createdBy'
 *      initiatedFrom: // value for 'initiatedFrom'
 *      initiatedTo: // value for 'initiatedTo'
 *   },
 * });
 */
export function useListBulkMessagingCampaignQuery(
  baseOptions?: Apollo.QueryHookOptions<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>(
    ListBulkMessagingCampaignDocument,
    options
  );
}
export function useListBulkMessagingCampaignLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>(
    ListBulkMessagingCampaignDocument,
    options
  );
}
// @ts-ignore
export function useListBulkMessagingCampaignSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>
): Apollo.UseSuspenseQueryResult<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>;
export function useListBulkMessagingCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>
): Apollo.UseSuspenseQueryResult<ListBulkMessagingCampaignQuery | undefined, ListBulkMessagingCampaignQueryVariables>;
export function useListBulkMessagingCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListBulkMessagingCampaignQuery, ListBulkMessagingCampaignQueryVariables>(
    ListBulkMessagingCampaignDocument,
    options
  );
}
export type ListBulkMessagingCampaignQueryHookResult = ReturnType<typeof useListBulkMessagingCampaignQuery>;
export type ListBulkMessagingCampaignLazyQueryHookResult = ReturnType<typeof useListBulkMessagingCampaignLazyQuery>;
export type ListBulkMessagingCampaignSuspenseQueryHookResult = ReturnType<
  typeof useListBulkMessagingCampaignSuspenseQuery
>;
export type ListBulkMessagingCampaignQueryResult = Apollo.QueryResult<
  ListBulkMessagingCampaignQuery,
  ListBulkMessagingCampaignQueryVariables
>;
export const ListBulkMessagingCampaignRunsDocument = gql`
  query ListBulkMessagingCampaignRuns(
    $campaignId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $status: BulkMessagingRunStatusEnum
    $runControl: [BulkMessagingRunStatusEnum]
  ) {
    listBulkMessagingCampaignRuns(
      campaignId: $campaignId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      status: $status
      runControl: $runControl
    ) {
      message
      data {
        id
        runNumber
        status
        totalRecipients
        scheduledAt
        startedAt
        completedAt
        createdAt
        updatedAt
        initiatedAt
        campaign {
          id
          name
        }
        deliverySummary {
          totalProcessed
          totalSent
          totalFailed
          totalDelivered
        }
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useListBulkMessagingCampaignRunsQuery__
 *
 * To run a query within a React component, call `useListBulkMessagingCampaignRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBulkMessagingCampaignRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBulkMessagingCampaignRunsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *      status: // value for 'status'
 *      runControl: // value for 'runControl'
 *   },
 * });
 */
export function useListBulkMessagingCampaignRunsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListBulkMessagingCampaignRunsQuery,
    ListBulkMessagingCampaignRunsQueryVariables
  > &
    ({ variables: ListBulkMessagingCampaignRunsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListBulkMessagingCampaignRunsQuery, ListBulkMessagingCampaignRunsQueryVariables>(
    ListBulkMessagingCampaignRunsDocument,
    options
  );
}
export function useListBulkMessagingCampaignRunsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListBulkMessagingCampaignRunsQuery,
    ListBulkMessagingCampaignRunsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListBulkMessagingCampaignRunsQuery, ListBulkMessagingCampaignRunsQueryVariables>(
    ListBulkMessagingCampaignRunsDocument,
    options
  );
}
// @ts-ignore
export function useListBulkMessagingCampaignRunsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListBulkMessagingCampaignRunsQuery,
    ListBulkMessagingCampaignRunsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListBulkMessagingCampaignRunsQuery, ListBulkMessagingCampaignRunsQueryVariables>;
export function useListBulkMessagingCampaignRunsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListBulkMessagingCampaignRunsQuery, ListBulkMessagingCampaignRunsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ListBulkMessagingCampaignRunsQuery | undefined,
  ListBulkMessagingCampaignRunsQueryVariables
>;
export function useListBulkMessagingCampaignRunsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListBulkMessagingCampaignRunsQuery, ListBulkMessagingCampaignRunsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListBulkMessagingCampaignRunsQuery, ListBulkMessagingCampaignRunsQueryVariables>(
    ListBulkMessagingCampaignRunsDocument,
    options
  );
}
export type ListBulkMessagingCampaignRunsQueryHookResult = ReturnType<typeof useListBulkMessagingCampaignRunsQuery>;
export type ListBulkMessagingCampaignRunsLazyQueryHookResult = ReturnType<
  typeof useListBulkMessagingCampaignRunsLazyQuery
>;
export type ListBulkMessagingCampaignRunsSuspenseQueryHookResult = ReturnType<
  typeof useListBulkMessagingCampaignRunsSuspenseQuery
>;
export type ListBulkMessagingCampaignRunsQueryResult = Apollo.QueryResult<
  ListBulkMessagingCampaignRunsQuery,
  ListBulkMessagingCampaignRunsQueryVariables
>;
export const ListPaymentOrdersDocument = gql`
  query ListPaymentOrders($lienStatus: PaymentOrderLienStatusEnum, $limit: Int, $sort: SortEnum, $order: String) {
    listPaymentOrders(lienStatus: $lienStatus, limit: $limit, sort: $sort, order: $order) {
      message
      data {
        id
        lienStatus
        createdAt
      }
      cursor {
        hasNextPage
      }
    }
  }
`;

/**
 * __useListPaymentOrdersQuery__
 *
 * To run a query within a React component, call `useListPaymentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentOrdersQuery({
 *   variables: {
 *      lienStatus: // value for 'lienStatus'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListPaymentOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>(ListPaymentOrdersDocument, options);
}
export function useListPaymentOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>(
    ListPaymentOrdersDocument,
    options
  );
}
// @ts-ignore
export function useListPaymentOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>
): Apollo.UseSuspenseQueryResult<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>;
export function useListPaymentOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>
): Apollo.UseSuspenseQueryResult<ListPaymentOrdersQuery | undefined, ListPaymentOrdersQueryVariables>;
export function useListPaymentOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>(
    ListPaymentOrdersDocument,
    options
  );
}
export type ListPaymentOrdersQueryHookResult = ReturnType<typeof useListPaymentOrdersQuery>;
export type ListPaymentOrdersLazyQueryHookResult = ReturnType<typeof useListPaymentOrdersLazyQuery>;
export type ListPaymentOrdersSuspenseQueryHookResult = ReturnType<typeof useListPaymentOrdersSuspenseQuery>;
export type ListPaymentOrdersQueryResult = Apollo.QueryResult<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>;
export const signOutDocument = gql`
  mutation signOut($input: InputRefreshToken) {
    signOut(input: $input) {
      message
    }
  }
`;
export type signOutMutationFn = Apollo.MutationFunction<signOutMutation, signOutMutationVariables>;

/**
 * __usesignOutMutation__
 *
 * To run a mutation, you first call `usesignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usesignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = usesignOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usesignOutMutation(
  baseOptions?: Apollo.MutationHookOptions<signOutMutation, signOutMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<signOutMutation, signOutMutationVariables>(signOutDocument, options);
}
export type signOutMutationHookResult = ReturnType<typeof usesignOutMutation>;
export type signOutMutationResult = Apollo.MutationResult<signOutMutation>;
export type signOutMutationOptions = Apollo.BaseMutationOptions<signOutMutation, signOutMutationVariables>;
export const SignUpDocument = gql`
  mutation SignUp($input: InputAuthSignUp!) {
    signUp(input: $input) {
      message
      data {
        email
        isEmailVerified
        isPhoneNumberVerified
      }
    }
  }
`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SignUpV2Document = gql`
  mutation SignUpV2($input: InputAuthSignUpV2!) {
    signUpV2(input: $input) {
      message
      data {
        email
        isEmailVerified
        isPhoneNumberVerified
      }
    }
  }
`;
export type SignUpV2MutationFn = Apollo.MutationFunction<SignUpV2Mutation, SignUpV2MutationVariables>;

/**
 * __useSignUpV2Mutation__
 *
 * To run a mutation, you first call `useSignUpV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpV2Mutation, { data, loading, error }] = useSignUpV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<SignUpV2Mutation, SignUpV2MutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignUpV2Mutation, SignUpV2MutationVariables>(SignUpV2Document, options);
}
export type SignUpV2MutationHookResult = ReturnType<typeof useSignUpV2Mutation>;
export type SignUpV2MutationResult = Apollo.MutationResult<SignUpV2Mutation>;
export type SignUpV2MutationOptions = Apollo.BaseMutationOptions<SignUpV2Mutation, SignUpV2MutationVariables>;
export const ConfirmSignupAndLoginDocument = gql`
  mutation ConfirmSignupAndLogin($input: InputAuthConfirmSignUp) {
    confirmSignupAndLogin(input: $input) {
      message
      data {
        token {
          sessionId
          refreshTokenIssuedAt
          refreshTokenExpiresAt
          refresh
          accessTokenIssuedAt
          accessTokenExpiresAt
          access
        }
        isEmailVerified
        twoFactorAuthenticationRequired
      }
    }
  }
`;
export type ConfirmSignupAndLoginMutationFn = Apollo.MutationFunction<
  ConfirmSignupAndLoginMutation,
  ConfirmSignupAndLoginMutationVariables
>;

/**
 * __useConfirmSignupAndLoginMutation__
 *
 * To run a mutation, you first call `useConfirmSignupAndLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSignupAndLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSignupAndLoginMutation, { data, loading, error }] = useConfirmSignupAndLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmSignupAndLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<ConfirmSignupAndLoginMutation, ConfirmSignupAndLoginMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmSignupAndLoginMutation, ConfirmSignupAndLoginMutationVariables>(
    ConfirmSignupAndLoginDocument,
    options
  );
}
export type ConfirmSignupAndLoginMutationHookResult = ReturnType<typeof useConfirmSignupAndLoginMutation>;
export type ConfirmSignupAndLoginMutationResult = Apollo.MutationResult<ConfirmSignupAndLoginMutation>;
export type ConfirmSignupAndLoginMutationOptions = Apollo.BaseMutationOptions<
  ConfirmSignupAndLoginMutation,
  ConfirmSignupAndLoginMutationVariables
>;
export const ForgotPasswordDocument = gql`
  mutation ForgotPassword($input: InputForgotPassword) {
    forgotPassword(input: $input) {
      message
      data {
        email
      }
    }
  }
`;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
}
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<
  ForgotPasswordMutation,
  ForgotPasswordMutationVariables
>;
export const LoginDocument = gql`
  mutation Login($input: InputAuthLogin!) {
    login(input: $input) {
      message
      data {
        token {
          sessionId
          access
          accessTokenIssuedAt
          accessTokenExpiresAt
          refresh
          refreshTokenIssuedAt
          refreshTokenExpiresAt
        }
        isEmailVerified
        twoFactorAuthenticationRequired
        challengeName
        name
        email
        id
      }
    }
  }
`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const CreateTeamsDocument = gql`
  mutation CreateTeams($input: createTeamsInput!) {
    createTeams(input: $input) {
      message
      data {
        totalMembers
        name
        status
        workspacesId
        metrics {
          key
          value
        }
        createdBy
        updatedBy
        description
        id
        members {
          id
          name
          profilePicture {
            id
            url
          }
          accountStatus
        }
      }
    }
  }
`;
export type CreateTeamsMutationFn = Apollo.MutationFunction<CreateTeamsMutation, CreateTeamsMutationVariables>;

/**
 * __useCreateTeamsMutation__
 *
 * To run a mutation, you first call `useCreateTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamsMutation, { data, loading, error }] = useCreateTeamsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamsMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTeamsMutation, CreateTeamsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTeamsMutation, CreateTeamsMutationVariables>(CreateTeamsDocument, options);
}
export type CreateTeamsMutationHookResult = ReturnType<typeof useCreateTeamsMutation>;
export type CreateTeamsMutationResult = Apollo.MutationResult<CreateTeamsMutation>;
export type CreateTeamsMutationOptions = Apollo.BaseMutationOptions<CreateTeamsMutation, CreateTeamsMutationVariables>;
export const UpdateTeamsDocument = gql`
  mutation UpdateTeams($updateTeamsId: String!, $input: updateTeamsInput!) {
    updateTeams(id: $updateTeamsId, input: $input) {
      message
      data {
        id
        name
        description
        status
        teamMembers {
          userId
          workspacesId
          teamId
          status
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
              originalname
            }
            address
          }
        }
      }
    }
  }
`;
export type UpdateTeamsMutationFn = Apollo.MutationFunction<UpdateTeamsMutation, UpdateTeamsMutationVariables>;

/**
 * __useUpdateTeamsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamsMutation, { data, loading, error }] = useUpdateTeamsMutation({
 *   variables: {
 *      updateTeamsId: // value for 'updateTeamsId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTeamsMutation, UpdateTeamsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTeamsMutation, UpdateTeamsMutationVariables>(UpdateTeamsDocument, options);
}
export type UpdateTeamsMutationHookResult = ReturnType<typeof useUpdateTeamsMutation>;
export type UpdateTeamsMutationResult = Apollo.MutationResult<UpdateTeamsMutation>;
export type UpdateTeamsMutationOptions = Apollo.BaseMutationOptions<UpdateTeamsMutation, UpdateTeamsMutationVariables>;
export const DeleteTeamsDocument = gql`
  mutation DeleteTeams($deleteTeamsId: String!) {
    deleteTeams(id: $deleteTeamsId) {
      message
    }
  }
`;
export type DeleteTeamsMutationFn = Apollo.MutationFunction<DeleteTeamsMutation, DeleteTeamsMutationVariables>;

/**
 * __useDeleteTeamsMutation__
 *
 * To run a mutation, you first call `useDeleteTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamsMutation, { data, loading, error }] = useDeleteTeamsMutation({
 *   variables: {
 *      deleteTeamsId: // value for 'deleteTeamsId'
 *   },
 * });
 */
export function useDeleteTeamsMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTeamsMutation, DeleteTeamsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTeamsMutation, DeleteTeamsMutationVariables>(DeleteTeamsDocument, options);
}
export type DeleteTeamsMutationHookResult = ReturnType<typeof useDeleteTeamsMutation>;
export type DeleteTeamsMutationResult = Apollo.MutationResult<DeleteTeamsMutation>;
export type DeleteTeamsMutationOptions = Apollo.BaseMutationOptions<DeleteTeamsMutation, DeleteTeamsMutationVariables>;
export const AddTeamMemberDocument = gql`
  mutation AddTeamMember($input: [InputTeamMembersInterface]!) {
    addTeamMember(input: $input) {
      message
    }
  }
`;
export type AddTeamMemberMutationFn = Apollo.MutationFunction<AddTeamMemberMutation, AddTeamMemberMutationVariables>;

/**
 * __useAddTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMemberMutation, { data, loading, error }] = useAddTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddTeamMemberMutation, AddTeamMemberMutationVariables>(AddTeamMemberDocument, options);
}
export type AddTeamMemberMutationHookResult = ReturnType<typeof useAddTeamMemberMutation>;
export type AddTeamMemberMutationResult = Apollo.MutationResult<AddTeamMemberMutation>;
export type AddTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  AddTeamMemberMutation,
  AddTeamMemberMutationVariables
>;
export const DeleteTeamMemberDocument = gql`
  mutation DeleteTeamMember($deleteTeamMemberId: Int!) {
    deleteTeamMember(id: $deleteTeamMemberId) {
      message
    }
  }
`;
export type DeleteTeamMemberMutationFn = Apollo.MutationFunction<
  DeleteTeamMemberMutation,
  DeleteTeamMemberMutationVariables
>;

/**
 * __useDeleteTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMemberMutation, { data, loading, error }] = useDeleteTeamMemberMutation({
 *   variables: {
 *      deleteTeamMemberId: // value for 'deleteTeamMemberId'
 *   },
 * });
 */
export function useDeleteTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>(
    DeleteTeamMemberDocument,
    options
  );
}
export type DeleteTeamMemberMutationHookResult = ReturnType<typeof useDeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationResult = Apollo.MutationResult<DeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  DeleteTeamMemberMutation,
  DeleteTeamMemberMutationVariables
>;
export const BlockOrUnblockContactDocument = gql`
  mutation BlockOrUnblockContact($blockOrUnblockContactId: Int, $input: InputBlockOrUnblockContact) {
    blockOrUnblockContact(id: $blockOrUnblockContactId, input: $input) {
      data {
        id
        isBlocked
        isPublished
        phoneNumber
        name
        blockedOn
        timeZone
        blockedBy {
          name
        }
        blockReason
        country {
          id
          flag
        }
        profilePicture {
          id
          url
        }
      }
      message
    }
  }
`;
export type BlockOrUnblockContactMutationFn = Apollo.MutationFunction<
  BlockOrUnblockContactMutation,
  BlockOrUnblockContactMutationVariables
>;

/**
 * __useBlockOrUnblockContactMutation__
 *
 * To run a mutation, you first call `useBlockOrUnblockContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockOrUnblockContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockOrUnblockContactMutation, { data, loading, error }] = useBlockOrUnblockContactMutation({
 *   variables: {
 *      blockOrUnblockContactId: // value for 'blockOrUnblockContactId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBlockOrUnblockContactMutation(
  baseOptions?: Apollo.MutationHookOptions<BlockOrUnblockContactMutation, BlockOrUnblockContactMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BlockOrUnblockContactMutation, BlockOrUnblockContactMutationVariables>(
    BlockOrUnblockContactDocument,
    options
  );
}
export type BlockOrUnblockContactMutationHookResult = ReturnType<typeof useBlockOrUnblockContactMutation>;
export type BlockOrUnblockContactMutationResult = Apollo.MutationResult<BlockOrUnblockContactMutation>;
export type BlockOrUnblockContactMutationOptions = Apollo.BaseMutationOptions<
  BlockOrUnblockContactMutation,
  BlockOrUnblockContactMutationVariables
>;
export const ConfirmForgotPasswordDocument = gql`
  mutation ConfirmForgotPassword($input: InputConfirmForgotPassword) {
    confirmForgotPassword(input: $input) {
      message
    }
  }
`;
export type ConfirmForgotPasswordMutationFn = Apollo.MutationFunction<
  ConfirmForgotPasswordMutation,
  ConfirmForgotPasswordMutationVariables
>;

/**
 * __useConfirmForgotPasswordMutation__
 *
 * To run a mutation, you first call `useConfirmForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmForgotPasswordMutation, { data, loading, error }] = useConfirmForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmForgotPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>(
    ConfirmForgotPasswordDocument,
    options
  );
}
export type ConfirmForgotPasswordMutationHookResult = ReturnType<typeof useConfirmForgotPasswordMutation>;
export type ConfirmForgotPasswordMutationResult = Apollo.MutationResult<ConfirmForgotPasswordMutation>;
export type ConfirmForgotPasswordMutationOptions = Apollo.BaseMutationOptions<
  ConfirmForgotPasswordMutation,
  ConfirmForgotPasswordMutationVariables
>;
export const SendMessageDocument = gql`
  mutation SendMessage($input: InputSendMessage) {
    sendMessage(input: $input) {
      message
      data {
        id
        markAsClosed
        direction
        durationConference {
          endDate
          startDate
        }
        client {
          id
          name
          phoneNumber
          profilePicture {
            id
            url
          }
          country {
            id
            flag
          }
        }
        agent {
          callPlatform
          user {
            id
            name
            profilePicture {
              id
              url
            }
          }
        }
        pinned
        channelId
        conversationStatus
        messageContent
        conversationType
        recordingUrl
        numMedia
        friendlyName
        voicemailRecordingUrl
        createdAt
        forwardedAt
        forwardedTo {
          externalNumber
        }
      }
    }
  }
`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
}
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const PinOrUnpinMessageConversationDocument = gql`
  mutation PinOrUnpinMessageConversation(
    $pinOrUnpinMessageConversationId: Int!
    $input: InputPinUnpinMessageConversation
  ) {
    pinOrUnpinMessageConversation(id: $pinOrUnpinMessageConversationId, input: $input) {
      message
      data {
        id
        pinned
      }
    }
  }
`;
export type PinOrUnpinMessageConversationMutationFn = Apollo.MutationFunction<
  PinOrUnpinMessageConversationMutation,
  PinOrUnpinMessageConversationMutationVariables
>;

/**
 * __usePinOrUnpinMessageConversationMutation__
 *
 * To run a mutation, you first call `usePinOrUnpinMessageConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinOrUnpinMessageConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinOrUnpinMessageConversationMutation, { data, loading, error }] = usePinOrUnpinMessageConversationMutation({
 *   variables: {
 *      pinOrUnpinMessageConversationId: // value for 'pinOrUnpinMessageConversationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePinOrUnpinMessageConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PinOrUnpinMessageConversationMutation,
    PinOrUnpinMessageConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PinOrUnpinMessageConversationMutation, PinOrUnpinMessageConversationMutationVariables>(
    PinOrUnpinMessageConversationDocument,
    options
  );
}
export type PinOrUnpinMessageConversationMutationHookResult = ReturnType<
  typeof usePinOrUnpinMessageConversationMutation
>;
export type PinOrUnpinMessageConversationMutationResult = Apollo.MutationResult<PinOrUnpinMessageConversationMutation>;
export type PinOrUnpinMessageConversationMutationOptions = Apollo.BaseMutationOptions<
  PinOrUnpinMessageConversationMutation,
  PinOrUnpinMessageConversationMutationVariables
>;
export const VerifyTwoFactorAuthenticationDocument = gql`
  mutation VerifyTwoFactorAuthentication($input: InputVerifyTwoFactorAuthentication) {
    verifyTwoFactorAuthentication(input: $input) {
      message
      data {
        token {
          sessionId
          access
          refresh
        }
        isEmailVerified
        twoFactorAuthenticationRequired
      }
    }
  }
`;
export type VerifyTwoFactorAuthenticationMutationFn = Apollo.MutationFunction<
  VerifyTwoFactorAuthenticationMutation,
  VerifyTwoFactorAuthenticationMutationVariables
>;

/**
 * __useVerifyTwoFactorAuthenticationMutation__
 *
 * To run a mutation, you first call `useVerifyTwoFactorAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTwoFactorAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTwoFactorAuthenticationMutation, { data, loading, error }] = useVerifyTwoFactorAuthenticationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyTwoFactorAuthenticationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyTwoFactorAuthenticationMutation,
    VerifyTwoFactorAuthenticationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyTwoFactorAuthenticationMutation, VerifyTwoFactorAuthenticationMutationVariables>(
    VerifyTwoFactorAuthenticationDocument,
    options
  );
}
export type VerifyTwoFactorAuthenticationMutationHookResult = ReturnType<
  typeof useVerifyTwoFactorAuthenticationMutation
>;
export type VerifyTwoFactorAuthenticationMutationResult = Apollo.MutationResult<VerifyTwoFactorAuthenticationMutation>;
export type VerifyTwoFactorAuthenticationMutationOptions = Apollo.BaseMutationOptions<
  VerifyTwoFactorAuthenticationMutation,
  VerifyTwoFactorAuthenticationMutationVariables
>;
export const ResendTwoFactorAuthenticationCodeDocument = gql`
  mutation ResendTwoFactorAuthenticationCode($email: String) {
    resendTwoFactorAuthenticationCode(email: $email) {
      message
    }
  }
`;
export type ResendTwoFactorAuthenticationCodeMutationFn = Apollo.MutationFunction<
  ResendTwoFactorAuthenticationCodeMutation,
  ResendTwoFactorAuthenticationCodeMutationVariables
>;

/**
 * __useResendTwoFactorAuthenticationCodeMutation__
 *
 * To run a mutation, you first call `useResendTwoFactorAuthenticationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTwoFactorAuthenticationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTwoFactorAuthenticationCodeMutation, { data, loading, error }] = useResendTwoFactorAuthenticationCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendTwoFactorAuthenticationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendTwoFactorAuthenticationCodeMutation,
    ResendTwoFactorAuthenticationCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendTwoFactorAuthenticationCodeMutation,
    ResendTwoFactorAuthenticationCodeMutationVariables
  >(ResendTwoFactorAuthenticationCodeDocument, options);
}
export type ResendTwoFactorAuthenticationCodeMutationHookResult = ReturnType<
  typeof useResendTwoFactorAuthenticationCodeMutation
>;
export type ResendTwoFactorAuthenticationCodeMutationResult =
  Apollo.MutationResult<ResendTwoFactorAuthenticationCodeMutation>;
export type ResendTwoFactorAuthenticationCodeMutationOptions = Apollo.BaseMutationOptions<
  ResendTwoFactorAuthenticationCodeMutation,
  ResendTwoFactorAuthenticationCodeMutationVariables
>;
export const WorkspaceLoginDocument = gql`
  mutation WorkspaceLogin($input: InputWorkspaceLogin) {
    workspaceLogin(input: $input) {
      data {
        token {
          access
        }
        workspaceUser {
          id
          workspace {
            status
            hasCompleted
            label
            logo {
              url
            }
          }
        }
      }
      message
    }
  }
`;
export type WorkspaceLoginMutationFn = Apollo.MutationFunction<WorkspaceLoginMutation, WorkspaceLoginMutationVariables>;

/**
 * __useWorkspaceLoginMutation__
 *
 * To run a mutation, you first call `useWorkspaceLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspaceLoginMutation, { data, loading, error }] = useWorkspaceLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspaceLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<WorkspaceLoginMutation, WorkspaceLoginMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WorkspaceLoginMutation, WorkspaceLoginMutationVariables>(WorkspaceLoginDocument, options);
}
export type WorkspaceLoginMutationHookResult = ReturnType<typeof useWorkspaceLoginMutation>;
export type WorkspaceLoginMutationResult = Apollo.MutationResult<WorkspaceLoginMutation>;
export type WorkspaceLoginMutationOptions = Apollo.BaseMutationOptions<
  WorkspaceLoginMutation,
  WorkspaceLoginMutationVariables
>;
export const CreateCommandResponseDocument = gql`
  mutation CreateCommandResponse($input: CommandResponseInput) {
    createCommandResponse(input: $input) {
      data {
        title
        id
        content
        command
      }
      message
    }
  }
`;
export type CreateCommandResponseMutationFn = Apollo.MutationFunction<
  CreateCommandResponseMutation,
  CreateCommandResponseMutationVariables
>;

/**
 * __useCreateCommandResponseMutation__
 *
 * To run a mutation, you first call `useCreateCommandResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommandResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommandResponseMutation, { data, loading, error }] = useCreateCommandResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommandResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCommandResponseMutation, CreateCommandResponseMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCommandResponseMutation, CreateCommandResponseMutationVariables>(
    CreateCommandResponseDocument,
    options
  );
}
export type CreateCommandResponseMutationHookResult = ReturnType<typeof useCreateCommandResponseMutation>;
export type CreateCommandResponseMutationResult = Apollo.MutationResult<CreateCommandResponseMutation>;
export type CreateCommandResponseMutationOptions = Apollo.BaseMutationOptions<
  CreateCommandResponseMutation,
  CreateCommandResponseMutationVariables
>;
export const UpdateCommandResponseDocument = gql`
  mutation UpdateCommandResponse($updateCommandResponseId: Int!, $input: CommandResponseInput) {
    updateCommandResponse(id: $updateCommandResponseId, input: $input) {
      message
      data {
        id
        title
        command
        content
      }
    }
  }
`;
export type UpdateCommandResponseMutationFn = Apollo.MutationFunction<
  UpdateCommandResponseMutation,
  UpdateCommandResponseMutationVariables
>;

/**
 * __useUpdateCommandResponseMutation__
 *
 * To run a mutation, you first call `useUpdateCommandResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommandResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommandResponseMutation, { data, loading, error }] = useUpdateCommandResponseMutation({
 *   variables: {
 *      updateCommandResponseId: // value for 'updateCommandResponseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommandResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCommandResponseMutation, UpdateCommandResponseMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCommandResponseMutation, UpdateCommandResponseMutationVariables>(
    UpdateCommandResponseDocument,
    options
  );
}
export type UpdateCommandResponseMutationHookResult = ReturnType<typeof useUpdateCommandResponseMutation>;
export type UpdateCommandResponseMutationResult = Apollo.MutationResult<UpdateCommandResponseMutation>;
export type UpdateCommandResponseMutationOptions = Apollo.BaseMutationOptions<
  UpdateCommandResponseMutation,
  UpdateCommandResponseMutationVariables
>;
export const DeleteCommandResponseDocument = gql`
  mutation DeleteCommandResponse($deleteCommandResponseId: Int!) {
    deleteCommandResponse(id: $deleteCommandResponseId) {
      message
      data {
        id
        title
        command
        content
      }
    }
  }
`;
export type DeleteCommandResponseMutationFn = Apollo.MutationFunction<
  DeleteCommandResponseMutation,
  DeleteCommandResponseMutationVariables
>;

/**
 * __useDeleteCommandResponseMutation__
 *
 * To run a mutation, you first call `useDeleteCommandResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommandResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommandResponseMutation, { data, loading, error }] = useDeleteCommandResponseMutation({
 *   variables: {
 *      deleteCommandResponseId: // value for 'deleteCommandResponseId'
 *   },
 * });
 */
export function useDeleteCommandResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCommandResponseMutation, DeleteCommandResponseMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCommandResponseMutation, DeleteCommandResponseMutationVariables>(
    DeleteCommandResponseDocument,
    options
  );
}
export type DeleteCommandResponseMutationHookResult = ReturnType<typeof useDeleteCommandResponseMutation>;
export type DeleteCommandResponseMutationResult = Apollo.MutationResult<DeleteCommandResponseMutation>;
export type DeleteCommandResponseMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommandResponseMutation,
  DeleteCommandResponseMutationVariables
>;
export const PreCheckLoginDocument = gql`
  mutation PreCheckLogin($input: PreCheckLogin) {
    preCheckLogin(input: $input) {
      message
      data {
        platformExists
      }
    }
  }
`;
export type PreCheckLoginMutationFn = Apollo.MutationFunction<PreCheckLoginMutation, PreCheckLoginMutationVariables>;

/**
 * __usePreCheckLoginMutation__
 *
 * To run a mutation, you first call `usePreCheckLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreCheckLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preCheckLoginMutation, { data, loading, error }] = usePreCheckLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreCheckLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<PreCheckLoginMutation, PreCheckLoginMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PreCheckLoginMutation, PreCheckLoginMutationVariables>(PreCheckLoginDocument, options);
}
export type PreCheckLoginMutationHookResult = ReturnType<typeof usePreCheckLoginMutation>;
export type PreCheckLoginMutationResult = Apollo.MutationResult<PreCheckLoginMutation>;
export type PreCheckLoginMutationOptions = Apollo.BaseMutationOptions<
  PreCheckLoginMutation,
  PreCheckLoginMutationVariables
>;
export const CreateCustomerV2Document = gql`
  mutation CreateCustomerV2($input: InputCreateCustomerV2) {
    createCustomerV2(input: $input) {
      message
    }
  }
`;
export type CreateCustomerV2MutationFn = Apollo.MutationFunction<
  CreateCustomerV2Mutation,
  CreateCustomerV2MutationVariables
>;

/**
 * __useCreateCustomerV2Mutation__
 *
 * To run a mutation, you first call `useCreateCustomerV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerV2Mutation, { data, loading, error }] = useCreateCustomerV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCustomerV2Mutation, CreateCustomerV2MutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCustomerV2Mutation, CreateCustomerV2MutationVariables>(
    CreateCustomerV2Document,
    options
  );
}
export type CreateCustomerV2MutationHookResult = ReturnType<typeof useCreateCustomerV2Mutation>;
export type CreateCustomerV2MutationResult = Apollo.MutationResult<CreateCustomerV2Mutation>;
export type CreateCustomerV2MutationOptions = Apollo.BaseMutationOptions<
  CreateCustomerV2Mutation,
  CreateCustomerV2MutationVariables
>;
export const CreatePaymentIntentV2Document = gql`
  mutation CreatePaymentIntentV2($amount: Int, $paymentGateway: PaymentGatewayEnum) {
    createPaymentIntentV2(amount: $amount, paymentGateway: $paymentGateway) {
      message
      data
    }
  }
`;
export type CreatePaymentIntentV2MutationFn = Apollo.MutationFunction<
  CreatePaymentIntentV2Mutation,
  CreatePaymentIntentV2MutationVariables
>;

/**
 * __useCreatePaymentIntentV2Mutation__
 *
 * To run a mutation, you first call `useCreatePaymentIntentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentIntentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentV2Mutation, { data, loading, error }] = useCreatePaymentIntentV2Mutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      paymentGateway: // value for 'paymentGateway'
 *   },
 * });
 */
export function useCreatePaymentIntentV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePaymentIntentV2Mutation, CreatePaymentIntentV2MutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePaymentIntentV2Mutation, CreatePaymentIntentV2MutationVariables>(
    CreatePaymentIntentV2Document,
    options
  );
}
export type CreatePaymentIntentV2MutationHookResult = ReturnType<typeof useCreatePaymentIntentV2Mutation>;
export type CreatePaymentIntentV2MutationResult = Apollo.MutationResult<CreatePaymentIntentV2Mutation>;
export type CreatePaymentIntentV2MutationOptions = Apollo.BaseMutationOptions<
  CreatePaymentIntentV2Mutation,
  CreatePaymentIntentV2MutationVariables
>;
export const CreateSubscriptionDocument = gql`
  mutation CreateSubscription($input: InputCreateSubscription) {
    createSubscription(input: $input) {
      message
    }
  }
`;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(
    CreateSubscriptionDocument,
    options
  );
}
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;
export const ResendConfirmationCodeDocument = gql`
  mutation ResendConfirmationCode($input: InputAuthResendConfirmationCode!) {
    resendConfirmationCode(input: $input) {
      message
    }
  }
`;
export type ResendConfirmationCodeMutationFn = Apollo.MutationFunction<
  ResendConfirmationCodeMutation,
  ResendConfirmationCodeMutationVariables
>;

/**
 * __useResendConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useResendConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendConfirmationCodeMutation, { data, loading, error }] = useResendConfirmationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendConfirmationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendConfirmationCodeMutation, ResendConfirmationCodeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResendConfirmationCodeMutation, ResendConfirmationCodeMutationVariables>(
    ResendConfirmationCodeDocument,
    options
  );
}
export type ResendConfirmationCodeMutationHookResult = ReturnType<typeof useResendConfirmationCodeMutation>;
export type ResendConfirmationCodeMutationResult = Apollo.MutationResult<ResendConfirmationCodeMutation>;
export type ResendConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<
  ResendConfirmationCodeMutation,
  ResendConfirmationCodeMutationVariables
>;
export const CreateUserWorkspaceFcmTokenDocument = gql`
  mutation CreateUserWorkspaceFcmToken($input: InputUserWorkspaceFCMToken!) {
    createUserWorkspaceFcmToken(input: $input) {
      message
      data {
        id
        token
        platform
      }
    }
  }
`;
export type CreateUserWorkspaceFcmTokenMutationFn = Apollo.MutationFunction<
  CreateUserWorkspaceFcmTokenMutation,
  CreateUserWorkspaceFcmTokenMutationVariables
>;

/**
 * __useCreateUserWorkspaceFcmTokenMutation__
 *
 * To run a mutation, you first call `useCreateUserWorkspaceFcmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserWorkspaceFcmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserWorkspaceFcmTokenMutation, { data, loading, error }] = useCreateUserWorkspaceFcmTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserWorkspaceFcmTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserWorkspaceFcmTokenMutation,
    CreateUserWorkspaceFcmTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserWorkspaceFcmTokenMutation, CreateUserWorkspaceFcmTokenMutationVariables>(
    CreateUserWorkspaceFcmTokenDocument,
    options
  );
}
export type CreateUserWorkspaceFcmTokenMutationHookResult = ReturnType<typeof useCreateUserWorkspaceFcmTokenMutation>;
export type CreateUserWorkspaceFcmTokenMutationResult = Apollo.MutationResult<CreateUserWorkspaceFcmTokenMutation>;
export type CreateUserWorkspaceFcmTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateUserWorkspaceFcmTokenMutation,
  CreateUserWorkspaceFcmTokenMutationVariables
>;
export const DeleteUserWorkspaceFcmTokenDocument = gql`
  mutation DeleteUserWorkspaceFcmToken {
    deleteUserWorkspaceFcmToken {
      message
    }
  }
`;
export type DeleteUserWorkspaceFcmTokenMutationFn = Apollo.MutationFunction<
  DeleteUserWorkspaceFcmTokenMutation,
  DeleteUserWorkspaceFcmTokenMutationVariables
>;

/**
 * __useDeleteUserWorkspaceFcmTokenMutation__
 *
 * To run a mutation, you first call `useDeleteUserWorkspaceFcmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserWorkspaceFcmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserWorkspaceFcmTokenMutation, { data, loading, error }] = useDeleteUserWorkspaceFcmTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserWorkspaceFcmTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserWorkspaceFcmTokenMutation,
    DeleteUserWorkspaceFcmTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserWorkspaceFcmTokenMutation, DeleteUserWorkspaceFcmTokenMutationVariables>(
    DeleteUserWorkspaceFcmTokenDocument,
    options
  );
}
export type DeleteUserWorkspaceFcmTokenMutationHookResult = ReturnType<typeof useDeleteUserWorkspaceFcmTokenMutation>;
export type DeleteUserWorkspaceFcmTokenMutationResult = Apollo.MutationResult<DeleteUserWorkspaceFcmTokenMutation>;
export type DeleteUserWorkspaceFcmTokenMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserWorkspaceFcmTokenMutation,
  DeleteUserWorkspaceFcmTokenMutationVariables
>;
export const CreateProviderErrorLogDocument = gql`
  mutation CreateProviderErrorLog($input: InputProviderErrorLogData) {
    createProviderErrorLog(input: $input) {
      message
    }
  }
`;
export type CreateProviderErrorLogMutationFn = Apollo.MutationFunction<
  CreateProviderErrorLogMutation,
  CreateProviderErrorLogMutationVariables
>;

/**
 * __useCreateProviderErrorLogMutation__
 *
 * To run a mutation, you first call `useCreateProviderErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderErrorLogMutation, { data, loading, error }] = useCreateProviderErrorLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderErrorLogMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProviderErrorLogMutation, CreateProviderErrorLogMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProviderErrorLogMutation, CreateProviderErrorLogMutationVariables>(
    CreateProviderErrorLogDocument,
    options
  );
}
export type CreateProviderErrorLogMutationHookResult = ReturnType<typeof useCreateProviderErrorLogMutation>;
export type CreateProviderErrorLogMutationResult = Apollo.MutationResult<CreateProviderErrorLogMutation>;
export type CreateProviderErrorLogMutationOptions = Apollo.BaseMutationOptions<
  CreateProviderErrorLogMutation,
  CreateProviderErrorLogMutationVariables
>;
export const CreateContactNoteDocument = gql`
  mutation CreateContactNote($input: InputContactNote!) {
    createContactNote(input: $input) {
      message
      data {
        id
        description
        createdAt
        updatedAt
        updatedBy {
          id
          user {
            id
            name
            profilePicture {
              id
              url
            }
          }
        }
      }
    }
  }
`;
export type CreateContactNoteMutationFn = Apollo.MutationFunction<
  CreateContactNoteMutation,
  CreateContactNoteMutationVariables
>;

/**
 * __useCreateContactNoteMutation__
 *
 * To run a mutation, you first call `useCreateContactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactNoteMutation, { data, loading, error }] = useCreateContactNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateContactNoteMutation, CreateContactNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateContactNoteMutation, CreateContactNoteMutationVariables>(
    CreateContactNoteDocument,
    options
  );
}
export type CreateContactNoteMutationHookResult = ReturnType<typeof useCreateContactNoteMutation>;
export type CreateContactNoteMutationResult = Apollo.MutationResult<CreateContactNoteMutation>;
export type CreateContactNoteMutationOptions = Apollo.BaseMutationOptions<
  CreateContactNoteMutation,
  CreateContactNoteMutationVariables
>;
export const UpdateContactNoteDocument = gql`
  mutation UpdateContactNote($updateContactNoteId: Int!, $input: InputContactNote!) {
    updateContactNote(id: $updateContactNoteId, input: $input) {
      message
      data {
        id
        description
        createdAt
        updatedAt
        updatedBy {
          id
          user {
            id
            name
            profilePicture {
              id
              url
            }
          }
        }
      }
    }
  }
`;
export type UpdateContactNoteMutationFn = Apollo.MutationFunction<
  UpdateContactNoteMutation,
  UpdateContactNoteMutationVariables
>;

/**
 * __useUpdateContactNoteMutation__
 *
 * To run a mutation, you first call `useUpdateContactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactNoteMutation, { data, loading, error }] = useUpdateContactNoteMutation({
 *   variables: {
 *      updateContactNoteId: // value for 'updateContactNoteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateContactNoteMutation, UpdateContactNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateContactNoteMutation, UpdateContactNoteMutationVariables>(
    UpdateContactNoteDocument,
    options
  );
}
export type UpdateContactNoteMutationHookResult = ReturnType<typeof useUpdateContactNoteMutation>;
export type UpdateContactNoteMutationResult = Apollo.MutationResult<UpdateContactNoteMutation>;
export type UpdateContactNoteMutationOptions = Apollo.BaseMutationOptions<
  UpdateContactNoteMutation,
  UpdateContactNoteMutationVariables
>;
export const DeleteContactNoteDocument = gql`
  mutation DeleteContactNote($deleteContactNoteId: Int!) {
    deleteContactNote(id: $deleteContactNoteId) {
      message
      data {
        id
      }
    }
  }
`;
export type DeleteContactNoteMutationFn = Apollo.MutationFunction<
  DeleteContactNoteMutation,
  DeleteContactNoteMutationVariables
>;

/**
 * __useDeleteContactNoteMutation__
 *
 * To run a mutation, you first call `useDeleteContactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactNoteMutation, { data, loading, error }] = useDeleteContactNoteMutation({
 *   variables: {
 *      deleteContactNoteId: // value for 'deleteContactNoteId'
 *   },
 * });
 */
export function useDeleteContactNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteContactNoteMutation, DeleteContactNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteContactNoteMutation, DeleteContactNoteMutationVariables>(
    DeleteContactNoteDocument,
    options
  );
}
export type DeleteContactNoteMutationHookResult = ReturnType<typeof useDeleteContactNoteMutation>;
export type DeleteContactNoteMutationResult = Apollo.MutationResult<DeleteContactNoteMutation>;
export type DeleteContactNoteMutationOptions = Apollo.BaseMutationOptions<
  DeleteContactNoteMutation,
  DeleteContactNoteMutationVariables
>;
export const CreateTagDocument = gql`
  mutation CreateTag($input: InputTag!) {
    createTag(input: $input) {
      message
      data {
        id
        label
        color
      }
    }
  }
`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
}
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
  mutation UpdateTag($updateTagId: Int!, $input: InputTag!) {
    updateTag(id: $updateTagId, input: $input) {
      message
      data {
        id
        label
        slug
        type
        color
      }
    }
  }
`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      updateTagId: // value for 'updateTagId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
}
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagsDocument = gql`
  mutation DeleteTags($ids: [Int!]!) {
    deleteTags(ids: $ids) {
      message
      data {
        id
      }
    }
  }
`;
export type DeleteTagsMutationFn = Apollo.MutationFunction<DeleteTagsMutation, DeleteTagsMutationVariables>;

/**
 * __useDeleteTagsMutation__
 *
 * To run a mutation, you first call `useDeleteTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagsMutation, { data, loading, error }] = useDeleteTagsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTagsMutation, DeleteTagsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTagsMutation, DeleteTagsMutationVariables>(DeleteTagsDocument, options);
}
export type DeleteTagsMutationHookResult = ReturnType<typeof useDeleteTagsMutation>;
export type DeleteTagsMutationResult = Apollo.MutationResult<DeleteTagsMutation>;
export type DeleteTagsMutationOptions = Apollo.BaseMutationOptions<DeleteTagsMutation, DeleteTagsMutationVariables>;
export const AssignTagsToContactDocument = gql`
  mutation AssignTagsToContact($input: AssignUnassignContactTag) {
    assignTagsToContact(input: $input) {
      message
      data {
        id
        contact {
          id
        }
        tags {
          type
          slug
          label
          id
          color
        }
      }
    }
  }
`;
export type AssignTagsToContactMutationFn = Apollo.MutationFunction<
  AssignTagsToContactMutation,
  AssignTagsToContactMutationVariables
>;

/**
 * __useAssignTagsToContactMutation__
 *
 * To run a mutation, you first call `useAssignTagsToContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTagsToContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTagsToContactMutation, { data, loading, error }] = useAssignTagsToContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTagsToContactMutation(
  baseOptions?: Apollo.MutationHookOptions<AssignTagsToContactMutation, AssignTagsToContactMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignTagsToContactMutation, AssignTagsToContactMutationVariables>(
    AssignTagsToContactDocument,
    options
  );
}
export type AssignTagsToContactMutationHookResult = ReturnType<typeof useAssignTagsToContactMutation>;
export type AssignTagsToContactMutationResult = Apollo.MutationResult<AssignTagsToContactMutation>;
export type AssignTagsToContactMutationOptions = Apollo.BaseMutationOptions<
  AssignTagsToContactMutation,
  AssignTagsToContactMutationVariables
>;
export const UnassignTagsFromContactDocument = gql`
  mutation UnassignTagsFromContact($input: AssignUnassignContactTag) {
    unassignTagsFromContact(input: $input) {
      message
      data {
        tags {
          id
          label
          color
        }
      }
    }
  }
`;
export type UnassignTagsFromContactMutationFn = Apollo.MutationFunction<
  UnassignTagsFromContactMutation,
  UnassignTagsFromContactMutationVariables
>;

/**
 * __useUnassignTagsFromContactMutation__
 *
 * To run a mutation, you first call `useUnassignTagsFromContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignTagsFromContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignTagsFromContactMutation, { data, loading, error }] = useUnassignTagsFromContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignTagsFromContactMutation(
  baseOptions?: Apollo.MutationHookOptions<UnassignTagsFromContactMutation, UnassignTagsFromContactMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnassignTagsFromContactMutation, UnassignTagsFromContactMutationVariables>(
    UnassignTagsFromContactDocument,
    options
  );
}
export type UnassignTagsFromContactMutationHookResult = ReturnType<typeof useUnassignTagsFromContactMutation>;
export type UnassignTagsFromContactMutationResult = Apollo.MutationResult<UnassignTagsFromContactMutation>;
export type UnassignTagsFromContactMutationOptions = Apollo.BaseMutationOptions<
  UnassignTagsFromContactMutation,
  UnassignTagsFromContactMutationVariables
>;
export const SetDefaultChannelDocument = gql`
  mutation SetDefaultChannel($channelId: Int!) {
    setDefaultChannel(channelId: $channelId) {
      message
      data {
        id
      }
    }
  }
`;
export type SetDefaultChannelMutationFn = Apollo.MutationFunction<
  SetDefaultChannelMutation,
  SetDefaultChannelMutationVariables
>;

/**
 * __useSetDefaultChannelMutation__
 *
 * To run a mutation, you first call `useSetDefaultChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultChannelMutation, { data, loading, error }] = useSetDefaultChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useSetDefaultChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<SetDefaultChannelMutation, SetDefaultChannelMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetDefaultChannelMutation, SetDefaultChannelMutationVariables>(
    SetDefaultChannelDocument,
    options
  );
}
export type SetDefaultChannelMutationHookResult = ReturnType<typeof useSetDefaultChannelMutation>;
export type SetDefaultChannelMutationResult = Apollo.MutationResult<SetDefaultChannelMutation>;
export type SetDefaultChannelMutationOptions = Apollo.BaseMutationOptions<
  SetDefaultChannelMutation,
  SetDefaultChannelMutationVariables
>;
export const SetDefaultCountryDocument = gql`
  mutation SetDefaultCountry($input: InputSetDefaultCountry) {
    setDefaultCountry(input: $input) {
      message
    }
  }
`;
export type SetDefaultCountryMutationFn = Apollo.MutationFunction<
  SetDefaultCountryMutation,
  SetDefaultCountryMutationVariables
>;

/**
 * __useSetDefaultCountryMutation__
 *
 * To run a mutation, you first call `useSetDefaultCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultCountryMutation, { data, loading, error }] = useSetDefaultCountryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultCountryMutation(
  baseOptions?: Apollo.MutationHookOptions<SetDefaultCountryMutation, SetDefaultCountryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetDefaultCountryMutation, SetDefaultCountryMutationVariables>(
    SetDefaultCountryDocument,
    options
  );
}
export type SetDefaultCountryMutationHookResult = ReturnType<typeof useSetDefaultCountryMutation>;
export type SetDefaultCountryMutationResult = Apollo.MutationResult<SetDefaultCountryMutation>;
export type SetDefaultCountryMutationOptions = Apollo.BaseMutationOptions<
  SetDefaultCountryMutation,
  SetDefaultCountryMutationVariables
>;
export const UpdateContactDocument = gql`
  mutation UpdateContact($updateContactId: Int!, $input: InputContact!) {
    updateContact(id: $updateContactId, input: $input) {
      message
      data {
        id
        email
        name
        companyName
        website
        address
        profilePicture {
          id
          url
        }
      }
    }
  }
`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      updateContactId: // value for 'updateContactId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
}
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<
  UpdateContactMutation,
  UpdateContactMutationVariables
>;
export const CreateOrUpdateRecordingCallDocument = gql`
  mutation CreateOrUpdateRecordingCall($callSid: String!, $input: UpdateRecordingInput!) {
    createOrUpdateRecordingCall(callSid: $callSid, input: $input) {
      message
    }
  }
`;
export type CreateOrUpdateRecordingCallMutationFn = Apollo.MutationFunction<
  CreateOrUpdateRecordingCallMutation,
  CreateOrUpdateRecordingCallMutationVariables
>;

/**
 * __useCreateOrUpdateRecordingCallMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateRecordingCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateRecordingCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateRecordingCallMutation, { data, loading, error }] = useCreateOrUpdateRecordingCallMutation({
 *   variables: {
 *      callSid: // value for 'callSid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateRecordingCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrUpdateRecordingCallMutation,
    CreateOrUpdateRecordingCallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOrUpdateRecordingCallMutation, CreateOrUpdateRecordingCallMutationVariables>(
    CreateOrUpdateRecordingCallDocument,
    options
  );
}
export type CreateOrUpdateRecordingCallMutationHookResult = ReturnType<typeof useCreateOrUpdateRecordingCallMutation>;
export type CreateOrUpdateRecordingCallMutationResult = Apollo.MutationResult<CreateOrUpdateRecordingCallMutation>;
export type CreateOrUpdateRecordingCallMutationOptions = Apollo.BaseMutationOptions<
  CreateOrUpdateRecordingCallMutation,
  CreateOrUpdateRecordingCallMutationVariables
>;
export const UpdateCustomerBillingAddressDocument = gql`
  mutation UpdateCustomerBillingAddress($input: InputBillingInfo) {
    updateCustomerBillingAddress(input: $input) {
      message
      data {
        billingAddress {
          name
          company
          phone
          line1
          state
          country
          zip
        }
        vatNumber
        email
      }
    }
  }
`;
export type UpdateCustomerBillingAddressMutationFn = Apollo.MutationFunction<
  UpdateCustomerBillingAddressMutation,
  UpdateCustomerBillingAddressMutationVariables
>;

/**
 * __useUpdateCustomerBillingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerBillingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerBillingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerBillingAddressMutation, { data, loading, error }] = useUpdateCustomerBillingAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerBillingAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerBillingAddressMutation,
    UpdateCustomerBillingAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCustomerBillingAddressMutation, UpdateCustomerBillingAddressMutationVariables>(
    UpdateCustomerBillingAddressDocument,
    options
  );
}
export type UpdateCustomerBillingAddressMutationHookResult = ReturnType<typeof useUpdateCustomerBillingAddressMutation>;
export type UpdateCustomerBillingAddressMutationResult = Apollo.MutationResult<UpdateCustomerBillingAddressMutation>;
export type UpdateCustomerBillingAddressMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerBillingAddressMutation,
  UpdateCustomerBillingAddressMutationVariables
>;
export const VerifyCallerIdDocument = gql`
  mutation VerifyCallerId($input: InputVerifyCallerId) {
    verifyCallerId(input: $input) {
      message
      data {
        friendlyName
        phoneNumber
        validationCode
      }
    }
  }
`;
export type VerifyCallerIdMutationFn = Apollo.MutationFunction<VerifyCallerIdMutation, VerifyCallerIdMutationVariables>;

/**
 * __useVerifyCallerIdMutation__
 *
 * To run a mutation, you first call `useVerifyCallerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCallerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCallerIdMutation, { data, loading, error }] = useVerifyCallerIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyCallerIdMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyCallerIdMutation, VerifyCallerIdMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyCallerIdMutation, VerifyCallerIdMutationVariables>(VerifyCallerIdDocument, options);
}
export type VerifyCallerIdMutationHookResult = ReturnType<typeof useVerifyCallerIdMutation>;
export type VerifyCallerIdMutationResult = Apollo.MutationResult<VerifyCallerIdMutation>;
export type VerifyCallerIdMutationOptions = Apollo.BaseMutationOptions<
  VerifyCallerIdMutation,
  VerifyCallerIdMutationVariables
>;
export const UpdateCallerIdDocument = gql`
  mutation UpdateCallerId($updateCallerIdId: Int!, $input: InputUpdateVerifyCallerId) {
    updateCallerId(id: $updateCallerIdId, input: $input) {
      data {
        friendlyName
      }
      message
    }
  }
`;
export type UpdateCallerIdMutationFn = Apollo.MutationFunction<UpdateCallerIdMutation, UpdateCallerIdMutationVariables>;

/**
 * __useUpdateCallerIdMutation__
 *
 * To run a mutation, you first call `useUpdateCallerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallerIdMutation, { data, loading, error }] = useUpdateCallerIdMutation({
 *   variables: {
 *      updateCallerIdId: // value for 'updateCallerIdId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCallerIdMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCallerIdMutation, UpdateCallerIdMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCallerIdMutation, UpdateCallerIdMutationVariables>(UpdateCallerIdDocument, options);
}
export type UpdateCallerIdMutationHookResult = ReturnType<typeof useUpdateCallerIdMutation>;
export type UpdateCallerIdMutationResult = Apollo.MutationResult<UpdateCallerIdMutation>;
export type UpdateCallerIdMutationOptions = Apollo.BaseMutationOptions<
  UpdateCallerIdMutation,
  UpdateCallerIdMutationVariables
>;
export const DeleteCallerIdDocument = gql`
  mutation DeleteCallerId($deleteCallerIdId: Int!) {
    deleteCallerId(id: $deleteCallerIdId) {
      message
    }
  }
`;
export type DeleteCallerIdMutationFn = Apollo.MutationFunction<DeleteCallerIdMutation, DeleteCallerIdMutationVariables>;

/**
 * __useDeleteCallerIdMutation__
 *
 * To run a mutation, you first call `useDeleteCallerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCallerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCallerIdMutation, { data, loading, error }] = useDeleteCallerIdMutation({
 *   variables: {
 *      deleteCallerIdId: // value for 'deleteCallerIdId'
 *   },
 * });
 */
export function useDeleteCallerIdMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCallerIdMutation, DeleteCallerIdMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCallerIdMutation, DeleteCallerIdMutationVariables>(DeleteCallerIdDocument, options);
}
export type DeleteCallerIdMutationHookResult = ReturnType<typeof useDeleteCallerIdMutation>;
export type DeleteCallerIdMutationResult = Apollo.MutationResult<DeleteCallerIdMutation>;
export type DeleteCallerIdMutationOptions = Apollo.BaseMutationOptions<
  DeleteCallerIdMutation,
  DeleteCallerIdMutationVariables
>;
export const EstimateUpgradeWorkspaceSubscriptionDocument = gql`
  mutation EstimateUpgradeWorkspaceSubscription($input: InputEstimateUpgradeWorkspaceSubscription) {
    estimateUpgradeWorkspaceSubscription(input: $input) {
      message
      data {
        estimatedAmount
      }
    }
  }
`;
export type EstimateUpgradeWorkspaceSubscriptionMutationFn = Apollo.MutationFunction<
  EstimateUpgradeWorkspaceSubscriptionMutation,
  EstimateUpgradeWorkspaceSubscriptionMutationVariables
>;

/**
 * __useEstimateUpgradeWorkspaceSubscriptionMutation__
 *
 * To run a mutation, you first call `useEstimateUpgradeWorkspaceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEstimateUpgradeWorkspaceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [estimateUpgradeWorkspaceSubscriptionMutation, { data, loading, error }] = useEstimateUpgradeWorkspaceSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstimateUpgradeWorkspaceSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EstimateUpgradeWorkspaceSubscriptionMutation,
    EstimateUpgradeWorkspaceSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EstimateUpgradeWorkspaceSubscriptionMutation,
    EstimateUpgradeWorkspaceSubscriptionMutationVariables
  >(EstimateUpgradeWorkspaceSubscriptionDocument, options);
}
export type EstimateUpgradeWorkspaceSubscriptionMutationHookResult = ReturnType<
  typeof useEstimateUpgradeWorkspaceSubscriptionMutation
>;
export type EstimateUpgradeWorkspaceSubscriptionMutationResult =
  Apollo.MutationResult<EstimateUpgradeWorkspaceSubscriptionMutation>;
export type EstimateUpgradeWorkspaceSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  EstimateUpgradeWorkspaceSubscriptionMutation,
  EstimateUpgradeWorkspaceSubscriptionMutationVariables
>;
export const UpgradeWorkspaceSubscriptionDocument = gql`
  mutation UpgradeWorkspaceSubscription($input: UpgradeWorkspaceSubscriptionInput) {
    upgradeWorkspaceSubscription(input: $input) {
      message
      data {
        id
      }
    }
  }
`;
export type UpgradeWorkspaceSubscriptionMutationFn = Apollo.MutationFunction<
  UpgradeWorkspaceSubscriptionMutation,
  UpgradeWorkspaceSubscriptionMutationVariables
>;

/**
 * __useUpgradeWorkspaceSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeWorkspaceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeWorkspaceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeWorkspaceSubscriptionMutation, { data, loading, error }] = useUpgradeWorkspaceSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradeWorkspaceSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpgradeWorkspaceSubscriptionMutation,
    UpgradeWorkspaceSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpgradeWorkspaceSubscriptionMutation, UpgradeWorkspaceSubscriptionMutationVariables>(
    UpgradeWorkspaceSubscriptionDocument,
    options
  );
}
export type UpgradeWorkspaceSubscriptionMutationHookResult = ReturnType<typeof useUpgradeWorkspaceSubscriptionMutation>;
export type UpgradeWorkspaceSubscriptionMutationResult = Apollo.MutationResult<UpgradeWorkspaceSubscriptionMutation>;
export type UpgradeWorkspaceSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  UpgradeWorkspaceSubscriptionMutation,
  UpgradeWorkspaceSubscriptionMutationVariables
>;
export const DowngradeWorkspaceSubscriptionDocument = gql`
  mutation DowngradeWorkspaceSubscription($input: DowngradeWorkspaceSubscriptionInput) {
    downgradeWorkspaceSubscription(input: $input) {
      message
      data {
        id
      }
    }
  }
`;
export type DowngradeWorkspaceSubscriptionMutationFn = Apollo.MutationFunction<
  DowngradeWorkspaceSubscriptionMutation,
  DowngradeWorkspaceSubscriptionMutationVariables
>;

/**
 * __useDowngradeWorkspaceSubscriptionMutation__
 *
 * To run a mutation, you first call `useDowngradeWorkspaceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDowngradeWorkspaceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downgradeWorkspaceSubscriptionMutation, { data, loading, error }] = useDowngradeWorkspaceSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDowngradeWorkspaceSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DowngradeWorkspaceSubscriptionMutation,
    DowngradeWorkspaceSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DowngradeWorkspaceSubscriptionMutation, DowngradeWorkspaceSubscriptionMutationVariables>(
    DowngradeWorkspaceSubscriptionDocument,
    options
  );
}
export type DowngradeWorkspaceSubscriptionMutationHookResult = ReturnType<
  typeof useDowngradeWorkspaceSubscriptionMutation
>;
export type DowngradeWorkspaceSubscriptionMutationResult =
  Apollo.MutationResult<DowngradeWorkspaceSubscriptionMutation>;
export type DowngradeWorkspaceSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  DowngradeWorkspaceSubscriptionMutation,
  DowngradeWorkspaceSubscriptionMutationVariables
>;
export const CancelSubscriptionV2Document = gql`
  mutation CancelSubscriptionV2($input: CancelSubscriptionInputV2!) {
    cancelSubscriptionV2(input: $input) {
      message
      data {
        id
        billingPeriodUnit
        remainingBillingCycles
        customerId
        status
        currentTermEnd
        nextBillingAt
        createdAt
        cancelledAt
        updatedAt
        cancelScheduleCreatedAt
        deleted
        currencyCode
        subscriptionItems {
          itemPriceId
          itemType
          quantity
          unitPrice
          amount
        }
        mrr
        itemProductFamily
        itemCount
        hasScheduledChanges
        scheduledChanges {
          id
          billingPeriodUnit
          remainingBillingCycles
          customerId
          status
          currentTermEnd
          nextBillingAt
          createdAt
          cancelledAt
          updatedAt
          cancelScheduleCreatedAt
          deleted
          currencyCode
          mrr
          itemProductFamily
          itemCount
        }
        discountItems {
          discountType
          discountAmount
          discountPercentage
        }
      }
    }
  }
`;
export type CancelSubscriptionV2MutationFn = Apollo.MutationFunction<
  CancelSubscriptionV2Mutation,
  CancelSubscriptionV2MutationVariables
>;

/**
 * __useCancelSubscriptionV2Mutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionV2Mutation, { data, loading, error }] = useCancelSubscriptionV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionV2Mutation, CancelSubscriptionV2MutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelSubscriptionV2Mutation, CancelSubscriptionV2MutationVariables>(
    CancelSubscriptionV2Document,
    options
  );
}
export type CancelSubscriptionV2MutationHookResult = ReturnType<typeof useCancelSubscriptionV2Mutation>;
export type CancelSubscriptionV2MutationResult = Apollo.MutationResult<CancelSubscriptionV2Mutation>;
export type CancelSubscriptionV2MutationOptions = Apollo.BaseMutationOptions<
  CancelSubscriptionV2Mutation,
  CancelSubscriptionV2MutationVariables
>;
export const RestoreCancelledSubscriptionDocument = gql`
  mutation RestoreCancelledSubscription {
    restoreCancelledSubscription {
      message
    }
  }
`;
export type RestoreCancelledSubscriptionMutationFn = Apollo.MutationFunction<
  RestoreCancelledSubscriptionMutation,
  RestoreCancelledSubscriptionMutationVariables
>;

/**
 * __useRestoreCancelledSubscriptionMutation__
 *
 * To run a mutation, you first call `useRestoreCancelledSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCancelledSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCancelledSubscriptionMutation, { data, loading, error }] = useRestoreCancelledSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useRestoreCancelledSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreCancelledSubscriptionMutation,
    RestoreCancelledSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RestoreCancelledSubscriptionMutation, RestoreCancelledSubscriptionMutationVariables>(
    RestoreCancelledSubscriptionDocument,
    options
  );
}
export type RestoreCancelledSubscriptionMutationHookResult = ReturnType<typeof useRestoreCancelledSubscriptionMutation>;
export type RestoreCancelledSubscriptionMutationResult = Apollo.MutationResult<RestoreCancelledSubscriptionMutation>;
export type RestoreCancelledSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  RestoreCancelledSubscriptionMutation,
  RestoreCancelledSubscriptionMutationVariables
>;
export const SetAutoRechargeConfigDocument = gql`
  mutation SetAutoRechargeConfig($input: InputAutoRechargeConfig) {
    setAutoRechargeConfig(input: $input) {
      message
      data {
        enabled
        creditThreshold
        credit
      }
    }
  }
`;
export type SetAutoRechargeConfigMutationFn = Apollo.MutationFunction<
  SetAutoRechargeConfigMutation,
  SetAutoRechargeConfigMutationVariables
>;

/**
 * __useSetAutoRechargeConfigMutation__
 *
 * To run a mutation, you first call `useSetAutoRechargeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAutoRechargeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAutoRechargeConfigMutation, { data, loading, error }] = useSetAutoRechargeConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAutoRechargeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<SetAutoRechargeConfigMutation, SetAutoRechargeConfigMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetAutoRechargeConfigMutation, SetAutoRechargeConfigMutationVariables>(
    SetAutoRechargeConfigDocument,
    options
  );
}
export type SetAutoRechargeConfigMutationHookResult = ReturnType<typeof useSetAutoRechargeConfigMutation>;
export type SetAutoRechargeConfigMutationResult = Apollo.MutationResult<SetAutoRechargeConfigMutation>;
export type SetAutoRechargeConfigMutationOptions = Apollo.BaseMutationOptions<
  SetAutoRechargeConfigMutation,
  SetAutoRechargeConfigMutationVariables
>;
export const SetLowBalanceAlertDocument = gql`
  mutation SetLowBalanceAlert($isEmail: Boolean, $balanceThreshold: Int) {
    setLowBalanceAlert(isEmail: $isEmail, balanceThreshold: $balanceThreshold) {
      message
      data {
        isEmail
        balanceThreshold
      }
    }
  }
`;
export type SetLowBalanceAlertMutationFn = Apollo.MutationFunction<
  SetLowBalanceAlertMutation,
  SetLowBalanceAlertMutationVariables
>;

/**
 * __useSetLowBalanceAlertMutation__
 *
 * To run a mutation, you first call `useSetLowBalanceAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLowBalanceAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLowBalanceAlertMutation, { data, loading, error }] = useSetLowBalanceAlertMutation({
 *   variables: {
 *      isEmail: // value for 'isEmail'
 *      balanceThreshold: // value for 'balanceThreshold'
 *   },
 * });
 */
export function useSetLowBalanceAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<SetLowBalanceAlertMutation, SetLowBalanceAlertMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetLowBalanceAlertMutation, SetLowBalanceAlertMutationVariables>(
    SetLowBalanceAlertDocument,
    options
  );
}
export type SetLowBalanceAlertMutationHookResult = ReturnType<typeof useSetLowBalanceAlertMutation>;
export type SetLowBalanceAlertMutationResult = Apollo.MutationResult<SetLowBalanceAlertMutation>;
export type SetLowBalanceAlertMutationOptions = Apollo.BaseMutationOptions<
  SetLowBalanceAlertMutation,
  SetLowBalanceAlertMutationVariables
>;
export const LoadWalletDocument = gql`
  mutation LoadWallet($input: LoadWalletInput!) {
    loadWallet(input: $input) {
      message
      data {
        amount
      }
    }
  }
`;
export type LoadWalletMutationFn = Apollo.MutationFunction<LoadWalletMutation, LoadWalletMutationVariables>;

/**
 * __useLoadWalletMutation__
 *
 * To run a mutation, you first call `useLoadWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoadWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loadWalletMutation, { data, loading, error }] = useLoadWalletMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadWalletMutation(
  baseOptions?: Apollo.MutationHookOptions<LoadWalletMutation, LoadWalletMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoadWalletMutation, LoadWalletMutationVariables>(LoadWalletDocument, options);
}
export type LoadWalletMutationHookResult = ReturnType<typeof useLoadWalletMutation>;
export type LoadWalletMutationResult = Apollo.MutationResult<LoadWalletMutation>;
export type LoadWalletMutationOptions = Apollo.BaseMutationOptions<LoadWalletMutation, LoadWalletMutationVariables>;
export const createPaymentIntentDocument = gql`
  mutation createPaymentIntent($input: PaymentIntentInput) {
    createPaymentIntent(input: $input) {
      data
      message
    }
  }
`;
export type createPaymentIntentMutationFn = Apollo.MutationFunction<
  createPaymentIntentMutation,
  createPaymentIntentMutationVariables
>;

/**
 * __usecreatePaymentIntentMutation__
 *
 * To run a mutation, you first call `usecreatePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreatePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentMutation, { data, loading, error }] = usecreatePaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usecreatePaymentIntentMutation(
  baseOptions?: Apollo.MutationHookOptions<createPaymentIntentMutation, createPaymentIntentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<createPaymentIntentMutation, createPaymentIntentMutationVariables>(
    createPaymentIntentDocument,
    options
  );
}
export type createPaymentIntentMutationHookResult = ReturnType<typeof usecreatePaymentIntentMutation>;
export type createPaymentIntentMutationResult = Apollo.MutationResult<createPaymentIntentMutation>;
export type createPaymentIntentMutationOptions = Apollo.BaseMutationOptions<
  createPaymentIntentMutation,
  createPaymentIntentMutationVariables
>;
export const MarkAllAsReadNotificationDocument = gql`
  mutation MarkAllAsReadNotification {
    markAllAsReadNotification {
      message
    }
  }
`;
export type MarkAllAsReadNotificationMutationFn = Apollo.MutationFunction<
  MarkAllAsReadNotificationMutation,
  MarkAllAsReadNotificationMutationVariables
>;

/**
 * __useMarkAllAsReadNotificationMutation__
 *
 * To run a mutation, you first call `useMarkAllAsReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllAsReadNotificationMutation, { data, loading, error }] = useMarkAllAsReadNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllAsReadNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAllAsReadNotificationMutation,
    MarkAllAsReadNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkAllAsReadNotificationMutation, MarkAllAsReadNotificationMutationVariables>(
    MarkAllAsReadNotificationDocument,
    options
  );
}
export type MarkAllAsReadNotificationMutationHookResult = ReturnType<typeof useMarkAllAsReadNotificationMutation>;
export type MarkAllAsReadNotificationMutationResult = Apollo.MutationResult<MarkAllAsReadNotificationMutation>;
export type MarkAllAsReadNotificationMutationOptions = Apollo.BaseMutationOptions<
  MarkAllAsReadNotificationMutation,
  MarkAllAsReadNotificationMutationVariables
>;
export const ToggleReadNotificationDocument = gql`
  mutation ToggleReadNotification($notificationId: Int) {
    toggleReadNotification(notificationId: $notificationId) {
      message
    }
  }
`;
export type ToggleReadNotificationMutationFn = Apollo.MutationFunction<
  ToggleReadNotificationMutation,
  ToggleReadNotificationMutationVariables
>;

/**
 * __useToggleReadNotificationMutation__
 *
 * To run a mutation, you first call `useToggleReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleReadNotificationMutation, { data, loading, error }] = useToggleReadNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useToggleReadNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<ToggleReadNotificationMutation, ToggleReadNotificationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ToggleReadNotificationMutation, ToggleReadNotificationMutationVariables>(
    ToggleReadNotificationDocument,
    options
  );
}
export type ToggleReadNotificationMutationHookResult = ReturnType<typeof useToggleReadNotificationMutation>;
export type ToggleReadNotificationMutationResult = Apollo.MutationResult<ToggleReadNotificationMutation>;
export type ToggleReadNotificationMutationOptions = Apollo.BaseMutationOptions<
  ToggleReadNotificationMutation,
  ToggleReadNotificationMutationVariables
>;
export const MarkAsSeenNotificationDocument = gql`
  mutation MarkAsSeenNotification($notificationId: Int) {
    markAsSeenNotification(notificationId: $notificationId) {
      message
    }
  }
`;
export type MarkAsSeenNotificationMutationFn = Apollo.MutationFunction<
  MarkAsSeenNotificationMutation,
  MarkAsSeenNotificationMutationVariables
>;

/**
 * __useMarkAsSeenNotificationMutation__
 *
 * To run a mutation, you first call `useMarkAsSeenNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsSeenNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsSeenNotificationMutation, { data, loading, error }] = useMarkAsSeenNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkAsSeenNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkAsSeenNotificationMutation, MarkAsSeenNotificationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkAsSeenNotificationMutation, MarkAsSeenNotificationMutationVariables>(
    MarkAsSeenNotificationDocument,
    options
  );
}
export type MarkAsSeenNotificationMutationHookResult = ReturnType<typeof useMarkAsSeenNotificationMutation>;
export type MarkAsSeenNotificationMutationResult = Apollo.MutationResult<MarkAsSeenNotificationMutation>;
export type MarkAsSeenNotificationMutationOptions = Apollo.BaseMutationOptions<
  MarkAsSeenNotificationMutation,
  MarkAsSeenNotificationMutationVariables
>;
export const SubscribeWorkspacePlanAndInviteUserDocument = gql`
  mutation SubscribeWorkspacePlanAndInviteUser($input: CreateSubscriptionInput) {
    subscribeWorkspacePlanAndInviteUser(input: $input) {
      message
      data {
        id
      }
    }
  }
`;
export type SubscribeWorkspacePlanAndInviteUserMutationFn = Apollo.MutationFunction<
  SubscribeWorkspacePlanAndInviteUserMutation,
  SubscribeWorkspacePlanAndInviteUserMutationVariables
>;

/**
 * __useSubscribeWorkspacePlanAndInviteUserMutation__
 *
 * To run a mutation, you first call `useSubscribeWorkspacePlanAndInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeWorkspacePlanAndInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeWorkspacePlanAndInviteUserMutation, { data, loading, error }] = useSubscribeWorkspacePlanAndInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeWorkspacePlanAndInviteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscribeWorkspacePlanAndInviteUserMutation,
    SubscribeWorkspacePlanAndInviteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubscribeWorkspacePlanAndInviteUserMutation,
    SubscribeWorkspacePlanAndInviteUserMutationVariables
  >(SubscribeWorkspacePlanAndInviteUserDocument, options);
}
export type SubscribeWorkspacePlanAndInviteUserMutationHookResult = ReturnType<
  typeof useSubscribeWorkspacePlanAndInviteUserMutation
>;
export type SubscribeWorkspacePlanAndInviteUserMutationResult =
  Apollo.MutationResult<SubscribeWorkspacePlanAndInviteUserMutation>;
export type SubscribeWorkspacePlanAndInviteUserMutationOptions = Apollo.BaseMutationOptions<
  SubscribeWorkspacePlanAndInviteUserMutation,
  SubscribeWorkspacePlanAndInviteUserMutationVariables
>;
export const EstimateMemberAdditionDocument = gql`
  mutation EstimateMemberAddition {
    estimateMemberAddition {
      message
      data {
        estimatedAmount
      }
    }
  }
`;
export type EstimateMemberAdditionMutationFn = Apollo.MutationFunction<
  EstimateMemberAdditionMutation,
  EstimateMemberAdditionMutationVariables
>;

/**
 * __useEstimateMemberAdditionMutation__
 *
 * To run a mutation, you first call `useEstimateMemberAdditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEstimateMemberAdditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [estimateMemberAdditionMutation, { data, loading, error }] = useEstimateMemberAdditionMutation({
 *   variables: {
 *   },
 * });
 */
export function useEstimateMemberAdditionMutation(
  baseOptions?: Apollo.MutationHookOptions<EstimateMemberAdditionMutation, EstimateMemberAdditionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EstimateMemberAdditionMutation, EstimateMemberAdditionMutationVariables>(
    EstimateMemberAdditionDocument,
    options
  );
}
export type EstimateMemberAdditionMutationHookResult = ReturnType<typeof useEstimateMemberAdditionMutation>;
export type EstimateMemberAdditionMutationResult = Apollo.MutationResult<EstimateMemberAdditionMutation>;
export type EstimateMemberAdditionMutationOptions = Apollo.BaseMutationOptions<
  EstimateMemberAdditionMutation,
  EstimateMemberAdditionMutationVariables
>;
export const MarkAllAsSeenNotificationDocument = gql`
  mutation MarkAllAsSeenNotification($notificationId: Int!) {
    markAllAsSeenNotification(notificationId: $notificationId) {
      message
    }
  }
`;
export type MarkAllAsSeenNotificationMutationFn = Apollo.MutationFunction<
  MarkAllAsSeenNotificationMutation,
  MarkAllAsSeenNotificationMutationVariables
>;

/**
 * __useMarkAllAsSeenNotificationMutation__
 *
 * To run a mutation, you first call `useMarkAllAsSeenNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsSeenNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllAsSeenNotificationMutation, { data, loading, error }] = useMarkAllAsSeenNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkAllAsSeenNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAllAsSeenNotificationMutation,
    MarkAllAsSeenNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkAllAsSeenNotificationMutation, MarkAllAsSeenNotificationMutationVariables>(
    MarkAllAsSeenNotificationDocument,
    options
  );
}
export type MarkAllAsSeenNotificationMutationHookResult = ReturnType<typeof useMarkAllAsSeenNotificationMutation>;
export type MarkAllAsSeenNotificationMutationResult = Apollo.MutationResult<MarkAllAsSeenNotificationMutation>;
export type MarkAllAsSeenNotificationMutationOptions = Apollo.BaseMutationOptions<
  MarkAllAsSeenNotificationMutation,
  MarkAllAsSeenNotificationMutationVariables
>;
export const CreateOrUpdateDraftMessageDocument = gql`
  mutation CreateOrUpdateDraftMessage($input: InputDraftMessageConversation) {
    createOrUpdateDraftMessage(input: $input) {
      message
      data {
        id
        channelId
        clientId
        messageContent
        createdAt
        medias {
          id
          url
          originalname
          size
          key
          mimetype
        }
      }
    }
  }
`;
export type CreateOrUpdateDraftMessageMutationFn = Apollo.MutationFunction<
  CreateOrUpdateDraftMessageMutation,
  CreateOrUpdateDraftMessageMutationVariables
>;

/**
 * __useCreateOrUpdateDraftMessageMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateDraftMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateDraftMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateDraftMessageMutation, { data, loading, error }] = useCreateOrUpdateDraftMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateDraftMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrUpdateDraftMessageMutation,
    CreateOrUpdateDraftMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOrUpdateDraftMessageMutation, CreateOrUpdateDraftMessageMutationVariables>(
    CreateOrUpdateDraftMessageDocument,
    options
  );
}
export type CreateOrUpdateDraftMessageMutationHookResult = ReturnType<typeof useCreateOrUpdateDraftMessageMutation>;
export type CreateOrUpdateDraftMessageMutationResult = Apollo.MutationResult<CreateOrUpdateDraftMessageMutation>;
export type CreateOrUpdateDraftMessageMutationOptions = Apollo.BaseMutationOptions<
  CreateOrUpdateDraftMessageMutation,
  CreateOrUpdateDraftMessageMutationVariables
>;
export const DeleteContactsDocument = gql`
  mutation DeleteContacts($ids: [Int!]!) {
    deleteContacts(ids: $ids) {
      message
    }
  }
`;
export type DeleteContactsMutationFn = Apollo.MutationFunction<DeleteContactsMutation, DeleteContactsMutationVariables>;

/**
 * __useDeleteContactsMutation__
 *
 * To run a mutation, you first call `useDeleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsMutation, { data, loading, error }] = useDeleteContactsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContactsMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteContactsMutation, DeleteContactsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteContactsMutation, DeleteContactsMutationVariables>(DeleteContactsDocument, options);
}
export type DeleteContactsMutationHookResult = ReturnType<typeof useDeleteContactsMutation>;
export type DeleteContactsMutationResult = Apollo.MutationResult<DeleteContactsMutation>;
export type DeleteContactsMutationOptions = Apollo.BaseMutationOptions<
  DeleteContactsMutation,
  DeleteContactsMutationVariables
>;
export const DeleteContactDocument = gql`
  mutation DeleteContact($deleteContactId: Int!) {
    deleteContact(id: $deleteContactId) {
      message
      data {
        id
        name
      }
    }
  }
`;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      deleteContactId: // value for 'deleteContactId'
 *   },
 * });
 */
export function useDeleteContactMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
}
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<
  DeleteContactMutation,
  DeleteContactMutationVariables
>;
export const CreateContactDocument = gql`
  mutation CreateContact($input: InputContact!) {
    createContact(input: $input) {
      message
      data {
        sourceType
        profilePicture {
          url
          originalname
          id
        }
        name
        phoneNumber
        id
        email
        country {
          id
          flag
          name
        }
        timeZone
        website
        tags {
          id
          label
          color
        }
        address
        companyName
      }
    }
  }
`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
}
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<
  CreateContactMutation,
  CreateContactMutationVariables
>;
export const authMeUpdateDocument = gql`
  mutation authMeUpdate($input: InputUser!) {
    authMe(input: $input) {
      message
      data {
        roles {
          id
          label
          slug
          level
          isActive
          isDefault
          position
        }
        id
        name
        email
        phoneNumber
        profilePicture {
          url
          id
          originalname
          size
          key
          mimetype
        }
        coverProfilePicture {
          url
        }
      }
    }
  }
`;
export type authMeUpdateMutationFn = Apollo.MutationFunction<authMeUpdateMutation, authMeUpdateMutationVariables>;

/**
 * __useauthMeUpdateMutation__
 *
 * To run a mutation, you first call `useauthMeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useauthMeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authMeUpdateMutation, { data, loading, error }] = useauthMeUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useauthMeUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<authMeUpdateMutation, authMeUpdateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<authMeUpdateMutation, authMeUpdateMutationVariables>(authMeUpdateDocument, options);
}
export type authMeUpdateMutationHookResult = ReturnType<typeof useauthMeUpdateMutation>;
export type authMeUpdateMutationResult = Apollo.MutationResult<authMeUpdateMutation>;
export type authMeUpdateMutationOptions = Apollo.BaseMutationOptions<
  authMeUpdateMutation,
  authMeUpdateMutationVariables
>;
export const PinOrUnpinRecentMessageConversationDocument = gql`
  mutation PinOrUnpinRecentMessageConversation(
    $pinOrUnpinRecentMessageConversationId: Int!
    $channelId: Int!
    $input: InputPinUnpinRecentMessageConversation
  ) {
    pinOrUnpinRecentMessageConversation(
      id: $pinOrUnpinRecentMessageConversationId
      channelId: $channelId
      input: $input
    ) {
      message
      data {
        id
        pinned
        updatedAt
        client {
          id
        }
        channel {
          id
        }
      }
    }
  }
`;
export type PinOrUnpinRecentMessageConversationMutationFn = Apollo.MutationFunction<
  PinOrUnpinRecentMessageConversationMutation,
  PinOrUnpinRecentMessageConversationMutationVariables
>;

/**
 * __usePinOrUnpinRecentMessageConversationMutation__
 *
 * To run a mutation, you first call `usePinOrUnpinRecentMessageConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinOrUnpinRecentMessageConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinOrUnpinRecentMessageConversationMutation, { data, loading, error }] = usePinOrUnpinRecentMessageConversationMutation({
 *   variables: {
 *      pinOrUnpinRecentMessageConversationId: // value for 'pinOrUnpinRecentMessageConversationId'
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePinOrUnpinRecentMessageConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PinOrUnpinRecentMessageConversationMutation,
    PinOrUnpinRecentMessageConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PinOrUnpinRecentMessageConversationMutation,
    PinOrUnpinRecentMessageConversationMutationVariables
  >(PinOrUnpinRecentMessageConversationDocument, options);
}
export type PinOrUnpinRecentMessageConversationMutationHookResult = ReturnType<
  typeof usePinOrUnpinRecentMessageConversationMutation
>;
export type PinOrUnpinRecentMessageConversationMutationResult =
  Apollo.MutationResult<PinOrUnpinRecentMessageConversationMutation>;
export type PinOrUnpinRecentMessageConversationMutationOptions = Apollo.BaseMutationOptions<
  PinOrUnpinRecentMessageConversationMutation,
  PinOrUnpinRecentMessageConversationMutationVariables
>;
export const ChangePasswordDocument = gql`
  mutation ChangePassword($input: InputChangePassword) {
    changePassword(input: $input) {
      message
    }
  }
`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const GlobalSignOutDocument = gql`
  mutation GlobalSignOut {
    globalSignOut {
      message
    }
  }
`;
export type GlobalSignOutMutationFn = Apollo.MutationFunction<GlobalSignOutMutation, GlobalSignOutMutationVariables>;

/**
 * __useGlobalSignOutMutation__
 *
 * To run a mutation, you first call `useGlobalSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGlobalSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [globalSignOutMutation, { data, loading, error }] = useGlobalSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useGlobalSignOutMutation(
  baseOptions?: Apollo.MutationHookOptions<GlobalSignOutMutation, GlobalSignOutMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GlobalSignOutMutation, GlobalSignOutMutationVariables>(GlobalSignOutDocument, options);
}
export type GlobalSignOutMutationHookResult = ReturnType<typeof useGlobalSignOutMutation>;
export type GlobalSignOutMutationResult = Apollo.MutationResult<GlobalSignOutMutation>;
export type GlobalSignOutMutationOptions = Apollo.BaseMutationOptions<
  GlobalSignOutMutation,
  GlobalSignOutMutationVariables
>;
export const ToggleChannelPinDocument = gql`
  mutation ToggleChannelPin($channelId: Int!) {
    toggleChannelPin(channelId: $channelId) {
      message
      data {
        id
        pinned
        isDefault
        updatedAt
      }
    }
  }
`;
export type ToggleChannelPinMutationFn = Apollo.MutationFunction<
  ToggleChannelPinMutation,
  ToggleChannelPinMutationVariables
>;

/**
 * __useToggleChannelPinMutation__
 *
 * To run a mutation, you first call `useToggleChannelPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleChannelPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleChannelPinMutation, { data, loading, error }] = useToggleChannelPinMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useToggleChannelPinMutation(
  baseOptions?: Apollo.MutationHookOptions<ToggleChannelPinMutation, ToggleChannelPinMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ToggleChannelPinMutation, ToggleChannelPinMutationVariables>(
    ToggleChannelPinDocument,
    options
  );
}
export type ToggleChannelPinMutationHookResult = ReturnType<typeof useToggleChannelPinMutation>;
export type ToggleChannelPinMutationResult = Apollo.MutationResult<ToggleChannelPinMutation>;
export type ToggleChannelPinMutationOptions = Apollo.BaseMutationOptions<
  ToggleChannelPinMutation,
  ToggleChannelPinMutationVariables
>;
export const CreatePaymentSourceDocument = gql`
  mutation CreatePaymentSource($input: PaymentSourceInput) {
    createPaymentSource(input: $input) {
      message
      data {
        id
        card {
          brand
          expiryMonth
          expiryYear
          firstName
          last4
          lastName
        }
        gatewayAccountId
        id
        isPrimary
        isSecondary
        paymentGateway
        paypal {
          email
        }
        referenceId
        status
      }
    }
  }
`;
export type CreatePaymentSourceMutationFn = Apollo.MutationFunction<
  CreatePaymentSourceMutation,
  CreatePaymentSourceMutationVariables
>;

/**
 * __useCreatePaymentSourceMutation__
 *
 * To run a mutation, you first call `useCreatePaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentSourceMutation, { data, loading, error }] = useCreatePaymentSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePaymentSourceMutation, CreatePaymentSourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePaymentSourceMutation, CreatePaymentSourceMutationVariables>(
    CreatePaymentSourceDocument,
    options
  );
}
export type CreatePaymentSourceMutationHookResult = ReturnType<typeof useCreatePaymentSourceMutation>;
export type CreatePaymentSourceMutationResult = Apollo.MutationResult<CreatePaymentSourceMutation>;
export type CreatePaymentSourceMutationOptions = Apollo.BaseMutationOptions<
  CreatePaymentSourceMutation,
  CreatePaymentSourceMutationVariables
>;
export const SwitchPrimaryPaymentSourceDocument = gql`
  mutation SwitchPrimaryPaymentSource($input: SwitchPaymentSourceInput) {
    switchPrimaryPaymentSource(input: $input) {
      message
    }
  }
`;
export type SwitchPrimaryPaymentSourceMutationFn = Apollo.MutationFunction<
  SwitchPrimaryPaymentSourceMutation,
  SwitchPrimaryPaymentSourceMutationVariables
>;

/**
 * __useSwitchPrimaryPaymentSourceMutation__
 *
 * To run a mutation, you first call `useSwitchPrimaryPaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchPrimaryPaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchPrimaryPaymentSourceMutation, { data, loading, error }] = useSwitchPrimaryPaymentSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchPrimaryPaymentSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SwitchPrimaryPaymentSourceMutation,
    SwitchPrimaryPaymentSourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SwitchPrimaryPaymentSourceMutation, SwitchPrimaryPaymentSourceMutationVariables>(
    SwitchPrimaryPaymentSourceDocument,
    options
  );
}
export type SwitchPrimaryPaymentSourceMutationHookResult = ReturnType<typeof useSwitchPrimaryPaymentSourceMutation>;
export type SwitchPrimaryPaymentSourceMutationResult = Apollo.MutationResult<SwitchPrimaryPaymentSourceMutation>;
export type SwitchPrimaryPaymentSourceMutationOptions = Apollo.BaseMutationOptions<
  SwitchPrimaryPaymentSourceMutation,
  SwitchPrimaryPaymentSourceMutationVariables
>;
export const RemoveSecondaryPaymentSourceDocument = gql`
  mutation RemoveSecondaryPaymentSource($input: RemoveSecondaryPaymentSourceInput) {
    removeSecondaryPaymentSource(input: $input) {
      message
    }
  }
`;
export type RemoveSecondaryPaymentSourceMutationFn = Apollo.MutationFunction<
  RemoveSecondaryPaymentSourceMutation,
  RemoveSecondaryPaymentSourceMutationVariables
>;

/**
 * __useRemoveSecondaryPaymentSourceMutation__
 *
 * To run a mutation, you first call `useRemoveSecondaryPaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSecondaryPaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSecondaryPaymentSourceMutation, { data, loading, error }] = useRemoveSecondaryPaymentSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSecondaryPaymentSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSecondaryPaymentSourceMutation,
    RemoveSecondaryPaymentSourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveSecondaryPaymentSourceMutation, RemoveSecondaryPaymentSourceMutationVariables>(
    RemoveSecondaryPaymentSourceDocument,
    options
  );
}
export type RemoveSecondaryPaymentSourceMutationHookResult = ReturnType<typeof useRemoveSecondaryPaymentSourceMutation>;
export type RemoveSecondaryPaymentSourceMutationResult = Apollo.MutationResult<RemoveSecondaryPaymentSourceMutation>;
export type RemoveSecondaryPaymentSourceMutationOptions = Apollo.BaseMutationOptions<
  RemoveSecondaryPaymentSourceMutation,
  RemoveSecondaryPaymentSourceMutationVariables
>;
export const SetSecondaryPaymentSourceDocument = gql`
  mutation SetSecondaryPaymentSource($input: SetSecondaryPaymentSourceInput) {
    setSecondaryPaymentSource(input: $input) {
      message
    }
  }
`;
export type SetSecondaryPaymentSourceMutationFn = Apollo.MutationFunction<
  SetSecondaryPaymentSourceMutation,
  SetSecondaryPaymentSourceMutationVariables
>;

/**
 * __useSetSecondaryPaymentSourceMutation__
 *
 * To run a mutation, you first call `useSetSecondaryPaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSecondaryPaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSecondaryPaymentSourceMutation, { data, loading, error }] = useSetSecondaryPaymentSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSecondaryPaymentSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSecondaryPaymentSourceMutation,
    SetSecondaryPaymentSourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetSecondaryPaymentSourceMutation, SetSecondaryPaymentSourceMutationVariables>(
    SetSecondaryPaymentSourceDocument,
    options
  );
}
export type SetSecondaryPaymentSourceMutationHookResult = ReturnType<typeof useSetSecondaryPaymentSourceMutation>;
export type SetSecondaryPaymentSourceMutationResult = Apollo.MutationResult<SetSecondaryPaymentSourceMutation>;
export type SetSecondaryPaymentSourceMutationOptions = Apollo.BaseMutationOptions<
  SetSecondaryPaymentSourceMutation,
  SetSecondaryPaymentSourceMutationVariables
>;
export const UnsetSecondaryPaymentSourceDocument = gql`
  mutation UnsetSecondaryPaymentSource($input: UnsetSecondaryPaymentSourceInput!) {
    unsetSecondaryPaymentSource(input: $input) {
      message
    }
  }
`;
export type UnsetSecondaryPaymentSourceMutationFn = Apollo.MutationFunction<
  UnsetSecondaryPaymentSourceMutation,
  UnsetSecondaryPaymentSourceMutationVariables
>;

/**
 * __useUnsetSecondaryPaymentSourceMutation__
 *
 * To run a mutation, you first call `useUnsetSecondaryPaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsetSecondaryPaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsetSecondaryPaymentSourceMutation, { data, loading, error }] = useUnsetSecondaryPaymentSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsetSecondaryPaymentSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnsetSecondaryPaymentSourceMutation,
    UnsetSecondaryPaymentSourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnsetSecondaryPaymentSourceMutation, UnsetSecondaryPaymentSourceMutationVariables>(
    UnsetSecondaryPaymentSourceDocument,
    options
  );
}
export type UnsetSecondaryPaymentSourceMutationHookResult = ReturnType<typeof useUnsetSecondaryPaymentSourceMutation>;
export type UnsetSecondaryPaymentSourceMutationResult = Apollo.MutationResult<UnsetSecondaryPaymentSourceMutation>;
export type UnsetSecondaryPaymentSourceMutationOptions = Apollo.BaseMutationOptions<
  UnsetSecondaryPaymentSourceMutation,
  UnsetSecondaryPaymentSourceMutationVariables
>;
export const DeleteWorkspaceUserDocument = gql`
  mutation DeleteWorkspaceUser($deleteWorkspaceUserId: Int!) {
    deleteWorkspaceUser(id: $deleteWorkspaceUserId) {
      data {
        id
      }
      message
    }
  }
`;
export type DeleteWorkspaceUserMutationFn = Apollo.MutationFunction<
  DeleteWorkspaceUserMutation,
  DeleteWorkspaceUserMutationVariables
>;

/**
 * __useDeleteWorkspaceUserMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceUserMutation, { data, loading, error }] = useDeleteWorkspaceUserMutation({
 *   variables: {
 *      deleteWorkspaceUserId: // value for 'deleteWorkspaceUserId'
 *   },
 * });
 */
export function useDeleteWorkspaceUserMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceUserMutation, DeleteWorkspaceUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteWorkspaceUserMutation, DeleteWorkspaceUserMutationVariables>(
    DeleteWorkspaceUserDocument,
    options
  );
}
export type DeleteWorkspaceUserMutationHookResult = ReturnType<typeof useDeleteWorkspaceUserMutation>;
export type DeleteWorkspaceUserMutationResult = Apollo.MutationResult<DeleteWorkspaceUserMutation>;
export type DeleteWorkspaceUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkspaceUserMutation,
  DeleteWorkspaceUserMutationVariables
>;
export const RevokeInvitationTokenDocument = gql`
  mutation RevokeInvitationToken($userWorkspaceId: Int) {
    revokeInvitationToken(userWorkspaceId: $userWorkspaceId) {
      data {
        id
      }
      message
    }
  }
`;
export type RevokeInvitationTokenMutationFn = Apollo.MutationFunction<
  RevokeInvitationTokenMutation,
  RevokeInvitationTokenMutationVariables
>;

/**
 * __useRevokeInvitationTokenMutation__
 *
 * To run a mutation, you first call `useRevokeInvitationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInvitationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInvitationTokenMutation, { data, loading, error }] = useRevokeInvitationTokenMutation({
 *   variables: {
 *      userWorkspaceId: // value for 'userWorkspaceId'
 *   },
 * });
 */
export function useRevokeInvitationTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<RevokeInvitationTokenMutation, RevokeInvitationTokenMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeInvitationTokenMutation, RevokeInvitationTokenMutationVariables>(
    RevokeInvitationTokenDocument,
    options
  );
}
export type RevokeInvitationTokenMutationHookResult = ReturnType<typeof useRevokeInvitationTokenMutation>;
export type RevokeInvitationTokenMutationResult = Apollo.MutationResult<RevokeInvitationTokenMutation>;
export type RevokeInvitationTokenMutationOptions = Apollo.BaseMutationOptions<
  RevokeInvitationTokenMutation,
  RevokeInvitationTokenMutationVariables
>;
export const ResendInviteWorkspaceMemberDocument = gql`
  mutation ResendInviteWorkspaceMember($input: InputResendInviteWorkspaceMember!) {
    resendInviteWorkspaceMember(input: $input) {
      message
    }
  }
`;
export type ResendInviteWorkspaceMemberMutationFn = Apollo.MutationFunction<
  ResendInviteWorkspaceMemberMutation,
  ResendInviteWorkspaceMemberMutationVariables
>;

/**
 * __useResendInviteWorkspaceMemberMutation__
 *
 * To run a mutation, you first call `useResendInviteWorkspaceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteWorkspaceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteWorkspaceMemberMutation, { data, loading, error }] = useResendInviteWorkspaceMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendInviteWorkspaceMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInviteWorkspaceMemberMutation,
    ResendInviteWorkspaceMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResendInviteWorkspaceMemberMutation, ResendInviteWorkspaceMemberMutationVariables>(
    ResendInviteWorkspaceMemberDocument,
    options
  );
}
export type ResendInviteWorkspaceMemberMutationHookResult = ReturnType<typeof useResendInviteWorkspaceMemberMutation>;
export type ResendInviteWorkspaceMemberMutationResult = Apollo.MutationResult<ResendInviteWorkspaceMemberMutation>;
export type ResendInviteWorkspaceMemberMutationOptions = Apollo.BaseMutationOptions<
  ResendInviteWorkspaceMemberMutation,
  ResendInviteWorkspaceMemberMutationVariables
>;
export const UpdateWorkspaceMemberDocument = gql`
  mutation UpdateWorkspaceMember($input: UpdateInviteWorkspaceMember!, $updateWorkspaceMemberId: Int) {
    updateWorkspaceMember(input: $input, id: $updateWorkspaceMemberId) {
      message
    }
  }
`;
export type UpdateWorkspaceMemberMutationFn = Apollo.MutationFunction<
  UpdateWorkspaceMemberMutation,
  UpdateWorkspaceMemberMutationVariables
>;

/**
 * __useUpdateWorkspaceMemberMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMemberMutation, { data, loading, error }] = useUpdateWorkspaceMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateWorkspaceMemberId: // value for 'updateWorkspaceMemberId'
 *   },
 * });
 */
export function useUpdateWorkspaceMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceMemberMutation, UpdateWorkspaceMemberMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateWorkspaceMemberMutation, UpdateWorkspaceMemberMutationVariables>(
    UpdateWorkspaceMemberDocument,
    options
  );
}
export type UpdateWorkspaceMemberMutationHookResult = ReturnType<typeof useUpdateWorkspaceMemberMutation>;
export type UpdateWorkspaceMemberMutationResult = Apollo.MutationResult<UpdateWorkspaceMemberMutation>;
export type UpdateWorkspaceMemberMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkspaceMemberMutation,
  UpdateWorkspaceMemberMutationVariables
>;
export const UpdateWorkspaceMemberV2Document = gql`
  mutation UpdateWorkspaceMemberV2($input: UpdateInviteWorkspaceMemberV2!, $updateWorkspaceMemberV2Id: Int) {
    updateWorkspaceMemberV2(input: $input, id: $updateWorkspaceMemberV2Id) {
      data {
        user {
          id
          name
          email
        }
        userWorkspace {
          id
        }
        role {
          id
          label
        }
      }
      message
    }
  }
`;
export type UpdateWorkspaceMemberV2MutationFn = Apollo.MutationFunction<
  UpdateWorkspaceMemberV2Mutation,
  UpdateWorkspaceMemberV2MutationVariables
>;

/**
 * __useUpdateWorkspaceMemberV2Mutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMemberV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMemberV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMemberV2Mutation, { data, loading, error }] = useUpdateWorkspaceMemberV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateWorkspaceMemberV2Id: // value for 'updateWorkspaceMemberV2Id'
 *   },
 * });
 */
export function useUpdateWorkspaceMemberV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceMemberV2Mutation, UpdateWorkspaceMemberV2MutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateWorkspaceMemberV2Mutation, UpdateWorkspaceMemberV2MutationVariables>(
    UpdateWorkspaceMemberV2Document,
    options
  );
}
export type UpdateWorkspaceMemberV2MutationHookResult = ReturnType<typeof useUpdateWorkspaceMemberV2Mutation>;
export type UpdateWorkspaceMemberV2MutationResult = Apollo.MutationResult<UpdateWorkspaceMemberV2Mutation>;
export type UpdateWorkspaceMemberV2MutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkspaceMemberV2Mutation,
  UpdateWorkspaceMemberV2MutationVariables
>;
export const AssignMemberToChannelDocument = gql`
  mutation AssignMemberToChannel($input: InputChannelUserWorkspace!) {
    assignMemberToChannel(input: $input) {
      message
    }
  }
`;
export type AssignMemberToChannelMutationFn = Apollo.MutationFunction<
  AssignMemberToChannelMutation,
  AssignMemberToChannelMutationVariables
>;

/**
 * __useAssignMemberToChannelMutation__
 *
 * To run a mutation, you first call `useAssignMemberToChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMemberToChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMemberToChannelMutation, { data, loading, error }] = useAssignMemberToChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignMemberToChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<AssignMemberToChannelMutation, AssignMemberToChannelMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignMemberToChannelMutation, AssignMemberToChannelMutationVariables>(
    AssignMemberToChannelDocument,
    options
  );
}
export type AssignMemberToChannelMutationHookResult = ReturnType<typeof useAssignMemberToChannelMutation>;
export type AssignMemberToChannelMutationResult = Apollo.MutationResult<AssignMemberToChannelMutation>;
export type AssignMemberToChannelMutationOptions = Apollo.BaseMutationOptions<
  AssignMemberToChannelMutation,
  AssignMemberToChannelMutationVariables
>;
export const sendChatMessageDocument = gql`
  mutation sendChatMessage($input: InputChatMessage!) {
    sendChatMessage(input: $input) {
      message
      data {
        id
        body
        isPinned
        createdAt
        sender {
          id
          status
          userOnlineManagement {
            isActive
            lastSeenAt
            activeStatus
            awayTill
            message
            awaySet
            icon
          }
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
            }
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            lastPasswordResetAt
          }
        }
      }
    }
  }
`;
export type sendChatMessageMutationFn = Apollo.MutationFunction<
  sendChatMessageMutation,
  sendChatMessageMutationVariables
>;

/**
 * __usesendChatMessageMutation__
 *
 * To run a mutation, you first call `usesendChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usesendChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageMutation, { data, loading, error }] = usesendChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usesendChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<sendChatMessageMutation, sendChatMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<sendChatMessageMutation, sendChatMessageMutationVariables>(
    sendChatMessageDocument,
    options
  );
}
export type sendChatMessageMutationHookResult = ReturnType<typeof usesendChatMessageMutation>;
export type sendChatMessageMutationResult = Apollo.MutationResult<sendChatMessageMutation>;
export type sendChatMessageMutationOptions = Apollo.BaseMutationOptions<
  sendChatMessageMutation,
  sendChatMessageMutationVariables
>;
export const PinOrUnpinChatMessageDocument = gql`
  mutation PinOrUnpinChatMessage($pinOrUnpinChatMessageId: Int!, $input: InputPinOrUnpinChatMessage) {
    pinOrUnpinChatMessage(id: $pinOrUnpinChatMessageId, input: $input) {
      message
      data {
        id
        isPinned
      }
    }
  }
`;
export type PinOrUnpinChatMessageMutationFn = Apollo.MutationFunction<
  PinOrUnpinChatMessageMutation,
  PinOrUnpinChatMessageMutationVariables
>;

/**
 * __usePinOrUnpinChatMessageMutation__
 *
 * To run a mutation, you first call `usePinOrUnpinChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinOrUnpinChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinOrUnpinChatMessageMutation, { data, loading, error }] = usePinOrUnpinChatMessageMutation({
 *   variables: {
 *      pinOrUnpinChatMessageId: // value for 'pinOrUnpinChatMessageId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePinOrUnpinChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<PinOrUnpinChatMessageMutation, PinOrUnpinChatMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PinOrUnpinChatMessageMutation, PinOrUnpinChatMessageMutationVariables>(
    PinOrUnpinChatMessageDocument,
    options
  );
}
export type PinOrUnpinChatMessageMutationHookResult = ReturnType<typeof usePinOrUnpinChatMessageMutation>;
export type PinOrUnpinChatMessageMutationResult = Apollo.MutationResult<PinOrUnpinChatMessageMutation>;
export type PinOrUnpinChatMessageMutationOptions = Apollo.BaseMutationOptions<
  PinOrUnpinChatMessageMutation,
  PinOrUnpinChatMessageMutationVariables
>;
export const AssignOrUnassignChannelToMemberDocument = gql`
  mutation AssignOrUnassignChannelToMember($input: InputAssignOrUnassignChannelToMember) {
    assignOrUnassignChannelToMember(input: $input) {
      message
    }
  }
`;
export type AssignOrUnassignChannelToMemberMutationFn = Apollo.MutationFunction<
  AssignOrUnassignChannelToMemberMutation,
  AssignOrUnassignChannelToMemberMutationVariables
>;

/**
 * __useAssignOrUnassignChannelToMemberMutation__
 *
 * To run a mutation, you first call `useAssignOrUnassignChannelToMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignOrUnassignChannelToMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignOrUnassignChannelToMemberMutation, { data, loading, error }] = useAssignOrUnassignChannelToMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignOrUnassignChannelToMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignOrUnassignChannelToMemberMutation,
    AssignOrUnassignChannelToMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignOrUnassignChannelToMemberMutation, AssignOrUnassignChannelToMemberMutationVariables>(
    AssignOrUnassignChannelToMemberDocument,
    options
  );
}
export type AssignOrUnassignChannelToMemberMutationHookResult = ReturnType<
  typeof useAssignOrUnassignChannelToMemberMutation
>;
export type AssignOrUnassignChannelToMemberMutationResult =
  Apollo.MutationResult<AssignOrUnassignChannelToMemberMutation>;
export type AssignOrUnassignChannelToMemberMutationOptions = Apollo.BaseMutationOptions<
  AssignOrUnassignChannelToMemberMutation,
  AssignOrUnassignChannelToMemberMutationVariables
>;
export const VerifyPaymentRequestDocument = gql`
  mutation VerifyPaymentRequest($urlToken: String!) {
    verifyPaymentRequest(urlToken: $urlToken) {
      message
      data {
        amount
        purpose
      }
    }
  }
`;
export type VerifyPaymentRequestMutationFn = Apollo.MutationFunction<
  VerifyPaymentRequestMutation,
  VerifyPaymentRequestMutationVariables
>;

/**
 * __useVerifyPaymentRequestMutation__
 *
 * To run a mutation, you first call `useVerifyPaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPaymentRequestMutation, { data, loading, error }] = useVerifyPaymentRequestMutation({
 *   variables: {
 *      urlToken: // value for 'urlToken'
 *   },
 * });
 */
export function useVerifyPaymentRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyPaymentRequestMutation, VerifyPaymentRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyPaymentRequestMutation, VerifyPaymentRequestMutationVariables>(
    VerifyPaymentRequestDocument,
    options
  );
}
export type VerifyPaymentRequestMutationHookResult = ReturnType<typeof useVerifyPaymentRequestMutation>;
export type VerifyPaymentRequestMutationResult = Apollo.MutationResult<VerifyPaymentRequestMutation>;
export type VerifyPaymentRequestMutationOptions = Apollo.BaseMutationOptions<
  VerifyPaymentRequestMutation,
  VerifyPaymentRequestMutationVariables
>;
export const CollectPaymentRequestDocument = gql`
  mutation CollectPaymentRequest($input: CollectPaymentRequestInput!) {
    collectPaymentRequest(input: $input) {
      message
    }
  }
`;
export type CollectPaymentRequestMutationFn = Apollo.MutationFunction<
  CollectPaymentRequestMutation,
  CollectPaymentRequestMutationVariables
>;

/**
 * __useCollectPaymentRequestMutation__
 *
 * To run a mutation, you first call `useCollectPaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectPaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectPaymentRequestMutation, { data, loading, error }] = useCollectPaymentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectPaymentRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<CollectPaymentRequestMutation, CollectPaymentRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CollectPaymentRequestMutation, CollectPaymentRequestMutationVariables>(
    CollectPaymentRequestDocument,
    options
  );
}
export type CollectPaymentRequestMutationHookResult = ReturnType<typeof useCollectPaymentRequestMutation>;
export type CollectPaymentRequestMutationResult = Apollo.MutationResult<CollectPaymentRequestMutation>;
export type CollectPaymentRequestMutationOptions = Apollo.BaseMutationOptions<
  CollectPaymentRequestMutation,
  CollectPaymentRequestMutationVariables
>;
export const ReadMessageDocument = gql`
  mutation ReadMessage($messageConversationId: Int) {
    readMessage(messageConversationId: $messageConversationId) {
      message
    }
  }
`;
export type ReadMessageMutationFn = Apollo.MutationFunction<ReadMessageMutation, ReadMessageMutationVariables>;

/**
 * __useReadMessageMutation__
 *
 * To run a mutation, you first call `useReadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readMessageMutation, { data, loading, error }] = useReadMessageMutation({
 *   variables: {
 *      messageConversationId: // value for 'messageConversationId'
 *   },
 * });
 */
export function useReadMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<ReadMessageMutation, ReadMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReadMessageMutation, ReadMessageMutationVariables>(ReadMessageDocument, options);
}
export type ReadMessageMutationHookResult = ReturnType<typeof useReadMessageMutation>;
export type ReadMessageMutationResult = Apollo.MutationResult<ReadMessageMutation>;
export type ReadMessageMutationOptions = Apollo.BaseMutationOptions<ReadMessageMutation, ReadMessageMutationVariables>;
export const ReadAllMessageDocument = gql`
  mutation ReadAllMessage($recentMessageConversationId: Int) {
    readAllMessage(recentMessageConversationId: $recentMessageConversationId) {
      message
    }
  }
`;
export type ReadAllMessageMutationFn = Apollo.MutationFunction<ReadAllMessageMutation, ReadAllMessageMutationVariables>;

/**
 * __useReadAllMessageMutation__
 *
 * To run a mutation, you first call `useReadAllMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllMessageMutation, { data, loading, error }] = useReadAllMessageMutation({
 *   variables: {
 *      recentMessageConversationId: // value for 'recentMessageConversationId'
 *   },
 * });
 */
export function useReadAllMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<ReadAllMessageMutation, ReadAllMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReadAllMessageMutation, ReadAllMessageMutationVariables>(ReadAllMessageDocument, options);
}
export type ReadAllMessageMutationHookResult = ReturnType<typeof useReadAllMessageMutation>;
export type ReadAllMessageMutationResult = Apollo.MutationResult<ReadAllMessageMutation>;
export type ReadAllMessageMutationOptions = Apollo.BaseMutationOptions<
  ReadAllMessageMutation,
  ReadAllMessageMutationVariables
>;
export const MarkAsActiveOrAwayDocument = gql`
  mutation MarkAsActiveOrAway($input: InputMarkAsActiveOrAway) {
    markAsActiveOrAway(input: $input) {
      message
    }
  }
`;
export type MarkAsActiveOrAwayMutationFn = Apollo.MutationFunction<
  MarkAsActiveOrAwayMutation,
  MarkAsActiveOrAwayMutationVariables
>;

/**
 * __useMarkAsActiveOrAwayMutation__
 *
 * To run a mutation, you first call `useMarkAsActiveOrAwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsActiveOrAwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsActiveOrAwayMutation, { data, loading, error }] = useMarkAsActiveOrAwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAsActiveOrAwayMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkAsActiveOrAwayMutation, MarkAsActiveOrAwayMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkAsActiveOrAwayMutation, MarkAsActiveOrAwayMutationVariables>(
    MarkAsActiveOrAwayDocument,
    options
  );
}
export type MarkAsActiveOrAwayMutationHookResult = ReturnType<typeof useMarkAsActiveOrAwayMutation>;
export type MarkAsActiveOrAwayMutationResult = Apollo.MutationResult<MarkAsActiveOrAwayMutation>;
export type MarkAsActiveOrAwayMutationOptions = Apollo.BaseMutationOptions<
  MarkAsActiveOrAwayMutation,
  MarkAsActiveOrAwayMutationVariables
>;
export const ExportInvoicesDocument = gql`
  mutation ExportInvoices($transactionDateFrom: Date!, $transactionDateTo: Date!) {
    exportInvoices(transactionDateFrom: $transactionDateFrom, transactionDateTo: $transactionDateTo) {
      message
    }
  }
`;
export type ExportInvoicesMutationFn = Apollo.MutationFunction<ExportInvoicesMutation, ExportInvoicesMutationVariables>;

/**
 * __useExportInvoicesMutation__
 *
 * To run a mutation, you first call `useExportInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportInvoicesMutation, { data, loading, error }] = useExportInvoicesMutation({
 *   variables: {
 *      transactionDateFrom: // value for 'transactionDateFrom'
 *      transactionDateTo: // value for 'transactionDateTo'
 *   },
 * });
 */
export function useExportInvoicesMutation(
  baseOptions?: Apollo.MutationHookOptions<ExportInvoicesMutation, ExportInvoicesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportInvoicesMutation, ExportInvoicesMutationVariables>(ExportInvoicesDocument, options);
}
export type ExportInvoicesMutationHookResult = ReturnType<typeof useExportInvoicesMutation>;
export type ExportInvoicesMutationResult = Apollo.MutationResult<ExportInvoicesMutation>;
export type ExportInvoicesMutationOptions = Apollo.BaseMutationOptions<
  ExportInvoicesMutation,
  ExportInvoicesMutationVariables
>;
export const AddToCartDocument = gql`
  mutation AddToCart($input: InputCart) {
    addToCart(input: $input) {
      message
    }
  }
`;
export type AddToCartMutationFn = Apollo.MutationFunction<AddToCartMutation, AddToCartMutationVariables>;

/**
 * __useAddToCartMutation__
 *
 * To run a mutation, you first call `useAddToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToCartMutation, { data, loading, error }] = useAddToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddToCartMutation(
  baseOptions?: Apollo.MutationHookOptions<AddToCartMutation, AddToCartMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddToCartMutation, AddToCartMutationVariables>(AddToCartDocument, options);
}
export type AddToCartMutationHookResult = ReturnType<typeof useAddToCartMutation>;
export type AddToCartMutationResult = Apollo.MutationResult<AddToCartMutation>;
export type AddToCartMutationOptions = Apollo.BaseMutationOptions<AddToCartMutation, AddToCartMutationVariables>;
export const RemoveFromCartDocument = gql`
  mutation RemoveFromCart($input: InputCart) {
    removeFromCart(input: $input) {
      message
    }
  }
`;
export type RemoveFromCartMutationFn = Apollo.MutationFunction<RemoveFromCartMutation, RemoveFromCartMutationVariables>;

/**
 * __useRemoveFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromCartMutation, { data, loading, error }] = useRemoveFromCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFromCartMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveFromCartMutation, RemoveFromCartMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveFromCartMutation, RemoveFromCartMutationVariables>(RemoveFromCartDocument, options);
}
export type RemoveFromCartMutationHookResult = ReturnType<typeof useRemoveFromCartMutation>;
export type RemoveFromCartMutationResult = Apollo.MutationResult<RemoveFromCartMutation>;
export type RemoveFromCartMutationOptions = Apollo.BaseMutationOptions<
  RemoveFromCartMutation,
  RemoveFromCartMutationVariables
>;
export const SubscribeNumberPlanDocument = gql`
  mutation SubscribeNumberPlan($input: NumberSubscriptionInput!) {
    subscribeNumberPlan(input: $input) {
      message
    }
  }
`;
export type SubscribeNumberPlanMutationFn = Apollo.MutationFunction<
  SubscribeNumberPlanMutation,
  SubscribeNumberPlanMutationVariables
>;

/**
 * __useSubscribeNumberPlanMutation__
 *
 * To run a mutation, you first call `useSubscribeNumberPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeNumberPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeNumberPlanMutation, { data, loading, error }] = useSubscribeNumberPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeNumberPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<SubscribeNumberPlanMutation, SubscribeNumberPlanMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubscribeNumberPlanMutation, SubscribeNumberPlanMutationVariables>(
    SubscribeNumberPlanDocument,
    options
  );
}
export type SubscribeNumberPlanMutationHookResult = ReturnType<typeof useSubscribeNumberPlanMutation>;
export type SubscribeNumberPlanMutationResult = Apollo.MutationResult<SubscribeNumberPlanMutation>;
export type SubscribeNumberPlanMutationOptions = Apollo.BaseMutationOptions<
  SubscribeNumberPlanMutation,
  SubscribeNumberPlanMutationVariables
>;
export const RequestRegulatoryComplianceDocument = gql`
  mutation RequestRegulatoryCompliance($input: InputRequestRegulatoryCompliance) {
    requestRegulatoryCompliance(input: $input) {
      message
    }
  }
`;
export type RequestRegulatoryComplianceMutationFn = Apollo.MutationFunction<
  RequestRegulatoryComplianceMutation,
  RequestRegulatoryComplianceMutationVariables
>;

/**
 * __useRequestRegulatoryComplianceMutation__
 *
 * To run a mutation, you first call `useRequestRegulatoryComplianceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestRegulatoryComplianceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestRegulatoryComplianceMutation, { data, loading, error }] = useRequestRegulatoryComplianceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestRegulatoryComplianceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestRegulatoryComplianceMutation,
    RequestRegulatoryComplianceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RequestRegulatoryComplianceMutation, RequestRegulatoryComplianceMutationVariables>(
    RequestRegulatoryComplianceDocument,
    options
  );
}
export type RequestRegulatoryComplianceMutationHookResult = ReturnType<typeof useRequestRegulatoryComplianceMutation>;
export type RequestRegulatoryComplianceMutationResult = Apollo.MutationResult<RequestRegulatoryComplianceMutation>;
export type RequestRegulatoryComplianceMutationOptions = Apollo.BaseMutationOptions<
  RequestRegulatoryComplianceMutation,
  RequestRegulatoryComplianceMutationVariables
>;
export const ClaimFreeNumbersDocument = gql`
  mutation ClaimFreeNumbers($input: NumbersClaimInput!) {
    claimFreeNumbers(input: $input) {
      message
    }
  }
`;
export type ClaimFreeNumbersMutationFn = Apollo.MutationFunction<
  ClaimFreeNumbersMutation,
  ClaimFreeNumbersMutationVariables
>;

/**
 * __useClaimFreeNumbersMutation__
 *
 * To run a mutation, you first call `useClaimFreeNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimFreeNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimFreeNumbersMutation, { data, loading, error }] = useClaimFreeNumbersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimFreeNumbersMutation(
  baseOptions?: Apollo.MutationHookOptions<ClaimFreeNumbersMutation, ClaimFreeNumbersMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ClaimFreeNumbersMutation, ClaimFreeNumbersMutationVariables>(
    ClaimFreeNumbersDocument,
    options
  );
}
export type ClaimFreeNumbersMutationHookResult = ReturnType<typeof useClaimFreeNumbersMutation>;
export type ClaimFreeNumbersMutationResult = Apollo.MutationResult<ClaimFreeNumbersMutation>;
export type ClaimFreeNumbersMutationOptions = Apollo.BaseMutationOptions<
  ClaimFreeNumbersMutation,
  ClaimFreeNumbersMutationVariables
>;
export const CallTransferDocument = gql`
  mutation CallTransfer($callSid: String!, $input: InputCallTransfer!) {
    callTransfer(callSid: $callSid, input: $input) {
      message
    }
  }
`;
export type CallTransferMutationFn = Apollo.MutationFunction<CallTransferMutation, CallTransferMutationVariables>;

/**
 * __useCallTransferMutation__
 *
 * To run a mutation, you first call `useCallTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callTransferMutation, { data, loading, error }] = useCallTransferMutation({
 *   variables: {
 *      callSid: // value for 'callSid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallTransferMutation(
  baseOptions?: Apollo.MutationHookOptions<CallTransferMutation, CallTransferMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CallTransferMutation, CallTransferMutationVariables>(CallTransferDocument, options);
}
export type CallTransferMutationHookResult = ReturnType<typeof useCallTransferMutation>;
export type CallTransferMutationResult = Apollo.MutationResult<CallTransferMutation>;
export type CallTransferMutationOptions = Apollo.BaseMutationOptions<
  CallTransferMutation,
  CallTransferMutationVariables
>;
export const ResendMessageDocument = gql`
  mutation ResendMessage($resendMessageId: Int!) {
    resendMessage(id: $resendMessageId) {
      message
      data {
        id
        messageConversationErrorLog {
          code
          message
          statusCode
        }
        numMedia
        friendlyName
        forwardedAt
        forwardedTo {
          externalNumber
        }
        agent {
          channels {
            friendlyName
            phoneNumber
            identity
            id
          }
        }
        channelId
        client {
          id
          name
          phoneNumber
          profilePicture {
            url
          }
        }
        agent {
          id
          status
          user {
            id
            name
            profilePicture {
              url
            }
          }
          userOnlineManagement {
            activeStatus
            isActive
            lastSeenAt
          }
        }
        conversationStatus
        conversationType
        direction
        id
        markAsClosed
        messageContent
        pinned
        updatedAt
        createdAt
        recordingUrl
        voicemailRecordingUrl
        durationConference {
          startDate
          endDate
          id
        }
        voicemailRecording {
          id
          url
        }
        callRecording {
          id
          transcription {
            id
            providerCallRecordingsId
            transcribedText
            targetLanguageCode
            sentiment
            callSummary
            jobStatus
            jobResponse
            jobKeyName
          }
        }
      }
    }
  }
`;
export type ResendMessageMutationFn = Apollo.MutationFunction<ResendMessageMutation, ResendMessageMutationVariables>;

/**
 * __useResendMessageMutation__
 *
 * To run a mutation, you first call `useResendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMessageMutation, { data, loading, error }] = useResendMessageMutation({
 *   variables: {
 *      resendMessageId: // value for 'resendMessageId'
 *   },
 * });
 */
export function useResendMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendMessageMutation, ResendMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResendMessageMutation, ResendMessageMutationVariables>(ResendMessageDocument, options);
}
export type ResendMessageMutationHookResult = ReturnType<typeof useResendMessageMutation>;
export type ResendMessageMutationResult = Apollo.MutationResult<ResendMessageMutation>;
export type ResendMessageMutationOptions = Apollo.BaseMutationOptions<
  ResendMessageMutation,
  ResendMessageMutationVariables
>;
export const ConnectThirdPartyDocument = gql`
  mutation ConnectThirdParty($integrationId: Int) {
    connectThirdParty(integrationId: $integrationId) {
      message
      data {
        id
        name
        description
        domain
        logoUrl
        label
        integrationUser {
          id
          status
        }
      }
    }
  }
`;
export type ConnectThirdPartyMutationFn = Apollo.MutationFunction<
  ConnectThirdPartyMutation,
  ConnectThirdPartyMutationVariables
>;

/**
 * __useConnectThirdPartyMutation__
 *
 * To run a mutation, you first call `useConnectThirdPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectThirdPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectThirdPartyMutation, { data, loading, error }] = useConnectThirdPartyMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useConnectThirdPartyMutation(
  baseOptions?: Apollo.MutationHookOptions<ConnectThirdPartyMutation, ConnectThirdPartyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConnectThirdPartyMutation, ConnectThirdPartyMutationVariables>(
    ConnectThirdPartyDocument,
    options
  );
}
export type ConnectThirdPartyMutationHookResult = ReturnType<typeof useConnectThirdPartyMutation>;
export type ConnectThirdPartyMutationResult = Apollo.MutationResult<ConnectThirdPartyMutation>;
export type ConnectThirdPartyMutationOptions = Apollo.BaseMutationOptions<
  ConnectThirdPartyMutation,
  ConnectThirdPartyMutationVariables
>;
export const DisconnectThirdPartyDocument = gql`
  mutation DisconnectThirdParty($integrationId: Int) {
    disconnectThirdParty(integrationId: $integrationId) {
      message
      data {
        id
        name
        description
        domain
        logoUrl
        label
        integrationUser {
          id
          status
        }
      }
    }
  }
`;
export type DisconnectThirdPartyMutationFn = Apollo.MutationFunction<
  DisconnectThirdPartyMutation,
  DisconnectThirdPartyMutationVariables
>;

/**
 * __useDisconnectThirdPartyMutation__
 *
 * To run a mutation, you first call `useDisconnectThirdPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectThirdPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectThirdPartyMutation, { data, loading, error }] = useDisconnectThirdPartyMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useDisconnectThirdPartyMutation(
  baseOptions?: Apollo.MutationHookOptions<DisconnectThirdPartyMutation, DisconnectThirdPartyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisconnectThirdPartyMutation, DisconnectThirdPartyMutationVariables>(
    DisconnectThirdPartyDocument,
    options
  );
}
export type DisconnectThirdPartyMutationHookResult = ReturnType<typeof useDisconnectThirdPartyMutation>;
export type DisconnectThirdPartyMutationResult = Apollo.MutationResult<DisconnectThirdPartyMutation>;
export type DisconnectThirdPartyMutationOptions = Apollo.BaseMutationOptions<
  DisconnectThirdPartyMutation,
  DisconnectThirdPartyMutationVariables
>;
export const CreateIntegrationConfigurationDocument = gql`
  mutation CreateIntegrationConfiguration($input: InputIntegrationConfiguration) {
    createIntegrationConfiguration(input: $input) {
      message
      data {
        id
        integrationUserId
        workspaceId
        syncCallDetails
        syncContacts
        syncMessage
        syncVoicemails
        syncRecordings
        createdBy
        updatedBy
      }
    }
  }
`;
export type CreateIntegrationConfigurationMutationFn = Apollo.MutationFunction<
  CreateIntegrationConfigurationMutation,
  CreateIntegrationConfigurationMutationVariables
>;

/**
 * __useCreateIntegrationConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationConfigurationMutation, { data, loading, error }] = useCreateIntegrationConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIntegrationConfigurationMutation,
    CreateIntegrationConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateIntegrationConfigurationMutation, CreateIntegrationConfigurationMutationVariables>(
    CreateIntegrationConfigurationDocument,
    options
  );
}
export type CreateIntegrationConfigurationMutationHookResult = ReturnType<
  typeof useCreateIntegrationConfigurationMutation
>;
export type CreateIntegrationConfigurationMutationResult =
  Apollo.MutationResult<CreateIntegrationConfigurationMutation>;
export type CreateIntegrationConfigurationMutationOptions = Apollo.BaseMutationOptions<
  CreateIntegrationConfigurationMutation,
  CreateIntegrationConfigurationMutationVariables
>;
export const CreateIntegrationWebhooksDocument = gql`
  mutation CreateIntegrationWebhooks($integrationUserId: Int!, $input: [InputIntegrationWebhook]) {
    createIntegrationWebhooks(integrationUserId: $integrationUserId, input: $input) {
      message
      data {
        id
        integrationUserId
        label
        username
        password
        url
      }
    }
  }
`;
export type CreateIntegrationWebhooksMutationFn = Apollo.MutationFunction<
  CreateIntegrationWebhooksMutation,
  CreateIntegrationWebhooksMutationVariables
>;

/**
 * __useCreateIntegrationWebhooksMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationWebhooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationWebhooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationWebhooksMutation, { data, loading, error }] = useCreateIntegrationWebhooksMutation({
 *   variables: {
 *      integrationUserId: // value for 'integrationUserId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationWebhooksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIntegrationWebhooksMutation,
    CreateIntegrationWebhooksMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateIntegrationWebhooksMutation, CreateIntegrationWebhooksMutationVariables>(
    CreateIntegrationWebhooksDocument,
    options
  );
}
export type CreateIntegrationWebhooksMutationHookResult = ReturnType<typeof useCreateIntegrationWebhooksMutation>;
export type CreateIntegrationWebhooksMutationResult = Apollo.MutationResult<CreateIntegrationWebhooksMutation>;
export type CreateIntegrationWebhooksMutationOptions = Apollo.BaseMutationOptions<
  CreateIntegrationWebhooksMutation,
  CreateIntegrationWebhooksMutationVariables
>;
export const UpdateIntegrationWebhooksDocument = gql`
  mutation UpdateIntegrationWebhooks($input: [InputUpdateIntegrationWebhook]) {
    updateIntegrationWebhooks(input: $input) {
      message
      data {
        id
        integrationUserId
        label
        username
        password
        url
      }
    }
  }
`;
export type UpdateIntegrationWebhooksMutationFn = Apollo.MutationFunction<
  UpdateIntegrationWebhooksMutation,
  UpdateIntegrationWebhooksMutationVariables
>;

/**
 * __useUpdateIntegrationWebhooksMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationWebhooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationWebhooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationWebhooksMutation, { data, loading, error }] = useUpdateIntegrationWebhooksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationWebhooksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIntegrationWebhooksMutation,
    UpdateIntegrationWebhooksMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateIntegrationWebhooksMutation, UpdateIntegrationWebhooksMutationVariables>(
    UpdateIntegrationWebhooksDocument,
    options
  );
}
export type UpdateIntegrationWebhooksMutationHookResult = ReturnType<typeof useUpdateIntegrationWebhooksMutation>;
export type UpdateIntegrationWebhooksMutationResult = Apollo.MutationResult<UpdateIntegrationWebhooksMutation>;
export type UpdateIntegrationWebhooksMutationOptions = Apollo.BaseMutationOptions<
  UpdateIntegrationWebhooksMutation,
  UpdateIntegrationWebhooksMutationVariables
>;
export const ToggleIntegrationChannelStatusDocument = gql`
  mutation ToggleIntegrationChannelStatus($input: InputIntegrationChannel) {
    toggleIntegrationChannelStatus(input: $input) {
      message
      data {
        id
        friendlyName
        phoneNumber
        country {
          id
          flag
        }
        integrationChannels {
          id
          integrationUserId
          isEnabled
        }
      }
    }
  }
`;
export type ToggleIntegrationChannelStatusMutationFn = Apollo.MutationFunction<
  ToggleIntegrationChannelStatusMutation,
  ToggleIntegrationChannelStatusMutationVariables
>;

/**
 * __useToggleIntegrationChannelStatusMutation__
 *
 * To run a mutation, you first call `useToggleIntegrationChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIntegrationChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIntegrationChannelStatusMutation, { data, loading, error }] = useToggleIntegrationChannelStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleIntegrationChannelStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleIntegrationChannelStatusMutation,
    ToggleIntegrationChannelStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ToggleIntegrationChannelStatusMutation, ToggleIntegrationChannelStatusMutationVariables>(
    ToggleIntegrationChannelStatusDocument,
    options
  );
}
export type ToggleIntegrationChannelStatusMutationHookResult = ReturnType<
  typeof useToggleIntegrationChannelStatusMutation
>;
export type ToggleIntegrationChannelStatusMutationResult =
  Apollo.MutationResult<ToggleIntegrationChannelStatusMutation>;
export type ToggleIntegrationChannelStatusMutationOptions = Apollo.BaseMutationOptions<
  ToggleIntegrationChannelStatusMutation,
  ToggleIntegrationChannelStatusMutationVariables
>;
export const RevokeDocument = gql`
  mutation Revoke($integrationId: Int!) {
    revoke(integrationId: $integrationId) {
      message
      data {
        id
        name
        description
        domain
        logoUrl
        label
        integrationUser {
          id
          status
        }
      }
    }
  }
`;
export type RevokeMutationFn = Apollo.MutationFunction<RevokeMutation, RevokeMutationVariables>;

/**
 * __useRevokeMutation__
 *
 * To run a mutation, you first call `useRevokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeMutation, { data, loading, error }] = useRevokeMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRevokeMutation(baseOptions?: Apollo.MutationHookOptions<RevokeMutation, RevokeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeMutation, RevokeMutationVariables>(RevokeDocument, options);
}
export type RevokeMutationHookResult = ReturnType<typeof useRevokeMutation>;
export type RevokeMutationResult = Apollo.MutationResult<RevokeMutation>;
export type RevokeMutationOptions = Apollo.BaseMutationOptions<RevokeMutation, RevokeMutationVariables>;
export const IntegrateDocument = gql`
  mutation Integrate($integrationId: Int!) {
    integrate(integrationId: $integrationId) {
      message
      data {
        authorizationUrl
      }
    }
  }
`;
export type IntegrateMutationFn = Apollo.MutationFunction<IntegrateMutation, IntegrateMutationVariables>;

/**
 * __useIntegrateMutation__
 *
 * To run a mutation, you first call `useIntegrateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrateMutation, { data, loading, error }] = useIntegrateMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useIntegrateMutation(
  baseOptions?: Apollo.MutationHookOptions<IntegrateMutation, IntegrateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<IntegrateMutation, IntegrateMutationVariables>(IntegrateDocument, options);
}
export type IntegrateMutationHookResult = ReturnType<typeof useIntegrateMutation>;
export type IntegrateMutationResult = Apollo.MutationResult<IntegrateMutation>;
export type IntegrateMutationOptions = Apollo.BaseMutationOptions<IntegrateMutation, IntegrateMutationVariables>;
export const ExchangeOAuthAuthorizationCodeForTokensDocument = gql`
  mutation ExchangeOAuthAuthorizationCodeForTokens($input: AuthorizeOAuthIntegrationInput) {
    exchangeOAuthAuthorizationCodeForTokens(input: $input) {
      message
      data {
        id
        name
        description
        domain
        logoUrl
        label
        integrationUser {
          id
          status
        }
      }
    }
  }
`;
export type ExchangeOAuthAuthorizationCodeForTokensMutationFn = Apollo.MutationFunction<
  ExchangeOAuthAuthorizationCodeForTokensMutation,
  ExchangeOAuthAuthorizationCodeForTokensMutationVariables
>;

/**
 * __useExchangeOAuthAuthorizationCodeForTokensMutation__
 *
 * To run a mutation, you first call `useExchangeOAuthAuthorizationCodeForTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeOAuthAuthorizationCodeForTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeOAuthAuthorizationCodeForTokensMutation, { data, loading, error }] = useExchangeOAuthAuthorizationCodeForTokensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExchangeOAuthAuthorizationCodeForTokensMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExchangeOAuthAuthorizationCodeForTokensMutation,
    ExchangeOAuthAuthorizationCodeForTokensMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExchangeOAuthAuthorizationCodeForTokensMutation,
    ExchangeOAuthAuthorizationCodeForTokensMutationVariables
  >(ExchangeOAuthAuthorizationCodeForTokensDocument, options);
}
export type ExchangeOAuthAuthorizationCodeForTokensMutationHookResult = ReturnType<
  typeof useExchangeOAuthAuthorizationCodeForTokensMutation
>;
export type ExchangeOAuthAuthorizationCodeForTokensMutationResult =
  Apollo.MutationResult<ExchangeOAuthAuthorizationCodeForTokensMutation>;
export type ExchangeOAuthAuthorizationCodeForTokensMutationOptions = Apollo.BaseMutationOptions<
  ExchangeOAuthAuthorizationCodeForTokensMutation,
  ExchangeOAuthAuthorizationCodeForTokensMutationVariables
>;
export const LogOAuthAuthorizationErrorDocument = gql`
  mutation LogOAuthAuthorizationError($input: LogOAuthAuthorizationErrorInput) {
    logOAuthAuthorizationError(input: $input) {
      message
    }
  }
`;
export type LogOAuthAuthorizationErrorMutationFn = Apollo.MutationFunction<
  LogOAuthAuthorizationErrorMutation,
  LogOAuthAuthorizationErrorMutationVariables
>;

/**
 * __useLogOAuthAuthorizationErrorMutation__
 *
 * To run a mutation, you first call `useLogOAuthAuthorizationErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOAuthAuthorizationErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOAuthAuthorizationErrorMutation, { data, loading, error }] = useLogOAuthAuthorizationErrorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogOAuthAuthorizationErrorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogOAuthAuthorizationErrorMutation,
    LogOAuthAuthorizationErrorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogOAuthAuthorizationErrorMutation, LogOAuthAuthorizationErrorMutationVariables>(
    LogOAuthAuthorizationErrorDocument,
    options
  );
}
export type LogOAuthAuthorizationErrorMutationHookResult = ReturnType<typeof useLogOAuthAuthorizationErrorMutation>;
export type LogOAuthAuthorizationErrorMutationResult = Apollo.MutationResult<LogOAuthAuthorizationErrorMutation>;
export type LogOAuthAuthorizationErrorMutationOptions = Apollo.BaseMutationOptions<
  LogOAuthAuthorizationErrorMutation,
  LogOAuthAuthorizationErrorMutationVariables
>;
export const CacheOAuthAuthorizationCodeDocument = gql`
  mutation CacheOAuthAuthorizationCode($input: CacheIntegrationOAuthCodeInput) {
    cacheOAuthAuthorizationCode(input: $input) {
      data {
        transientToken
      }
      message
    }
  }
`;
export type CacheOAuthAuthorizationCodeMutationFn = Apollo.MutationFunction<
  CacheOAuthAuthorizationCodeMutation,
  CacheOAuthAuthorizationCodeMutationVariables
>;

/**
 * __useCacheOAuthAuthorizationCodeMutation__
 *
 * To run a mutation, you first call `useCacheOAuthAuthorizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCacheOAuthAuthorizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cacheOAuthAuthorizationCodeMutation, { data, loading, error }] = useCacheOAuthAuthorizationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCacheOAuthAuthorizationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CacheOAuthAuthorizationCodeMutation,
    CacheOAuthAuthorizationCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CacheOAuthAuthorizationCodeMutation, CacheOAuthAuthorizationCodeMutationVariables>(
    CacheOAuthAuthorizationCodeDocument,
    options
  );
}
export type CacheOAuthAuthorizationCodeMutationHookResult = ReturnType<typeof useCacheOAuthAuthorizationCodeMutation>;
export type CacheOAuthAuthorizationCodeMutationResult = Apollo.MutationResult<CacheOAuthAuthorizationCodeMutation>;
export type CacheOAuthAuthorizationCodeMutationOptions = Apollo.BaseMutationOptions<
  CacheOAuthAuthorizationCodeMutation,
  CacheOAuthAuthorizationCodeMutationVariables
>;
export const ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenDocument = gql`
  mutation ExchangeOAuthAuthorizationCodeForTokensViaTransientToken($input: AuthorizeOAuthIntegrationWithTokenInput) {
    exchangeOAuthAuthorizationCodeForTokensViaTransientToken(input: $input) {
      message
    }
  }
`;
export type ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationFn = Apollo.MutationFunction<
  ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation,
  ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationVariables
>;

/**
 * __useExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation__
 *
 * To run a mutation, you first call `useExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation, { data, loading, error }] = useExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation,
    ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation,
    ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationVariables
  >(ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenDocument, options);
}
export type ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationHookResult = ReturnType<
  typeof useExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation
>;
export type ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationResult =
  Apollo.MutationResult<ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation>;
export type ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationOptions = Apollo.BaseMutationOptions<
  ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutation,
  ExchangeOAuthAuthorizationCodeForTokensViaTransientTokenMutationVariables
>;
export const WorkspaceAuthMeDocument = gql`
  mutation WorkspaceAuthMe($input: InputUpdateWorkspace) {
    workspaceAuthMe(input: $input) {
      message
      data {
        id
        coverProfile {
          url
          id
        }
        logo {
          id
          url
        }
        label
        timezoneId
        timezoneLabel
        timezoneValue
        timezone
      }
    }
  }
`;
export type WorkspaceAuthMeMutationFn = Apollo.MutationFunction<
  WorkspaceAuthMeMutation,
  WorkspaceAuthMeMutationVariables
>;

/**
 * __useWorkspaceAuthMeMutation__
 *
 * To run a mutation, you first call `useWorkspaceAuthMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceAuthMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspaceAuthMeMutation, { data, loading, error }] = useWorkspaceAuthMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspaceAuthMeMutation(
  baseOptions?: Apollo.MutationHookOptions<WorkspaceAuthMeMutation, WorkspaceAuthMeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WorkspaceAuthMeMutation, WorkspaceAuthMeMutationVariables>(
    WorkspaceAuthMeDocument,
    options
  );
}
export type WorkspaceAuthMeMutationHookResult = ReturnType<typeof useWorkspaceAuthMeMutation>;
export type WorkspaceAuthMeMutationResult = Apollo.MutationResult<WorkspaceAuthMeMutation>;
export type WorkspaceAuthMeMutationOptions = Apollo.BaseMutationOptions<
  WorkspaceAuthMeMutation,
  WorkspaceAuthMeMutationVariables
>;
export const CreateIntegrationRequestDocument = gql`
  mutation CreateIntegrationRequest($input: CreateIntegrationRequestInput!) {
    createIntegrationRequest(input: $input) {
      data {
        appName
        id
      }
      message
    }
  }
`;
export type CreateIntegrationRequestMutationFn = Apollo.MutationFunction<
  CreateIntegrationRequestMutation,
  CreateIntegrationRequestMutationVariables
>;

/**
 * __useCreateIntegrationRequestMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationRequestMutation, { data, loading, error }] = useCreateIntegrationRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateIntegrationRequestMutation, CreateIntegrationRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateIntegrationRequestMutation, CreateIntegrationRequestMutationVariables>(
    CreateIntegrationRequestDocument,
    options
  );
}
export type CreateIntegrationRequestMutationHookResult = ReturnType<typeof useCreateIntegrationRequestMutation>;
export type CreateIntegrationRequestMutationResult = Apollo.MutationResult<CreateIntegrationRequestMutation>;
export type CreateIntegrationRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateIntegrationRequestMutation,
  CreateIntegrationRequestMutationVariables
>;
export const CreateBusinessAddressDocument = gql`
  mutation CreateBusinessAddress($input: InputBusinessAddress) {
    createBusinessAddress(input: $input) {
      data {
        id
      }
      message
    }
  }
`;
export type CreateBusinessAddressMutationFn = Apollo.MutationFunction<
  CreateBusinessAddressMutation,
  CreateBusinessAddressMutationVariables
>;

/**
 * __useCreateBusinessAddressMutation__
 *
 * To run a mutation, you first call `useCreateBusinessAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessAddressMutation, { data, loading, error }] = useCreateBusinessAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBusinessAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateBusinessAddressMutation, CreateBusinessAddressMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateBusinessAddressMutation, CreateBusinessAddressMutationVariables>(
    CreateBusinessAddressDocument,
    options
  );
}
export type CreateBusinessAddressMutationHookResult = ReturnType<typeof useCreateBusinessAddressMutation>;
export type CreateBusinessAddressMutationResult = Apollo.MutationResult<CreateBusinessAddressMutation>;
export type CreateBusinessAddressMutationOptions = Apollo.BaseMutationOptions<
  CreateBusinessAddressMutation,
  CreateBusinessAddressMutationVariables
>;
export const CreateCallSettingDocument = gql`
  mutation CreateCallSetting($input: InputCallSetting!) {
    createCallSetting(input: $input) {
      data {
        id
        friendlyName
      }
      message
    }
  }
`;
export type CreateCallSettingMutationFn = Apollo.MutationFunction<
  CreateCallSettingMutation,
  CreateCallSettingMutationVariables
>;

/**
 * __useCreateCallSettingMutation__
 *
 * To run a mutation, you first call `useCreateCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCallSettingMutation, { data, loading, error }] = useCreateCallSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCallSettingMutation, CreateCallSettingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCallSettingMutation, CreateCallSettingMutationVariables>(
    CreateCallSettingDocument,
    options
  );
}
export type CreateCallSettingMutationHookResult = ReturnType<typeof useCreateCallSettingMutation>;
export type CreateCallSettingMutationResult = Apollo.MutationResult<CreateCallSettingMutation>;
export type CreateCallSettingMutationOptions = Apollo.BaseMutationOptions<
  CreateCallSettingMutation,
  CreateCallSettingMutationVariables
>;
export const setCallForwardInCallSettingDocument = gql`
  mutation setCallForwardInCallSetting($input: InputCallForward!) {
    setCallForwardInCallSetting(input: $input) {
      message
      data {
        id
        isUnconditional
        targetPhoneNumber
        isActive
      }
    }
  }
`;
export type setCallForwardInCallSettingMutationFn = Apollo.MutationFunction<
  setCallForwardInCallSettingMutation,
  setCallForwardInCallSettingMutationVariables
>;

/**
 * __usesetCallForwardInCallSettingMutation__
 *
 * To run a mutation, you first call `usesetCallForwardInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usesetCallForwardInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallForwardInCallSettingMutation, { data, loading, error }] = usesetCallForwardInCallSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usesetCallForwardInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    setCallForwardInCallSettingMutation,
    setCallForwardInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<setCallForwardInCallSettingMutation, setCallForwardInCallSettingMutationVariables>(
    setCallForwardInCallSettingDocument,
    options
  );
}
export type setCallForwardInCallSettingMutationHookResult = ReturnType<typeof usesetCallForwardInCallSettingMutation>;
export type setCallForwardInCallSettingMutationResult = Apollo.MutationResult<setCallForwardInCallSettingMutation>;
export type setCallForwardInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  setCallForwardInCallSettingMutation,
  setCallForwardInCallSettingMutationVariables
>;
export const SetVoicemailInCallSettingDocument = gql`
  mutation SetVoicemailInCallSetting($setCallsettingVoicemailId: Int!, $input: InputCallSettingVoiceMail!) {
    setVoicemailInCallSetting(id: $setCallsettingVoicemailId, input: $input) {
      data {
        id
        audioPrompt {
          audio {
            id
            url
          }
          id
          gender
          language
          text
          type
        }
        isActive
        sendVoicemailToEmail
      }
      message
    }
  }
`;
export type SetVoicemailInCallSettingMutationFn = Apollo.MutationFunction<
  SetVoicemailInCallSettingMutation,
  SetVoicemailInCallSettingMutationVariables
>;

/**
 * __useSetVoicemailInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetVoicemailInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVoicemailInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVoicemailInCallSettingMutation, { data, loading, error }] = useSetVoicemailInCallSettingMutation({
 *   variables: {
 *      setCallsettingVoicemailId: // value for 'setCallsettingVoicemailId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetVoicemailInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetVoicemailInCallSettingMutation,
    SetVoicemailInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetVoicemailInCallSettingMutation, SetVoicemailInCallSettingMutationVariables>(
    SetVoicemailInCallSettingDocument,
    options
  );
}
export type SetVoicemailInCallSettingMutationHookResult = ReturnType<typeof useSetVoicemailInCallSettingMutation>;
export type SetVoicemailInCallSettingMutationResult = Apollo.MutationResult<SetVoicemailInCallSettingMutation>;
export type SetVoicemailInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetVoicemailInCallSettingMutation,
  SetVoicemailInCallSettingMutationVariables
>;
export const SetBusinessHoursInCallSettingDocument = gql`
  mutation SetBusinessHoursInCallSetting($input: InputCallSettingBusinessHour!) {
    setBusinessHoursInCallSetting(input: $input) {
      message
    }
  }
`;
export type SetBusinessHoursInCallSettingMutationFn = Apollo.MutationFunction<
  SetBusinessHoursInCallSettingMutation,
  SetBusinessHoursInCallSettingMutationVariables
>;

/**
 * __useSetBusinessHoursInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetBusinessHoursInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBusinessHoursInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBusinessHoursInCallSettingMutation, { data, loading, error }] = useSetBusinessHoursInCallSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBusinessHoursInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBusinessHoursInCallSettingMutation,
    SetBusinessHoursInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetBusinessHoursInCallSettingMutation, SetBusinessHoursInCallSettingMutationVariables>(
    SetBusinessHoursInCallSettingDocument,
    options
  );
}
export type SetBusinessHoursInCallSettingMutationHookResult = ReturnType<
  typeof useSetBusinessHoursInCallSettingMutation
>;
export type SetBusinessHoursInCallSettingMutationResult = Apollo.MutationResult<SetBusinessHoursInCallSettingMutation>;
export type SetBusinessHoursInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetBusinessHoursInCallSettingMutation,
  SetBusinessHoursInCallSettingMutationVariables
>;
export const SetBusinessAfterHoursInCallSettingDocument = gql`
  mutation SetBusinessAfterHoursInCallSetting($input: InputCallSettingBusinessAfterHours!) {
    setBusinessAfterHoursInCallSetting(input: $input) {
      message
    }
  }
`;
export type SetBusinessAfterHoursInCallSettingMutationFn = Apollo.MutationFunction<
  SetBusinessAfterHoursInCallSettingMutation,
  SetBusinessAfterHoursInCallSettingMutationVariables
>;

/**
 * __useSetBusinessAfterHoursInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetBusinessAfterHoursInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBusinessAfterHoursInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBusinessAfterHoursInCallSettingMutation, { data, loading, error }] = useSetBusinessAfterHoursInCallSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBusinessAfterHoursInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBusinessAfterHoursInCallSettingMutation,
    SetBusinessAfterHoursInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBusinessAfterHoursInCallSettingMutation,
    SetBusinessAfterHoursInCallSettingMutationVariables
  >(SetBusinessAfterHoursInCallSettingDocument, options);
}
export type SetBusinessAfterHoursInCallSettingMutationHookResult = ReturnType<
  typeof useSetBusinessAfterHoursInCallSettingMutation
>;
export type SetBusinessAfterHoursInCallSettingMutationResult =
  Apollo.MutationResult<SetBusinessAfterHoursInCallSettingMutation>;
export type SetBusinessAfterHoursInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetBusinessAfterHoursInCallSettingMutation,
  SetBusinessAfterHoursInCallSettingMutationVariables
>;
export const ScheduleMessageDocument = gql`
  mutation ScheduleMessage($input: InputMessageSchedule) {
    scheduleMessage(input: $input) {
      message
      data {
        attachments {
          createdAt
          id
          key
          mimetype
          originalname
          size
          url
        }
        id
        failureReason
        messageContent
        scheduleAt
        status
        client {
          id
        }
        channel {
          id
        }
        createdAt
      }
      message
    }
  }
`;
export type ScheduleMessageMutationFn = Apollo.MutationFunction<
  ScheduleMessageMutation,
  ScheduleMessageMutationVariables
>;

/**
 * __useScheduleMessageMutation__
 *
 * To run a mutation, you first call `useScheduleMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleMessageMutation, { data, loading, error }] = useScheduleMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<ScheduleMessageMutation, ScheduleMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ScheduleMessageMutation, ScheduleMessageMutationVariables>(
    ScheduleMessageDocument,
    options
  );
}
export type ScheduleMessageMutationHookResult = ReturnType<typeof useScheduleMessageMutation>;
export type ScheduleMessageMutationResult = Apollo.MutationResult<ScheduleMessageMutation>;
export type ScheduleMessageMutationOptions = Apollo.BaseMutationOptions<
  ScheduleMessageMutation,
  ScheduleMessageMutationVariables
>;
export const SetIvrInCallSettingDocument = gql`
  mutation SetIvrInCallSetting($callSettingId: Int!, $input: InputIvr!) {
    setIvrInCallSetting(callSettingId: $callSettingId, input: $input) {
      message
      data {
        id
      }
    }
  }
`;
export type SetIvrInCallSettingMutationFn = Apollo.MutationFunction<
  SetIvrInCallSettingMutation,
  SetIvrInCallSettingMutationVariables
>;

/**
 * __useSetIvrInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetIvrInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIvrInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIvrInCallSettingMutation, { data, loading, error }] = useSetIvrInCallSettingMutation({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIvrInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<SetIvrInCallSettingMutation, SetIvrInCallSettingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetIvrInCallSettingMutation, SetIvrInCallSettingMutationVariables>(
    SetIvrInCallSettingDocument,
    options
  );
}
export type SetIvrInCallSettingMutationHookResult = ReturnType<typeof useSetIvrInCallSettingMutation>;
export type SetIvrInCallSettingMutationResult = Apollo.MutationResult<SetIvrInCallSettingMutation>;
export type SetIvrInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetIvrInCallSettingMutation,
  SetIvrInCallSettingMutationVariables
>;
export const DeleteScheduledMessageDocument = gql`
  mutation DeleteScheduledMessage($deleteScheduledMessageId: String!) {
    deleteScheduledMessage(id: $deleteScheduledMessageId) {
      message
    }
  }
`;
export type DeleteScheduledMessageMutationFn = Apollo.MutationFunction<
  DeleteScheduledMessageMutation,
  DeleteScheduledMessageMutationVariables
>;

/**
 * __useDeleteScheduledMessageMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledMessageMutation, { data, loading, error }] = useDeleteScheduledMessageMutation({
 *   variables: {
 *      deleteScheduledMessageId: // value for 'deleteScheduledMessageId'
 *   },
 * });
 */
export function useDeleteScheduledMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteScheduledMessageMutation, DeleteScheduledMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteScheduledMessageMutation, DeleteScheduledMessageMutationVariables>(
    DeleteScheduledMessageDocument,
    options
  );
}
export type DeleteScheduledMessageMutationHookResult = ReturnType<typeof useDeleteScheduledMessageMutation>;
export type DeleteScheduledMessageMutationResult = Apollo.MutationResult<DeleteScheduledMessageMutation>;
export type DeleteScheduledMessageMutationOptions = Apollo.BaseMutationOptions<
  DeleteScheduledMessageMutation,
  DeleteScheduledMessageMutationVariables
>;
export const SendScheduledMessageNowDocument = gql`
  mutation SendScheduledMessageNow($sendScheduledMessageNowId: String!) {
    sendScheduledMessageNow(id: $sendScheduledMessageNowId) {
      message
    }
  }
`;
export type SendScheduledMessageNowMutationFn = Apollo.MutationFunction<
  SendScheduledMessageNowMutation,
  SendScheduledMessageNowMutationVariables
>;

/**
 * __useSendScheduledMessageNowMutation__
 *
 * To run a mutation, you first call `useSendScheduledMessageNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendScheduledMessageNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendScheduledMessageNowMutation, { data, loading, error }] = useSendScheduledMessageNowMutation({
 *   variables: {
 *      sendScheduledMessageNowId: // value for 'sendScheduledMessageNowId'
 *   },
 * });
 */
export function useSendScheduledMessageNowMutation(
  baseOptions?: Apollo.MutationHookOptions<SendScheduledMessageNowMutation, SendScheduledMessageNowMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendScheduledMessageNowMutation, SendScheduledMessageNowMutationVariables>(
    SendScheduledMessageNowDocument,
    options
  );
}
export type SendScheduledMessageNowMutationHookResult = ReturnType<typeof useSendScheduledMessageNowMutation>;
export type SendScheduledMessageNowMutationResult = Apollo.MutationResult<SendScheduledMessageNowMutation>;
export type SendScheduledMessageNowMutationOptions = Apollo.BaseMutationOptions<
  SendScheduledMessageNowMutation,
  SendScheduledMessageNowMutationVariables
>;
export const UpdateScheduledMessageDocument = gql`
  mutation UpdateScheduledMessage($updateScheduledMessageId: String!, $input: UpdateMessageSchedule!) {
    updateScheduledMessage(id: $updateScheduledMessageId, input: $input) {
      message
    }
  }
`;
export type UpdateScheduledMessageMutationFn = Apollo.MutationFunction<
  UpdateScheduledMessageMutation,
  UpdateScheduledMessageMutationVariables
>;

/**
 * __useUpdateScheduledMessageMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledMessageMutation, { data, loading, error }] = useUpdateScheduledMessageMutation({
 *   variables: {
 *      updateScheduledMessageId: // value for 'updateScheduledMessageId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>(
    UpdateScheduledMessageDocument,
    options
  );
}
export type UpdateScheduledMessageMutationHookResult = ReturnType<typeof useUpdateScheduledMessageMutation>;
export type UpdateScheduledMessageMutationResult = Apollo.MutationResult<UpdateScheduledMessageMutation>;
export type UpdateScheduledMessageMutationOptions = Apollo.BaseMutationOptions<
  UpdateScheduledMessageMutation,
  UpdateScheduledMessageMutationVariables
>;
export const CollectPaymentDocument = gql`
  mutation CollectPayment($paymentSourceId: String!, $collectPaymentId: String) {
    collectPayment(paymentSourceId: $paymentSourceId, id: $collectPaymentId) {
      message
      data
    }
  }
`;
export type CollectPaymentMutationFn = Apollo.MutationFunction<CollectPaymentMutation, CollectPaymentMutationVariables>;

/**
 * __useCollectPaymentMutation__
 *
 * To run a mutation, you first call `useCollectPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectPaymentMutation, { data, loading, error }] = useCollectPaymentMutation({
 *   variables: {
 *      paymentSourceId: // value for 'paymentSourceId'
 *      collectPaymentId: // value for 'collectPaymentId'
 *   },
 * });
 */
export function useCollectPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<CollectPaymentMutation, CollectPaymentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CollectPaymentMutation, CollectPaymentMutationVariables>(CollectPaymentDocument, options);
}
export type CollectPaymentMutationHookResult = ReturnType<typeof useCollectPaymentMutation>;
export type CollectPaymentMutationResult = Apollo.MutationResult<CollectPaymentMutation>;
export type CollectPaymentMutationOptions = Apollo.BaseMutationOptions<
  CollectPaymentMutation,
  CollectPaymentMutationVariables
>;
export const SetCallTransferInCallSettingDocument = gql`
  mutation SetCallTransferInCallSetting($callSettingId: Int!, $input: InputCallSettingTransfer!) {
    setCallTransferInCallSetting(callSettingId: $callSettingId, input: $input) {
      message
    }
  }
`;
export type SetCallTransferInCallSettingMutationFn = Apollo.MutationFunction<
  SetCallTransferInCallSettingMutation,
  SetCallTransferInCallSettingMutationVariables
>;

/**
 * __useSetCallTransferInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetCallTransferInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallTransferInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallTransferInCallSettingMutation, { data, loading, error }] = useSetCallTransferInCallSettingMutation({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCallTransferInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallTransferInCallSettingMutation,
    SetCallTransferInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallTransferInCallSettingMutation, SetCallTransferInCallSettingMutationVariables>(
    SetCallTransferInCallSettingDocument,
    options
  );
}
export type SetCallTransferInCallSettingMutationHookResult = ReturnType<typeof useSetCallTransferInCallSettingMutation>;
export type SetCallTransferInCallSettingMutationResult = Apollo.MutationResult<SetCallTransferInCallSettingMutation>;
export type SetCallTransferInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetCallTransferInCallSettingMutation,
  SetCallTransferInCallSettingMutationVariables
>;
export const SetCallerIdInCallSettingDocument = gql`
  mutation SetCallerIdInCallSetting($callerId: Int, $setCallerIdInCallSettingId: Int!) {
    setCallerIdInCallSetting(callerId: $callerId, id: $setCallerIdInCallSettingId) {
      message
    }
  }
`;
export type SetCallerIdInCallSettingMutationFn = Apollo.MutationFunction<
  SetCallerIdInCallSettingMutation,
  SetCallerIdInCallSettingMutationVariables
>;

/**
 * __useSetCallerIdInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetCallerIdInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallerIdInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallerIdInCallSettingMutation, { data, loading, error }] = useSetCallerIdInCallSettingMutation({
 *   variables: {
 *      callerId: // value for 'callerId'
 *      setCallerIdInCallSettingId: // value for 'setCallerIdInCallSettingId'
 *   },
 * });
 */
export function useSetCallerIdInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<SetCallerIdInCallSettingMutation, SetCallerIdInCallSettingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallerIdInCallSettingMutation, SetCallerIdInCallSettingMutationVariables>(
    SetCallerIdInCallSettingDocument,
    options
  );
}
export type SetCallerIdInCallSettingMutationHookResult = ReturnType<typeof useSetCallerIdInCallSettingMutation>;
export type SetCallerIdInCallSettingMutationResult = Apollo.MutationResult<SetCallerIdInCallSettingMutation>;
export type SetCallerIdInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetCallerIdInCallSettingMutation,
  SetCallerIdInCallSettingMutationVariables
>;
export const SetTimeoutInCallSettingDocument = gql`
  mutation SetTimeoutInCallSetting($setTimeoutInCallSettingId: Int!, $input: InputTimeout!) {
    setTimeoutInCallSetting(id: $setTimeoutInCallSettingId, input: $input) {
      message
      data {
        id
        timeout
      }
    }
  }
`;
export type SetTimeoutInCallSettingMutationFn = Apollo.MutationFunction<
  SetTimeoutInCallSettingMutation,
  SetTimeoutInCallSettingMutationVariables
>;

/**
 * __useSetTimeoutInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetTimeoutInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTimeoutInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTimeoutInCallSettingMutation, { data, loading, error }] = useSetTimeoutInCallSettingMutation({
 *   variables: {
 *      setTimeoutInCallSettingId: // value for 'setTimeoutInCallSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTimeoutInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<SetTimeoutInCallSettingMutation, SetTimeoutInCallSettingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTimeoutInCallSettingMutation, SetTimeoutInCallSettingMutationVariables>(
    SetTimeoutInCallSettingDocument,
    options
  );
}
export type SetTimeoutInCallSettingMutationHookResult = ReturnType<typeof useSetTimeoutInCallSettingMutation>;
export type SetTimeoutInCallSettingMutationResult = Apollo.MutationResult<SetTimeoutInCallSettingMutation>;
export type SetTimeoutInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetTimeoutInCallSettingMutation,
  SetTimeoutInCallSettingMutationVariables
>;
export const SetCallerTuneInCallSettingDocument = gql`
  mutation SetCallerTuneInCallSetting($setCallerTuneInCallSettingId: Int!, $input: InputCallerTune!) {
    setCallerTuneInCallSetting(id: $setCallerTuneInCallSettingId, input: $input) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
        callerTuneLoop
      }
    }
  }
`;
export type SetCallerTuneInCallSettingMutationFn = Apollo.MutationFunction<
  SetCallerTuneInCallSettingMutation,
  SetCallerTuneInCallSettingMutationVariables
>;

/**
 * __useSetCallerTuneInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetCallerTuneInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallerTuneInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallerTuneInCallSettingMutation, { data, loading, error }] = useSetCallerTuneInCallSettingMutation({
 *   variables: {
 *      setCallerTuneInCallSettingId: // value for 'setCallerTuneInCallSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCallerTuneInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallerTuneInCallSettingMutation,
    SetCallerTuneInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallerTuneInCallSettingMutation, SetCallerTuneInCallSettingMutationVariables>(
    SetCallerTuneInCallSettingDocument,
    options
  );
}
export type SetCallerTuneInCallSettingMutationHookResult = ReturnType<typeof useSetCallerTuneInCallSettingMutation>;
export type SetCallerTuneInCallSettingMutationResult = Apollo.MutationResult<SetCallerTuneInCallSettingMutation>;
export type SetCallerTuneInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetCallerTuneInCallSettingMutation,
  SetCallerTuneInCallSettingMutationVariables
>;
export const SetWelcomeMessageInCallSettingDocument = gql`
  mutation SetWelcomeMessageInCallSetting(
    $setWelcomeMessageInCallSettingId: Int!
    $input: InputCallSettingWelcomeMessage!
  ) {
    setWelcomeMessageInCallSetting(id: $setWelcomeMessageInCallSettingId, input: $input) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
      }
    }
  }
`;
export type SetWelcomeMessageInCallSettingMutationFn = Apollo.MutationFunction<
  SetWelcomeMessageInCallSettingMutation,
  SetWelcomeMessageInCallSettingMutationVariables
>;

/**
 * __useSetWelcomeMessageInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetWelcomeMessageInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWelcomeMessageInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWelcomeMessageInCallSettingMutation, { data, loading, error }] = useSetWelcomeMessageInCallSettingMutation({
 *   variables: {
 *      setWelcomeMessageInCallSettingId: // value for 'setWelcomeMessageInCallSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWelcomeMessageInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetWelcomeMessageInCallSettingMutation,
    SetWelcomeMessageInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetWelcomeMessageInCallSettingMutation, SetWelcomeMessageInCallSettingMutationVariables>(
    SetWelcomeMessageInCallSettingDocument,
    options
  );
}
export type SetWelcomeMessageInCallSettingMutationHookResult = ReturnType<
  typeof useSetWelcomeMessageInCallSettingMutation
>;
export type SetWelcomeMessageInCallSettingMutationResult =
  Apollo.MutationResult<SetWelcomeMessageInCallSettingMutation>;
export type SetWelcomeMessageInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetWelcomeMessageInCallSettingMutation,
  SetWelcomeMessageInCallSettingMutationVariables
>;
export const SetChannelGroupsInCallSettingDocument = gql`
  mutation SetChannelGroupsInCallSetting($setChannelGroupsInCallSettingId: Int!, $channelGroupIds: [Int]!) {
    setChannelGroupsInCallSetting(id: $setChannelGroupsInCallSettingId, channelGroupIds: $channelGroupIds) {
      message
      data {
        slug
        name
        id
      }
    }
  }
`;
export type SetChannelGroupsInCallSettingMutationFn = Apollo.MutationFunction<
  SetChannelGroupsInCallSettingMutation,
  SetChannelGroupsInCallSettingMutationVariables
>;

/**
 * __useSetChannelGroupsInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetChannelGroupsInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChannelGroupsInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChannelGroupsInCallSettingMutation, { data, loading, error }] = useSetChannelGroupsInCallSettingMutation({
 *   variables: {
 *      setChannelGroupsInCallSettingId: // value for 'setChannelGroupsInCallSettingId'
 *      channelGroupIds: // value for 'channelGroupIds'
 *   },
 * });
 */
export function useSetChannelGroupsInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChannelGroupsInCallSettingMutation,
    SetChannelGroupsInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetChannelGroupsInCallSettingMutation, SetChannelGroupsInCallSettingMutationVariables>(
    SetChannelGroupsInCallSettingDocument,
    options
  );
}
export type SetChannelGroupsInCallSettingMutationHookResult = ReturnType<
  typeof useSetChannelGroupsInCallSettingMutation
>;
export type SetChannelGroupsInCallSettingMutationResult = Apollo.MutationResult<SetChannelGroupsInCallSettingMutation>;
export type SetChannelGroupsInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetChannelGroupsInCallSettingMutation,
  SetChannelGroupsInCallSettingMutationVariables
>;
export const DeleteCallSettingDocument = gql`
  mutation DeleteCallSetting($deleteCallSettingId: Int!) {
    deleteCallSetting(id: $deleteCallSettingId) {
      message
    }
  }
`;
export type DeleteCallSettingMutationFn = Apollo.MutationFunction<
  DeleteCallSettingMutation,
  DeleteCallSettingMutationVariables
>;

/**
 * __useDeleteCallSettingMutation__
 *
 * To run a mutation, you first call `useDeleteCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCallSettingMutation, { data, loading, error }] = useDeleteCallSettingMutation({
 *   variables: {
 *      deleteCallSettingId: // value for 'deleteCallSettingId'
 *   },
 * });
 */
export function useDeleteCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCallSettingMutation, DeleteCallSettingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCallSettingMutation, DeleteCallSettingMutationVariables>(
    DeleteCallSettingDocument,
    options
  );
}
export type DeleteCallSettingMutationHookResult = ReturnType<typeof useDeleteCallSettingMutation>;
export type DeleteCallSettingMutationResult = Apollo.MutationResult<DeleteCallSettingMutation>;
export type DeleteCallSettingMutationOptions = Apollo.BaseMutationOptions<
  DeleteCallSettingMutation,
  DeleteCallSettingMutationVariables
>;
export const CreateContactComplianceConsentDocument = gql`
  mutation CreateContactComplianceConsent($input: InputContactComplianceConsent!) {
    createContactComplianceConsent(input: $input) {
      message
      data {
        id
      }
    }
  }
`;
export type CreateContactComplianceConsentMutationFn = Apollo.MutationFunction<
  CreateContactComplianceConsentMutation,
  CreateContactComplianceConsentMutationVariables
>;

/**
 * __useCreateContactComplianceConsentMutation__
 *
 * To run a mutation, you first call `useCreateContactComplianceConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactComplianceConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactComplianceConsentMutation, { data, loading, error }] = useCreateContactComplianceConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactComplianceConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContactComplianceConsentMutation,
    CreateContactComplianceConsentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateContactComplianceConsentMutation, CreateContactComplianceConsentMutationVariables>(
    CreateContactComplianceConsentDocument,
    options
  );
}
export type CreateContactComplianceConsentMutationHookResult = ReturnType<
  typeof useCreateContactComplianceConsentMutation
>;
export type CreateContactComplianceConsentMutationResult =
  Apollo.MutationResult<CreateContactComplianceConsentMutation>;
export type CreateContactComplianceConsentMutationOptions = Apollo.BaseMutationOptions<
  CreateContactComplianceConsentMutation,
  CreateContactComplianceConsentMutationVariables
>;
export const SetCallerIdInChannelSettingDocument = gql`
  mutation SetCallerIdInChannelSetting($channelId: Int!, $callerId: Int) {
    setCallerIdInChannelSetting(channelId: $channelId, callerId: $callerId) {
      message
    }
  }
`;
export type SetCallerIdInChannelSettingMutationFn = Apollo.MutationFunction<
  SetCallerIdInChannelSettingMutation,
  SetCallerIdInChannelSettingMutationVariables
>;

/**
 * __useSetCallerIdInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetCallerIdInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallerIdInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallerIdInChannelSettingMutation, { data, loading, error }] = useSetCallerIdInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      callerId: // value for 'callerId'
 *   },
 * });
 */
export function useSetCallerIdInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallerIdInChannelSettingMutation,
    SetCallerIdInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallerIdInChannelSettingMutation, SetCallerIdInChannelSettingMutationVariables>(
    SetCallerIdInChannelSettingDocument,
    options
  );
}
export type SetCallerIdInChannelSettingMutationHookResult = ReturnType<typeof useSetCallerIdInChannelSettingMutation>;
export type SetCallerIdInChannelSettingMutationResult = Apollo.MutationResult<SetCallerIdInChannelSettingMutation>;
export type SetCallerIdInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetCallerIdInChannelSettingMutation,
  SetCallerIdInChannelSettingMutationVariables
>;
export const SetCallForwardInChannelSettingDocument = gql`
  mutation SetCallForwardInChannelSetting($input: InputCallForwardChannel!, $channelId: Int) {
    setCallForwardInChannelSetting(input: $input, channelId: $channelId) {
      message
      data {
        id
        isUnconditional
        targetPhoneNumber
        isActive
      }
    }
  }
`;
export type SetCallForwardInChannelSettingMutationFn = Apollo.MutationFunction<
  SetCallForwardInChannelSettingMutation,
  SetCallForwardInChannelSettingMutationVariables
>;

/**
 * __useSetCallForwardInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetCallForwardInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallForwardInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallForwardInChannelSettingMutation, { data, loading, error }] = useSetCallForwardInChannelSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useSetCallForwardInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallForwardInChannelSettingMutation,
    SetCallForwardInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallForwardInChannelSettingMutation, SetCallForwardInChannelSettingMutationVariables>(
    SetCallForwardInChannelSettingDocument,
    options
  );
}
export type SetCallForwardInChannelSettingMutationHookResult = ReturnType<
  typeof useSetCallForwardInChannelSettingMutation
>;
export type SetCallForwardInChannelSettingMutationResult =
  Apollo.MutationResult<SetCallForwardInChannelSettingMutation>;
export type SetCallForwardInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetCallForwardInChannelSettingMutation,
  SetCallForwardInChannelSettingMutationVariables
>;
export const SetAutoRecordingInCallSettingDocument = gql`
  mutation SetAutoRecordingInCallSetting($setAutoRecordingInCallSettingId: Int!, $input: InputAutoRecording!) {
    setAutoRecordingInCallSetting(id: $setAutoRecordingInCallSettingId, input: $input) {
      message
      data {
        id
        autoRecording
      }
    }
  }
`;
export type SetAutoRecordingInCallSettingMutationFn = Apollo.MutationFunction<
  SetAutoRecordingInCallSettingMutation,
  SetAutoRecordingInCallSettingMutationVariables
>;

/**
 * __useSetAutoRecordingInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetAutoRecordingInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAutoRecordingInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAutoRecordingInCallSettingMutation, { data, loading, error }] = useSetAutoRecordingInCallSettingMutation({
 *   variables: {
 *      setAutoRecordingInCallSettingId: // value for 'setAutoRecordingInCallSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAutoRecordingInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAutoRecordingInCallSettingMutation,
    SetAutoRecordingInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetAutoRecordingInCallSettingMutation, SetAutoRecordingInCallSettingMutationVariables>(
    SetAutoRecordingInCallSettingDocument,
    options
  );
}
export type SetAutoRecordingInCallSettingMutationHookResult = ReturnType<
  typeof useSetAutoRecordingInCallSettingMutation
>;
export type SetAutoRecordingInCallSettingMutationResult = Apollo.MutationResult<SetAutoRecordingInCallSettingMutation>;
export type SetAutoRecordingInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetAutoRecordingInCallSettingMutation,
  SetAutoRecordingInCallSettingMutationVariables
>;
export const SetAutoTranscribeInCallSettingDocument = gql`
  mutation SetAutoTranscribeInCallSetting($setAutoTranscribeInCallSettingId: Int!, $input: InputAutoTranscribe!) {
    setAutoTranscribeInCallSetting(id: $setAutoTranscribeInCallSettingId, input: $input) {
      message
      data {
        id
        autoTranscribe
      }
    }
  }
`;
export type SetAutoTranscribeInCallSettingMutationFn = Apollo.MutationFunction<
  SetAutoTranscribeInCallSettingMutation,
  SetAutoTranscribeInCallSettingMutationVariables
>;

/**
 * __useSetAutoTranscribeInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetAutoTranscribeInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAutoTranscribeInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAutoTranscribeInCallSettingMutation, { data, loading, error }] = useSetAutoTranscribeInCallSettingMutation({
 *   variables: {
 *      setAutoTranscribeInCallSettingId: // value for 'setAutoTranscribeInCallSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAutoTranscribeInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAutoTranscribeInCallSettingMutation,
    SetAutoTranscribeInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetAutoTranscribeInCallSettingMutation, SetAutoTranscribeInCallSettingMutationVariables>(
    SetAutoTranscribeInCallSettingDocument,
    options
  );
}
export type SetAutoTranscribeInCallSettingMutationHookResult = ReturnType<
  typeof useSetAutoTranscribeInCallSettingMutation
>;
export type SetAutoTranscribeInCallSettingMutationResult =
  Apollo.MutationResult<SetAutoTranscribeInCallSettingMutation>;
export type SetAutoTranscribeInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetAutoTranscribeInCallSettingMutation,
  SetAutoTranscribeInCallSettingMutationVariables
>;
export const SetRecordingAnnouncementInCallSettingDocument = gql`
  mutation SetRecordingAnnouncementInCallSetting(
    $setRecordingAnnouncementInCallSettingId: Int!
    $input: InputRecordingAnnouncement!
  ) {
    setRecordingAnnouncementInCallSetting(id: $setRecordingAnnouncementInCallSettingId, input: $input) {
      message
      data {
        recordingAnnouncementMessage
        recordingAnnouncementAfterBeep
        id
        audioPrompt {
          id
          text
          gender
          audio {
            url
            id
          }
        }
      }
    }
  }
`;
export type SetRecordingAnnouncementInCallSettingMutationFn = Apollo.MutationFunction<
  SetRecordingAnnouncementInCallSettingMutation,
  SetRecordingAnnouncementInCallSettingMutationVariables
>;

/**
 * __useSetRecordingAnnouncementInCallSettingMutation__
 *
 * To run a mutation, you first call `useSetRecordingAnnouncementInCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRecordingAnnouncementInCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRecordingAnnouncementInCallSettingMutation, { data, loading, error }] = useSetRecordingAnnouncementInCallSettingMutation({
 *   variables: {
 *      setRecordingAnnouncementInCallSettingId: // value for 'setRecordingAnnouncementInCallSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRecordingAnnouncementInCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetRecordingAnnouncementInCallSettingMutation,
    SetRecordingAnnouncementInCallSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetRecordingAnnouncementInCallSettingMutation,
    SetRecordingAnnouncementInCallSettingMutationVariables
  >(SetRecordingAnnouncementInCallSettingDocument, options);
}
export type SetRecordingAnnouncementInCallSettingMutationHookResult = ReturnType<
  typeof useSetRecordingAnnouncementInCallSettingMutation
>;
export type SetRecordingAnnouncementInCallSettingMutationResult =
  Apollo.MutationResult<SetRecordingAnnouncementInCallSettingMutation>;
export type SetRecordingAnnouncementInCallSettingMutationOptions = Apollo.BaseMutationOptions<
  SetRecordingAnnouncementInCallSettingMutation,
  SetRecordingAnnouncementInCallSettingMutationVariables
>;
export const SetWelcomeMessageInChannelSettingDocument = gql`
  mutation SetWelcomeMessageInChannelSetting($channelId: Int!, $input: InputCallSettingWelcomeMessage!) {
    setWelcomeMessageInChannelSetting(channelId: $channelId, input: $input) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
      }
    }
  }
`;
export type SetWelcomeMessageInChannelSettingMutationFn = Apollo.MutationFunction<
  SetWelcomeMessageInChannelSettingMutation,
  SetWelcomeMessageInChannelSettingMutationVariables
>;

/**
 * __useSetWelcomeMessageInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetWelcomeMessageInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWelcomeMessageInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWelcomeMessageInChannelSettingMutation, { data, loading, error }] = useSetWelcomeMessageInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWelcomeMessageInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetWelcomeMessageInChannelSettingMutation,
    SetWelcomeMessageInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetWelcomeMessageInChannelSettingMutation,
    SetWelcomeMessageInChannelSettingMutationVariables
  >(SetWelcomeMessageInChannelSettingDocument, options);
}
export type SetWelcomeMessageInChannelSettingMutationHookResult = ReturnType<
  typeof useSetWelcomeMessageInChannelSettingMutation
>;
export type SetWelcomeMessageInChannelSettingMutationResult =
  Apollo.MutationResult<SetWelcomeMessageInChannelSettingMutation>;
export type SetWelcomeMessageInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetWelcomeMessageInChannelSettingMutation,
  SetWelcomeMessageInChannelSettingMutationVariables
>;
export const SetTimeoutInChannelSettingDocument = gql`
  mutation SetTimeoutInChannelSetting($channelId: Int!, $input: InputTimeout!) {
    setTimeoutInChannelSetting(channelId: $channelId, input: $input) {
      message
      data {
        id
        timeout
      }
    }
  }
`;
export type SetTimeoutInChannelSettingMutationFn = Apollo.MutationFunction<
  SetTimeoutInChannelSettingMutation,
  SetTimeoutInChannelSettingMutationVariables
>;

/**
 * __useSetTimeoutInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetTimeoutInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTimeoutInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTimeoutInChannelSettingMutation, { data, loading, error }] = useSetTimeoutInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTimeoutInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetTimeoutInChannelSettingMutation,
    SetTimeoutInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTimeoutInChannelSettingMutation, SetTimeoutInChannelSettingMutationVariables>(
    SetTimeoutInChannelSettingDocument,
    options
  );
}
export type SetTimeoutInChannelSettingMutationHookResult = ReturnType<typeof useSetTimeoutInChannelSettingMutation>;
export type SetTimeoutInChannelSettingMutationResult = Apollo.MutationResult<SetTimeoutInChannelSettingMutation>;
export type SetTimeoutInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetTimeoutInChannelSettingMutation,
  SetTimeoutInChannelSettingMutationVariables
>;
export const SetCallerTuneInChannelSettingDocument = gql`
  mutation SetCallerTuneInChannelSetting($channelId: Int!, $input: InputCallerTune!) {
    setCallerTuneInChannelSetting(channelId: $channelId, input: $input) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
        callerTuneLoop
      }
    }
  }
`;
export type SetCallerTuneInChannelSettingMutationFn = Apollo.MutationFunction<
  SetCallerTuneInChannelSettingMutation,
  SetCallerTuneInChannelSettingMutationVariables
>;

/**
 * __useSetCallerTuneInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetCallerTuneInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallerTuneInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallerTuneInChannelSettingMutation, { data, loading, error }] = useSetCallerTuneInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCallerTuneInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallerTuneInChannelSettingMutation,
    SetCallerTuneInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallerTuneInChannelSettingMutation, SetCallerTuneInChannelSettingMutationVariables>(
    SetCallerTuneInChannelSettingDocument,
    options
  );
}
export type SetCallerTuneInChannelSettingMutationHookResult = ReturnType<
  typeof useSetCallerTuneInChannelSettingMutation
>;
export type SetCallerTuneInChannelSettingMutationResult = Apollo.MutationResult<SetCallerTuneInChannelSettingMutation>;
export type SetCallerTuneInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetCallerTuneInChannelSettingMutation,
  SetCallerTuneInChannelSettingMutationVariables
>;
export const SetVoicemailInChannelSettingDocument = gql`
  mutation SetVoicemailInChannelSetting($channelId: Int!, $input: InputCallSettingVoiceMail!) {
    setVoicemailInChannelSetting(channelId: $channelId, input: $input) {
      message
      data {
        id
        audioPrompt {
          audio {
            id
            url
          }
          id
          gender
          language
          text
          type
        }
        isActive
        sendVoicemailToEmail
      }
    }
  }
`;
export type SetVoicemailInChannelSettingMutationFn = Apollo.MutationFunction<
  SetVoicemailInChannelSettingMutation,
  SetVoicemailInChannelSettingMutationVariables
>;

/**
 * __useSetVoicemailInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetVoicemailInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVoicemailInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVoicemailInChannelSettingMutation, { data, loading, error }] = useSetVoicemailInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetVoicemailInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetVoicemailInChannelSettingMutation,
    SetVoicemailInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetVoicemailInChannelSettingMutation, SetVoicemailInChannelSettingMutationVariables>(
    SetVoicemailInChannelSettingDocument,
    options
  );
}
export type SetVoicemailInChannelSettingMutationHookResult = ReturnType<typeof useSetVoicemailInChannelSettingMutation>;
export type SetVoicemailInChannelSettingMutationResult = Apollo.MutationResult<SetVoicemailInChannelSettingMutation>;
export type SetVoicemailInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetVoicemailInChannelSettingMutation,
  SetVoicemailInChannelSettingMutationVariables
>;
export const SetCallTransferInChannelSettingDocument = gql`
  mutation SetCallTransferInChannelSetting($channelId: Int!, $input: InputChannelSettingCallTransfer!) {
    setCallTransferInChannelSetting(channelId: $channelId, input: $input) {
      message
    }
  }
`;
export type SetCallTransferInChannelSettingMutationFn = Apollo.MutationFunction<
  SetCallTransferInChannelSettingMutation,
  SetCallTransferInChannelSettingMutationVariables
>;

/**
 * __useSetCallTransferInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetCallTransferInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallTransferInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallTransferInChannelSettingMutation, { data, loading, error }] = useSetCallTransferInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCallTransferInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallTransferInChannelSettingMutation,
    SetCallTransferInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallTransferInChannelSettingMutation, SetCallTransferInChannelSettingMutationVariables>(
    SetCallTransferInChannelSettingDocument,
    options
  );
}
export type SetCallTransferInChannelSettingMutationHookResult = ReturnType<
  typeof useSetCallTransferInChannelSettingMutation
>;
export type SetCallTransferInChannelSettingMutationResult =
  Apollo.MutationResult<SetCallTransferInChannelSettingMutation>;
export type SetCallTransferInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetCallTransferInChannelSettingMutation,
  SetCallTransferInChannelSettingMutationVariables
>;
export const UpdateChannelDocument = gql`
  mutation UpdateChannel($updateChannelId: Int!, $input: InputChannel!) {
    updateChannel(id: $updateChannelId, input: $input) {
      message
      data {
        id
        friendlyName
        phoneNumber
      }
    }
  }
`;
export type UpdateChannelMutationFn = Apollo.MutationFunction<UpdateChannelMutation, UpdateChannelMutationVariables>;

/**
 * __useUpdateChannelMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMutation, { data, loading, error }] = useUpdateChannelMutation({
 *   variables: {
 *      updateChannelId: // value for 'updateChannelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateChannelMutation, UpdateChannelMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChannelMutation, UpdateChannelMutationVariables>(UpdateChannelDocument, options);
}
export type UpdateChannelMutationHookResult = ReturnType<typeof useUpdateChannelMutation>;
export type UpdateChannelMutationResult = Apollo.MutationResult<UpdateChannelMutation>;
export type UpdateChannelMutationOptions = Apollo.BaseMutationOptions<
  UpdateChannelMutation,
  UpdateChannelMutationVariables
>;
export const SetAutoRecordingInChannelSettingDocument = gql`
  mutation SetAutoRecordingInChannelSetting($channelId: Int!, $input: InputAutoRecording!) {
    setAutoRecordingInChannelSetting(channelId: $channelId, input: $input) {
      message
      data {
        id
        autoRecording
      }
    }
  }
`;
export type SetAutoRecordingInChannelSettingMutationFn = Apollo.MutationFunction<
  SetAutoRecordingInChannelSettingMutation,
  SetAutoRecordingInChannelSettingMutationVariables
>;

/**
 * __useSetAutoRecordingInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetAutoRecordingInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAutoRecordingInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAutoRecordingInChannelSettingMutation, { data, loading, error }] = useSetAutoRecordingInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAutoRecordingInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAutoRecordingInChannelSettingMutation,
    SetAutoRecordingInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAutoRecordingInChannelSettingMutation,
    SetAutoRecordingInChannelSettingMutationVariables
  >(SetAutoRecordingInChannelSettingDocument, options);
}
export type SetAutoRecordingInChannelSettingMutationHookResult = ReturnType<
  typeof useSetAutoRecordingInChannelSettingMutation
>;
export type SetAutoRecordingInChannelSettingMutationResult =
  Apollo.MutationResult<SetAutoRecordingInChannelSettingMutation>;
export type SetAutoRecordingInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetAutoRecordingInChannelSettingMutation,
  SetAutoRecordingInChannelSettingMutationVariables
>;
export const SetAutoTranscribeInChannelSettingDocument = gql`
  mutation SetAutoTranscribeInChannelSetting($channelId: Int!, $input: InputAutoTranscribe!) {
    setAutoTranscribeInChannelSetting(channelId: $channelId, input: $input) {
      message
      data {
        id
        autoTranscribe
      }
    }
  }
`;
export type SetAutoTranscribeInChannelSettingMutationFn = Apollo.MutationFunction<
  SetAutoTranscribeInChannelSettingMutation,
  SetAutoTranscribeInChannelSettingMutationVariables
>;

/**
 * __useSetAutoTranscribeInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetAutoTranscribeInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAutoTranscribeInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAutoTranscribeInChannelSettingMutation, { data, loading, error }] = useSetAutoTranscribeInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAutoTranscribeInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAutoTranscribeInChannelSettingMutation,
    SetAutoTranscribeInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAutoTranscribeInChannelSettingMutation,
    SetAutoTranscribeInChannelSettingMutationVariables
  >(SetAutoTranscribeInChannelSettingDocument, options);
}
export type SetAutoTranscribeInChannelSettingMutationHookResult = ReturnType<
  typeof useSetAutoTranscribeInChannelSettingMutation
>;
export type SetAutoTranscribeInChannelSettingMutationResult =
  Apollo.MutationResult<SetAutoTranscribeInChannelSettingMutation>;
export type SetAutoTranscribeInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetAutoTranscribeInChannelSettingMutation,
  SetAutoTranscribeInChannelSettingMutationVariables
>;
export const SetRecordingAnnouncementInChannelSettingDocument = gql`
  mutation SetRecordingAnnouncementInChannelSetting($channelId: Int!, $input: InputRecordingAnnouncement!) {
    setRecordingAnnouncementInChannelSetting(channelId: $channelId, input: $input) {
      message
      data {
        recordingAnnouncementMessage
        recordingAnnouncementAfterBeep
        id
        audioPrompt {
          id
          text
          gender
          audio {
            url
            id
          }
        }
      }
    }
  }
`;
export type SetRecordingAnnouncementInChannelSettingMutationFn = Apollo.MutationFunction<
  SetRecordingAnnouncementInChannelSettingMutation,
  SetRecordingAnnouncementInChannelSettingMutationVariables
>;

/**
 * __useSetRecordingAnnouncementInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetRecordingAnnouncementInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRecordingAnnouncementInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRecordingAnnouncementInChannelSettingMutation, { data, loading, error }] = useSetRecordingAnnouncementInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRecordingAnnouncementInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetRecordingAnnouncementInChannelSettingMutation,
    SetRecordingAnnouncementInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetRecordingAnnouncementInChannelSettingMutation,
    SetRecordingAnnouncementInChannelSettingMutationVariables
  >(SetRecordingAnnouncementInChannelSettingDocument, options);
}
export type SetRecordingAnnouncementInChannelSettingMutationHookResult = ReturnType<
  typeof useSetRecordingAnnouncementInChannelSettingMutation
>;
export type SetRecordingAnnouncementInChannelSettingMutationResult =
  Apollo.MutationResult<SetRecordingAnnouncementInChannelSettingMutation>;
export type SetRecordingAnnouncementInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetRecordingAnnouncementInChannelSettingMutation,
  SetRecordingAnnouncementInChannelSettingMutationVariables
>;
export const SetIvrInChannelSettingDocument = gql`
  mutation SetIvrInChannelSetting($channelId: Int!, $input: InputChannelSettingIvr!) {
    setIvrInChannelSetting(channelId: $channelId, input: $input) {
      message
      data {
        id
      }
    }
  }
`;
export type SetIvrInChannelSettingMutationFn = Apollo.MutationFunction<
  SetIvrInChannelSettingMutation,
  SetIvrInChannelSettingMutationVariables
>;

/**
 * __useSetIvrInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetIvrInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIvrInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIvrInChannelSettingMutation, { data, loading, error }] = useSetIvrInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIvrInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<SetIvrInChannelSettingMutation, SetIvrInChannelSettingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetIvrInChannelSettingMutation, SetIvrInChannelSettingMutationVariables>(
    SetIvrInChannelSettingDocument,
    options
  );
}
export type SetIvrInChannelSettingMutationHookResult = ReturnType<typeof useSetIvrInChannelSettingMutation>;
export type SetIvrInChannelSettingMutationResult = Apollo.MutationResult<SetIvrInChannelSettingMutation>;
export type SetIvrInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetIvrInChannelSettingMutation,
  SetIvrInChannelSettingMutationVariables
>;
export const SetBusinessHoursInChannelSettingDocument = gql`
  mutation SetBusinessHoursInChannelSetting($channelId: Int!, $input: InputChannelSettingBusinessHour!) {
    setBusinessHoursInChannelSetting(channelId: $channelId, input: $input) {
      message
    }
  }
`;
export type SetBusinessHoursInChannelSettingMutationFn = Apollo.MutationFunction<
  SetBusinessHoursInChannelSettingMutation,
  SetBusinessHoursInChannelSettingMutationVariables
>;

/**
 * __useSetBusinessHoursInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetBusinessHoursInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBusinessHoursInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBusinessHoursInChannelSettingMutation, { data, loading, error }] = useSetBusinessHoursInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBusinessHoursInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBusinessHoursInChannelSettingMutation,
    SetBusinessHoursInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBusinessHoursInChannelSettingMutation,
    SetBusinessHoursInChannelSettingMutationVariables
  >(SetBusinessHoursInChannelSettingDocument, options);
}
export type SetBusinessHoursInChannelSettingMutationHookResult = ReturnType<
  typeof useSetBusinessHoursInChannelSettingMutation
>;
export type SetBusinessHoursInChannelSettingMutationResult =
  Apollo.MutationResult<SetBusinessHoursInChannelSettingMutation>;
export type SetBusinessHoursInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetBusinessHoursInChannelSettingMutation,
  SetBusinessHoursInChannelSettingMutationVariables
>;
export const CreateChannelGroupDocument = gql`
  mutation CreateChannelGroup($input: InputChannelGroup!) {
    createChannelGroup(input: $input) {
      message
      data {
        slug
        name
        id
      }
    }
  }
`;
export type CreateChannelGroupMutationFn = Apollo.MutationFunction<
  CreateChannelGroupMutation,
  CreateChannelGroupMutationVariables
>;

/**
 * __useCreateChannelGroupMutation__
 *
 * To run a mutation, you first call `useCreateChannelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelGroupMutation, { data, loading, error }] = useCreateChannelGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChannelGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateChannelGroupMutation, CreateChannelGroupMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateChannelGroupMutation, CreateChannelGroupMutationVariables>(
    CreateChannelGroupDocument,
    options
  );
}
export type CreateChannelGroupMutationHookResult = ReturnType<typeof useCreateChannelGroupMutation>;
export type CreateChannelGroupMutationResult = Apollo.MutationResult<CreateChannelGroupMutation>;
export type CreateChannelGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateChannelGroupMutation,
  CreateChannelGroupMutationVariables
>;
export const DeleteChannelGroupDocument = gql`
  mutation DeleteChannelGroup($deleteChannelGroupId: Int!) {
    deleteChannelGroup(id: $deleteChannelGroupId) {
      message
    }
  }
`;
export type DeleteChannelGroupMutationFn = Apollo.MutationFunction<
  DeleteChannelGroupMutation,
  DeleteChannelGroupMutationVariables
>;

/**
 * __useDeleteChannelGroupMutation__
 *
 * To run a mutation, you first call `useDeleteChannelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelGroupMutation, { data, loading, error }] = useDeleteChannelGroupMutation({
 *   variables: {
 *      deleteChannelGroupId: // value for 'deleteChannelGroupId'
 *   },
 * });
 */
export function useDeleteChannelGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteChannelGroupMutation, DeleteChannelGroupMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteChannelGroupMutation, DeleteChannelGroupMutationVariables>(
    DeleteChannelGroupDocument,
    options
  );
}
export type DeleteChannelGroupMutationHookResult = ReturnType<typeof useDeleteChannelGroupMutation>;
export type DeleteChannelGroupMutationResult = Apollo.MutationResult<DeleteChannelGroupMutation>;
export type DeleteChannelGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteChannelGroupMutation,
  DeleteChannelGroupMutationVariables
>;
export const UpdateChannelGroupDocument = gql`
  mutation UpdateChannelGroup($updateChannelGroupId: Int!, $input: InputChannelGroup!) {
    updateChannelGroup(id: $updateChannelGroupId, input: $input) {
      message
    }
  }
`;
export type UpdateChannelGroupMutationFn = Apollo.MutationFunction<
  UpdateChannelGroupMutation,
  UpdateChannelGroupMutationVariables
>;

/**
 * __useUpdateChannelGroupMutation__
 *
 * To run a mutation, you first call `useUpdateChannelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelGroupMutation, { data, loading, error }] = useUpdateChannelGroupMutation({
 *   variables: {
 *      updateChannelGroupId: // value for 'updateChannelGroupId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateChannelGroupMutation, UpdateChannelGroupMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChannelGroupMutation, UpdateChannelGroupMutationVariables>(
    UpdateChannelGroupDocument,
    options
  );
}
export type UpdateChannelGroupMutationHookResult = ReturnType<typeof useUpdateChannelGroupMutation>;
export type UpdateChannelGroupMutationResult = Apollo.MutationResult<UpdateChannelGroupMutation>;
export type UpdateChannelGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateChannelGroupMutation,
  UpdateChannelGroupMutationVariables
>;
export const SetChannelsInGroupDocument = gql`
  mutation SetChannelsInGroup($input: InputSetChannelsInGroup!) {
    setChannelsInGroup(input: $input) {
      message
      data {
        unAssignedChannels {
          phoneNumber
          friendlyName
          id
        }
        assignedChannels {
          phoneNumber
          friendlyName
          id
        }
      }
    }
  }
`;
export type SetChannelsInGroupMutationFn = Apollo.MutationFunction<
  SetChannelsInGroupMutation,
  SetChannelsInGroupMutationVariables
>;

/**
 * __useSetChannelsInGroupMutation__
 *
 * To run a mutation, you first call `useSetChannelsInGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChannelsInGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChannelsInGroupMutation, { data, loading, error }] = useSetChannelsInGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChannelsInGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<SetChannelsInGroupMutation, SetChannelsInGroupMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetChannelsInGroupMutation, SetChannelsInGroupMutationVariables>(
    SetChannelsInGroupDocument,
    options
  );
}
export type SetChannelsInGroupMutationHookResult = ReturnType<typeof useSetChannelsInGroupMutation>;
export type SetChannelsInGroupMutationResult = Apollo.MutationResult<SetChannelsInGroupMutation>;
export type SetChannelsInGroupMutationOptions = Apollo.BaseMutationOptions<
  SetChannelsInGroupMutation,
  SetChannelsInGroupMutationVariables
>;
export const SetBusinessAfterHoursInChannelSettingDocument = gql`
  mutation SetBusinessAfterHoursInChannelSetting($channelId: Int!, $input: InputChannelSettingBusinessAfterHours!) {
    setBusinessAfterHoursInChannelSetting(channelId: $channelId, input: $input) {
      message
    }
  }
`;
export type SetBusinessAfterHoursInChannelSettingMutationFn = Apollo.MutationFunction<
  SetBusinessAfterHoursInChannelSettingMutation,
  SetBusinessAfterHoursInChannelSettingMutationVariables
>;

/**
 * __useSetBusinessAfterHoursInChannelSettingMutation__
 *
 * To run a mutation, you first call `useSetBusinessAfterHoursInChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBusinessAfterHoursInChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBusinessAfterHoursInChannelSettingMutation, { data, loading, error }] = useSetBusinessAfterHoursInChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBusinessAfterHoursInChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBusinessAfterHoursInChannelSettingMutation,
    SetBusinessAfterHoursInChannelSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBusinessAfterHoursInChannelSettingMutation,
    SetBusinessAfterHoursInChannelSettingMutationVariables
  >(SetBusinessAfterHoursInChannelSettingDocument, options);
}
export type SetBusinessAfterHoursInChannelSettingMutationHookResult = ReturnType<
  typeof useSetBusinessAfterHoursInChannelSettingMutation
>;
export type SetBusinessAfterHoursInChannelSettingMutationResult =
  Apollo.MutationResult<SetBusinessAfterHoursInChannelSettingMutation>;
export type SetBusinessAfterHoursInChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SetBusinessAfterHoursInChannelSettingMutation,
  SetBusinessAfterHoursInChannelSettingMutationVariables
>;
export const SwitchToChannelSettingDocument = gql`
  mutation SwitchToChannelSetting($channelId: Int!) {
    switchToChannelSetting(channelId: $channelId) {
      message
      data {
        id
        friendlyName
        phoneNumber
        country {
          id
          flag
          alphaTwoCode
        }
        callSetting {
          id
          businessHourType
          friendlyName
          incomingTimeout
          recording
          metrics {
            key
            value
          }
          callerId {
            id
            friendlyName
            phoneNumber
          }
        }
        channelGroup {
          id
          name
          callSetting {
            id
            businessHourType
            metrics {
              key
              value
            }
            friendlyName
            recording
            incomingTimeout
            callerId {
              id
              friendlyName
              phoneNumber
            }
          }
        }
        assignedUsers {
          id
          name
          profilePicture {
            id
            url
          }
        }
      }
    }
  }
`;
export type SwitchToChannelSettingMutationFn = Apollo.MutationFunction<
  SwitchToChannelSettingMutation,
  SwitchToChannelSettingMutationVariables
>;

/**
 * __useSwitchToChannelSettingMutation__
 *
 * To run a mutation, you first call `useSwitchToChannelSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchToChannelSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchToChannelSettingMutation, { data, loading, error }] = useSwitchToChannelSettingMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useSwitchToChannelSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<SwitchToChannelSettingMutation, SwitchToChannelSettingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SwitchToChannelSettingMutation, SwitchToChannelSettingMutationVariables>(
    SwitchToChannelSettingDocument,
    options
  );
}
export type SwitchToChannelSettingMutationHookResult = ReturnType<typeof useSwitchToChannelSettingMutation>;
export type SwitchToChannelSettingMutationResult = Apollo.MutationResult<SwitchToChannelSettingMutation>;
export type SwitchToChannelSettingMutationOptions = Apollo.BaseMutationOptions<
  SwitchToChannelSettingMutation,
  SwitchToChannelSettingMutationVariables
>;
export const SetCallSettingInChannelGroupDocument = gql`
  mutation SetCallSettingInChannelGroup($setCallSettingInChannelGroupId: Int!, $callSettingId: Int) {
    setCallSettingInChannelGroup(id: $setCallSettingInChannelGroupId, callSettingId: $callSettingId) {
      message
      data {
        slug
        name
        metrics {
          value
          key
        }
        id
        channel {
          phoneNumber
          id
          friendlyName
        }
        callSetting {
          id
          friendlyName
          metrics {
            value
            key
          }
        }
      }
    }
  }
`;
export type SetCallSettingInChannelGroupMutationFn = Apollo.MutationFunction<
  SetCallSettingInChannelGroupMutation,
  SetCallSettingInChannelGroupMutationVariables
>;

/**
 * __useSetCallSettingInChannelGroupMutation__
 *
 * To run a mutation, you first call `useSetCallSettingInChannelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallSettingInChannelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallSettingInChannelGroupMutation, { data, loading, error }] = useSetCallSettingInChannelGroupMutation({
 *   variables: {
 *      setCallSettingInChannelGroupId: // value for 'setCallSettingInChannelGroupId'
 *      callSettingId: // value for 'callSettingId'
 *   },
 * });
 */
export function useSetCallSettingInChannelGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallSettingInChannelGroupMutation,
    SetCallSettingInChannelGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallSettingInChannelGroupMutation, SetCallSettingInChannelGroupMutationVariables>(
    SetCallSettingInChannelGroupDocument,
    options
  );
}
export type SetCallSettingInChannelGroupMutationHookResult = ReturnType<typeof useSetCallSettingInChannelGroupMutation>;
export type SetCallSettingInChannelGroupMutationResult = Apollo.MutationResult<SetCallSettingInChannelGroupMutation>;
export type SetCallSettingInChannelGroupMutationOptions = Apollo.BaseMutationOptions<
  SetCallSettingInChannelGroupMutation,
  SetCallSettingInChannelGroupMutationVariables
>;
export const ToggleChannelNotificationDocument = gql`
  mutation ToggleChannelNotification($input: InputToggleChannelNotification!) {
    toggleChannelNotification(input: $input) {
      message
    }
  }
`;
export type ToggleChannelNotificationMutationFn = Apollo.MutationFunction<
  ToggleChannelNotificationMutation,
  ToggleChannelNotificationMutationVariables
>;

/**
 * __useToggleChannelNotificationMutation__
 *
 * To run a mutation, you first call `useToggleChannelNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleChannelNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleChannelNotificationMutation, { data, loading, error }] = useToggleChannelNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleChannelNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleChannelNotificationMutation,
    ToggleChannelNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ToggleChannelNotificationMutation, ToggleChannelNotificationMutationVariables>(
    ToggleChannelNotificationDocument,
    options
  );
}
export type ToggleChannelNotificationMutationHookResult = ReturnType<typeof useToggleChannelNotificationMutation>;
export type ToggleChannelNotificationMutationResult = Apollo.MutationResult<ToggleChannelNotificationMutation>;
export type ToggleChannelNotificationMutationOptions = Apollo.BaseMutationOptions<
  ToggleChannelNotificationMutation,
  ToggleChannelNotificationMutationVariables
>;
export const ExportContactsDocument = gql`
  mutation ExportContacts($query: String, $tags: [Int], $countryCode: [String], $sourceType: [ContactSourceTypeEnum]) {
    exportContacts(query: $query, tags: $tags, countryCode: $countryCode, sourceType: $sourceType) {
      message
    }
  }
`;
export type ExportContactsMutationFn = Apollo.MutationFunction<ExportContactsMutation, ExportContactsMutationVariables>;

/**
 * __useExportContactsMutation__
 *
 * To run a mutation, you first call `useExportContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportContactsMutation, { data, loading, error }] = useExportContactsMutation({
 *   variables: {
 *      query: // value for 'query'
 *      tags: // value for 'tags'
 *      countryCode: // value for 'countryCode'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useExportContactsMutation(
  baseOptions?: Apollo.MutationHookOptions<ExportContactsMutation, ExportContactsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportContactsMutation, ExportContactsMutationVariables>(ExportContactsDocument, options);
}
export type ExportContactsMutationHookResult = ReturnType<typeof useExportContactsMutation>;
export type ExportContactsMutationResult = Apollo.MutationResult<ExportContactsMutation>;
export type ExportContactsMutationOptions = Apollo.BaseMutationOptions<
  ExportContactsMutation,
  ExportContactsMutationVariables
>;
export const ForwardChatToEmailDocument = gql`
  mutation ForwardChatToEmail($input: InputForwardChatToEmail!) {
    forwardChatToEmail(input: $input) {
      message
    }
  }
`;
export type ForwardChatToEmailMutationFn = Apollo.MutationFunction<
  ForwardChatToEmailMutation,
  ForwardChatToEmailMutationVariables
>;

/**
 * __useForwardChatToEmailMutation__
 *
 * To run a mutation, you first call `useForwardChatToEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForwardChatToEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forwardChatToEmailMutation, { data, loading, error }] = useForwardChatToEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForwardChatToEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<ForwardChatToEmailMutation, ForwardChatToEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ForwardChatToEmailMutation, ForwardChatToEmailMutationVariables>(
    ForwardChatToEmailDocument,
    options
  );
}
export type ForwardChatToEmailMutationHookResult = ReturnType<typeof useForwardChatToEmailMutation>;
export type ForwardChatToEmailMutationResult = Apollo.MutationResult<ForwardChatToEmailMutation>;
export type ForwardChatToEmailMutationOptions = Apollo.BaseMutationOptions<
  ForwardChatToEmailMutation,
  ForwardChatToEmailMutationVariables
>;
export const VerifyInvitationTokenDocument = gql`
  mutation VerifyInvitationToken($input: InputVerifyInvitationToken) {
    verifyInvitationToken(input: $input) {
      data {
        name
        passwordRequired
      }
      message
    }
  }
`;
export type VerifyInvitationTokenMutationFn = Apollo.MutationFunction<
  VerifyInvitationTokenMutation,
  VerifyInvitationTokenMutationVariables
>;

/**
 * __useVerifyInvitationTokenMutation__
 *
 * To run a mutation, you first call `useVerifyInvitationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyInvitationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyInvitationTokenMutation, { data, loading, error }] = useVerifyInvitationTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyInvitationTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyInvitationTokenMutation, VerifyInvitationTokenMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyInvitationTokenMutation, VerifyInvitationTokenMutationVariables>(
    VerifyInvitationTokenDocument,
    options
  );
}
export type VerifyInvitationTokenMutationHookResult = ReturnType<typeof useVerifyInvitationTokenMutation>;
export type VerifyInvitationTokenMutationResult = Apollo.MutationResult<VerifyInvitationTokenMutation>;
export type VerifyInvitationTokenMutationOptions = Apollo.BaseMutationOptions<
  VerifyInvitationTokenMutation,
  VerifyInvitationTokenMutationVariables
>;
export const AcceptInvitedWorkspaceMemberDocument = gql`
  mutation AcceptInvitedWorkspaceMember($input: InputAcceptInvitedWorkspaceMemberInterface) {
    acceptInvitedWorkspaceMember(input: $input) {
      message
    }
  }
`;
export type AcceptInvitedWorkspaceMemberMutationFn = Apollo.MutationFunction<
  AcceptInvitedWorkspaceMemberMutation,
  AcceptInvitedWorkspaceMemberMutationVariables
>;

/**
 * __useAcceptInvitedWorkspaceMemberMutation__
 *
 * To run a mutation, you first call `useAcceptInvitedWorkspaceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitedWorkspaceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitedWorkspaceMemberMutation, { data, loading, error }] = useAcceptInvitedWorkspaceMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInvitedWorkspaceMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptInvitedWorkspaceMemberMutation,
    AcceptInvitedWorkspaceMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AcceptInvitedWorkspaceMemberMutation, AcceptInvitedWorkspaceMemberMutationVariables>(
    AcceptInvitedWorkspaceMemberDocument,
    options
  );
}
export type AcceptInvitedWorkspaceMemberMutationHookResult = ReturnType<typeof useAcceptInvitedWorkspaceMemberMutation>;
export type AcceptInvitedWorkspaceMemberMutationResult = Apollo.MutationResult<AcceptInvitedWorkspaceMemberMutation>;
export type AcceptInvitedWorkspaceMemberMutationOptions = Apollo.BaseMutationOptions<
  AcceptInvitedWorkspaceMemberMutation,
  AcceptInvitedWorkspaceMemberMutationVariables
>;
export const WrapUpCallDocument = gql`
  mutation WrapUpCall($callSid: String!) {
    wrapUpCall(callSid: $callSid) {
      message
    }
  }
`;
export type WrapUpCallMutationFn = Apollo.MutationFunction<WrapUpCallMutation, WrapUpCallMutationVariables>;

/**
 * __useWrapUpCallMutation__
 *
 * To run a mutation, you first call `useWrapUpCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWrapUpCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wrapUpCallMutation, { data, loading, error }] = useWrapUpCallMutation({
 *   variables: {
 *      callSid: // value for 'callSid'
 *   },
 * });
 */
export function useWrapUpCallMutation(
  baseOptions?: Apollo.MutationHookOptions<WrapUpCallMutation, WrapUpCallMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WrapUpCallMutation, WrapUpCallMutationVariables>(WrapUpCallDocument, options);
}
export type WrapUpCallMutationHookResult = ReturnType<typeof useWrapUpCallMutation>;
export type WrapUpCallMutationResult = Apollo.MutationResult<WrapUpCallMutation>;
export type WrapUpCallMutationOptions = Apollo.BaseMutationOptions<WrapUpCallMutation, WrapUpCallMutationVariables>;
export const VerifyAndTransitionStatusDocument = gql`
  mutation VerifyAndTransitionStatus($verifyAndTransitionStatusId: Int!, $model: VerifyAndTransitionModelEnum) {
    verifyAndTransitionStatus(id: $verifyAndTransitionStatusId, model: $model) {
      message
    }
  }
`;
export type VerifyAndTransitionStatusMutationFn = Apollo.MutationFunction<
  VerifyAndTransitionStatusMutation,
  VerifyAndTransitionStatusMutationVariables
>;

/**
 * __useVerifyAndTransitionStatusMutation__
 *
 * To run a mutation, you first call `useVerifyAndTransitionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAndTransitionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAndTransitionStatusMutation, { data, loading, error }] = useVerifyAndTransitionStatusMutation({
 *   variables: {
 *      verifyAndTransitionStatusId: // value for 'verifyAndTransitionStatusId'
 *      model: // value for 'model'
 *   },
 * });
 */
export function useVerifyAndTransitionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyAndTransitionStatusMutation,
    VerifyAndTransitionStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyAndTransitionStatusMutation, VerifyAndTransitionStatusMutationVariables>(
    VerifyAndTransitionStatusDocument,
    options
  );
}
export type VerifyAndTransitionStatusMutationHookResult = ReturnType<typeof useVerifyAndTransitionStatusMutation>;
export type VerifyAndTransitionStatusMutationResult = Apollo.MutationResult<VerifyAndTransitionStatusMutation>;
export type VerifyAndTransitionStatusMutationOptions = Apollo.BaseMutationOptions<
  VerifyAndTransitionStatusMutation,
  VerifyAndTransitionStatusMutationVariables
>;
export const RemoveProviderPhoneNumberDocument = gql`
  mutation RemoveProviderPhoneNumber($removeProviderPhoneNumberId: Int!) {
    removeProviderPhoneNumber(id: $removeProviderPhoneNumberId) {
      message
    }
  }
`;
export type RemoveProviderPhoneNumberMutationFn = Apollo.MutationFunction<
  RemoveProviderPhoneNumberMutation,
  RemoveProviderPhoneNumberMutationVariables
>;

/**
 * __useRemoveProviderPhoneNumberMutation__
 *
 * To run a mutation, you first call `useRemoveProviderPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProviderPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProviderPhoneNumberMutation, { data, loading, error }] = useRemoveProviderPhoneNumberMutation({
 *   variables: {
 *      removeProviderPhoneNumberId: // value for 'removeProviderPhoneNumberId'
 *   },
 * });
 */
export function useRemoveProviderPhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProviderPhoneNumberMutation,
    RemoveProviderPhoneNumberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveProviderPhoneNumberMutation, RemoveProviderPhoneNumberMutationVariables>(
    RemoveProviderPhoneNumberDocument,
    options
  );
}
export type RemoveProviderPhoneNumberMutationHookResult = ReturnType<typeof useRemoveProviderPhoneNumberMutation>;
export type RemoveProviderPhoneNumberMutationResult = Apollo.MutationResult<RemoveProviderPhoneNumberMutation>;
export type RemoveProviderPhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  RemoveProviderPhoneNumberMutation,
  RemoveProviderPhoneNumberMutationVariables
>;
export const RemoveProviderPhoneNumbersDocument = gql`
  mutation RemoveProviderPhoneNumbers($ids: [Int!]!) {
    removeProviderPhoneNumbers(ids: $ids) {
      message
      deletedIds
      failed {
        id
        reason
      }
    }
  }
`;
export type RemoveProviderPhoneNumbersMutationFn = Apollo.MutationFunction<
  RemoveProviderPhoneNumbersMutation,
  RemoveProviderPhoneNumbersMutationVariables
>;

/**
 * __useRemoveProviderPhoneNumbersMutation__
 *
 * To run a mutation, you first call `useRemoveProviderPhoneNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProviderPhoneNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProviderPhoneNumbersMutation, { data, loading, error }] = useRemoveProviderPhoneNumbersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRemoveProviderPhoneNumbersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProviderPhoneNumbersMutation,
    RemoveProviderPhoneNumbersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveProviderPhoneNumbersMutation, RemoveProviderPhoneNumbersMutationVariables>(
    RemoveProviderPhoneNumbersDocument,
    options
  );
}
export type RemoveProviderPhoneNumbersMutationHookResult = ReturnType<typeof useRemoveProviderPhoneNumbersMutation>;
export type RemoveProviderPhoneNumbersMutationResult = Apollo.MutationResult<RemoveProviderPhoneNumbersMutation>;
export type RemoveProviderPhoneNumbersMutationOptions = Apollo.BaseMutationOptions<
  RemoveProviderPhoneNumbersMutation,
  RemoveProviderPhoneNumbersMutationVariables
>;
export const CreateTranscriptionJobDocument = gql`
  mutation CreateTranscriptionJob($input: InputTranscriptionInformation!) {
    createTranscriptionJob(input: $input) {
      message
      data {
        jobStatus
        id
        providerCallRecordingsId
      }
    }
  }
`;
export type CreateTranscriptionJobMutationFn = Apollo.MutationFunction<
  CreateTranscriptionJobMutation,
  CreateTranscriptionJobMutationVariables
>;

/**
 * __useCreateTranscriptionJobMutation__
 *
 * To run a mutation, you first call `useCreateTranscriptionJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscriptionJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranscriptionJobMutation, { data, loading, error }] = useCreateTranscriptionJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTranscriptionJobMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTranscriptionJobMutation, CreateTranscriptionJobMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTranscriptionJobMutation, CreateTranscriptionJobMutationVariables>(
    CreateTranscriptionJobDocument,
    options
  );
}
export type CreateTranscriptionJobMutationHookResult = ReturnType<typeof useCreateTranscriptionJobMutation>;
export type CreateTranscriptionJobMutationResult = Apollo.MutationResult<CreateTranscriptionJobMutation>;
export type CreateTranscriptionJobMutationOptions = Apollo.BaseMutationOptions<
  CreateTranscriptionJobMutation,
  CreateTranscriptionJobMutationVariables
>;
export const SwitchUiVersionDocument = gql`
  mutation SwitchUiVersion($uiVersion: UiVersionEnum!) {
    switchUiVersion(uiVersion: $uiVersion) {
      message
    }
  }
`;
export type SwitchUiVersionMutationFn = Apollo.MutationFunction<
  SwitchUiVersionMutation,
  SwitchUiVersionMutationVariables
>;

/**
 * __useSwitchUiVersionMutation__
 *
 * To run a mutation, you first call `useSwitchUiVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchUiVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchUiVersionMutation, { data, loading, error }] = useSwitchUiVersionMutation({
 *   variables: {
 *      uiVersion: // value for 'uiVersion'
 *   },
 * });
 */
export function useSwitchUiVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<SwitchUiVersionMutation, SwitchUiVersionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SwitchUiVersionMutation, SwitchUiVersionMutationVariables>(
    SwitchUiVersionDocument,
    options
  );
}
export type SwitchUiVersionMutationHookResult = ReturnType<typeof useSwitchUiVersionMutation>;
export type SwitchUiVersionMutationResult = Apollo.MutationResult<SwitchUiVersionMutation>;
export type SwitchUiVersionMutationOptions = Apollo.BaseMutationOptions<
  SwitchUiVersionMutation,
  SwitchUiVersionMutationVariables
>;
export const MigrateToV2Document = gql`
  mutation MigrateToV2 {
    migrateToV2 {
      message
    }
  }
`;
export type MigrateToV2MutationFn = Apollo.MutationFunction<MigrateToV2Mutation, MigrateToV2MutationVariables>;

/**
 * __useMigrateToV2Mutation__
 *
 * To run a mutation, you first call `useMigrateToV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateToV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateToV2Mutation, { data, loading, error }] = useMigrateToV2Mutation({
 *   variables: {
 *   },
 * });
 */
export function useMigrateToV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<MigrateToV2Mutation, MigrateToV2MutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MigrateToV2Mutation, MigrateToV2MutationVariables>(MigrateToV2Document, options);
}
export type MigrateToV2MutationHookResult = ReturnType<typeof useMigrateToV2Mutation>;
export type MigrateToV2MutationResult = Apollo.MutationResult<MigrateToV2Mutation>;
export type MigrateToV2MutationOptions = Apollo.BaseMutationOptions<MigrateToV2Mutation, MigrateToV2MutationVariables>;
export const UpdateCallSettingDocument = gql`
  mutation UpdateCallSetting($updateCallSettingId: Int!, $input: InputCallSetting!) {
    updateCallSetting(id: $updateCallSettingId, input: $input) {
      data {
        id
        friendlyName
      }
      message
    }
  }
`;
export type UpdateCallSettingMutationFn = Apollo.MutationFunction<
  UpdateCallSettingMutation,
  UpdateCallSettingMutationVariables
>;

/**
 * __useUpdateCallSettingMutation__
 *
 * To run a mutation, you first call `useUpdateCallSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallSettingMutation, { data, loading, error }] = useUpdateCallSettingMutation({
 *   variables: {
 *      updateCallSettingId: // value for 'updateCallSettingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCallSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCallSettingMutation, UpdateCallSettingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCallSettingMutation, UpdateCallSettingMutationVariables>(
    UpdateCallSettingDocument,
    options
  );
}
export type UpdateCallSettingMutationHookResult = ReturnType<typeof useUpdateCallSettingMutation>;
export type UpdateCallSettingMutationResult = Apollo.MutationResult<UpdateCallSettingMutation>;
export type UpdateCallSettingMutationOptions = Apollo.BaseMutationOptions<
  UpdateCallSettingMutation,
  UpdateCallSettingMutationVariables
>;
export const SuperviseConferenceDocument = gql`
  mutation SuperviseConference($superviseConferenceId: Int!, $input: InputSuperviseConference) {
    superviseConference(id: $superviseConferenceId, input: $input) {
      message
      data {
        supervisionId
      }
    }
  }
`;
export type SuperviseConferenceMutationFn = Apollo.MutationFunction<
  SuperviseConferenceMutation,
  SuperviseConferenceMutationVariables
>;

/**
 * __useSuperviseConferenceMutation__
 *
 * To run a mutation, you first call `useSuperviseConferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperviseConferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superviseConferenceMutation, { data, loading, error }] = useSuperviseConferenceMutation({
 *   variables: {
 *      superviseConferenceId: // value for 'superviseConferenceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperviseConferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<SuperviseConferenceMutation, SuperviseConferenceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SuperviseConferenceMutation, SuperviseConferenceMutationVariables>(
    SuperviseConferenceDocument,
    options
  );
}
export type SuperviseConferenceMutationHookResult = ReturnType<typeof useSuperviseConferenceMutation>;
export type SuperviseConferenceMutationResult = Apollo.MutationResult<SuperviseConferenceMutation>;
export type SuperviseConferenceMutationOptions = Apollo.BaseMutationOptions<
  SuperviseConferenceMutation,
  SuperviseConferenceMutationVariables
>;
export const UnSuperviseConferenceDocument = gql`
  mutation UnSuperviseConference($unSuperviseConferenceId: Int!, $input: InputUnSuperviseConference) {
    unSuperviseConference(id: $unSuperviseConferenceId, input: $input) {
      message
      data {
        supervisionId
      }
    }
  }
`;
export type UnSuperviseConferenceMutationFn = Apollo.MutationFunction<
  UnSuperviseConferenceMutation,
  UnSuperviseConferenceMutationVariables
>;

/**
 * __useUnSuperviseConferenceMutation__
 *
 * To run a mutation, you first call `useUnSuperviseConferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnSuperviseConferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unSuperviseConferenceMutation, { data, loading, error }] = useUnSuperviseConferenceMutation({
 *   variables: {
 *      unSuperviseConferenceId: // value for 'unSuperviseConferenceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnSuperviseConferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<UnSuperviseConferenceMutation, UnSuperviseConferenceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnSuperviseConferenceMutation, UnSuperviseConferenceMutationVariables>(
    UnSuperviseConferenceDocument,
    options
  );
}
export type UnSuperviseConferenceMutationHookResult = ReturnType<typeof useUnSuperviseConferenceMutation>;
export type UnSuperviseConferenceMutationResult = Apollo.MutationResult<UnSuperviseConferenceMutation>;
export type UnSuperviseConferenceMutationOptions = Apollo.BaseMutationOptions<
  UnSuperviseConferenceMutation,
  UnSuperviseConferenceMutationVariables
>;
export const HangUpConferenceDocument = gql`
  mutation HangUpConference($hangUpConferenceId: Int!, $input: InputHangUpConference) {
    hangUpConference(id: $hangUpConferenceId, input: $input) {
      message
    }
  }
`;
export type HangUpConferenceMutationFn = Apollo.MutationFunction<
  HangUpConferenceMutation,
  HangUpConferenceMutationVariables
>;

/**
 * __useHangUpConferenceMutation__
 *
 * To run a mutation, you first call `useHangUpConferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHangUpConferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hangUpConferenceMutation, { data, loading, error }] = useHangUpConferenceMutation({
 *   variables: {
 *      hangUpConferenceId: // value for 'hangUpConferenceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHangUpConferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<HangUpConferenceMutation, HangUpConferenceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<HangUpConferenceMutation, HangUpConferenceMutationVariables>(
    HangUpConferenceDocument,
    options
  );
}
export type HangUpConferenceMutationHookResult = ReturnType<typeof useHangUpConferenceMutation>;
export type HangUpConferenceMutationResult = Apollo.MutationResult<HangUpConferenceMutation>;
export type HangUpConferenceMutationOptions = Apollo.BaseMutationOptions<
  HangUpConferenceMutation,
  HangUpConferenceMutationVariables
>;
export const CaptureClientCallEntityInfoDocument = gql`
  mutation CaptureClientCallEntityInfo($callSid: String!, $input: InputCollectClientInformation!) {
    captureClientCallEntityInfo(callSid: $callSid, input: $input) {
      message
    }
  }
`;
export type CaptureClientCallEntityInfoMutationFn = Apollo.MutationFunction<
  CaptureClientCallEntityInfoMutation,
  CaptureClientCallEntityInfoMutationVariables
>;

/**
 * __useCaptureClientCallEntityInfoMutation__
 *
 * To run a mutation, you first call `useCaptureClientCallEntityInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureClientCallEntityInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureClientCallEntityInfoMutation, { data, loading, error }] = useCaptureClientCallEntityInfoMutation({
 *   variables: {
 *      callSid: // value for 'callSid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCaptureClientCallEntityInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CaptureClientCallEntityInfoMutation,
    CaptureClientCallEntityInfoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CaptureClientCallEntityInfoMutation, CaptureClientCallEntityInfoMutationVariables>(
    CaptureClientCallEntityInfoDocument,
    options
  );
}
export type CaptureClientCallEntityInfoMutationHookResult = ReturnType<typeof useCaptureClientCallEntityInfoMutation>;
export type CaptureClientCallEntityInfoMutationResult = Apollo.MutationResult<CaptureClientCallEntityInfoMutation>;
export type CaptureClientCallEntityInfoMutationOptions = Apollo.BaseMutationOptions<
  CaptureClientCallEntityInfoMutation,
  CaptureClientCallEntityInfoMutationVariables
>;
export const FederatedAuthDocument = gql`
  mutation FederatedAuth($input: InputFederatedAuth!) {
    federatedAuth(input: $input) {
      message
      data {
        token {
          sessionId
          access
          accessTokenIssuedAt
          accessTokenExpiresAt
          refresh
          refreshTokenIssuedAt
          refreshTokenExpiresAt
        }
        name
        id
        email
      }
    }
  }
`;
export type FederatedAuthMutationFn = Apollo.MutationFunction<FederatedAuthMutation, FederatedAuthMutationVariables>;

/**
 * __useFederatedAuthMutation__
 *
 * To run a mutation, you first call `useFederatedAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedAuthMutation, { data, loading, error }] = useFederatedAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<FederatedAuthMutation, FederatedAuthMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FederatedAuthMutation, FederatedAuthMutationVariables>(FederatedAuthDocument, options);
}
export type FederatedAuthMutationHookResult = ReturnType<typeof useFederatedAuthMutation>;
export type FederatedAuthMutationResult = Apollo.MutationResult<FederatedAuthMutation>;
export type FederatedAuthMutationOptions = Apollo.BaseMutationOptions<
  FederatedAuthMutation,
  FederatedAuthMutationVariables
>;
export const SetUpTOTPMfaDocument = gql`
  mutation SetUpTOTPMfa {
    setUpTOTPMfa {
      message
      data {
        otpAuthUri
      }
    }
  }
`;
export type SetUpTOTPMfaMutationFn = Apollo.MutationFunction<SetUpTOTPMfaMutation, SetUpTOTPMfaMutationVariables>;

/**
 * __useSetUpTOTPMfaMutation__
 *
 * To run a mutation, you first call `useSetUpTOTPMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUpTOTPMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUpTotpMfaMutation, { data, loading, error }] = useSetUpTOTPMfaMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetUpTOTPMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<SetUpTOTPMfaMutation, SetUpTOTPMfaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetUpTOTPMfaMutation, SetUpTOTPMfaMutationVariables>(SetUpTOTPMfaDocument, options);
}
export type SetUpTOTPMfaMutationHookResult = ReturnType<typeof useSetUpTOTPMfaMutation>;
export type SetUpTOTPMfaMutationResult = Apollo.MutationResult<SetUpTOTPMfaMutation>;
export type SetUpTOTPMfaMutationOptions = Apollo.BaseMutationOptions<
  SetUpTOTPMfaMutation,
  SetUpTOTPMfaMutationVariables
>;
export const VerifyAndEnableTOTPMfaDocument = gql`
  mutation VerifyAndEnableTOTPMfa($input: InputEnabledTOTPMfa!) {
    verifyAndEnableTOTPMfa(input: $input) {
      message
      data {
        status
      }
    }
  }
`;
export type VerifyAndEnableTOTPMfaMutationFn = Apollo.MutationFunction<
  VerifyAndEnableTOTPMfaMutation,
  VerifyAndEnableTOTPMfaMutationVariables
>;

/**
 * __useVerifyAndEnableTOTPMfaMutation__
 *
 * To run a mutation, you first call `useVerifyAndEnableTOTPMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAndEnableTOTPMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAndEnableTotpMfaMutation, { data, loading, error }] = useVerifyAndEnableTOTPMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAndEnableTOTPMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyAndEnableTOTPMfaMutation, VerifyAndEnableTOTPMfaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyAndEnableTOTPMfaMutation, VerifyAndEnableTOTPMfaMutationVariables>(
    VerifyAndEnableTOTPMfaDocument,
    options
  );
}
export type VerifyAndEnableTOTPMfaMutationHookResult = ReturnType<typeof useVerifyAndEnableTOTPMfaMutation>;
export type VerifyAndEnableTOTPMfaMutationResult = Apollo.MutationResult<VerifyAndEnableTOTPMfaMutation>;
export type VerifyAndEnableTOTPMfaMutationOptions = Apollo.BaseMutationOptions<
  VerifyAndEnableTOTPMfaMutation,
  VerifyAndEnableTOTPMfaMutationVariables
>;
export const DisableTOTPMfaDocument = gql`
  mutation DisableTOTPMfa {
    disableTOTPMfa {
      message
      data {
        status
      }
    }
  }
`;
export type DisableTOTPMfaMutationFn = Apollo.MutationFunction<DisableTOTPMfaMutation, DisableTOTPMfaMutationVariables>;

/**
 * __useDisableTOTPMfaMutation__
 *
 * To run a mutation, you first call `useDisableTOTPMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTOTPMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTotpMfaMutation, { data, loading, error }] = useDisableTOTPMfaMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableTOTPMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<DisableTOTPMfaMutation, DisableTOTPMfaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisableTOTPMfaMutation, DisableTOTPMfaMutationVariables>(DisableTOTPMfaDocument, options);
}
export type DisableTOTPMfaMutationHookResult = ReturnType<typeof useDisableTOTPMfaMutation>;
export type DisableTOTPMfaMutationResult = Apollo.MutationResult<DisableTOTPMfaMutation>;
export type DisableTOTPMfaMutationOptions = Apollo.BaseMutationOptions<
  DisableTOTPMfaMutation,
  DisableTOTPMfaMutationVariables
>;
export const SetUpEmailMfaDocument = gql`
  mutation SetUpEmailMfa($input: InputEmailMfa!) {
    setUpEmailMfa(input: $input) {
      message
      data {
        status
      }
    }
  }
`;
export type SetUpEmailMfaMutationFn = Apollo.MutationFunction<SetUpEmailMfaMutation, SetUpEmailMfaMutationVariables>;

/**
 * __useSetUpEmailMfaMutation__
 *
 * To run a mutation, you first call `useSetUpEmailMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUpEmailMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUpEmailMfaMutation, { data, loading, error }] = useSetUpEmailMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUpEmailMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<SetUpEmailMfaMutation, SetUpEmailMfaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetUpEmailMfaMutation, SetUpEmailMfaMutationVariables>(SetUpEmailMfaDocument, options);
}
export type SetUpEmailMfaMutationHookResult = ReturnType<typeof useSetUpEmailMfaMutation>;
export type SetUpEmailMfaMutationResult = Apollo.MutationResult<SetUpEmailMfaMutation>;
export type SetUpEmailMfaMutationOptions = Apollo.BaseMutationOptions<
  SetUpEmailMfaMutation,
  SetUpEmailMfaMutationVariables
>;
export const SwitchToEmailMfaDocument = gql`
  mutation SwitchToEmailMfa($input: InputSwitchEmailMfa!) {
    switchToEmailMfa(input: $input) {
      message
      data {
        challengeName
      }
    }
  }
`;
export type SwitchToEmailMfaMutationFn = Apollo.MutationFunction<
  SwitchToEmailMfaMutation,
  SwitchToEmailMfaMutationVariables
>;

/**
 * __useSwitchToEmailMfaMutation__
 *
 * To run a mutation, you first call `useSwitchToEmailMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchToEmailMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchToEmailMfaMutation, { data, loading, error }] = useSwitchToEmailMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchToEmailMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<SwitchToEmailMfaMutation, SwitchToEmailMfaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SwitchToEmailMfaMutation, SwitchToEmailMfaMutationVariables>(
    SwitchToEmailMfaDocument,
    options
  );
}
export type SwitchToEmailMfaMutationHookResult = ReturnType<typeof useSwitchToEmailMfaMutation>;
export type SwitchToEmailMfaMutationResult = Apollo.MutationResult<SwitchToEmailMfaMutation>;
export type SwitchToEmailMfaMutationOptions = Apollo.BaseMutationOptions<
  SwitchToEmailMfaMutation,
  SwitchToEmailMfaMutationVariables
>;
export const ResendEmailMfaOtpDocument = gql`
  mutation ResendEmailMfaOtp($input: InputSwitchEmailMfa!) {
    resendEmailMfaOtp(input: $input) {
      message
      data {
        challengeName
      }
    }
  }
`;
export type ResendEmailMfaOtpMutationFn = Apollo.MutationFunction<
  ResendEmailMfaOtpMutation,
  ResendEmailMfaOtpMutationVariables
>;

/**
 * __useResendEmailMfaOtpMutation__
 *
 * To run a mutation, you first call `useResendEmailMfaOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailMfaOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailMfaOtpMutation, { data, loading, error }] = useResendEmailMfaOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendEmailMfaOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendEmailMfaOtpMutation, ResendEmailMfaOtpMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResendEmailMfaOtpMutation, ResendEmailMfaOtpMutationVariables>(
    ResendEmailMfaOtpDocument,
    options
  );
}
export type ResendEmailMfaOtpMutationHookResult = ReturnType<typeof useResendEmailMfaOtpMutation>;
export type ResendEmailMfaOtpMutationResult = Apollo.MutationResult<ResendEmailMfaOtpMutation>;
export type ResendEmailMfaOtpMutationOptions = Apollo.BaseMutationOptions<
  ResendEmailMfaOtpMutation,
  ResendEmailMfaOtpMutationVariables
>;
export const VerifyMfaAuthenticationDocument = gql`
  mutation VerifyMfaAuthentication($input: InputMfaAuth!) {
    verifyMfaAuthentication(input: $input) {
      message
      data {
        token {
          sessionId
          access
          accessTokenIssuedAt
          accessTokenExpiresAt
          refresh
          refreshTokenIssuedAt
          refreshTokenExpiresAt
        }
        isEmailVerified
        twoFactorAuthenticationRequired
        challengeName
        name
        email
        id
      }
    }
  }
`;
export type VerifyMfaAuthenticationMutationFn = Apollo.MutationFunction<
  VerifyMfaAuthenticationMutation,
  VerifyMfaAuthenticationMutationVariables
>;

/**
 * __useVerifyMfaAuthenticationMutation__
 *
 * To run a mutation, you first call `useVerifyMfaAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMfaAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMfaAuthenticationMutation, { data, loading, error }] = useVerifyMfaAuthenticationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyMfaAuthenticationMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyMfaAuthenticationMutation, VerifyMfaAuthenticationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyMfaAuthenticationMutation, VerifyMfaAuthenticationMutationVariables>(
    VerifyMfaAuthenticationDocument,
    options
  );
}
export type VerifyMfaAuthenticationMutationHookResult = ReturnType<typeof useVerifyMfaAuthenticationMutation>;
export type VerifyMfaAuthenticationMutationResult = Apollo.MutationResult<VerifyMfaAuthenticationMutation>;
export type VerifyMfaAuthenticationMutationOptions = Apollo.BaseMutationOptions<
  VerifyMfaAuthenticationMutation,
  VerifyMfaAuthenticationMutationVariables
>;
export const SetMfaReminderDocument = gql`
  mutation SetMfaReminder {
    setMfaReminder {
      message
    }
  }
`;
export type SetMfaReminderMutationFn = Apollo.MutationFunction<SetMfaReminderMutation, SetMfaReminderMutationVariables>;

/**
 * __useSetMfaReminderMutation__
 *
 * To run a mutation, you first call `useSetMfaReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMfaReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMfaReminderMutation, { data, loading, error }] = useSetMfaReminderMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetMfaReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<SetMfaReminderMutation, SetMfaReminderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetMfaReminderMutation, SetMfaReminderMutationVariables>(SetMfaReminderDocument, options);
}
export type SetMfaReminderMutationHookResult = ReturnType<typeof useSetMfaReminderMutation>;
export type SetMfaReminderMutationResult = Apollo.MutationResult<SetMfaReminderMutation>;
export type SetMfaReminderMutationOptions = Apollo.BaseMutationOptions<
  SetMfaReminderMutation,
  SetMfaReminderMutationVariables
>;
export const SetWorkspacePreferredContactMethodsDocument = gql`
  mutation SetWorkspacePreferredContactMethods($input: InputWorkspacePreferredContactMethod) {
    setWorkspacePreferredContactMethods(input: $input) {
      message
    }
  }
`;
export type SetWorkspacePreferredContactMethodsMutationFn = Apollo.MutationFunction<
  SetWorkspacePreferredContactMethodsMutation,
  SetWorkspacePreferredContactMethodsMutationVariables
>;

/**
 * __useSetWorkspacePreferredContactMethodsMutation__
 *
 * To run a mutation, you first call `useSetWorkspacePreferredContactMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspacePreferredContactMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspacePreferredContactMethodsMutation, { data, loading, error }] = useSetWorkspacePreferredContactMethodsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkspacePreferredContactMethodsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetWorkspacePreferredContactMethodsMutation,
    SetWorkspacePreferredContactMethodsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetWorkspacePreferredContactMethodsMutation,
    SetWorkspacePreferredContactMethodsMutationVariables
  >(SetWorkspacePreferredContactMethodsDocument, options);
}
export type SetWorkspacePreferredContactMethodsMutationHookResult = ReturnType<
  typeof useSetWorkspacePreferredContactMethodsMutation
>;
export type SetWorkspacePreferredContactMethodsMutationResult =
  Apollo.MutationResult<SetWorkspacePreferredContactMethodsMutation>;
export type SetWorkspacePreferredContactMethodsMutationOptions = Apollo.BaseMutationOptions<
  SetWorkspacePreferredContactMethodsMutation,
  SetWorkspacePreferredContactMethodsMutationVariables
>;
export const SetWorkspacePreferredContactMethodsLaterDocument = gql`
  mutation SetWorkspacePreferredContactMethodsLater {
    setWorkspacePreferredContactMethodsLater {
      message
    }
  }
`;
export type SetWorkspacePreferredContactMethodsLaterMutationFn = Apollo.MutationFunction<
  SetWorkspacePreferredContactMethodsLaterMutation,
  SetWorkspacePreferredContactMethodsLaterMutationVariables
>;

/**
 * __useSetWorkspacePreferredContactMethodsLaterMutation__
 *
 * To run a mutation, you first call `useSetWorkspacePreferredContactMethodsLaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspacePreferredContactMethodsLaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspacePreferredContactMethodsLaterMutation, { data, loading, error }] = useSetWorkspacePreferredContactMethodsLaterMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetWorkspacePreferredContactMethodsLaterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetWorkspacePreferredContactMethodsLaterMutation,
    SetWorkspacePreferredContactMethodsLaterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetWorkspacePreferredContactMethodsLaterMutation,
    SetWorkspacePreferredContactMethodsLaterMutationVariables
  >(SetWorkspacePreferredContactMethodsLaterDocument, options);
}
export type SetWorkspacePreferredContactMethodsLaterMutationHookResult = ReturnType<
  typeof useSetWorkspacePreferredContactMethodsLaterMutation
>;
export type SetWorkspacePreferredContactMethodsLaterMutationResult =
  Apollo.MutationResult<SetWorkspacePreferredContactMethodsLaterMutation>;
export type SetWorkspacePreferredContactMethodsLaterMutationOptions = Apollo.BaseMutationOptions<
  SetWorkspacePreferredContactMethodsLaterMutation,
  SetWorkspacePreferredContactMethodsLaterMutationVariables
>;
export const CreateKycVerificationSessionDocument = gql`
  mutation CreateKycVerificationSession {
    createKycVerificationSession {
      data {
        id
        sessionUrl
        sessionExpiry
        sessionId
        status
        vendorData
        workflowId
      }
      message
    }
  }
`;
export type CreateKycVerificationSessionMutationFn = Apollo.MutationFunction<
  CreateKycVerificationSessionMutation,
  CreateKycVerificationSessionMutationVariables
>;

/**
 * __useCreateKycVerificationSessionMutation__
 *
 * To run a mutation, you first call `useCreateKycVerificationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKycVerificationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKycVerificationSessionMutation, { data, loading, error }] = useCreateKycVerificationSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateKycVerificationSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateKycVerificationSessionMutation,
    CreateKycVerificationSessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateKycVerificationSessionMutation, CreateKycVerificationSessionMutationVariables>(
    CreateKycVerificationSessionDocument,
    options
  );
}
export type CreateKycVerificationSessionMutationHookResult = ReturnType<typeof useCreateKycVerificationSessionMutation>;
export type CreateKycVerificationSessionMutationResult = Apollo.MutationResult<CreateKycVerificationSessionMutation>;
export type CreateKycVerificationSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateKycVerificationSessionMutation,
  CreateKycVerificationSessionMutationVariables
>;
export const SetUsageReportNotificationDocument = gql`
  mutation SetUsageReportNotification($input: InputSetUsageReportNotification!) {
    setUsageReportNotification(input: $input) {
      message
    }
  }
`;
export type SetUsageReportNotificationMutationFn = Apollo.MutationFunction<
  SetUsageReportNotificationMutation,
  SetUsageReportNotificationMutationVariables
>;

/**
 * __useSetUsageReportNotificationMutation__
 *
 * To run a mutation, you first call `useSetUsageReportNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUsageReportNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUsageReportNotificationMutation, { data, loading, error }] = useSetUsageReportNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUsageReportNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetUsageReportNotificationMutation,
    SetUsageReportNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetUsageReportNotificationMutation, SetUsageReportNotificationMutationVariables>(
    SetUsageReportNotificationDocument,
    options
  );
}
export type SetUsageReportNotificationMutationHookResult = ReturnType<typeof useSetUsageReportNotificationMutation>;
export type SetUsageReportNotificationMutationResult = Apollo.MutationResult<SetUsageReportNotificationMutation>;
export type SetUsageReportNotificationMutationOptions = Apollo.BaseMutationOptions<
  SetUsageReportNotificationMutation,
  SetUsageReportNotificationMutationVariables
>;
export const MarkMemberChatAsReadDocument = gql`
  mutation MarkMemberChatAsRead($roomId: Int!) {
    markMemberChatAsRead(roomId: $roomId) {
      message
    }
  }
`;
export type MarkMemberChatAsReadMutationFn = Apollo.MutationFunction<
  MarkMemberChatAsReadMutation,
  MarkMemberChatAsReadMutationVariables
>;

/**
 * __useMarkMemberChatAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMemberChatAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMemberChatAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMemberChatAsReadMutation, { data, loading, error }] = useMarkMemberChatAsReadMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useMarkMemberChatAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkMemberChatAsReadMutation, MarkMemberChatAsReadMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkMemberChatAsReadMutation, MarkMemberChatAsReadMutationVariables>(
    MarkMemberChatAsReadDocument,
    options
  );
}
export type MarkMemberChatAsReadMutationHookResult = ReturnType<typeof useMarkMemberChatAsReadMutation>;
export type MarkMemberChatAsReadMutationResult = Apollo.MutationResult<MarkMemberChatAsReadMutation>;
export type MarkMemberChatAsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkMemberChatAsReadMutation,
  MarkMemberChatAsReadMutationVariables
>;
export const SwitchCallDocument = gql`
  mutation SwitchCall($switchCallId: Int!, $input: InputSwitchCall!) {
    switchCall(id: $switchCallId, input: $input) {
      message
    }
  }
`;
export type SwitchCallMutationFn = Apollo.MutationFunction<SwitchCallMutation, SwitchCallMutationVariables>;

/**
 * __useSwitchCallMutation__
 *
 * To run a mutation, you first call `useSwitchCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchCallMutation, { data, loading, error }] = useSwitchCallMutation({
 *   variables: {
 *      switchCallId: // value for 'switchCallId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchCallMutation(
  baseOptions?: Apollo.MutationHookOptions<SwitchCallMutation, SwitchCallMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SwitchCallMutation, SwitchCallMutationVariables>(SwitchCallDocument, options);
}
export type SwitchCallMutationHookResult = ReturnType<typeof useSwitchCallMutation>;
export type SwitchCallMutationResult = Apollo.MutationResult<SwitchCallMutation>;
export type SwitchCallMutationOptions = Apollo.BaseMutationOptions<SwitchCallMutation, SwitchCallMutationVariables>;
export const CancelWorkspaceDowngradeDocument = gql`
  mutation CancelWorkspaceDowngrade {
    cancelWorkspaceDowngrade {
      message
    }
  }
`;
export type CancelWorkspaceDowngradeMutationFn = Apollo.MutationFunction<
  CancelWorkspaceDowngradeMutation,
  CancelWorkspaceDowngradeMutationVariables
>;

/**
 * __useCancelWorkspaceDowngradeMutation__
 *
 * To run a mutation, you first call `useCancelWorkspaceDowngradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWorkspaceDowngradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWorkspaceDowngradeMutation, { data, loading, error }] = useCancelWorkspaceDowngradeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelWorkspaceDowngradeMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelWorkspaceDowngradeMutation, CancelWorkspaceDowngradeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelWorkspaceDowngradeMutation, CancelWorkspaceDowngradeMutationVariables>(
    CancelWorkspaceDowngradeDocument,
    options
  );
}
export type CancelWorkspaceDowngradeMutationHookResult = ReturnType<typeof useCancelWorkspaceDowngradeMutation>;
export type CancelWorkspaceDowngradeMutationResult = Apollo.MutationResult<CancelWorkspaceDowngradeMutation>;
export type CancelWorkspaceDowngradeMutationOptions = Apollo.BaseMutationOptions<
  CancelWorkspaceDowngradeMutation,
  CancelWorkspaceDowngradeMutationVariables
>;
export const CreateBulkMessagingCampaignDocument = gql`
  mutation CreateBulkMessagingCampaign($input: InputBulkMessagingCampaign) {
    createBulkMessagingCampaign(input: $input) {
      message
      data {
        id
        campaignName
        isDraft
        messageTemplate
        mediaCount
        campaignType
        a2pCampaignId
        a2pCampaignType
        a2pSampleId
        messagingType
        status
        scheduleType
        isScheduled
        initiatedAt
        scheduledAt
        maxOccurrence
        endAt
        attachments {
          id
          fileName
          mimetype
          fileSize
          fileUrl
        }
        metrics {
          key
          value
        }
        createdBy {
          id
          name
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          roles {
            id
            isActive
            isDefault
            label
            position
            slug
            level
          }
        }
        createdAt
        deliverySummary {
          totalSent
          totalRecipients
          runStatus
        }
      }
    }
  }
`;
export type CreateBulkMessagingCampaignMutationFn = Apollo.MutationFunction<
  CreateBulkMessagingCampaignMutation,
  CreateBulkMessagingCampaignMutationVariables
>;

/**
 * __useCreateBulkMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useCreateBulkMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkMessagingCampaignMutation, { data, loading, error }] = useCreateBulkMessagingCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkMessagingCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBulkMessagingCampaignMutation,
    CreateBulkMessagingCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateBulkMessagingCampaignMutation, CreateBulkMessagingCampaignMutationVariables>(
    CreateBulkMessagingCampaignDocument,
    options
  );
}
export type CreateBulkMessagingCampaignMutationHookResult = ReturnType<typeof useCreateBulkMessagingCampaignMutation>;
export type CreateBulkMessagingCampaignMutationResult = Apollo.MutationResult<CreateBulkMessagingCampaignMutation>;
export type CreateBulkMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<
  CreateBulkMessagingCampaignMutation,
  CreateBulkMessagingCampaignMutationVariables
>;
export const UpdateBulkMessagingCampaignDocument = gql`
  mutation UpdateBulkMessagingCampaign($campaignId: Int!, $input: InputBulkMessagingCampaign) {
    updateBulkMessagingCampaign(campaignId: $campaignId, input: $input) {
      message
      data {
        id
        campaignName
        isDraft
        messageTemplate
        mediaCount
        campaignType
        messagingType
        a2pCampaignId
        a2pCampaignType
        a2pSampleId
        status
        scheduleType
        isScheduled
        initiatedAt
        scheduledAt
        maxOccurrence
        endAt
        attachments {
          id
          fileName
          mimetype
          fileSize
          fileUrl
        }
        metrics {
          key
          value
        }
        createdBy {
          id
          name
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          roles {
            id
            label
            slug
            level
            isActive
            isDefault
            position
          }
        }
        createdAt
        deliverySummary {
          totalSent
          totalRecipients
          runStatus
        }
      }
    }
  }
`;
export type UpdateBulkMessagingCampaignMutationFn = Apollo.MutationFunction<
  UpdateBulkMessagingCampaignMutation,
  UpdateBulkMessagingCampaignMutationVariables
>;

/**
 * __useUpdateBulkMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateBulkMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkMessagingCampaignMutation, { data, loading, error }] = useUpdateBulkMessagingCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBulkMessagingCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBulkMessagingCampaignMutation,
    UpdateBulkMessagingCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateBulkMessagingCampaignMutation, UpdateBulkMessagingCampaignMutationVariables>(
    UpdateBulkMessagingCampaignDocument,
    options
  );
}
export type UpdateBulkMessagingCampaignMutationHookResult = ReturnType<typeof useUpdateBulkMessagingCampaignMutation>;
export type UpdateBulkMessagingCampaignMutationResult = Apollo.MutationResult<UpdateBulkMessagingCampaignMutation>;
export type UpdateBulkMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<
  UpdateBulkMessagingCampaignMutation,
  UpdateBulkMessagingCampaignMutationVariables
>;
export const RemoveWorkspaceUserWithDispositionDocument = gql`
  mutation RemoveWorkspaceUserWithDisposition($input: RemoveMemberDispositionInput!) {
    removeWorkspaceUserWithDisposition(input: $input) {
      message
    }
  }
`;
export type RemoveWorkspaceUserWithDispositionMutationFn = Apollo.MutationFunction<
  RemoveWorkspaceUserWithDispositionMutation,
  RemoveWorkspaceUserWithDispositionMutationVariables
>;

/**
 * __useRemoveWorkspaceUserWithDispositionMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceUserWithDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceUserWithDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceUserWithDispositionMutation, { data, loading, error }] = useRemoveWorkspaceUserWithDispositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkspaceUserWithDispositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveWorkspaceUserWithDispositionMutation,
    RemoveWorkspaceUserWithDispositionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveWorkspaceUserWithDispositionMutation,
    RemoveWorkspaceUserWithDispositionMutationVariables
  >(RemoveWorkspaceUserWithDispositionDocument, options);
}
export type RemoveWorkspaceUserWithDispositionMutationHookResult = ReturnType<
  typeof useRemoveWorkspaceUserWithDispositionMutation
>;
export type RemoveWorkspaceUserWithDispositionMutationResult =
  Apollo.MutationResult<RemoveWorkspaceUserWithDispositionMutation>;
export type RemoveWorkspaceUserWithDispositionMutationOptions = Apollo.BaseMutationOptions<
  RemoveWorkspaceUserWithDispositionMutation,
  RemoveWorkspaceUserWithDispositionMutationVariables
>;
export const DeleteBulkMessagingCampaignDocument = gql`
  mutation DeleteBulkMessagingCampaign($campaignId: Int!) {
    deleteBulkMessagingCampaign(campaignId: $campaignId) {
      message
    }
  }
`;
export type DeleteBulkMessagingCampaignMutationFn = Apollo.MutationFunction<
  DeleteBulkMessagingCampaignMutation,
  DeleteBulkMessagingCampaignMutationVariables
>;

/**
 * __useDeleteBulkMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteBulkMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBulkMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBulkMessagingCampaignMutation, { data, loading, error }] = useDeleteBulkMessagingCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteBulkMessagingCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteBulkMessagingCampaignMutation,
    DeleteBulkMessagingCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteBulkMessagingCampaignMutation, DeleteBulkMessagingCampaignMutationVariables>(
    DeleteBulkMessagingCampaignDocument,
    options
  );
}
export type DeleteBulkMessagingCampaignMutationHookResult = ReturnType<typeof useDeleteBulkMessagingCampaignMutation>;
export type DeleteBulkMessagingCampaignMutationResult = Apollo.MutationResult<DeleteBulkMessagingCampaignMutation>;
export type DeleteBulkMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<
  DeleteBulkMessagingCampaignMutation,
  DeleteBulkMessagingCampaignMutationVariables
>;
export const DuplicateBulkMessagingCampaignDocument = gql`
  mutation DuplicateBulkMessagingCampaign($campaignId: Int!) {
    duplicateBulkMessagingCampaign(campaignId: $campaignId) {
      message
    }
  }
`;
export type DuplicateBulkMessagingCampaignMutationFn = Apollo.MutationFunction<
  DuplicateBulkMessagingCampaignMutation,
  DuplicateBulkMessagingCampaignMutationVariables
>;

/**
 * __useDuplicateBulkMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useDuplicateBulkMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateBulkMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateBulkMessagingCampaignMutation, { data, loading, error }] = useDuplicateBulkMessagingCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDuplicateBulkMessagingCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateBulkMessagingCampaignMutation,
    DuplicateBulkMessagingCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DuplicateBulkMessagingCampaignMutation, DuplicateBulkMessagingCampaignMutationVariables>(
    DuplicateBulkMessagingCampaignDocument,
    options
  );
}
export type DuplicateBulkMessagingCampaignMutationHookResult = ReturnType<
  typeof useDuplicateBulkMessagingCampaignMutation
>;
export type DuplicateBulkMessagingCampaignMutationResult =
  Apollo.MutationResult<DuplicateBulkMessagingCampaignMutation>;
export type DuplicateBulkMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<
  DuplicateBulkMessagingCampaignMutation,
  DuplicateBulkMessagingCampaignMutationVariables
>;
export const PauseRecurringBulkMessagingCampaignDocument = gql`
  mutation PauseRecurringBulkMessagingCampaign($campaignId: Int!) {
    pauseRecurringBulkMessagingCampaign(campaignId: $campaignId) {
      message
    }
  }
`;
export type PauseRecurringBulkMessagingCampaignMutationFn = Apollo.MutationFunction<
  PauseRecurringBulkMessagingCampaignMutation,
  PauseRecurringBulkMessagingCampaignMutationVariables
>;

/**
 * __usePauseRecurringBulkMessagingCampaignMutation__
 *
 * To run a mutation, you first call `usePauseRecurringBulkMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseRecurringBulkMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseRecurringBulkMessagingCampaignMutation, { data, loading, error }] = usePauseRecurringBulkMessagingCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function usePauseRecurringBulkMessagingCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PauseRecurringBulkMessagingCampaignMutation,
    PauseRecurringBulkMessagingCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PauseRecurringBulkMessagingCampaignMutation,
    PauseRecurringBulkMessagingCampaignMutationVariables
  >(PauseRecurringBulkMessagingCampaignDocument, options);
}
export type PauseRecurringBulkMessagingCampaignMutationHookResult = ReturnType<
  typeof usePauseRecurringBulkMessagingCampaignMutation
>;
export type PauseRecurringBulkMessagingCampaignMutationResult =
  Apollo.MutationResult<PauseRecurringBulkMessagingCampaignMutation>;
export type PauseRecurringBulkMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<
  PauseRecurringBulkMessagingCampaignMutation,
  PauseRecurringBulkMessagingCampaignMutationVariables
>;
export const ResumeRecurringBulkMessagingCampaignDocument = gql`
  mutation ResumeRecurringBulkMessagingCampaign($campaignId: Int!) {
    resumeRecurringBulkMessagingCampaign(campaignId: $campaignId) {
      message
    }
  }
`;
export type ResumeRecurringBulkMessagingCampaignMutationFn = Apollo.MutationFunction<
  ResumeRecurringBulkMessagingCampaignMutation,
  ResumeRecurringBulkMessagingCampaignMutationVariables
>;

/**
 * __useResumeRecurringBulkMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useResumeRecurringBulkMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeRecurringBulkMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeRecurringBulkMessagingCampaignMutation, { data, loading, error }] = useResumeRecurringBulkMessagingCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useResumeRecurringBulkMessagingCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResumeRecurringBulkMessagingCampaignMutation,
    ResumeRecurringBulkMessagingCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResumeRecurringBulkMessagingCampaignMutation,
    ResumeRecurringBulkMessagingCampaignMutationVariables
  >(ResumeRecurringBulkMessagingCampaignDocument, options);
}
export type ResumeRecurringBulkMessagingCampaignMutationHookResult = ReturnType<
  typeof useResumeRecurringBulkMessagingCampaignMutation
>;
export type ResumeRecurringBulkMessagingCampaignMutationResult =
  Apollo.MutationResult<ResumeRecurringBulkMessagingCampaignMutation>;
export type ResumeRecurringBulkMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<
  ResumeRecurringBulkMessagingCampaignMutation,
  ResumeRecurringBulkMessagingCampaignMutationVariables
>;
export const TerminateRecurringBulkMessagingCampaignDocument = gql`
  mutation TerminateRecurringBulkMessagingCampaign($campaignId: Int!) {
    terminateRecurringBulkMessagingCampaign(campaignId: $campaignId) {
      message
    }
  }
`;
export type TerminateRecurringBulkMessagingCampaignMutationFn = Apollo.MutationFunction<
  TerminateRecurringBulkMessagingCampaignMutation,
  TerminateRecurringBulkMessagingCampaignMutationVariables
>;

/**
 * __useTerminateRecurringBulkMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useTerminateRecurringBulkMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateRecurringBulkMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateRecurringBulkMessagingCampaignMutation, { data, loading, error }] = useTerminateRecurringBulkMessagingCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useTerminateRecurringBulkMessagingCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TerminateRecurringBulkMessagingCampaignMutation,
    TerminateRecurringBulkMessagingCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TerminateRecurringBulkMessagingCampaignMutation,
    TerminateRecurringBulkMessagingCampaignMutationVariables
  >(TerminateRecurringBulkMessagingCampaignDocument, options);
}
export type TerminateRecurringBulkMessagingCampaignMutationHookResult = ReturnType<
  typeof useTerminateRecurringBulkMessagingCampaignMutation
>;
export type TerminateRecurringBulkMessagingCampaignMutationResult =
  Apollo.MutationResult<TerminateRecurringBulkMessagingCampaignMutation>;
export type TerminateRecurringBulkMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<
  TerminateRecurringBulkMessagingCampaignMutation,
  TerminateRecurringBulkMessagingCampaignMutationVariables
>;
export const SetCallSettingEmailAlertsDocument = gql`
  mutation SetCallSettingEmailAlerts($setCallSettingEmailAlertsId: Int!, $input: InputEmailAlerts!) {
    setCallSettingEmailAlerts(id: $setCallSettingEmailAlertsId, input: $input) {
      message
      data {
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
      }
    }
  }
`;
export type SetCallSettingEmailAlertsMutationFn = Apollo.MutationFunction<
  SetCallSettingEmailAlertsMutation,
  SetCallSettingEmailAlertsMutationVariables
>;

/**
 * __useSetCallSettingEmailAlertsMutation__
 *
 * To run a mutation, you first call `useSetCallSettingEmailAlertsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallSettingEmailAlertsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallSettingEmailAlertsMutation, { data, loading, error }] = useSetCallSettingEmailAlertsMutation({
 *   variables: {
 *      setCallSettingEmailAlertsId: // value for 'setCallSettingEmailAlertsId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCallSettingEmailAlertsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallSettingEmailAlertsMutation,
    SetCallSettingEmailAlertsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCallSettingEmailAlertsMutation, SetCallSettingEmailAlertsMutationVariables>(
    SetCallSettingEmailAlertsDocument,
    options
  );
}
export type SetCallSettingEmailAlertsMutationHookResult = ReturnType<typeof useSetCallSettingEmailAlertsMutation>;
export type SetCallSettingEmailAlertsMutationResult = Apollo.MutationResult<SetCallSettingEmailAlertsMutation>;
export type SetCallSettingEmailAlertsMutationOptions = Apollo.BaseMutationOptions<
  SetCallSettingEmailAlertsMutation,
  SetCallSettingEmailAlertsMutationVariables
>;
export const SetChannelSettingEmailAlertsDocument = gql`
  mutation SetChannelSettingEmailAlerts($channelId: Int!, $input: InputEmailAlerts!) {
    setChannelSettingEmailAlerts(channelId: $channelId, input: $input) {
      message
      data {
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
      }
    }
  }
`;
export type SetChannelSettingEmailAlertsMutationFn = Apollo.MutationFunction<
  SetChannelSettingEmailAlertsMutation,
  SetChannelSettingEmailAlertsMutationVariables
>;

/**
 * __useSetChannelSettingEmailAlertsMutation__
 *
 * To run a mutation, you first call `useSetChannelSettingEmailAlertsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChannelSettingEmailAlertsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChannelSettingEmailAlertsMutation, { data, loading, error }] = useSetChannelSettingEmailAlertsMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChannelSettingEmailAlertsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChannelSettingEmailAlertsMutation,
    SetChannelSettingEmailAlertsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetChannelSettingEmailAlertsMutation, SetChannelSettingEmailAlertsMutationVariables>(
    SetChannelSettingEmailAlertsDocument,
    options
  );
}
export type SetChannelSettingEmailAlertsMutationHookResult = ReturnType<typeof useSetChannelSettingEmailAlertsMutation>;
export type SetChannelSettingEmailAlertsMutationResult = Apollo.MutationResult<SetChannelSettingEmailAlertsMutation>;
export type SetChannelSettingEmailAlertsMutationOptions = Apollo.BaseMutationOptions<
  SetChannelSettingEmailAlertsMutation,
  SetChannelSettingEmailAlertsMutationVariables
>;
export const SetAutoRechargeConfigV2Document = gql`
  mutation SetAutoRechargeConfigV2($input: InputAutoRechargeConfig) {
    setAutoRechargeConfigV2(input: $input) {
      message
      data {
        enabled
        creditThreshold
        credit
        targetBalance
        isDisableAllowed
      }
    }
  }
`;
export type SetAutoRechargeConfigV2MutationFn = Apollo.MutationFunction<
  SetAutoRechargeConfigV2Mutation,
  SetAutoRechargeConfigV2MutationVariables
>;

/**
 * __useSetAutoRechargeConfigV2Mutation__
 *
 * To run a mutation, you first call `useSetAutoRechargeConfigV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAutoRechargeConfigV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAutoRechargeConfigV2Mutation, { data, loading, error }] = useSetAutoRechargeConfigV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAutoRechargeConfigV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<SetAutoRechargeConfigV2Mutation, SetAutoRechargeConfigV2MutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetAutoRechargeConfigV2Mutation, SetAutoRechargeConfigV2MutationVariables>(
    SetAutoRechargeConfigV2Document,
    options
  );
}
export type SetAutoRechargeConfigV2MutationHookResult = ReturnType<typeof useSetAutoRechargeConfigV2Mutation>;
export type SetAutoRechargeConfigV2MutationResult = Apollo.MutationResult<SetAutoRechargeConfigV2Mutation>;
export type SetAutoRechargeConfigV2MutationOptions = Apollo.BaseMutationOptions<
  SetAutoRechargeConfigV2Mutation,
  SetAutoRechargeConfigV2MutationVariables
>;
export const ReleaseChannelsDocument = gql`
  mutation ReleaseChannels($input: InputReleaseChannels) {
    releaseChannels(input: $input) {
      message
    }
  }
`;
export type ReleaseChannelsMutationFn = Apollo.MutationFunction<
  ReleaseChannelsMutation,
  ReleaseChannelsMutationVariables
>;

/**
 * __useReleaseChannelsMutation__
 *
 * To run a mutation, you first call `useReleaseChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseChannelsMutation, { data, loading, error }] = useReleaseChannelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleaseChannelsMutation(
  baseOptions?: Apollo.MutationHookOptions<ReleaseChannelsMutation, ReleaseChannelsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReleaseChannelsMutation, ReleaseChannelsMutationVariables>(
    ReleaseChannelsDocument,
    options
  );
}
export type ReleaseChannelsMutationHookResult = ReturnType<typeof useReleaseChannelsMutation>;
export type ReleaseChannelsMutationResult = Apollo.MutationResult<ReleaseChannelsMutation>;
export type ReleaseChannelsMutationOptions = Apollo.BaseMutationOptions<
  ReleaseChannelsMutation,
  ReleaseChannelsMutationVariables
>;
export const PurchaseNumbersDocument = gql`
  mutation PurchaseNumbers($input: InputPurchaseNumbers) {
    purchaseNumbers(input: $input) {
      message
      data {
        duplicates
      }
    }
  }
`;
export type PurchaseNumbersMutationFn = Apollo.MutationFunction<
  PurchaseNumbersMutation,
  PurchaseNumbersMutationVariables
>;

/**
 * __usePurchaseNumbersMutation__
 *
 * To run a mutation, you first call `usePurchaseNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseNumbersMutation, { data, loading, error }] = usePurchaseNumbersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseNumbersMutation(
  baseOptions?: Apollo.MutationHookOptions<PurchaseNumbersMutation, PurchaseNumbersMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PurchaseNumbersMutation, PurchaseNumbersMutationVariables>(
    PurchaseNumbersDocument,
    options
  );
}
export type PurchaseNumbersMutationHookResult = ReturnType<typeof usePurchaseNumbersMutation>;
export type PurchaseNumbersMutationResult = Apollo.MutationResult<PurchaseNumbersMutation>;
export type PurchaseNumbersMutationOptions = Apollo.BaseMutationOptions<
  PurchaseNumbersMutation,
  PurchaseNumbersMutationVariables
>;
export const ConfirmPaymentOrderDocument = gql`
  mutation ConfirmPaymentOrder($paymentOrderId: Int!) {
    confirmPaymentOrder(paymentOrderId: $paymentOrderId) {
      message
      data {
        id
        status
        lienStatus
      }
    }
  }
`;
export type ConfirmPaymentOrderMutationFn = Apollo.MutationFunction<
  ConfirmPaymentOrderMutation,
  ConfirmPaymentOrderMutationVariables
>;

/**
 * __useConfirmPaymentOrderMutation__
 *
 * To run a mutation, you first call `useConfirmPaymentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPaymentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPaymentOrderMutation, { data, loading, error }] = useConfirmPaymentOrderMutation({
 *   variables: {
 *      paymentOrderId: // value for 'paymentOrderId'
 *   },
 * });
 */
export function useConfirmPaymentOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<ConfirmPaymentOrderMutation, ConfirmPaymentOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmPaymentOrderMutation, ConfirmPaymentOrderMutationVariables>(
    ConfirmPaymentOrderDocument,
    options
  );
}
export type ConfirmPaymentOrderMutationHookResult = ReturnType<typeof useConfirmPaymentOrderMutation>;
export type ConfirmPaymentOrderMutationResult = Apollo.MutationResult<ConfirmPaymentOrderMutation>;
export type ConfirmPaymentOrderMutationOptions = Apollo.BaseMutationOptions<
  ConfirmPaymentOrderMutation,
  ConfirmPaymentOrderMutationVariables
>;
export const RejectPaymentOrderDocument = gql`
  mutation RejectPaymentOrder($input: InputRejectPaymentOrder!) {
    rejectPaymentOrder(input: $input) {
      message
      data {
        id
        status
        lienStatus
      }
    }
  }
`;
export type RejectPaymentOrderMutationFn = Apollo.MutationFunction<
  RejectPaymentOrderMutation,
  RejectPaymentOrderMutationVariables
>;

/**
 * __useRejectPaymentOrderMutation__
 *
 * To run a mutation, you first call `useRejectPaymentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPaymentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPaymentOrderMutation, { data, loading, error }] = useRejectPaymentOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectPaymentOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<RejectPaymentOrderMutation, RejectPaymentOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RejectPaymentOrderMutation, RejectPaymentOrderMutationVariables>(
    RejectPaymentOrderDocument,
    options
  );
}
export type RejectPaymentOrderMutationHookResult = ReturnType<typeof useRejectPaymentOrderMutation>;
export type RejectPaymentOrderMutationResult = Apollo.MutationResult<RejectPaymentOrderMutation>;
export type RejectPaymentOrderMutationOptions = Apollo.BaseMutationOptions<
  RejectPaymentOrderMutation,
  RejectPaymentOrderMutationVariables
>;
export const RemoveChannelRemovalScheduleDocument = gql`
  mutation RemoveChannelRemovalSchedule($channelId: Int!) {
    removeChannelRemovalSchedule(channelId: $channelId) {
      message
    }
  }
`;
export type RemoveChannelRemovalScheduleMutationFn = Apollo.MutationFunction<
  RemoveChannelRemovalScheduleMutation,
  RemoveChannelRemovalScheduleMutationVariables
>;

/**
 * __useRemoveChannelRemovalScheduleMutation__
 *
 * To run a mutation, you first call `useRemoveChannelRemovalScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChannelRemovalScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChannelRemovalScheduleMutation, { data, loading, error }] = useRemoveChannelRemovalScheduleMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useRemoveChannelRemovalScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveChannelRemovalScheduleMutation,
    RemoveChannelRemovalScheduleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveChannelRemovalScheduleMutation, RemoveChannelRemovalScheduleMutationVariables>(
    RemoveChannelRemovalScheduleDocument,
    options
  );
}
export type RemoveChannelRemovalScheduleMutationHookResult = ReturnType<typeof useRemoveChannelRemovalScheduleMutation>;
export type RemoveChannelRemovalScheduleMutationResult = Apollo.MutationResult<RemoveChannelRemovalScheduleMutation>;
export type RemoveChannelRemovalScheduleMutationOptions = Apollo.BaseMutationOptions<
  RemoveChannelRemovalScheduleMutation,
  RemoveChannelRemovalScheduleMutationVariables
>;
export const GetWalletDetailsV2Document = gql`
  query GetWalletDetailsV2 {
    getWalletDetailsV2 {
      message
      data {
        amount
        isAutoRechargeEnabled
      }
    }
  }
`;

/**
 * __useGetWalletDetailsV2Query__
 *
 * To run a query within a React component, call `useGetWalletDetailsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletDetailsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletDetailsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetWalletDetailsV2Query(
  baseOptions?: Apollo.QueryHookOptions<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>(
    GetWalletDetailsV2Document,
    options
  );
}
export function useGetWalletDetailsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>(
    GetWalletDetailsV2Document,
    options
  );
}
// @ts-ignore
export function useGetWalletDetailsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>;
export function useGetWalletDetailsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>
): Apollo.UseSuspenseQueryResult<GetWalletDetailsV2Query | undefined, GetWalletDetailsV2QueryVariables>;
export function useGetWalletDetailsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWalletDetailsV2Query, GetWalletDetailsV2QueryVariables>(
    GetWalletDetailsV2Document,
    options
  );
}
export type GetWalletDetailsV2QueryHookResult = ReturnType<typeof useGetWalletDetailsV2Query>;
export type GetWalletDetailsV2LazyQueryHookResult = ReturnType<typeof useGetWalletDetailsV2LazyQuery>;
export type GetWalletDetailsV2SuspenseQueryHookResult = ReturnType<typeof useGetWalletDetailsV2SuspenseQuery>;
export type GetWalletDetailsV2QueryResult = Apollo.QueryResult<
  GetWalletDetailsV2Query,
  GetWalletDetailsV2QueryVariables
>;
export const authMeDocument = gql`
  query authMe {
    authMe {
      message
      data {
        lastSession {
          platform
          id
          authType
          userAgent
        }
        user {
          lastPasswordResetAt
          id
          name
          email
          phoneNumber
          language
          identityProvider
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          coverProfilePicture {
            createdAt
            id
            key
            mimetype
            originalname
            size
            url
          }
          roles {
            id
            label
            slug
            level
            isActive
            isDefault
          }
          uiVersion
          mfaTotpEnabled
          mfaEmailEnabled
          mfaReminderAt
        }
        userWorkspaceRole {
          role {
            id
            isActive
            label
            level
            position
            slug
          }
        }
      }
    }
  }
`;

/**
 * __useauthMeQuery__
 *
 * To run a query within a React component, call `useauthMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useauthMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useauthMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useauthMeQuery(baseOptions?: Apollo.QueryHookOptions<authMeQuery, authMeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<authMeQuery, authMeQueryVariables>(authMeDocument, options);
}
export function useauthMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<authMeQuery, authMeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<authMeQuery, authMeQueryVariables>(authMeDocument, options);
}
// @ts-ignore
export function useauthMeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<authMeQuery, authMeQueryVariables>
): Apollo.UseSuspenseQueryResult<authMeQuery, authMeQueryVariables>;
export function useauthMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<authMeQuery, authMeQueryVariables>
): Apollo.UseSuspenseQueryResult<authMeQuery | undefined, authMeQueryVariables>;
export function useauthMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<authMeQuery, authMeQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<authMeQuery, authMeQueryVariables>(authMeDocument, options);
}
export type authMeQueryHookResult = ReturnType<typeof useauthMeQuery>;
export type authMeLazyQueryHookResult = ReturnType<typeof useauthMeLazyQuery>;
export type authMeSuspenseQueryHookResult = ReturnType<typeof useauthMeSuspenseQuery>;
export type authMeQueryResult = Apollo.QueryResult<authMeQuery, authMeQueryVariables>;
export const aiDashboardIntentDocument = gql`
  query aiDashboardIntent(
    $intentType: String!
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $offset: Int
    $order: String
    $sort: SortEnum
  ) {
    aiDashboardIntent(
      intentType: $intentType
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      offset: $offset
      order: $order
      sort: $sort
    ) {
      message
      count
      edges {
        intent
        currentCount
        currentSentiment
        previousCount
        previousSentiment
        callVolume
      }
    }
  }
`;

/**
 * __useaiDashboardIntentQuery__
 *
 * To run a query within a React component, call `useaiDashboardIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useaiDashboardIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useaiDashboardIntentQuery({
 *   variables: {
 *      intentType: // value for 'intentType'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useaiDashboardIntentQuery(
  baseOptions: Apollo.QueryHookOptions<aiDashboardIntentQuery, aiDashboardIntentQueryVariables> &
    ({ variables: aiDashboardIntentQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>(aiDashboardIntentDocument, options);
}
export function useaiDashboardIntentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>(
    aiDashboardIntentDocument,
    options
  );
}
// @ts-ignore
export function useaiDashboardIntentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>
): Apollo.UseSuspenseQueryResult<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>;
export function useaiDashboardIntentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>
): Apollo.UseSuspenseQueryResult<aiDashboardIntentQuery | undefined, aiDashboardIntentQueryVariables>;
export function useaiDashboardIntentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>(
    aiDashboardIntentDocument,
    options
  );
}
export type aiDashboardIntentQueryHookResult = ReturnType<typeof useaiDashboardIntentQuery>;
export type aiDashboardIntentLazyQueryHookResult = ReturnType<typeof useaiDashboardIntentLazyQuery>;
export type aiDashboardIntentSuspenseQueryHookResult = ReturnType<typeof useaiDashboardIntentSuspenseQuery>;
export type aiDashboardIntentQueryResult = Apollo.QueryResult<aiDashboardIntentQuery, aiDashboardIntentQueryVariables>;
export const workspaceAuthMeV2Document = gql`
  query workspaceAuthMeV2 {
    workspaceAuthMeV2 {
      message
      data {
        v2MigratedAt
        country {
          id
          name
          dialingCode
          alphaTwoCode
        }
        timezoneValue
        unreadCountWorkspace
        workspaceDetails {
          planPrice {
            amount
          }
          documents {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
        }
        id
        label
        status
        timezone
        timezoneId
        timezoneLabel
        logo {
          id
          url
        }
        providerAccount {
          systemSuspend
          status
        }
        owner {
          phoneNumber
          name
          email
          id
          profilePicture {
            id
            url
          }
          language
          roles {
            id
            label
          }
          workspaces {
            providerAccount {
              systemSuspend
              status
            }
          }
        }
        subscription {
          status
          transactionDate
        }
        currentUserWorkspace {
          id
          status
          identity
          workspace {
            id
            logo {
              id
              url
            }
          }
        }
        kycVerified
        hasCompleted
        preferredContactMethodReminderAt
      }
    }
  }
`;

/**
 * __useworkspaceAuthMeV2Query__
 *
 * To run a query within a React component, call `useworkspaceAuthMeV2Query` and pass it any options that fit your needs.
 * When your component renders, `useworkspaceAuthMeV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useworkspaceAuthMeV2Query({
 *   variables: {
 *   },
 * });
 */
export function useworkspaceAuthMeV2Query(
  baseOptions?: Apollo.QueryHookOptions<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>(workspaceAuthMeV2Document, options);
}
export function useworkspaceAuthMeV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>(
    workspaceAuthMeV2Document,
    options
  );
}
// @ts-ignore
export function useworkspaceAuthMeV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>
): Apollo.UseSuspenseQueryResult<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>;
export function useworkspaceAuthMeV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>
): Apollo.UseSuspenseQueryResult<workspaceAuthMeV2Query | undefined, workspaceAuthMeV2QueryVariables>;
export function useworkspaceAuthMeV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>(
    workspaceAuthMeV2Document,
    options
  );
}
export type workspaceAuthMeV2QueryHookResult = ReturnType<typeof useworkspaceAuthMeV2Query>;
export type workspaceAuthMeV2LazyQueryHookResult = ReturnType<typeof useworkspaceAuthMeV2LazyQuery>;
export type workspaceAuthMeV2SuspenseQueryHookResult = ReturnType<typeof useworkspaceAuthMeV2SuspenseQuery>;
export type workspaceAuthMeV2QueryResult = Apollo.QueryResult<workspaceAuthMeV2Query, workspaceAuthMeV2QueryVariables>;
export const NumberReportAnalyticDocument = gql`
  query NumberReportAnalytic($channelId: Int, $fromDate: DateTime, $toDate: DateTime) {
    numberReportAnalytic(channelId: $channelId, fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        callType
        count
        percentage
      }
    }
  }
`;

/**
 * __useNumberReportAnalyticQuery__
 *
 * To run a query within a React component, call `useNumberReportAnalyticQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberReportAnalyticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberReportAnalyticQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useNumberReportAnalyticQuery(
  baseOptions?: Apollo.QueryHookOptions<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>(
    NumberReportAnalyticDocument,
    options
  );
}
export function useNumberReportAnalyticLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>(
    NumberReportAnalyticDocument,
    options
  );
}
// @ts-ignore
export function useNumberReportAnalyticSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>
): Apollo.UseSuspenseQueryResult<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>;
export function useNumberReportAnalyticSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>
): Apollo.UseSuspenseQueryResult<NumberReportAnalyticQuery | undefined, NumberReportAnalyticQueryVariables>;
export function useNumberReportAnalyticSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NumberReportAnalyticQuery, NumberReportAnalyticQueryVariables>(
    NumberReportAnalyticDocument,
    options
  );
}
export type NumberReportAnalyticQueryHookResult = ReturnType<typeof useNumberReportAnalyticQuery>;
export type NumberReportAnalyticLazyQueryHookResult = ReturnType<typeof useNumberReportAnalyticLazyQuery>;
export type NumberReportAnalyticSuspenseQueryHookResult = ReturnType<typeof useNumberReportAnalyticSuspenseQuery>;
export type NumberReportAnalyticQueryResult = Apollo.QueryResult<
  NumberReportAnalyticQuery,
  NumberReportAnalyticQueryVariables
>;
export const DashboardNumberAnalyticsDocument = gql`
  query DashboardNumberAnalytics(
    $fromDate: DateTime!
    $toDate: DateTime!
    $offset: Int
    $sort: SortEnum
    $order: String
    $query: String
  ) {
    dashboardNumberAnalytics(
      fromDate: $fromDate
      toDate: $toDate
      offset: $offset
      sort: $sort
      order: $order
      query: $query
    ) {
      message
      edges {
        id
        phoneNumber
        isActive
        members {
          id
          name
          profileUrl
        }
        teams {
          id
          name
        }
        totalCalls
        duration
        country {
          id
          name
          slug
          dialingCode
          alphaTwoCode
          alphaThreeCode
          numeric
          flag
        }
        emergencyStatus
        channelName
        strategies {
          strategySlug
        }
      }
      count
    }
  }
`;

/**
 * __useDashboardNumberAnalyticsQuery__
 *
 * To run a query within a React component, call `useDashboardNumberAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardNumberAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardNumberAnalyticsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDashboardNumberAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables> &
    ({ variables: DashboardNumberAnalyticsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables>(
    DashboardNumberAnalyticsDocument,
    options
  );
}
export function useDashboardNumberAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables>(
    DashboardNumberAnalyticsDocument,
    options
  );
}
// @ts-ignore
export function useDashboardNumberAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables>;
export function useDashboardNumberAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardNumberAnalyticsQuery | undefined, DashboardNumberAnalyticsQueryVariables>;
export function useDashboardNumberAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardNumberAnalyticsQuery, DashboardNumberAnalyticsQueryVariables>(
    DashboardNumberAnalyticsDocument,
    options
  );
}
export type DashboardNumberAnalyticsQueryHookResult = ReturnType<typeof useDashboardNumberAnalyticsQuery>;
export type DashboardNumberAnalyticsLazyQueryHookResult = ReturnType<typeof useDashboardNumberAnalyticsLazyQuery>;
export type DashboardNumberAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useDashboardNumberAnalyticsSuspenseQuery
>;
export type DashboardNumberAnalyticsQueryResult = Apollo.QueryResult<
  DashboardNumberAnalyticsQuery,
  DashboardNumberAnalyticsQueryVariables
>;
export const aiDashboardMemberPerformanceDocument = gql`
  query aiDashboardMemberPerformance(
    $sentimentType: String!
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $offset: Int
  ) {
    aiDashboardMemberPerformance(
      sentimentType: $sentimentType
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      offset: $offset
    ) {
      message
      count
      data {
        userName
        totalCallCount
        percentage
        userWorkspaceId
        transcribeCallCount
        transcribeSpecificSentimentCount
        averageDuration
      }
    }
  }
`;

/**
 * __useaiDashboardMemberPerformanceQuery__
 *
 * To run a query within a React component, call `useaiDashboardMemberPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useaiDashboardMemberPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useaiDashboardMemberPerformanceQuery({
 *   variables: {
 *      sentimentType: // value for 'sentimentType'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useaiDashboardMemberPerformanceQuery(
  baseOptions: Apollo.QueryHookOptions<aiDashboardMemberPerformanceQuery, aiDashboardMemberPerformanceQueryVariables> &
    ({ variables: aiDashboardMemberPerformanceQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<aiDashboardMemberPerformanceQuery, aiDashboardMemberPerformanceQueryVariables>(
    aiDashboardMemberPerformanceDocument,
    options
  );
}
export function useaiDashboardMemberPerformanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    aiDashboardMemberPerformanceQuery,
    aiDashboardMemberPerformanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<aiDashboardMemberPerformanceQuery, aiDashboardMemberPerformanceQueryVariables>(
    aiDashboardMemberPerformanceDocument,
    options
  );
}
// @ts-ignore
export function useaiDashboardMemberPerformanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    aiDashboardMemberPerformanceQuery,
    aiDashboardMemberPerformanceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<aiDashboardMemberPerformanceQuery, aiDashboardMemberPerformanceQueryVariables>;
export function useaiDashboardMemberPerformanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<aiDashboardMemberPerformanceQuery, aiDashboardMemberPerformanceQueryVariables>
): Apollo.UseSuspenseQueryResult<
  aiDashboardMemberPerformanceQuery | undefined,
  aiDashboardMemberPerformanceQueryVariables
>;
export function useaiDashboardMemberPerformanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<aiDashboardMemberPerformanceQuery, aiDashboardMemberPerformanceQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<aiDashboardMemberPerformanceQuery, aiDashboardMemberPerformanceQueryVariables>(
    aiDashboardMemberPerformanceDocument,
    options
  );
}
export type aiDashboardMemberPerformanceQueryHookResult = ReturnType<typeof useaiDashboardMemberPerformanceQuery>;
export type aiDashboardMemberPerformanceLazyQueryHookResult = ReturnType<
  typeof useaiDashboardMemberPerformanceLazyQuery
>;
export type aiDashboardMemberPerformanceSuspenseQueryHookResult = ReturnType<
  typeof useaiDashboardMemberPerformanceSuspenseQuery
>;
export type aiDashboardMemberPerformanceQueryResult = Apollo.QueryResult<
  aiDashboardMemberPerformanceQuery,
  aiDashboardMemberPerformanceQueryVariables
>;
export const MemberDashboardReportAnalyticsDocument = gql`
  query MemberDashboardReportAnalytics(
    $fromDate: DateTime!
    $toDate: DateTime!
    $limit: Int
    $order: String
    $sort: SortEnum
    $offset: Int
    $query: String
  ) {
    memberDashboardReportAnalytics(
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      order: $order
      sort: $sort
      offset: $offset
      query: $query
    ) {
      message
      edges {
        id
        role
        status
        isActive
        teams {
          id
          name
        }
        user {
          id
          name
          phoneNumber
          profileUrl
        }
        channel {
          id
          friendlyName
          phoneNumber
        }
        outbound
        missed
        inbound
        averageCallDuration
        totalCallDuration
      }
      count
    }
  }
`;

/**
 * __useMemberDashboardReportAnalyticsQuery__
 *
 * To run a query within a React component, call `useMemberDashboardReportAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDashboardReportAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDashboardReportAnalyticsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMemberDashboardReportAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberDashboardReportAnalyticsQuery,
    MemberDashboardReportAnalyticsQueryVariables
  > &
    ({ variables: MemberDashboardReportAnalyticsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberDashboardReportAnalyticsQuery, MemberDashboardReportAnalyticsQueryVariables>(
    MemberDashboardReportAnalyticsDocument,
    options
  );
}
export function useMemberDashboardReportAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberDashboardReportAnalyticsQuery,
    MemberDashboardReportAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberDashboardReportAnalyticsQuery, MemberDashboardReportAnalyticsQueryVariables>(
    MemberDashboardReportAnalyticsDocument,
    options
  );
}
// @ts-ignore
export function useMemberDashboardReportAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MemberDashboardReportAnalyticsQuery,
    MemberDashboardReportAnalyticsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<MemberDashboardReportAnalyticsQuery, MemberDashboardReportAnalyticsQueryVariables>;
export function useMemberDashboardReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberDashboardReportAnalyticsQuery, MemberDashboardReportAnalyticsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  MemberDashboardReportAnalyticsQuery | undefined,
  MemberDashboardReportAnalyticsQueryVariables
>;
export function useMemberDashboardReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberDashboardReportAnalyticsQuery, MemberDashboardReportAnalyticsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemberDashboardReportAnalyticsQuery, MemberDashboardReportAnalyticsQueryVariables>(
    MemberDashboardReportAnalyticsDocument,
    options
  );
}
export type MemberDashboardReportAnalyticsQueryHookResult = ReturnType<typeof useMemberDashboardReportAnalyticsQuery>;
export type MemberDashboardReportAnalyticsLazyQueryHookResult = ReturnType<
  typeof useMemberDashboardReportAnalyticsLazyQuery
>;
export type MemberDashboardReportAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useMemberDashboardReportAnalyticsSuspenseQuery
>;
export type MemberDashboardReportAnalyticsQueryResult = Apollo.QueryResult<
  MemberDashboardReportAnalyticsQuery,
  MemberDashboardReportAnalyticsQueryVariables
>;
export const ChannelDocument = gql`
  query Channel($channelId: Int!) {
    channel(id: $channelId) {
      data {
        id
        friendlyName
        phoneNumber
        numberType
        country {
          id
          flag
          alphaTwoCode
        }
      }
      message
    }
  }
`;

/**
 * __useChannelQuery__
 *
 * To run a query within a React component, call `useChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelQuery(
  baseOptions: Apollo.QueryHookOptions<ChannelQuery, ChannelQueryVariables> &
    ({ variables: ChannelQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelQuery, ChannelQueryVariables>(ChannelDocument, options);
}
export function useChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelQuery, ChannelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelQuery, ChannelQueryVariables>(ChannelDocument, options);
}
// @ts-ignore
export function useChannelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelQuery, ChannelQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelQuery, ChannelQueryVariables>;
export function useChannelSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelQuery, ChannelQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelQuery | undefined, ChannelQueryVariables>;
export function useChannelSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelQuery, ChannelQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelQuery, ChannelQueryVariables>(ChannelDocument, options);
}
export type ChannelQueryHookResult = ReturnType<typeof useChannelQuery>;
export type ChannelLazyQueryHookResult = ReturnType<typeof useChannelLazyQuery>;
export type ChannelSuspenseQueryHookResult = ReturnType<typeof useChannelSuspenseQuery>;
export type ChannelQueryResult = Apollo.QueryResult<ChannelQuery, ChannelQueryVariables>;
export const NumberGraphReportAnalyticsDocument = gql`
  query NumberGraphReportAnalytics($channelId: Int!, $fromDate: DateTime!, $toDate: DateTime!) {
    numberGraphReportAnalytics(channelId: $channelId, fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        year
        month
        missed
        outbound
        inbound
        totalCalls
      }
    }
  }
`;

/**
 * __useNumberGraphReportAnalyticsQuery__
 *
 * To run a query within a React component, call `useNumberGraphReportAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberGraphReportAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberGraphReportAnalyticsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useNumberGraphReportAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<NumberGraphReportAnalyticsQuery, NumberGraphReportAnalyticsQueryVariables> &
    ({ variables: NumberGraphReportAnalyticsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NumberGraphReportAnalyticsQuery, NumberGraphReportAnalyticsQueryVariables>(
    NumberGraphReportAnalyticsDocument,
    options
  );
}
export function useNumberGraphReportAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NumberGraphReportAnalyticsQuery, NumberGraphReportAnalyticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NumberGraphReportAnalyticsQuery, NumberGraphReportAnalyticsQueryVariables>(
    NumberGraphReportAnalyticsDocument,
    options
  );
}
// @ts-ignore
export function useNumberGraphReportAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NumberGraphReportAnalyticsQuery,
    NumberGraphReportAnalyticsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<NumberGraphReportAnalyticsQuery, NumberGraphReportAnalyticsQueryVariables>;
export function useNumberGraphReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NumberGraphReportAnalyticsQuery, NumberGraphReportAnalyticsQueryVariables>
): Apollo.UseSuspenseQueryResult<NumberGraphReportAnalyticsQuery | undefined, NumberGraphReportAnalyticsQueryVariables>;
export function useNumberGraphReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NumberGraphReportAnalyticsQuery, NumberGraphReportAnalyticsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NumberGraphReportAnalyticsQuery, NumberGraphReportAnalyticsQueryVariables>(
    NumberGraphReportAnalyticsDocument,
    options
  );
}
export type NumberGraphReportAnalyticsQueryHookResult = ReturnType<typeof useNumberGraphReportAnalyticsQuery>;
export type NumberGraphReportAnalyticsLazyQueryHookResult = ReturnType<typeof useNumberGraphReportAnalyticsLazyQuery>;
export type NumberGraphReportAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useNumberGraphReportAnalyticsSuspenseQuery
>;
export type NumberGraphReportAnalyticsQueryResult = Apollo.QueryResult<
  NumberGraphReportAnalyticsQuery,
  NumberGraphReportAnalyticsQueryVariables
>;
export const DashboardReportAnalyticDocument = gql`
  query DashboardReportAnalytic($fromDate: DateTime!, $toDate: DateTime!, $userWorkspaceId: Int, $channelId: Int) {
    dashboardReportAnalytic(
      fromDate: $fromDate
      toDate: $toDate
      userWorkspaceId: $userWorkspaceId
      channelId: $channelId
    ) {
      data {
        callType
        count
        percentage
      }
      message
    }
  }
`;

/**
 * __useDashboardReportAnalyticQuery__
 *
 * To run a query within a React component, call `useDashboardReportAnalyticQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardReportAnalyticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardReportAnalyticQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      userWorkspaceId: // value for 'userWorkspaceId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDashboardReportAnalyticQuery(
  baseOptions: Apollo.QueryHookOptions<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables> &
    ({ variables: DashboardReportAnalyticQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables>(
    DashboardReportAnalyticDocument,
    options
  );
}
export function useDashboardReportAnalyticLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables>(
    DashboardReportAnalyticDocument,
    options
  );
}
// @ts-ignore
export function useDashboardReportAnalyticSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables>;
export function useDashboardReportAnalyticSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardReportAnalyticQuery | undefined, DashboardReportAnalyticQueryVariables>;
export function useDashboardReportAnalyticSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardReportAnalyticQuery, DashboardReportAnalyticQueryVariables>(
    DashboardReportAnalyticDocument,
    options
  );
}
export type DashboardReportAnalyticQueryHookResult = ReturnType<typeof useDashboardReportAnalyticQuery>;
export type DashboardReportAnalyticLazyQueryHookResult = ReturnType<typeof useDashboardReportAnalyticLazyQuery>;
export type DashboardReportAnalyticSuspenseQueryHookResult = ReturnType<typeof useDashboardReportAnalyticSuspenseQuery>;
export type DashboardReportAnalyticQueryResult = Apollo.QueryResult<
  DashboardReportAnalyticQuery,
  DashboardReportAnalyticQueryVariables
>;
export const IndividualMemberDashboardReportAnalyticsDocument = gql`
  query IndividualMemberDashboardReportAnalytics(
    $fromDate: DateTime!
    $toDate: DateTime!
    $userWorkspaceId: Int!
    $limit: Int
    $order: String
    $sort: SortEnum
    $offset: Int
    $query: String
  ) {
    individualMemberDashboardReportAnalytics(
      fromDate: $fromDate
      toDate: $toDate
      userWorkspaceId: $userWorkspaceId
      limit: $limit
      order: $order
      sort: $sort
      offset: $offset
      query: $query
    ) {
      message
      count
      edges {
        id
        name
        phoneNumber
        callType
        callDate
        callDuration
      }
    }
  }
`;

/**
 * __useIndividualMemberDashboardReportAnalyticsQuery__
 *
 * To run a query within a React component, call `useIndividualMemberDashboardReportAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualMemberDashboardReportAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualMemberDashboardReportAnalyticsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      userWorkspaceId: // value for 'userWorkspaceId'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useIndividualMemberDashboardReportAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IndividualMemberDashboardReportAnalyticsQuery,
    IndividualMemberDashboardReportAnalyticsQueryVariables
  > &
    ({ variables: IndividualMemberDashboardReportAnalyticsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IndividualMemberDashboardReportAnalyticsQuery,
    IndividualMemberDashboardReportAnalyticsQueryVariables
  >(IndividualMemberDashboardReportAnalyticsDocument, options);
}
export function useIndividualMemberDashboardReportAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndividualMemberDashboardReportAnalyticsQuery,
    IndividualMemberDashboardReportAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IndividualMemberDashboardReportAnalyticsQuery,
    IndividualMemberDashboardReportAnalyticsQueryVariables
  >(IndividualMemberDashboardReportAnalyticsDocument, options);
}
// @ts-ignore
export function useIndividualMemberDashboardReportAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IndividualMemberDashboardReportAnalyticsQuery,
    IndividualMemberDashboardReportAnalyticsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IndividualMemberDashboardReportAnalyticsQuery,
  IndividualMemberDashboardReportAnalyticsQueryVariables
>;
export function useIndividualMemberDashboardReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndividualMemberDashboardReportAnalyticsQuery,
        IndividualMemberDashboardReportAnalyticsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IndividualMemberDashboardReportAnalyticsQuery | undefined,
  IndividualMemberDashboardReportAnalyticsQueryVariables
>;
export function useIndividualMemberDashboardReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndividualMemberDashboardReportAnalyticsQuery,
        IndividualMemberDashboardReportAnalyticsQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IndividualMemberDashboardReportAnalyticsQuery,
    IndividualMemberDashboardReportAnalyticsQueryVariables
  >(IndividualMemberDashboardReportAnalyticsDocument, options);
}
export type IndividualMemberDashboardReportAnalyticsQueryHookResult = ReturnType<
  typeof useIndividualMemberDashboardReportAnalyticsQuery
>;
export type IndividualMemberDashboardReportAnalyticsLazyQueryHookResult = ReturnType<
  typeof useIndividualMemberDashboardReportAnalyticsLazyQuery
>;
export type IndividualMemberDashboardReportAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useIndividualMemberDashboardReportAnalyticsSuspenseQuery
>;
export type IndividualMemberDashboardReportAnalyticsQueryResult = Apollo.QueryResult<
  IndividualMemberDashboardReportAnalyticsQuery,
  IndividualMemberDashboardReportAnalyticsQueryVariables
>;
export const NumberAggregatedReportAnalyticsDocument = gql`
  query NumberAggregatedReportAnalytics($channelId: Int!, $fromDate: DateTime!, $toDate: DateTime!) {
    numberAggregatedReportAnalytics(channelId: $channelId, fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        key
        value {
          callDuration
          percentage
        }
      }
    }
  }
`;

/**
 * __useNumberAggregatedReportAnalyticsQuery__
 *
 * To run a query within a React component, call `useNumberAggregatedReportAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberAggregatedReportAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberAggregatedReportAnalyticsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useNumberAggregatedReportAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    NumberAggregatedReportAnalyticsQuery,
    NumberAggregatedReportAnalyticsQueryVariables
  > &
    ({ variables: NumberAggregatedReportAnalyticsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NumberAggregatedReportAnalyticsQuery, NumberAggregatedReportAnalyticsQueryVariables>(
    NumberAggregatedReportAnalyticsDocument,
    options
  );
}
export function useNumberAggregatedReportAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NumberAggregatedReportAnalyticsQuery,
    NumberAggregatedReportAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NumberAggregatedReportAnalyticsQuery, NumberAggregatedReportAnalyticsQueryVariables>(
    NumberAggregatedReportAnalyticsDocument,
    options
  );
}
// @ts-ignore
export function useNumberAggregatedReportAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NumberAggregatedReportAnalyticsQuery,
    NumberAggregatedReportAnalyticsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<NumberAggregatedReportAnalyticsQuery, NumberAggregatedReportAnalyticsQueryVariables>;
export function useNumberAggregatedReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NumberAggregatedReportAnalyticsQuery,
        NumberAggregatedReportAnalyticsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  NumberAggregatedReportAnalyticsQuery | undefined,
  NumberAggregatedReportAnalyticsQueryVariables
>;
export function useNumberAggregatedReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NumberAggregatedReportAnalyticsQuery,
        NumberAggregatedReportAnalyticsQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NumberAggregatedReportAnalyticsQuery, NumberAggregatedReportAnalyticsQueryVariables>(
    NumberAggregatedReportAnalyticsDocument,
    options
  );
}
export type NumberAggregatedReportAnalyticsQueryHookResult = ReturnType<typeof useNumberAggregatedReportAnalyticsQuery>;
export type NumberAggregatedReportAnalyticsLazyQueryHookResult = ReturnType<
  typeof useNumberAggregatedReportAnalyticsLazyQuery
>;
export type NumberAggregatedReportAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useNumberAggregatedReportAnalyticsSuspenseQuery
>;
export type NumberAggregatedReportAnalyticsQueryResult = Apollo.QueryResult<
  NumberAggregatedReportAnalyticsQuery,
  NumberAggregatedReportAnalyticsQueryVariables
>;
export const ChannelMembersDocument = gql`
  query ChannelMembers($channelId: Int!) {
    channelMembers(channelId: $channelId) {
      message
      data {
        name
        userId
        url
      }
    }
  }
`;

/**
 * __useChannelMembersQuery__
 *
 * To run a query within a React component, call `useChannelMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelMembersQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelMembersQuery(
  baseOptions: Apollo.QueryHookOptions<ChannelMembersQuery, ChannelMembersQueryVariables> &
    ({ variables: ChannelMembersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelMembersQuery, ChannelMembersQueryVariables>(ChannelMembersDocument, options);
}
export function useChannelMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChannelMembersQuery, ChannelMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelMembersQuery, ChannelMembersQueryVariables>(ChannelMembersDocument, options);
}
// @ts-ignore
export function useChannelMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelMembersQuery, ChannelMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelMembersQuery, ChannelMembersQueryVariables>;
export function useChannelMembersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelMembersQuery, ChannelMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelMembersQuery | undefined, ChannelMembersQueryVariables>;
export function useChannelMembersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelMembersQuery, ChannelMembersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelMembersQuery, ChannelMembersQueryVariables>(ChannelMembersDocument, options);
}
export type ChannelMembersQueryHookResult = ReturnType<typeof useChannelMembersQuery>;
export type ChannelMembersLazyQueryHookResult = ReturnType<typeof useChannelMembersLazyQuery>;
export type ChannelMembersSuspenseQueryHookResult = ReturnType<typeof useChannelMembersSuspenseQuery>;
export type ChannelMembersQueryResult = Apollo.QueryResult<ChannelMembersQuery, ChannelMembersQueryVariables>;
export const IndividualNumberReportAnalyticsDocument = gql`
  query IndividualNumberReportAnalytics(
    $channelId: Int!
    $fromDate: DateTime!
    $toDate: DateTime!
    $limit: Int
    $offset: Int
    $sort: SortEnum
    $order: String
    $query: String
  ) {
    individualNumberReportAnalytics(
      channelId: $channelId
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      offset: $offset
      sort: $sort
      order: $order
      query: $query
    ) {
      message
      count
      edges {
        id
        name
        phoneNumber
        callDate
        callDuration
        callType
      }
    }
  }
`;

/**
 * __useIndividualNumberReportAnalyticsQuery__
 *
 * To run a query within a React component, call `useIndividualNumberReportAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualNumberReportAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualNumberReportAnalyticsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useIndividualNumberReportAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IndividualNumberReportAnalyticsQuery,
    IndividualNumberReportAnalyticsQueryVariables
  > &
    ({ variables: IndividualNumberReportAnalyticsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IndividualNumberReportAnalyticsQuery, IndividualNumberReportAnalyticsQueryVariables>(
    IndividualNumberReportAnalyticsDocument,
    options
  );
}
export function useIndividualNumberReportAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndividualNumberReportAnalyticsQuery,
    IndividualNumberReportAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IndividualNumberReportAnalyticsQuery, IndividualNumberReportAnalyticsQueryVariables>(
    IndividualNumberReportAnalyticsDocument,
    options
  );
}
// @ts-ignore
export function useIndividualNumberReportAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IndividualNumberReportAnalyticsQuery,
    IndividualNumberReportAnalyticsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IndividualNumberReportAnalyticsQuery, IndividualNumberReportAnalyticsQueryVariables>;
export function useIndividualNumberReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndividualNumberReportAnalyticsQuery,
        IndividualNumberReportAnalyticsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IndividualNumberReportAnalyticsQuery | undefined,
  IndividualNumberReportAnalyticsQueryVariables
>;
export function useIndividualNumberReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndividualNumberReportAnalyticsQuery,
        IndividualNumberReportAnalyticsQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IndividualNumberReportAnalyticsQuery, IndividualNumberReportAnalyticsQueryVariables>(
    IndividualNumberReportAnalyticsDocument,
    options
  );
}
export type IndividualNumberReportAnalyticsQueryHookResult = ReturnType<typeof useIndividualNumberReportAnalyticsQuery>;
export type IndividualNumberReportAnalyticsLazyQueryHookResult = ReturnType<
  typeof useIndividualNumberReportAnalyticsLazyQuery
>;
export type IndividualNumberReportAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useIndividualNumberReportAnalyticsSuspenseQuery
>;
export type IndividualNumberReportAnalyticsQueryResult = Apollo.QueryResult<
  IndividualNumberReportAnalyticsQuery,
  IndividualNumberReportAnalyticsQueryVariables
>;
export const aiAdvanceCallReportDocument = gql`
  query aiAdvanceCallReport(
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $offset: Int
    $sentimentType: String
    $reasonType: String
    $conclusionType: String
    $userWorkspaceId: Int
    $order: String
    $sort: SortEnum
    $callType: String
    $callResolution: String
  ) {
    aiAdvanceCallReport(
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      offset: $offset
      sentimentType: $sentimentType
      reasonType: $reasonType
      conclusionType: $conclusionType
      userWorkspaceId: $userWorkspaceId
      order: $order
      sort: $sort
      callType: $callType
      callResolution: $callResolution
    ) {
      message
      count
      edges {
        userName
        callDirection
        createdAt
        agentPhoneNumber
        callCount
        callRecordingId
        transcriptionId
        callRecordingUrl
        customerName
        customerPhoneNumber
      }
    }
  }
`;

/**
 * __useaiAdvanceCallReportQuery__
 *
 * To run a query within a React component, call `useaiAdvanceCallReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useaiAdvanceCallReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useaiAdvanceCallReportQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sentimentType: // value for 'sentimentType'
 *      reasonType: // value for 'reasonType'
 *      conclusionType: // value for 'conclusionType'
 *      userWorkspaceId: // value for 'userWorkspaceId'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      callType: // value for 'callType'
 *      callResolution: // value for 'callResolution'
 *   },
 * });
 */
export function useaiAdvanceCallReportQuery(
  baseOptions: Apollo.QueryHookOptions<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables> &
    ({ variables: aiAdvanceCallReportQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables>(
    aiAdvanceCallReportDocument,
    options
  );
}
export function useaiAdvanceCallReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables>(
    aiAdvanceCallReportDocument,
    options
  );
}
// @ts-ignore
export function useaiAdvanceCallReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables>
): Apollo.UseSuspenseQueryResult<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables>;
export function useaiAdvanceCallReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables>
): Apollo.UseSuspenseQueryResult<aiAdvanceCallReportQuery | undefined, aiAdvanceCallReportQueryVariables>;
export function useaiAdvanceCallReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<aiAdvanceCallReportQuery, aiAdvanceCallReportQueryVariables>(
    aiAdvanceCallReportDocument,
    options
  );
}
export type aiAdvanceCallReportQueryHookResult = ReturnType<typeof useaiAdvanceCallReportQuery>;
export type aiAdvanceCallReportLazyQueryHookResult = ReturnType<typeof useaiAdvanceCallReportLazyQuery>;
export type aiAdvanceCallReportSuspenseQueryHookResult = ReturnType<typeof useaiAdvanceCallReportSuspenseQuery>;
export type aiAdvanceCallReportQueryResult = Apollo.QueryResult<
  aiAdvanceCallReportQuery,
  aiAdvanceCallReportQueryVariables
>;
export const workspaceMembersDocument = gql`
  query workspaceMembers(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $status: UserWorkspaceStatusEnum
  ) {
    workspaceMembers(first: $first, last: $last, after: $after, before: $before, query: $query, status: $status) {
      pageInfo {
        count
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      message
      edges {
        node {
          id
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
            }
          }
          status
          id
          channels {
            phoneNumber
            id
            friendlyName
          }
          userWorkspaceRoles {
            role {
              level
              label
              id
            }
          }
        }
      }
    }
  }
`;

/**
 * __useworkspaceMembersQuery__
 *
 * To run a query within a React component, call `useworkspaceMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useworkspaceMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useworkspaceMembersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useworkspaceMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<workspaceMembersQuery, workspaceMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<workspaceMembersQuery, workspaceMembersQueryVariables>(workspaceMembersDocument, options);
}
export function useworkspaceMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<workspaceMembersQuery, workspaceMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<workspaceMembersQuery, workspaceMembersQueryVariables>(workspaceMembersDocument, options);
}
// @ts-ignore
export function useworkspaceMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<workspaceMembersQuery, workspaceMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<workspaceMembersQuery, workspaceMembersQueryVariables>;
export function useworkspaceMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<workspaceMembersQuery, workspaceMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<workspaceMembersQuery | undefined, workspaceMembersQueryVariables>;
export function useworkspaceMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<workspaceMembersQuery, workspaceMembersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<workspaceMembersQuery, workspaceMembersQueryVariables>(
    workspaceMembersDocument,
    options
  );
}
export type workspaceMembersQueryHookResult = ReturnType<typeof useworkspaceMembersQuery>;
export type workspaceMembersLazyQueryHookResult = ReturnType<typeof useworkspaceMembersLazyQuery>;
export type workspaceMembersSuspenseQueryHookResult = ReturnType<typeof useworkspaceMembersSuspenseQuery>;
export type workspaceMembersQueryResult = Apollo.QueryResult<workspaceMembersQuery, workspaceMembersQueryVariables>;
export const AiDashboardCountDocument = gql`
  query AiDashboardCount($fromDate: Date!, $toDate: Date!) {
    aiDashboardCount(fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        sentiment
        totalCount
        percentage
      }
    }
  }
`;

/**
 * __useAiDashboardCountQuery__
 *
 * To run a query within a React component, call `useAiDashboardCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDashboardCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDashboardCountQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useAiDashboardCountQuery(
  baseOptions: Apollo.QueryHookOptions<AiDashboardCountQuery, AiDashboardCountQueryVariables> &
    ({ variables: AiDashboardCountQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiDashboardCountQuery, AiDashboardCountQueryVariables>(AiDashboardCountDocument, options);
}
export function useAiDashboardCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AiDashboardCountQuery, AiDashboardCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiDashboardCountQuery, AiDashboardCountQueryVariables>(AiDashboardCountDocument, options);
}
// @ts-ignore
export function useAiDashboardCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AiDashboardCountQuery, AiDashboardCountQueryVariables>
): Apollo.UseSuspenseQueryResult<AiDashboardCountQuery, AiDashboardCountQueryVariables>;
export function useAiDashboardCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDashboardCountQuery, AiDashboardCountQueryVariables>
): Apollo.UseSuspenseQueryResult<AiDashboardCountQuery | undefined, AiDashboardCountQueryVariables>;
export function useAiDashboardCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDashboardCountQuery, AiDashboardCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiDashboardCountQuery, AiDashboardCountQueryVariables>(
    AiDashboardCountDocument,
    options
  );
}
export type AiDashboardCountQueryHookResult = ReturnType<typeof useAiDashboardCountQuery>;
export type AiDashboardCountLazyQueryHookResult = ReturnType<typeof useAiDashboardCountLazyQuery>;
export type AiDashboardCountSuspenseQueryHookResult = ReturnType<typeof useAiDashboardCountSuspenseQuery>;
export type AiDashboardCountQueryResult = Apollo.QueryResult<AiDashboardCountQuery, AiDashboardCountQueryVariables>;
export const AiDashboardReportAnalyticsDocument = gql`
  query AiDashboardReportAnalytics($fromDate: Date!, $toDate: Date!) {
    aiDashboardReportAnalytics(fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        key
        value {
          count
          percentage
          duration
          label
        }
      }
    }
  }
`;

/**
 * __useAiDashboardReportAnalyticsQuery__
 *
 * To run a query within a React component, call `useAiDashboardReportAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDashboardReportAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDashboardReportAnalyticsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useAiDashboardReportAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<AiDashboardReportAnalyticsQuery, AiDashboardReportAnalyticsQueryVariables> &
    ({ variables: AiDashboardReportAnalyticsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiDashboardReportAnalyticsQuery, AiDashboardReportAnalyticsQueryVariables>(
    AiDashboardReportAnalyticsDocument,
    options
  );
}
export function useAiDashboardReportAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AiDashboardReportAnalyticsQuery, AiDashboardReportAnalyticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiDashboardReportAnalyticsQuery, AiDashboardReportAnalyticsQueryVariables>(
    AiDashboardReportAnalyticsDocument,
    options
  );
}
// @ts-ignore
export function useAiDashboardReportAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiDashboardReportAnalyticsQuery,
    AiDashboardReportAnalyticsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<AiDashboardReportAnalyticsQuery, AiDashboardReportAnalyticsQueryVariables>;
export function useAiDashboardReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDashboardReportAnalyticsQuery, AiDashboardReportAnalyticsQueryVariables>
): Apollo.UseSuspenseQueryResult<AiDashboardReportAnalyticsQuery | undefined, AiDashboardReportAnalyticsQueryVariables>;
export function useAiDashboardReportAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDashboardReportAnalyticsQuery, AiDashboardReportAnalyticsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiDashboardReportAnalyticsQuery, AiDashboardReportAnalyticsQueryVariables>(
    AiDashboardReportAnalyticsDocument,
    options
  );
}
export type AiDashboardReportAnalyticsQueryHookResult = ReturnType<typeof useAiDashboardReportAnalyticsQuery>;
export type AiDashboardReportAnalyticsLazyQueryHookResult = ReturnType<typeof useAiDashboardReportAnalyticsLazyQuery>;
export type AiDashboardReportAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useAiDashboardReportAnalyticsSuspenseQuery
>;
export type AiDashboardReportAnalyticsQueryResult = Apollo.QueryResult<
  AiDashboardReportAnalyticsQuery,
  AiDashboardReportAnalyticsQueryVariables
>;
export const GetTranscriptionInformationDocument = gql`
  query GetTranscriptionInformation($callRecordingId: Int) {
    getTranscriptionInformation(callRecordingId: $callRecordingId) {
      message
      data {
        callSummary
        sentiment
        reason
        conclusion
        resolutions
        recommendations
        callRecordingUrl
        transcriptionText {
          content
          participantRole
          sentiment
        }
        memberTalkTime
        customerTalkTime
        silenceTime
        totalTalkTime
        availableSentiments
      }
    }
  }
`;

/**
 * __useGetTranscriptionInformationQuery__
 *
 * To run a query within a React component, call `useGetTranscriptionInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptionInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranscriptionInformationQuery({
 *   variables: {
 *      callRecordingId: // value for 'callRecordingId'
 *   },
 * });
 */
export function useGetTranscriptionInformationQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTranscriptionInformationQuery, GetTranscriptionInformationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTranscriptionInformationQuery, GetTranscriptionInformationQueryVariables>(
    GetTranscriptionInformationDocument,
    options
  );
}
export function useGetTranscriptionInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTranscriptionInformationQuery, GetTranscriptionInformationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTranscriptionInformationQuery, GetTranscriptionInformationQueryVariables>(
    GetTranscriptionInformationDocument,
    options
  );
}
// @ts-ignore
export function useGetTranscriptionInformationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTranscriptionInformationQuery,
    GetTranscriptionInformationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetTranscriptionInformationQuery, GetTranscriptionInformationQueryVariables>;
export function useGetTranscriptionInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTranscriptionInformationQuery, GetTranscriptionInformationQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetTranscriptionInformationQuery | undefined,
  GetTranscriptionInformationQueryVariables
>;
export function useGetTranscriptionInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTranscriptionInformationQuery, GetTranscriptionInformationQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTranscriptionInformationQuery, GetTranscriptionInformationQueryVariables>(
    GetTranscriptionInformationDocument,
    options
  );
}
export type GetTranscriptionInformationQueryHookResult = ReturnType<typeof useGetTranscriptionInformationQuery>;
export type GetTranscriptionInformationLazyQueryHookResult = ReturnType<typeof useGetTranscriptionInformationLazyQuery>;
export type GetTranscriptionInformationSuspenseQueryHookResult = ReturnType<
  typeof useGetTranscriptionInformationSuspenseQuery
>;
export type GetTranscriptionInformationQueryResult = Apollo.QueryResult<
  GetTranscriptionInformationQuery,
  GetTranscriptionInformationQueryVariables
>;
export const AiDashboardDayWiseSentimentDocument = gql`
  query AiDashboardDayWiseSentiment($fromDate: Date!, $toDate: Date!) {
    aiDashboardDayWiseSentiment(fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        createdAt
        positiveSentimentCount
        negativeSentimentCount
        neutralSentimentCount
      }
    }
  }
`;

/**
 * __useAiDashboardDayWiseSentimentQuery__
 *
 * To run a query within a React component, call `useAiDashboardDayWiseSentimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDashboardDayWiseSentimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDashboardDayWiseSentimentQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useAiDashboardDayWiseSentimentQuery(
  baseOptions: Apollo.QueryHookOptions<AiDashboardDayWiseSentimentQuery, AiDashboardDayWiseSentimentQueryVariables> &
    ({ variables: AiDashboardDayWiseSentimentQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiDashboardDayWiseSentimentQuery, AiDashboardDayWiseSentimentQueryVariables>(
    AiDashboardDayWiseSentimentDocument,
    options
  );
}
export function useAiDashboardDayWiseSentimentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AiDashboardDayWiseSentimentQuery, AiDashboardDayWiseSentimentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiDashboardDayWiseSentimentQuery, AiDashboardDayWiseSentimentQueryVariables>(
    AiDashboardDayWiseSentimentDocument,
    options
  );
}
// @ts-ignore
export function useAiDashboardDayWiseSentimentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiDashboardDayWiseSentimentQuery,
    AiDashboardDayWiseSentimentQueryVariables
  >
): Apollo.UseSuspenseQueryResult<AiDashboardDayWiseSentimentQuery, AiDashboardDayWiseSentimentQueryVariables>;
export function useAiDashboardDayWiseSentimentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDashboardDayWiseSentimentQuery, AiDashboardDayWiseSentimentQueryVariables>
): Apollo.UseSuspenseQueryResult<
  AiDashboardDayWiseSentimentQuery | undefined,
  AiDashboardDayWiseSentimentQueryVariables
>;
export function useAiDashboardDayWiseSentimentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDashboardDayWiseSentimentQuery, AiDashboardDayWiseSentimentQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiDashboardDayWiseSentimentQuery, AiDashboardDayWiseSentimentQueryVariables>(
    AiDashboardDayWiseSentimentDocument,
    options
  );
}
export type AiDashboardDayWiseSentimentQueryHookResult = ReturnType<typeof useAiDashboardDayWiseSentimentQuery>;
export type AiDashboardDayWiseSentimentLazyQueryHookResult = ReturnType<typeof useAiDashboardDayWiseSentimentLazyQuery>;
export type AiDashboardDayWiseSentimentSuspenseQueryHookResult = ReturnType<
  typeof useAiDashboardDayWiseSentimentSuspenseQuery
>;
export type AiDashboardDayWiseSentimentQueryResult = Apollo.QueryResult<
  AiDashboardDayWiseSentimentQuery,
  AiDashboardDayWiseSentimentQueryVariables
>;
export const AiDashboardMemberPerformanceGraphReportDocument = gql`
  query AiDashboardMemberPerformanceGraphReport($limit: Int, $fromDate: Date!, $toDate: Date!) {
    aiDashboardMemberPerformanceGraphReport(limit: $limit, fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        userId
        userName
        percentage
        totalCallCount
      }
    }
  }
`;

/**
 * __useAiDashboardMemberPerformanceGraphReportQuery__
 *
 * To run a query within a React component, call `useAiDashboardMemberPerformanceGraphReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDashboardMemberPerformanceGraphReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDashboardMemberPerformanceGraphReportQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useAiDashboardMemberPerformanceGraphReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    AiDashboardMemberPerformanceGraphReportQuery,
    AiDashboardMemberPerformanceGraphReportQueryVariables
  > &
    ({ variables: AiDashboardMemberPerformanceGraphReportQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AiDashboardMemberPerformanceGraphReportQuery,
    AiDashboardMemberPerformanceGraphReportQueryVariables
  >(AiDashboardMemberPerformanceGraphReportDocument, options);
}
export function useAiDashboardMemberPerformanceGraphReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiDashboardMemberPerformanceGraphReportQuery,
    AiDashboardMemberPerformanceGraphReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AiDashboardMemberPerformanceGraphReportQuery,
    AiDashboardMemberPerformanceGraphReportQueryVariables
  >(AiDashboardMemberPerformanceGraphReportDocument, options);
}
// @ts-ignore
export function useAiDashboardMemberPerformanceGraphReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiDashboardMemberPerformanceGraphReportQuery,
    AiDashboardMemberPerformanceGraphReportQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AiDashboardMemberPerformanceGraphReportQuery,
  AiDashboardMemberPerformanceGraphReportQueryVariables
>;
export function useAiDashboardMemberPerformanceGraphReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiDashboardMemberPerformanceGraphReportQuery,
        AiDashboardMemberPerformanceGraphReportQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AiDashboardMemberPerformanceGraphReportQuery | undefined,
  AiDashboardMemberPerformanceGraphReportQueryVariables
>;
export function useAiDashboardMemberPerformanceGraphReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiDashboardMemberPerformanceGraphReportQuery,
        AiDashboardMemberPerformanceGraphReportQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiDashboardMemberPerformanceGraphReportQuery,
    AiDashboardMemberPerformanceGraphReportQueryVariables
  >(AiDashboardMemberPerformanceGraphReportDocument, options);
}
export type AiDashboardMemberPerformanceGraphReportQueryHookResult = ReturnType<
  typeof useAiDashboardMemberPerformanceGraphReportQuery
>;
export type AiDashboardMemberPerformanceGraphReportLazyQueryHookResult = ReturnType<
  typeof useAiDashboardMemberPerformanceGraphReportLazyQuery
>;
export type AiDashboardMemberPerformanceGraphReportSuspenseQueryHookResult = ReturnType<
  typeof useAiDashboardMemberPerformanceGraphReportSuspenseQuery
>;
export type AiDashboardMemberPerformanceGraphReportQueryResult = Apollo.QueryResult<
  AiDashboardMemberPerformanceGraphReportQuery,
  AiDashboardMemberPerformanceGraphReportQueryVariables
>;
export const WorkspaceMemberDocument = gql`
  query WorkspaceMember($workspaceMemberId: Int!) {
    workspaceMember(id: $workspaceMemberId) {
      message
      data {
        id
        user {
          id
          name
          email
          profilePicture {
            id
            url
          }
        }
        userOnlineManagement {
          isActive
          lastSeenAt
          activeStatus
          awayTill
          message
          icon
        }
      }
    }
  }
`;

/**
 * __useWorkspaceMemberQuery__
 *
 * To run a query within a React component, call `useWorkspaceMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceMemberQuery({
 *   variables: {
 *      workspaceMemberId: // value for 'workspaceMemberId'
 *   },
 * });
 */
export function useWorkspaceMemberQuery(
  baseOptions: Apollo.QueryHookOptions<WorkspaceMemberQuery, WorkspaceMemberQueryVariables> &
    ({ variables: WorkspaceMemberQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>(WorkspaceMemberDocument, options);
}
export function useWorkspaceMemberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>(WorkspaceMemberDocument, options);
}
// @ts-ignore
export function useWorkspaceMemberSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>
): Apollo.UseSuspenseQueryResult<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>;
export function useWorkspaceMemberSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>
): Apollo.UseSuspenseQueryResult<WorkspaceMemberQuery | undefined, WorkspaceMemberQueryVariables>;
export function useWorkspaceMemberSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>(WorkspaceMemberDocument, options);
}
export type WorkspaceMemberQueryHookResult = ReturnType<typeof useWorkspaceMemberQuery>;
export type WorkspaceMemberLazyQueryHookResult = ReturnType<typeof useWorkspaceMemberLazyQuery>;
export type WorkspaceMemberSuspenseQueryHookResult = ReturnType<typeof useWorkspaceMemberSuspenseQuery>;
export type WorkspaceMemberQueryResult = Apollo.QueryResult<WorkspaceMemberQuery, WorkspaceMemberQueryVariables>;
export const assignChannelsDocument = gql`
  query assignChannels($first: Int, $query: String) {
    assignChannels(first: $first, query: $query) {
      edges {
        node {
          id
          isDefault
          channel {
            id
            unreadCountChannel
            friendlyName
            phoneNumber
            identity
            muted
            setting {
              id
              voicemail
              recording
            }
            a2pVerified
            country {
              id
              flag
            }
          }
          userWorkspace {
            id
            status
            user {
              id
              name
            }
          }
        }
      }
      message
    }
  }
`;

/**
 * __useassignChannelsQuery__
 *
 * To run a query within a React component, call `useassignChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useassignChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useassignChannelsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useassignChannelsQuery(
  baseOptions?: Apollo.QueryHookOptions<assignChannelsQuery, assignChannelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<assignChannelsQuery, assignChannelsQueryVariables>(assignChannelsDocument, options);
}
export function useassignChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<assignChannelsQuery, assignChannelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<assignChannelsQuery, assignChannelsQueryVariables>(assignChannelsDocument, options);
}
// @ts-ignore
export function useassignChannelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<assignChannelsQuery, assignChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<assignChannelsQuery, assignChannelsQueryVariables>;
export function useassignChannelsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<assignChannelsQuery, assignChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<assignChannelsQuery | undefined, assignChannelsQueryVariables>;
export function useassignChannelsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<assignChannelsQuery, assignChannelsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<assignChannelsQuery, assignChannelsQueryVariables>(assignChannelsDocument, options);
}
export type assignChannelsQueryHookResult = ReturnType<typeof useassignChannelsQuery>;
export type assignChannelsLazyQueryHookResult = ReturnType<typeof useassignChannelsLazyQuery>;
export type assignChannelsSuspenseQueryHookResult = ReturnType<typeof useassignChannelsSuspenseQuery>;
export type assignChannelsQueryResult = Apollo.QueryResult<assignChannelsQuery, assignChannelsQueryVariables>;
export const RecentMessageConversationsDocument = gql`
  query RecentMessageConversations(
    $channelId: Int!
    $after: String
    $first: Int
    $query: String
    $markAsClosed: Boolean
    $sort: SortEnum
    $order: String
    $voicemail: Boolean
    $direction: DirectionTypeEnum
    $conversationStatus: [String]
  ) {
    recentMessageConversations(
      channelId: $channelId
      after: $after
      first: $first
      query: $query
      markAsClosed: $markAsClosed
      sort: $sort
      order: $order
      voicemail: $voicemail
      direction: $direction
      conversationStatus: $conversationStatus
    ) {
      edges {
        node {
          id
          updatedAt
          unreadCountRecentMessage
          draftMessage
          channel {
            id
          }
          client {
            id
            name
            phoneNumber
            country {
              id
              flag
            }
            profilePicture {
              id
              url
            }
          }
          markAsClosed
          messageConversation {
            id
            conversationType
            conversationStatus
            direction
            messageContent
            pinned
            voicemailRecordingUrl
          }
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;

/**
 * __useRecentMessageConversationsQuery__
 *
 * To run a query within a React component, call `useRecentMessageConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentMessageConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentMessageConversationsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      markAsClosed: // value for 'markAsClosed'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *      voicemail: // value for 'voicemail'
 *      direction: // value for 'direction'
 *      conversationStatus: // value for 'conversationStatus'
 *   },
 * });
 */
export function useRecentMessageConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<RecentMessageConversationsQuery, RecentMessageConversationsQueryVariables> &
    ({ variables: RecentMessageConversationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecentMessageConversationsQuery, RecentMessageConversationsQueryVariables>(
    RecentMessageConversationsDocument,
    options
  );
}
export function useRecentMessageConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RecentMessageConversationsQuery, RecentMessageConversationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecentMessageConversationsQuery, RecentMessageConversationsQueryVariables>(
    RecentMessageConversationsDocument,
    options
  );
}
// @ts-ignore
export function useRecentMessageConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecentMessageConversationsQuery,
    RecentMessageConversationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<RecentMessageConversationsQuery, RecentMessageConversationsQueryVariables>;
export function useRecentMessageConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecentMessageConversationsQuery, RecentMessageConversationsQueryVariables>
): Apollo.UseSuspenseQueryResult<RecentMessageConversationsQuery | undefined, RecentMessageConversationsQueryVariables>;
export function useRecentMessageConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecentMessageConversationsQuery, RecentMessageConversationsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RecentMessageConversationsQuery, RecentMessageConversationsQueryVariables>(
    RecentMessageConversationsDocument,
    options
  );
}
export type RecentMessageConversationsQueryHookResult = ReturnType<typeof useRecentMessageConversationsQuery>;
export type RecentMessageConversationsLazyQueryHookResult = ReturnType<typeof useRecentMessageConversationsLazyQuery>;
export type RecentMessageConversationsSuspenseQueryHookResult = ReturnType<
  typeof useRecentMessageConversationsSuspenseQuery
>;
export type RecentMessageConversationsQueryResult = Apollo.QueryResult<
  RecentMessageConversationsQuery,
  RecentMessageConversationsQueryVariables
>;
export const PlanPricesDocument = gql`
  query PlanPrices(
    $periodicity: PeriodicityEnum
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
  ) {
    planPrices(periodicity: $periodicity, first: $first, last: $last, after: $after, before: $before, query: $query) {
      message
      edges {
        node {
          id
          amount
          periodicity
          isPublished
          rank
          plan {
            id
            label
            name
            slug
            shortDescription
            description
            features
            recommendation
            showAmount
          }
          position
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;

/**
 * __usePlanPricesQuery__
 *
 * To run a query within a React component, call `usePlanPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPricesQuery({
 *   variables: {
 *      periodicity: // value for 'periodicity'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePlanPricesQuery(baseOptions?: Apollo.QueryHookOptions<PlanPricesQuery, PlanPricesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlanPricesQuery, PlanPricesQueryVariables>(PlanPricesDocument, options);
}
export function usePlanPricesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PlanPricesQuery, PlanPricesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlanPricesQuery, PlanPricesQueryVariables>(PlanPricesDocument, options);
}
// @ts-ignore
export function usePlanPricesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PlanPricesQuery, PlanPricesQueryVariables>
): Apollo.UseSuspenseQueryResult<PlanPricesQuery, PlanPricesQueryVariables>;
export function usePlanPricesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanPricesQuery, PlanPricesQueryVariables>
): Apollo.UseSuspenseQueryResult<PlanPricesQuery | undefined, PlanPricesQueryVariables>;
export function usePlanPricesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanPricesQuery, PlanPricesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PlanPricesQuery, PlanPricesQueryVariables>(PlanPricesDocument, options);
}
export type PlanPricesQueryHookResult = ReturnType<typeof usePlanPricesQuery>;
export type PlanPricesLazyQueryHookResult = ReturnType<typeof usePlanPricesLazyQuery>;
export type PlanPricesSuspenseQueryHookResult = ReturnType<typeof usePlanPricesSuspenseQuery>;
export type PlanPricesQueryResult = Apollo.QueryResult<PlanPricesQuery, PlanPricesQueryVariables>;
export const ContactByIdDocument = gql`
  query ContactById($contactId: Int!) {
    contact(id: $contactId) {
      message
      data {
        id
        isBlocked
        name
        phoneNumber
        isBlocked
        country {
          id
          flag
        }
        profilePicture {
          id
          url
        }
      }
    }
  }
`;

/**
 * __useContactByIdQuery__
 *
 * To run a query within a React component, call `useContactByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactByIdQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactByIdQuery(
  baseOptions: Apollo.QueryHookOptions<ContactByIdQuery, ContactByIdQueryVariables> &
    ({ variables: ContactByIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactByIdQuery, ContactByIdQueryVariables>(ContactByIdDocument, options);
}
export function useContactByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactByIdQuery, ContactByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactByIdQuery, ContactByIdQueryVariables>(ContactByIdDocument, options);
}
// @ts-ignore
export function useContactByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactByIdQuery, ContactByIdQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactByIdQuery, ContactByIdQueryVariables>;
export function useContactByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactByIdQuery, ContactByIdQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactByIdQuery | undefined, ContactByIdQueryVariables>;
export function useContactByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactByIdQuery, ContactByIdQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactByIdQuery, ContactByIdQueryVariables>(ContactByIdDocument, options);
}
export type ContactByIdQueryHookResult = ReturnType<typeof useContactByIdQuery>;
export type ContactByIdLazyQueryHookResult = ReturnType<typeof useContactByIdLazyQuery>;
export type ContactByIdSuspenseQueryHookResult = ReturnType<typeof useContactByIdSuspenseQuery>;
export type ContactByIdQueryResult = Apollo.QueryResult<ContactByIdQuery, ContactByIdQueryVariables>;
export const MarkConversationAsCloseOrOpenDocument = gql`
  mutation MarkConversationAsCloseOrOpen($markAsCloseOrOpenId: Int!, $input: InputMarkAsCloseOrOpen) {
    markAsCloseOrOpen(id: $markAsCloseOrOpenId, input: $input) {
      message
    }
  }
`;
export type MarkConversationAsCloseOrOpenMutationFn = Apollo.MutationFunction<
  MarkConversationAsCloseOrOpenMutation,
  MarkConversationAsCloseOrOpenMutationVariables
>;

/**
 * __useMarkConversationAsCloseOrOpenMutation__
 *
 * To run a mutation, you first call `useMarkConversationAsCloseOrOpenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationAsCloseOrOpenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationAsCloseOrOpenMutation, { data, loading, error }] = useMarkConversationAsCloseOrOpenMutation({
 *   variables: {
 *      markAsCloseOrOpenId: // value for 'markAsCloseOrOpenId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkConversationAsCloseOrOpenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkConversationAsCloseOrOpenMutation,
    MarkConversationAsCloseOrOpenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkConversationAsCloseOrOpenMutation, MarkConversationAsCloseOrOpenMutationVariables>(
    MarkConversationAsCloseOrOpenDocument,
    options
  );
}
export type MarkConversationAsCloseOrOpenMutationHookResult = ReturnType<
  typeof useMarkConversationAsCloseOrOpenMutation
>;
export type MarkConversationAsCloseOrOpenMutationResult = Apollo.MutationResult<MarkConversationAsCloseOrOpenMutation>;
export type MarkConversationAsCloseOrOpenMutationOptions = Apollo.BaseMutationOptions<
  MarkConversationAsCloseOrOpenMutation,
  MarkConversationAsCloseOrOpenMutationVariables
>;
export const ChannelsDocument = gql`
  query Channels($first: Int, $last: Int, $after: String, $before: String, $query: String) {
    channels(first: $first, last: $last, after: $after, before: $before, query: $query) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
        __typename
      }
      message
      edges {
        cursor
        node {
          id
          friendlyName
          phoneNumber
          identity
          emergencyStatus
          beta
          country {
            id
            flag
          }
          capability {
            voice
            __typename
          }
          channelUserWorkspaces {
            id
            userWorkspace {
              id
              user {
                id
                name
                profilePicture {
                  id
                  url
                  originalname
                  size
                  key
                  mimetype
                  __typename
                }
                __typename
              }
              status
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

/**
 * __useChannelsQuery__
 *
 * To run a query within a React component, call `useChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useChannelsQuery(baseOptions?: Apollo.QueryHookOptions<ChannelsQuery, ChannelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelsQuery, ChannelsQueryVariables>(ChannelsDocument, options);
}
export function useChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelsQuery, ChannelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelsQuery, ChannelsQueryVariables>(ChannelsDocument, options);
}
// @ts-ignore
export function useChannelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelsQuery, ChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelsQuery, ChannelsQueryVariables>;
export function useChannelsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelsQuery, ChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelsQuery | undefined, ChannelsQueryVariables>;
export function useChannelsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelsQuery, ChannelsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelsQuery, ChannelsQueryVariables>(ChannelsDocument, options);
}
export type ChannelsQueryHookResult = ReturnType<typeof useChannelsQuery>;
export type ChannelsLazyQueryHookResult = ReturnType<typeof useChannelsLazyQuery>;
export type ChannelsSuspenseQueryHookResult = ReturnType<typeof useChannelsSuspenseQuery>;
export type ChannelsQueryResult = Apollo.QueryResult<ChannelsQuery, ChannelsQueryVariables>;
export const RegulatoryCompliancesDocument = gql`
  query RegulatoryCompliances($first: Int, $last: Int, $after: String, $before: String, $query: String) {
    regulatoryCompliances(first: $first, last: $last, after: $after, before: $before, query: $query) {
      message
      pageInfo {
        count
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        __typename
      }
      edges {
        cursor
        node {
          id
          createdAt
          updatedAt
          numberType
          status
          country {
            id
            name
            flag
            alphaTwoCode
            __typename
          }
          channelRequested {
            addressRequirements
            isoCountry
            phoneNumber
            friendlyName
            region
            rateCenter
            capabilities {
              voice
              SMS
              MMS
              __typename
            }
            numberType
            basePrice
            currentPrice
            supportingDocument
            endUser
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

/**
 * __useRegulatoryCompliancesQuery__
 *
 * To run a query within a React component, call `useRegulatoryCompliancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryCompliancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulatoryCompliancesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useRegulatoryCompliancesQuery(
  baseOptions?: Apollo.QueryHookOptions<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>(
    RegulatoryCompliancesDocument,
    options
  );
}
export function useRegulatoryCompliancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>(
    RegulatoryCompliancesDocument,
    options
  );
}
// @ts-ignore
export function useRegulatoryCompliancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>
): Apollo.UseSuspenseQueryResult<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>;
export function useRegulatoryCompliancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>
): Apollo.UseSuspenseQueryResult<RegulatoryCompliancesQuery | undefined, RegulatoryCompliancesQueryVariables>;
export function useRegulatoryCompliancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RegulatoryCompliancesQuery, RegulatoryCompliancesQueryVariables>(
    RegulatoryCompliancesDocument,
    options
  );
}
export type RegulatoryCompliancesQueryHookResult = ReturnType<typeof useRegulatoryCompliancesQuery>;
export type RegulatoryCompliancesLazyQueryHookResult = ReturnType<typeof useRegulatoryCompliancesLazyQuery>;
export type RegulatoryCompliancesSuspenseQueryHookResult = ReturnType<typeof useRegulatoryCompliancesSuspenseQuery>;
export type RegulatoryCompliancesQueryResult = Apollo.QueryResult<
  RegulatoryCompliancesQuery,
  RegulatoryCompliancesQueryVariables
>;
export const InProcessPhoneNumbersDocument = gql`
  query InProcessPhoneNumbers(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $sort: SortEnum
    $order: String
  ) {
    inProcessPhoneNumbers(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      sort: $sort
      order: $order
    ) {
      message
      pageInfo {
        count
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        __typename
      }
      edges {
        cursor
        node {
          id
          status
          country {
            id
            name
            flag
            alphaTwoCode
          }
          meta {
            phoneNumber
            isoCountry
            friendlyName
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

/**
 * __useInProcessPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useInProcessPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProcessPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInProcessPhoneNumbersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInProcessPhoneNumbersQuery(
  baseOptions?: Apollo.QueryHookOptions<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>(
    InProcessPhoneNumbersDocument,
    options
  );
}
export function useInProcessPhoneNumbersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>(
    InProcessPhoneNumbersDocument,
    options
  );
}
// @ts-ignore
export function useInProcessPhoneNumbersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>
): Apollo.UseSuspenseQueryResult<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>;
export function useInProcessPhoneNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>
): Apollo.UseSuspenseQueryResult<InProcessPhoneNumbersQuery | undefined, InProcessPhoneNumbersQueryVariables>;
export function useInProcessPhoneNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InProcessPhoneNumbersQuery, InProcessPhoneNumbersQueryVariables>(
    InProcessPhoneNumbersDocument,
    options
  );
}
export type InProcessPhoneNumbersQueryHookResult = ReturnType<typeof useInProcessPhoneNumbersQuery>;
export type InProcessPhoneNumbersLazyQueryHookResult = ReturnType<typeof useInProcessPhoneNumbersLazyQuery>;
export type InProcessPhoneNumbersSuspenseQueryHookResult = ReturnType<typeof useInProcessPhoneNumbersSuspenseQuery>;
export type InProcessPhoneNumbersQueryResult = Apollo.QueryResult<
  InProcessPhoneNumbersQuery,
  InProcessPhoneNumbersQueryVariables
>;
export const availablePhoneNumbersDocument = gql`
  query availablePhoneNumbers(
    $countryCode: String!
    $numberType: NumberTypeEnum
    $smsEnabled: Boolean
    $voiceEnabled: Boolean
    $mmsEnabled: Boolean
    $faxEnabled: Boolean
    $excludeAllAddressRequired: Boolean
    $excludeLocalAddressRequired: Boolean
    $excludeForeignAddressRequired: Boolean
    $beta: Boolean
    $contains: String
    $areaCode: Int
    $inLocality: String
  ) {
    availablePhoneNumbers(
      countryCode: $countryCode
      numberType: $numberType
      smsEnabled: $smsEnabled
      voiceEnabled: $voiceEnabled
      mmsEnabled: $mmsEnabled
      faxEnabled: $faxEnabled
      excludeAllAddressRequired: $excludeAllAddressRequired
      excludeLocalAddressRequired: $excludeLocalAddressRequired
      excludeForeignAddressRequired: $excludeForeignAddressRequired
      beta: $beta
      contains: $contains
      areaCode: $areaCode
      inLocality: $inLocality
    ) {
      message
      edges {
        addressRequirements
        isoCountry
        phoneNumber
        friendlyName
        region
        rateCenter
        capabilities {
          voice
          SMS
          MMS
        }
        numberType
        basePrice
        currentPrice
        supportingDocument
        endUser
      }
    }
  }
`;

/**
 * __useavailablePhoneNumbersQuery__
 *
 * To run a query within a React component, call `useavailablePhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useavailablePhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useavailablePhoneNumbersQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      numberType: // value for 'numberType'
 *      smsEnabled: // value for 'smsEnabled'
 *      voiceEnabled: // value for 'voiceEnabled'
 *      mmsEnabled: // value for 'mmsEnabled'
 *      faxEnabled: // value for 'faxEnabled'
 *      excludeAllAddressRequired: // value for 'excludeAllAddressRequired'
 *      excludeLocalAddressRequired: // value for 'excludeLocalAddressRequired'
 *      excludeForeignAddressRequired: // value for 'excludeForeignAddressRequired'
 *      beta: // value for 'beta'
 *      contains: // value for 'contains'
 *      areaCode: // value for 'areaCode'
 *      inLocality: // value for 'inLocality'
 *   },
 * });
 */
export function useavailablePhoneNumbersQuery(
  baseOptions: Apollo.QueryHookOptions<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables> &
    ({ variables: availablePhoneNumbersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables>(
    availablePhoneNumbersDocument,
    options
  );
}
export function useavailablePhoneNumbersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables>(
    availablePhoneNumbersDocument,
    options
  );
}
// @ts-ignore
export function useavailablePhoneNumbersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables>
): Apollo.UseSuspenseQueryResult<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables>;
export function useavailablePhoneNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables>
): Apollo.UseSuspenseQueryResult<availablePhoneNumbersQuery | undefined, availablePhoneNumbersQueryVariables>;
export function useavailablePhoneNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<availablePhoneNumbersQuery, availablePhoneNumbersQueryVariables>(
    availablePhoneNumbersDocument,
    options
  );
}
export type availablePhoneNumbersQueryHookResult = ReturnType<typeof useavailablePhoneNumbersQuery>;
export type availablePhoneNumbersLazyQueryHookResult = ReturnType<typeof useavailablePhoneNumbersLazyQuery>;
export type availablePhoneNumbersSuspenseQueryHookResult = ReturnType<typeof useavailablePhoneNumbersSuspenseQuery>;
export type availablePhoneNumbersQueryResult = Apollo.QueryResult<
  availablePhoneNumbersQuery,
  availablePhoneNumbersQueryVariables
>;
export const GetContactByPhoneNumberDocument = gql`
  query GetContactByPhoneNumber($phoneNumber: String!) {
    getContactByPhoneNumber(phoneNumber: $phoneNumber) {
      message
      data {
        address
        companyName
        email
        id
        isBlocked
        blockedBy {
          name
          phoneNumber
          id
        }
        isPublished
        name
        phoneNumber
        country {
          id
          name
          flag
        }
        profilePicture {
          id
          url
        }
        timeZone
        website
        tags {
          id
          label
          color
        }
      }
    }
  }
`;

/**
 * __useGetContactByPhoneNumberQuery__
 *
 * To run a query within a React component, call `useGetContactByPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactByPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactByPhoneNumberQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useGetContactByPhoneNumberQuery(
  baseOptions: Apollo.QueryHookOptions<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables> &
    ({ variables: GetContactByPhoneNumberQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables>(
    GetContactByPhoneNumberDocument,
    options
  );
}
export function useGetContactByPhoneNumberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables>(
    GetContactByPhoneNumberDocument,
    options
  );
}
// @ts-ignore
export function useGetContactByPhoneNumberSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables>
): Apollo.UseSuspenseQueryResult<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables>;
export function useGetContactByPhoneNumberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables>
): Apollo.UseSuspenseQueryResult<GetContactByPhoneNumberQuery | undefined, GetContactByPhoneNumberQueryVariables>;
export function useGetContactByPhoneNumberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetContactByPhoneNumberQuery, GetContactByPhoneNumberQueryVariables>(
    GetContactByPhoneNumberDocument,
    options
  );
}
export type GetContactByPhoneNumberQueryHookResult = ReturnType<typeof useGetContactByPhoneNumberQuery>;
export type GetContactByPhoneNumberLazyQueryHookResult = ReturnType<typeof useGetContactByPhoneNumberLazyQuery>;
export type GetContactByPhoneNumberSuspenseQueryHookResult = ReturnType<typeof useGetContactByPhoneNumberSuspenseQuery>;
export type GetContactByPhoneNumberQueryResult = Apollo.QueryResult<
  GetContactByPhoneNumberQuery,
  GetContactByPhoneNumberQueryVariables
>;
export const TeamsDocument = gql`
  query Teams($query: String) {
    teams(query: $query) {
      message
      pageInfo {
        count
      }
      edges {
        node {
          id
          name
          status
          totalMembers
          teamMembers {
            user {
              profilePicture {
                id
                url
              }
              name
              id
            }
            status
            userId
          }
        }
      }
    }
  }
`;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
}
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
}
// @ts-ignore
export function useTeamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<TeamsQuery, TeamsQueryVariables>;
export function useTeamsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<TeamsQuery | undefined, TeamsQueryVariables>;
export function useTeamsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
}
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsSuspenseQueryHookResult = ReturnType<typeof useTeamsSuspenseQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const WorkspaceMembersListDocument = gql`
  query WorkspaceMembersList($orderBy: [OrderByInput], $first: Int) {
    accepted: workspaceMembers(status: accepted, orderBy: $orderBy, first: $first) {
      message
      edges {
        node {
          id
          user {
            phoneNumber
            name
            id
            email
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
            }
          }
          userOnlineManagement {
            isActive
            lastSeenAt
            activeStatus
            awayTill
            message
            icon
          }
          userWorkspaceRoles {
            role {
              label
            }
          }
          identity
        }
      }
    }
  }
`;

/**
 * __useWorkspaceMembersListQuery__
 *
 * To run a query within a React component, call `useWorkspaceMembersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMembersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceMembersListQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useWorkspaceMembersListQuery(
  baseOptions?: Apollo.QueryHookOptions<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>(
    WorkspaceMembersListDocument,
    options
  );
}
export function useWorkspaceMembersListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>(
    WorkspaceMembersListDocument,
    options
  );
}
// @ts-ignore
export function useWorkspaceMembersListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>
): Apollo.UseSuspenseQueryResult<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>;
export function useWorkspaceMembersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>
): Apollo.UseSuspenseQueryResult<WorkspaceMembersListQuery | undefined, WorkspaceMembersListQueryVariables>;
export function useWorkspaceMembersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkspaceMembersListQuery, WorkspaceMembersListQueryVariables>(
    WorkspaceMembersListDocument,
    options
  );
}
export type WorkspaceMembersListQueryHookResult = ReturnType<typeof useWorkspaceMembersListQuery>;
export type WorkspaceMembersListLazyQueryHookResult = ReturnType<typeof useWorkspaceMembersListLazyQuery>;
export type WorkspaceMembersListSuspenseQueryHookResult = ReturnType<typeof useWorkspaceMembersListSuspenseQuery>;
export type WorkspaceMembersListQueryResult = Apollo.QueryResult<
  WorkspaceMembersListQuery,
  WorkspaceMembersListQueryVariables
>;
export const TeamMembersDocument = gql`
  query TeamMembers($teamId: String!, $first: Int, $query: String, $after: String) {
    teamMembers(teamId: $teamId, first: $first, query: $query, after: $after) {
      message
      edges {
        node {
          userId
          workspacesId
          teamId
          status
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
              createdAt
            }
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            language
          }
          id
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTeamMembersQuery(
  baseOptions: Apollo.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables> &
    ({ variables: TeamMembersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
}
export function useTeamMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
}
// @ts-ignore
export function useTeamMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<TeamMembersQuery | undefined, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
}
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersSuspenseQueryHookResult = ReturnType<typeof useTeamMembersSuspenseQuery>;
export type TeamMembersQueryResult = Apollo.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const GetBlockedContactsDocument = gql`
  query GetBlockedContacts(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $order: String
    $sort: SortEnum
  ) {
    getBlockedContacts(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
      sort: $sort
    ) {
      pageInfo {
        count
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      message
      edges {
        cursor
        node {
          profilePicture {
            url
          }
          blockedBy {
            name
          }
          timeZone
          blockedOn
          blockReason
          id
          phoneNumber
          name
          isBlocked
          isPublished
        }
      }
    }
  }
`;

/**
 * __useGetBlockedContactsQuery__
 *
 * To run a query within a React component, call `useGetBlockedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedContactsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBlockedContactsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>(
    GetBlockedContactsDocument,
    options
  );
}
export function useGetBlockedContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>(
    GetBlockedContactsDocument,
    options
  );
}
// @ts-ignore
export function useGetBlockedContactsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>;
export function useGetBlockedContactsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetBlockedContactsQuery | undefined, GetBlockedContactsQueryVariables>;
export function useGetBlockedContactsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBlockedContactsQuery, GetBlockedContactsQueryVariables>(
    GetBlockedContactsDocument,
    options
  );
}
export type GetBlockedContactsQueryHookResult = ReturnType<typeof useGetBlockedContactsQuery>;
export type GetBlockedContactsLazyQueryHookResult = ReturnType<typeof useGetBlockedContactsLazyQuery>;
export type GetBlockedContactsSuspenseQueryHookResult = ReturnType<typeof useGetBlockedContactsSuspenseQuery>;
export type GetBlockedContactsQueryResult = Apollo.QueryResult<
  GetBlockedContactsQuery,
  GetBlockedContactsQueryVariables
>;
export const ActiveWorkspacesDocument = gql`
  query ActiveWorkspaces {
    activeWorkspaces {
      message
      edges {
        kycVerified
        hasCompleted
        active
        workspaceDetails {
          planPrice {
            amount
          }
        }
        id
        label
        isCurrent
        status
        logo {
          id
          url
        }
        unreadCountWorkspace
        pkReference
      }
    }
  }
`;

/**
 * __useActiveWorkspacesQuery__
 *
 * To run a query within a React component, call `useActiveWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveWorkspacesQuery(
  baseOptions?: Apollo.QueryHookOptions<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>(ActiveWorkspacesDocument, options);
}
export function useActiveWorkspacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>(ActiveWorkspacesDocument, options);
}
// @ts-ignore
export function useActiveWorkspacesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>
): Apollo.UseSuspenseQueryResult<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>;
export function useActiveWorkspacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>
): Apollo.UseSuspenseQueryResult<ActiveWorkspacesQuery | undefined, ActiveWorkspacesQueryVariables>;
export function useActiveWorkspacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>(
    ActiveWorkspacesDocument,
    options
  );
}
export type ActiveWorkspacesQueryHookResult = ReturnType<typeof useActiveWorkspacesQuery>;
export type ActiveWorkspacesLazyQueryHookResult = ReturnType<typeof useActiveWorkspacesLazyQuery>;
export type ActiveWorkspacesSuspenseQueryHookResult = ReturnType<typeof useActiveWorkspacesSuspenseQuery>;
export type ActiveWorkspacesQueryResult = Apollo.QueryResult<ActiveWorkspacesQuery, ActiveWorkspacesQueryVariables>;
export const ProviderLoginDocument = gql`
  query ProviderLogin {
    providerLogin {
      message
      data {
        token {
          access
        }
      }
    }
  }
`;

/**
 * __useProviderLoginQuery__
 *
 * To run a query within a React component, call `useProviderLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderLoginQuery(
  baseOptions?: Apollo.QueryHookOptions<ProviderLoginQuery, ProviderLoginQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProviderLoginQuery, ProviderLoginQueryVariables>(ProviderLoginDocument, options);
}
export function useProviderLoginLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProviderLoginQuery, ProviderLoginQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProviderLoginQuery, ProviderLoginQueryVariables>(ProviderLoginDocument, options);
}
// @ts-ignore
export function useProviderLoginSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderLoginQuery, ProviderLoginQueryVariables>
): Apollo.UseSuspenseQueryResult<ProviderLoginQuery, ProviderLoginQueryVariables>;
export function useProviderLoginSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderLoginQuery, ProviderLoginQueryVariables>
): Apollo.UseSuspenseQueryResult<ProviderLoginQuery | undefined, ProviderLoginQueryVariables>;
export function useProviderLoginSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderLoginQuery, ProviderLoginQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProviderLoginQuery, ProviderLoginQueryVariables>(ProviderLoginDocument, options);
}
export type ProviderLoginQueryHookResult = ReturnType<typeof useProviderLoginQuery>;
export type ProviderLoginLazyQueryHookResult = ReturnType<typeof useProviderLoginLazyQuery>;
export type ProviderLoginSuspenseQueryHookResult = ReturnType<typeof useProviderLoginSuspenseQuery>;
export type ProviderLoginQueryResult = Apollo.QueryResult<ProviderLoginQuery, ProviderLoginQueryVariables>;
export const CommandResponsesDocument = gql`
  query CommandResponses($query: String) {
    commandResponses(query: $query) {
      edges {
        node {
          command
          content
          id
          title
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
      message
    }
  }
`;

/**
 * __useCommandResponsesQuery__
 *
 * To run a query within a React component, call `useCommandResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommandResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommandResponsesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCommandResponsesQuery(
  baseOptions?: Apollo.QueryHookOptions<CommandResponsesQuery, CommandResponsesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CommandResponsesQuery, CommandResponsesQueryVariables>(CommandResponsesDocument, options);
}
export function useCommandResponsesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CommandResponsesQuery, CommandResponsesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CommandResponsesQuery, CommandResponsesQueryVariables>(CommandResponsesDocument, options);
}
// @ts-ignore
export function useCommandResponsesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CommandResponsesQuery, CommandResponsesQueryVariables>
): Apollo.UseSuspenseQueryResult<CommandResponsesQuery, CommandResponsesQueryVariables>;
export function useCommandResponsesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CommandResponsesQuery, CommandResponsesQueryVariables>
): Apollo.UseSuspenseQueryResult<CommandResponsesQuery | undefined, CommandResponsesQueryVariables>;
export function useCommandResponsesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CommandResponsesQuery, CommandResponsesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CommandResponsesQuery, CommandResponsesQueryVariables>(
    CommandResponsesDocument,
    options
  );
}
export type CommandResponsesQueryHookResult = ReturnType<typeof useCommandResponsesQuery>;
export type CommandResponsesLazyQueryHookResult = ReturnType<typeof useCommandResponsesLazyQuery>;
export type CommandResponsesSuspenseQueryHookResult = ReturnType<typeof useCommandResponsesSuspenseQuery>;
export type CommandResponsesQueryResult = Apollo.QueryResult<CommandResponsesQuery, CommandResponsesQueryVariables>;
export const VerifyPromoCodeDocument = gql`
  query VerifyPromoCode($input: InputVerifyPromoCode!) {
    verifyPromoCode(input: $input) {
      data {
        isValid
        discountAmount
        discountPercentage
        discountType
      }
      message
    }
  }
`;

/**
 * __useVerifyPromoCodeQuery__
 *
 * To run a query within a React component, call `useVerifyPromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyPromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyPromoCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyPromoCodeQuery(
  baseOptions: Apollo.QueryHookOptions<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables> &
    ({ variables: VerifyPromoCodeQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>(VerifyPromoCodeDocument, options);
}
export function useVerifyPromoCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>(VerifyPromoCodeDocument, options);
}
// @ts-ignore
export function useVerifyPromoCodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>
): Apollo.UseSuspenseQueryResult<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>;
export function useVerifyPromoCodeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>
): Apollo.UseSuspenseQueryResult<VerifyPromoCodeQuery | undefined, VerifyPromoCodeQueryVariables>;
export function useVerifyPromoCodeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>(VerifyPromoCodeDocument, options);
}
export type VerifyPromoCodeQueryHookResult = ReturnType<typeof useVerifyPromoCodeQuery>;
export type VerifyPromoCodeLazyQueryHookResult = ReturnType<typeof useVerifyPromoCodeLazyQuery>;
export type VerifyPromoCodeSuspenseQueryHookResult = ReturnType<typeof useVerifyPromoCodeSuspenseQuery>;
export type VerifyPromoCodeQueryResult = Apollo.QueryResult<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>;
export const InvoicesDocument = gql`
  query Invoices {
    invoices {
      message
      edges {
        cursor
        node {
          id
          type
          status
          totalAmount
          invoiceNo
          transactionId
          transactionDate
          invoiceItems {
            id
            invoiceId
            amount
            quantity
            remarks
            numberType
            country {
              id
              name
              slug
              dialingCode
              alphaTwoCode
              alphaThreeCode
              numeric
              flag
            }
          }
          billingCycleDate
          customer {
            email
            billingAddress {
              first_name
              last_name
              company
              phone
              line1
              line2
              city
              state
              country
              zip
            }
          }
          currency
          paymentMode {
            firstName
            lastName
            last4
            expiryMonth
            expiryYear
            brand
          }
          creditsApplied
          subTotalAmount
          discountPercentage
          discountAmount
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
}
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
}
// @ts-ignore
export function useInvoicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>
): Apollo.UseSuspenseQueryResult<InvoicesQuery, InvoicesQueryVariables>;
export function useInvoicesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>
): Apollo.UseSuspenseQueryResult<InvoicesQuery | undefined, InvoicesQueryVariables>;
export function useInvoicesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
}
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const ContactNotesDocument = gql`
  query ContactNotes(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $contactId: Int
    $order: String
    $sort: SortEnum
  ) {
    contactNotes(
      first: $first
      last: $last
      after: $after
      before: $before
      contactId: $contactId
      order: $order
      sort: $sort
    ) {
      message
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
      edges {
        cursor
        node {
          id
          description
          createdAt
          updatedAt
          updatedBy {
            id
            user {
              id
              name
              profilePicture {
                url
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useContactNotesQuery__
 *
 * To run a query within a React component, call `useContactNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactNotesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      contactId: // value for 'contactId'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useContactNotesQuery(
  baseOptions?: Apollo.QueryHookOptions<ContactNotesQuery, ContactNotesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactNotesQuery, ContactNotesQueryVariables>(ContactNotesDocument, options);
}
export function useContactNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactNotesQuery, ContactNotesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactNotesQuery, ContactNotesQueryVariables>(ContactNotesDocument, options);
}
// @ts-ignore
export function useContactNotesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactNotesQuery, ContactNotesQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactNotesQuery, ContactNotesQueryVariables>;
export function useContactNotesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactNotesQuery, ContactNotesQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactNotesQuery | undefined, ContactNotesQueryVariables>;
export function useContactNotesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactNotesQuery, ContactNotesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactNotesQuery, ContactNotesQueryVariables>(ContactNotesDocument, options);
}
export type ContactNotesQueryHookResult = ReturnType<typeof useContactNotesQuery>;
export type ContactNotesLazyQueryHookResult = ReturnType<typeof useContactNotesLazyQuery>;
export type ContactNotesSuspenseQueryHookResult = ReturnType<typeof useContactNotesSuspenseQuery>;
export type ContactNotesQueryResult = Apollo.QueryResult<ContactNotesQuery, ContactNotesQueryVariables>;
export const ValidateActivationCodeDocument = gql`
  query ValidateActivationCode($email: String!, $code: String!) {
    validateActivationCode(email: $email, code: $code) {
      message
      data {
        id
        email
        code
        billingPlanPricesId
        createdAt
        updatedAt
        deletedAt
        expiresAt
        usedAt
        billingPlanPrices {
          id
          amount
          periodicity
          isPublished
          position
          rank
          plan {
            id
            label
            name
            slug
            shortDescription
            description
            features
            recommendation
            showAmount
          }
        }
      }
    }
  }
`;

/**
 * __useValidateActivationCodeQuery__
 *
 * To run a query within a React component, call `useValidateActivationCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateActivationCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateActivationCodeQuery({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateActivationCodeQuery(
  baseOptions: Apollo.QueryHookOptions<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables> &
    ({ variables: ValidateActivationCodeQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>(
    ValidateActivationCodeDocument,
    options
  );
}
export function useValidateActivationCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>(
    ValidateActivationCodeDocument,
    options
  );
}
// @ts-ignore
export function useValidateActivationCodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>
): Apollo.UseSuspenseQueryResult<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>;
export function useValidateActivationCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>
): Apollo.UseSuspenseQueryResult<ValidateActivationCodeQuery | undefined, ValidateActivationCodeQueryVariables>;
export function useValidateActivationCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>(
    ValidateActivationCodeDocument,
    options
  );
}
export type ValidateActivationCodeQueryHookResult = ReturnType<typeof useValidateActivationCodeQuery>;
export type ValidateActivationCodeLazyQueryHookResult = ReturnType<typeof useValidateActivationCodeLazyQuery>;
export type ValidateActivationCodeSuspenseQueryHookResult = ReturnType<typeof useValidateActivationCodeSuspenseQuery>;
export type ValidateActivationCodeQueryResult = Apollo.QueryResult<
  ValidateActivationCodeQuery,
  ValidateActivationCodeQueryVariables
>;
export const TagsDocument = gql`
  query Tags($first: Int, $last: Int, $after: String, $before: String, $query: String) {
    tags(first: $first, last: $last, after: $after, before: $before, query: $query) {
      message
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
      edges {
        cursor
        node {
          id
          label
          slug
          type
          color
        }
      }
    }
  }
`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
}
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
}
// @ts-ignore
export function useTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>
): Apollo.UseSuspenseQueryResult<TagsQuery, TagsQueryVariables>;
export function useTagsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>
): Apollo.UseSuspenseQueryResult<TagsQuery | undefined, TagsQueryVariables>;
export function useTagsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
}
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const ContactTagsDocument = gql`
  query ContactTags($first: Int, $last: Int, $after: String, $before: String, $contactId: Int, $sort: SortEnum) {
    contactTags(first: $first, last: $last, after: $after, before: $before, contactId: $contactId, sort: $sort) {
      message
      pageInfo {
        count
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          contactId
          tags {
            id
            label
            slug
            type
            color
          }
        }
      }
    }
  }
`;

/**
 * __useContactTagsQuery__
 *
 * To run a query within a React component, call `useContactTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactTagsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      contactId: // value for 'contactId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useContactTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<ContactTagsQuery, ContactTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactTagsQuery, ContactTagsQueryVariables>(ContactTagsDocument, options);
}
export function useContactTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactTagsQuery, ContactTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactTagsQuery, ContactTagsQueryVariables>(ContactTagsDocument, options);
}
// @ts-ignore
export function useContactTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactTagsQuery, ContactTagsQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactTagsQuery, ContactTagsQueryVariables>;
export function useContactTagsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactTagsQuery, ContactTagsQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactTagsQuery | undefined, ContactTagsQueryVariables>;
export function useContactTagsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactTagsQuery, ContactTagsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactTagsQuery, ContactTagsQueryVariables>(ContactTagsDocument, options);
}
export type ContactTagsQueryHookResult = ReturnType<typeof useContactTagsQuery>;
export type ContactTagsLazyQueryHookResult = ReturnType<typeof useContactTagsLazyQuery>;
export type ContactTagsSuspenseQueryHookResult = ReturnType<typeof useContactTagsSuspenseQuery>;
export type ContactTagsQueryResult = Apollo.QueryResult<ContactTagsQuery, ContactTagsQueryVariables>;
export const GetAssignedChannelsCountDocument = gql`
  query GetAssignedChannelsCount {
    getAssignedChannelsCount {
      message
      count
    }
  }
`;

/**
 * __useGetAssignedChannelsCountQuery__
 *
 * To run a query within a React component, call `useGetAssignedChannelsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedChannelsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedChannelsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssignedChannelsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>(
    GetAssignedChannelsCountDocument,
    options
  );
}
export function useGetAssignedChannelsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>(
    GetAssignedChannelsCountDocument,
    options
  );
}
// @ts-ignore
export function useGetAssignedChannelsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>;
export function useGetAssignedChannelsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAssignedChannelsCountQuery | undefined, GetAssignedChannelsCountQueryVariables>;
export function useGetAssignedChannelsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAssignedChannelsCountQuery, GetAssignedChannelsCountQueryVariables>(
    GetAssignedChannelsCountDocument,
    options
  );
}
export type GetAssignedChannelsCountQueryHookResult = ReturnType<typeof useGetAssignedChannelsCountQuery>;
export type GetAssignedChannelsCountLazyQueryHookResult = ReturnType<typeof useGetAssignedChannelsCountLazyQuery>;
export type GetAssignedChannelsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetAssignedChannelsCountSuspenseQuery
>;
export type GetAssignedChannelsCountQueryResult = Apollo.QueryResult<
  GetAssignedChannelsCountQuery,
  GetAssignedChannelsCountQueryVariables
>;
export const ContactsDocument = gql`
  query Contacts($first: Int, $sort: SortEnum, $order: String, $nameStartsWith: String, $after: String) {
    contacts(first: $first, sort: $sort, order: $order, nameStartsWith: $nameStartsWith, after: $after) {
      message
      edges {
        cursor
        node {
          id
          name
          phoneNumber
          profilePicture {
            id
            url
            originalname
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        startCursor
      }
    }
  }
`;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *      nameStartsWith: // value for 'nameStartsWith'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
}
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
}
// @ts-ignore
export function useContactsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactsQuery, ContactsQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactsQuery, ContactsQueryVariables>;
export function useContactsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsQuery, ContactsQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactsQuery | undefined, ContactsQueryVariables>;
export function useContactsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsQuery, ContactsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
}
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsSuspenseQueryHookResult = ReturnType<typeof useContactsSuspenseQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const ContactDocument = gql`
  query Contact($contactId: Int!) {
    contact(id: $contactId) {
      message
      data {
        id
        name
        phoneNumber
        email
        address
        website
        companyName
        timeZone
        sourceType
        profilePicture {
          id
          url
          originalname
        }
        country {
          id
          flag
          name
        }
      }
    }
  }
`;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactQuery(
  baseOptions: Apollo.QueryHookOptions<ContactQuery, ContactQueryVariables> &
    ({ variables: ContactQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
}
export function useContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
}
// @ts-ignore
export function useContactSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactQuery, ContactQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactQuery, ContactQueryVariables>;
export function useContactSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactQuery, ContactQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactQuery | undefined, ContactQueryVariables>;
export function useContactSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactQuery, ContactQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
}
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactSuspenseQueryHookResult = ReturnType<typeof useContactSuspenseQuery>;
export type ContactQueryResult = Apollo.QueryResult<ContactQuery, ContactQueryVariables>;
export const ListPaymentSourceDocument = gql`
  query ListPaymentSource {
    listPaymentSource {
      message
      data {
        id
        referenceId
        isPrimary
        isSecondary
        gatewayAccountId
        card {
          firstName
          lastName
          last4
          expiryMonth
          expiryYear
          brand
        }
        paymentGateway
        status
        paypal {
          email
        }
      }
    }
  }
`;

/**
 * __useListPaymentSourceQuery__
 *
 * To run a query within a React component, call `useListPaymentSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPaymentSourceQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>(ListPaymentSourceDocument, options);
}
export function useListPaymentSourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>(
    ListPaymentSourceDocument,
    options
  );
}
// @ts-ignore
export function useListPaymentSourceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>
): Apollo.UseSuspenseQueryResult<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>;
export function useListPaymentSourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>
): Apollo.UseSuspenseQueryResult<ListPaymentSourceQuery | undefined, ListPaymentSourceQueryVariables>;
export function useListPaymentSourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>(
    ListPaymentSourceDocument,
    options
  );
}
export type ListPaymentSourceQueryHookResult = ReturnType<typeof useListPaymentSourceQuery>;
export type ListPaymentSourceLazyQueryHookResult = ReturnType<typeof useListPaymentSourceLazyQuery>;
export type ListPaymentSourceSuspenseQueryHookResult = ReturnType<typeof useListPaymentSourceSuspenseQuery>;
export type ListPaymentSourceQueryResult = Apollo.QueryResult<ListPaymentSourceQuery, ListPaymentSourceQueryVariables>;
export const CustomerBillingAddressDocument = gql`
  query CustomerBillingAddress {
    customerBillingAddress {
      data {
        billingAddress {
          first_name
          last_name
          name
          company
          phone
          line1
          line2
          city
          state
          country
          zip
        }
        vatNumber
      }
      message
    }
  }
`;

/**
 * __useCustomerBillingAddressQuery__
 *
 * To run a query within a React component, call `useCustomerBillingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerBillingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerBillingAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerBillingAddressQuery(
  baseOptions?: Apollo.QueryHookOptions<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>(
    CustomerBillingAddressDocument,
    options
  );
}
export function useCustomerBillingAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>(
    CustomerBillingAddressDocument,
    options
  );
}
// @ts-ignore
export function useCustomerBillingAddressSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>
): Apollo.UseSuspenseQueryResult<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>;
export function useCustomerBillingAddressSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>
): Apollo.UseSuspenseQueryResult<CustomerBillingAddressQuery | undefined, CustomerBillingAddressQueryVariables>;
export function useCustomerBillingAddressSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CustomerBillingAddressQuery, CustomerBillingAddressQueryVariables>(
    CustomerBillingAddressDocument,
    options
  );
}
export type CustomerBillingAddressQueryHookResult = ReturnType<typeof useCustomerBillingAddressQuery>;
export type CustomerBillingAddressLazyQueryHookResult = ReturnType<typeof useCustomerBillingAddressLazyQuery>;
export type CustomerBillingAddressSuspenseQueryHookResult = ReturnType<typeof useCustomerBillingAddressSuspenseQuery>;
export type CustomerBillingAddressQueryResult = Apollo.QueryResult<
  CustomerBillingAddressQuery,
  CustomerBillingAddressQueryVariables
>;
export const ListSubscriptionDocument = gql`
  query ListSubscription {
    listSubscription {
      message
      edges {
        id
        customerId
        status
        currentTermEnd
        nextBillingAt
        createdAt
        cancelledAt
        updatedAt
        deleted
        cancelScheduleCreatedAt
        mrr
        itemCount
        itemProductFamily
        discountItems {
          discountType
          discountAmount
          discountPercentage
        }
        subscriptionItems {
          itemPriceId
          itemType
          quantity
          unitPrice
          amount
        }
        billingPeriodUnit
        remainingBillingCycles
        hasScheduledChanges
        scheduledChanges {
          id
          billingPeriodUnit
          remainingBillingCycles
          customerId
          status
          currentTermEnd
          nextBillingAt
          createdAt
          cancelledAt
          updatedAt
          cancelScheduleCreatedAt
          deleted
          currencyCode
          subscriptionItems {
            itemPriceId
            itemType
            quantity
            unitPrice
            amount
          }
          mrr
          itemProductFamily
          itemCount
        }
      }
    }
  }
`;

/**
 * __useListSubscriptionQuery__
 *
 * To run a query within a React component, call `useListSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<ListSubscriptionQuery, ListSubscriptionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListSubscriptionQuery, ListSubscriptionQueryVariables>(ListSubscriptionDocument, options);
}
export function useListSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListSubscriptionQuery, ListSubscriptionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListSubscriptionQuery, ListSubscriptionQueryVariables>(ListSubscriptionDocument, options);
}
// @ts-ignore
export function useListSubscriptionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListSubscriptionQuery, ListSubscriptionQueryVariables>
): Apollo.UseSuspenseQueryResult<ListSubscriptionQuery, ListSubscriptionQueryVariables>;
export function useListSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSubscriptionQuery, ListSubscriptionQueryVariables>
): Apollo.UseSuspenseQueryResult<ListSubscriptionQuery | undefined, ListSubscriptionQueryVariables>;
export function useListSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSubscriptionQuery, ListSubscriptionQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListSubscriptionQuery, ListSubscriptionQueryVariables>(
    ListSubscriptionDocument,
    options
  );
}
export type ListSubscriptionQueryHookResult = ReturnType<typeof useListSubscriptionQuery>;
export type ListSubscriptionLazyQueryHookResult = ReturnType<typeof useListSubscriptionLazyQuery>;
export type ListSubscriptionSuspenseQueryHookResult = ReturnType<typeof useListSubscriptionSuspenseQuery>;
export type ListSubscriptionQueryResult = Apollo.QueryResult<ListSubscriptionQuery, ListSubscriptionQueryVariables>;
export const FetchJournalEntriesDocument = gql`
  query FetchJournalEntries(
    $transactionDateFrom: Date!
    $transactionDateTo: Date!
    $fields: [String]
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $credit: Boolean
    $debit: Boolean
    $chargeType: [ChargeTypeEnum]
    $messageConversationDirection: [DirectionTypeEnum]
    $usageType: [UsageTypeEnum]
  ) {
    fetchJournalEntries(
      transactionDateFrom: $transactionDateFrom
      transactionDateTo: $transactionDateTo
      fields: $fields
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      credit: $credit
      debit: $debit
      chargeType: $chargeType
      messageConversationDirection: $messageConversationDirection
      usageType: $usageType
    ) {
      data {
        balance
        creditAmount
        currencyCode
        debitAmount
        duration
        from
        id
        remarks
        to
        transactionDate
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useFetchJournalEntriesQuery__
 *
 * To run a query within a React component, call `useFetchJournalEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJournalEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJournalEntriesQuery({
 *   variables: {
 *      transactionDateFrom: // value for 'transactionDateFrom'
 *      transactionDateTo: // value for 'transactionDateTo'
 *      fields: // value for 'fields'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      credit: // value for 'credit'
 *      debit: // value for 'debit'
 *      chargeType: // value for 'chargeType'
 *      messageConversationDirection: // value for 'messageConversationDirection'
 *      usageType: // value for 'usageType'
 *   },
 * });
 */
export function useFetchJournalEntriesQuery(
  baseOptions: Apollo.QueryHookOptions<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables> &
    ({ variables: FetchJournalEntriesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>(
    FetchJournalEntriesDocument,
    options
  );
}
export function useFetchJournalEntriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>(
    FetchJournalEntriesDocument,
    options
  );
}
// @ts-ignore
export function useFetchJournalEntriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>
): Apollo.UseSuspenseQueryResult<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>;
export function useFetchJournalEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>
): Apollo.UseSuspenseQueryResult<FetchJournalEntriesQuery | undefined, FetchJournalEntriesQueryVariables>;
export function useFetchJournalEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>(
    FetchJournalEntriesDocument,
    options
  );
}
export type FetchJournalEntriesQueryHookResult = ReturnType<typeof useFetchJournalEntriesQuery>;
export type FetchJournalEntriesLazyQueryHookResult = ReturnType<typeof useFetchJournalEntriesLazyQuery>;
export type FetchJournalEntriesSuspenseQueryHookResult = ReturnType<typeof useFetchJournalEntriesSuspenseQuery>;
export type FetchJournalEntriesQueryResult = Apollo.QueryResult<
  FetchJournalEntriesQuery,
  FetchJournalEntriesQueryVariables
>;
export const GetAutoRechargeConfigsDocument = gql`
  query GetAutoRechargeConfigs {
    getAutoRechargeConfigs {
      message
      data {
        enabled
        creditThreshold
        credit
        targetBalance
        isDisableAllowed
      }
    }
  }
`;

/**
 * __useGetAutoRechargeConfigsQuery__
 *
 * To run a query within a React component, call `useGetAutoRechargeConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoRechargeConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoRechargeConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoRechargeConfigsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>(
    GetAutoRechargeConfigsDocument,
    options
  );
}
export function useGetAutoRechargeConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>(
    GetAutoRechargeConfigsDocument,
    options
  );
}
// @ts-ignore
export function useGetAutoRechargeConfigsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>;
export function useGetAutoRechargeConfigsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAutoRechargeConfigsQuery | undefined, GetAutoRechargeConfigsQueryVariables>;
export function useGetAutoRechargeConfigsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAutoRechargeConfigsQuery, GetAutoRechargeConfigsQueryVariables>(
    GetAutoRechargeConfigsDocument,
    options
  );
}
export type GetAutoRechargeConfigsQueryHookResult = ReturnType<typeof useGetAutoRechargeConfigsQuery>;
export type GetAutoRechargeConfigsLazyQueryHookResult = ReturnType<typeof useGetAutoRechargeConfigsLazyQuery>;
export type GetAutoRechargeConfigsSuspenseQueryHookResult = ReturnType<typeof useGetAutoRechargeConfigsSuspenseQuery>;
export type GetAutoRechargeConfigsQueryResult = Apollo.QueryResult<
  GetAutoRechargeConfigsQuery,
  GetAutoRechargeConfigsQueryVariables
>;
export const GetLowBalanceAlertDocument = gql`
  query GetLowBalanceAlert {
    getLowBalanceAlert {
      message
      data {
        isEmail
        balanceThreshold
      }
    }
  }
`;

/**
 * __useGetLowBalanceAlertQuery__
 *
 * To run a query within a React component, call `useGetLowBalanceAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLowBalanceAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLowBalanceAlertQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLowBalanceAlertQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>(
    GetLowBalanceAlertDocument,
    options
  );
}
export function useGetLowBalanceAlertLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>(
    GetLowBalanceAlertDocument,
    options
  );
}
// @ts-ignore
export function useGetLowBalanceAlertSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>
): Apollo.UseSuspenseQueryResult<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>;
export function useGetLowBalanceAlertSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>
): Apollo.UseSuspenseQueryResult<GetLowBalanceAlertQuery | undefined, GetLowBalanceAlertQueryVariables>;
export function useGetLowBalanceAlertSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLowBalanceAlertQuery, GetLowBalanceAlertQueryVariables>(
    GetLowBalanceAlertDocument,
    options
  );
}
export type GetLowBalanceAlertQueryHookResult = ReturnType<typeof useGetLowBalanceAlertQuery>;
export type GetLowBalanceAlertLazyQueryHookResult = ReturnType<typeof useGetLowBalanceAlertLazyQuery>;
export type GetLowBalanceAlertSuspenseQueryHookResult = ReturnType<typeof useGetLowBalanceAlertSuspenseQuery>;
export type GetLowBalanceAlertQueryResult = Apollo.QueryResult<
  GetLowBalanceAlertQuery,
  GetLowBalanceAlertQueryVariables
>;
export const ObtainNotificationCountDocument = gql`
  query ObtainNotificationCount {
    obtainNotificationCount {
      data
    }
  }
`;

/**
 * __useObtainNotificationCountQuery__
 *
 * To run a query within a React component, call `useObtainNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useObtainNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObtainNotificationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useObtainNotificationCountQuery(
  baseOptions?: Apollo.QueryHookOptions<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>(
    ObtainNotificationCountDocument,
    options
  );
}
export function useObtainNotificationCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>(
    ObtainNotificationCountDocument,
    options
  );
}
// @ts-ignore
export function useObtainNotificationCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>
): Apollo.UseSuspenseQueryResult<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>;
export function useObtainNotificationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>
): Apollo.UseSuspenseQueryResult<ObtainNotificationCountQuery | undefined, ObtainNotificationCountQueryVariables>;
export function useObtainNotificationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ObtainNotificationCountQuery, ObtainNotificationCountQueryVariables>(
    ObtainNotificationCountDocument,
    options
  );
}
export type ObtainNotificationCountQueryHookResult = ReturnType<typeof useObtainNotificationCountQuery>;
export type ObtainNotificationCountLazyQueryHookResult = ReturnType<typeof useObtainNotificationCountLazyQuery>;
export type ObtainNotificationCountSuspenseQueryHookResult = ReturnType<typeof useObtainNotificationCountSuspenseQuery>;
export type ObtainNotificationCountQueryResult = Apollo.QueryResult<
  ObtainNotificationCountQuery,
  ObtainNotificationCountQueryVariables
>;
export const SearchMessageConversationsDocument = gql`
  query SearchMessageConversations(
    $clientId: Int!
    $channelId: Int!
    $query: String!
    $cursor: String
    $limit: Int
    $sort: SortEnum
    $direction: CursorDirectionEnum
    $order: String
  ) {
    searchMessageConversations(
      clientId: $clientId
      channelId: $channelId
      query: $query
      cursor: $cursor
      limit: $limit
      sort: $sort
      direction: $direction
      order: $order
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        cursor
      }
    }
  }
`;

/**
 * __useSearchMessageConversationsQuery__
 *
 * To run a query within a React component, call `useSearchMessageConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMessageConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMessageConversationsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      channelId: // value for 'channelId'
 *      query: // value for 'query'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      direction: // value for 'direction'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchMessageConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchMessageConversationsQuery, SearchMessageConversationsQueryVariables> &
    ({ variables: SearchMessageConversationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchMessageConversationsQuery, SearchMessageConversationsQueryVariables>(
    SearchMessageConversationsDocument,
    options
  );
}
export function useSearchMessageConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchMessageConversationsQuery, SearchMessageConversationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchMessageConversationsQuery, SearchMessageConversationsQueryVariables>(
    SearchMessageConversationsDocument,
    options
  );
}
// @ts-ignore
export function useSearchMessageConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchMessageConversationsQuery,
    SearchMessageConversationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<SearchMessageConversationsQuery, SearchMessageConversationsQueryVariables>;
export function useSearchMessageConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchMessageConversationsQuery, SearchMessageConversationsQueryVariables>
): Apollo.UseSuspenseQueryResult<SearchMessageConversationsQuery | undefined, SearchMessageConversationsQueryVariables>;
export function useSearchMessageConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchMessageConversationsQuery, SearchMessageConversationsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchMessageConversationsQuery, SearchMessageConversationsQueryVariables>(
    SearchMessageConversationsDocument,
    options
  );
}
export type SearchMessageConversationsQueryHookResult = ReturnType<typeof useSearchMessageConversationsQuery>;
export type SearchMessageConversationsLazyQueryHookResult = ReturnType<typeof useSearchMessageConversationsLazyQuery>;
export type SearchMessageConversationsSuspenseQueryHookResult = ReturnType<
  typeof useSearchMessageConversationsSuspenseQuery
>;
export type SearchMessageConversationsQueryResult = Apollo.QueryResult<
  SearchMessageConversationsQuery,
  SearchMessageConversationsQueryVariables
>;
export const GetContactsCountDocument = gql`
  query GetContactsCount($query: String, $sourceType: [ContactSourceTypeEnum], $countryCode: [String], $tags: [Int]) {
    getContactsCount(query: $query, sourceType: $sourceType, countryCode: $countryCode, tags: $tags) {
      count
      message
    }
  }
`;

/**
 * __useGetContactsCountQuery__
 *
 * To run a query within a React component, call `useGetContactsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sourceType: // value for 'sourceType'
 *      countryCode: // value for 'countryCode'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useGetContactsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<GetContactsCountQuery, GetContactsCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContactsCountQuery, GetContactsCountQueryVariables>(GetContactsCountDocument, options);
}
export function useGetContactsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetContactsCountQuery, GetContactsCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContactsCountQuery, GetContactsCountQueryVariables>(GetContactsCountDocument, options);
}
// @ts-ignore
export function useGetContactsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetContactsCountQuery, GetContactsCountQueryVariables>
): Apollo.UseSuspenseQueryResult<GetContactsCountQuery, GetContactsCountQueryVariables>;
export function useGetContactsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContactsCountQuery, GetContactsCountQueryVariables>
): Apollo.UseSuspenseQueryResult<GetContactsCountQuery | undefined, GetContactsCountQueryVariables>;
export function useGetContactsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContactsCountQuery, GetContactsCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetContactsCountQuery, GetContactsCountQueryVariables>(
    GetContactsCountDocument,
    options
  );
}
export type GetContactsCountQueryHookResult = ReturnType<typeof useGetContactsCountQuery>;
export type GetContactsCountLazyQueryHookResult = ReturnType<typeof useGetContactsCountLazyQuery>;
export type GetContactsCountSuspenseQueryHookResult = ReturnType<typeof useGetContactsCountSuspenseQuery>;
export type GetContactsCountQueryResult = Apollo.QueryResult<GetContactsCountQuery, GetContactsCountQueryVariables>;
export const CountMessageConversationsDocument = gql`
  query CountMessageConversations($clientId: Int!, $channelId: Int!, $query: String!) {
    countSearchMessageConversations(clientId: $clientId, channelId: $channelId, query: $query) {
      count
    }
  }
`;

/**
 * __useCountMessageConversationsQuery__
 *
 * To run a query within a React component, call `useCountMessageConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMessageConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMessageConversationsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      channelId: // value for 'channelId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCountMessageConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<CountMessageConversationsQuery, CountMessageConversationsQueryVariables> &
    ({ variables: CountMessageConversationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountMessageConversationsQuery, CountMessageConversationsQueryVariables>(
    CountMessageConversationsDocument,
    options
  );
}
export function useCountMessageConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountMessageConversationsQuery, CountMessageConversationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountMessageConversationsQuery, CountMessageConversationsQueryVariables>(
    CountMessageConversationsDocument,
    options
  );
}
// @ts-ignore
export function useCountMessageConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CountMessageConversationsQuery, CountMessageConversationsQueryVariables>
): Apollo.UseSuspenseQueryResult<CountMessageConversationsQuery, CountMessageConversationsQueryVariables>;
export function useCountMessageConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CountMessageConversationsQuery, CountMessageConversationsQueryVariables>
): Apollo.UseSuspenseQueryResult<CountMessageConversationsQuery | undefined, CountMessageConversationsQueryVariables>;
export function useCountMessageConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CountMessageConversationsQuery, CountMessageConversationsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CountMessageConversationsQuery, CountMessageConversationsQueryVariables>(
    CountMessageConversationsDocument,
    options
  );
}
export type CountMessageConversationsQueryHookResult = ReturnType<typeof useCountMessageConversationsQuery>;
export type CountMessageConversationsLazyQueryHookResult = ReturnType<typeof useCountMessageConversationsLazyQuery>;
export type CountMessageConversationsSuspenseQueryHookResult = ReturnType<
  typeof useCountMessageConversationsSuspenseQuery
>;
export type CountMessageConversationsQueryResult = Apollo.QueryResult<
  CountMessageConversationsQuery,
  CountMessageConversationsQueryVariables
>;
export const ContactSourceTypesDocument = gql`
  query ContactSourceTypes {
    contactSourceTypes {
      message
      data {
        sourceType
      }
    }
  }
`;

/**
 * __useContactSourceTypesQuery__
 *
 * To run a query within a React component, call `useContactSourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactSourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactSourceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactSourceTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>(
    ContactSourceTypesDocument,
    options
  );
}
export function useContactSourceTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>(
    ContactSourceTypesDocument,
    options
  );
}
// @ts-ignore
export function useContactSourceTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>;
export function useContactSourceTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>
): Apollo.UseSuspenseQueryResult<ContactSourceTypesQuery | undefined, ContactSourceTypesQueryVariables>;
export function useContactSourceTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ContactSourceTypesQuery, ContactSourceTypesQueryVariables>(
    ContactSourceTypesDocument,
    options
  );
}
export type ContactSourceTypesQueryHookResult = ReturnType<typeof useContactSourceTypesQuery>;
export type ContactSourceTypesLazyQueryHookResult = ReturnType<typeof useContactSourceTypesLazyQuery>;
export type ContactSourceTypesSuspenseQueryHookResult = ReturnType<typeof useContactSourceTypesSuspenseQuery>;
export type ContactSourceTypesQueryResult = Apollo.QueryResult<
  ContactSourceTypesQuery,
  ContactSourceTypesQueryVariables
>;
export const CheckMemberEmailExistDocument = gql`
  query CheckMemberEmailExist($email: String!) {
    checkMemberEmailExist(email: $email) {
      message
      data {
        exists
      }
    }
  }
`;

/**
 * __useCheckMemberEmailExistQuery__
 *
 * To run a query within a React component, call `useCheckMemberEmailExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMemberEmailExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMemberEmailExistQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckMemberEmailExistQuery(
  baseOptions: Apollo.QueryHookOptions<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables> &
    ({ variables: CheckMemberEmailExistQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables>(
    CheckMemberEmailExistDocument,
    options
  );
}
export function useCheckMemberEmailExistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables>(
    CheckMemberEmailExistDocument,
    options
  );
}
// @ts-ignore
export function useCheckMemberEmailExistSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables>
): Apollo.UseSuspenseQueryResult<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables>;
export function useCheckMemberEmailExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables>
): Apollo.UseSuspenseQueryResult<CheckMemberEmailExistQuery | undefined, CheckMemberEmailExistQueryVariables>;
export function useCheckMemberEmailExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckMemberEmailExistQuery, CheckMemberEmailExistQueryVariables>(
    CheckMemberEmailExistDocument,
    options
  );
}
export type CheckMemberEmailExistQueryHookResult = ReturnType<typeof useCheckMemberEmailExistQuery>;
export type CheckMemberEmailExistLazyQueryHookResult = ReturnType<typeof useCheckMemberEmailExistLazyQuery>;
export type CheckMemberEmailExistSuspenseQueryHookResult = ReturnType<typeof useCheckMemberEmailExistSuspenseQuery>;
export type CheckMemberEmailExistQueryResult = Apollo.QueryResult<
  CheckMemberEmailExistQuery,
  CheckMemberEmailExistQueryVariables
>;
export const ExportJournalEntriesDocument = gql`
  query ExportJournalEntries(
    $transactionDateFrom: Date!
    $transactionDateTo: Date!
    $credit: Boolean
    $chargeType: [ChargeTypeEnum]
    $messageConversationDirection: [DirectionTypeEnum]
    $usageType: [UsageTypeEnum]
    $fields: [String]
  ) {
    exportJournalEntries(
      transactionDateFrom: $transactionDateFrom
      transactionDateTo: $transactionDateTo
      credit: $credit
      chargeType: $chargeType
      messageConversationDirection: $messageConversationDirection
      usageType: $usageType
      fields: $fields
    ) {
      message
    }
  }
`;

/**
 * __useExportJournalEntriesQuery__
 *
 * To run a query within a React component, call `useExportJournalEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportJournalEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportJournalEntriesQuery({
 *   variables: {
 *      transactionDateFrom: // value for 'transactionDateFrom'
 *      transactionDateTo: // value for 'transactionDateTo'
 *      credit: // value for 'credit'
 *      chargeType: // value for 'chargeType'
 *      messageConversationDirection: // value for 'messageConversationDirection'
 *      usageType: // value for 'usageType'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useExportJournalEntriesQuery(
  baseOptions: Apollo.QueryHookOptions<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables> &
    ({ variables: ExportJournalEntriesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables>(
    ExportJournalEntriesDocument,
    options
  );
}
export function useExportJournalEntriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables>(
    ExportJournalEntriesDocument,
    options
  );
}
// @ts-ignore
export function useExportJournalEntriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables>
): Apollo.UseSuspenseQueryResult<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables>;
export function useExportJournalEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables>
): Apollo.UseSuspenseQueryResult<ExportJournalEntriesQuery | undefined, ExportJournalEntriesQueryVariables>;
export function useExportJournalEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportJournalEntriesQuery, ExportJournalEntriesQueryVariables>(
    ExportJournalEntriesDocument,
    options
  );
}
export type ExportJournalEntriesQueryHookResult = ReturnType<typeof useExportJournalEntriesQuery>;
export type ExportJournalEntriesLazyQueryHookResult = ReturnType<typeof useExportJournalEntriesLazyQuery>;
export type ExportJournalEntriesSuspenseQueryHookResult = ReturnType<typeof useExportJournalEntriesSuspenseQuery>;
export type ExportJournalEntriesQueryResult = Apollo.QueryResult<
  ExportJournalEntriesQuery,
  ExportJournalEntriesQueryVariables
>;
export const FetchSingleRecentMessageConversationDocument = gql`
  query FetchSingleRecentMessageConversation($channelId: Int, $phoneNumber: String) {
    fetchSingleRecentMessageConversation(channelId: $channelId, phoneNumber: $phoneNumber) {
      data {
        id
        client {
          id
        }
      }
    }
  }
`;

/**
 * __useFetchSingleRecentMessageConversationQuery__
 *
 * To run a query within a React component, call `useFetchSingleRecentMessageConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSingleRecentMessageConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSingleRecentMessageConversationQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useFetchSingleRecentMessageConversationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchSingleRecentMessageConversationQuery,
    FetchSingleRecentMessageConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchSingleRecentMessageConversationQuery, FetchSingleRecentMessageConversationQueryVariables>(
    FetchSingleRecentMessageConversationDocument,
    options
  );
}
export function useFetchSingleRecentMessageConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchSingleRecentMessageConversationQuery,
    FetchSingleRecentMessageConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchSingleRecentMessageConversationQuery,
    FetchSingleRecentMessageConversationQueryVariables
  >(FetchSingleRecentMessageConversationDocument, options);
}
// @ts-ignore
export function useFetchSingleRecentMessageConversationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchSingleRecentMessageConversationQuery,
    FetchSingleRecentMessageConversationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  FetchSingleRecentMessageConversationQuery,
  FetchSingleRecentMessageConversationQueryVariables
>;
export function useFetchSingleRecentMessageConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchSingleRecentMessageConversationQuery,
        FetchSingleRecentMessageConversationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  FetchSingleRecentMessageConversationQuery | undefined,
  FetchSingleRecentMessageConversationQueryVariables
>;
export function useFetchSingleRecentMessageConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchSingleRecentMessageConversationQuery,
        FetchSingleRecentMessageConversationQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchSingleRecentMessageConversationQuery,
    FetchSingleRecentMessageConversationQueryVariables
  >(FetchSingleRecentMessageConversationDocument, options);
}
export type FetchSingleRecentMessageConversationQueryHookResult = ReturnType<
  typeof useFetchSingleRecentMessageConversationQuery
>;
export type FetchSingleRecentMessageConversationLazyQueryHookResult = ReturnType<
  typeof useFetchSingleRecentMessageConversationLazyQuery
>;
export type FetchSingleRecentMessageConversationSuspenseQueryHookResult = ReturnType<
  typeof useFetchSingleRecentMessageConversationSuspenseQuery
>;
export type FetchSingleRecentMessageConversationQueryResult = Apollo.QueryResult<
  FetchSingleRecentMessageConversationQuery,
  FetchSingleRecentMessageConversationQueryVariables
>;
export const CountPinnedMessageConversationsDocument = gql`
  query CountPinnedMessageConversations($clientId: Int!, $channelId: Int!) {
    countPinnedMessageConversations(clientId: $clientId, channelId: $channelId) {
      count
    }
  }
`;

/**
 * __useCountPinnedMessageConversationsQuery__
 *
 * To run a query within a React component, call `useCountPinnedMessageConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPinnedMessageConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPinnedMessageConversationsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useCountPinnedMessageConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CountPinnedMessageConversationsQuery,
    CountPinnedMessageConversationsQueryVariables
  > &
    ({ variables: CountPinnedMessageConversationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountPinnedMessageConversationsQuery, CountPinnedMessageConversationsQueryVariables>(
    CountPinnedMessageConversationsDocument,
    options
  );
}
export function useCountPinnedMessageConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CountPinnedMessageConversationsQuery,
    CountPinnedMessageConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountPinnedMessageConversationsQuery, CountPinnedMessageConversationsQueryVariables>(
    CountPinnedMessageConversationsDocument,
    options
  );
}
// @ts-ignore
export function useCountPinnedMessageConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CountPinnedMessageConversationsQuery,
    CountPinnedMessageConversationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<CountPinnedMessageConversationsQuery, CountPinnedMessageConversationsQueryVariables>;
export function useCountPinnedMessageConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CountPinnedMessageConversationsQuery,
        CountPinnedMessageConversationsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CountPinnedMessageConversationsQuery | undefined,
  CountPinnedMessageConversationsQueryVariables
>;
export function useCountPinnedMessageConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CountPinnedMessageConversationsQuery,
        CountPinnedMessageConversationsQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CountPinnedMessageConversationsQuery, CountPinnedMessageConversationsQueryVariables>(
    CountPinnedMessageConversationsDocument,
    options
  );
}
export type CountPinnedMessageConversationsQueryHookResult = ReturnType<typeof useCountPinnedMessageConversationsQuery>;
export type CountPinnedMessageConversationsLazyQueryHookResult = ReturnType<
  typeof useCountPinnedMessageConversationsLazyQuery
>;
export type CountPinnedMessageConversationsSuspenseQueryHookResult = ReturnType<
  typeof useCountPinnedMessageConversationsSuspenseQuery
>;
export type CountPinnedMessageConversationsQueryResult = Apollo.QueryResult<
  CountPinnedMessageConversationsQuery,
  CountPinnedMessageConversationsQueryVariables
>;
export const GetMemberRoomDocument = gql`
  query GetMemberRoom($input: InputRoom!) {
    getMemberRoom(input: $input) {
      message
      data {
        id
        label
        identity
        type
        isPublic
      }
    }
  }
`;

/**
 * __useGetMemberRoomQuery__
 *
 * To run a query within a React component, call `useGetMemberRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberRoomQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMemberRoomQuery(
  baseOptions: Apollo.QueryHookOptions<GetMemberRoomQuery, GetMemberRoomQueryVariables> &
    ({ variables: GetMemberRoomQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMemberRoomQuery, GetMemberRoomQueryVariables>(GetMemberRoomDocument, options);
}
export function useGetMemberRoomLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMemberRoomQuery, GetMemberRoomQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMemberRoomQuery, GetMemberRoomQueryVariables>(GetMemberRoomDocument, options);
}
// @ts-ignore
export function useGetMemberRoomSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberRoomQuery, GetMemberRoomQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMemberRoomQuery, GetMemberRoomQueryVariables>;
export function useGetMemberRoomSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMemberRoomQuery, GetMemberRoomQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMemberRoomQuery | undefined, GetMemberRoomQueryVariables>;
export function useGetMemberRoomSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMemberRoomQuery, GetMemberRoomQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMemberRoomQuery, GetMemberRoomQueryVariables>(GetMemberRoomDocument, options);
}
export type GetMemberRoomQueryHookResult = ReturnType<typeof useGetMemberRoomQuery>;
export type GetMemberRoomLazyQueryHookResult = ReturnType<typeof useGetMemberRoomLazyQuery>;
export type GetMemberRoomSuspenseQueryHookResult = ReturnType<typeof useGetMemberRoomSuspenseQuery>;
export type GetMemberRoomQueryResult = Apollo.QueryResult<GetMemberRoomQuery, GetMemberRoomQueryVariables>;
export const CountSearchChatMessagesDocument = gql`
  query CountSearchChatMessages($roomId: Int!, $query: String!) {
    countSearchChatMessages(roomId: $roomId, query: $query) {
      count
    }
  }
`;

/**
 * __useCountSearchChatMessagesQuery__
 *
 * To run a query within a React component, call `useCountSearchChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountSearchChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountSearchChatMessagesQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCountSearchChatMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables> &
    ({ variables: CountSearchChatMessagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables>(
    CountSearchChatMessagesDocument,
    options
  );
}
export function useCountSearchChatMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables>(
    CountSearchChatMessagesDocument,
    options
  );
}
// @ts-ignore
export function useCountSearchChatMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables>
): Apollo.UseSuspenseQueryResult<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables>;
export function useCountSearchChatMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables>
): Apollo.UseSuspenseQueryResult<CountSearchChatMessagesQuery | undefined, CountSearchChatMessagesQueryVariables>;
export function useCountSearchChatMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CountSearchChatMessagesQuery, CountSearchChatMessagesQueryVariables>(
    CountSearchChatMessagesDocument,
    options
  );
}
export type CountSearchChatMessagesQueryHookResult = ReturnType<typeof useCountSearchChatMessagesQuery>;
export type CountSearchChatMessagesLazyQueryHookResult = ReturnType<typeof useCountSearchChatMessagesLazyQuery>;
export type CountSearchChatMessagesSuspenseQueryHookResult = ReturnType<typeof useCountSearchChatMessagesSuspenseQuery>;
export type CountSearchChatMessagesQueryResult = Apollo.QueryResult<
  CountSearchChatMessagesQuery,
  CountSearchChatMessagesQueryVariables
>;
export const CountPinnedChatMessagesDocument = gql`
  query CountPinnedChatMessages($roomId: Int!) {
    countPinnedChatMessages(roomId: $roomId) {
      count
      message
    }
  }
`;

/**
 * __useCountPinnedChatMessagesQuery__
 *
 * To run a query within a React component, call `useCountPinnedChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPinnedChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPinnedChatMessagesQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useCountPinnedChatMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables> &
    ({ variables: CountPinnedChatMessagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables>(
    CountPinnedChatMessagesDocument,
    options
  );
}
export function useCountPinnedChatMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables>(
    CountPinnedChatMessagesDocument,
    options
  );
}
// @ts-ignore
export function useCountPinnedChatMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables>
): Apollo.UseSuspenseQueryResult<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables>;
export function useCountPinnedChatMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables>
): Apollo.UseSuspenseQueryResult<CountPinnedChatMessagesQuery | undefined, CountPinnedChatMessagesQueryVariables>;
export function useCountPinnedChatMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CountPinnedChatMessagesQuery, CountPinnedChatMessagesQueryVariables>(
    CountPinnedChatMessagesDocument,
    options
  );
}
export type CountPinnedChatMessagesQueryHookResult = ReturnType<typeof useCountPinnedChatMessagesQuery>;
export type CountPinnedChatMessagesLazyQueryHookResult = ReturnType<typeof useCountPinnedChatMessagesLazyQuery>;
export type CountPinnedChatMessagesSuspenseQueryHookResult = ReturnType<typeof useCountPinnedChatMessagesSuspenseQuery>;
export type CountPinnedChatMessagesQueryResult = Apollo.QueryResult<
  CountPinnedChatMessagesQuery,
  CountPinnedChatMessagesQueryVariables
>;
export const SearchChatMessagesDocument = gql`
  query SearchChatMessages(
    $roomId: Int!
    $query: String!
    $cursor: String
    $order: String
    $sort: SortEnum
    $withCursor: Boolean
    $direction: CursorDirectionEnum
    $limit: Int
  ) {
    searchChatMessages(
      roomId: $roomId
      query: $query
      cursor: $cursor
      order: $order
      sort: $sort
      withCursor: $withCursor
      direction: $direction
      limit: $limit
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        cursor
      }
    }
  }
`;

/**
 * __useSearchChatMessagesQuery__
 *
 * To run a query within a React component, call `useSearchChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchChatMessagesQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      query: // value for 'query'
 *      cursor: // value for 'cursor'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      withCursor: // value for 'withCursor'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchChatMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<SearchChatMessagesQuery, SearchChatMessagesQueryVariables> &
    ({ variables: SearchChatMessagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchChatMessagesQuery, SearchChatMessagesQueryVariables>(
    SearchChatMessagesDocument,
    options
  );
}
export function useSearchChatMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchChatMessagesQuery, SearchChatMessagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchChatMessagesQuery, SearchChatMessagesQueryVariables>(
    SearchChatMessagesDocument,
    options
  );
}
// @ts-ignore
export function useSearchChatMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SearchChatMessagesQuery, SearchChatMessagesQueryVariables>
): Apollo.UseSuspenseQueryResult<SearchChatMessagesQuery, SearchChatMessagesQueryVariables>;
export function useSearchChatMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchChatMessagesQuery, SearchChatMessagesQueryVariables>
): Apollo.UseSuspenseQueryResult<SearchChatMessagesQuery | undefined, SearchChatMessagesQueryVariables>;
export function useSearchChatMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchChatMessagesQuery, SearchChatMessagesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchChatMessagesQuery, SearchChatMessagesQueryVariables>(
    SearchChatMessagesDocument,
    options
  );
}
export type SearchChatMessagesQueryHookResult = ReturnType<typeof useSearchChatMessagesQuery>;
export type SearchChatMessagesLazyQueryHookResult = ReturnType<typeof useSearchChatMessagesLazyQuery>;
export type SearchChatMessagesSuspenseQueryHookResult = ReturnType<typeof useSearchChatMessagesSuspenseQuery>;
export type SearchChatMessagesQueryResult = Apollo.QueryResult<
  SearchChatMessagesQuery,
  SearchChatMessagesQueryVariables
>;
export const CountTeamsDocument = gql`
  query CountTeams($query: String) {
    countTeams(query: $query) {
      count
      message
    }
  }
`;

/**
 * __useCountTeamsQuery__
 *
 * To run a query within a React component, call `useCountTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTeamsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCountTeamsQuery(baseOptions?: Apollo.QueryHookOptions<CountTeamsQuery, CountTeamsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountTeamsQuery, CountTeamsQueryVariables>(CountTeamsDocument, options);
}
export function useCountTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountTeamsQuery, CountTeamsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountTeamsQuery, CountTeamsQueryVariables>(CountTeamsDocument, options);
}
// @ts-ignore
export function useCountTeamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CountTeamsQuery, CountTeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<CountTeamsQuery, CountTeamsQueryVariables>;
export function useCountTeamsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTeamsQuery, CountTeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<CountTeamsQuery | undefined, CountTeamsQueryVariables>;
export function useCountTeamsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTeamsQuery, CountTeamsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CountTeamsQuery, CountTeamsQueryVariables>(CountTeamsDocument, options);
}
export type CountTeamsQueryHookResult = ReturnType<typeof useCountTeamsQuery>;
export type CountTeamsLazyQueryHookResult = ReturnType<typeof useCountTeamsLazyQuery>;
export type CountTeamsSuspenseQueryHookResult = ReturnType<typeof useCountTeamsSuspenseQuery>;
export type CountTeamsQueryResult = Apollo.QueryResult<CountTeamsQuery, CountTeamsQueryVariables>;
export const ActiveWorkspacesV2Document = gql`
  query ActiveWorkspacesV2($cursor: String, $withCursor: Boolean, $limit: Int, $query: String, $sort: SortEnum) {
    activeWorkspacesV2(cursor: $cursor, withCursor: $withCursor, limit: $limit, query: $query, sort: $sort) {
      cursor {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      data {
        active
        availableBalance
        id
        isCurrent
        label
        logo {
          url
          id
        }
        numberOfUsers
        owner {
          accountStatus
          coverProfilePicture {
            url
            id
          }
          id
          lastPasswordResetAt
          name
          roles {
            id
            isActive
            label
          }
        }
        status
        unreadCountWorkspace
      }
    }
  }
`;

/**
 * __useActiveWorkspacesV2Query__
 *
 * To run a query within a React component, call `useActiveWorkspacesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useActiveWorkspacesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveWorkspacesV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useActiveWorkspacesV2Query(
  baseOptions?: Apollo.QueryHookOptions<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>(
    ActiveWorkspacesV2Document,
    options
  );
}
export function useActiveWorkspacesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>(
    ActiveWorkspacesV2Document,
    options
  );
}
// @ts-ignore
export function useActiveWorkspacesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>;
export function useActiveWorkspacesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<ActiveWorkspacesV2Query | undefined, ActiveWorkspacesV2QueryVariables>;
export function useActiveWorkspacesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables>(
    ActiveWorkspacesV2Document,
    options
  );
}
export type ActiveWorkspacesV2QueryHookResult = ReturnType<typeof useActiveWorkspacesV2Query>;
export type ActiveWorkspacesV2LazyQueryHookResult = ReturnType<typeof useActiveWorkspacesV2LazyQuery>;
export type ActiveWorkspacesV2SuspenseQueryHookResult = ReturnType<typeof useActiveWorkspacesV2SuspenseQuery>;
export type ActiveWorkspacesV2QueryResult = Apollo.QueryResult<
  ActiveWorkspacesV2Query,
  ActiveWorkspacesV2QueryVariables
>;
export const CountMembersDocument = gql`
  query CountMembers($query: String) {
    countMembers(query: $query) {
      data {
        key
        value
      }
      message
    }
  }
`;

/**
 * __useCountMembersQuery__
 *
 * To run a query within a React component, call `useCountMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMembersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCountMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<CountMembersQuery, CountMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountMembersQuery, CountMembersQueryVariables>(CountMembersDocument, options);
}
export function useCountMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountMembersQuery, CountMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountMembersQuery, CountMembersQueryVariables>(CountMembersDocument, options);
}
// @ts-ignore
export function useCountMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CountMembersQuery, CountMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<CountMembersQuery, CountMembersQueryVariables>;
export function useCountMembersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountMembersQuery, CountMembersQueryVariables>
): Apollo.UseSuspenseQueryResult<CountMembersQuery | undefined, CountMembersQueryVariables>;
export function useCountMembersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountMembersQuery, CountMembersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CountMembersQuery, CountMembersQueryVariables>(CountMembersDocument, options);
}
export type CountMembersQueryHookResult = ReturnType<typeof useCountMembersQuery>;
export type CountMembersLazyQueryHookResult = ReturnType<typeof useCountMembersLazyQuery>;
export type CountMembersSuspenseQueryHookResult = ReturnType<typeof useCountMembersSuspenseQuery>;
export type CountMembersQueryResult = Apollo.QueryResult<CountMembersQuery, CountMembersQueryVariables>;
export const MessageAttachmentsDocument = gql`
  query MessageAttachments($friendlyName: String!) {
    messageAttachments(friendlyName: $friendlyName) {
      message
      data {
        id
        identity
        mimetype
        url
      }
    }
  }
`;

/**
 * __useMessageAttachmentsQuery__
 *
 * To run a query within a React component, call `useMessageAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAttachmentsQuery({
 *   variables: {
 *      friendlyName: // value for 'friendlyName'
 *   },
 * });
 */
export function useMessageAttachmentsQuery(
  baseOptions: Apollo.QueryHookOptions<MessageAttachmentsQuery, MessageAttachmentsQueryVariables> &
    ({ variables: MessageAttachmentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MessageAttachmentsQuery, MessageAttachmentsQueryVariables>(
    MessageAttachmentsDocument,
    options
  );
}
export function useMessageAttachmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MessageAttachmentsQuery, MessageAttachmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MessageAttachmentsQuery, MessageAttachmentsQueryVariables>(
    MessageAttachmentsDocument,
    options
  );
}
// @ts-ignore
export function useMessageAttachmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MessageAttachmentsQuery, MessageAttachmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<MessageAttachmentsQuery, MessageAttachmentsQueryVariables>;
export function useMessageAttachmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessageAttachmentsQuery, MessageAttachmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<MessageAttachmentsQuery | undefined, MessageAttachmentsQueryVariables>;
export function useMessageAttachmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessageAttachmentsQuery, MessageAttachmentsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MessageAttachmentsQuery, MessageAttachmentsQueryVariables>(
    MessageAttachmentsDocument,
    options
  );
}
export type MessageAttachmentsQueryHookResult = ReturnType<typeof useMessageAttachmentsQuery>;
export type MessageAttachmentsLazyQueryHookResult = ReturnType<typeof useMessageAttachmentsLazyQuery>;
export type MessageAttachmentsSuspenseQueryHookResult = ReturnType<typeof useMessageAttachmentsSuspenseQuery>;
export type MessageAttachmentsQueryResult = Apollo.QueryResult<
  MessageAttachmentsQuery,
  MessageAttachmentsQueryVariables
>;
export const draftMessageDocument = gql`
  query draftMessage($clientId: Int!, $channelId: Int!) {
    draftMessage(clientId: $clientId, channelId: $channelId) {
      data {
        id
        messageContent
        createdAt
        updatedAt
        medias {
          id
          url
          mimetype
          size
        }
      }
      message
    }
  }
`;

/**
 * __usedraftMessageQuery__
 *
 * To run a query within a React component, call `usedraftMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `usedraftMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usedraftMessageQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usedraftMessageQuery(
  baseOptions: Apollo.QueryHookOptions<draftMessageQuery, draftMessageQueryVariables> &
    ({ variables: draftMessageQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<draftMessageQuery, draftMessageQueryVariables>(draftMessageDocument, options);
}
export function usedraftMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<draftMessageQuery, draftMessageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<draftMessageQuery, draftMessageQueryVariables>(draftMessageDocument, options);
}
// @ts-ignore
export function usedraftMessageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<draftMessageQuery, draftMessageQueryVariables>
): Apollo.UseSuspenseQueryResult<draftMessageQuery, draftMessageQueryVariables>;
export function usedraftMessageSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<draftMessageQuery, draftMessageQueryVariables>
): Apollo.UseSuspenseQueryResult<draftMessageQuery | undefined, draftMessageQueryVariables>;
export function usedraftMessageSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<draftMessageQuery, draftMessageQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<draftMessageQuery, draftMessageQueryVariables>(draftMessageDocument, options);
}
export type draftMessageQueryHookResult = ReturnType<typeof usedraftMessageQuery>;
export type draftMessageLazyQueryHookResult = ReturnType<typeof usedraftMessageLazyQuery>;
export type draftMessageSuspenseQueryHookResult = ReturnType<typeof usedraftMessageSuspenseQuery>;
export type draftMessageQueryResult = Apollo.QueryResult<draftMessageQuery, draftMessageQueryVariables>;
export const InvoicesV2Document = gql`
  query InvoicesV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $status: InvoiceStatusEnum
    $transactionDateFrom: Date
    $transactionDateTo: Date
  ) {
    invoicesV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      status: $status
      transactionDateFrom: $transactionDateFrom
      transactionDateTo: $transactionDateTo
    ) {
      message
      data {
        id
        type
        status
        totalAmount
        invoiceNo
        transactionId
        transactionDate
        billingCycleDate
        currency
        creditsApplied
        subTotalAmount
        discountPercentage
        discountAmount
        totalRefundedAmount
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useInvoicesV2Query__
 *
 * To run a query within a React component, call `useInvoicesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesV2Query({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *      status: // value for 'status'
 *      transactionDateFrom: // value for 'transactionDateFrom'
 *      transactionDateTo: // value for 'transactionDateTo'
 *   },
 * });
 */
export function useInvoicesV2Query(baseOptions?: Apollo.QueryHookOptions<InvoicesV2Query, InvoicesV2QueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InvoicesV2Query, InvoicesV2QueryVariables>(InvoicesV2Document, options);
}
export function useInvoicesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InvoicesV2Query, InvoicesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InvoicesV2Query, InvoicesV2QueryVariables>(InvoicesV2Document, options);
}
// @ts-ignore
export function useInvoicesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicesV2Query, InvoicesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<InvoicesV2Query, InvoicesV2QueryVariables>;
export function useInvoicesV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoicesV2Query, InvoicesV2QueryVariables>
): Apollo.UseSuspenseQueryResult<InvoicesV2Query | undefined, InvoicesV2QueryVariables>;
export function useInvoicesV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoicesV2Query, InvoicesV2QueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InvoicesV2Query, InvoicesV2QueryVariables>(InvoicesV2Document, options);
}
export type InvoicesV2QueryHookResult = ReturnType<typeof useInvoicesV2Query>;
export type InvoicesV2LazyQueryHookResult = ReturnType<typeof useInvoicesV2LazyQuery>;
export type InvoicesV2SuspenseQueryHookResult = ReturnType<typeof useInvoicesV2SuspenseQuery>;
export type InvoicesV2QueryResult = Apollo.QueryResult<InvoicesV2Query, InvoicesV2QueryVariables>;
export const InvoiceDocument = gql`
  query Invoice($invoiceId: Int) {
    invoice(id: $invoiceId) {
      message
      data {
        id
        invoiceNo
        status
        transactionDate
        transactionId
        type
        billingCycleDate
        currency
        totalAmount
        subTotalAmount
        creditsApplied
        discountPercentage
        discountAmount
        customer {
          email
          billingAddress {
            city
            company
            country
            first_name
            last_name
            state
            phone
          }
          vatNumber
        }
        invoiceItems {
          id
          amount
          invoiceId
          quantity
          remarks
          numberType
          country {
            name
          }
          phoneNumbers
          meta
        }
      }
    }
  }
`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
}
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
}
// @ts-ignore
export function useInvoiceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>
): Apollo.UseSuspenseQueryResult<InvoiceQuery, InvoiceQueryVariables>;
export function useInvoiceSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>
): Apollo.UseSuspenseQueryResult<InvoiceQuery | undefined, InvoiceQueryVariables>;
export function useInvoiceSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
}
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceSuspenseQueryHookResult = ReturnType<typeof useInvoiceSuspenseQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const GetUserOnlineStatusDocument = gql`
  query GetUserOnlineStatus($userWorkspaceId: Int) {
    getUserOnlineStatus(userWorkspaceId: $userWorkspaceId) {
      data {
        activeStatus
        awaySet
        awayTill
        icon
        message
      }
    }
  }
`;

/**
 * __useGetUserOnlineStatusQuery__
 *
 * To run a query within a React component, call `useGetUserOnlineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOnlineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOnlineStatusQuery({
 *   variables: {
 *      userWorkspaceId: // value for 'userWorkspaceId'
 *   },
 * });
 */
export function useGetUserOnlineStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>(
    GetUserOnlineStatusDocument,
    options
  );
}
export function useGetUserOnlineStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>(
    GetUserOnlineStatusDocument,
    options
  );
}
// @ts-ignore
export function useGetUserOnlineStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>
): Apollo.UseSuspenseQueryResult<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>;
export function useGetUserOnlineStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>
): Apollo.UseSuspenseQueryResult<GetUserOnlineStatusQuery | undefined, GetUserOnlineStatusQueryVariables>;
export function useGetUserOnlineStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserOnlineStatusQuery, GetUserOnlineStatusQueryVariables>(
    GetUserOnlineStatusDocument,
    options
  );
}
export type GetUserOnlineStatusQueryHookResult = ReturnType<typeof useGetUserOnlineStatusQuery>;
export type GetUserOnlineStatusLazyQueryHookResult = ReturnType<typeof useGetUserOnlineStatusLazyQuery>;
export type GetUserOnlineStatusSuspenseQueryHookResult = ReturnType<typeof useGetUserOnlineStatusSuspenseQuery>;
export type GetUserOnlineStatusQueryResult = Apollo.QueryResult<
  GetUserOnlineStatusQuery,
  GetUserOnlineStatusQueryVariables
>;
export const CartsDocument = gql`
  query Carts {
    carts {
      message
      data {
        addressRequirements
        isoCountry
        friendlyName
        phoneNumber
        region
        rateCenter
        capabilities {
          voice
          SMS
          MMS
        }
        endUser
        supportingDocument
        currentPrice
        basePrice
        numberType
      }
    }
  }
`;

/**
 * __useCartsQuery__
 *
 * To run a query within a React component, call `useCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartsQuery(baseOptions?: Apollo.QueryHookOptions<CartsQuery, CartsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CartsQuery, CartsQueryVariables>(CartsDocument, options);
}
export function useCartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartsQuery, CartsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CartsQuery, CartsQueryVariables>(CartsDocument, options);
}
// @ts-ignore
export function useCartsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CartsQuery, CartsQueryVariables>
): Apollo.UseSuspenseQueryResult<CartsQuery, CartsQueryVariables>;
export function useCartsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartsQuery, CartsQueryVariables>
): Apollo.UseSuspenseQueryResult<CartsQuery | undefined, CartsQueryVariables>;
export function useCartsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartsQuery, CartsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CartsQuery, CartsQueryVariables>(CartsDocument, options);
}
export type CartsQueryHookResult = ReturnType<typeof useCartsQuery>;
export type CartsLazyQueryHookResult = ReturnType<typeof useCartsLazyQuery>;
export type CartsSuspenseQueryHookResult = ReturnType<typeof useCartsSuspenseQuery>;
export type CartsQueryResult = Apollo.QueryResult<CartsQuery, CartsQueryVariables>;
export const CheckRegulatoryComplianceDocument = gql`
  query CheckRegulatoryCompliance($isoCountry: String!, $numberType: NumberTypeEnum!, $addressRequirements: String!) {
    checkRegulatoryCompliance(
      isoCountry: $isoCountry
      numberType: $numberType
      addressRequirements: $addressRequirements
    ) {
      message
      data {
        regulatoryCompliance
        approvedRegulatoryCompliance {
          identity
          address
          endUserTypes
        }
        requiredRegulatoryCompliance {
          identity
          address
          endUserTypes
        }
      }
    }
  }
`;

/**
 * __useCheckRegulatoryComplianceQuery__
 *
 * To run a query within a React component, call `useCheckRegulatoryComplianceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRegulatoryComplianceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRegulatoryComplianceQuery({
 *   variables: {
 *      isoCountry: // value for 'isoCountry'
 *      numberType: // value for 'numberType'
 *      addressRequirements: // value for 'addressRequirements'
 *   },
 * });
 */
export function useCheckRegulatoryComplianceQuery(
  baseOptions: Apollo.QueryHookOptions<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables> &
    ({ variables: CheckRegulatoryComplianceQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables>(
    CheckRegulatoryComplianceDocument,
    options
  );
}
export function useCheckRegulatoryComplianceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables>(
    CheckRegulatoryComplianceDocument,
    options
  );
}
// @ts-ignore
export function useCheckRegulatoryComplianceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables>
): Apollo.UseSuspenseQueryResult<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables>;
export function useCheckRegulatoryComplianceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables>
): Apollo.UseSuspenseQueryResult<CheckRegulatoryComplianceQuery | undefined, CheckRegulatoryComplianceQueryVariables>;
export function useCheckRegulatoryComplianceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckRegulatoryComplianceQuery, CheckRegulatoryComplianceQueryVariables>(
    CheckRegulatoryComplianceDocument,
    options
  );
}
export type CheckRegulatoryComplianceQueryHookResult = ReturnType<typeof useCheckRegulatoryComplianceQuery>;
export type CheckRegulatoryComplianceLazyQueryHookResult = ReturnType<typeof useCheckRegulatoryComplianceLazyQuery>;
export type CheckRegulatoryComplianceSuspenseQueryHookResult = ReturnType<
  typeof useCheckRegulatoryComplianceSuspenseQuery
>;
export type CheckRegulatoryComplianceQueryResult = Apollo.QueryResult<
  CheckRegulatoryComplianceQuery,
  CheckRegulatoryComplianceQueryVariables
>;
export const CheckConfigurationAndRewardOfChannelDocument = gql`
  query CheckConfigurationAndRewardOfChannel {
    checkConfigurationAndRewardOfChannel {
      message
      data {
        availableRewardCount
        requiresDisposition
      }
    }
  }
`;

/**
 * __useCheckConfigurationAndRewardOfChannelQuery__
 *
 * To run a query within a React component, call `useCheckConfigurationAndRewardOfChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckConfigurationAndRewardOfChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckConfigurationAndRewardOfChannelQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckConfigurationAndRewardOfChannelQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckConfigurationAndRewardOfChannelQuery,
    CheckConfigurationAndRewardOfChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckConfigurationAndRewardOfChannelQuery, CheckConfigurationAndRewardOfChannelQueryVariables>(
    CheckConfigurationAndRewardOfChannelDocument,
    options
  );
}
export function useCheckConfigurationAndRewardOfChannelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckConfigurationAndRewardOfChannelQuery,
    CheckConfigurationAndRewardOfChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckConfigurationAndRewardOfChannelQuery,
    CheckConfigurationAndRewardOfChannelQueryVariables
  >(CheckConfigurationAndRewardOfChannelDocument, options);
}
// @ts-ignore
export function useCheckConfigurationAndRewardOfChannelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckConfigurationAndRewardOfChannelQuery,
    CheckConfigurationAndRewardOfChannelQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CheckConfigurationAndRewardOfChannelQuery,
  CheckConfigurationAndRewardOfChannelQueryVariables
>;
export function useCheckConfigurationAndRewardOfChannelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckConfigurationAndRewardOfChannelQuery,
        CheckConfigurationAndRewardOfChannelQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CheckConfigurationAndRewardOfChannelQuery | undefined,
  CheckConfigurationAndRewardOfChannelQueryVariables
>;
export function useCheckConfigurationAndRewardOfChannelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckConfigurationAndRewardOfChannelQuery,
        CheckConfigurationAndRewardOfChannelQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckConfigurationAndRewardOfChannelQuery,
    CheckConfigurationAndRewardOfChannelQueryVariables
  >(CheckConfigurationAndRewardOfChannelDocument, options);
}
export type CheckConfigurationAndRewardOfChannelQueryHookResult = ReturnType<
  typeof useCheckConfigurationAndRewardOfChannelQuery
>;
export type CheckConfigurationAndRewardOfChannelLazyQueryHookResult = ReturnType<
  typeof useCheckConfigurationAndRewardOfChannelLazyQuery
>;
export type CheckConfigurationAndRewardOfChannelSuspenseQueryHookResult = ReturnType<
  typeof useCheckConfigurationAndRewardOfChannelSuspenseQuery
>;
export type CheckConfigurationAndRewardOfChannelQueryResult = Apollo.QueryResult<
  CheckConfigurationAndRewardOfChannelQuery,
  CheckConfigurationAndRewardOfChannelQueryVariables
>;
export const IntegrationDocument = gql`
  query Integration($integrationId: Int) {
    integration(id: $integrationId) {
      message
      data {
        id
        name
        description
        domain
        logoUrl
        label
        integrationUser {
          id
          status
        }
      }
    }
  }
`;

/**
 * __useIntegrationQuery__
 *
 * To run a query within a React component, call `useIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useIntegrationQuery(
  baseOptions?: Apollo.QueryHookOptions<IntegrationQuery, IntegrationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
}
export function useIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
}
// @ts-ignore
export function useIntegrationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationQuery, IntegrationQueryVariables>;
export function useIntegrationSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationQuery | undefined, IntegrationQueryVariables>;
export function useIntegrationSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
}
export type IntegrationQueryHookResult = ReturnType<typeof useIntegrationQuery>;
export type IntegrationLazyQueryHookResult = ReturnType<typeof useIntegrationLazyQuery>;
export type IntegrationSuspenseQueryHookResult = ReturnType<typeof useIntegrationSuspenseQuery>;
export type IntegrationQueryResult = Apollo.QueryResult<IntegrationQuery, IntegrationQueryVariables>;
export const GetPaymentRequestTokenDocument = gql`
  query GetPaymentRequestToken($invoiceId: Int!) {
    getPaymentRequestToken(invoiceId: $invoiceId) {
      message
      data {
        urlToken
      }
    }
  }
`;

/**
 * __useGetPaymentRequestTokenQuery__
 *
 * To run a query within a React component, call `useGetPaymentRequestTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentRequestTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentRequestTokenQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetPaymentRequestTokenQuery(
  baseOptions: Apollo.QueryHookOptions<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables> &
    ({ variables: GetPaymentRequestTokenQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables>(
    GetPaymentRequestTokenDocument,
    options
  );
}
export function useGetPaymentRequestTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables>(
    GetPaymentRequestTokenDocument,
    options
  );
}
// @ts-ignore
export function useGetPaymentRequestTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables>
): Apollo.UseSuspenseQueryResult<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables>;
export function useGetPaymentRequestTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables>
): Apollo.UseSuspenseQueryResult<GetPaymentRequestTokenQuery | undefined, GetPaymentRequestTokenQueryVariables>;
export function useGetPaymentRequestTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPaymentRequestTokenQuery, GetPaymentRequestTokenQueryVariables>(
    GetPaymentRequestTokenDocument,
    options
  );
}
export type GetPaymentRequestTokenQueryHookResult = ReturnType<typeof useGetPaymentRequestTokenQuery>;
export type GetPaymentRequestTokenLazyQueryHookResult = ReturnType<typeof useGetPaymentRequestTokenLazyQuery>;
export type GetPaymentRequestTokenSuspenseQueryHookResult = ReturnType<typeof useGetPaymentRequestTokenSuspenseQuery>;
export type GetPaymentRequestTokenQueryResult = Apollo.QueryResult<
  GetPaymentRequestTokenQuery,
  GetPaymentRequestTokenQueryVariables
>;
export const IntegrationCountDocument = gql`
  query IntegrationCount {
    integrationCount {
      message
      data {
        key
        value
      }
    }
  }
`;

/**
 * __useIntegrationCountQuery__
 *
 * To run a query within a React component, call `useIntegrationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationCountQuery(
  baseOptions?: Apollo.QueryHookOptions<IntegrationCountQuery, IntegrationCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationCountQuery, IntegrationCountQueryVariables>(IntegrationCountDocument, options);
}
export function useIntegrationCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IntegrationCountQuery, IntegrationCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationCountQuery, IntegrationCountQueryVariables>(IntegrationCountDocument, options);
}
// @ts-ignore
export function useIntegrationCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationCountQuery, IntegrationCountQueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationCountQuery, IntegrationCountQueryVariables>;
export function useIntegrationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationCountQuery, IntegrationCountQueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationCountQuery | undefined, IntegrationCountQueryVariables>;
export function useIntegrationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationCountQuery, IntegrationCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IntegrationCountQuery, IntegrationCountQueryVariables>(
    IntegrationCountDocument,
    options
  );
}
export type IntegrationCountQueryHookResult = ReturnType<typeof useIntegrationCountQuery>;
export type IntegrationCountLazyQueryHookResult = ReturnType<typeof useIntegrationCountLazyQuery>;
export type IntegrationCountSuspenseQueryHookResult = ReturnType<typeof useIntegrationCountSuspenseQuery>;
export type IntegrationCountQueryResult = Apollo.QueryResult<IntegrationCountQuery, IntegrationCountQueryVariables>;
export const GetMemberSubscriptionDocument = gql`
  query GetMemberSubscription {
    getMemberSubscription {
      message
      data {
        id
        memberPlanId
        status
        nextBillingAt
        endedAt
        plan {
          id
          label
        }
        totalAmount
        itemsQuantity
        periodUnit
      }
    }
  }
`;

/**
 * __useGetMemberSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetMemberSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMemberSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>(
    GetMemberSubscriptionDocument,
    options
  );
}
export function useGetMemberSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>(
    GetMemberSubscriptionDocument,
    options
  );
}
// @ts-ignore
export function useGetMemberSubscriptionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>;
export function useGetMemberSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMemberSubscriptionQuery | undefined, GetMemberSubscriptionQueryVariables>;
export function useGetMemberSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMemberSubscriptionQuery, GetMemberSubscriptionQueryVariables>(
    GetMemberSubscriptionDocument,
    options
  );
}
export type GetMemberSubscriptionQueryHookResult = ReturnType<typeof useGetMemberSubscriptionQuery>;
export type GetMemberSubscriptionLazyQueryHookResult = ReturnType<typeof useGetMemberSubscriptionLazyQuery>;
export type GetMemberSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetMemberSubscriptionSuspenseQuery>;
export type GetMemberSubscriptionQueryResult = Apollo.QueryResult<
  GetMemberSubscriptionQuery,
  GetMemberSubscriptionQueryVariables
>;
export const IntegrationConfigurationDocument = gql`
  query IntegrationConfiguration($integrationConfigurationId: Int!) {
    integrationConfiguration(id: $integrationConfigurationId) {
      message
      data {
        id
        integrationUserId
        workspaceId
        syncCallDetails
        syncContacts
        syncMessage
        syncVoicemails
        syncRecordings
        createdBy
        updatedBy
      }
    }
  }
`;

/**
 * __useIntegrationConfigurationQuery__
 *
 * To run a query within a React component, call `useIntegrationConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConfigurationQuery({
 *   variables: {
 *      integrationConfigurationId: // value for 'integrationConfigurationId'
 *   },
 * });
 */
export function useIntegrationConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables> &
    ({ variables: IntegrationConfigurationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(
    IntegrationConfigurationDocument,
    options
  );
}
export function useIntegrationConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(
    IntegrationConfigurationDocument,
    options
  );
}
// @ts-ignore
export function useIntegrationConfigurationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>;
export function useIntegrationConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationConfigurationQuery | undefined, IntegrationConfigurationQueryVariables>;
export function useIntegrationConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(
    IntegrationConfigurationDocument,
    options
  );
}
export type IntegrationConfigurationQueryHookResult = ReturnType<typeof useIntegrationConfigurationQuery>;
export type IntegrationConfigurationLazyQueryHookResult = ReturnType<typeof useIntegrationConfigurationLazyQuery>;
export type IntegrationConfigurationSuspenseQueryHookResult = ReturnType<
  typeof useIntegrationConfigurationSuspenseQuery
>;
export type IntegrationConfigurationQueryResult = Apollo.QueryResult<
  IntegrationConfigurationQuery,
  IntegrationConfigurationQueryVariables
>;
export const IntegrationWebhooksDocument = gql`
  query IntegrationWebhooks($integrationUserId: Int!) {
    integrationWebhooks(integrationUserId: $integrationUserId) {
      message
      data {
        id
        integrationUserId
        label
        username
        password
        url
      }
    }
  }
`;

/**
 * __useIntegrationWebhooksQuery__
 *
 * To run a query within a React component, call `useIntegrationWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationWebhooksQuery({
 *   variables: {
 *      integrationUserId: // value for 'integrationUserId'
 *   },
 * });
 */
export function useIntegrationWebhooksQuery(
  baseOptions: Apollo.QueryHookOptions<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables> &
    ({ variables: IntegrationWebhooksQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables>(
    IntegrationWebhooksDocument,
    options
  );
}
export function useIntegrationWebhooksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables>(
    IntegrationWebhooksDocument,
    options
  );
}
// @ts-ignore
export function useIntegrationWebhooksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables>;
export function useIntegrationWebhooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables>
): Apollo.UseSuspenseQueryResult<IntegrationWebhooksQuery | undefined, IntegrationWebhooksQueryVariables>;
export function useIntegrationWebhooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IntegrationWebhooksQuery, IntegrationWebhooksQueryVariables>(
    IntegrationWebhooksDocument,
    options
  );
}
export type IntegrationWebhooksQueryHookResult = ReturnType<typeof useIntegrationWebhooksQuery>;
export type IntegrationWebhooksLazyQueryHookResult = ReturnType<typeof useIntegrationWebhooksLazyQuery>;
export type IntegrationWebhooksSuspenseQueryHookResult = ReturnType<typeof useIntegrationWebhooksSuspenseQuery>;
export type IntegrationWebhooksQueryResult = Apollo.QueryResult<
  IntegrationWebhooksQuery,
  IntegrationWebhooksQueryVariables
>;
export const MyRolePrivilegeDocument = gql`
  query MyRolePrivilege {
    myRolePrivilege {
      edges {
        module {
          slug
        }
        privilege {
          slug
        }
        role {
          slug
        }
        screen {
          slug
        }
      }
    }
  }
`;

/**
 * __useMyRolePrivilegeQuery__
 *
 * To run a query within a React component, call `useMyRolePrivilegeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRolePrivilegeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRolePrivilegeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRolePrivilegeQuery(
  baseOptions?: Apollo.QueryHookOptions<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>(MyRolePrivilegeDocument, options);
}
export function useMyRolePrivilegeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>(MyRolePrivilegeDocument, options);
}
// @ts-ignore
export function useMyRolePrivilegeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>
): Apollo.UseSuspenseQueryResult<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>;
export function useMyRolePrivilegeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>
): Apollo.UseSuspenseQueryResult<MyRolePrivilegeQuery | undefined, MyRolePrivilegeQueryVariables>;
export function useMyRolePrivilegeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>(MyRolePrivilegeDocument, options);
}
export type MyRolePrivilegeQueryHookResult = ReturnType<typeof useMyRolePrivilegeQuery>;
export type MyRolePrivilegeLazyQueryHookResult = ReturnType<typeof useMyRolePrivilegeLazyQuery>;
export type MyRolePrivilegeSuspenseQueryHookResult = ReturnType<typeof useMyRolePrivilegeSuspenseQuery>;
export type MyRolePrivilegeQueryResult = Apollo.QueryResult<MyRolePrivilegeQuery, MyRolePrivilegeQueryVariables>;
export const CountChannelsDocument = gql`
  query CountChannels($isFree: Boolean, $query: String) {
    freeNumbers: countChannels(isFree: $isFree) {
      message
      count
    }
    totalNumbers: countChannels(isFree: null, query: $query) {
      message
      count
    }
  }
`;

/**
 * __useCountChannelsQuery__
 *
 * To run a query within a React component, call `useCountChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountChannelsQuery({
 *   variables: {
 *      isFree: // value for 'isFree'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCountChannelsQuery(
  baseOptions?: Apollo.QueryHookOptions<CountChannelsQuery, CountChannelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountChannelsQuery, CountChannelsQueryVariables>(CountChannelsDocument, options);
}
export function useCountChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountChannelsQuery, CountChannelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountChannelsQuery, CountChannelsQueryVariables>(CountChannelsDocument, options);
}
// @ts-ignore
export function useCountChannelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CountChannelsQuery, CountChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<CountChannelsQuery, CountChannelsQueryVariables>;
export function useCountChannelsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountChannelsQuery, CountChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<CountChannelsQuery | undefined, CountChannelsQueryVariables>;
export function useCountChannelsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountChannelsQuery, CountChannelsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CountChannelsQuery, CountChannelsQueryVariables>(CountChannelsDocument, options);
}
export type CountChannelsQueryHookResult = ReturnType<typeof useCountChannelsQuery>;
export type CountChannelsLazyQueryHookResult = ReturnType<typeof useCountChannelsLazyQuery>;
export type CountChannelsSuspenseQueryHookResult = ReturnType<typeof useCountChannelsSuspenseQuery>;
export type CountChannelsQueryResult = Apollo.QueryResult<CountChannelsQuery, CountChannelsQueryVariables>;
export const MyPlanPrivilegeDocument = gql`
  query MyPlanPrivilege {
    myPlanPrivilege {
      message
      edges {
        privilege {
          slug
        }
        screen {
          slug
        }
        module {
          slug
        }
      }
    }
  }
`;

/**
 * __useMyPlanPrivilegeQuery__
 *
 * To run a query within a React component, call `useMyPlanPrivilegeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPlanPrivilegeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPlanPrivilegeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPlanPrivilegeQuery(
  baseOptions?: Apollo.QueryHookOptions<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>(MyPlanPrivilegeDocument, options);
}
export function useMyPlanPrivilegeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>(MyPlanPrivilegeDocument, options);
}
// @ts-ignore
export function useMyPlanPrivilegeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>
): Apollo.UseSuspenseQueryResult<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>;
export function useMyPlanPrivilegeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>
): Apollo.UseSuspenseQueryResult<MyPlanPrivilegeQuery | undefined, MyPlanPrivilegeQueryVariables>;
export function useMyPlanPrivilegeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>(MyPlanPrivilegeDocument, options);
}
export type MyPlanPrivilegeQueryHookResult = ReturnType<typeof useMyPlanPrivilegeQuery>;
export type MyPlanPrivilegeLazyQueryHookResult = ReturnType<typeof useMyPlanPrivilegeLazyQuery>;
export type MyPlanPrivilegeSuspenseQueryHookResult = ReturnType<typeof useMyPlanPrivilegeSuspenseQuery>;
export type MyPlanPrivilegeQueryResult = Apollo.QueryResult<MyPlanPrivilegeQuery, MyPlanPrivilegeQueryVariables>;
export const GetAssignedChannelsDocument = gql`
  query GetAssignedChannels($userWorkspaceId: Int!, $query: String) {
    getAssignedChannels(userWorkspaceId: $userWorkspaceId, query: $query) {
      message
      data {
        channel {
          friendlyName
          phoneNumber
          id
          muted
        }
      }
    }
  }
`;

/**
 * __useGetAssignedChannelsQuery__
 *
 * To run a query within a React component, call `useGetAssignedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedChannelsQuery({
 *   variables: {
 *      userWorkspaceId: // value for 'userWorkspaceId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAssignedChannelsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables> &
    ({ variables: GetAssignedChannelsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables>(
    GetAssignedChannelsDocument,
    options
  );
}
export function useGetAssignedChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables>(
    GetAssignedChannelsDocument,
    options
  );
}
// @ts-ignore
export function useGetAssignedChannelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables>;
export function useGetAssignedChannelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAssignedChannelsQuery | undefined, GetAssignedChannelsQueryVariables>;
export function useGetAssignedChannelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAssignedChannelsQuery, GetAssignedChannelsQueryVariables>(
    GetAssignedChannelsDocument,
    options
  );
}
export type GetAssignedChannelsQueryHookResult = ReturnType<typeof useGetAssignedChannelsQuery>;
export type GetAssignedChannelsLazyQueryHookResult = ReturnType<typeof useGetAssignedChannelsLazyQuery>;
export type GetAssignedChannelsSuspenseQueryHookResult = ReturnType<typeof useGetAssignedChannelsSuspenseQuery>;
export type GetAssignedChannelsQueryResult = Apollo.QueryResult<
  GetAssignedChannelsQuery,
  GetAssignedChannelsQueryVariables
>;
export const GetBusinessHoursInCallSettingDocument = gql`
  query GetBusinessHoursInCallSetting($callSettingId: Int!) {
    getBusinessHoursInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        timezoneId
        isAlwaysOpen
        entries {
          localDayOfWeek
          localStartTime
          localEndTime
          businessHourId
          isActive
        }
        timezone {
          value
          label
          id
        }
      }
    }
  }
`;

/**
 * __useGetBusinessHoursInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetBusinessHoursInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessHoursInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessHoursInCallSettingQuery({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *   },
 * });
 */
export function useGetBusinessHoursInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBusinessHoursInCallSettingQuery,
    GetBusinessHoursInCallSettingQueryVariables
  > &
    ({ variables: GetBusinessHoursInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBusinessHoursInCallSettingQuery, GetBusinessHoursInCallSettingQueryVariables>(
    GetBusinessHoursInCallSettingDocument,
    options
  );
}
export function useGetBusinessHoursInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBusinessHoursInCallSettingQuery,
    GetBusinessHoursInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBusinessHoursInCallSettingQuery, GetBusinessHoursInCallSettingQueryVariables>(
    GetBusinessHoursInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetBusinessHoursInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBusinessHoursInCallSettingQuery,
    GetBusinessHoursInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetBusinessHoursInCallSettingQuery, GetBusinessHoursInCallSettingQueryVariables>;
export function useGetBusinessHoursInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBusinessHoursInCallSettingQuery, GetBusinessHoursInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetBusinessHoursInCallSettingQuery | undefined,
  GetBusinessHoursInCallSettingQueryVariables
>;
export function useGetBusinessHoursInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBusinessHoursInCallSettingQuery, GetBusinessHoursInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBusinessHoursInCallSettingQuery, GetBusinessHoursInCallSettingQueryVariables>(
    GetBusinessHoursInCallSettingDocument,
    options
  );
}
export type GetBusinessHoursInCallSettingQueryHookResult = ReturnType<typeof useGetBusinessHoursInCallSettingQuery>;
export type GetBusinessHoursInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetBusinessHoursInCallSettingLazyQuery
>;
export type GetBusinessHoursInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetBusinessHoursInCallSettingSuspenseQuery
>;
export type GetBusinessHoursInCallSettingQueryResult = Apollo.QueryResult<
  GetBusinessHoursInCallSettingQuery,
  GetBusinessHoursInCallSettingQueryVariables
>;
export const MyWorkspaceDocument = gql`
  query MyWorkspace {
    myWorkspace {
      data {
        id
        label
        logo {
          id
          url
        }
        totalPhoneNumbers
        coverProfile {
          url
          id
        }
        availableBalance
      }
    }
  }
`;

/**
 * __useMyWorkspaceQuery__
 *
 * To run a query within a React component, call `useMyWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWorkspaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyWorkspaceQuery(
  baseOptions?: Apollo.QueryHookOptions<MyWorkspaceQuery, MyWorkspaceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyWorkspaceQuery, MyWorkspaceQueryVariables>(MyWorkspaceDocument, options);
}
export function useMyWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyWorkspaceQuery, MyWorkspaceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyWorkspaceQuery, MyWorkspaceQueryVariables>(MyWorkspaceDocument, options);
}
// @ts-ignore
export function useMyWorkspaceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyWorkspaceQuery, MyWorkspaceQueryVariables>
): Apollo.UseSuspenseQueryResult<MyWorkspaceQuery, MyWorkspaceQueryVariables>;
export function useMyWorkspaceSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyWorkspaceQuery, MyWorkspaceQueryVariables>
): Apollo.UseSuspenseQueryResult<MyWorkspaceQuery | undefined, MyWorkspaceQueryVariables>;
export function useMyWorkspaceSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyWorkspaceQuery, MyWorkspaceQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyWorkspaceQuery, MyWorkspaceQueryVariables>(MyWorkspaceDocument, options);
}
export type MyWorkspaceQueryHookResult = ReturnType<typeof useMyWorkspaceQuery>;
export type MyWorkspaceLazyQueryHookResult = ReturnType<typeof useMyWorkspaceLazyQuery>;
export type MyWorkspaceSuspenseQueryHookResult = ReturnType<typeof useMyWorkspaceSuspenseQuery>;
export type MyWorkspaceQueryResult = Apollo.QueryResult<MyWorkspaceQuery, MyWorkspaceQueryVariables>;
export const GetWalletDetailsWithLastCreditedDocument = gql`
  query GetWalletDetailsWithLastCredited {
    getWalletDetailsWithLastCredited {
      data {
        amount
        lastCredit
        lastTransactionDate
      }
      message
    }
  }
`;

/**
 * __useGetWalletDetailsWithLastCreditedQuery__
 *
 * To run a query within a React component, call `useGetWalletDetailsWithLastCreditedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletDetailsWithLastCreditedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletDetailsWithLastCreditedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWalletDetailsWithLastCreditedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWalletDetailsWithLastCreditedQuery,
    GetWalletDetailsWithLastCreditedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWalletDetailsWithLastCreditedQuery, GetWalletDetailsWithLastCreditedQueryVariables>(
    GetWalletDetailsWithLastCreditedDocument,
    options
  );
}
export function useGetWalletDetailsWithLastCreditedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWalletDetailsWithLastCreditedQuery,
    GetWalletDetailsWithLastCreditedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWalletDetailsWithLastCreditedQuery, GetWalletDetailsWithLastCreditedQueryVariables>(
    GetWalletDetailsWithLastCreditedDocument,
    options
  );
}
// @ts-ignore
export function useGetWalletDetailsWithLastCreditedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWalletDetailsWithLastCreditedQuery,
    GetWalletDetailsWithLastCreditedQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetWalletDetailsWithLastCreditedQuery, GetWalletDetailsWithLastCreditedQueryVariables>;
export function useGetWalletDetailsWithLastCreditedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWalletDetailsWithLastCreditedQuery,
        GetWalletDetailsWithLastCreditedQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetWalletDetailsWithLastCreditedQuery | undefined,
  GetWalletDetailsWithLastCreditedQueryVariables
>;
export function useGetWalletDetailsWithLastCreditedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWalletDetailsWithLastCreditedQuery,
        GetWalletDetailsWithLastCreditedQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWalletDetailsWithLastCreditedQuery, GetWalletDetailsWithLastCreditedQueryVariables>(
    GetWalletDetailsWithLastCreditedDocument,
    options
  );
}
export type GetWalletDetailsWithLastCreditedQueryHookResult = ReturnType<
  typeof useGetWalletDetailsWithLastCreditedQuery
>;
export type GetWalletDetailsWithLastCreditedLazyQueryHookResult = ReturnType<
  typeof useGetWalletDetailsWithLastCreditedLazyQuery
>;
export type GetWalletDetailsWithLastCreditedSuspenseQueryHookResult = ReturnType<
  typeof useGetWalletDetailsWithLastCreditedSuspenseQuery
>;
export type GetWalletDetailsWithLastCreditedQueryResult = Apollo.QueryResult<
  GetWalletDetailsWithLastCreditedQuery,
  GetWalletDetailsWithLastCreditedQueryVariables
>;
export const EnumerateCountriesForAvailableNumbersDocument = gql`
  query EnumerateCountriesForAvailableNumbers($query: String) {
    enumerateCountriesForAvailableNumbers(query: $query) {
      message
      data {
        id
        name
        slug
        dialingCode
        alphaTwoCode
        alphaThreeCode
        numeric
        flag
      }
    }
  }
`;

/**
 * __useEnumerateCountriesForAvailableNumbersQuery__
 *
 * To run a query within a React component, call `useEnumerateCountriesForAvailableNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnumerateCountriesForAvailableNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnumerateCountriesForAvailableNumbersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEnumerateCountriesForAvailableNumbersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EnumerateCountriesForAvailableNumbersQuery,
    EnumerateCountriesForAvailableNumbersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnumerateCountriesForAvailableNumbersQuery,
    EnumerateCountriesForAvailableNumbersQueryVariables
  >(EnumerateCountriesForAvailableNumbersDocument, options);
}
export function useEnumerateCountriesForAvailableNumbersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnumerateCountriesForAvailableNumbersQuery,
    EnumerateCountriesForAvailableNumbersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnumerateCountriesForAvailableNumbersQuery,
    EnumerateCountriesForAvailableNumbersQueryVariables
  >(EnumerateCountriesForAvailableNumbersDocument, options);
}
// @ts-ignore
export function useEnumerateCountriesForAvailableNumbersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EnumerateCountriesForAvailableNumbersQuery,
    EnumerateCountriesForAvailableNumbersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  EnumerateCountriesForAvailableNumbersQuery,
  EnumerateCountriesForAvailableNumbersQueryVariables
>;
export function useEnumerateCountriesForAvailableNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EnumerateCountriesForAvailableNumbersQuery,
        EnumerateCountriesForAvailableNumbersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  EnumerateCountriesForAvailableNumbersQuery | undefined,
  EnumerateCountriesForAvailableNumbersQueryVariables
>;
export function useEnumerateCountriesForAvailableNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EnumerateCountriesForAvailableNumbersQuery,
        EnumerateCountriesForAvailableNumbersQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EnumerateCountriesForAvailableNumbersQuery,
    EnumerateCountriesForAvailableNumbersQueryVariables
  >(EnumerateCountriesForAvailableNumbersDocument, options);
}
export type EnumerateCountriesForAvailableNumbersQueryHookResult = ReturnType<
  typeof useEnumerateCountriesForAvailableNumbersQuery
>;
export type EnumerateCountriesForAvailableNumbersLazyQueryHookResult = ReturnType<
  typeof useEnumerateCountriesForAvailableNumbersLazyQuery
>;
export type EnumerateCountriesForAvailableNumbersSuspenseQueryHookResult = ReturnType<
  typeof useEnumerateCountriesForAvailableNumbersSuspenseQuery
>;
export type EnumerateCountriesForAvailableNumbersQueryResult = Apollo.QueryResult<
  EnumerateCountriesForAvailableNumbersQuery,
  EnumerateCountriesForAvailableNumbersQueryVariables
>;
export const EnumerateNumberTypesAvailableForCountryDocument = gql`
  query EnumerateNumberTypesAvailableForCountry($countryCode: String!) {
    enumerateNumberTypesAvailableForCountry(countryCode: $countryCode) {
      message
      data {
        id
        label
      }
    }
  }
`;

/**
 * __useEnumerateNumberTypesAvailableForCountryQuery__
 *
 * To run a query within a React component, call `useEnumerateNumberTypesAvailableForCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnumerateNumberTypesAvailableForCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnumerateNumberTypesAvailableForCountryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useEnumerateNumberTypesAvailableForCountryQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnumerateNumberTypesAvailableForCountryQuery,
    EnumerateNumberTypesAvailableForCountryQueryVariables
  > &
    ({ variables: EnumerateNumberTypesAvailableForCountryQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnumerateNumberTypesAvailableForCountryQuery,
    EnumerateNumberTypesAvailableForCountryQueryVariables
  >(EnumerateNumberTypesAvailableForCountryDocument, options);
}
export function useEnumerateNumberTypesAvailableForCountryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnumerateNumberTypesAvailableForCountryQuery,
    EnumerateNumberTypesAvailableForCountryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnumerateNumberTypesAvailableForCountryQuery,
    EnumerateNumberTypesAvailableForCountryQueryVariables
  >(EnumerateNumberTypesAvailableForCountryDocument, options);
}
// @ts-ignore
export function useEnumerateNumberTypesAvailableForCountrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EnumerateNumberTypesAvailableForCountryQuery,
    EnumerateNumberTypesAvailableForCountryQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  EnumerateNumberTypesAvailableForCountryQuery,
  EnumerateNumberTypesAvailableForCountryQueryVariables
>;
export function useEnumerateNumberTypesAvailableForCountrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EnumerateNumberTypesAvailableForCountryQuery,
        EnumerateNumberTypesAvailableForCountryQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  EnumerateNumberTypesAvailableForCountryQuery | undefined,
  EnumerateNumberTypesAvailableForCountryQueryVariables
>;
export function useEnumerateNumberTypesAvailableForCountrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EnumerateNumberTypesAvailableForCountryQuery,
        EnumerateNumberTypesAvailableForCountryQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EnumerateNumberTypesAvailableForCountryQuery,
    EnumerateNumberTypesAvailableForCountryQueryVariables
  >(EnumerateNumberTypesAvailableForCountryDocument, options);
}
export type EnumerateNumberTypesAvailableForCountryQueryHookResult = ReturnType<
  typeof useEnumerateNumberTypesAvailableForCountryQuery
>;
export type EnumerateNumberTypesAvailableForCountryLazyQueryHookResult = ReturnType<
  typeof useEnumerateNumberTypesAvailableForCountryLazyQuery
>;
export type EnumerateNumberTypesAvailableForCountrySuspenseQueryHookResult = ReturnType<
  typeof useEnumerateNumberTypesAvailableForCountrySuspenseQuery
>;
export type EnumerateNumberTypesAvailableForCountryQueryResult = Apollo.QueryResult<
  EnumerateNumberTypesAvailableForCountryQuery,
  EnumerateNumberTypesAvailableForCountryQueryVariables
>;
export const GetCallSettingDocument = gql`
  query GetCallSetting($getCallSettingId: Int!) {
    getCallSetting(id: $getCallSettingId) {
      message
      data {
        id
        friendlyName
        isBusinessAlwaysOpen
        afterHour
        ivr
        voicemail
        welcomeMessage
        recording
        callerTune
        callForward
        callTransfer
        callerId
        timeout
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
      }
    }
  }
`;

/**
 * __useGetCallSettingQuery__
 *
 * To run a query within a React component, call `useGetCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallSettingQuery({
 *   variables: {
 *      getCallSettingId: // value for 'getCallSettingId'
 *   },
 * });
 */
export function useGetCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallSettingQuery, GetCallSettingQueryVariables> &
    ({ variables: GetCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallSettingQuery, GetCallSettingQueryVariables>(GetCallSettingDocument, options);
}
export function useGetCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallSettingQuery, GetCallSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallSettingQuery, GetCallSettingQueryVariables>(GetCallSettingDocument, options);
}
// @ts-ignore
export function useGetCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallSettingQuery, GetCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingQuery, GetCallSettingQueryVariables>;
export function useGetCallSettingSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallSettingQuery, GetCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingQuery | undefined, GetCallSettingQueryVariables>;
export function useGetCallSettingSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallSettingQuery, GetCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallSettingQuery, GetCallSettingQueryVariables>(GetCallSettingDocument, options);
}
export type GetCallSettingQueryHookResult = ReturnType<typeof useGetCallSettingQuery>;
export type GetCallSettingLazyQueryHookResult = ReturnType<typeof useGetCallSettingLazyQuery>;
export type GetCallSettingSuspenseQueryHookResult = ReturnType<typeof useGetCallSettingSuspenseQuery>;
export type GetCallSettingQueryResult = Apollo.QueryResult<GetCallSettingQuery, GetCallSettingQueryVariables>;
export const GetBusinessAfterHoursInCallSettingDocument = gql`
  query GetBusinessAfterHoursInCallSetting($callSettingId: Int!) {
    getBusinessAfterHoursInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        route
        supportAfterHours
        voicemailAudioPrompt {
          id
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        targetPhoneNumber
        updatedAt
      }
    }
  }
`;

/**
 * __useGetBusinessAfterHoursInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetBusinessAfterHoursInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAfterHoursInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAfterHoursInCallSettingQuery({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *   },
 * });
 */
export function useGetBusinessAfterHoursInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBusinessAfterHoursInCallSettingQuery,
    GetBusinessAfterHoursInCallSettingQueryVariables
  > &
    ({ variables: GetBusinessAfterHoursInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBusinessAfterHoursInCallSettingQuery, GetBusinessAfterHoursInCallSettingQueryVariables>(
    GetBusinessAfterHoursInCallSettingDocument,
    options
  );
}
export function useGetBusinessAfterHoursInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBusinessAfterHoursInCallSettingQuery,
    GetBusinessAfterHoursInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBusinessAfterHoursInCallSettingQuery, GetBusinessAfterHoursInCallSettingQueryVariables>(
    GetBusinessAfterHoursInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetBusinessAfterHoursInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBusinessAfterHoursInCallSettingQuery,
    GetBusinessAfterHoursInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetBusinessAfterHoursInCallSettingQuery,
  GetBusinessAfterHoursInCallSettingQueryVariables
>;
export function useGetBusinessAfterHoursInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBusinessAfterHoursInCallSettingQuery,
        GetBusinessAfterHoursInCallSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetBusinessAfterHoursInCallSettingQuery | undefined,
  GetBusinessAfterHoursInCallSettingQueryVariables
>;
export function useGetBusinessAfterHoursInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBusinessAfterHoursInCallSettingQuery,
        GetBusinessAfterHoursInCallSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetBusinessAfterHoursInCallSettingQuery,
    GetBusinessAfterHoursInCallSettingQueryVariables
  >(GetBusinessAfterHoursInCallSettingDocument, options);
}
export type GetBusinessAfterHoursInCallSettingQueryHookResult = ReturnType<
  typeof useGetBusinessAfterHoursInCallSettingQuery
>;
export type GetBusinessAfterHoursInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetBusinessAfterHoursInCallSettingLazyQuery
>;
export type GetBusinessAfterHoursInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetBusinessAfterHoursInCallSettingSuspenseQuery
>;
export type GetBusinessAfterHoursInCallSettingQueryResult = Apollo.QueryResult<
  GetBusinessAfterHoursInCallSettingQuery,
  GetBusinessAfterHoursInCallSettingQueryVariables
>;
export const GetMemberSubscriptionOverviewDocument = gql`
  query GetMemberSubscriptionOverview {
    getMemberSubscriptionOverview {
      data {
        id
        totalAmount
        userCount
        plan {
          id
          amount
          periodicity
          label
        }
        discount {
          percent
        }
        promo {
          label
          percent
        }
      }
    }
  }
`;

/**
 * __useGetMemberSubscriptionOverviewQuery__
 *
 * To run a query within a React component, call `useGetMemberSubscriptionOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberSubscriptionOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberSubscriptionOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMemberSubscriptionOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMemberSubscriptionOverviewQuery, GetMemberSubscriptionOverviewQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMemberSubscriptionOverviewQuery, GetMemberSubscriptionOverviewQueryVariables>(
    GetMemberSubscriptionOverviewDocument,
    options
  );
}
export function useGetMemberSubscriptionOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMemberSubscriptionOverviewQuery,
    GetMemberSubscriptionOverviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMemberSubscriptionOverviewQuery, GetMemberSubscriptionOverviewQueryVariables>(
    GetMemberSubscriptionOverviewDocument,
    options
  );
}
// @ts-ignore
export function useGetMemberSubscriptionOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMemberSubscriptionOverviewQuery,
    GetMemberSubscriptionOverviewQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetMemberSubscriptionOverviewQuery, GetMemberSubscriptionOverviewQueryVariables>;
export function useGetMemberSubscriptionOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMemberSubscriptionOverviewQuery, GetMemberSubscriptionOverviewQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetMemberSubscriptionOverviewQuery | undefined,
  GetMemberSubscriptionOverviewQueryVariables
>;
export function useGetMemberSubscriptionOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMemberSubscriptionOverviewQuery, GetMemberSubscriptionOverviewQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMemberSubscriptionOverviewQuery, GetMemberSubscriptionOverviewQueryVariables>(
    GetMemberSubscriptionOverviewDocument,
    options
  );
}
export type GetMemberSubscriptionOverviewQueryHookResult = ReturnType<typeof useGetMemberSubscriptionOverviewQuery>;
export type GetMemberSubscriptionOverviewLazyQueryHookResult = ReturnType<
  typeof useGetMemberSubscriptionOverviewLazyQuery
>;
export type GetMemberSubscriptionOverviewSuspenseQueryHookResult = ReturnType<
  typeof useGetMemberSubscriptionOverviewSuspenseQuery
>;
export type GetMemberSubscriptionOverviewQueryResult = Apollo.QueryResult<
  GetMemberSubscriptionOverviewQuery,
  GetMemberSubscriptionOverviewQueryVariables
>;
export const GetIvrInCallSettingDocument = gql`
  query GetIvrInCallSetting($callSettingId: Int!) {
    getIvrInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        isActive
        startPrompt {
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        invalidPrompt {
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
        ifUnansweredPrompt {
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetIvrInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetIvrInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIvrInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIvrInCallSettingQuery({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *   },
 * });
 */
export function useGetIvrInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables> &
    ({ variables: GetIvrInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables>(
    GetIvrInCallSettingDocument,
    options
  );
}
export function useGetIvrInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables>(
    GetIvrInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetIvrInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables>;
export function useGetIvrInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetIvrInCallSettingQuery | undefined, GetIvrInCallSettingQueryVariables>;
export function useGetIvrInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIvrInCallSettingQuery, GetIvrInCallSettingQueryVariables>(
    GetIvrInCallSettingDocument,
    options
  );
}
export type GetIvrInCallSettingQueryHookResult = ReturnType<typeof useGetIvrInCallSettingQuery>;
export type GetIvrInCallSettingLazyQueryHookResult = ReturnType<typeof useGetIvrInCallSettingLazyQuery>;
export type GetIvrInCallSettingSuspenseQueryHookResult = ReturnType<typeof useGetIvrInCallSettingSuspenseQuery>;
export type GetIvrInCallSettingQueryResult = Apollo.QueryResult<
  GetIvrInCallSettingQuery,
  GetIvrInCallSettingQueryVariables
>;
export const GetCallForwardInCallSettingDocument = gql`
  query GetCallForwardInCallSetting($callSettingId: Int!) {
    getCallForwardInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        isUnconditional
        targetPhoneNumber
        isActive
      }
    }
  }
`;

/**
 * __useGetCallForwardInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetCallForwardInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallForwardInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallForwardInCallSettingQuery({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *   },
 * });
 */
export function useGetCallForwardInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallForwardInCallSettingQuery, GetCallForwardInCallSettingQueryVariables> &
    ({ variables: GetCallForwardInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallForwardInCallSettingQuery, GetCallForwardInCallSettingQueryVariables>(
    GetCallForwardInCallSettingDocument,
    options
  );
}
export function useGetCallForwardInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallForwardInCallSettingQuery, GetCallForwardInCallSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallForwardInCallSettingQuery, GetCallForwardInCallSettingQueryVariables>(
    GetCallForwardInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetCallForwardInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCallForwardInCallSettingQuery,
    GetCallForwardInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetCallForwardInCallSettingQuery, GetCallForwardInCallSettingQueryVariables>;
export function useGetCallForwardInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallForwardInCallSettingQuery, GetCallForwardInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetCallForwardInCallSettingQuery | undefined,
  GetCallForwardInCallSettingQueryVariables
>;
export function useGetCallForwardInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallForwardInCallSettingQuery, GetCallForwardInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallForwardInCallSettingQuery, GetCallForwardInCallSettingQueryVariables>(
    GetCallForwardInCallSettingDocument,
    options
  );
}
export type GetCallForwardInCallSettingQueryHookResult = ReturnType<typeof useGetCallForwardInCallSettingQuery>;
export type GetCallForwardInCallSettingLazyQueryHookResult = ReturnType<typeof useGetCallForwardInCallSettingLazyQuery>;
export type GetCallForwardInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetCallForwardInCallSettingSuspenseQuery
>;
export type GetCallForwardInCallSettingQueryResult = Apollo.QueryResult<
  GetCallForwardInCallSettingQuery,
  GetCallForwardInCallSettingQueryVariables
>;
export const GetMessageScheduleCountDocument = gql`
  query GetMessageScheduleCount($channelId: Int!, $clientId: Int!, $status: [MessageScheduleStatusEnum]) {
    getMessageScheduleCount(channelId: $channelId, clientId: $clientId, status: $status) {
      message
      data {
        scheduleAt
        id
        count
      }
    }
  }
`;

/**
 * __useGetMessageScheduleCountQuery__
 *
 * To run a query within a React component, call `useGetMessageScheduleCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageScheduleCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageScheduleCountQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      clientId: // value for 'clientId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetMessageScheduleCountQuery(
  baseOptions: Apollo.QueryHookOptions<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables> &
    ({ variables: GetMessageScheduleCountQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables>(
    GetMessageScheduleCountDocument,
    options
  );
}
export function useGetMessageScheduleCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables>(
    GetMessageScheduleCountDocument,
    options
  );
}
// @ts-ignore
export function useGetMessageScheduleCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables>;
export function useGetMessageScheduleCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMessageScheduleCountQuery | undefined, GetMessageScheduleCountQueryVariables>;
export function useGetMessageScheduleCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMessageScheduleCountQuery, GetMessageScheduleCountQueryVariables>(
    GetMessageScheduleCountDocument,
    options
  );
}
export type GetMessageScheduleCountQueryHookResult = ReturnType<typeof useGetMessageScheduleCountQuery>;
export type GetMessageScheduleCountLazyQueryHookResult = ReturnType<typeof useGetMessageScheduleCountLazyQuery>;
export type GetMessageScheduleCountSuspenseQueryHookResult = ReturnType<typeof useGetMessageScheduleCountSuspenseQuery>;
export type GetMessageScheduleCountQueryResult = Apollo.QueryResult<
  GetMessageScheduleCountQuery,
  GetMessageScheduleCountQueryVariables
>;
export const EstimateRenewFailedSubscriptionV2Document = gql`
  query EstimateRenewFailedSubscriptionV2 {
    estimateRenewFailedSubscriptionV2 {
      message
      data {
        estimatedAmount
      }
    }
  }
`;

/**
 * __useEstimateRenewFailedSubscriptionV2Query__
 *
 * To run a query within a React component, call `useEstimateRenewFailedSubscriptionV2Query` and pass it any options that fit your needs.
 * When your component renders, `useEstimateRenewFailedSubscriptionV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateRenewFailedSubscriptionV2Query({
 *   variables: {
 *   },
 * });
 */
export function useEstimateRenewFailedSubscriptionV2Query(
  baseOptions?: Apollo.QueryHookOptions<
    EstimateRenewFailedSubscriptionV2Query,
    EstimateRenewFailedSubscriptionV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EstimateRenewFailedSubscriptionV2Query, EstimateRenewFailedSubscriptionV2QueryVariables>(
    EstimateRenewFailedSubscriptionV2Document,
    options
  );
}
export function useEstimateRenewFailedSubscriptionV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EstimateRenewFailedSubscriptionV2Query,
    EstimateRenewFailedSubscriptionV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EstimateRenewFailedSubscriptionV2Query, EstimateRenewFailedSubscriptionV2QueryVariables>(
    EstimateRenewFailedSubscriptionV2Document,
    options
  );
}
// @ts-ignore
export function useEstimateRenewFailedSubscriptionV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EstimateRenewFailedSubscriptionV2Query,
    EstimateRenewFailedSubscriptionV2QueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  EstimateRenewFailedSubscriptionV2Query,
  EstimateRenewFailedSubscriptionV2QueryVariables
>;
export function useEstimateRenewFailedSubscriptionV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EstimateRenewFailedSubscriptionV2Query,
        EstimateRenewFailedSubscriptionV2QueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  EstimateRenewFailedSubscriptionV2Query | undefined,
  EstimateRenewFailedSubscriptionV2QueryVariables
>;
export function useEstimateRenewFailedSubscriptionV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EstimateRenewFailedSubscriptionV2Query,
        EstimateRenewFailedSubscriptionV2QueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EstimateRenewFailedSubscriptionV2Query,
    EstimateRenewFailedSubscriptionV2QueryVariables
  >(EstimateRenewFailedSubscriptionV2Document, options);
}
export type EstimateRenewFailedSubscriptionV2QueryHookResult = ReturnType<
  typeof useEstimateRenewFailedSubscriptionV2Query
>;
export type EstimateRenewFailedSubscriptionV2LazyQueryHookResult = ReturnType<
  typeof useEstimateRenewFailedSubscriptionV2LazyQuery
>;
export type EstimateRenewFailedSubscriptionV2SuspenseQueryHookResult = ReturnType<
  typeof useEstimateRenewFailedSubscriptionV2SuspenseQuery
>;
export type EstimateRenewFailedSubscriptionV2QueryResult = Apollo.QueryResult<
  EstimateRenewFailedSubscriptionV2Query,
  EstimateRenewFailedSubscriptionV2QueryVariables
>;
export const GetCallTransferInCallSettingDocument = gql`
  query GetCallTransferInCallSetting($callSettingId: Int!) {
    getCallTransferInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        isActive
        transferPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        noAnswerPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
        terminatedPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetCallTransferInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetCallTransferInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallTransferInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallTransferInCallSettingQuery({
 *   variables: {
 *      callSettingId: // value for 'callSettingId'
 *   },
 * });
 */
export function useGetCallTransferInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallTransferInCallSettingQuery, GetCallTransferInCallSettingQueryVariables> &
    ({ variables: GetCallTransferInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallTransferInCallSettingQuery, GetCallTransferInCallSettingQueryVariables>(
    GetCallTransferInCallSettingDocument,
    options
  );
}
export function useGetCallTransferInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCallTransferInCallSettingQuery,
    GetCallTransferInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallTransferInCallSettingQuery, GetCallTransferInCallSettingQueryVariables>(
    GetCallTransferInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetCallTransferInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCallTransferInCallSettingQuery,
    GetCallTransferInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetCallTransferInCallSettingQuery, GetCallTransferInCallSettingQueryVariables>;
export function useGetCallTransferInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallTransferInCallSettingQuery, GetCallTransferInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetCallTransferInCallSettingQuery | undefined,
  GetCallTransferInCallSettingQueryVariables
>;
export function useGetCallTransferInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallTransferInCallSettingQuery, GetCallTransferInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallTransferInCallSettingQuery, GetCallTransferInCallSettingQueryVariables>(
    GetCallTransferInCallSettingDocument,
    options
  );
}
export type GetCallTransferInCallSettingQueryHookResult = ReturnType<typeof useGetCallTransferInCallSettingQuery>;
export type GetCallTransferInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetCallTransferInCallSettingLazyQuery
>;
export type GetCallTransferInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetCallTransferInCallSettingSuspenseQuery
>;
export type GetCallTransferInCallSettingQueryResult = Apollo.QueryResult<
  GetCallTransferInCallSettingQuery,
  GetCallTransferInCallSettingQueryVariables
>;
export const GetCallerIdInCallSettingDocument = gql`
  query GetCallerIdInCallSetting($callId: Int!) {
    getCallerIdInCallSetting(id: $callId) {
      message
      data {
        id
        callerIdInfo {
          id
        }
      }
    }
  }
`;

/**
 * __useGetCallerIdInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetCallerIdInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallerIdInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallerIdInCallSettingQuery({
 *   variables: {
 *      callId: // value for 'callId'
 *   },
 * });
 */
export function useGetCallerIdInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables> &
    ({ variables: GetCallerIdInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables>(
    GetCallerIdInCallSettingDocument,
    options
  );
}
export function useGetCallerIdInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables>(
    GetCallerIdInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetCallerIdInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables>;
export function useGetCallerIdInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallerIdInCallSettingQuery | undefined, GetCallerIdInCallSettingQueryVariables>;
export function useGetCallerIdInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallerIdInCallSettingQuery, GetCallerIdInCallSettingQueryVariables>(
    GetCallerIdInCallSettingDocument,
    options
  );
}
export type GetCallerIdInCallSettingQueryHookResult = ReturnType<typeof useGetCallerIdInCallSettingQuery>;
export type GetCallerIdInCallSettingLazyQueryHookResult = ReturnType<typeof useGetCallerIdInCallSettingLazyQuery>;
export type GetCallerIdInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetCallerIdInCallSettingSuspenseQuery
>;
export type GetCallerIdInCallSettingQueryResult = Apollo.QueryResult<
  GetCallerIdInCallSettingQuery,
  GetCallerIdInCallSettingQueryVariables
>;
export const GetTimeoutInCallSettingDocument = gql`
  query GetTimeoutInCallSetting($getTimeoutInCallSettingId: Int!) {
    getTimeoutInCallSetting(id: $getTimeoutInCallSettingId) {
      message
      data {
        id
        timeout
      }
    }
  }
`;

/**
 * __useGetTimeoutInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetTimeoutInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeoutInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeoutInCallSettingQuery({
 *   variables: {
 *      getTimeoutInCallSettingId: // value for 'getTimeoutInCallSettingId'
 *   },
 * });
 */
export function useGetTimeoutInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables> &
    ({ variables: GetTimeoutInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables>(
    GetTimeoutInCallSettingDocument,
    options
  );
}
export function useGetTimeoutInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables>(
    GetTimeoutInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetTimeoutInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables>;
export function useGetTimeoutInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetTimeoutInCallSettingQuery | undefined, GetTimeoutInCallSettingQueryVariables>;
export function useGetTimeoutInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTimeoutInCallSettingQuery, GetTimeoutInCallSettingQueryVariables>(
    GetTimeoutInCallSettingDocument,
    options
  );
}
export type GetTimeoutInCallSettingQueryHookResult = ReturnType<typeof useGetTimeoutInCallSettingQuery>;
export type GetTimeoutInCallSettingLazyQueryHookResult = ReturnType<typeof useGetTimeoutInCallSettingLazyQuery>;
export type GetTimeoutInCallSettingSuspenseQueryHookResult = ReturnType<typeof useGetTimeoutInCallSettingSuspenseQuery>;
export type GetTimeoutInCallSettingQueryResult = Apollo.QueryResult<
  GetTimeoutInCallSettingQuery,
  GetTimeoutInCallSettingQueryVariables
>;
export const GetCallerTuneInCallSettingDocument = gql`
  query GetCallerTuneInCallSetting($getCallerTuneInCallSettingId: Int!) {
    getCallerTuneInCallSetting(id: $getCallerTuneInCallSettingId) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
        callerTuneLoop
      }
    }
  }
`;

/**
 * __useGetCallerTuneInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetCallerTuneInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallerTuneInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallerTuneInCallSettingQuery({
 *   variables: {
 *      getCallerTuneInCallSettingId: // value for 'getCallerTuneInCallSettingId'
 *   },
 * });
 */
export function useGetCallerTuneInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallerTuneInCallSettingQuery, GetCallerTuneInCallSettingQueryVariables> &
    ({ variables: GetCallerTuneInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallerTuneInCallSettingQuery, GetCallerTuneInCallSettingQueryVariables>(
    GetCallerTuneInCallSettingDocument,
    options
  );
}
export function useGetCallerTuneInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallerTuneInCallSettingQuery, GetCallerTuneInCallSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallerTuneInCallSettingQuery, GetCallerTuneInCallSettingQueryVariables>(
    GetCallerTuneInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetCallerTuneInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCallerTuneInCallSettingQuery,
    GetCallerTuneInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetCallerTuneInCallSettingQuery, GetCallerTuneInCallSettingQueryVariables>;
export function useGetCallerTuneInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallerTuneInCallSettingQuery, GetCallerTuneInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallerTuneInCallSettingQuery | undefined, GetCallerTuneInCallSettingQueryVariables>;
export function useGetCallerTuneInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallerTuneInCallSettingQuery, GetCallerTuneInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallerTuneInCallSettingQuery, GetCallerTuneInCallSettingQueryVariables>(
    GetCallerTuneInCallSettingDocument,
    options
  );
}
export type GetCallerTuneInCallSettingQueryHookResult = ReturnType<typeof useGetCallerTuneInCallSettingQuery>;
export type GetCallerTuneInCallSettingLazyQueryHookResult = ReturnType<typeof useGetCallerTuneInCallSettingLazyQuery>;
export type GetCallerTuneInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetCallerTuneInCallSettingSuspenseQuery
>;
export type GetCallerTuneInCallSettingQueryResult = Apollo.QueryResult<
  GetCallerTuneInCallSettingQuery,
  GetCallerTuneInCallSettingQueryVariables
>;
export const GetWelcomeMessageInCallSettingDocument = gql`
  query GetWelcomeMessageInCallSetting($getWelcomeMessageInCallSettingId: Int!) {
    getWelcomeMessageInCallSetting(id: $getWelcomeMessageInCallSettingId) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
      }
    }
  }
`;

/**
 * __useGetWelcomeMessageInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetWelcomeMessageInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelcomeMessageInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelcomeMessageInCallSettingQuery({
 *   variables: {
 *      getWelcomeMessageInCallSettingId: // value for 'getWelcomeMessageInCallSettingId'
 *   },
 * });
 */
export function useGetWelcomeMessageInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWelcomeMessageInCallSettingQuery,
    GetWelcomeMessageInCallSettingQueryVariables
  > &
    ({ variables: GetWelcomeMessageInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWelcomeMessageInCallSettingQuery, GetWelcomeMessageInCallSettingQueryVariables>(
    GetWelcomeMessageInCallSettingDocument,
    options
  );
}
export function useGetWelcomeMessageInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWelcomeMessageInCallSettingQuery,
    GetWelcomeMessageInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWelcomeMessageInCallSettingQuery, GetWelcomeMessageInCallSettingQueryVariables>(
    GetWelcomeMessageInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetWelcomeMessageInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWelcomeMessageInCallSettingQuery,
    GetWelcomeMessageInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetWelcomeMessageInCallSettingQuery, GetWelcomeMessageInCallSettingQueryVariables>;
export function useGetWelcomeMessageInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWelcomeMessageInCallSettingQuery, GetWelcomeMessageInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetWelcomeMessageInCallSettingQuery | undefined,
  GetWelcomeMessageInCallSettingQueryVariables
>;
export function useGetWelcomeMessageInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWelcomeMessageInCallSettingQuery, GetWelcomeMessageInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWelcomeMessageInCallSettingQuery, GetWelcomeMessageInCallSettingQueryVariables>(
    GetWelcomeMessageInCallSettingDocument,
    options
  );
}
export type GetWelcomeMessageInCallSettingQueryHookResult = ReturnType<typeof useGetWelcomeMessageInCallSettingQuery>;
export type GetWelcomeMessageInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetWelcomeMessageInCallSettingLazyQuery
>;
export type GetWelcomeMessageInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetWelcomeMessageInCallSettingSuspenseQuery
>;
export type GetWelcomeMessageInCallSettingQueryResult = Apollo.QueryResult<
  GetWelcomeMessageInCallSettingQuery,
  GetWelcomeMessageInCallSettingQueryVariables
>;
export const WorkspaceRateLimitsDocument = gql`
  query WorkspaceRateLimits {
    workspaceRateLimits {
      message
      data {
        id
        category
        direction
        threshold
        timeLimit
        segmentLimit
        exhaust {
          value
        }
      }
    }
  }
`;

/**
 * __useWorkspaceRateLimitsQuery__
 *
 * To run a query within a React component, call `useWorkspaceRateLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceRateLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceRateLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceRateLimitsQuery(
  baseOptions?: Apollo.QueryHookOptions<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>(
    WorkspaceRateLimitsDocument,
    options
  );
}
export function useWorkspaceRateLimitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>(
    WorkspaceRateLimitsDocument,
    options
  );
}
// @ts-ignore
export function useWorkspaceRateLimitsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>
): Apollo.UseSuspenseQueryResult<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>;
export function useWorkspaceRateLimitsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>
): Apollo.UseSuspenseQueryResult<WorkspaceRateLimitsQuery | undefined, WorkspaceRateLimitsQueryVariables>;
export function useWorkspaceRateLimitsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkspaceRateLimitsQuery, WorkspaceRateLimitsQueryVariables>(
    WorkspaceRateLimitsDocument,
    options
  );
}
export type WorkspaceRateLimitsQueryHookResult = ReturnType<typeof useWorkspaceRateLimitsQuery>;
export type WorkspaceRateLimitsLazyQueryHookResult = ReturnType<typeof useWorkspaceRateLimitsLazyQuery>;
export type WorkspaceRateLimitsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceRateLimitsSuspenseQuery>;
export type WorkspaceRateLimitsQueryResult = Apollo.QueryResult<
  WorkspaceRateLimitsQuery,
  WorkspaceRateLimitsQueryVariables
>;
export const WorkspaceA2PVerificationStatusDocument = gql`
  query WorkspaceA2PVerificationStatus {
    workspaceA2PVerificationStatus {
      message
      data {
        a2pVerified
      }
    }
  }
`;

/**
 * __useWorkspaceA2PVerificationStatusQuery__
 *
 * To run a query within a React component, call `useWorkspaceA2PVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceA2PVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceA2PVerificationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceA2PVerificationStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorkspaceA2PVerificationStatusQuery,
    WorkspaceA2PVerificationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceA2PVerificationStatusQuery, WorkspaceA2PVerificationStatusQueryVariables>(
    WorkspaceA2PVerificationStatusDocument,
    options
  );
}
export function useWorkspaceA2PVerificationStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkspaceA2PVerificationStatusQuery,
    WorkspaceA2PVerificationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkspaceA2PVerificationStatusQuery, WorkspaceA2PVerificationStatusQueryVariables>(
    WorkspaceA2PVerificationStatusDocument,
    options
  );
}
// @ts-ignore
export function useWorkspaceA2PVerificationStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkspaceA2PVerificationStatusQuery,
    WorkspaceA2PVerificationStatusQueryVariables
  >
): Apollo.UseSuspenseQueryResult<WorkspaceA2PVerificationStatusQuery, WorkspaceA2PVerificationStatusQueryVariables>;
export function useWorkspaceA2PVerificationStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceA2PVerificationStatusQuery, WorkspaceA2PVerificationStatusQueryVariables>
): Apollo.UseSuspenseQueryResult<
  WorkspaceA2PVerificationStatusQuery | undefined,
  WorkspaceA2PVerificationStatusQueryVariables
>;
export function useWorkspaceA2PVerificationStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceA2PVerificationStatusQuery, WorkspaceA2PVerificationStatusQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkspaceA2PVerificationStatusQuery, WorkspaceA2PVerificationStatusQueryVariables>(
    WorkspaceA2PVerificationStatusDocument,
    options
  );
}
export type WorkspaceA2PVerificationStatusQueryHookResult = ReturnType<typeof useWorkspaceA2PVerificationStatusQuery>;
export type WorkspaceA2PVerificationStatusLazyQueryHookResult = ReturnType<
  typeof useWorkspaceA2PVerificationStatusLazyQuery
>;
export type WorkspaceA2PVerificationStatusSuspenseQueryHookResult = ReturnType<
  typeof useWorkspaceA2PVerificationStatusSuspenseQuery
>;
export type WorkspaceA2PVerificationStatusQueryResult = Apollo.QueryResult<
  WorkspaceA2PVerificationStatusQuery,
  WorkspaceA2PVerificationStatusQueryVariables
>;
export const GetContactComplianceConsentDocument = gql`
  query GetContactComplianceConsent($getContactComplianceConsentId: Int!) {
    getContactComplianceConsent(id: $getContactComplianceConsentId) {
      message
      data {
        id
        consentedAt
        isConsented
        consentSource
        consentDetails
        campaign {
          id
          messageServiceName
        }
        flowDetails
      }
    }
  }
`;

/**
 * __useGetContactComplianceConsentQuery__
 *
 * To run a query within a React component, call `useGetContactComplianceConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactComplianceConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactComplianceConsentQuery({
 *   variables: {
 *      getContactComplianceConsentId: // value for 'getContactComplianceConsentId'
 *   },
 * });
 */
export function useGetContactComplianceConsentQuery(
  baseOptions: Apollo.QueryHookOptions<GetContactComplianceConsentQuery, GetContactComplianceConsentQueryVariables> &
    ({ variables: GetContactComplianceConsentQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContactComplianceConsentQuery, GetContactComplianceConsentQueryVariables>(
    GetContactComplianceConsentDocument,
    options
  );
}
export function useGetContactComplianceConsentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetContactComplianceConsentQuery, GetContactComplianceConsentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContactComplianceConsentQuery, GetContactComplianceConsentQueryVariables>(
    GetContactComplianceConsentDocument,
    options
  );
}
// @ts-ignore
export function useGetContactComplianceConsentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContactComplianceConsentQuery,
    GetContactComplianceConsentQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetContactComplianceConsentQuery, GetContactComplianceConsentQueryVariables>;
export function useGetContactComplianceConsentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContactComplianceConsentQuery, GetContactComplianceConsentQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetContactComplianceConsentQuery | undefined,
  GetContactComplianceConsentQueryVariables
>;
export function useGetContactComplianceConsentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContactComplianceConsentQuery, GetContactComplianceConsentQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetContactComplianceConsentQuery, GetContactComplianceConsentQueryVariables>(
    GetContactComplianceConsentDocument,
    options
  );
}
export type GetContactComplianceConsentQueryHookResult = ReturnType<typeof useGetContactComplianceConsentQuery>;
export type GetContactComplianceConsentLazyQueryHookResult = ReturnType<typeof useGetContactComplianceConsentLazyQuery>;
export type GetContactComplianceConsentSuspenseQueryHookResult = ReturnType<
  typeof useGetContactComplianceConsentSuspenseQuery
>;
export type GetContactComplianceConsentQueryResult = Apollo.QueryResult<
  GetContactComplianceConsentQuery,
  GetContactComplianceConsentQueryVariables
>;
export const GetCallerIdInChannelSettingDocument = gql`
  query GetCallerIdInChannelSetting($channelId: Int!) {
    getCallerIdInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        callerIdInfo {
          id
        }
      }
    }
  }
`;

/**
 * __useGetCallerIdInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetCallerIdInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallerIdInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallerIdInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetCallerIdInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallerIdInChannelSettingQuery, GetCallerIdInChannelSettingQueryVariables> &
    ({ variables: GetCallerIdInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallerIdInChannelSettingQuery, GetCallerIdInChannelSettingQueryVariables>(
    GetCallerIdInChannelSettingDocument,
    options
  );
}
export function useGetCallerIdInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallerIdInChannelSettingQuery, GetCallerIdInChannelSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallerIdInChannelSettingQuery, GetCallerIdInChannelSettingQueryVariables>(
    GetCallerIdInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetCallerIdInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCallerIdInChannelSettingQuery,
    GetCallerIdInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetCallerIdInChannelSettingQuery, GetCallerIdInChannelSettingQueryVariables>;
export function useGetCallerIdInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallerIdInChannelSettingQuery, GetCallerIdInChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetCallerIdInChannelSettingQuery | undefined,
  GetCallerIdInChannelSettingQueryVariables
>;
export function useGetCallerIdInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallerIdInChannelSettingQuery, GetCallerIdInChannelSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallerIdInChannelSettingQuery, GetCallerIdInChannelSettingQueryVariables>(
    GetCallerIdInChannelSettingDocument,
    options
  );
}
export type GetCallerIdInChannelSettingQueryHookResult = ReturnType<typeof useGetCallerIdInChannelSettingQuery>;
export type GetCallerIdInChannelSettingLazyQueryHookResult = ReturnType<typeof useGetCallerIdInChannelSettingLazyQuery>;
export type GetCallerIdInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetCallerIdInChannelSettingSuspenseQuery
>;
export type GetCallerIdInChannelSettingQueryResult = Apollo.QueryResult<
  GetCallerIdInChannelSettingQuery,
  GetCallerIdInChannelSettingQueryVariables
>;
export const GetCallForwardInChannelSettingDocument = gql`
  query GetCallForwardInChannelSetting($channelId: Int!) {
    getCallForwardInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isUnconditional
        targetPhoneNumber
        isActive
      }
    }
  }
`;

/**
 * __useGetCallForwardInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetCallForwardInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallForwardInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallForwardInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetCallForwardInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCallForwardInChannelSettingQuery,
    GetCallForwardInChannelSettingQueryVariables
  > &
    ({ variables: GetCallForwardInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallForwardInChannelSettingQuery, GetCallForwardInChannelSettingQueryVariables>(
    GetCallForwardInChannelSettingDocument,
    options
  );
}
export function useGetCallForwardInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCallForwardInChannelSettingQuery,
    GetCallForwardInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallForwardInChannelSettingQuery, GetCallForwardInChannelSettingQueryVariables>(
    GetCallForwardInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetCallForwardInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCallForwardInChannelSettingQuery,
    GetCallForwardInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetCallForwardInChannelSettingQuery, GetCallForwardInChannelSettingQueryVariables>;
export function useGetCallForwardInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallForwardInChannelSettingQuery, GetCallForwardInChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetCallForwardInChannelSettingQuery | undefined,
  GetCallForwardInChannelSettingQueryVariables
>;
export function useGetCallForwardInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallForwardInChannelSettingQuery, GetCallForwardInChannelSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallForwardInChannelSettingQuery, GetCallForwardInChannelSettingQueryVariables>(
    GetCallForwardInChannelSettingDocument,
    options
  );
}
export type GetCallForwardInChannelSettingQueryHookResult = ReturnType<typeof useGetCallForwardInChannelSettingQuery>;
export type GetCallForwardInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetCallForwardInChannelSettingLazyQuery
>;
export type GetCallForwardInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetCallForwardInChannelSettingSuspenseQuery
>;
export type GetCallForwardInChannelSettingQueryResult = Apollo.QueryResult<
  GetCallForwardInChannelSettingQuery,
  GetCallForwardInChannelSettingQueryVariables
>;
export const GetAutoTranscribeInCallSettingDocument = gql`
  query GetAutoTranscribeInCallSetting($getAutoTranscribeInCallSettingId: Int!) {
    getAutoTranscribeInCallSetting(id: $getAutoTranscribeInCallSettingId) {
      message
      data {
        id
        autoTranscribe
      }
    }
  }
`;

/**
 * __useGetAutoTranscribeInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetAutoTranscribeInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoTranscribeInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoTranscribeInCallSettingQuery({
 *   variables: {
 *      getAutoTranscribeInCallSettingId: // value for 'getAutoTranscribeInCallSettingId'
 *   },
 * });
 */
export function useGetAutoTranscribeInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutoTranscribeInCallSettingQuery,
    GetAutoTranscribeInCallSettingQueryVariables
  > &
    ({ variables: GetAutoTranscribeInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAutoTranscribeInCallSettingQuery, GetAutoTranscribeInCallSettingQueryVariables>(
    GetAutoTranscribeInCallSettingDocument,
    options
  );
}
export function useGetAutoTranscribeInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutoTranscribeInCallSettingQuery,
    GetAutoTranscribeInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAutoTranscribeInCallSettingQuery, GetAutoTranscribeInCallSettingQueryVariables>(
    GetAutoTranscribeInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetAutoTranscribeInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAutoTranscribeInCallSettingQuery,
    GetAutoTranscribeInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetAutoTranscribeInCallSettingQuery, GetAutoTranscribeInCallSettingQueryVariables>;
export function useGetAutoTranscribeInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAutoTranscribeInCallSettingQuery, GetAutoTranscribeInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetAutoTranscribeInCallSettingQuery | undefined,
  GetAutoTranscribeInCallSettingQueryVariables
>;
export function useGetAutoTranscribeInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAutoTranscribeInCallSettingQuery, GetAutoTranscribeInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAutoTranscribeInCallSettingQuery, GetAutoTranscribeInCallSettingQueryVariables>(
    GetAutoTranscribeInCallSettingDocument,
    options
  );
}
export type GetAutoTranscribeInCallSettingQueryHookResult = ReturnType<typeof useGetAutoTranscribeInCallSettingQuery>;
export type GetAutoTranscribeInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetAutoTranscribeInCallSettingLazyQuery
>;
export type GetAutoTranscribeInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetAutoTranscribeInCallSettingSuspenseQuery
>;
export type GetAutoTranscribeInCallSettingQueryResult = Apollo.QueryResult<
  GetAutoTranscribeInCallSettingQuery,
  GetAutoTranscribeInCallSettingQueryVariables
>;
export const GetRecordingAnnouncementInCallSettingDocument = gql`
  query GetRecordingAnnouncementInCallSetting($getRecordingAnnouncementInCallSettingId: Int!) {
    getRecordingAnnouncementInCallSetting(id: $getRecordingAnnouncementInCallSettingId) {
      message
      data {
        recordingAnnouncementMessage
        recordingAnnouncementAfterBeep
        id
        audioPrompt {
          audio {
            url
            id
          }
          id
          gender
          language
          text
          type
          workspaceId
        }
      }
    }
  }
`;

/**
 * __useGetRecordingAnnouncementInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetRecordingAnnouncementInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingAnnouncementInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingAnnouncementInCallSettingQuery({
 *   variables: {
 *      getRecordingAnnouncementInCallSettingId: // value for 'getRecordingAnnouncementInCallSettingId'
 *   },
 * });
 */
export function useGetRecordingAnnouncementInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRecordingAnnouncementInCallSettingQuery,
    GetRecordingAnnouncementInCallSettingQueryVariables
  > &
    ({ variables: GetRecordingAnnouncementInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRecordingAnnouncementInCallSettingQuery,
    GetRecordingAnnouncementInCallSettingQueryVariables
  >(GetRecordingAnnouncementInCallSettingDocument, options);
}
export function useGetRecordingAnnouncementInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecordingAnnouncementInCallSettingQuery,
    GetRecordingAnnouncementInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRecordingAnnouncementInCallSettingQuery,
    GetRecordingAnnouncementInCallSettingQueryVariables
  >(GetRecordingAnnouncementInCallSettingDocument, options);
}
// @ts-ignore
export function useGetRecordingAnnouncementInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRecordingAnnouncementInCallSettingQuery,
    GetRecordingAnnouncementInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetRecordingAnnouncementInCallSettingQuery,
  GetRecordingAnnouncementInCallSettingQueryVariables
>;
export function useGetRecordingAnnouncementInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRecordingAnnouncementInCallSettingQuery,
        GetRecordingAnnouncementInCallSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetRecordingAnnouncementInCallSettingQuery | undefined,
  GetRecordingAnnouncementInCallSettingQueryVariables
>;
export function useGetRecordingAnnouncementInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRecordingAnnouncementInCallSettingQuery,
        GetRecordingAnnouncementInCallSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRecordingAnnouncementInCallSettingQuery,
    GetRecordingAnnouncementInCallSettingQueryVariables
  >(GetRecordingAnnouncementInCallSettingDocument, options);
}
export type GetRecordingAnnouncementInCallSettingQueryHookResult = ReturnType<
  typeof useGetRecordingAnnouncementInCallSettingQuery
>;
export type GetRecordingAnnouncementInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetRecordingAnnouncementInCallSettingLazyQuery
>;
export type GetRecordingAnnouncementInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetRecordingAnnouncementInCallSettingSuspenseQuery
>;
export type GetRecordingAnnouncementInCallSettingQueryResult = Apollo.QueryResult<
  GetRecordingAnnouncementInCallSettingQuery,
  GetRecordingAnnouncementInCallSettingQueryVariables
>;
export const GetAutoRecordingInCallSettingDocument = gql`
  query GetAutoRecordingInCallSetting($getAutoRecordingInCallSettingId: Int!) {
    getAutoRecordingInCallSetting(id: $getAutoRecordingInCallSettingId) {
      message
      data {
        id
        autoRecording
      }
    }
  }
`;

/**
 * __useGetAutoRecordingInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetAutoRecordingInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoRecordingInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoRecordingInCallSettingQuery({
 *   variables: {
 *      getAutoRecordingInCallSettingId: // value for 'getAutoRecordingInCallSettingId'
 *   },
 * });
 */
export function useGetAutoRecordingInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutoRecordingInCallSettingQuery,
    GetAutoRecordingInCallSettingQueryVariables
  > &
    ({ variables: GetAutoRecordingInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAutoRecordingInCallSettingQuery, GetAutoRecordingInCallSettingQueryVariables>(
    GetAutoRecordingInCallSettingDocument,
    options
  );
}
export function useGetAutoRecordingInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutoRecordingInCallSettingQuery,
    GetAutoRecordingInCallSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAutoRecordingInCallSettingQuery, GetAutoRecordingInCallSettingQueryVariables>(
    GetAutoRecordingInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetAutoRecordingInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAutoRecordingInCallSettingQuery,
    GetAutoRecordingInCallSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetAutoRecordingInCallSettingQuery, GetAutoRecordingInCallSettingQueryVariables>;
export function useGetAutoRecordingInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAutoRecordingInCallSettingQuery, GetAutoRecordingInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetAutoRecordingInCallSettingQuery | undefined,
  GetAutoRecordingInCallSettingQueryVariables
>;
export function useGetAutoRecordingInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAutoRecordingInCallSettingQuery, GetAutoRecordingInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAutoRecordingInCallSettingQuery, GetAutoRecordingInCallSettingQueryVariables>(
    GetAutoRecordingInCallSettingDocument,
    options
  );
}
export type GetAutoRecordingInCallSettingQueryHookResult = ReturnType<typeof useGetAutoRecordingInCallSettingQuery>;
export type GetAutoRecordingInCallSettingLazyQueryHookResult = ReturnType<
  typeof useGetAutoRecordingInCallSettingLazyQuery
>;
export type GetAutoRecordingInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetAutoRecordingInCallSettingSuspenseQuery
>;
export type GetAutoRecordingInCallSettingQueryResult = Apollo.QueryResult<
  GetAutoRecordingInCallSettingQuery,
  GetAutoRecordingInCallSettingQueryVariables
>;
export const GetWelcomeMessageInChannelSettingDocument = gql`
  query GetWelcomeMessageInChannelSetting($channelId: Int!) {
    getWelcomeMessageInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
      }
    }
  }
`;

/**
 * __useGetWelcomeMessageInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetWelcomeMessageInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelcomeMessageInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelcomeMessageInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetWelcomeMessageInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWelcomeMessageInChannelSettingQuery,
    GetWelcomeMessageInChannelSettingQueryVariables
  > &
    ({ variables: GetWelcomeMessageInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWelcomeMessageInChannelSettingQuery, GetWelcomeMessageInChannelSettingQueryVariables>(
    GetWelcomeMessageInChannelSettingDocument,
    options
  );
}
export function useGetWelcomeMessageInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWelcomeMessageInChannelSettingQuery,
    GetWelcomeMessageInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWelcomeMessageInChannelSettingQuery, GetWelcomeMessageInChannelSettingQueryVariables>(
    GetWelcomeMessageInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetWelcomeMessageInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWelcomeMessageInChannelSettingQuery,
    GetWelcomeMessageInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetWelcomeMessageInChannelSettingQuery,
  GetWelcomeMessageInChannelSettingQueryVariables
>;
export function useGetWelcomeMessageInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWelcomeMessageInChannelSettingQuery,
        GetWelcomeMessageInChannelSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetWelcomeMessageInChannelSettingQuery | undefined,
  GetWelcomeMessageInChannelSettingQueryVariables
>;
export function useGetWelcomeMessageInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWelcomeMessageInChannelSettingQuery,
        GetWelcomeMessageInChannelSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWelcomeMessageInChannelSettingQuery,
    GetWelcomeMessageInChannelSettingQueryVariables
  >(GetWelcomeMessageInChannelSettingDocument, options);
}
export type GetWelcomeMessageInChannelSettingQueryHookResult = ReturnType<
  typeof useGetWelcomeMessageInChannelSettingQuery
>;
export type GetWelcomeMessageInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetWelcomeMessageInChannelSettingLazyQuery
>;
export type GetWelcomeMessageInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetWelcomeMessageInChannelSettingSuspenseQuery
>;
export type GetWelcomeMessageInChannelSettingQueryResult = Apollo.QueryResult<
  GetWelcomeMessageInChannelSettingQuery,
  GetWelcomeMessageInChannelSettingQueryVariables
>;
export const GetTimeoutInChannelSettingDocument = gql`
  query GetTimeoutInChannelSetting($channelId: Int!) {
    getTimeoutInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        timeout
      }
    }
  }
`;

/**
 * __useGetTimeoutInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetTimeoutInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeoutInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeoutInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetTimeoutInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetTimeoutInChannelSettingQuery, GetTimeoutInChannelSettingQueryVariables> &
    ({ variables: GetTimeoutInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTimeoutInChannelSettingQuery, GetTimeoutInChannelSettingQueryVariables>(
    GetTimeoutInChannelSettingDocument,
    options
  );
}
export function useGetTimeoutInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTimeoutInChannelSettingQuery, GetTimeoutInChannelSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTimeoutInChannelSettingQuery, GetTimeoutInChannelSettingQueryVariables>(
    GetTimeoutInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetTimeoutInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTimeoutInChannelSettingQuery,
    GetTimeoutInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetTimeoutInChannelSettingQuery, GetTimeoutInChannelSettingQueryVariables>;
export function useGetTimeoutInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTimeoutInChannelSettingQuery, GetTimeoutInChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetTimeoutInChannelSettingQuery | undefined, GetTimeoutInChannelSettingQueryVariables>;
export function useGetTimeoutInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTimeoutInChannelSettingQuery, GetTimeoutInChannelSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTimeoutInChannelSettingQuery, GetTimeoutInChannelSettingQueryVariables>(
    GetTimeoutInChannelSettingDocument,
    options
  );
}
export type GetTimeoutInChannelSettingQueryHookResult = ReturnType<typeof useGetTimeoutInChannelSettingQuery>;
export type GetTimeoutInChannelSettingLazyQueryHookResult = ReturnType<typeof useGetTimeoutInChannelSettingLazyQuery>;
export type GetTimeoutInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetTimeoutInChannelSettingSuspenseQuery
>;
export type GetTimeoutInChannelSettingQueryResult = Apollo.QueryResult<
  GetTimeoutInChannelSettingQuery,
  GetTimeoutInChannelSettingQueryVariables
>;
export const GetCallerTuneInChannelSettingDocument = gql`
  query GetCallerTuneInChannelSetting($channelId: Int!) {
    getCallerTuneInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
        callerTuneLoop
      }
    }
  }
`;

/**
 * __useGetCallerTuneInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetCallerTuneInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallerTuneInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallerTuneInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetCallerTuneInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCallerTuneInChannelSettingQuery,
    GetCallerTuneInChannelSettingQueryVariables
  > &
    ({ variables: GetCallerTuneInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallerTuneInChannelSettingQuery, GetCallerTuneInChannelSettingQueryVariables>(
    GetCallerTuneInChannelSettingDocument,
    options
  );
}
export function useGetCallerTuneInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCallerTuneInChannelSettingQuery,
    GetCallerTuneInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallerTuneInChannelSettingQuery, GetCallerTuneInChannelSettingQueryVariables>(
    GetCallerTuneInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetCallerTuneInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCallerTuneInChannelSettingQuery,
    GetCallerTuneInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetCallerTuneInChannelSettingQuery, GetCallerTuneInChannelSettingQueryVariables>;
export function useGetCallerTuneInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallerTuneInChannelSettingQuery, GetCallerTuneInChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetCallerTuneInChannelSettingQuery | undefined,
  GetCallerTuneInChannelSettingQueryVariables
>;
export function useGetCallerTuneInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallerTuneInChannelSettingQuery, GetCallerTuneInChannelSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallerTuneInChannelSettingQuery, GetCallerTuneInChannelSettingQueryVariables>(
    GetCallerTuneInChannelSettingDocument,
    options
  );
}
export type GetCallerTuneInChannelSettingQueryHookResult = ReturnType<typeof useGetCallerTuneInChannelSettingQuery>;
export type GetCallerTuneInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetCallerTuneInChannelSettingLazyQuery
>;
export type GetCallerTuneInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetCallerTuneInChannelSettingSuspenseQuery
>;
export type GetCallerTuneInChannelSettingQueryResult = Apollo.QueryResult<
  GetCallerTuneInChannelSettingQuery,
  GetCallerTuneInChannelSettingQueryVariables
>;
export const GetVoicemailInCallSettingDocument = gql`
  query GetVoicemailInCallSetting($getVoicemailInCallSettingId: Int!) {
    getVoicemailInCallSetting(id: $getVoicemailInCallSettingId) {
      message
      data {
        voicemailAfterBeep
        sendVoicemailToEmail
        isActive
        id
        audioPrompt {
          type
          text
          language
          id
          gender
          audio {
            url
            id
            mimetype
          }
          workspaceId
        }
      }
    }
  }
`;

/**
 * __useGetVoicemailInCallSettingQuery__
 *
 * To run a query within a React component, call `useGetVoicemailInCallSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoicemailInCallSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoicemailInCallSettingQuery({
 *   variables: {
 *      getVoicemailInCallSettingId: // value for 'getVoicemailInCallSettingId'
 *   },
 * });
 */
export function useGetVoicemailInCallSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables> &
    ({ variables: GetVoicemailInCallSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables>(
    GetVoicemailInCallSettingDocument,
    options
  );
}
export function useGetVoicemailInCallSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables>(
    GetVoicemailInCallSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetVoicemailInCallSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables>;
export function useGetVoicemailInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetVoicemailInCallSettingQuery | undefined, GetVoicemailInCallSettingQueryVariables>;
export function useGetVoicemailInCallSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetVoicemailInCallSettingQuery, GetVoicemailInCallSettingQueryVariables>(
    GetVoicemailInCallSettingDocument,
    options
  );
}
export type GetVoicemailInCallSettingQueryHookResult = ReturnType<typeof useGetVoicemailInCallSettingQuery>;
export type GetVoicemailInCallSettingLazyQueryHookResult = ReturnType<typeof useGetVoicemailInCallSettingLazyQuery>;
export type GetVoicemailInCallSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetVoicemailInCallSettingSuspenseQuery
>;
export type GetVoicemailInCallSettingQueryResult = Apollo.QueryResult<
  GetVoicemailInCallSettingQuery,
  GetVoicemailInCallSettingQueryVariables
>;
export const GetCallTransferInChannelSettingDocument = gql`
  query GetCallTransferInChannelSetting($channelId: Int!) {
    getCallTransferInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isActive
        transferPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        noAnswerPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
        terminatedPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetCallTransferInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetCallTransferInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallTransferInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallTransferInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetCallTransferInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCallTransferInChannelSettingQuery,
    GetCallTransferInChannelSettingQueryVariables
  > &
    ({ variables: GetCallTransferInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallTransferInChannelSettingQuery, GetCallTransferInChannelSettingQueryVariables>(
    GetCallTransferInChannelSettingDocument,
    options
  );
}
export function useGetCallTransferInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCallTransferInChannelSettingQuery,
    GetCallTransferInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallTransferInChannelSettingQuery, GetCallTransferInChannelSettingQueryVariables>(
    GetCallTransferInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetCallTransferInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCallTransferInChannelSettingQuery,
    GetCallTransferInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetCallTransferInChannelSettingQuery, GetCallTransferInChannelSettingQueryVariables>;
export function useGetCallTransferInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCallTransferInChannelSettingQuery,
        GetCallTransferInChannelSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCallTransferInChannelSettingQuery | undefined,
  GetCallTransferInChannelSettingQueryVariables
>;
export function useGetCallTransferInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCallTransferInChannelSettingQuery,
        GetCallTransferInChannelSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallTransferInChannelSettingQuery, GetCallTransferInChannelSettingQueryVariables>(
    GetCallTransferInChannelSettingDocument,
    options
  );
}
export type GetCallTransferInChannelSettingQueryHookResult = ReturnType<typeof useGetCallTransferInChannelSettingQuery>;
export type GetCallTransferInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetCallTransferInChannelSettingLazyQuery
>;
export type GetCallTransferInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetCallTransferInChannelSettingSuspenseQuery
>;
export type GetCallTransferInChannelSettingQueryResult = Apollo.QueryResult<
  GetCallTransferInChannelSettingQuery,
  GetCallTransferInChannelSettingQueryVariables
>;
export const GetVoicemailInChannelSettingDocument = gql`
  query GetVoicemailInChannelSetting($channelId: Int!) {
    getVoicemailInChannelSetting(channelId: $channelId) {
      message
      data {
        voicemailAfterBeep
        sendVoicemailToEmail
        isActive
        id
        audioPrompt {
          type
          text
          language
          id
          gender
          audio {
            url
            id
            mimetype
          }
          workspaceId
        }
      }
    }
  }
`;

/**
 * __useGetVoicemailInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetVoicemailInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoicemailInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoicemailInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetVoicemailInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetVoicemailInChannelSettingQuery, GetVoicemailInChannelSettingQueryVariables> &
    ({ variables: GetVoicemailInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVoicemailInChannelSettingQuery, GetVoicemailInChannelSettingQueryVariables>(
    GetVoicemailInChannelSettingDocument,
    options
  );
}
export function useGetVoicemailInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVoicemailInChannelSettingQuery,
    GetVoicemailInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVoicemailInChannelSettingQuery, GetVoicemailInChannelSettingQueryVariables>(
    GetVoicemailInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetVoicemailInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetVoicemailInChannelSettingQuery,
    GetVoicemailInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetVoicemailInChannelSettingQuery, GetVoicemailInChannelSettingQueryVariables>;
export function useGetVoicemailInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVoicemailInChannelSettingQuery, GetVoicemailInChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetVoicemailInChannelSettingQuery | undefined,
  GetVoicemailInChannelSettingQueryVariables
>;
export function useGetVoicemailInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVoicemailInChannelSettingQuery, GetVoicemailInChannelSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetVoicemailInChannelSettingQuery, GetVoicemailInChannelSettingQueryVariables>(
    GetVoicemailInChannelSettingDocument,
    options
  );
}
export type GetVoicemailInChannelSettingQueryHookResult = ReturnType<typeof useGetVoicemailInChannelSettingQuery>;
export type GetVoicemailInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetVoicemailInChannelSettingLazyQuery
>;
export type GetVoicemailInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetVoicemailInChannelSettingSuspenseQuery
>;
export type GetVoicemailInChannelSettingQueryResult = Apollo.QueryResult<
  GetVoicemailInChannelSettingQuery,
  GetVoicemailInChannelSettingQueryVariables
>;
export const GetAutoRecordingInChannelSettingDocument = gql`
  query GetAutoRecordingInChannelSetting($channelId: Int!) {
    getAutoRecordingInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        autoRecording
      }
    }
  }
`;

/**
 * __useGetAutoRecordingInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetAutoRecordingInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoRecordingInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoRecordingInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetAutoRecordingInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutoRecordingInChannelSettingQuery,
    GetAutoRecordingInChannelSettingQueryVariables
  > &
    ({ variables: GetAutoRecordingInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAutoRecordingInChannelSettingQuery, GetAutoRecordingInChannelSettingQueryVariables>(
    GetAutoRecordingInChannelSettingDocument,
    options
  );
}
export function useGetAutoRecordingInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutoRecordingInChannelSettingQuery,
    GetAutoRecordingInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAutoRecordingInChannelSettingQuery, GetAutoRecordingInChannelSettingQueryVariables>(
    GetAutoRecordingInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetAutoRecordingInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAutoRecordingInChannelSettingQuery,
    GetAutoRecordingInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetAutoRecordingInChannelSettingQuery, GetAutoRecordingInChannelSettingQueryVariables>;
export function useGetAutoRecordingInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAutoRecordingInChannelSettingQuery,
        GetAutoRecordingInChannelSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAutoRecordingInChannelSettingQuery | undefined,
  GetAutoRecordingInChannelSettingQueryVariables
>;
export function useGetAutoRecordingInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAutoRecordingInChannelSettingQuery,
        GetAutoRecordingInChannelSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAutoRecordingInChannelSettingQuery, GetAutoRecordingInChannelSettingQueryVariables>(
    GetAutoRecordingInChannelSettingDocument,
    options
  );
}
export type GetAutoRecordingInChannelSettingQueryHookResult = ReturnType<
  typeof useGetAutoRecordingInChannelSettingQuery
>;
export type GetAutoRecordingInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetAutoRecordingInChannelSettingLazyQuery
>;
export type GetAutoRecordingInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetAutoRecordingInChannelSettingSuspenseQuery
>;
export type GetAutoRecordingInChannelSettingQueryResult = Apollo.QueryResult<
  GetAutoRecordingInChannelSettingQuery,
  GetAutoRecordingInChannelSettingQueryVariables
>;
export const GetAutoTranscribeInChannelSettingDocument = gql`
  query GetAutoTranscribeInChannelSetting($channelId: Int!) {
    getAutoTranscribeInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        autoTranscribe
      }
    }
  }
`;

/**
 * __useGetAutoTranscribeInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetAutoTranscribeInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoTranscribeInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoTranscribeInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetAutoTranscribeInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutoTranscribeInChannelSettingQuery,
    GetAutoTranscribeInChannelSettingQueryVariables
  > &
    ({ variables: GetAutoTranscribeInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAutoTranscribeInChannelSettingQuery, GetAutoTranscribeInChannelSettingQueryVariables>(
    GetAutoTranscribeInChannelSettingDocument,
    options
  );
}
export function useGetAutoTranscribeInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutoTranscribeInChannelSettingQuery,
    GetAutoTranscribeInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAutoTranscribeInChannelSettingQuery, GetAutoTranscribeInChannelSettingQueryVariables>(
    GetAutoTranscribeInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetAutoTranscribeInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAutoTranscribeInChannelSettingQuery,
    GetAutoTranscribeInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAutoTranscribeInChannelSettingQuery,
  GetAutoTranscribeInChannelSettingQueryVariables
>;
export function useGetAutoTranscribeInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAutoTranscribeInChannelSettingQuery,
        GetAutoTranscribeInChannelSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAutoTranscribeInChannelSettingQuery | undefined,
  GetAutoTranscribeInChannelSettingQueryVariables
>;
export function useGetAutoTranscribeInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAutoTranscribeInChannelSettingQuery,
        GetAutoTranscribeInChannelSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAutoTranscribeInChannelSettingQuery,
    GetAutoTranscribeInChannelSettingQueryVariables
  >(GetAutoTranscribeInChannelSettingDocument, options);
}
export type GetAutoTranscribeInChannelSettingQueryHookResult = ReturnType<
  typeof useGetAutoTranscribeInChannelSettingQuery
>;
export type GetAutoTranscribeInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetAutoTranscribeInChannelSettingLazyQuery
>;
export type GetAutoTranscribeInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetAutoTranscribeInChannelSettingSuspenseQuery
>;
export type GetAutoTranscribeInChannelSettingQueryResult = Apollo.QueryResult<
  GetAutoTranscribeInChannelSettingQuery,
  GetAutoTranscribeInChannelSettingQueryVariables
>;
export const GetRecordingAnnouncementInChannelSettingDocument = gql`
  query GetRecordingAnnouncementInChannelSetting($channelId: Int!) {
    getRecordingAnnouncementInChannelSetting(channelId: $channelId) {
      message
      data {
        recordingAnnouncementMessage
        recordingAnnouncementAfterBeep
        id
        audioPrompt {
          audio {
            url
            id
          }
          id
          gender
          language
          text
          type
          workspaceId
        }
      }
    }
  }
`;

/**
 * __useGetRecordingAnnouncementInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetRecordingAnnouncementInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingAnnouncementInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingAnnouncementInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetRecordingAnnouncementInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRecordingAnnouncementInChannelSettingQuery,
    GetRecordingAnnouncementInChannelSettingQueryVariables
  > &
    ({ variables: GetRecordingAnnouncementInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRecordingAnnouncementInChannelSettingQuery,
    GetRecordingAnnouncementInChannelSettingQueryVariables
  >(GetRecordingAnnouncementInChannelSettingDocument, options);
}
export function useGetRecordingAnnouncementInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecordingAnnouncementInChannelSettingQuery,
    GetRecordingAnnouncementInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRecordingAnnouncementInChannelSettingQuery,
    GetRecordingAnnouncementInChannelSettingQueryVariables
  >(GetRecordingAnnouncementInChannelSettingDocument, options);
}
// @ts-ignore
export function useGetRecordingAnnouncementInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRecordingAnnouncementInChannelSettingQuery,
    GetRecordingAnnouncementInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetRecordingAnnouncementInChannelSettingQuery,
  GetRecordingAnnouncementInChannelSettingQueryVariables
>;
export function useGetRecordingAnnouncementInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRecordingAnnouncementInChannelSettingQuery,
        GetRecordingAnnouncementInChannelSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetRecordingAnnouncementInChannelSettingQuery | undefined,
  GetRecordingAnnouncementInChannelSettingQueryVariables
>;
export function useGetRecordingAnnouncementInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRecordingAnnouncementInChannelSettingQuery,
        GetRecordingAnnouncementInChannelSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRecordingAnnouncementInChannelSettingQuery,
    GetRecordingAnnouncementInChannelSettingQueryVariables
  >(GetRecordingAnnouncementInChannelSettingDocument, options);
}
export type GetRecordingAnnouncementInChannelSettingQueryHookResult = ReturnType<
  typeof useGetRecordingAnnouncementInChannelSettingQuery
>;
export type GetRecordingAnnouncementInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetRecordingAnnouncementInChannelSettingLazyQuery
>;
export type GetRecordingAnnouncementInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetRecordingAnnouncementInChannelSettingSuspenseQuery
>;
export type GetRecordingAnnouncementInChannelSettingQueryResult = Apollo.QueryResult<
  GetRecordingAnnouncementInChannelSettingQuery,
  GetRecordingAnnouncementInChannelSettingQueryVariables
>;
export const GetIvrInChannelSettingDocument = gql`
  query GetIvrInChannelSetting($channelId: Int!) {
    getIvrInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isActive
        startPrompt {
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        invalidPrompt {
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
        ifUnansweredPrompt {
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetIvrInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetIvrInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIvrInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIvrInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetIvrInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables> &
    ({ variables: GetIvrInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables>(
    GetIvrInChannelSettingDocument,
    options
  );
}
export function useGetIvrInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables>(
    GetIvrInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetIvrInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables>;
export function useGetIvrInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetIvrInChannelSettingQuery | undefined, GetIvrInChannelSettingQueryVariables>;
export function useGetIvrInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIvrInChannelSettingQuery, GetIvrInChannelSettingQueryVariables>(
    GetIvrInChannelSettingDocument,
    options
  );
}
export type GetIvrInChannelSettingQueryHookResult = ReturnType<typeof useGetIvrInChannelSettingQuery>;
export type GetIvrInChannelSettingLazyQueryHookResult = ReturnType<typeof useGetIvrInChannelSettingLazyQuery>;
export type GetIvrInChannelSettingSuspenseQueryHookResult = ReturnType<typeof useGetIvrInChannelSettingSuspenseQuery>;
export type GetIvrInChannelSettingQueryResult = Apollo.QueryResult<
  GetIvrInChannelSettingQuery,
  GetIvrInChannelSettingQueryVariables
>;
export const GetBusinessHoursInChannelSettingDocument = gql`
  query GetBusinessHoursInChannelSetting($channelId: Int!) {
    getBusinessHoursInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isAlwaysOpen
        entries {
          localDayOfWeek
          localStartTime
          localEndTime
          businessHourId
          isActive
        }
        timezone {
          value
          label
          id
        }
      }
    }
  }
`;

/**
 * __useGetBusinessHoursInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetBusinessHoursInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessHoursInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessHoursInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetBusinessHoursInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBusinessHoursInChannelSettingQuery,
    GetBusinessHoursInChannelSettingQueryVariables
  > &
    ({ variables: GetBusinessHoursInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBusinessHoursInChannelSettingQuery, GetBusinessHoursInChannelSettingQueryVariables>(
    GetBusinessHoursInChannelSettingDocument,
    options
  );
}
export function useGetBusinessHoursInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBusinessHoursInChannelSettingQuery,
    GetBusinessHoursInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBusinessHoursInChannelSettingQuery, GetBusinessHoursInChannelSettingQueryVariables>(
    GetBusinessHoursInChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetBusinessHoursInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBusinessHoursInChannelSettingQuery,
    GetBusinessHoursInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetBusinessHoursInChannelSettingQuery, GetBusinessHoursInChannelSettingQueryVariables>;
export function useGetBusinessHoursInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBusinessHoursInChannelSettingQuery,
        GetBusinessHoursInChannelSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetBusinessHoursInChannelSettingQuery | undefined,
  GetBusinessHoursInChannelSettingQueryVariables
>;
export function useGetBusinessHoursInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBusinessHoursInChannelSettingQuery,
        GetBusinessHoursInChannelSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBusinessHoursInChannelSettingQuery, GetBusinessHoursInChannelSettingQueryVariables>(
    GetBusinessHoursInChannelSettingDocument,
    options
  );
}
export type GetBusinessHoursInChannelSettingQueryHookResult = ReturnType<
  typeof useGetBusinessHoursInChannelSettingQuery
>;
export type GetBusinessHoursInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetBusinessHoursInChannelSettingLazyQuery
>;
export type GetBusinessHoursInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetBusinessHoursInChannelSettingSuspenseQuery
>;
export type GetBusinessHoursInChannelSettingQueryResult = Apollo.QueryResult<
  GetBusinessHoursInChannelSettingQuery,
  GetBusinessHoursInChannelSettingQueryVariables
>;
export const GetChannelSettingDocument = gql`
  query GetChannelSetting($channelId: Int!) {
    getChannelSetting(channelId: $channelId) {
      message
      data {
        id
        friendlyName
        callTransfer
        isBusinessAlwaysOpen
        afterHour
        ivr
        timeout
        voicemail
        welcomeMessage
        recording
        callerTune
        callForward
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
        callerId
      }
    }
  }
`;

/**
 * __useGetChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<GetChannelSettingQuery, GetChannelSettingQueryVariables> &
    ({ variables: GetChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelSettingQuery, GetChannelSettingQueryVariables>(GetChannelSettingDocument, options);
}
export function useGetChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChannelSettingQuery, GetChannelSettingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelSettingQuery, GetChannelSettingQueryVariables>(
    GetChannelSettingDocument,
    options
  );
}
// @ts-ignore
export function useGetChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelSettingQuery, GetChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetChannelSettingQuery, GetChannelSettingQueryVariables>;
export function useGetChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelSettingQuery, GetChannelSettingQueryVariables>
): Apollo.UseSuspenseQueryResult<GetChannelSettingQuery | undefined, GetChannelSettingQueryVariables>;
export function useGetChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelSettingQuery, GetChannelSettingQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChannelSettingQuery, GetChannelSettingQueryVariables>(
    GetChannelSettingDocument,
    options
  );
}
export type GetChannelSettingQueryHookResult = ReturnType<typeof useGetChannelSettingQuery>;
export type GetChannelSettingLazyQueryHookResult = ReturnType<typeof useGetChannelSettingLazyQuery>;
export type GetChannelSettingSuspenseQueryHookResult = ReturnType<typeof useGetChannelSettingSuspenseQuery>;
export type GetChannelSettingQueryResult = Apollo.QueryResult<GetChannelSettingQuery, GetChannelSettingQueryVariables>;
export const GetBusinessAfterHoursInChannelSettingDocument = gql`
  query GetBusinessAfterHoursInChannelSetting($channelId: Int!) {
    getBusinessAfterHoursInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        route
        supportAfterHours
        voicemailAudioPrompt {
          id
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        targetPhoneNumber
        updatedAt
      }
    }
  }
`;

/**
 * __useGetBusinessAfterHoursInChannelSettingQuery__
 *
 * To run a query within a React component, call `useGetBusinessAfterHoursInChannelSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAfterHoursInChannelSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAfterHoursInChannelSettingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetBusinessAfterHoursInChannelSettingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBusinessAfterHoursInChannelSettingQuery,
    GetBusinessAfterHoursInChannelSettingQueryVariables
  > &
    ({ variables: GetBusinessAfterHoursInChannelSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBusinessAfterHoursInChannelSettingQuery,
    GetBusinessAfterHoursInChannelSettingQueryVariables
  >(GetBusinessAfterHoursInChannelSettingDocument, options);
}
export function useGetBusinessAfterHoursInChannelSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBusinessAfterHoursInChannelSettingQuery,
    GetBusinessAfterHoursInChannelSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBusinessAfterHoursInChannelSettingQuery,
    GetBusinessAfterHoursInChannelSettingQueryVariables
  >(GetBusinessAfterHoursInChannelSettingDocument, options);
}
// @ts-ignore
export function useGetBusinessAfterHoursInChannelSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBusinessAfterHoursInChannelSettingQuery,
    GetBusinessAfterHoursInChannelSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetBusinessAfterHoursInChannelSettingQuery,
  GetBusinessAfterHoursInChannelSettingQueryVariables
>;
export function useGetBusinessAfterHoursInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBusinessAfterHoursInChannelSettingQuery,
        GetBusinessAfterHoursInChannelSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetBusinessAfterHoursInChannelSettingQuery | undefined,
  GetBusinessAfterHoursInChannelSettingQueryVariables
>;
export function useGetBusinessAfterHoursInChannelSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBusinessAfterHoursInChannelSettingQuery,
        GetBusinessAfterHoursInChannelSettingQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetBusinessAfterHoursInChannelSettingQuery,
    GetBusinessAfterHoursInChannelSettingQueryVariables
  >(GetBusinessAfterHoursInChannelSettingDocument, options);
}
export type GetBusinessAfterHoursInChannelSettingQueryHookResult = ReturnType<
  typeof useGetBusinessAfterHoursInChannelSettingQuery
>;
export type GetBusinessAfterHoursInChannelSettingLazyQueryHookResult = ReturnType<
  typeof useGetBusinessAfterHoursInChannelSettingLazyQuery
>;
export type GetBusinessAfterHoursInChannelSettingSuspenseQueryHookResult = ReturnType<
  typeof useGetBusinessAfterHoursInChannelSettingSuspenseQuery
>;
export type GetBusinessAfterHoursInChannelSettingQueryResult = Apollo.QueryResult<
  GetBusinessAfterHoursInChannelSettingQuery,
  GetBusinessAfterHoursInChannelSettingQueryVariables
>;
export const GetChannelOverviewDocument = gql`
  query GetChannelOverview($channelId: Int!) {
    getChannelOverview(channelId: $channelId) {
      message
      data {
        id
        friendlyName
        phoneNumber
        country {
          id
          flag
          alphaTwoCode
        }
        callSetting {
          id
          businessHourType
          friendlyName
          incomingTimeout
          recording
          metrics {
            key
            value
          }
          callerId {
            id
            friendlyName
            phoneNumber
          }
        }
        subscription {
          nextBillingAt
        }
        channelGroup {
          id
          name
          callSetting {
            id
            businessHourType
            metrics {
              key
              value
            }
            friendlyName
            recording
            incomingTimeout
            callerId {
              id
              friendlyName
              phoneNumber
            }
          }
        }
        removalSchedule {
          scheduleAt
        }
        assignedUsers {
          id
          name
          profilePicture {
            id
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetChannelOverviewQuery__
 *
 * To run a query within a React component, call `useGetChannelOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelOverviewQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<GetChannelOverviewQuery, GetChannelOverviewQueryVariables> &
    ({ variables: GetChannelOverviewQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelOverviewQuery, GetChannelOverviewQueryVariables>(
    GetChannelOverviewDocument,
    options
  );
}
export function useGetChannelOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChannelOverviewQuery, GetChannelOverviewQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelOverviewQuery, GetChannelOverviewQueryVariables>(
    GetChannelOverviewDocument,
    options
  );
}
// @ts-ignore
export function useGetChannelOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelOverviewQuery, GetChannelOverviewQueryVariables>
): Apollo.UseSuspenseQueryResult<GetChannelOverviewQuery, GetChannelOverviewQueryVariables>;
export function useGetChannelOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelOverviewQuery, GetChannelOverviewQueryVariables>
): Apollo.UseSuspenseQueryResult<GetChannelOverviewQuery | undefined, GetChannelOverviewQueryVariables>;
export function useGetChannelOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelOverviewQuery, GetChannelOverviewQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChannelOverviewQuery, GetChannelOverviewQueryVariables>(
    GetChannelOverviewDocument,
    options
  );
}
export type GetChannelOverviewQueryHookResult = ReturnType<typeof useGetChannelOverviewQuery>;
export type GetChannelOverviewLazyQueryHookResult = ReturnType<typeof useGetChannelOverviewLazyQuery>;
export type GetChannelOverviewSuspenseQueryHookResult = ReturnType<typeof useGetChannelOverviewSuspenseQuery>;
export type GetChannelOverviewQueryResult = Apollo.QueryResult<
  GetChannelOverviewQuery,
  GetChannelOverviewQueryVariables
>;
export const FetchActiveChannelStrategiesDocument = gql`
  query FetchActiveChannelStrategies($channelId: Int!) {
    fetchActiveChannelStrategies(channelId: $channelId) {
      data
    }
  }
`;

/**
 * __useFetchActiveChannelStrategiesQuery__
 *
 * To run a query within a React component, call `useFetchActiveChannelStrategiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActiveChannelStrategiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActiveChannelStrategiesQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useFetchActiveChannelStrategiesQuery(
  baseOptions: Apollo.QueryHookOptions<FetchActiveChannelStrategiesQuery, FetchActiveChannelStrategiesQueryVariables> &
    ({ variables: FetchActiveChannelStrategiesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchActiveChannelStrategiesQuery, FetchActiveChannelStrategiesQueryVariables>(
    FetchActiveChannelStrategiesDocument,
    options
  );
}
export function useFetchActiveChannelStrategiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchActiveChannelStrategiesQuery,
    FetchActiveChannelStrategiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchActiveChannelStrategiesQuery, FetchActiveChannelStrategiesQueryVariables>(
    FetchActiveChannelStrategiesDocument,
    options
  );
}
// @ts-ignore
export function useFetchActiveChannelStrategiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchActiveChannelStrategiesQuery,
    FetchActiveChannelStrategiesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<FetchActiveChannelStrategiesQuery, FetchActiveChannelStrategiesQueryVariables>;
export function useFetchActiveChannelStrategiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchActiveChannelStrategiesQuery, FetchActiveChannelStrategiesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  FetchActiveChannelStrategiesQuery | undefined,
  FetchActiveChannelStrategiesQueryVariables
>;
export function useFetchActiveChannelStrategiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchActiveChannelStrategiesQuery, FetchActiveChannelStrategiesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FetchActiveChannelStrategiesQuery, FetchActiveChannelStrategiesQueryVariables>(
    FetchActiveChannelStrategiesDocument,
    options
  );
}
export type FetchActiveChannelStrategiesQueryHookResult = ReturnType<typeof useFetchActiveChannelStrategiesQuery>;
export type FetchActiveChannelStrategiesLazyQueryHookResult = ReturnType<
  typeof useFetchActiveChannelStrategiesLazyQuery
>;
export type FetchActiveChannelStrategiesSuspenseQueryHookResult = ReturnType<
  typeof useFetchActiveChannelStrategiesSuspenseQuery
>;
export type FetchActiveChannelStrategiesQueryResult = Apollo.QueryResult<
  FetchActiveChannelStrategiesQuery,
  FetchActiveChannelStrategiesQueryVariables
>;
export const DashboardKpisDocument = gql`
  query DashboardKpis($input: InputFromDateToDateUserId) {
    dashboardKpis(input: $input) {
      data {
        answerRate {
          name
          slug
          value {
            answerRate
            changePercent
            currentAnsweredCall
            currentTotalInbound
            previousAnsweredCall
            previousTotalInbound
          }
        }
        averageAnswerTime {
          name
          slug
          value {
            changePercent
            currentAverageAns
            previousAverageAns
          }
        }
        totalCall {
          name
          slug
          value {
            currentInboundCall
            currentOutboundCall
            previousInboundCall
            previousOutboundCall
            inboundCallChangePercent
            outboundCallChangePercent
          }
        }
        closedConversation {
          name
          slug
          value {
            changePercent
            currentClosedConversation
            previousClosedConversation
          }
        }
        liveCall {
          name
          slug
          value {
            liveCallCount
            peakCount
          }
        }
        totalMessage {
          name
          slug
          value {
            currentInboundMess
            currentOutboundMess
            previousInboundMess
            previousOutboundMess
            inboundMessChangePercent
            outboundMessChangePercent
          }
        }
        missedCall {
          name
          slug
          value {
            changePercent
            percentOfInbound
            currentMissedCallValue
            previousMissedCallValue
          }
        }
        openedConversation {
          name
          slug
          value {
            changePercent
            currentOpenConversation
            previousOpenConversation
          }
        }
      }
      message
    }
  }
`;

/**
 * __useDashboardKpisQuery__
 *
 * To run a query within a React component, call `useDashboardKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardKpisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardKpisQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardKpisQuery, DashboardKpisQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardKpisQuery, DashboardKpisQueryVariables>(DashboardKpisDocument, options);
}
export function useDashboardKpisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardKpisQuery, DashboardKpisQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardKpisQuery, DashboardKpisQueryVariables>(DashboardKpisDocument, options);
}
// @ts-ignore
export function useDashboardKpisSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardKpisQuery, DashboardKpisQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardKpisQuery, DashboardKpisQueryVariables>;
export function useDashboardKpisSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardKpisQuery, DashboardKpisQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardKpisQuery | undefined, DashboardKpisQueryVariables>;
export function useDashboardKpisSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardKpisQuery, DashboardKpisQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardKpisQuery, DashboardKpisQueryVariables>(DashboardKpisDocument, options);
}
export type DashboardKpisQueryHookResult = ReturnType<typeof useDashboardKpisQuery>;
export type DashboardKpisLazyQueryHookResult = ReturnType<typeof useDashboardKpisLazyQuery>;
export type DashboardKpisSuspenseQueryHookResult = ReturnType<typeof useDashboardKpisSuspenseQuery>;
export type DashboardKpisQueryResult = Apollo.QueryResult<DashboardKpisQuery, DashboardKpisQueryVariables>;
export const DashboardCallVolumeDocument = gql`
  query DashboardCallVolume($input: InputFromDateToDateUserId) {
    dashboardCallVolume(input: $input) {
      data {
        timeBucket
        outboundCount
        inboundCount
      }
      message
    }
  }
`;

/**
 * __useDashboardCallVolumeQuery__
 *
 * To run a query within a React component, call `useDashboardCallVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCallVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCallVolumeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardCallVolumeQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>(
    DashboardCallVolumeDocument,
    options
  );
}
export function useDashboardCallVolumeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>(
    DashboardCallVolumeDocument,
    options
  );
}
// @ts-ignore
export function useDashboardCallVolumeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>;
export function useDashboardCallVolumeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardCallVolumeQuery | undefined, DashboardCallVolumeQueryVariables>;
export function useDashboardCallVolumeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardCallVolumeQuery, DashboardCallVolumeQueryVariables>(
    DashboardCallVolumeDocument,
    options
  );
}
export type DashboardCallVolumeQueryHookResult = ReturnType<typeof useDashboardCallVolumeQuery>;
export type DashboardCallVolumeLazyQueryHookResult = ReturnType<typeof useDashboardCallVolumeLazyQuery>;
export type DashboardCallVolumeSuspenseQueryHookResult = ReturnType<typeof useDashboardCallVolumeSuspenseQuery>;
export type DashboardCallVolumeQueryResult = Apollo.QueryResult<
  DashboardCallVolumeQuery,
  DashboardCallVolumeQueryVariables
>;
export const DashboardUniqueVsRepeatedCallerDocument = gql`
  query DashboardUniqueVsRepeatedCaller($input: InputFromDateToDateUserId) {
    dashboardUniqueVsRepeatedCaller(input: $input) {
      data {
        timeBucket
        uniqueCount
        repeatedCount
      }
      message
    }
  }
`;

/**
 * __useDashboardUniqueVsRepeatedCallerQuery__
 *
 * To run a query within a React component, call `useDashboardUniqueVsRepeatedCallerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUniqueVsRepeatedCallerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUniqueVsRepeatedCallerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardUniqueVsRepeatedCallerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardUniqueVsRepeatedCallerQuery,
    DashboardUniqueVsRepeatedCallerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardUniqueVsRepeatedCallerQuery, DashboardUniqueVsRepeatedCallerQueryVariables>(
    DashboardUniqueVsRepeatedCallerDocument,
    options
  );
}
export function useDashboardUniqueVsRepeatedCallerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardUniqueVsRepeatedCallerQuery,
    DashboardUniqueVsRepeatedCallerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardUniqueVsRepeatedCallerQuery, DashboardUniqueVsRepeatedCallerQueryVariables>(
    DashboardUniqueVsRepeatedCallerDocument,
    options
  );
}
// @ts-ignore
export function useDashboardUniqueVsRepeatedCallerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DashboardUniqueVsRepeatedCallerQuery,
    DashboardUniqueVsRepeatedCallerQueryVariables
  >
): Apollo.UseSuspenseQueryResult<DashboardUniqueVsRepeatedCallerQuery, DashboardUniqueVsRepeatedCallerQueryVariables>;
export function useDashboardUniqueVsRepeatedCallerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DashboardUniqueVsRepeatedCallerQuery,
        DashboardUniqueVsRepeatedCallerQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  DashboardUniqueVsRepeatedCallerQuery | undefined,
  DashboardUniqueVsRepeatedCallerQueryVariables
>;
export function useDashboardUniqueVsRepeatedCallerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DashboardUniqueVsRepeatedCallerQuery,
        DashboardUniqueVsRepeatedCallerQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardUniqueVsRepeatedCallerQuery, DashboardUniqueVsRepeatedCallerQueryVariables>(
    DashboardUniqueVsRepeatedCallerDocument,
    options
  );
}
export type DashboardUniqueVsRepeatedCallerQueryHookResult = ReturnType<typeof useDashboardUniqueVsRepeatedCallerQuery>;
export type DashboardUniqueVsRepeatedCallerLazyQueryHookResult = ReturnType<
  typeof useDashboardUniqueVsRepeatedCallerLazyQuery
>;
export type DashboardUniqueVsRepeatedCallerSuspenseQueryHookResult = ReturnType<
  typeof useDashboardUniqueVsRepeatedCallerSuspenseQuery
>;
export type DashboardUniqueVsRepeatedCallerQueryResult = Apollo.QueryResult<
  DashboardUniqueVsRepeatedCallerQuery,
  DashboardUniqueVsRepeatedCallerQueryVariables
>;
export const DashboardMemberLeaderBoardDocument = gql`
  query DashboardMemberLeaderBoard($input: InputFromDateToDate) {
    dashboardMemberLeaderBoard(input: $input) {
      data {
        userId
        userName
        userMediaUrl
        callFlowName
        callFlowId
        totalCalls
        totalMessages
        total
      }
      message
    }
  }
`;

/**
 * __useDashboardMemberLeaderBoardQuery__
 *
 * To run a query within a React component, call `useDashboardMemberLeaderBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardMemberLeaderBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardMemberLeaderBoardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardMemberLeaderBoardQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardMemberLeaderBoardQuery, DashboardMemberLeaderBoardQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardMemberLeaderBoardQuery, DashboardMemberLeaderBoardQueryVariables>(
    DashboardMemberLeaderBoardDocument,
    options
  );
}
export function useDashboardMemberLeaderBoardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardMemberLeaderBoardQuery, DashboardMemberLeaderBoardQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardMemberLeaderBoardQuery, DashboardMemberLeaderBoardQueryVariables>(
    DashboardMemberLeaderBoardDocument,
    options
  );
}
// @ts-ignore
export function useDashboardMemberLeaderBoardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DashboardMemberLeaderBoardQuery,
    DashboardMemberLeaderBoardQueryVariables
  >
): Apollo.UseSuspenseQueryResult<DashboardMemberLeaderBoardQuery, DashboardMemberLeaderBoardQueryVariables>;
export function useDashboardMemberLeaderBoardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardMemberLeaderBoardQuery, DashboardMemberLeaderBoardQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardMemberLeaderBoardQuery | undefined, DashboardMemberLeaderBoardQueryVariables>;
export function useDashboardMemberLeaderBoardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardMemberLeaderBoardQuery, DashboardMemberLeaderBoardQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardMemberLeaderBoardQuery, DashboardMemberLeaderBoardQueryVariables>(
    DashboardMemberLeaderBoardDocument,
    options
  );
}
export type DashboardMemberLeaderBoardQueryHookResult = ReturnType<typeof useDashboardMemberLeaderBoardQuery>;
export type DashboardMemberLeaderBoardLazyQueryHookResult = ReturnType<typeof useDashboardMemberLeaderBoardLazyQuery>;
export type DashboardMemberLeaderBoardSuspenseQueryHookResult = ReturnType<
  typeof useDashboardMemberLeaderBoardSuspenseQuery
>;
export type DashboardMemberLeaderBoardQueryResult = Apollo.QueryResult<
  DashboardMemberLeaderBoardQuery,
  DashboardMemberLeaderBoardQueryVariables
>;
export const DashboardCallDistributionsDocument = gql`
  query DashboardCallDistributions($input: InputFromDateToDateUserId) {
    dashboardCallDistributions(input: $input) {
      data {
        channelId
        channelFriendlyName
        channelMediaUrl
        channelPhoneNumber
        totalCalls
        callPercentage
      }
      message
    }
  }
`;

/**
 * __useDashboardCallDistributionsQuery__
 *
 * To run a query within a React component, call `useDashboardCallDistributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCallDistributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCallDistributionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardCallDistributionsQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardCallDistributionsQuery, DashboardCallDistributionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardCallDistributionsQuery, DashboardCallDistributionsQueryVariables>(
    DashboardCallDistributionsDocument,
    options
  );
}
export function useDashboardCallDistributionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardCallDistributionsQuery, DashboardCallDistributionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardCallDistributionsQuery, DashboardCallDistributionsQueryVariables>(
    DashboardCallDistributionsDocument,
    options
  );
}
// @ts-ignore
export function useDashboardCallDistributionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DashboardCallDistributionsQuery,
    DashboardCallDistributionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<DashboardCallDistributionsQuery, DashboardCallDistributionsQueryVariables>;
export function useDashboardCallDistributionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardCallDistributionsQuery, DashboardCallDistributionsQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardCallDistributionsQuery | undefined, DashboardCallDistributionsQueryVariables>;
export function useDashboardCallDistributionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardCallDistributionsQuery, DashboardCallDistributionsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardCallDistributionsQuery, DashboardCallDistributionsQueryVariables>(
    DashboardCallDistributionsDocument,
    options
  );
}
export type DashboardCallDistributionsQueryHookResult = ReturnType<typeof useDashboardCallDistributionsQuery>;
export type DashboardCallDistributionsLazyQueryHookResult = ReturnType<typeof useDashboardCallDistributionsLazyQuery>;
export type DashboardCallDistributionsSuspenseQueryHookResult = ReturnType<
  typeof useDashboardCallDistributionsSuspenseQuery
>;
export type DashboardCallDistributionsQueryResult = Apollo.QueryResult<
  DashboardCallDistributionsQuery,
  DashboardCallDistributionsQueryVariables
>;
export const DashboardKeyKpisDocument = gql`
  query DashboardKeyKpis($input: InputFromDateToDateUserId) {
    dashboardKeyKpis(input: $input) {
      data {
        totalCalls
        missedCalls
        answerRate
        averageAnswerTime
        message
        recordingCoverage
        transcriptionCoverage
      }
      message
    }
  }
`;

/**
 * __useDashboardKeyKpisQuery__
 *
 * To run a query within a React component, call `useDashboardKeyKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardKeyKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardKeyKpisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardKeyKpisQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>(DashboardKeyKpisDocument, options);
}
export function useDashboardKeyKpisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>(DashboardKeyKpisDocument, options);
}
// @ts-ignore
export function useDashboardKeyKpisSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>;
export function useDashboardKeyKpisSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardKeyKpisQuery | undefined, DashboardKeyKpisQueryVariables>;
export function useDashboardKeyKpisSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>(
    DashboardKeyKpisDocument,
    options
  );
}
export type DashboardKeyKpisQueryHookResult = ReturnType<typeof useDashboardKeyKpisQuery>;
export type DashboardKeyKpisLazyQueryHookResult = ReturnType<typeof useDashboardKeyKpisLazyQuery>;
export type DashboardKeyKpisSuspenseQueryHookResult = ReturnType<typeof useDashboardKeyKpisSuspenseQuery>;
export type DashboardKeyKpisQueryResult = Apollo.QueryResult<DashboardKeyKpisQuery, DashboardKeyKpisQueryVariables>;
export const DashboardWalletExpenditureDocument = gql`
  query DashboardWalletExpenditure($input: InputFromDateToDateUserId) {
    dashboardWalletExpenditure(input: $input) {
      data {
        spentSection
        amountSpent
      }
      message
    }
  }
`;

/**
 * __useDashboardWalletExpenditureQuery__
 *
 * To run a query within a React component, call `useDashboardWalletExpenditureQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardWalletExpenditureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardWalletExpenditureQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardWalletExpenditureQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardWalletExpenditureQuery, DashboardWalletExpenditureQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardWalletExpenditureQuery, DashboardWalletExpenditureQueryVariables>(
    DashboardWalletExpenditureDocument,
    options
  );
}
export function useDashboardWalletExpenditureLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardWalletExpenditureQuery, DashboardWalletExpenditureQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardWalletExpenditureQuery, DashboardWalletExpenditureQueryVariables>(
    DashboardWalletExpenditureDocument,
    options
  );
}
// @ts-ignore
export function useDashboardWalletExpenditureSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DashboardWalletExpenditureQuery,
    DashboardWalletExpenditureQueryVariables
  >
): Apollo.UseSuspenseQueryResult<DashboardWalletExpenditureQuery, DashboardWalletExpenditureQueryVariables>;
export function useDashboardWalletExpenditureSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardWalletExpenditureQuery, DashboardWalletExpenditureQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardWalletExpenditureQuery | undefined, DashboardWalletExpenditureQueryVariables>;
export function useDashboardWalletExpenditureSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardWalletExpenditureQuery, DashboardWalletExpenditureQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardWalletExpenditureQuery, DashboardWalletExpenditureQueryVariables>(
    DashboardWalletExpenditureDocument,
    options
  );
}
export type DashboardWalletExpenditureQueryHookResult = ReturnType<typeof useDashboardWalletExpenditureQuery>;
export type DashboardWalletExpenditureLazyQueryHookResult = ReturnType<typeof useDashboardWalletExpenditureLazyQuery>;
export type DashboardWalletExpenditureSuspenseQueryHookResult = ReturnType<
  typeof useDashboardWalletExpenditureSuspenseQuery
>;
export type DashboardWalletExpenditureQueryResult = Apollo.QueryResult<
  DashboardWalletExpenditureQuery,
  DashboardWalletExpenditureQueryVariables
>;
export const DashboardCriticalEventsDocument = gql`
  query DashboardCriticalEvents {
    dashboardCriticalEvents {
      data {
        message
        event
      }
      message
    }
  }
`;

/**
 * __useDashboardCriticalEventsQuery__
 *
 * To run a query within a React component, call `useDashboardCriticalEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCriticalEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCriticalEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardCriticalEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>(
    DashboardCriticalEventsDocument,
    options
  );
}
export function useDashboardCriticalEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>(
    DashboardCriticalEventsDocument,
    options
  );
}
// @ts-ignore
export function useDashboardCriticalEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>;
export function useDashboardCriticalEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardCriticalEventsQuery | undefined, DashboardCriticalEventsQueryVariables>;
export function useDashboardCriticalEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardCriticalEventsQuery, DashboardCriticalEventsQueryVariables>(
    DashboardCriticalEventsDocument,
    options
  );
}
export type DashboardCriticalEventsQueryHookResult = ReturnType<typeof useDashboardCriticalEventsQuery>;
export type DashboardCriticalEventsLazyQueryHookResult = ReturnType<typeof useDashboardCriticalEventsLazyQuery>;
export type DashboardCriticalEventsSuspenseQueryHookResult = ReturnType<typeof useDashboardCriticalEventsSuspenseQuery>;
export type DashboardCriticalEventsQueryResult = Apollo.QueryResult<
  DashboardCriticalEventsQuery,
  DashboardCriticalEventsQueryVariables
>;
export const UnlimitedConfigsDocument = gql`
  query UnlimitedConfigs {
    unlimitedConfigs {
      message
      data {
        id
        direction
        threshold
        consumedThreshold
        unit
      }
    }
  }
`;

/**
 * __useUnlimitedConfigsQuery__
 *
 * To run a query within a React component, call `useUnlimitedConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnlimitedConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnlimitedConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnlimitedConfigsQuery(
  baseOptions?: Apollo.QueryHookOptions<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>(UnlimitedConfigsDocument, options);
}
export function useUnlimitedConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>(UnlimitedConfigsDocument, options);
}
// @ts-ignore
export function useUnlimitedConfigsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>
): Apollo.UseSuspenseQueryResult<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>;
export function useUnlimitedConfigsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>
): Apollo.UseSuspenseQueryResult<UnlimitedConfigsQuery | undefined, UnlimitedConfigsQueryVariables>;
export function useUnlimitedConfigsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>(
    UnlimitedConfigsDocument,
    options
  );
}
export type UnlimitedConfigsQueryHookResult = ReturnType<typeof useUnlimitedConfigsQuery>;
export type UnlimitedConfigsLazyQueryHookResult = ReturnType<typeof useUnlimitedConfigsLazyQuery>;
export type UnlimitedConfigsSuspenseQueryHookResult = ReturnType<typeof useUnlimitedConfigsSuspenseQuery>;
export type UnlimitedConfigsQueryResult = Apollo.QueryResult<UnlimitedConfigsQuery, UnlimitedConfigsQueryVariables>;
export const DashboardUnlimitedUsagesDocument = gql`
  query DashboardUnlimitedUsages($input: InputUserId) {
    dashboardUnlimitedUsages(input: $input) {
      data {
        endingAt
        freeCreditWorth
        incoming {
          call
          message
          messageCount
          callCount
          messageThreshold
          callThreshold
        }
        outgoing {
          call
          message
          callCount
          messageCount
          callThreshold
          messageThreshold
        }
        hasUnlimitedConfig
      }
      message
    }
  }
`;

/**
 * __useDashboardUnlimitedUsagesQuery__
 *
 * To run a query within a React component, call `useDashboardUnlimitedUsagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUnlimitedUsagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUnlimitedUsagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardUnlimitedUsagesQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>(
    DashboardUnlimitedUsagesDocument,
    options
  );
}
export function useDashboardUnlimitedUsagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>(
    DashboardUnlimitedUsagesDocument,
    options
  );
}
// @ts-ignore
export function useDashboardUnlimitedUsagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>;
export function useDashboardUnlimitedUsagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>
): Apollo.UseSuspenseQueryResult<DashboardUnlimitedUsagesQuery | undefined, DashboardUnlimitedUsagesQueryVariables>;
export function useDashboardUnlimitedUsagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardUnlimitedUsagesQuery, DashboardUnlimitedUsagesQueryVariables>(
    DashboardUnlimitedUsagesDocument,
    options
  );
}
export type DashboardUnlimitedUsagesQueryHookResult = ReturnType<typeof useDashboardUnlimitedUsagesQuery>;
export type DashboardUnlimitedUsagesLazyQueryHookResult = ReturnType<typeof useDashboardUnlimitedUsagesLazyQuery>;
export type DashboardUnlimitedUsagesSuspenseQueryHookResult = ReturnType<
  typeof useDashboardUnlimitedUsagesSuspenseQuery
>;
export type DashboardUnlimitedUsagesQueryResult = Apollo.QueryResult<
  DashboardUnlimitedUsagesQuery,
  DashboardUnlimitedUsagesQueryVariables
>;
export const DashboardAfterHourActivitiesDocument = gql`
  query DashboardAfterHourActivities($input: InputFromDateToDateUserId) {
    dashboardAfterHourActivities(input: $input) {
      data {
        date
        call
        message
      }
      message
    }
  }
`;

/**
 * __useDashboardAfterHourActivitiesQuery__
 *
 * To run a query within a React component, call `useDashboardAfterHourActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardAfterHourActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardAfterHourActivitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardAfterHourActivitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardAfterHourActivitiesQuery, DashboardAfterHourActivitiesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardAfterHourActivitiesQuery, DashboardAfterHourActivitiesQueryVariables>(
    DashboardAfterHourActivitiesDocument,
    options
  );
}
export function useDashboardAfterHourActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardAfterHourActivitiesQuery,
    DashboardAfterHourActivitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardAfterHourActivitiesQuery, DashboardAfterHourActivitiesQueryVariables>(
    DashboardAfterHourActivitiesDocument,
    options
  );
}
// @ts-ignore
export function useDashboardAfterHourActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DashboardAfterHourActivitiesQuery,
    DashboardAfterHourActivitiesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<DashboardAfterHourActivitiesQuery, DashboardAfterHourActivitiesQueryVariables>;
export function useDashboardAfterHourActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardAfterHourActivitiesQuery, DashboardAfterHourActivitiesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  DashboardAfterHourActivitiesQuery | undefined,
  DashboardAfterHourActivitiesQueryVariables
>;
export function useDashboardAfterHourActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardAfterHourActivitiesQuery, DashboardAfterHourActivitiesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DashboardAfterHourActivitiesQuery, DashboardAfterHourActivitiesQueryVariables>(
    DashboardAfterHourActivitiesDocument,
    options
  );
}
export type DashboardAfterHourActivitiesQueryHookResult = ReturnType<typeof useDashboardAfterHourActivitiesQuery>;
export type DashboardAfterHourActivitiesLazyQueryHookResult = ReturnType<
  typeof useDashboardAfterHourActivitiesLazyQuery
>;
export type DashboardAfterHourActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useDashboardAfterHourActivitiesSuspenseQuery
>;
export type DashboardAfterHourActivitiesQueryResult = Apollo.QueryResult<
  DashboardAfterHourActivitiesQuery,
  DashboardAfterHourActivitiesQueryVariables
>;
export const GetCallSettingForChannelDocument = gql`
  query GetCallSettingForChannel($channelId: Int!) {
    getCallSettingForChannel(channelId: $channelId) {
      data {
        callSetting {
          callTransfer
          recording
        }
        id
      }
    }
  }
`;

/**
 * __useGetCallSettingForChannelQuery__
 *
 * To run a query within a React component, call `useGetCallSettingForChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallSettingForChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallSettingForChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetCallSettingForChannelQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables> &
    ({ variables: GetCallSettingForChannelQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables>(
    GetCallSettingForChannelDocument,
    options
  );
}
export function useGetCallSettingForChannelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables>(
    GetCallSettingForChannelDocument,
    options
  );
}
// @ts-ignore
export function useGetCallSettingForChannelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables>;
export function useGetCallSettingForChannelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingForChannelQuery | undefined, GetCallSettingForChannelQueryVariables>;
export function useGetCallSettingForChannelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallSettingForChannelQuery, GetCallSettingForChannelQueryVariables>(
    GetCallSettingForChannelDocument,
    options
  );
}
export type GetCallSettingForChannelQueryHookResult = ReturnType<typeof useGetCallSettingForChannelQuery>;
export type GetCallSettingForChannelLazyQueryHookResult = ReturnType<typeof useGetCallSettingForChannelLazyQuery>;
export type GetCallSettingForChannelSuspenseQueryHookResult = ReturnType<
  typeof useGetCallSettingForChannelSuspenseQuery
>;
export type GetCallSettingForChannelQueryResult = Apollo.QueryResult<
  GetCallSettingForChannelQuery,
  GetCallSettingForChannelQueryVariables
>;
export const ChannelGroupsCountDocument = gql`
  query ChannelGroupsCount($query: String) {
    channelGroupsCount(query: $query) {
      message
      data {
        count
      }
    }
  }
`;

/**
 * __useChannelGroupsCountQuery__
 *
 * To run a query within a React component, call `useChannelGroupsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelGroupsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelGroupsCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useChannelGroupsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>(
    ChannelGroupsCountDocument,
    options
  );
}
export function useChannelGroupsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>(
    ChannelGroupsCountDocument,
    options
  );
}
// @ts-ignore
export function useChannelGroupsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>;
export function useChannelGroupsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>
): Apollo.UseSuspenseQueryResult<ChannelGroupsCountQuery | undefined, ChannelGroupsCountQueryVariables>;
export function useChannelGroupsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelGroupsCountQuery, ChannelGroupsCountQueryVariables>(
    ChannelGroupsCountDocument,
    options
  );
}
export type ChannelGroupsCountQueryHookResult = ReturnType<typeof useChannelGroupsCountQuery>;
export type ChannelGroupsCountLazyQueryHookResult = ReturnType<typeof useChannelGroupsCountLazyQuery>;
export type ChannelGroupsCountSuspenseQueryHookResult = ReturnType<typeof useChannelGroupsCountSuspenseQuery>;
export type ChannelGroupsCountQueryResult = Apollo.QueryResult<
  ChannelGroupsCountQuery,
  ChannelGroupsCountQueryVariables
>;
export const GetCallSettingsCountDocument = gql`
  query GetCallSettingsCount($query: String) {
    getCallSettingsCount(query: $query) {
      message
      data {
        count
      }
    }
  }
`;

/**
 * __useGetCallSettingsCountQuery__
 *
 * To run a query within a React component, call `useGetCallSettingsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallSettingsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallSettingsCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetCallSettingsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>(
    GetCallSettingsCountDocument,
    options
  );
}
export function useGetCallSettingsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>(
    GetCallSettingsCountDocument,
    options
  );
}
// @ts-ignore
export function useGetCallSettingsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>;
export function useGetCallSettingsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingsCountQuery | undefined, GetCallSettingsCountQueryVariables>;
export function useGetCallSettingsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallSettingsCountQuery, GetCallSettingsCountQueryVariables>(
    GetCallSettingsCountDocument,
    options
  );
}
export type GetCallSettingsCountQueryHookResult = ReturnType<typeof useGetCallSettingsCountQuery>;
export type GetCallSettingsCountLazyQueryHookResult = ReturnType<typeof useGetCallSettingsCountLazyQuery>;
export type GetCallSettingsCountSuspenseQueryHookResult = ReturnType<typeof useGetCallSettingsCountSuspenseQuery>;
export type GetCallSettingsCountQueryResult = Apollo.QueryResult<
  GetCallSettingsCountQuery,
  GetCallSettingsCountQueryVariables
>;
export const GetConfigurationDocument = gql`
  query GetConfiguration($key: String!) {
    getConfiguration(key: $key) {
      message
      data
    }
  }
`;

/**
 * __useGetConfigurationQuery__
 *
 * To run a query within a React component, call `useGetConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables> &
    ({ variables: GetConfigurationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
}
export function useGetConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
}
// @ts-ignore
export function useGetConfigurationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>
): Apollo.UseSuspenseQueryResult<GetConfigurationQuery, GetConfigurationQueryVariables>;
export function useGetConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>
): Apollo.UseSuspenseQueryResult<GetConfigurationQuery | undefined, GetConfigurationQueryVariables>;
export function useGetConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(
    GetConfigurationDocument,
    options
  );
}
export type GetConfigurationQueryHookResult = ReturnType<typeof useGetConfigurationQuery>;
export type GetConfigurationLazyQueryHookResult = ReturnType<typeof useGetConfigurationLazyQuery>;
export type GetConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetConfigurationSuspenseQuery>;
export type GetConfigurationQueryResult = Apollo.QueryResult<GetConfigurationQuery, GetConfigurationQueryVariables>;
export const LiveConferenceCountDocument = gql`
  query LiveConferenceCount {
    liveConferenceCount {
      message
      count
    }
  }
`;

/**
 * __useLiveConferenceCountQuery__
 *
 * To run a query within a React component, call `useLiveConferenceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveConferenceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveConferenceCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiveConferenceCountQuery(
  baseOptions?: Apollo.QueryHookOptions<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>(
    LiveConferenceCountDocument,
    options
  );
}
export function useLiveConferenceCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>(
    LiveConferenceCountDocument,
    options
  );
}
// @ts-ignore
export function useLiveConferenceCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>
): Apollo.UseSuspenseQueryResult<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>;
export function useLiveConferenceCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>
): Apollo.UseSuspenseQueryResult<LiveConferenceCountQuery | undefined, LiveConferenceCountQueryVariables>;
export function useLiveConferenceCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LiveConferenceCountQuery, LiveConferenceCountQueryVariables>(
    LiveConferenceCountDocument,
    options
  );
}
export type LiveConferenceCountQueryHookResult = ReturnType<typeof useLiveConferenceCountQuery>;
export type LiveConferenceCountLazyQueryHookResult = ReturnType<typeof useLiveConferenceCountLazyQuery>;
export type LiveConferenceCountSuspenseQueryHookResult = ReturnType<typeof useLiveConferenceCountSuspenseQuery>;
export type LiveConferenceCountQueryResult = Apollo.QueryResult<
  LiveConferenceCountQuery,
  LiveConferenceCountQueryVariables
>;
export const PhoneNumberStatusCountDocument = gql`
  query PhoneNumberStatusCount($query: String) {
    phoneNumberStatusCount(query: $query) {
      message
      data {
        activeCount
        pendingCount
        failedCount
        releasedAndScheduledChannelsCount
      }
    }
  }
`;

/**
 * __usePhoneNumberStatusCountQuery__
 *
 * To run a query within a React component, call `usePhoneNumberStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberStatusCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePhoneNumberStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>(
    PhoneNumberStatusCountDocument,
    options
  );
}
export function usePhoneNumberStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>(
    PhoneNumberStatusCountDocument,
    options
  );
}
// @ts-ignore
export function usePhoneNumberStatusCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>
): Apollo.UseSuspenseQueryResult<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>;
export function usePhoneNumberStatusCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>
): Apollo.UseSuspenseQueryResult<PhoneNumberStatusCountQuery | undefined, PhoneNumberStatusCountQueryVariables>;
export function usePhoneNumberStatusCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PhoneNumberStatusCountQuery, PhoneNumberStatusCountQueryVariables>(
    PhoneNumberStatusCountDocument,
    options
  );
}
export type PhoneNumberStatusCountQueryHookResult = ReturnType<typeof usePhoneNumberStatusCountQuery>;
export type PhoneNumberStatusCountLazyQueryHookResult = ReturnType<typeof usePhoneNumberStatusCountLazyQuery>;
export type PhoneNumberStatusCountSuspenseQueryHookResult = ReturnType<typeof usePhoneNumberStatusCountSuspenseQuery>;
export type PhoneNumberStatusCountQueryResult = Apollo.QueryResult<
  PhoneNumberStatusCountQuery,
  PhoneNumberStatusCountQueryVariables
>;
export const PublicCheckPhoneNumberRegulationDocument = gql`
  query PublicCheckPhoneNumberRegulation(
    $isoCountry: String!
    $numberType: NumberTypeEnum!
    $addressRequirements: String!
  ) {
    publicCheckPhoneNumberRegulation(
      isoCountry: $isoCountry
      numberType: $numberType
      addressRequirements: $addressRequirements
    ) {
      message
      data {
        regulatoryCompliance
        requiredRegulatoryCompliance {
          identity
          address
          endUserTypes
        }
      }
    }
  }
`;

/**
 * __usePublicCheckPhoneNumberRegulationQuery__
 *
 * To run a query within a React component, call `usePublicCheckPhoneNumberRegulationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCheckPhoneNumberRegulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCheckPhoneNumberRegulationQuery({
 *   variables: {
 *      isoCountry: // value for 'isoCountry'
 *      numberType: // value for 'numberType'
 *      addressRequirements: // value for 'addressRequirements'
 *   },
 * });
 */
export function usePublicCheckPhoneNumberRegulationQuery(
  baseOptions: Apollo.QueryHookOptions<
    PublicCheckPhoneNumberRegulationQuery,
    PublicCheckPhoneNumberRegulationQueryVariables
  > &
    ({ variables: PublicCheckPhoneNumberRegulationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PublicCheckPhoneNumberRegulationQuery, PublicCheckPhoneNumberRegulationQueryVariables>(
    PublicCheckPhoneNumberRegulationDocument,
    options
  );
}
export function usePublicCheckPhoneNumberRegulationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicCheckPhoneNumberRegulationQuery,
    PublicCheckPhoneNumberRegulationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PublicCheckPhoneNumberRegulationQuery, PublicCheckPhoneNumberRegulationQueryVariables>(
    PublicCheckPhoneNumberRegulationDocument,
    options
  );
}
// @ts-ignore
export function usePublicCheckPhoneNumberRegulationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PublicCheckPhoneNumberRegulationQuery,
    PublicCheckPhoneNumberRegulationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<PublicCheckPhoneNumberRegulationQuery, PublicCheckPhoneNumberRegulationQueryVariables>;
export function usePublicCheckPhoneNumberRegulationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PublicCheckPhoneNumberRegulationQuery,
        PublicCheckPhoneNumberRegulationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  PublicCheckPhoneNumberRegulationQuery | undefined,
  PublicCheckPhoneNumberRegulationQueryVariables
>;
export function usePublicCheckPhoneNumberRegulationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PublicCheckPhoneNumberRegulationQuery,
        PublicCheckPhoneNumberRegulationQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PublicCheckPhoneNumberRegulationQuery, PublicCheckPhoneNumberRegulationQueryVariables>(
    PublicCheckPhoneNumberRegulationDocument,
    options
  );
}
export type PublicCheckPhoneNumberRegulationQueryHookResult = ReturnType<
  typeof usePublicCheckPhoneNumberRegulationQuery
>;
export type PublicCheckPhoneNumberRegulationLazyQueryHookResult = ReturnType<
  typeof usePublicCheckPhoneNumberRegulationLazyQuery
>;
export type PublicCheckPhoneNumberRegulationSuspenseQueryHookResult = ReturnType<
  typeof usePublicCheckPhoneNumberRegulationSuspenseQuery
>;
export type PublicCheckPhoneNumberRegulationQueryResult = Apollo.QueryResult<
  PublicCheckPhoneNumberRegulationQuery,
  PublicCheckPhoneNumberRegulationQueryVariables
>;
export const GetPreferredContactMethodsDocument = gql`
  query GetPreferredContactMethods {
    getPreferredContactMethods {
      message
      data {
        id
        messagingEnabled
        messagingType
        messagingNumber
        phoneCallEnabled
        phoneCallNumber
        prefStartTime
        prefEndTime
        emailEnabled
        email
      }
    }
  }
`;

/**
 * __useGetPreferredContactMethodsQuery__
 *
 * To run a query within a React component, call `useGetPreferredContactMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredContactMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredContactMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreferredContactMethodsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPreferredContactMethodsQuery, GetPreferredContactMethodsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPreferredContactMethodsQuery, GetPreferredContactMethodsQueryVariables>(
    GetPreferredContactMethodsDocument,
    options
  );
}
export function useGetPreferredContactMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPreferredContactMethodsQuery, GetPreferredContactMethodsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPreferredContactMethodsQuery, GetPreferredContactMethodsQueryVariables>(
    GetPreferredContactMethodsDocument,
    options
  );
}
// @ts-ignore
export function useGetPreferredContactMethodsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPreferredContactMethodsQuery,
    GetPreferredContactMethodsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetPreferredContactMethodsQuery, GetPreferredContactMethodsQueryVariables>;
export function useGetPreferredContactMethodsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPreferredContactMethodsQuery, GetPreferredContactMethodsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetPreferredContactMethodsQuery | undefined, GetPreferredContactMethodsQueryVariables>;
export function useGetPreferredContactMethodsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPreferredContactMethodsQuery, GetPreferredContactMethodsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPreferredContactMethodsQuery, GetPreferredContactMethodsQueryVariables>(
    GetPreferredContactMethodsDocument,
    options
  );
}
export type GetPreferredContactMethodsQueryHookResult = ReturnType<typeof useGetPreferredContactMethodsQuery>;
export type GetPreferredContactMethodsLazyQueryHookResult = ReturnType<typeof useGetPreferredContactMethodsLazyQuery>;
export type GetPreferredContactMethodsSuspenseQueryHookResult = ReturnType<
  typeof useGetPreferredContactMethodsSuspenseQuery
>;
export type GetPreferredContactMethodsQueryResult = Apollo.QueryResult<
  GetPreferredContactMethodsQuery,
  GetPreferredContactMethodsQueryVariables
>;
export const UsageReportNotificationDocument = gql`
  query UsageReportNotification {
    usageReportNotification {
      message
      data {
        frequency
        localSendAt
        localDayOfWeek
        localDayOfMonth
        localWeekOfMonth
        localWeekdayOfMonth
        localMonthOfYear
        monthlyScheduleType
        enabled
      }
    }
  }
`;

/**
 * __useUsageReportNotificationQuery__
 *
 * To run a query within a React component, call `useUsageReportNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageReportNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageReportNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsageReportNotificationQuery(
  baseOptions?: Apollo.QueryHookOptions<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>(
    UsageReportNotificationDocument,
    options
  );
}
export function useUsageReportNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>(
    UsageReportNotificationDocument,
    options
  );
}
// @ts-ignore
export function useUsageReportNotificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>
): Apollo.UseSuspenseQueryResult<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>;
export function useUsageReportNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>
): Apollo.UseSuspenseQueryResult<UsageReportNotificationQuery | undefined, UsageReportNotificationQueryVariables>;
export function useUsageReportNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UsageReportNotificationQuery, UsageReportNotificationQueryVariables>(
    UsageReportNotificationDocument,
    options
  );
}
export type UsageReportNotificationQueryHookResult = ReturnType<typeof useUsageReportNotificationQuery>;
export type UsageReportNotificationLazyQueryHookResult = ReturnType<typeof useUsageReportNotificationLazyQuery>;
export type UsageReportNotificationSuspenseQueryHookResult = ReturnType<typeof useUsageReportNotificationSuspenseQuery>;
export type UsageReportNotificationQueryResult = Apollo.QueryResult<
  UsageReportNotificationQuery,
  UsageReportNotificationQueryVariables
>;
export const AgentInProgressConversationDocument = gql`
  query AgentInProgressConversation {
    agentInProgressConversation {
      message
      data {
        id
        callEntity {
          id
          sid
          clientIdentity
          callPlatform
        }
      }
    }
  }
`;

/**
 * __useAgentInProgressConversationQuery__
 *
 * To run a query within a React component, call `useAgentInProgressConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentInProgressConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentInProgressConversationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentInProgressConversationQuery(
  baseOptions?: Apollo.QueryHookOptions<AgentInProgressConversationQuery, AgentInProgressConversationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AgentInProgressConversationQuery, AgentInProgressConversationQueryVariables>(
    AgentInProgressConversationDocument,
    options
  );
}
export function useAgentInProgressConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AgentInProgressConversationQuery, AgentInProgressConversationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AgentInProgressConversationQuery, AgentInProgressConversationQueryVariables>(
    AgentInProgressConversationDocument,
    options
  );
}
// @ts-ignore
export function useAgentInProgressConversationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AgentInProgressConversationQuery,
    AgentInProgressConversationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<AgentInProgressConversationQuery, AgentInProgressConversationQueryVariables>;
export function useAgentInProgressConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AgentInProgressConversationQuery, AgentInProgressConversationQueryVariables>
): Apollo.UseSuspenseQueryResult<
  AgentInProgressConversationQuery | undefined,
  AgentInProgressConversationQueryVariables
>;
export function useAgentInProgressConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AgentInProgressConversationQuery, AgentInProgressConversationQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AgentInProgressConversationQuery, AgentInProgressConversationQueryVariables>(
    AgentInProgressConversationDocument,
    options
  );
}
export type AgentInProgressConversationQueryHookResult = ReturnType<typeof useAgentInProgressConversationQuery>;
export type AgentInProgressConversationLazyQueryHookResult = ReturnType<typeof useAgentInProgressConversationLazyQuery>;
export type AgentInProgressConversationSuspenseQueryHookResult = ReturnType<
  typeof useAgentInProgressConversationSuspenseQuery
>;
export type AgentInProgressConversationQueryResult = Apollo.QueryResult<
  AgentInProgressConversationQuery,
  AgentInProgressConversationQueryVariables
>;
export const GetBulkMessagingCampaignDocument = gql`
  query GetBulkMessagingCampaign($campaignId: Int!) {
    getBulkMessagingCampaign(campaignId: $campaignId) {
      message
      data {
        id
        campaignName
        isDraft
        messageTemplate
        mediaCount
        campaignType
        messagingType
        a2pCampaignId
        a2pCampaignType
        a2pSampleId
        status
        scheduleType
        isScheduled
        initiatedAt
        scheduledAt
        maxOccurrence
        endAt
        recipients {
          id
          name
          phoneNumber
          profile {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
        }
        attachments {
          id
          fileName
          mimetype
          fileSize
          fileUrl
          media {
            id
          }
        }
        metrics {
          key
          value
        }
        createdBy {
          id
          name
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          roles {
            id
            label
            slug
            level
            isActive
            isDefault
            position
          }
        }
        createdAt
        nextOccurrence
        deliverySummary {
          totalRecipients
          totalDelivered
          runStatus
          totalSent
        }
        channel {
          id
          phoneNumber
        }
      }
    }
  }
`;

/**
 * __useGetBulkMessagingCampaignQuery__
 *
 * To run a query within a React component, call `useGetBulkMessagingCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkMessagingCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkMessagingCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetBulkMessagingCampaignQuery(
  baseOptions: Apollo.QueryHookOptions<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables> &
    ({ variables: GetBulkMessagingCampaignQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables>(
    GetBulkMessagingCampaignDocument,
    options
  );
}
export function useGetBulkMessagingCampaignLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables>(
    GetBulkMessagingCampaignDocument,
    options
  );
}
// @ts-ignore
export function useGetBulkMessagingCampaignSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables>
): Apollo.UseSuspenseQueryResult<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables>;
export function useGetBulkMessagingCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables>
): Apollo.UseSuspenseQueryResult<GetBulkMessagingCampaignQuery | undefined, GetBulkMessagingCampaignQueryVariables>;
export function useGetBulkMessagingCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBulkMessagingCampaignQuery, GetBulkMessagingCampaignQueryVariables>(
    GetBulkMessagingCampaignDocument,
    options
  );
}
export type GetBulkMessagingCampaignQueryHookResult = ReturnType<typeof useGetBulkMessagingCampaignQuery>;
export type GetBulkMessagingCampaignLazyQueryHookResult = ReturnType<typeof useGetBulkMessagingCampaignLazyQuery>;
export type GetBulkMessagingCampaignSuspenseQueryHookResult = ReturnType<
  typeof useGetBulkMessagingCampaignSuspenseQuery
>;
export type GetBulkMessagingCampaignQueryResult = Apollo.QueryResult<
  GetBulkMessagingCampaignQuery,
  GetBulkMessagingCampaignQueryVariables
>;
export const FetchBulkMessagingCampaignRecipientsDocument = gql`
  query FetchBulkMessagingCampaignRecipients(
    $campaignId: Int!
    $sort: SortEnum
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $withCursor: Boolean
    $order: String
    $query: String
    $status: BulkMessagingCampaignRecipientStatusEnum
  ) {
    fetchBulkMessagingCampaignRecipients(
      campaignId: $campaignId
      sort: $sort
      cursor: $cursor
      direction: $direction
      limit: $limit
      withCursor: $withCursor
      order: $order
      query: $query
      status: $status
    ) {
      message
      data {
        id
        conversationStatus
        contact {
          id
          country {
            id
            name
            flag
          }
          profilePicture {
            id
            url
          }
          phoneNumber
          name
        }
        messageConversationErrorLog {
          id
          code
          message
        }
        createdAt
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useFetchBulkMessagingCampaignRecipientsQuery__
 *
 * To run a query within a React component, call `useFetchBulkMessagingCampaignRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBulkMessagingCampaignRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBulkMessagingCampaignRecipientsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      withCursor: // value for 'withCursor'
 *      order: // value for 'order'
 *      query: // value for 'query'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useFetchBulkMessagingCampaignRecipientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchBulkMessagingCampaignRecipientsQuery,
    FetchBulkMessagingCampaignRecipientsQueryVariables
  > &
    ({ variables: FetchBulkMessagingCampaignRecipientsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchBulkMessagingCampaignRecipientsQuery, FetchBulkMessagingCampaignRecipientsQueryVariables>(
    FetchBulkMessagingCampaignRecipientsDocument,
    options
  );
}
export function useFetchBulkMessagingCampaignRecipientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchBulkMessagingCampaignRecipientsQuery,
    FetchBulkMessagingCampaignRecipientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchBulkMessagingCampaignRecipientsQuery,
    FetchBulkMessagingCampaignRecipientsQueryVariables
  >(FetchBulkMessagingCampaignRecipientsDocument, options);
}
// @ts-ignore
export function useFetchBulkMessagingCampaignRecipientsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchBulkMessagingCampaignRecipientsQuery,
    FetchBulkMessagingCampaignRecipientsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  FetchBulkMessagingCampaignRecipientsQuery,
  FetchBulkMessagingCampaignRecipientsQueryVariables
>;
export function useFetchBulkMessagingCampaignRecipientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchBulkMessagingCampaignRecipientsQuery,
        FetchBulkMessagingCampaignRecipientsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  FetchBulkMessagingCampaignRecipientsQuery | undefined,
  FetchBulkMessagingCampaignRecipientsQueryVariables
>;
export function useFetchBulkMessagingCampaignRecipientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchBulkMessagingCampaignRecipientsQuery,
        FetchBulkMessagingCampaignRecipientsQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchBulkMessagingCampaignRecipientsQuery,
    FetchBulkMessagingCampaignRecipientsQueryVariables
  >(FetchBulkMessagingCampaignRecipientsDocument, options);
}
export type FetchBulkMessagingCampaignRecipientsQueryHookResult = ReturnType<
  typeof useFetchBulkMessagingCampaignRecipientsQuery
>;
export type FetchBulkMessagingCampaignRecipientsLazyQueryHookResult = ReturnType<
  typeof useFetchBulkMessagingCampaignRecipientsLazyQuery
>;
export type FetchBulkMessagingCampaignRecipientsSuspenseQueryHookResult = ReturnType<
  typeof useFetchBulkMessagingCampaignRecipientsSuspenseQuery
>;
export type FetchBulkMessagingCampaignRecipientsQueryResult = Apollo.QueryResult<
  FetchBulkMessagingCampaignRecipientsQuery,
  FetchBulkMessagingCampaignRecipientsQueryVariables
>;
export const GetBulkMessagingCampaignListCountDocument = gql`
  query GetBulkMessagingCampaignListCount(
    $campaignType: BulkMessagingCampaignTypeEnum
    $status: [BulkMessagingCampaignStatusEnum]
    $createdBy: [Int]
    $query: String
    $initiatedFrom: Date
    $initiatedTo: Date
  ) {
    getBulkMessagingCampaignListCount(
      campaignType: $campaignType
      status: $status
      createdBy: $createdBy
      query: $query
      initiatedFrom: $initiatedFrom
      initiatedTo: $initiatedTo
    ) {
      count
      message
    }
  }
`;

/**
 * __useGetBulkMessagingCampaignListCountQuery__
 *
 * To run a query within a React component, call `useGetBulkMessagingCampaignListCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkMessagingCampaignListCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkMessagingCampaignListCountQuery({
 *   variables: {
 *      campaignType: // value for 'campaignType'
 *      status: // value for 'status'
 *      createdBy: // value for 'createdBy'
 *      query: // value for 'query'
 *      initiatedFrom: // value for 'initiatedFrom'
 *      initiatedTo: // value for 'initiatedTo'
 *   },
 * });
 */
export function useGetBulkMessagingCampaignListCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBulkMessagingCampaignListCountQuery,
    GetBulkMessagingCampaignListCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBulkMessagingCampaignListCountQuery, GetBulkMessagingCampaignListCountQueryVariables>(
    GetBulkMessagingCampaignListCountDocument,
    options
  );
}
export function useGetBulkMessagingCampaignListCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBulkMessagingCampaignListCountQuery,
    GetBulkMessagingCampaignListCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBulkMessagingCampaignListCountQuery, GetBulkMessagingCampaignListCountQueryVariables>(
    GetBulkMessagingCampaignListCountDocument,
    options
  );
}
// @ts-ignore
export function useGetBulkMessagingCampaignListCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBulkMessagingCampaignListCountQuery,
    GetBulkMessagingCampaignListCountQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetBulkMessagingCampaignListCountQuery,
  GetBulkMessagingCampaignListCountQueryVariables
>;
export function useGetBulkMessagingCampaignListCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBulkMessagingCampaignListCountQuery,
        GetBulkMessagingCampaignListCountQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetBulkMessagingCampaignListCountQuery | undefined,
  GetBulkMessagingCampaignListCountQueryVariables
>;
export function useGetBulkMessagingCampaignListCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBulkMessagingCampaignListCountQuery,
        GetBulkMessagingCampaignListCountQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetBulkMessagingCampaignListCountQuery,
    GetBulkMessagingCampaignListCountQueryVariables
  >(GetBulkMessagingCampaignListCountDocument, options);
}
export type GetBulkMessagingCampaignListCountQueryHookResult = ReturnType<
  typeof useGetBulkMessagingCampaignListCountQuery
>;
export type GetBulkMessagingCampaignListCountLazyQueryHookResult = ReturnType<
  typeof useGetBulkMessagingCampaignListCountLazyQuery
>;
export type GetBulkMessagingCampaignListCountSuspenseQueryHookResult = ReturnType<
  typeof useGetBulkMessagingCampaignListCountSuspenseQuery
>;
export type GetBulkMessagingCampaignListCountQueryResult = Apollo.QueryResult<
  GetBulkMessagingCampaignListCountQuery,
  GetBulkMessagingCampaignListCountQueryVariables
>;
export const WorkspaceClaimedFreeNumbersDocument = gql`
  query WorkspaceClaimedFreeNumbers {
    workspaceClaimedFreeNumbers {
      message
      data {
        id
        phoneNumber
        friendlyName
        currentPrice
      }
    }
  }
`;

/**
 * __useWorkspaceClaimedFreeNumbersQuery__
 *
 * To run a query within a React component, call `useWorkspaceClaimedFreeNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceClaimedFreeNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceClaimedFreeNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceClaimedFreeNumbersQuery(
  baseOptions?: Apollo.QueryHookOptions<WorkspaceClaimedFreeNumbersQuery, WorkspaceClaimedFreeNumbersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceClaimedFreeNumbersQuery, WorkspaceClaimedFreeNumbersQueryVariables>(
    WorkspaceClaimedFreeNumbersDocument,
    options
  );
}
export function useWorkspaceClaimedFreeNumbersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceClaimedFreeNumbersQuery, WorkspaceClaimedFreeNumbersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkspaceClaimedFreeNumbersQuery, WorkspaceClaimedFreeNumbersQueryVariables>(
    WorkspaceClaimedFreeNumbersDocument,
    options
  );
}
// @ts-ignore
export function useWorkspaceClaimedFreeNumbersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkspaceClaimedFreeNumbersQuery,
    WorkspaceClaimedFreeNumbersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<WorkspaceClaimedFreeNumbersQuery, WorkspaceClaimedFreeNumbersQueryVariables>;
export function useWorkspaceClaimedFreeNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceClaimedFreeNumbersQuery, WorkspaceClaimedFreeNumbersQueryVariables>
): Apollo.UseSuspenseQueryResult<
  WorkspaceClaimedFreeNumbersQuery | undefined,
  WorkspaceClaimedFreeNumbersQueryVariables
>;
export function useWorkspaceClaimedFreeNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceClaimedFreeNumbersQuery, WorkspaceClaimedFreeNumbersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkspaceClaimedFreeNumbersQuery, WorkspaceClaimedFreeNumbersQueryVariables>(
    WorkspaceClaimedFreeNumbersDocument,
    options
  );
}
export type WorkspaceClaimedFreeNumbersQueryHookResult = ReturnType<typeof useWorkspaceClaimedFreeNumbersQuery>;
export type WorkspaceClaimedFreeNumbersLazyQueryHookResult = ReturnType<typeof useWorkspaceClaimedFreeNumbersLazyQuery>;
export type WorkspaceClaimedFreeNumbersSuspenseQueryHookResult = ReturnType<
  typeof useWorkspaceClaimedFreeNumbersSuspenseQuery
>;
export type WorkspaceClaimedFreeNumbersQueryResult = Apollo.QueryResult<
  WorkspaceClaimedFreeNumbersQuery,
  WorkspaceClaimedFreeNumbersQueryVariables
>;
export const GetRecipientsByCampaignRunDocument = gql`
  query GetRecipientsByCampaignRun(
    $campaignRunId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $status: String
  ) {
    getRecipientsByCampaignRun(
      campaignRunId: $campaignRunId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      status: $status
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        updatedAt
        id
        createdAt
        conversationStatus
        contact {
          id
          email
          name
          phoneNumber
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          country {
            id
            name
            slug
            dialingCode
            alphaTwoCode
            alphaThreeCode
            numeric
            flag
          }
        }
        messageConversationErrorLog {
          id
          code
          message
        }
      }
    }
  }
`;

/**
 * __useGetRecipientsByCampaignRunQuery__
 *
 * To run a query within a React component, call `useGetRecipientsByCampaignRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientsByCampaignRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientsByCampaignRunQuery({
 *   variables: {
 *      campaignRunId: // value for 'campaignRunId'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetRecipientsByCampaignRunQuery(
  baseOptions: Apollo.QueryHookOptions<GetRecipientsByCampaignRunQuery, GetRecipientsByCampaignRunQueryVariables> &
    ({ variables: GetRecipientsByCampaignRunQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRecipientsByCampaignRunQuery, GetRecipientsByCampaignRunQueryVariables>(
    GetRecipientsByCampaignRunDocument,
    options
  );
}
export function useGetRecipientsByCampaignRunLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRecipientsByCampaignRunQuery, GetRecipientsByCampaignRunQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRecipientsByCampaignRunQuery, GetRecipientsByCampaignRunQueryVariables>(
    GetRecipientsByCampaignRunDocument,
    options
  );
}
// @ts-ignore
export function useGetRecipientsByCampaignRunSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRecipientsByCampaignRunQuery,
    GetRecipientsByCampaignRunQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetRecipientsByCampaignRunQuery, GetRecipientsByCampaignRunQueryVariables>;
export function useGetRecipientsByCampaignRunSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRecipientsByCampaignRunQuery, GetRecipientsByCampaignRunQueryVariables>
): Apollo.UseSuspenseQueryResult<GetRecipientsByCampaignRunQuery | undefined, GetRecipientsByCampaignRunQueryVariables>;
export function useGetRecipientsByCampaignRunSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRecipientsByCampaignRunQuery, GetRecipientsByCampaignRunQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRecipientsByCampaignRunQuery, GetRecipientsByCampaignRunQueryVariables>(
    GetRecipientsByCampaignRunDocument,
    options
  );
}
export type GetRecipientsByCampaignRunQueryHookResult = ReturnType<typeof useGetRecipientsByCampaignRunQuery>;
export type GetRecipientsByCampaignRunLazyQueryHookResult = ReturnType<typeof useGetRecipientsByCampaignRunLazyQuery>;
export type GetRecipientsByCampaignRunSuspenseQueryHookResult = ReturnType<
  typeof useGetRecipientsByCampaignRunSuspenseQuery
>;
export type GetRecipientsByCampaignRunQueryResult = Apollo.QueryResult<
  GetRecipientsByCampaignRunQuery,
  GetRecipientsByCampaignRunQueryVariables
>;
export const GetCampaignRecipientsByCampaignIdDocument = gql`
  query GetCampaignRecipientsByCampaignId(
    $campaignId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    getCampaignRecipientsByCampaignId(
      campaignId: $campaignId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        updatedAt
        id
        createdAt
        contact {
          id
          email
          country {
            id
            name
            flag
          }
          name
          phoneNumber
          profilePicture {
            id
            key
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetCampaignRecipientsByCampaignIdQuery__
 *
 * To run a query within a React component, call `useGetCampaignRecipientsByCampaignIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignRecipientsByCampaignIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignRecipientsByCampaignIdQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      cursor: // value for 'cursor'
 *      direction: // value for 'direction'
 *      withCursor: // value for 'withCursor'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetCampaignRecipientsByCampaignIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCampaignRecipientsByCampaignIdQuery,
    GetCampaignRecipientsByCampaignIdQueryVariables
  > &
    ({ variables: GetCampaignRecipientsByCampaignIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCampaignRecipientsByCampaignIdQuery, GetCampaignRecipientsByCampaignIdQueryVariables>(
    GetCampaignRecipientsByCampaignIdDocument,
    options
  );
}
export function useGetCampaignRecipientsByCampaignIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCampaignRecipientsByCampaignIdQuery,
    GetCampaignRecipientsByCampaignIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCampaignRecipientsByCampaignIdQuery, GetCampaignRecipientsByCampaignIdQueryVariables>(
    GetCampaignRecipientsByCampaignIdDocument,
    options
  );
}
// @ts-ignore
export function useGetCampaignRecipientsByCampaignIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCampaignRecipientsByCampaignIdQuery,
    GetCampaignRecipientsByCampaignIdQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCampaignRecipientsByCampaignIdQuery,
  GetCampaignRecipientsByCampaignIdQueryVariables
>;
export function useGetCampaignRecipientsByCampaignIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCampaignRecipientsByCampaignIdQuery,
        GetCampaignRecipientsByCampaignIdQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCampaignRecipientsByCampaignIdQuery | undefined,
  GetCampaignRecipientsByCampaignIdQueryVariables
>;
export function useGetCampaignRecipientsByCampaignIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCampaignRecipientsByCampaignIdQuery,
        GetCampaignRecipientsByCampaignIdQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCampaignRecipientsByCampaignIdQuery,
    GetCampaignRecipientsByCampaignIdQueryVariables
  >(GetCampaignRecipientsByCampaignIdDocument, options);
}
export type GetCampaignRecipientsByCampaignIdQueryHookResult = ReturnType<
  typeof useGetCampaignRecipientsByCampaignIdQuery
>;
export type GetCampaignRecipientsByCampaignIdLazyQueryHookResult = ReturnType<
  typeof useGetCampaignRecipientsByCampaignIdLazyQuery
>;
export type GetCampaignRecipientsByCampaignIdSuspenseQueryHookResult = ReturnType<
  typeof useGetCampaignRecipientsByCampaignIdSuspenseQuery
>;
export type GetCampaignRecipientsByCampaignIdQueryResult = Apollo.QueryResult<
  GetCampaignRecipientsByCampaignIdQuery,
  GetCampaignRecipientsByCampaignIdQueryVariables
>;
export const GetCallSettingEmailAlertsDocument = gql`
  query GetCallSettingEmailAlerts($getCallSettingEmailAlertsId: Int!) {
    getCallSettingEmailAlerts(id: $getCallSettingEmailAlertsId) {
      message
      data {
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
      }
    }
  }
`;

/**
 * __useGetCallSettingEmailAlertsQuery__
 *
 * To run a query within a React component, call `useGetCallSettingEmailAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallSettingEmailAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallSettingEmailAlertsQuery({
 *   variables: {
 *      getCallSettingEmailAlertsId: // value for 'getCallSettingEmailAlertsId'
 *   },
 * });
 */
export function useGetCallSettingEmailAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables> &
    ({ variables: GetCallSettingEmailAlertsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables>(
    GetCallSettingEmailAlertsDocument,
    options
  );
}
export function useGetCallSettingEmailAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables>(
    GetCallSettingEmailAlertsDocument,
    options
  );
}
// @ts-ignore
export function useGetCallSettingEmailAlertsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables>;
export function useGetCallSettingEmailAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetCallSettingEmailAlertsQuery | undefined, GetCallSettingEmailAlertsQueryVariables>;
export function useGetCallSettingEmailAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallSettingEmailAlertsQuery, GetCallSettingEmailAlertsQueryVariables>(
    GetCallSettingEmailAlertsDocument,
    options
  );
}
export type GetCallSettingEmailAlertsQueryHookResult = ReturnType<typeof useGetCallSettingEmailAlertsQuery>;
export type GetCallSettingEmailAlertsLazyQueryHookResult = ReturnType<typeof useGetCallSettingEmailAlertsLazyQuery>;
export type GetCallSettingEmailAlertsSuspenseQueryHookResult = ReturnType<
  typeof useGetCallSettingEmailAlertsSuspenseQuery
>;
export type GetCallSettingEmailAlertsQueryResult = Apollo.QueryResult<
  GetCallSettingEmailAlertsQuery,
  GetCallSettingEmailAlertsQueryVariables
>;
export const GetChannelSettingEmailAlertsDocument = gql`
  query GetChannelSettingEmailAlerts($channelId: Int!) {
    getChannelSettingEmailAlerts(channelId: $channelId) {
      message
      data {
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
      }
    }
  }
`;

/**
 * __useGetChannelSettingEmailAlertsQuery__
 *
 * To run a query within a React component, call `useGetChannelSettingEmailAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelSettingEmailAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelSettingEmailAlertsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelSettingEmailAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<GetChannelSettingEmailAlertsQuery, GetChannelSettingEmailAlertsQueryVariables> &
    ({ variables: GetChannelSettingEmailAlertsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelSettingEmailAlertsQuery, GetChannelSettingEmailAlertsQueryVariables>(
    GetChannelSettingEmailAlertsDocument,
    options
  );
}
export function useGetChannelSettingEmailAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChannelSettingEmailAlertsQuery,
    GetChannelSettingEmailAlertsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelSettingEmailAlertsQuery, GetChannelSettingEmailAlertsQueryVariables>(
    GetChannelSettingEmailAlertsDocument,
    options
  );
}
// @ts-ignore
export function useGetChannelSettingEmailAlertsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChannelSettingEmailAlertsQuery,
    GetChannelSettingEmailAlertsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetChannelSettingEmailAlertsQuery, GetChannelSettingEmailAlertsQueryVariables>;
export function useGetChannelSettingEmailAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelSettingEmailAlertsQuery, GetChannelSettingEmailAlertsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetChannelSettingEmailAlertsQuery | undefined,
  GetChannelSettingEmailAlertsQueryVariables
>;
export function useGetChannelSettingEmailAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelSettingEmailAlertsQuery, GetChannelSettingEmailAlertsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChannelSettingEmailAlertsQuery, GetChannelSettingEmailAlertsQueryVariables>(
    GetChannelSettingEmailAlertsDocument,
    options
  );
}
export type GetChannelSettingEmailAlertsQueryHookResult = ReturnType<typeof useGetChannelSettingEmailAlertsQuery>;
export type GetChannelSettingEmailAlertsLazyQueryHookResult = ReturnType<
  typeof useGetChannelSettingEmailAlertsLazyQuery
>;
export type GetChannelSettingEmailAlertsSuspenseQueryHookResult = ReturnType<
  typeof useGetChannelSettingEmailAlertsSuspenseQuery
>;
export type GetChannelSettingEmailAlertsQueryResult = Apollo.QueryResult<
  GetChannelSettingEmailAlertsQuery,
  GetChannelSettingEmailAlertsQueryVariables
>;
export const GetBulkMessagingCampaignRunDocument = gql`
  query GetBulkMessagingCampaignRun($campaignRunId: Int!) {
    getBulkMessagingCampaignRun(campaignRunId: $campaignRunId) {
      message
      data {
        updatedAt
        totalRecipients
        status
        startedAt
        scheduledAt
        runNumber
        initiatedAt
        id
        campaign {
          campaignType
          id
          messageTemplate
          name
          phoneNumber
        }
        completedAt
        createdAt
        createdBy {
          id
          name
        }
        deliverySummary {
          totalProcessed
          totalSent
          totalFailed
          totalDelivered
        }
      }
    }
  }
`;

/**
 * __useGetBulkMessagingCampaignRunQuery__
 *
 * To run a query within a React component, call `useGetBulkMessagingCampaignRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkMessagingCampaignRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkMessagingCampaignRunQuery({
 *   variables: {
 *      campaignRunId: // value for 'campaignRunId'
 *   },
 * });
 */
export function useGetBulkMessagingCampaignRunQuery(
  baseOptions: Apollo.QueryHookOptions<GetBulkMessagingCampaignRunQuery, GetBulkMessagingCampaignRunQueryVariables> &
    ({ variables: GetBulkMessagingCampaignRunQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBulkMessagingCampaignRunQuery, GetBulkMessagingCampaignRunQueryVariables>(
    GetBulkMessagingCampaignRunDocument,
    options
  );
}
export function useGetBulkMessagingCampaignRunLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBulkMessagingCampaignRunQuery, GetBulkMessagingCampaignRunQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBulkMessagingCampaignRunQuery, GetBulkMessagingCampaignRunQueryVariables>(
    GetBulkMessagingCampaignRunDocument,
    options
  );
}
// @ts-ignore
export function useGetBulkMessagingCampaignRunSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBulkMessagingCampaignRunQuery,
    GetBulkMessagingCampaignRunQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetBulkMessagingCampaignRunQuery, GetBulkMessagingCampaignRunQueryVariables>;
export function useGetBulkMessagingCampaignRunSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBulkMessagingCampaignRunQuery, GetBulkMessagingCampaignRunQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetBulkMessagingCampaignRunQuery | undefined,
  GetBulkMessagingCampaignRunQueryVariables
>;
export function useGetBulkMessagingCampaignRunSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBulkMessagingCampaignRunQuery, GetBulkMessagingCampaignRunQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBulkMessagingCampaignRunQuery, GetBulkMessagingCampaignRunQueryVariables>(
    GetBulkMessagingCampaignRunDocument,
    options
  );
}
export type GetBulkMessagingCampaignRunQueryHookResult = ReturnType<typeof useGetBulkMessagingCampaignRunQuery>;
export type GetBulkMessagingCampaignRunLazyQueryHookResult = ReturnType<typeof useGetBulkMessagingCampaignRunLazyQuery>;
export type GetBulkMessagingCampaignRunSuspenseQueryHookResult = ReturnType<
  typeof useGetBulkMessagingCampaignRunSuspenseQuery
>;
export type GetBulkMessagingCampaignRunQueryResult = Apollo.QueryResult<
  GetBulkMessagingCampaignRunQuery,
  GetBulkMessagingCampaignRunQueryVariables
>;
export const GetChannelsByCampaignDocument = gql`
  query GetChannelsByCampaign($campaignId: Int!, $type: ContactComplianceConsentCampaignTypeEnum!) {
    getChannelsByCampaign(campaignId: $campaignId, type: $type) {
      message
      data {
        id
        phoneNumber
        friendlyName
      }
    }
  }
`;

/**
 * __useGetChannelsByCampaignQuery__
 *
 * To run a query within a React component, call `useGetChannelsByCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsByCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsByCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetChannelsByCampaignQuery(
  baseOptions: Apollo.QueryHookOptions<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables> &
    ({ variables: GetChannelsByCampaignQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables>(
    GetChannelsByCampaignDocument,
    options
  );
}
export function useGetChannelsByCampaignLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables>(
    GetChannelsByCampaignDocument,
    options
  );
}
// @ts-ignore
export function useGetChannelsByCampaignSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables>
): Apollo.UseSuspenseQueryResult<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables>;
export function useGetChannelsByCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables>
): Apollo.UseSuspenseQueryResult<GetChannelsByCampaignQuery | undefined, GetChannelsByCampaignQueryVariables>;
export function useGetChannelsByCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChannelsByCampaignQuery, GetChannelsByCampaignQueryVariables>(
    GetChannelsByCampaignDocument,
    options
  );
}
export type GetChannelsByCampaignQueryHookResult = ReturnType<typeof useGetChannelsByCampaignQuery>;
export type GetChannelsByCampaignLazyQueryHookResult = ReturnType<typeof useGetChannelsByCampaignLazyQuery>;
export type GetChannelsByCampaignSuspenseQueryHookResult = ReturnType<typeof useGetChannelsByCampaignSuspenseQuery>;
export type GetChannelsByCampaignQueryResult = Apollo.QueryResult<
  GetChannelsByCampaignQuery,
  GetChannelsByCampaignQueryVariables
>;
export const GetComplianceCampaignSampleMessagesDocument = gql`
  query GetComplianceCampaignSampleMessages($campaignId: Int!, $type: ContactComplianceConsentCampaignTypeEnum!) {
    getComplianceCampaignSampleMessages(campaignId: $campaignId, type: $type) {
      message
      data {
        id
        message
      }
    }
  }
`;

/**
 * __useGetComplianceCampaignSampleMessagesQuery__
 *
 * To run a query within a React component, call `useGetComplianceCampaignSampleMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCampaignSampleMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCampaignSampleMessagesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetComplianceCampaignSampleMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceCampaignSampleMessagesQuery,
    GetComplianceCampaignSampleMessagesQueryVariables
  > &
    ({ variables: GetComplianceCampaignSampleMessagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetComplianceCampaignSampleMessagesQuery, GetComplianceCampaignSampleMessagesQueryVariables>(
    GetComplianceCampaignSampleMessagesDocument,
    options
  );
}
export function useGetComplianceCampaignSampleMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceCampaignSampleMessagesQuery,
    GetComplianceCampaignSampleMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceCampaignSampleMessagesQuery,
    GetComplianceCampaignSampleMessagesQueryVariables
  >(GetComplianceCampaignSampleMessagesDocument, options);
}
// @ts-ignore
export function useGetComplianceCampaignSampleMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceCampaignSampleMessagesQuery,
    GetComplianceCampaignSampleMessagesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetComplianceCampaignSampleMessagesQuery,
  GetComplianceCampaignSampleMessagesQueryVariables
>;
export function useGetComplianceCampaignSampleMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceCampaignSampleMessagesQuery,
        GetComplianceCampaignSampleMessagesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetComplianceCampaignSampleMessagesQuery | undefined,
  GetComplianceCampaignSampleMessagesQueryVariables
>;
export function useGetComplianceCampaignSampleMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceCampaignSampleMessagesQuery,
        GetComplianceCampaignSampleMessagesQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceCampaignSampleMessagesQuery,
    GetComplianceCampaignSampleMessagesQueryVariables
  >(GetComplianceCampaignSampleMessagesDocument, options);
}
export type GetComplianceCampaignSampleMessagesQueryHookResult = ReturnType<
  typeof useGetComplianceCampaignSampleMessagesQuery
>;
export type GetComplianceCampaignSampleMessagesLazyQueryHookResult = ReturnType<
  typeof useGetComplianceCampaignSampleMessagesLazyQuery
>;
export type GetComplianceCampaignSampleMessagesSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceCampaignSampleMessagesSuspenseQuery
>;
export type GetComplianceCampaignSampleMessagesQueryResult = Apollo.QueryResult<
  GetComplianceCampaignSampleMessagesQuery,
  GetComplianceCampaignSampleMessagesQueryVariables
>;
export const GetPaymentOrderByIdDocument = gql`
  query GetPaymentOrderById($paymentOrderId: Int!) {
    getPaymentOrderById(paymentOrderId: $paymentOrderId) {
      message
      data {
        id
        orderNumber
        cartAmount
        chargedAmount
        status
        lienStatus
        type
        remarks
        itemsQuantity
        createdAt
      }
    }
  }
`;

/**
 * __useGetPaymentOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentOrderByIdQuery({
 *   variables: {
 *      paymentOrderId: // value for 'paymentOrderId'
 *   },
 * });
 */
export function useGetPaymentOrderByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables> &
    ({ variables: GetPaymentOrderByIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables>(
    GetPaymentOrderByIdDocument,
    options
  );
}
export function useGetPaymentOrderByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables>(
    GetPaymentOrderByIdDocument,
    options
  );
}
// @ts-ignore
export function useGetPaymentOrderByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables>
): Apollo.UseSuspenseQueryResult<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables>;
export function useGetPaymentOrderByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables>
): Apollo.UseSuspenseQueryResult<GetPaymentOrderByIdQuery | undefined, GetPaymentOrderByIdQueryVariables>;
export function useGetPaymentOrderByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPaymentOrderByIdQuery, GetPaymentOrderByIdQueryVariables>(
    GetPaymentOrderByIdDocument,
    options
  );
}
export type GetPaymentOrderByIdQueryHookResult = ReturnType<typeof useGetPaymentOrderByIdQuery>;
export type GetPaymentOrderByIdLazyQueryHookResult = ReturnType<typeof useGetPaymentOrderByIdLazyQuery>;
export type GetPaymentOrderByIdSuspenseQueryHookResult = ReturnType<typeof useGetPaymentOrderByIdSuspenseQuery>;
export type GetPaymentOrderByIdQueryResult = Apollo.QueryResult<
  GetPaymentOrderByIdQuery,
  GetPaymentOrderByIdQueryVariables
>;
export const ReleasedAndScheduledChannelsDocument = gql`
  query ReleasedAndScheduledChannels(
    $query: String
    $countryIds: [Int]
    $numberTypes: [String]
    $channelStatus: ReleasedChannelFilterEnum
  ) {
    releasedAndScheduledChannels(
      query: $query
      countryIds: $countryIds
      numberTypes: $numberTypes
      channelStatus: $channelStatus
    ) {
      message
      data {
        id
        friendlyName
        phoneNumber
        releasedAt
        country {
          id
          flag
          alphaTwoCode
        }
        removalSchedule {
          scheduleAt
        }
        subscription {
          nextBillingAt
        }
        numberType
      }
    }
  }
`;

/**
 * __useReleasedAndScheduledChannelsQuery__
 *
 * To run a query within a React component, call `useReleasedAndScheduledChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReleasedAndScheduledChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReleasedAndScheduledChannelsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      countryIds: // value for 'countryIds'
 *      numberTypes: // value for 'numberTypes'
 *      channelStatus: // value for 'channelStatus'
 *   },
 * });
 */
export function useReleasedAndScheduledChannelsQuery(
  baseOptions?: Apollo.QueryHookOptions<ReleasedAndScheduledChannelsQuery, ReleasedAndScheduledChannelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReleasedAndScheduledChannelsQuery, ReleasedAndScheduledChannelsQueryVariables>(
    ReleasedAndScheduledChannelsDocument,
    options
  );
}
export function useReleasedAndScheduledChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReleasedAndScheduledChannelsQuery,
    ReleasedAndScheduledChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReleasedAndScheduledChannelsQuery, ReleasedAndScheduledChannelsQueryVariables>(
    ReleasedAndScheduledChannelsDocument,
    options
  );
}
// @ts-ignore
export function useReleasedAndScheduledChannelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReleasedAndScheduledChannelsQuery,
    ReleasedAndScheduledChannelsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ReleasedAndScheduledChannelsQuery, ReleasedAndScheduledChannelsQueryVariables>;
export function useReleasedAndScheduledChannelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReleasedAndScheduledChannelsQuery, ReleasedAndScheduledChannelsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ReleasedAndScheduledChannelsQuery | undefined,
  ReleasedAndScheduledChannelsQueryVariables
>;
export function useReleasedAndScheduledChannelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReleasedAndScheduledChannelsQuery, ReleasedAndScheduledChannelsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReleasedAndScheduledChannelsQuery, ReleasedAndScheduledChannelsQueryVariables>(
    ReleasedAndScheduledChannelsDocument,
    options
  );
}
export type ReleasedAndScheduledChannelsQueryHookResult = ReturnType<typeof useReleasedAndScheduledChannelsQuery>;
export type ReleasedAndScheduledChannelsLazyQueryHookResult = ReturnType<
  typeof useReleasedAndScheduledChannelsLazyQuery
>;
export type ReleasedAndScheduledChannelsSuspenseQueryHookResult = ReturnType<
  typeof useReleasedAndScheduledChannelsSuspenseQuery
>;
export type ReleasedAndScheduledChannelsQueryResult = Apollo.QueryResult<
  ReleasedAndScheduledChannelsQuery,
  ReleasedAndScheduledChannelsQueryVariables
>;
export const MessageConversationDocument = gql`
  subscription MessageConversation($identity: [String!]) {
    messageConversation(identity: $identity) {
      id
      direction
      client {
        id
        name
        phoneNumber
        country {
          id
          flag
        }
        profilePicture {
          id
          url
        }
      }
      pinned
      channelId
      conversationStatus
      messageContent
      markAsClosed
      conversationType
      recordingUrl
      friendlyName
      voicemailRecordingUrl
      agent {
        id
        status
        callPlatform
        user {
          id
          name
          email
          phoneNumber
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
          }
        }
        userOnlineManagement {
          id
          userWorkspaceId
          workspaceId
          isActive
          lastSeenAt
          awayTill
          message
          icon
          activeStatus
        }
        workspace {
          id
          label
          status
          trusted
        }
      }
      voicemailRecording {
        id
        url
        duration
      }
      callRecording {
        id
        url
        duration
      }
      durationConference {
        id
        startDate
        endDate
      }
      createdAt
      updatedAt
      forwardedAt
      forwardedTo {
        externalNumber
      }
      messageConversationErrorLog {
        code
        message
        statusCode
      }
      numMedia
      friendlyName
    }
  }
`;

/**
 * __useMessageConversationSubscription__
 *
 * To run a query within a React component, call `useMessageConversationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessageConversationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageConversationSubscription({
 *   variables: {
 *      identity: // value for 'identity'
 *   },
 * });
 */
export function useMessageConversationSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    MessageConversationSubscription,
    MessageConversationSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<MessageConversationSubscription, MessageConversationSubscriptionVariables>(
    MessageConversationDocument,
    options
  );
}
export type MessageConversationSubscriptionHookResult = ReturnType<typeof useMessageConversationSubscription>;
export type MessageConversationSubscriptionResult = Apollo.SubscriptionResult<MessageConversationSubscription>;
export const AssignedChannelCounterDocument = gql`
  subscription AssignedChannelCounter($identity: [String]) {
    assignedChannelCounter(identity: $identity) {
      counter
      channelId
      clientId
      from
    }
  }
`;

/**
 * __useAssignedChannelCounterSubscription__
 *
 * To run a query within a React component, call `useAssignedChannelCounterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssignedChannelCounterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedChannelCounterSubscription({
 *   variables: {
 *      identity: // value for 'identity'
 *   },
 * });
 */
export function useAssignedChannelCounterSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    AssignedChannelCounterSubscription,
    AssignedChannelCounterSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<AssignedChannelCounterSubscription, AssignedChannelCounterSubscriptionVariables>(
    AssignedChannelCounterDocument,
    options
  );
}
export type AssignedChannelCounterSubscriptionHookResult = ReturnType<typeof useAssignedChannelCounterSubscription>;
export type AssignedChannelCounterSubscriptionResult = Apollo.SubscriptionResult<AssignedChannelCounterSubscription>;
export const NotificationSubscriptionDocument = gql`
  subscription NotificationSubscription {
    notificationSubscription {
      notification {
        id
        createdAt
        updatedAt
        imageUrl
        title
        body
        isExternal
        type
        redirection {
          key
          params {
            channelId
            clientId
            clientName
            markAsClosed
            pinned
          }
        }
        replacementAttributes {
          key
          value
        }
        redirectUrl
      }
      counter
      userWorkspaceId
    }
  }
`;

/**
 * __useNotificationSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNotificationSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationSubscriptionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    NotificationSubscriptionSubscription,
    NotificationSubscriptionSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<NotificationSubscriptionSubscription, NotificationSubscriptionSubscriptionVariables>(
    NotificationSubscriptionDocument,
    options
  );
}
export type NotificationSubscriptionSubscriptionHookResult = ReturnType<typeof useNotificationSubscriptionSubscription>;
export type NotificationSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<NotificationSubscriptionSubscription>;
export const callerIdVerificationDocument = gql`
  subscription callerIdVerification {
    callerIdVerification {
      id
      friendlyName
      phoneNumber
      sid
      createdAt
      updatedAt
    }
  }
`;

/**
 * __usecallerIdVerificationSubscription__
 *
 * To run a query within a React component, call `usecallerIdVerificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `usecallerIdVerificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usecallerIdVerificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function usecallerIdVerificationSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    callerIdVerificationSubscription,
    callerIdVerificationSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<callerIdVerificationSubscription, callerIdVerificationSubscriptionVariables>(
    callerIdVerificationDocument,
    options
  );
}
export type callerIdVerificationSubscriptionHookResult = ReturnType<typeof usecallerIdVerificationSubscription>;
export type callerIdVerificationSubscriptionResult = Apollo.SubscriptionResult<callerIdVerificationSubscription>;
export const ImportBulkContactProgressDocument = gql`
  subscription ImportBulkContactProgress($eventReferenceId: String) {
    importBulkContactProgress(eventReferenceId: $eventReferenceId) {
      progress
      status
    }
  }
`;

/**
 * __useImportBulkContactProgressSubscription__
 *
 * To run a query within a React component, call `useImportBulkContactProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useImportBulkContactProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportBulkContactProgressSubscription({
 *   variables: {
 *      eventReferenceId: // value for 'eventReferenceId'
 *   },
 * });
 */
export function useImportBulkContactProgressSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ImportBulkContactProgressSubscription,
    ImportBulkContactProgressSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ImportBulkContactProgressSubscription, ImportBulkContactProgressSubscriptionVariables>(
    ImportBulkContactProgressDocument,
    options
  );
}
export type ImportBulkContactProgressSubscriptionHookResult = ReturnType<
  typeof useImportBulkContactProgressSubscription
>;
export type ImportBulkContactProgressSubscriptionResult =
  Apollo.SubscriptionResult<ImportBulkContactProgressSubscription>;
export const WalletUsageHistoryExportMediaDocument = gql`
  subscription WalletUsageHistoryExportMedia($identity: String!) {
    walletUsageHistoryExportMedia(identity: $identity) {
      url
      id
    }
  }
`;

/**
 * __useWalletUsageHistoryExportMediaSubscription__
 *
 * To run a query within a React component, call `useWalletUsageHistoryExportMediaSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWalletUsageHistoryExportMediaSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletUsageHistoryExportMediaSubscription({
 *   variables: {
 *      identity: // value for 'identity'
 *   },
 * });
 */
export function useWalletUsageHistoryExportMediaSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WalletUsageHistoryExportMediaSubscription,
    WalletUsageHistoryExportMediaSubscriptionVariables
  > &
    ({ variables: WalletUsageHistoryExportMediaSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WalletUsageHistoryExportMediaSubscription,
    WalletUsageHistoryExportMediaSubscriptionVariables
  >(WalletUsageHistoryExportMediaDocument, options);
}
export type WalletUsageHistoryExportMediaSubscriptionHookResult = ReturnType<
  typeof useWalletUsageHistoryExportMediaSubscription
>;
export type WalletUsageHistoryExportMediaSubscriptionResult =
  Apollo.SubscriptionResult<WalletUsageHistoryExportMediaSubscription>;
export const ExportInvoicesStatusDocument = gql`
  subscription ExportInvoicesStatus {
    exportInvoicesStatus {
      status
      data {
        id
        url
      }
    }
  }
`;

/**
 * __useExportInvoicesStatusSubscription__
 *
 * To run a query within a React component, call `useExportInvoicesStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportInvoicesStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportInvoicesStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useExportInvoicesStatusSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ExportInvoicesStatusSubscription,
    ExportInvoicesStatusSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ExportInvoicesStatusSubscription, ExportInvoicesStatusSubscriptionVariables>(
    ExportInvoicesStatusDocument,
    options
  );
}
export type ExportInvoicesStatusSubscriptionHookResult = ReturnType<typeof useExportInvoicesStatusSubscription>;
export type ExportInvoicesStatusSubscriptionResult = Apollo.SubscriptionResult<ExportInvoicesStatusSubscription>;
export const DialerCallPulseDocument = gql`
  subscription DialerCallPulse($identity: String!) {
    dialerCallPulse(identity: $identity) {
      feature
      data
    }
  }
`;

/**
 * __useDialerCallPulseSubscription__
 *
 * To run a query within a React component, call `useDialerCallPulseSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDialerCallPulseSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDialerCallPulseSubscription({
 *   variables: {
 *      identity: // value for 'identity'
 *   },
 * });
 */
export function useDialerCallPulseSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<DialerCallPulseSubscription, DialerCallPulseSubscriptionVariables> &
    ({ variables: DialerCallPulseSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<DialerCallPulseSubscription, DialerCallPulseSubscriptionVariables>(
    DialerCallPulseDocument,
    options
  );
}
export type DialerCallPulseSubscriptionHookResult = ReturnType<typeof useDialerCallPulseSubscription>;
export type DialerCallPulseSubscriptionResult = Apollo.SubscriptionResult<DialerCallPulseSubscription>;
export const MessageConversationErrorLogDocument = gql`
  subscription MessageConversationErrorLog {
    messageConversationErrorLog {
      id
      message
      code
      statusCode
      workspaceId
      createdAt
    }
  }
`;

/**
 * __useMessageConversationErrorLogSubscription__
 *
 * To run a query within a React component, call `useMessageConversationErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessageConversationErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageConversationErrorLogSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMessageConversationErrorLogSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    MessageConversationErrorLogSubscription,
    MessageConversationErrorLogSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MessageConversationErrorLogSubscription,
    MessageConversationErrorLogSubscriptionVariables
  >(MessageConversationErrorLogDocument, options);
}
export type MessageConversationErrorLogSubscriptionHookResult = ReturnType<
  typeof useMessageConversationErrorLogSubscription
>;
export type MessageConversationErrorLogSubscriptionResult =
  Apollo.SubscriptionResult<MessageConversationErrorLogSubscription>;
export const ChatMessageDocument = gql`
  subscription ChatMessage {
    chatMessage {
      id
      body
      createdAt
      isPinned
      sender {
        id
        status
        user {
          id
          name
          email
          phoneNumber
          emailVerifiedAt
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
          }
        }
        userOnlineManagement {
          id
          userWorkspaceId
          workspaceId
          isActive
          lastSeenAt
          awayTill
          message
          icon
          activeStatus
          userWorkspace {
            id
            status
          }
        }
        workspace {
          id
          label
          status
          trusted
        }
      }
      room {
        id
      }
      type
      messageConversation {
        id
        conversationStatus
        effectiveStartedAt
        effectiveEndedAt
      }
    }
  }
`;

/**
 * __useChatMessageSubscription__
 *
 * To run a query within a React component, call `useChatMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessageSubscription({
 *   variables: {
 *   },
 * });
 */
export function useChatMessageSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<ChatMessageSubscription, ChatMessageSubscriptionVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ChatMessageSubscription, ChatMessageSubscriptionVariables>(
    ChatMessageDocument,
    options
  );
}
export type ChatMessageSubscriptionHookResult = ReturnType<typeof useChatMessageSubscription>;
export type ChatMessageSubscriptionResult = Apollo.SubscriptionResult<ChatMessageSubscription>;
export const WorkspaceMembersOnlineManagementDocument = gql`
  subscription WorkspaceMembersOnlineManagement {
    workspaceMembersOnlineManagement {
      workspace {
        id
      }
      userWorkspace {
        id
      }
      isActive
      message
      lastSeenAt
      id
      icon
      awayTill
      activeStatus
    }
  }
`;

/**
 * __useWorkspaceMembersOnlineManagementSubscription__
 *
 * To run a query within a React component, call `useWorkspaceMembersOnlineManagementSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMembersOnlineManagementSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceMembersOnlineManagementSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceMembersOnlineManagementSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    WorkspaceMembersOnlineManagementSubscription,
    WorkspaceMembersOnlineManagementSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WorkspaceMembersOnlineManagementSubscription,
    WorkspaceMembersOnlineManagementSubscriptionVariables
  >(WorkspaceMembersOnlineManagementDocument, options);
}
export type WorkspaceMembersOnlineManagementSubscriptionHookResult = ReturnType<
  typeof useWorkspaceMembersOnlineManagementSubscription
>;
export type WorkspaceMembersOnlineManagementSubscriptionResult =
  Apollo.SubscriptionResult<WorkspaceMembersOnlineManagementSubscription>;
export const WorkspaceRateLimitDocument = gql`
  subscription WorkspaceRateLimit {
    workspaceRateLimit {
      id
      category
      direction
      threshold
      timeLimit
      segmentLimit
      exhaust {
        value
      }
    }
  }
`;

/**
 * __useWorkspaceRateLimitSubscription__
 *
 * To run a query within a React component, call `useWorkspaceRateLimitSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceRateLimitSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceRateLimitSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceRateLimitSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<WorkspaceRateLimitSubscription, WorkspaceRateLimitSubscriptionVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<WorkspaceRateLimitSubscription, WorkspaceRateLimitSubscriptionVariables>(
    WorkspaceRateLimitDocument,
    options
  );
}
export type WorkspaceRateLimitSubscriptionHookResult = ReturnType<typeof useWorkspaceRateLimitSubscription>;
export type WorkspaceRateLimitSubscriptionResult = Apollo.SubscriptionResult<WorkspaceRateLimitSubscription>;
export const walletDetailsDocument = gql`
  subscription walletDetails {
    walletDetails {
      amount
    }
  }
`;

/**
 * __usewalletDetailsSubscription__
 *
 * To run a query within a React component, call `usewalletDetailsSubscription` and pass it any options that fit your needs.
 * When your component renders, `usewalletDetailsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usewalletDetailsSubscription({
 *   variables: {
 *   },
 * });
 */
export function usewalletDetailsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<walletDetailsSubscription, walletDetailsSubscriptionVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<walletDetailsSubscription, walletDetailsSubscriptionVariables>(
    walletDetailsDocument,
    options
  );
}
export type walletDetailsSubscriptionHookResult = ReturnType<typeof usewalletDetailsSubscription>;
export type walletDetailsSubscriptionResult = Apollo.SubscriptionResult<walletDetailsSubscription>;
export const MessageScheduleDocument = gql`
  subscription MessageSchedule($identity: [String!]) {
    messageSchedule(identity: $identity) {
      id
      messageContent
      createdAt
      client {
        id
        phoneNumber
        country {
          id
          flag
        }
      }
      channel {
        id
        phoneNumber
        identity
      }
      attachments {
        id
        url
      }
    }
  }
`;

/**
 * __useMessageScheduleSubscription__
 *
 * To run a query within a React component, call `useMessageScheduleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessageScheduleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageScheduleSubscription({
 *   variables: {
 *      identity: // value for 'identity'
 *   },
 * });
 */
export function useMessageScheduleSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<MessageScheduleSubscription, MessageScheduleSubscriptionVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<MessageScheduleSubscription, MessageScheduleSubscriptionVariables>(
    MessageScheduleDocument,
    options
  );
}
export type MessageScheduleSubscriptionHookResult = ReturnType<typeof useMessageScheduleSubscription>;
export type MessageScheduleSubscriptionResult = Apollo.SubscriptionResult<MessageScheduleSubscription>;
export const ExportContactStatusDocument = gql`
  subscription ExportContactStatus {
    exportContactStatus {
      status
      data {
        url
        size
        originalname
        mimetype
        key
        id
      }
    }
  }
`;

/**
 * __useExportContactStatusSubscription__
 *
 * To run a query within a React component, call `useExportContactStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportContactStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportContactStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useExportContactStatusSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ExportContactStatusSubscription,
    ExportContactStatusSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ExportContactStatusSubscription, ExportContactStatusSubscriptionVariables>(
    ExportContactStatusDocument,
    options
  );
}
export type ExportContactStatusSubscriptionHookResult = ReturnType<typeof useExportContactStatusSubscription>;
export type ExportContactStatusSubscriptionResult = Apollo.SubscriptionResult<ExportContactStatusSubscription>;
export const SendTranscriptionStatusDocument = gql`
  subscription SendTranscriptionStatus {
    sendTranscriptionStatus {
      id
      jobStatus
      providerCallRecordingsId
    }
  }
`;

/**
 * __useSendTranscriptionStatusSubscription__
 *
 * To run a query within a React component, call `useSendTranscriptionStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSendTranscriptionStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendTranscriptionStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSendTranscriptionStatusSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SendTranscriptionStatusSubscription,
    SendTranscriptionStatusSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<SendTranscriptionStatusSubscription, SendTranscriptionStatusSubscriptionVariables>(
    SendTranscriptionStatusDocument,
    options
  );
}
export type SendTranscriptionStatusSubscriptionHookResult = ReturnType<typeof useSendTranscriptionStatusSubscription>;
export type SendTranscriptionStatusSubscriptionResult = Apollo.SubscriptionResult<SendTranscriptionStatusSubscription>;
export const liveConferenceDocument = gql`
  subscription liveConference {
    liveConference {
      id
      agent {
        callPlatform
        user {
          id
          name
          profilePicture {
            id
            url
          }
        }
        userOnlineManagement {
          isActive
        }
      }
      client {
        id
        name
        phoneNumber
        country {
          flag
        }
        profilePicture {
          id
          url
        }
      }
      channel {
        friendlyName
        phoneNumber
        identity
        country {
          flag
        }
      }
      direction
      conversationStatus
      createdAt
      durationConference {
        startDate
      }
    }
  }
`;

/**
 * __useliveConferenceSubscription__
 *
 * To run a query within a React component, call `useliveConferenceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useliveConferenceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useliveConferenceSubscription({
 *   variables: {
 *   },
 * });
 */
export function useliveConferenceSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<liveConferenceSubscription, liveConferenceSubscriptionVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<liveConferenceSubscription, liveConferenceSubscriptionVariables>(
    liveConferenceDocument,
    options
  );
}
export type liveConferenceSubscriptionHookResult = ReturnType<typeof useliveConferenceSubscription>;
export type liveConferenceSubscriptionResult = Apollo.SubscriptionResult<liveConferenceSubscription>;
export const LiveConferenceCountSubscriptionDocument = gql`
  subscription LiveConferenceCountSubscription {
    liveConferenceCount {
      count
    }
  }
`;

/**
 * __useLiveConferenceCountSubscriptionSubscription__
 *
 * To run a query within a React component, call `useLiveConferenceCountSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveConferenceCountSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveConferenceCountSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useLiveConferenceCountSubscriptionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    LiveConferenceCountSubscriptionSubscription,
    LiveConferenceCountSubscriptionSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LiveConferenceCountSubscriptionSubscription,
    LiveConferenceCountSubscriptionSubscriptionVariables
  >(LiveConferenceCountSubscriptionDocument, options);
}
export type LiveConferenceCountSubscriptionSubscriptionHookResult = ReturnType<
  typeof useLiveConferenceCountSubscriptionSubscription
>;
export type LiveConferenceCountSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<LiveConferenceCountSubscriptionSubscription>;
export const WorkspaceCounterDocument = gql`
  subscription WorkspaceCounter {
    workspaceCounter {
      workspaceId
      to
      from
      counter
      channelId
      userWorkspaceId
    }
  }
`;

/**
 * __useWorkspaceCounterSubscription__
 *
 * To run a query within a React component, call `useWorkspaceCounterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceCounterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceCounterSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceCounterSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<WorkspaceCounterSubscription, WorkspaceCounterSubscriptionVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<WorkspaceCounterSubscription, WorkspaceCounterSubscriptionVariables>(
    WorkspaceCounterDocument,
    options
  );
}
export type WorkspaceCounterSubscriptionHookResult = ReturnType<typeof useWorkspaceCounterSubscription>;
export type WorkspaceCounterSubscriptionResult = Apollo.SubscriptionResult<WorkspaceCounterSubscription>;
export const KycVerificationSessionDocument = gql`
  subscription KycVerificationSession {
    kycVerificationSession {
      id
      status
      workspaceId
    }
  }
`;

/**
 * __useKycVerificationSessionSubscription__
 *
 * To run a query within a React component, call `useKycVerificationSessionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useKycVerificationSessionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKycVerificationSessionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useKycVerificationSessionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    KycVerificationSessionSubscription,
    KycVerificationSessionSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<KycVerificationSessionSubscription, KycVerificationSessionSubscriptionVariables>(
    KycVerificationSessionDocument,
    options
  );
}
export type KycVerificationSessionSubscriptionHookResult = ReturnType<typeof useKycVerificationSessionSubscription>;
export type KycVerificationSessionSubscriptionResult = Apollo.SubscriptionResult<KycVerificationSessionSubscription>;
export const WorkspaceMemberNotificationCounterDocument = gql`
  subscription WorkspaceMemberNotificationCounter {
    workspaceMemberNotificationCounter {
      counter
      memberId
      roomId
      type
      userWorkspaceId
    }
  }
`;

/**
 * __useWorkspaceMemberNotificationCounterSubscription__
 *
 * To run a query within a React component, call `useWorkspaceMemberNotificationCounterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMemberNotificationCounterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceMemberNotificationCounterSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceMemberNotificationCounterSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    WorkspaceMemberNotificationCounterSubscription,
    WorkspaceMemberNotificationCounterSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WorkspaceMemberNotificationCounterSubscription,
    WorkspaceMemberNotificationCounterSubscriptionVariables
  >(WorkspaceMemberNotificationCounterDocument, options);
}
export type WorkspaceMemberNotificationCounterSubscriptionHookResult = ReturnType<
  typeof useWorkspaceMemberNotificationCounterSubscription
>;
export type WorkspaceMemberNotificationCounterSubscriptionResult =
  Apollo.SubscriptionResult<WorkspaceMemberNotificationCounterSubscription>;
export const PaymentOrderCreatedDocument = gql`
  subscription PaymentOrderCreated {
    paymentOrderCreated {
      id
      orderNumber
      workspaceId
      userId
      clientRequestId
      batchId
      cartAmount
      chargedAmount
      status
      lienStatus
      type
      remarks
      itemsQuantity
      dunningAttempt
      failureReason
      createdAt
      updatedAt
    }
  }
`;

/**
 * __usePaymentOrderCreatedSubscription__
 *
 * To run a query within a React component, call `usePaymentOrderCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePaymentOrderCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentOrderCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePaymentOrderCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PaymentOrderCreatedSubscription,
    PaymentOrderCreatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<PaymentOrderCreatedSubscription, PaymentOrderCreatedSubscriptionVariables>(
    PaymentOrderCreatedDocument,
    options
  );
}
export type PaymentOrderCreatedSubscriptionHookResult = ReturnType<typeof usePaymentOrderCreatedSubscription>;
export type PaymentOrderCreatedSubscriptionResult = Apollo.SubscriptionResult<PaymentOrderCreatedSubscription>;
